import { defineComponent, computed, createBlock, openBlock, resolveDynamicComponent, normalizeStyle, normalizeClass, unref, withCtx, renderSlot, useSlots, ref, watch, createElementBlock, createElementVNode, createCommentVNode, defineAsyncComponent, createVNode, createTextVNode, toDisplayString, Fragment, renderList, watchEffect, reactive, readonly, onMounted, onUnmounted, inject, useCssVars, onBeforeUnmount, Transition, withModifiers, withDirectives, mergeProps, resolveDirective, normalizeProps, guardReactiveProps, toHandlers, vShow, h as h$2, pushScopeId, popScopeId, nextTick, resolveComponent, createApp, withScopeId, withKeys, provide, Teleport, isRef, createSlots, useId, vModelText, onBeforeMount, mergeModels, useModel } from "vue";
import { bemBuilder, giveMeThatValue, isBrowser, unlockBody, lockBody, toMoney, debounce as debounce$1, parseInputNumber, findCountryByIso, getPhoneNumberExample, isValidMobileNumber, hasProperLength, addPlusToInternationalNumber, textBeautifier } from "@chatfood/core-utils";
import { RouterLink } from "vue-router";
const className$1M = "sat-otp-method-selector", css$1M = bemBuilder(className$1M);
bemBuilder(className$1M, !0);
const className$1L = "atom-text", css$1L = bemBuilder(className$1L);
bemBuilder(className$1L, !0);
const _sfc_main$1V = /* @__PURE__ */ defineComponent({
  __name: "AtomText",
  props: {
    type: { default: "body" },
    tag: {},
    color: {},
    striked: { type: Boolean }
  },
  setup(e) {
    const j = e, ke = computed(() => j.tag ? j.tag : {
      subtitle: "h4",
      body: "span",
      "body-bold": "span",
      "small-bold": "small",
      link: "span"
    }[j.type] || j.type);
    return (Se, xe) => (openBlock(), createBlock(resolveDynamicComponent(ke.value), {
      class: normalizeClass({
        [unref(css$1L)("")]: !0,
        [unref(css$1L)("", e.type)]: !0,
        [unref(css$1L)("", "striked")]: j.striked
      }),
      style: normalizeStyle(j.color ? `color: var(--${j.color})` : void 0)
    }, {
      default: withCtx(() => [
        renderSlot(Se.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["class", "style"]));
  }
}), _export_sfc = (e, j) => {
  const ke = e.__vccOpts || e;
  for (const [Se, xe] of j)
    ke[Se] = xe;
  return ke;
}, AtomText = /* @__PURE__ */ _export_sfc(_sfc_main$1V, [["__scopeId", "data-v-6b25b0e8"]]), className$1K = "atom-radio", css$1K = bemBuilder(className$1K);
bemBuilder(className$1K, !0);
const _hoisted_1$A = ["name", "value", "checked", "disabled"], _sfc_main$1U = /* @__PURE__ */ defineComponent({
  __name: "AtomRadio",
  props: {
    name: {},
    value: { default: "" },
    checked: { type: Boolean, default: !1 },
    spaceBetween: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    rightContent: { type: Boolean, default: !1 }
  },
  emits: ["change"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = useSlots(), Ie = computed(() => !!xe.default), Me = ref(ke.checked);
    watch(
      () => ke.checked,
      (Be) => {
        Me.value = Be;
      }
    );
    function Ee() {
      ke.disabled || ke.checked || Se("change", ke.value);
    }
    return (Be, $e) => (openBlock(), createElementBlock("label", {
      class: normalizeClass([
        unref(css$1K)(),
        {
          [unref(css$1K)("", "right-content")]: ke.rightContent,
          [unref(css$1K)("", "space-between")]: ke.spaceBetween,
          [unref(css$1K)("", "disabled")]: ke.disabled
        }
      ])
    }, [
      createElementVNode("input", {
        type: "radio",
        name: ke.name,
        value: ke.value,
        checked: Me.value,
        class: normalizeClass(unref(css$1K)("input")),
        disabled: ke.disabled,
        onChange: Ee
      }, null, 42, _hoisted_1$A),
      createElementVNode("span", {
        class: normalizeClass(unref(css$1K)("checkmark"))
      }, null, 2),
      Ie.value ? (openBlock(), createBlock(unref(AtomText), {
        key: 0,
        tag: "div",
        class: normalizeClass(unref(css$1K)("content"))
      }, {
        default: withCtx(() => [
          renderSlot(Be.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["class"])) : createCommentVNode("", !0)
    ], 2));
  }
}), AtomRadio = /* @__PURE__ */ _export_sfc(_sfc_main$1U, [["__scopeId", "data-v-098ff543"]]), className$1J = "sat-button", css$1J = bemBuilder(className$1J);
bemBuilder(className$1J, !0);
function useSatelliteUtils() {
  return {
    routerComponent: () => RouterLink
  };
}
const _sfc_main$1T = /* @__PURE__ */ defineComponent({
  __name: "SatButton",
  props: {
    variant: { default: "primary" },
    theme: { default: "filled" },
    size: { default: "medium" },
    type: { default: "button" },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    wide: { type: Boolean, default: !1 },
    route: {},
    isDisabled: { type: Boolean, default: !1 },
    isLoading: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: j }) {
    const ke = j, Se = e, { routerComponent: xe } = useSatelliteUtils(), Ie = computed(() => Se.route ? xe() : "button"), Me = computed(() => Se.isLoading || Se.loading), Ee = computed(() => Se.isDisabled || Se.disabled), Be = computed(() => defineAsyncComponent(async () => import("./loading-DBZZ21qX.js")));
    return ($e, Le) => (openBlock(), createBlock(resolveDynamicComponent(Ie.value), {
      to: Se.route,
      class: normalizeClass([
        unref(css$1J)(),
        unref(css$1J)("", Se.size),
        unref(css$1J)(Se.variant),
        unref(css$1J)(Se.variant, Se.theme),
        {
          [unref(css$1J)("", "wide")]: Se.wide,
          [unref(css$1J)("", "is-loading")]: Me.value
        }
      ]),
      disabled: Ee.value || Me.value,
      type: Se.type,
      onClick: Le[0] || (Le[0] = (Fe) => ke("click", Fe))
    }, {
      default: withCtx(() => [
        renderSlot($e.$slots, "default", {}, void 0, !0),
        Me.value ? (openBlock(), createElementBlock("span", {
          key: 0,
          class: normalizeClass(unref(css$1J)("loading"))
        }, [
          (openBlock(), createBlock(resolveDynamicComponent(Be.value)))
        ], 2)) : createCommentVNode("", !0)
      ]),
      _: 3
    }, 8, ["to", "class", "disabled", "type"]));
  }
}), SatButton = /* @__PURE__ */ _export_sfc(_sfc_main$1T, [["__scopeId", "data-v-eb545fad"]]), AtomButton = SatButton, _sfc_main$1S = /* @__PURE__ */ defineComponent({
  __name: "SatOtpMethodSelector",
  props: {
    title: {},
    headline: {},
    isLoading: { type: Boolean },
    cta: {},
    methodTitle: {},
    methods: {}
  },
  emits: ["select"],
  setup(e, { emit: j }) {
    const ke = e, Se = ref(), xe = (Ee) => {
      Se.value = Ee;
    }, Ie = j, Me = () => {
      Ie("select", Se.value);
    };
    return (Ee, Be) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$1M)())
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$1M)("header"))
      }, [
        createVNode(unref(AtomText), {
          class: normalizeClass(unref(css$1M)("title")),
          type: "h3",
          tag: "div"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.title), 1)
          ]),
          _: 1
        }, 8, ["class"]),
        createVNode(unref(AtomText), {
          class: normalizeClass(unref(css$1M)("headline")),
          tag: "div"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.headline), 1)
          ]),
          _: 1
        }, 8, ["class"])
      ], 2),
      createElementVNode("div", {
        class: normalizeClass(unref(css$1M)("otp-methods-box"))
      }, [
        ke.methodTitle ? (openBlock(), createBlock(unref(AtomText), {
          key: 0,
          type: "subtitle",
          color: "color-base-20"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.methodTitle), 1)
          ]),
          _: 1
        })) : createCommentVNode("", !0),
        (openBlock(!0), createElementBlock(Fragment, null, renderList(ke.methods, ($e) => (openBlock(), createElementBlock("div", {
          key: $e.key,
          class: normalizeClass(unref(css$1M)("otp-method-item"))
        }, [
          createElementVNode("label", {
            name: "otp-method",
            class: normalizeClass(unref(css$1M)("otp-method-label"))
          }, [
            createVNode(unref(AtomRadio), {
              name: "otp-method",
              value: $e.key,
              checked: Se.value === $e,
              onChange: () => xe($e)
            }, {
              default: withCtx(() => [
                createVNode(unref(AtomText), {
                  type: "body",
                  color: "color-base-20"
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString($e.text), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["value", "checked", "onChange"]),
            createVNode(unref(AtomText), {
              color: "color-base-40",
              type: "small"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString($e.subText), 1)
              ]),
              _: 2
            }, 1024)
          ], 2)
        ], 2))), 128))
      ], 2),
      createVNode(unref(AtomButton), {
        size: "large",
        wide: "",
        "data-test": "send-otp",
        class: normalizeClass(unref(css$1M)("confirm-cta")),
        "is-loading": ke.isLoading,
        onClick: Me
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(ke.cta), 1)
        ]),
        _: 1
      }, 8, ["class", "is-loading"])
    ], 2));
  }
}), SatOtpMethodSelector = /* @__PURE__ */ _export_sfc(_sfc_main$1S, [["__scopeId", "data-v-24e0a89f"]]), className$1I = "sat-setup", css$1I = bemBuilder(className$1I);
bemBuilder(className$1I, !0);
const SAT_SETUP_ID = "sat-setup", SAT_SETUP_ID_SELECTOR = `#${SAT_SETUP_ID}`, locale = {
  toast: {
    unexpected_error_title: "Oops",
    unexpected_error_message: "Something went wrong!"
  },
  menu_navigator: {
    search_placeholder: "Search for products..."
  },
  form_control: {
    optional_flag: "(optional)",
    required_flag: "*"
  },
  virtual_keyboard: {
    backspace_label: "⌫",
    clear_label: "Clear"
  },
  item_builder: {
    back_cta: "Back",
    item: {
      cta_label: "Add to basket",
      note_label: "Add note",
      note_placeholder: "Let us know if you have special requirements..."
    },
    modifier: {
      cta_label: "Select"
    }
  },
  use_date: {
    time_range: "{from} - {to}",
    today: "Today",
    tomorrow: "Tomorrow"
  },
  item_handler: {
    allergens_label: "Allergens:",
    bottle_deposit: "Includes {amount} bottle deposit",
    calories_label: "Nutrition:",
    calories_value: "{calories} kcal",
    choose_1: "Choose 1",
    choose_at_least_x: "Please select at least {min} option",
    choose_at_least_x_up_to_x: "Please select at least {min} option, up to {max}",
    choose_up_to_x: "Choose up to {max}",
    customizable: "Customizable",
    min_selections_required: "{count} selections required",
    product_info_cta_label: "Allergens, nutrition and product info",
    info: {
      additives_label: "Additives",
      alcohol: "Alcohol {amount}%",
      allergens_label: "Allergens",
      back_cta: "Back",
      beverage_label: "Beverage",
      business_operator_label: "Business operator",
      caffeine: "Caffeine {amount}mg",
      calories_value: "{calories} kcal",
      empty_label: "Please reach out to the restaurant for more information.",
      ingredients_label: "Ingredients",
      instructions_to_use_label: "Instructions to use",
      legal_name_label: "Legal name",
      nutrition_label: "Nutrition:",
      nutrition_table: {
        carbohydrates: "Carbohydrates",
        fat: "Fat",
        grams_label: "{amount}g",
        net_quantity: "Quantity ({amount} {count} per {type})",
        protein: "Protein",
        salt: "Salt",
        saturated_fat: "Saturated fat",
        serving_size: "Serving size ({amount} {count} per {type})",
        sugar: "Sugar",
        title: "Nutrition info"
      },
      prepackaged_label: "Prepackaged",
      prepackaged_label_no: "No",
      prepackaged_label_yes: "Yes",
      range_calories_value: "{calories} to {highCalories} kcal",
      reusable_label: "Reusable",
      reusable_label_no: "No",
      reusable_label_yes: "Yes",
      storage_instructions_label: "Storage instructions"
    }
  }
};
function isPlainObject(e) {
  if (e === null || typeof e != "object")
    return !1;
  const j = Object.getPrototypeOf(e);
  return j !== null && j !== Object.prototype && Object.getPrototypeOf(j) !== null || Symbol.iterator in e ? !1 : Symbol.toStringTag in e ? Object.prototype.toString.call(e) === "[object Module]" : !0;
}
function _defu(e, j, ke = ".", Se) {
  if (!isPlainObject(j))
    return _defu(e, {}, ke, Se);
  const xe = Object.assign({}, j);
  for (const Ie in e) {
    if (Ie === "__proto__" || Ie === "constructor")
      continue;
    const Me = e[Ie];
    Me != null && (Se && Se(xe, Ie, Me, ke) || (Array.isArray(Me) && Array.isArray(xe[Ie]) ? xe[Ie] = [...Me, ...xe[Ie]] : isPlainObject(Me) && isPlainObject(xe[Ie]) ? xe[Ie] = _defu(
      Me,
      xe[Ie],
      (ke ? `${ke}.` : "") + Ie.toString(),
      Se
    ) : xe[Ie] = Me));
  }
  return xe;
}
function createDefu(e) {
  return (...j) => (
    // eslint-disable-next-line unicorn/no-array-reduce
    j.reduce((ke, Se) => _defu(ke, Se, "", e), {})
  );
}
const defu = createDefu(), refLocale = ref(locale), setLocale = (e) => {
  refLocale.value = e;
}, updateLocale = (e) => {
  refLocale.value = defu(e, locale);
};
function interpolate(e, j) {
  return e.replace(/\{(\w+)\}/g, (ke, Se) => {
    const xe = j[Se];
    return xe !== void 0 ? String(xe) : ke;
  });
}
function t(e, j) {
  let ke = giveMeThatValue(e.split("."), refLocale.value);
  return ke === void 0 && (ke = giveMeThatValue(e.split("."), locale)), ke === void 0 && (ke = e), typeof j == "string" ? j : j && typeof j == "object" ? interpolate(ke, j) : ke;
}
const _hoisted_1$z = ["id"], _sfc_main$1R = /* @__PURE__ */ defineComponent({
  __name: "SatSetup",
  props: {
    locale: {},
    fullLocale: {},
    preloadGraphics: { type: Boolean },
    preloadIcons: { type: Boolean }
  },
  setup(e) {
    const j = e;
    return watch(
      () => j.locale,
      (ke) => {
        ke && updateLocale(ke);
      },
      { immediate: !0 }
    ), watch(
      () => j.fullLocale,
      (ke) => {
        ke && setLocale(ke);
      },
      { immediate: !0 }
    ), (ke, Se) => (openBlock(), createElementBlock("div", {
      id: unref(SAT_SETUP_ID),
      class: normalizeClass(unref(css$1I)())
    }, [
      renderSlot(ke.$slots, "default", {}, void 0, !0)
    ], 10, _hoisted_1$z));
  }
}), SatSetup = /* @__PURE__ */ _export_sfc(_sfc_main$1R, [["__scopeId", "data-v-3e82e42b"]]);
function getDefaultExportFromCjs(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var toastify$1 = { exports: {} };
var toastify = toastify$1.exports, hasRequiredToastify;
function requireToastify() {
  return hasRequiredToastify || (hasRequiredToastify = 1, function(e) {
    (function(j, ke) {
      e.exports ? e.exports = ke() : j.Toastify = ke();
    })(toastify, function(j) {
      var ke = function(Me) {
        return new ke.lib.init(Me);
      }, Se = "1.12.0";
      ke.defaults = {
        oldestFirst: !0,
        text: "Toastify is awesome!",
        node: void 0,
        duration: 3e3,
        selector: void 0,
        callback: function() {
        },
        destination: void 0,
        newWindow: !1,
        close: !1,
        gravity: "toastify-top",
        positionLeft: !1,
        position: "",
        backgroundColor: "",
        avatar: "",
        className: "",
        stopOnFocus: !0,
        onClick: function() {
        },
        offset: { x: 0, y: 0 },
        escapeMarkup: !0,
        ariaLive: "polite",
        style: { background: "" }
      }, ke.lib = ke.prototype = {
        toastify: Se,
        constructor: ke,
        // Initializing the object with required parameters
        init: function(Me) {
          return Me || (Me = {}), this.options = {}, this.toastElement = null, this.options.text = Me.text || ke.defaults.text, this.options.node = Me.node || ke.defaults.node, this.options.duration = Me.duration === 0 ? 0 : Me.duration || ke.defaults.duration, this.options.selector = Me.selector || ke.defaults.selector, this.options.callback = Me.callback || ke.defaults.callback, this.options.destination = Me.destination || ke.defaults.destination, this.options.newWindow = Me.newWindow || ke.defaults.newWindow, this.options.close = Me.close || ke.defaults.close, this.options.gravity = Me.gravity === "bottom" ? "toastify-bottom" : ke.defaults.gravity, this.options.positionLeft = Me.positionLeft || ke.defaults.positionLeft, this.options.position = Me.position || ke.defaults.position, this.options.backgroundColor = Me.backgroundColor || ke.defaults.backgroundColor, this.options.avatar = Me.avatar || ke.defaults.avatar, this.options.className = Me.className || ke.defaults.className, this.options.stopOnFocus = Me.stopOnFocus === void 0 ? ke.defaults.stopOnFocus : Me.stopOnFocus, this.options.onClick = Me.onClick || ke.defaults.onClick, this.options.offset = Me.offset || ke.defaults.offset, this.options.escapeMarkup = Me.escapeMarkup !== void 0 ? Me.escapeMarkup : ke.defaults.escapeMarkup, this.options.ariaLive = Me.ariaLive || ke.defaults.ariaLive, this.options.style = Me.style || ke.defaults.style, Me.backgroundColor && (this.options.style.background = Me.backgroundColor), this;
        },
        // Building the DOM element
        buildToast: function() {
          if (!this.options)
            throw "Toastify is not initialized";
          var Me = document.createElement("div");
          Me.className = "toastify on " + this.options.className, this.options.position ? Me.className += " toastify-" + this.options.position : this.options.positionLeft === !0 ? (Me.className += " toastify-left", console.warn("Property `positionLeft` will be depreciated in further versions. Please use `position` instead.")) : Me.className += " toastify-right", Me.className += " " + this.options.gravity, this.options.backgroundColor && console.warn('DEPRECATION NOTICE: "backgroundColor" is being deprecated. Please use the "style.background" property.');
          for (var Ee in this.options.style)
            Me.style[Ee] = this.options.style[Ee];
          if (this.options.ariaLive && Me.setAttribute("aria-live", this.options.ariaLive), this.options.node && this.options.node.nodeType === Node.ELEMENT_NODE)
            Me.appendChild(this.options.node);
          else if (this.options.escapeMarkup ? Me.innerText = this.options.text : Me.innerHTML = this.options.text, this.options.avatar !== "") {
            var Be = document.createElement("img");
            Be.src = this.options.avatar, Be.className = "toastify-avatar", this.options.position == "left" || this.options.positionLeft === !0 ? Me.appendChild(Be) : Me.insertAdjacentElement("afterbegin", Be);
          }
          if (this.options.close === !0) {
            var $e = document.createElement("button");
            $e.type = "button", $e.setAttribute("aria-label", "Close"), $e.className = "toast-close", $e.innerHTML = "&#10006;", $e.addEventListener(
              "click",
              (function(Ue) {
                Ue.stopPropagation(), this.removeElement(this.toastElement), window.clearTimeout(this.toastElement.timeOutValue);
              }).bind(this)
            );
            var Le = window.innerWidth > 0 ? window.innerWidth : screen.width;
            (this.options.position == "left" || this.options.positionLeft === !0) && Le > 360 ? Me.insertAdjacentElement("afterbegin", $e) : Me.appendChild($e);
          }
          if (this.options.stopOnFocus && this.options.duration > 0) {
            var Fe = this;
            Me.addEventListener(
              "mouseover",
              function(Ue) {
                window.clearTimeout(Me.timeOutValue);
              }
            ), Me.addEventListener(
              "mouseleave",
              function() {
                Me.timeOutValue = window.setTimeout(
                  function() {
                    Fe.removeElement(Me);
                  },
                  Fe.options.duration
                );
              }
            );
          }
          if (typeof this.options.destination < "u" && Me.addEventListener(
            "click",
            (function(Ue) {
              Ue.stopPropagation(), this.options.newWindow === !0 ? window.open(this.options.destination, "_blank") : window.location = this.options.destination;
            }).bind(this)
          ), typeof this.options.onClick == "function" && typeof this.options.destination > "u" && Me.addEventListener(
            "click",
            (function(Ue) {
              Ue.stopPropagation(), this.options.onClick();
            }).bind(this)
          ), typeof this.options.offset == "object") {
            var Ve = xe("x", this.options), je = xe("y", this.options), Ge = this.options.position == "left" ? Ve : "-" + Ve, De = this.options.gravity == "toastify-top" ? je : "-" + je;
            Me.style.transform = "translate(" + Ge + "," + De + ")";
          }
          return Me;
        },
        // Displaying the toast
        showToast: function() {
          this.toastElement = this.buildToast();
          var Me;
          if (typeof this.options.selector == "string" ? Me = document.getElementById(this.options.selector) : this.options.selector instanceof HTMLElement || typeof ShadowRoot < "u" && this.options.selector instanceof ShadowRoot ? Me = this.options.selector : Me = document.body, !Me)
            throw "Root element is not defined";
          var Ee = ke.defaults.oldestFirst ? Me.firstChild : Me.lastChild;
          return Me.insertBefore(this.toastElement, Ee), ke.reposition(), this.options.duration > 0 && (this.toastElement.timeOutValue = window.setTimeout(
            (function() {
              this.removeElement(this.toastElement);
            }).bind(this),
            this.options.duration
          )), this;
        },
        hideToast: function() {
          this.toastElement.timeOutValue && clearTimeout(this.toastElement.timeOutValue), this.removeElement(this.toastElement);
        },
        // Removing the element from the DOM
        removeElement: function(Me) {
          Me.className = Me.className.replace(" on", ""), window.setTimeout(
            (function() {
              this.options.node && this.options.node.parentNode && this.options.node.parentNode.removeChild(this.options.node), Me.parentNode && Me.parentNode.removeChild(Me), this.options.callback.call(Me), ke.reposition();
            }).bind(this),
            400
          );
        }
      }, ke.reposition = function() {
        for (var Me = {
          top: 15,
          bottom: 15
        }, Ee = {
          top: 15,
          bottom: 15
        }, Be = {
          top: 15,
          bottom: 15
        }, $e = document.getElementsByClassName("toastify"), Le, Fe = 0; Fe < $e.length; Fe++) {
          Ie($e[Fe], "toastify-top") === !0 ? Le = "toastify-top" : Le = "toastify-bottom";
          var Ve = $e[Fe].offsetHeight;
          Le = Le.substr(9, Le.length - 1);
          var je = 15, Ge = window.innerWidth > 0 ? window.innerWidth : screen.width;
          Ge <= 360 ? ($e[Fe].style[Le] = Be[Le] + "px", Be[Le] += Ve + je) : Ie($e[Fe], "toastify-left") === !0 ? ($e[Fe].style[Le] = Me[Le] + "px", Me[Le] += Ve + je) : ($e[Fe].style[Le] = Ee[Le] + "px", Ee[Le] += Ve + je);
        }
        return this;
      };
      function xe(Me, Ee) {
        return Ee.offset[Me] ? isNaN(Ee.offset[Me]) ? Ee.offset[Me] : Ee.offset[Me] + "px" : "0px";
      }
      function Ie(Me, Ee) {
        return !Me || typeof Ee != "string" ? !1 : !!(Me.className && Me.className.trim().split(/\s+/gi).indexOf(Ee) > -1);
      }
      return ke.lib.init.prototype = ke.lib, ke;
    });
  }(toastify$1)), toastify$1.exports;
}
var toastifyExports = requireToastify();
const Toastify = /* @__PURE__ */ getDefaultExportFromCjs(toastifyExports), CLOSE_SVG = `<svg viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.0303 9.53033C20.3232 9.23744 20.3232 8.76256 20.0303 8.46967C19.7374 8.17678 19.2626 8.17678 18.9697 8.46967L14 13.4393L9.03033 8.46967C8.73744 8.17678 8.26256 8.17678 7.96967 8.46967C7.67678 8.76256 7.67678 9.23744 7.96967 9.53033L12.9393 14.5L7.96967 19.4697C7.67678 19.7626 7.67678 20.2374 7.96967 20.5303C8.26256 20.8232 8.73744 20.8232 9.03033 20.5303L14 15.5607L18.9697 20.5303C19.2626 20.8232 19.7374 20.8232 20.0303 20.5303C20.3232 20.2374 20.3232 19.7626 20.0303 19.4697L15.0607 14.5L20.0303 9.53033Z" fill="currentColor"/>
    <path d="M0.5 14.5C0.5 7.04416 6.54416 1 14 1C21.4558 1 27.5 7.04416 27.5 14.5C27.5 21.9558 21.4558 28 14 28C6.54416 28 0.5 21.9558 0.5 14.5Z" stroke="currentColor"/>
</svg>
`;
function useToast() {
  const e = (Ie, Me = {}) => {
    xe("success", Ie, Me, {
      backgroundColor: "var(--color-mint)"
    });
  }, j = (Ie, Me = {}) => {
    xe("error", Ie, Me, {
      backgroundColor: "var(--color-coral)"
    });
  }, ke = (Ie, Me = {}) => {
    xe("warning", Ie, Me, {
      backgroundColor: "var(--color-canary)"
    });
  }, Se = () => {
    j(t("toast.unexpected_error_message"), {
      title: t("toast.unexpected_error_title")
    });
  }, xe = (Ie, Me, Ee = {}, Be) => {
    const $e = `<div class="toast-message">${Me}</div>`, Le = Ee.title ? `<div class="toast-title">${Ee.title}</div>` : "", Fe = document.querySelector(SAT_SETUP_ID_SELECTOR), Ve = Toastify({
      text: `
      <div class="toast-wrapper">
        <div class="toast-content">${Le}${$e}</div>
        ${CLOSE_SVG}
      </div>`,
      duration: Ee.duration || 3e3,
      destination: Ee.link || void 0,
      newWindow: Ee.newWindow || !1,
      className: `toastify-${Ie}`,
      escapeMarkup: !1,
      close: !1,
      selector: Fe ?? void 0,
      gravity: "top",
      position: "right",
      stopOnFocus: !0,
      style: Be,
      onClick: () => {
        Ve.hideToast();
      }
    });
    if (Ve.showToast(), !Ve.toastElement) return;
    const je = Ve.toastElement.querySelector(".toast-wrapper svg");
    je && je.addEventListener("click", (Ge) => {
      Ge.preventDefault(), Ve && Ve.hideToast();
    });
  };
  return {
    toastSuccess: e,
    toastError: j,
    toastWarning: ke,
    toastUnexpectedError: Se
  };
}
const colorSemanticTokens = {
  "--color-primary": "var(--color-blue-50)",
  "--color-on-primary": "var(--color-base-100)",
  "--color-primary-hover": "var(--color-blue-60)",
  "--color-secondary": "var(--color-blue-10)",
  "--color-on-secondary": "var(--color-blue-50)",
  "--color-secondary-hover": "var(--color-blue-20)",
  "--color-error": "var(--color-coral)",
  "--color-background": "var(--color-base-95)",
  "--color-background-card": "var(--color-base-100)",
  "--color-background-shell": "var(--color-base-100)",
  "--color-text-body": "var(--color-base-20)",
  "--color-text-secondary": "var(--color-base-40)",
  "--color-text-disabled": "var(--color-base-50)",
  "--color-text-headline": "var(--color-base-20)"
}, defaultSemanticTokens = {
  // Spacings
  "--spacing-none": "var(--size-none)",
  "--spacing-xs": "var(--size-xs)",
  "--spacing-sm": "var(--size-sm)",
  "--spacing-md": "var(--size-md)",
  "--spacing-lg": "var(--size-lg)",
  "--spacing-xl": "var(--size-xl)",
  "--spacing-2xl": "var(--size-2xl)",
  "--spacing-3xl": "var(--size-3xl)",
  "--spacing-4xl": "var(--size-4xl)",
  // Radii buttons
  "--radii-button": "var(--size-sm)",
  "--radii-icon-button": "var(--size-infinite)",
  // Radii card
  "--radii-card-xs": "var(--size-xs)",
  "--radii-card-sm": "var(--size-sm)",
  "--radii-card-md": "var(--size-md)",
  "--radii-card-lg": "var(--size-lg)",
  "--radii-card-rounded": "var(--size-infinite)",
  // Buttons
  "--secondary-tailored-background": "transparent",
  "--secondary-tailored-background-hover": "transparent",
  "--secondary-tailored-text": "var(--color-primary)",
  "--secondary-tailored-text-hover": "var(--color-primary-hover)",
  "--secondary-tailored-border-color": "var(--color-primary)",
  "--secondary-tailored-border-color-hover": "var(--color-primary-hover)",
  // Text
  "--text-headline-transform": "initial",
  "--text-headline-font-family": "Inter",
  "--text-base-font-family": "Inter",
  // Font sizes
  "--font-size-body": "14px",
  "--font-size-small": "11px",
  "--font-size-subtitle": "18px",
  "--font-size-h1": "41px",
  "--font-size-h2": "31px",
  "--font-size-h3": "24px",
  ...colorSemanticTokens
};
function useDesignTokens() {
  const e = ref(defaultSemanticTokens), j = (Be, $e = ":root") => (ke(Be), `${$e} {${Object.entries(Be).map(([Le, Fe]) => `${Le}: ${Fe};`).join(" ")}}`), ke = (Be) => {
    e.value = {
      ...e.value,
      ...Be
    };
  }, Se = () => {
    e.value = defaultSemanticTokens;
  }, xe = (Be = {}) => {
    ke(Be);
    const $e = "semantic-tokens", Le = document.getElementById($e);
    Le && document.head.removeChild(Le);
    const Fe = j(e.value), Ve = document.createElement("style");
    Ve.id = $e, Ve.innerHTML = Fe, document.head.appendChild(Ve);
  }, Ie = computed(() => {
    const Be = {};
    return Object.keys(e.value).forEach(($e) => {
      const Le = $e, Fe = e.value[Le];
      Fe && (Be[Le] = Fe);
    }), Be;
  }), Me = (Be) => Ie.value[Be];
  return {
    semanticTokensToStyleString: j,
    patchSemanticTokens: ke,
    semanticTokens: Ie,
    restoreDefaults: Se,
    injectTokensInTheDocHead: xe,
    getRawTokenValue: (Be) => {
      const $e = Me(Be);
      if (!$e.startsWith("var("))
        return $e;
      const Le = $e.slice(4, -1).trim();
      return getComputedStyle(document.documentElement).getPropertyValue(Le).trim();
    },
    getTokenValue: Me
  };
}
function useTogglable() {
  const e = ref(!1);
  return {
    state: e,
    enable: () => e.value = !0,
    disable: () => e.value = !1,
    toggle: () => e.value = !e.value
  };
}
function useAtomDrawer() {
  const e = ref(!1);
  return {
    isDrawerVisible: e,
    showDrawer: () => e.value = !0,
    hideDrawer: () => e.value = !1,
    toggleDrawer: () => e.value = !e.value
  };
}
const AUTO_COMPRESS_FORMAT = "compress,format", COLOR_SPACE = "srgb", useImage = () => ({
  optimize: (j, ke) => {
    let Se;
    try {
      Se = new URL(j);
    } catch {
      throw new Error("Invalid URL");
    }
    return Object.entries(ke).filter(
      ([, Ie]) => Ie !== void 0
    ).forEach(([Ie, Me]) => {
      Se.searchParams.set(Ie, Me.toString());
    }), Se.searchParams.set("auto", AUTO_COMPRESS_FORMAT), Se.searchParams.set("cs", COLOR_SPACE), Se.toString().replace(/%2C/g, ",");
  }
});
var dayjs_min$1 = { exports: {} }, dayjs_min = dayjs_min$1.exports, hasRequiredDayjs_min;
function requireDayjs_min() {
  return hasRequiredDayjs_min || (hasRequiredDayjs_min = 1, function(e, j) {
    (function(ke, Se) {
      e.exports = Se();
    })(dayjs_min, function() {
      var ke = 1e3, Se = 6e4, xe = 36e5, Ie = "millisecond", Me = "second", Ee = "minute", Be = "hour", $e = "day", Le = "week", Fe = "month", Ve = "quarter", je = "year", Ge = "date", De = "Invalid Date", Ue = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, Re = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, Ye = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(Dt) {
        var zt = ["th", "st", "nd", "rd"], kt = Dt % 100;
        return "[" + Dt + (zt[(kt - 20) % 10] || zt[kt] || zt[0]) + "]";
      } }, We = function(Dt, zt, kt) {
        var Et = String(Dt);
        return !Et || Et.length >= zt ? Dt : "" + Array(zt + 1 - Et.length).join(kt) + Dt;
      }, qe = { s: We, z: function(Dt) {
        var zt = -Dt.utcOffset(), kt = Math.abs(zt), Et = Math.floor(kt / 60), Qe = kt % 60;
        return (zt <= 0 ? "+" : "-") + We(Et, 2, "0") + ":" + We(Qe, 2, "0");
      }, m: function Dt(zt, kt) {
        if (zt.date() < kt.date()) return -Dt(kt, zt);
        var Et = 12 * (kt.year() - zt.year()) + (kt.month() - zt.month()), Qe = zt.clone().add(Et, Fe), Xe = kt - Qe < 0, Vt = zt.clone().add(Et + (Xe ? -1 : 1), Fe);
        return +(-(Et + (kt - Qe) / (Xe ? Qe - Vt : Vt - Qe)) || 0);
      }, a: function(Dt) {
        return Dt < 0 ? Math.ceil(Dt) || 0 : Math.floor(Dt);
      }, p: function(Dt) {
        return { M: Fe, y: je, w: Le, d: $e, D: Ge, h: Be, m: Ee, s: Me, ms: Ie, Q: Ve }[Dt] || String(Dt || "").toLowerCase().replace(/s$/, "");
      }, u: function(Dt) {
        return Dt === void 0;
      } }, Je = "en", Ke = {};
      Ke[Je] = Ye;
      var xt = "$isDayjsObject", Ct = function(Dt) {
        return Dt instanceof At || !(!Dt || !Dt[xt]);
      }, It = function Dt(zt, kt, Et) {
        var Qe;
        if (!zt) return Je;
        if (typeof zt == "string") {
          var Xe = zt.toLowerCase();
          Ke[Xe] && (Qe = Xe), kt && (Ke[Xe] = kt, Qe = Xe);
          var Vt = zt.split("-");
          if (!Qe && Vt.length > 1) return Dt(Vt[0]);
        } else {
          var Lt = zt.name;
          Ke[Lt] = zt, Qe = Lt;
        }
        return !Et && Qe && (Je = Qe), Qe || !Et && Je;
      }, Nt = function(Dt, zt) {
        if (Ct(Dt)) return Dt.clone();
        var kt = typeof zt == "object" ? zt : {};
        return kt.date = Dt, kt.args = arguments, new At(kt);
      }, Bt = qe;
      Bt.l = It, Bt.i = Ct, Bt.w = function(Dt, zt) {
        return Nt(Dt, { locale: zt.$L, utc: zt.$u, x: zt.$x, $offset: zt.$offset });
      };
      var At = function() {
        function Dt(kt) {
          this.$L = It(kt.locale, null, !0), this.parse(kt), this.$x = this.$x || kt.x || {}, this[xt] = !0;
        }
        var zt = Dt.prototype;
        return zt.parse = function(kt) {
          this.$d = function(Et) {
            var Qe = Et.date, Xe = Et.utc;
            if (Qe === null) return /* @__PURE__ */ new Date(NaN);
            if (Bt.u(Qe)) return /* @__PURE__ */ new Date();
            if (Qe instanceof Date) return new Date(Qe);
            if (typeof Qe == "string" && !/Z$/i.test(Qe)) {
              var Vt = Qe.match(Ue);
              if (Vt) {
                var Lt = Vt[2] - 1 || 0, Gt = (Vt[7] || "0").substring(0, 3);
                return Xe ? new Date(Date.UTC(Vt[1], Lt, Vt[3] || 1, Vt[4] || 0, Vt[5] || 0, Vt[6] || 0, Gt)) : new Date(Vt[1], Lt, Vt[3] || 1, Vt[4] || 0, Vt[5] || 0, Vt[6] || 0, Gt);
              }
            }
            return new Date(Qe);
          }(kt), this.init();
        }, zt.init = function() {
          var kt = this.$d;
          this.$y = kt.getFullYear(), this.$M = kt.getMonth(), this.$D = kt.getDate(), this.$W = kt.getDay(), this.$H = kt.getHours(), this.$m = kt.getMinutes(), this.$s = kt.getSeconds(), this.$ms = kt.getMilliseconds();
        }, zt.$utils = function() {
          return Bt;
        }, zt.isValid = function() {
          return this.$d.toString() !== De;
        }, zt.isSame = function(kt, Et) {
          var Qe = Nt(kt);
          return this.startOf(Et) <= Qe && Qe <= this.endOf(Et);
        }, zt.isAfter = function(kt, Et) {
          return Nt(kt) < this.startOf(Et);
        }, zt.isBefore = function(kt, Et) {
          return this.endOf(Et) < Nt(kt);
        }, zt.$g = function(kt, Et, Qe) {
          return Bt.u(kt) ? this[Et] : this.set(Qe, kt);
        }, zt.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, zt.valueOf = function() {
          return this.$d.getTime();
        }, zt.startOf = function(kt, Et) {
          var Qe = this, Xe = !!Bt.u(Et) || Et, Vt = Bt.p(kt), Lt = function(Yt, Ut) {
            var Qt = Bt.w(Qe.$u ? Date.UTC(Qe.$y, Ut, Yt) : new Date(Qe.$y, Ut, Yt), Qe);
            return Xe ? Qt : Qt.endOf($e);
          }, Gt = function(Yt, Ut) {
            return Bt.w(Qe.toDate()[Yt].apply(Qe.toDate("s"), (Xe ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Ut)), Qe);
          }, Wt = this.$W, Zt = this.$M, Ot = this.$D, Ht = "set" + (this.$u ? "UTC" : "");
          switch (Vt) {
            case je:
              return Xe ? Lt(1, 0) : Lt(31, 11);
            case Fe:
              return Xe ? Lt(1, Zt) : Lt(0, Zt + 1);
            case Le:
              var Rt = this.$locale().weekStart || 0, jt = (Wt < Rt ? Wt + 7 : Wt) - Rt;
              return Lt(Xe ? Ot - jt : Ot + (6 - jt), Zt);
            case $e:
            case Ge:
              return Gt(Ht + "Hours", 0);
            case Be:
              return Gt(Ht + "Minutes", 1);
            case Ee:
              return Gt(Ht + "Seconds", 2);
            case Me:
              return Gt(Ht + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, zt.endOf = function(kt) {
          return this.startOf(kt, !1);
        }, zt.$set = function(kt, Et) {
          var Qe, Xe = Bt.p(kt), Vt = "set" + (this.$u ? "UTC" : ""), Lt = (Qe = {}, Qe[$e] = Vt + "Date", Qe[Ge] = Vt + "Date", Qe[Fe] = Vt + "Month", Qe[je] = Vt + "FullYear", Qe[Be] = Vt + "Hours", Qe[Ee] = Vt + "Minutes", Qe[Me] = Vt + "Seconds", Qe[Ie] = Vt + "Milliseconds", Qe)[Xe], Gt = Xe === $e ? this.$D + (Et - this.$W) : Et;
          if (Xe === Fe || Xe === je) {
            var Wt = this.clone().set(Ge, 1);
            Wt.$d[Lt](Gt), Wt.init(), this.$d = Wt.set(Ge, Math.min(this.$D, Wt.daysInMonth())).$d;
          } else Lt && this.$d[Lt](Gt);
          return this.init(), this;
        }, zt.set = function(kt, Et) {
          return this.clone().$set(kt, Et);
        }, zt.get = function(kt) {
          return this[Bt.p(kt)]();
        }, zt.add = function(kt, Et) {
          var Qe, Xe = this;
          kt = Number(kt);
          var Vt = Bt.p(Et), Lt = function(Zt) {
            var Ot = Nt(Xe);
            return Bt.w(Ot.date(Ot.date() + Math.round(Zt * kt)), Xe);
          };
          if (Vt === Fe) return this.set(Fe, this.$M + kt);
          if (Vt === je) return this.set(je, this.$y + kt);
          if (Vt === $e) return Lt(1);
          if (Vt === Le) return Lt(7);
          var Gt = (Qe = {}, Qe[Ee] = Se, Qe[Be] = xe, Qe[Me] = ke, Qe)[Vt] || 1, Wt = this.$d.getTime() + kt * Gt;
          return Bt.w(Wt, this);
        }, zt.subtract = function(kt, Et) {
          return this.add(-1 * kt, Et);
        }, zt.format = function(kt) {
          var Et = this, Qe = this.$locale();
          if (!this.isValid()) return Qe.invalidDate || De;
          var Xe = kt || "YYYY-MM-DDTHH:mm:ssZ", Vt = Bt.z(this), Lt = this.$H, Gt = this.$m, Wt = this.$M, Zt = Qe.weekdays, Ot = Qe.months, Ht = Qe.meridiem, Rt = function(Ut, Qt, Kt, Jt) {
            return Ut && (Ut[Qt] || Ut(Et, Xe)) || Kt[Qt].slice(0, Jt);
          }, jt = function(Ut) {
            return Bt.s(Lt % 12 || 12, Ut, "0");
          }, Yt = Ht || function(Ut, Qt, Kt) {
            var Jt = Ut < 12 ? "AM" : "PM";
            return Kt ? Jt.toLowerCase() : Jt;
          };
          return Xe.replace(Re, function(Ut, Qt) {
            return Qt || function(Kt) {
              switch (Kt) {
                case "YY":
                  return String(Et.$y).slice(-2);
                case "YYYY":
                  return Bt.s(Et.$y, 4, "0");
                case "M":
                  return Wt + 1;
                case "MM":
                  return Bt.s(Wt + 1, 2, "0");
                case "MMM":
                  return Rt(Qe.monthsShort, Wt, Ot, 3);
                case "MMMM":
                  return Rt(Ot, Wt);
                case "D":
                  return Et.$D;
                case "DD":
                  return Bt.s(Et.$D, 2, "0");
                case "d":
                  return String(Et.$W);
                case "dd":
                  return Rt(Qe.weekdaysMin, Et.$W, Zt, 2);
                case "ddd":
                  return Rt(Qe.weekdaysShort, Et.$W, Zt, 3);
                case "dddd":
                  return Zt[Et.$W];
                case "H":
                  return String(Lt);
                case "HH":
                  return Bt.s(Lt, 2, "0");
                case "h":
                  return jt(1);
                case "hh":
                  return jt(2);
                case "a":
                  return Yt(Lt, Gt, !0);
                case "A":
                  return Yt(Lt, Gt, !1);
                case "m":
                  return String(Gt);
                case "mm":
                  return Bt.s(Gt, 2, "0");
                case "s":
                  return String(Et.$s);
                case "ss":
                  return Bt.s(Et.$s, 2, "0");
                case "SSS":
                  return Bt.s(Et.$ms, 3, "0");
                case "Z":
                  return Vt;
              }
              return null;
            }(Ut) || Vt.replace(":", "");
          });
        }, zt.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, zt.diff = function(kt, Et, Qe) {
          var Xe, Vt = this, Lt = Bt.p(Et), Gt = Nt(kt), Wt = (Gt.utcOffset() - this.utcOffset()) * Se, Zt = this - Gt, Ot = function() {
            return Bt.m(Vt, Gt);
          };
          switch (Lt) {
            case je:
              Xe = Ot() / 12;
              break;
            case Fe:
              Xe = Ot();
              break;
            case Ve:
              Xe = Ot() / 3;
              break;
            case Le:
              Xe = (Zt - Wt) / 6048e5;
              break;
            case $e:
              Xe = (Zt - Wt) / 864e5;
              break;
            case Be:
              Xe = Zt / xe;
              break;
            case Ee:
              Xe = Zt / Se;
              break;
            case Me:
              Xe = Zt / ke;
              break;
            default:
              Xe = Zt;
          }
          return Qe ? Xe : Bt.a(Xe);
        }, zt.daysInMonth = function() {
          return this.endOf(Fe).$D;
        }, zt.$locale = function() {
          return Ke[this.$L];
        }, zt.locale = function(kt, Et) {
          if (!kt) return this.$L;
          var Qe = this.clone(), Xe = It(kt, Et, !0);
          return Xe && (Qe.$L = Xe), Qe;
        }, zt.clone = function() {
          return Bt.w(this.$d, this);
        }, zt.toDate = function() {
          return new Date(this.valueOf());
        }, zt.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, zt.toISOString = function() {
          return this.$d.toISOString();
        }, zt.toString = function() {
          return this.$d.toUTCString();
        }, Dt;
      }(), Ft = At.prototype;
      return Nt.prototype = Ft, [["$ms", Ie], ["$s", Me], ["$m", Ee], ["$H", Be], ["$W", $e], ["$M", Fe], ["$y", je], ["$D", Ge]].forEach(function(Dt) {
        Ft[Dt[1]] = function(zt) {
          return this.$g(zt, Dt[0], Dt[1]);
        };
      }), Nt.extend = function(Dt, zt) {
        return Dt.$i || (Dt(zt, At, Nt), Dt.$i = !0), Nt;
      }, Nt.locale = It, Nt.isDayjs = Ct, Nt.unix = function(Dt) {
        return Nt(1e3 * Dt);
      }, Nt.en = Ke[Je], Nt.Ls = Ke, Nt.p = {}, Nt;
    });
  }(dayjs_min$1)), dayjs_min$1.exports;
}
var dayjs_minExports = requireDayjs_min();
const dayjs = /* @__PURE__ */ getDefaultExportFromCjs(dayjs_minExports);
var utc$2 = { exports: {} }, utc$1 = utc$2.exports, hasRequiredUtc;
function requireUtc() {
  return hasRequiredUtc || (hasRequiredUtc = 1, function(e, j) {
    (function(ke, Se) {
      e.exports = Se();
    })(utc$1, function() {
      var ke = "minute", Se = /[+-]\d\d(?::?\d\d)?/g, xe = /([+-]|\d\d)/g;
      return function(Ie, Me, Ee) {
        var Be = Me.prototype;
        Ee.utc = function(De) {
          var Ue = { date: De, utc: !0, args: arguments };
          return new Me(Ue);
        }, Be.utc = function(De) {
          var Ue = Ee(this.toDate(), { locale: this.$L, utc: !0 });
          return De ? Ue.add(this.utcOffset(), ke) : Ue;
        }, Be.local = function() {
          return Ee(this.toDate(), { locale: this.$L, utc: !1 });
        };
        var $e = Be.parse;
        Be.parse = function(De) {
          De.utc && (this.$u = !0), this.$utils().u(De.$offset) || (this.$offset = De.$offset), $e.call(this, De);
        };
        var Le = Be.init;
        Be.init = function() {
          if (this.$u) {
            var De = this.$d;
            this.$y = De.getUTCFullYear(), this.$M = De.getUTCMonth(), this.$D = De.getUTCDate(), this.$W = De.getUTCDay(), this.$H = De.getUTCHours(), this.$m = De.getUTCMinutes(), this.$s = De.getUTCSeconds(), this.$ms = De.getUTCMilliseconds();
          } else Le.call(this);
        };
        var Fe = Be.utcOffset;
        Be.utcOffset = function(De, Ue) {
          var Re = this.$utils().u;
          if (Re(De)) return this.$u ? 0 : Re(this.$offset) ? Fe.call(this) : this.$offset;
          if (typeof De == "string" && (De = function(Je) {
            Je === void 0 && (Je = "");
            var Ke = Je.match(Se);
            if (!Ke) return null;
            var xt = ("" + Ke[0]).match(xe) || ["-", 0, 0], Ct = xt[0], It = 60 * +xt[1] + +xt[2];
            return It === 0 ? 0 : Ct === "+" ? It : -It;
          }(De), De === null)) return this;
          var Ye = Math.abs(De) <= 16 ? 60 * De : De;
          if (Ye === 0) return this.utc(Ue);
          var We = this.clone();
          if (Ue) return We.$offset = Ye, We.$u = !1, We;
          var qe = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          return (We = this.local().add(Ye + qe, ke)).$offset = Ye, We.$x.$localOffset = qe, We;
        };
        var Ve = Be.format;
        Be.format = function(De) {
          var Ue = De || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
          return Ve.call(this, Ue);
        }, Be.valueOf = function() {
          var De = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * De;
        }, Be.isUTC = function() {
          return !!this.$u;
        }, Be.toISOString = function() {
          return this.toDate().toISOString();
        }, Be.toString = function() {
          return this.toDate().toUTCString();
        };
        var je = Be.toDate;
        Be.toDate = function(De) {
          return De === "s" && this.$offset ? Ee(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : je.call(this);
        };
        var Ge = Be.diff;
        Be.diff = function(De, Ue, Re) {
          if (De && this.$u === De.$u) return Ge.call(this, De, Ue, Re);
          var Ye = this.local(), We = Ee(De).local();
          return Ge.call(Ye, We, Ue, Re);
        };
      };
    });
  }(utc$2)), utc$2.exports;
}
var utcExports = requireUtc();
const utc = /* @__PURE__ */ getDefaultExportFromCjs(utcExports);
var timezone$2 = { exports: {} }, timezone$1 = timezone$2.exports, hasRequiredTimezone;
function requireTimezone() {
  return hasRequiredTimezone || (hasRequiredTimezone = 1, function(e, j) {
    (function(ke, Se) {
      e.exports = Se();
    })(timezone$1, function() {
      var ke = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, Se = {};
      return function(xe, Ie, Me) {
        var Ee, Be = function(Ve, je, Ge) {
          Ge === void 0 && (Ge = {});
          var De = new Date(Ve), Ue = function(Re, Ye) {
            Ye === void 0 && (Ye = {});
            var We = Ye.timeZoneName || "short", qe = Re + "|" + We, Je = Se[qe];
            return Je || (Je = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: Re, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: We }), Se[qe] = Je), Je;
          }(je, Ge);
          return Ue.formatToParts(De);
        }, $e = function(Ve, je) {
          for (var Ge = Be(Ve, je), De = [], Ue = 0; Ue < Ge.length; Ue += 1) {
            var Re = Ge[Ue], Ye = Re.type, We = Re.value, qe = ke[Ye];
            qe >= 0 && (De[qe] = parseInt(We, 10));
          }
          var Je = De[3], Ke = Je === 24 ? 0 : Je, xt = De[0] + "-" + De[1] + "-" + De[2] + " " + Ke + ":" + De[4] + ":" + De[5] + ":000", Ct = +Ve;
          return (Me.utc(xt).valueOf() - (Ct -= Ct % 1e3)) / 6e4;
        }, Le = Ie.prototype;
        Le.tz = function(Ve, je) {
          Ve === void 0 && (Ve = Ee);
          var Ge, De = this.utcOffset(), Ue = this.toDate(), Re = Ue.toLocaleString("en-US", { timeZone: Ve }), Ye = Math.round((Ue - new Date(Re)) / 1e3 / 60), We = 15 * -Math.round(Ue.getTimezoneOffset() / 15) - Ye;
          if (!Number(We)) Ge = this.utcOffset(0, je);
          else if (Ge = Me(Re, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(We, !0), je) {
            var qe = Ge.utcOffset();
            Ge = Ge.add(De - qe, "minute");
          }
          return Ge.$x.$timezone = Ve, Ge;
        }, Le.offsetName = function(Ve) {
          var je = this.$x.$timezone || Me.tz.guess(), Ge = Be(this.valueOf(), je, { timeZoneName: Ve }).find(function(De) {
            return De.type.toLowerCase() === "timezonename";
          });
          return Ge && Ge.value;
        };
        var Fe = Le.startOf;
        Le.startOf = function(Ve, je) {
          if (!this.$x || !this.$x.$timezone) return Fe.call(this, Ve, je);
          var Ge = Me(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
          return Fe.call(Ge, Ve, je).tz(this.$x.$timezone, !0);
        }, Me.tz = function(Ve, je, Ge) {
          var De = Ge && je, Ue = Ge || je || Ee, Re = $e(+Me(), Ue);
          if (typeof Ve != "string") return Me(Ve).tz(Ue);
          var Ye = function(Ke, xt, Ct) {
            var It = Ke - 60 * xt * 1e3, Nt = $e(It, Ct);
            if (xt === Nt) return [It, xt];
            var Bt = $e(It -= 60 * (Nt - xt) * 1e3, Ct);
            return Nt === Bt ? [It, Nt] : [Ke - 60 * Math.min(Nt, Bt) * 1e3, Math.max(Nt, Bt)];
          }(Me.utc(Ve, De).valueOf(), Re, Ue), We = Ye[0], qe = Ye[1], Je = Me(We).utcOffset(qe);
          return Je.$x.$timezone = Ue, Je;
        }, Me.tz.guess = function() {
          return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, Me.tz.setDefault = function(Ve) {
          Ee = Ve;
        };
      };
    });
  }(timezone$2)), timezone$2.exports;
}
var timezoneExports = requireTimezone();
const timezone = /* @__PURE__ */ getDefaultExportFromCjs(timezoneExports);
var isToday$2 = { exports: {} }, isToday$1 = isToday$2.exports, hasRequiredIsToday;
function requireIsToday() {
  return hasRequiredIsToday || (hasRequiredIsToday = 1, function(e, j) {
    (function(ke, Se) {
      e.exports = Se();
    })(isToday$1, function() {
      return function(ke, Se, xe) {
        Se.prototype.isToday = function() {
          var Ie = "YYYY-MM-DD", Me = xe();
          return this.format(Ie) === Me.format(Ie);
        };
      };
    });
  }(isToday$2)), isToday$2.exports;
}
var isTodayExports = requireIsToday();
const isToday = /* @__PURE__ */ getDefaultExportFromCjs(isTodayExports);
var isTomorrow$2 = { exports: {} }, isTomorrow$1 = isTomorrow$2.exports, hasRequiredIsTomorrow;
function requireIsTomorrow() {
  return hasRequiredIsTomorrow || (hasRequiredIsTomorrow = 1, function(e, j) {
    (function(ke, Se) {
      e.exports = Se();
    })(isTomorrow$1, function() {
      return function(ke, Se, xe) {
        Se.prototype.isTomorrow = function() {
          var Ie = "YYYY-MM-DD", Me = xe().add(1, "day");
          return this.format(Ie) === Me.format(Ie);
        };
      };
    });
  }(isTomorrow$2)), isTomorrow$2.exports;
}
var isTomorrowExports = requireIsTomorrow();
const isTomorrow = /* @__PURE__ */ getDefaultExportFromCjs(isTomorrowExports);
var localizedFormat$2 = { exports: {} }, localizedFormat$1 = localizedFormat$2.exports, hasRequiredLocalizedFormat;
function requireLocalizedFormat() {
  return hasRequiredLocalizedFormat || (hasRequiredLocalizedFormat = 1, function(e, j) {
    (function(ke, Se) {
      e.exports = Se();
    })(localizedFormat$1, function() {
      var ke = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
      return function(Se, xe, Ie) {
        var Me = xe.prototype, Ee = Me.format;
        Ie.en.formats = ke, Me.format = function(Be) {
          Be === void 0 && (Be = "YYYY-MM-DDTHH:mm:ssZ");
          var $e = this.$locale().formats, Le = function(Fe, Ve) {
            return Fe.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(je, Ge, De) {
              var Ue = De && De.toUpperCase();
              return Ge || Ve[De] || ke[De] || Ve[Ue].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(Re, Ye, We) {
                return Ye || We.slice(1);
              });
            });
          }(Be, $e === void 0 ? {} : $e);
          return Ee.call(this, Le);
        };
      };
    });
  }(localizedFormat$2)), localizedFormat$2.exports;
}
var localizedFormatExports = requireLocalizedFormat();
const localizedFormat = /* @__PURE__ */ getDefaultExportFromCjs(localizedFormatExports);
var advancedFormat$2 = { exports: {} }, advancedFormat$1 = advancedFormat$2.exports, hasRequiredAdvancedFormat;
function requireAdvancedFormat() {
  return hasRequiredAdvancedFormat || (hasRequiredAdvancedFormat = 1, function(e, j) {
    (function(ke, Se) {
      e.exports = Se();
    })(advancedFormat$1, function() {
      return function(ke, Se) {
        var xe = Se.prototype, Ie = xe.format;
        xe.format = function(Me) {
          var Ee = this, Be = this.$locale();
          if (!this.isValid()) return Ie.bind(this)(Me);
          var $e = this.$utils(), Le = (Me || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(Fe) {
            switch (Fe) {
              case "Q":
                return Math.ceil((Ee.$M + 1) / 3);
              case "Do":
                return Be.ordinal(Ee.$D);
              case "gggg":
                return Ee.weekYear();
              case "GGGG":
                return Ee.isoWeekYear();
              case "wo":
                return Be.ordinal(Ee.week(), "W");
              case "w":
              case "ww":
                return $e.s(Ee.week(), Fe === "w" ? 1 : 2, "0");
              case "W":
              case "WW":
                return $e.s(Ee.isoWeek(), Fe === "W" ? 1 : 2, "0");
              case "k":
              case "kk":
                return $e.s(String(Ee.$H === 0 ? 24 : Ee.$H), Fe === "k" ? 1 : 2, "0");
              case "X":
                return Math.floor(Ee.$d.getTime() / 1e3);
              case "x":
                return Ee.$d.getTime();
              case "z":
                return "[" + Ee.offsetName() + "]";
              case "zzz":
                return "[" + Ee.offsetName("long") + "]";
              default:
                return Fe;
            }
          });
          return Ie.bind(this)(Le);
        };
      };
    });
  }(advancedFormat$2)), advancedFormat$2.exports;
}
var advancedFormatExports = requireAdvancedFormat();
const advancedFormat = /* @__PURE__ */ getDefaultExportFromCjs(advancedFormatExports);
dayjs.extend(utc);
dayjs.extend(isTomorrow);
dayjs.extend(isToday);
dayjs.extend(timezone);
dayjs.extend(localizedFormat);
dayjs.extend(advancedFormat);
const useDate = () => {
  const e = (Me, Ee, Be) => {
    const $e = dayjs(Me, Be);
    let Le;
    return $e.isToday() ? Le = t("use_date.today") : $e.isTomorrow() ? Le = t("use_date.tomorrow") : Le = $e.format(Ee), Le;
  }, j = (Me, Ee) => dayjs(Me).format(Ee), ke = (Me, Ee) => {
    const Be = Ee || Ie(), [$e, Le] = Me.split("-").map((je) => {
      const [Ge, De] = je.split(":");
      return dayjs().startOf("day").set("hours", +Ge).set("minutes", +De);
    }), Fe = $e.format(Be), Ve = Le.format(Be);
    return t("use_date.time_range", {
      from: Fe,
      to: Ve
    });
  }, Se = (Me, Ee) => {
    const Be = Ee || Ie(), [$e, Le] = Me.split(":");
    return dayjs().startOf("day").set("hours", +$e).set("minutes", +Le).format(Be);
  }, xe = (Me, Ee, Be) => {
    const $e = dayjs(Me), Le = dayjs().diff($e, "seconds");
    return Be === "hours" ? Le / 3600 > Ee : Be === "minutes" ? Le / 60 > Ee : Le > Ee;
  }, Ie = (Me = "default") => new Intl.DateTimeFormat(Me, {
    hour: "numeric"
  }).format(new Date(2024, 0, 1, 13, 0)).includes("13") ? "H:mm" : "h:mma";
  return {
    getReadableDate: e,
    formatDatetime: j,
    formatTimeRange: ke,
    formatTime: Se,
    isOlderThan: xe,
    getTimeFormat: Ie
  };
};
function useLocalStorage() {
  const e = (Ie, Me) => {
    try {
      const Ee = localStorage.getItem(Ie);
      return Ee === null ? Me ?? void 0 : JSON.parse(Ee);
    } catch (Ee) {
      return console.error(`Error getting '${Ie}' from localStorage:`, Ee), Me ?? void 0;
    }
  }, j = (Ie, Me) => {
    try {
      const Ee = JSON.stringify(Me);
      localStorage.setItem(Ie, Ee);
    } catch (Ee) {
      console.error(`Error setting '${Ie}' in localStorage:`, Ee);
    }
  }, ke = (Ie) => {
    try {
      localStorage.removeItem(Ie);
    } catch (Me) {
      console.error(`Error removing '${Ie}' from localStorage:`, Me);
    }
  };
  return {
    getItem: e,
    setItem: j,
    removeItem: ke,
    useItem: (Ie, Me) => {
      const Ee = ref(e(Ie, Me));
      return watchEffect(() => {
        Ee.value === null || Ee.value === void 0 ? ke(Ie) : j(Ie, Ee.value);
      }), Ee;
    },
    hasItem: (Ie) => {
      try {
        return localStorage.getItem(Ie) !== null;
      } catch (Me) {
        return console.error(
          `Error checking if '${Ie}' is exists in localStorage:`,
          Me
        ), !1;
      }
    }
  };
}
function useStackedNavigation() {
  const e = ref([]), j = (Ue) => {
    e.value.push(Ue);
  }, ke = (Ue) => Ue < 0 || Ue >= e.value.length ? !1 : (e.value = e.value.slice(0, Ue + 1), !0), Se = () => e.value.length <= 1 ? !1 : (e.value.pop(), !0), xe = () => e.value.length === 0 ? !1 : (e.value = [e.value[0]], !0), Ie = (Ue) => {
    e.value = Ue ? [Ue] : [];
  }, Me = () => e.value[e.value.length - 1], Ee = (Ue) => e.value[Ue], Be = (Ue) => {
    const Re = e.value.length - 1;
    Re >= 0 && (e.value[Re] = Ue);
  }, $e = computed(() => e.value.length - 1), Le = computed(() => Me()), Fe = computed(() => e.value.length > 1), Ve = computed(() => e.value.length > 1), je = computed(() => e.value.length), Ge = computed(() => e.value.length <= 1), De = computed(() => e.value.length === 0);
  return {
    navigationStack: e,
    currentIndex: $e,
    currentItem: Le,
    canGoBack: Fe,
    canGoToRoot: Ve,
    stackLength: je,
    isAtRoot: Ge,
    isEmpty: De,
    navigateTo: j,
    navigateToIndex: ke,
    goBack: Se,
    goToRoot: xe,
    reset: Ie,
    getCurrentItem: Me,
    getItemAtIndex: Ee,
    updateCurrentItem: Be
  };
}
function useItemManager(e) {
  const j = reactive({
    itemId: e.rootItem.id,
    itemPlu: e.rootItem.plu,
    modifierLists: {}
  }), ke = ref(1), Se = ref(""), xe = (Ot) => e.discountPercentageAmount > 0 ? Ot * (1 - e.discountPercentageAmount / 100) : Ot, Ie = computed(() => e.rootItem), Me = computed(() => e.rootItem.price.currency), Ee = computed(() => {
    const Ot = /* @__PURE__ */ new Map(), Ht = (Rt) => {
      Rt.forEach((jt) => {
        Ot.set(jt.id, jt), jt.modifiers.forEach((Yt) => {
          Ht(Yt.modifierLists);
        });
      });
    };
    return Ht(Ie.value.modifierLists), Ot;
  }), Be = (Ot) => Ee.value.get(Ot), $e = (Ot, Ht, Rt) => {
    const jt = (Yt) => {
      for (const Ut of Yt) {
        if (Ut.id === Ht)
          return Ut.modifiers.find((Qt) => Qt.id === Rt);
        for (const Qt of Ut.modifiers) {
          const Kt = jt(Qt.modifierLists);
          if (Kt) return Kt;
        }
      }
    };
    return jt(Ot);
  }, Le = (Ot, Ht = j.modifierLists) => {
    Ot.forEach((Rt) => {
      const jt = {};
      Rt.modifiers.forEach((Yt) => {
        Yt.defaultQuantity > 0 && (jt[Yt.id] = {
          id: Yt.id,
          plu: Yt.plu,
          quantity: Yt.defaultQuantity,
          unitPrice: Yt.price.value,
          modifierLists: {}
        }, Yt.modifierLists.length > 0 && Le(
          Yt.modifierLists,
          jt[Yt.id].modifierLists
        ));
      }), Object.keys(jt).length > 0 && (Ht[Rt.id] = jt);
    });
  }, Fe = (Ot, Ht) => {
    const {
      modifierListId: Rt,
      modifierId: jt,
      modifierPlu: Yt,
      quantity: Ut = 1,
      unitPrice: Qt
    } = Ot, Kt = Ht || j.modifierLists, Jt = Be(Rt);
    if (!Jt) return !1;
    Jt.selectType === "radio" && Kt[Rt] && (Kt[Rt] = {});
    const qt = Object.values(Kt[Rt] || {}).reduce(
      (tr, Xt) => tr + Xt.quantity,
      0
    );
    if (!(qt < Jt.maxSelection)) return !1;
    const rr = Kt[Rt]?.[jt]?.quantity || 0;
    if (qt - rr + Ut > Jt.maxSelection) return !1;
    Kt[Rt] || (Kt[Rt] = {});
    const or = Kt[Rt][jt]?.modifierLists || {};
    return Kt[Rt][jt] = {
      id: jt,
      plu: Yt,
      quantity: Ut,
      unitPrice: xe(Qt),
      modifierLists: or
    }, !0;
  }, Ve = (Ot, Ht) => {
    const { modifierListId: Rt, modifierId: jt, quantity: Yt = 1 } = Ot, Ut = Ht || j.modifierLists, Qt = Ut[Rt], Kt = Qt?.[jt];
    if (!Kt) return !1;
    const Jt = Kt.quantity - Yt;
    return Jt <= 0 ? (delete Qt[jt], Object.keys(Qt).length === 0 && delete Ut[Rt]) : Kt.quantity = Jt, !0;
  }, je = (Ot, Ht, Rt) => {
    const jt = Rt || j.modifierLists, Yt = $e(
      Ie.value.modifierLists,
      Ot,
      Ht
    );
    return Yt ? jt[Ot]?.[Ht] ? Ve({ modifierListId: Ot, modifierId: Ht }, jt) : Fe(
      {
        modifierListId: Ot,
        modifierId: Ht,
        modifierPlu: Yt.plu,
        quantity: 1,
        unitPrice: Yt.price.value
      },
      jt
    ) : !1;
  }, Ge = (Ot) => {
    const Ht = j.modifierLists;
    delete Ht[Ot];
  }, De = (Ot) => {
    const Ht = Ot.unitPrice * Ot.quantity, Rt = Object.values(Ot.modifierLists).reduce(
      (jt, Yt) => jt + Object.values(Yt).reduce(
        (Ut, Qt) => Ut + De(Qt),
        0
      ),
      0
    );
    return Ht + Rt * Ot.quantity;
  }, Ue = () => {
    const Ot = [], Ht = (Rt, jt, Yt = "") => {
      Rt.forEach((Ut) => {
        const Qt = jt[Ut.id] || {}, Kt = Object.values(Qt).reduce(
          (qt, er) => qt + er.quantity,
          0
        ), Jt = Yt || "root";
        Kt < Ut.minSelection && Ot.push({
          modifierListId: Ut.id,
          modifierListName: Ut.name,
          error: "MIN_SELECTION",
          minRequired: Ut.minSelection,
          currentSelection: Kt,
          level: Jt
        }), Object.values(Qt).forEach((qt) => {
          const er = Ut.modifiers.find(
            (rr) => rr.id === qt.id
          );
          er && er.modifierLists.length > 0 && Ht(
            er.modifierLists,
            qt.modifierLists,
            `${Jt} > ${er.name}`
          );
        });
      });
    };
    return Ht(
      Ie.value.modifierLists,
      j.modifierLists
    ), {
      isValid: Ot.length === 0,
      errors: Ot
    };
  }, Re = (Ot) => Object.entries(Ot).map(([Ht, Rt]) => {
    const jt = Ee.value.get(Ht);
    return {
      id: Ht,
      plu: jt?.plu || "",
      modifiers: Object.values(Rt).map(Ye)
    };
  }), Ye = (Ot) => ({
    id: Ot.id,
    plu: Ot.plu,
    quantity: Ot.quantity,
    unitPrice: Ot.unitPrice,
    modifierLists: Re(
      Ot.modifierLists
    )
  }), We = () => {
    const Ot = Re(j.modifierLists).filter(
      (Ht) => Ht.modifiers.length > 0
    );
    return {
      id: j.itemId,
      plu: j.itemPlu,
      quantity: ke.value,
      unitPrice: It.value.value,
      modifierLists: Ot,
      ...Se.value ? { notes: Se.value } : {}
    };
  }, qe = (Ot, Ht) => Ot.reduce(
    (Rt, jt) => {
      const Yt = Ht[jt.id] || {}, Ut = Object.values(Yt).reduce(
        (Qt, Kt) => Qt + Kt.quantity,
        0
      );
      return Rt[jt.id] = {
        id: jt.id,
        plu: jt.plu,
        name: jt.name,
        minSelection: jt.minSelection,
        maxSelection: jt.maxSelection,
        selectType: jt.selectType,
        selectedCount: Ut,
        canSelectMore: Ut < jt.maxSelection,
        isValid: Ut >= jt.minSelection && Ut <= jt.maxSelection,
        selectedModifiers: Object.values(Yt).map((Qt) => {
          const Kt = jt.modifiers.find(
            (Jt) => Jt.id === Qt.id
          );
          return {
            id: Qt.id,
            plu: Qt.plu,
            name: Kt?.name || "",
            quantity: Qt.quantity,
            price: Kt?.price || {
              value: 0,
              currency: Ie.value.price.currency
            }
          };
        })
      }, Rt;
    },
    {}
  ), Je = computed(() => qe(
    Ie.value.modifierLists,
    j.modifierLists
  )), Ke = computed(() => new Set(
    Object.entries(Je.value).filter(([, Ot]) => !Ot.isValid).map(([Ot]) => Ot)
  )), xt = computed(() => Ke.value.values().next().value || ""), Ct = (Ot = 0) => ({
    value: Ot,
    currency: Me.value
  }), It = computed(
    () => Ct(xe(Ie.value.price.value))
  ), Nt = computed(() => {
    const Ot = Object.values(j.modifierLists).reduce(
      (Rt, jt) => Rt + Object.values(jt).reduce(
        (Yt, Ut) => Yt + De(Ut),
        0
      ),
      0
    ), Ht = (It.value.value + Ot) * ke.value;
    return Ct(Ht);
  }), Bt = computed(() => Ue().isValid && ke.value > 0), At = computed(() => Ue()), Ft = (Ot, Ht, Rt) => !!(Rt || j.modifierLists)[Ot]?.[Ht], Dt = (Ot, Ht, Rt, jt) => {
    const Yt = jt || j.modifierLists, Ut = qe(Rt, Yt), Qt = Ft(Ot, Ht, Yt), Kt = Ut[Ot];
    return !Qt && !Kt?.canSelectMore;
  }, zt = (Ot, Ht, Rt) => {
    const jt = $e(Rt, Ot, Ht);
    return !!(jt && jt.modifierLists.length > 0);
  }, kt = (Ot, Ht, Rt) => (Rt || j.modifierLists)[Ot]?.[Ht], Et = (Ot, Ht, Rt) => kt(Ot, Ht, Rt)?.quantity || 0, Qe = (Ot, Ht, Rt) => {
    const jt = Rt || j.modifierLists;
    return qe(Ht, jt)[Ot]?.selectedCount || 0;
  }, Xe = (Ot, Ht, Rt) => {
    const jt = Rt || j.modifierLists;
    return qe(Ht, jt)[Ot]?.isValid ?? !1;
  }, Vt = (Ot = !0) => {
    j.modifierLists = {}, ke.value = 1, Se.value = "", Ot && Le(Ie.value.modifierLists);
  }, Lt = (Ot) => {
    ke.value = Ot;
  }, Gt = (Ot) => {
    Se.value = Ot;
  }, Wt = (Ot) => {
    const Ht = {};
    return Ot.forEach((Rt) => {
      Rt.modifiers.length > 0 && (Ht[Rt.id] = {}, Rt.modifiers.forEach((jt) => {
        Ht[Rt.id][jt.id] = {
          id: jt.id,
          plu: jt.plu,
          quantity: jt.quantity,
          unitPrice: jt.unitPrice,
          modifierLists: Wt(
            jt.modifierLists || []
          )
        };
      }));
    }), Ht;
  }, Zt = (Ot) => {
    Vt(!1), Lt(Ot.quantity), Gt(Ot.notes || ""), j.modifierLists = Wt(
      Ot.modifierLists
    );
  };
  return e.initialSelection ? Zt(e.initialSelection) : Le(e.rootItem.modifierLists), {
    itemQuantity: readonly(ke),
    itemNotes: readonly(Se),
    selection: readonly(j),
    currentItem: readonly(Ie),
    canAddToBasket: Bt,
    totalPrice: Nt,
    currentValidation: At,
    modifierListsSummary: Je,
    invalidModifierLists: Ke,
    firstInvalidModifierList: xt,
    addModifier: Fe,
    removeModifier: Ve,
    toggleModifier: je,
    clearModifierList: Ge,
    setItemQuantity: Lt,
    setItemNotes: Gt,
    resetSelections: Vt,
    loadFromBasketPayload: Zt,
    isModifierSelected: Ft,
    isModifierDisabled: Dt,
    hasSubModifiers: zt,
    getSelectedModifier: kt,
    getSelectedModifierQuantity: Et,
    getSelectedModifiersCount: Qe,
    isModifierListValid: Xe,
    validateSelections: Ue,
    generateBasketPayload: We,
    getModifierListsSummary: qe
  };
}
const useWindowResize = () => {
  const e = ref(0), j = ref(0), ke = () => {
    isBrowser() && (e.value = window.innerWidth, j.value = window.innerHeight);
  }, Se = computed(() => e.value <= 576), xe = computed(() => e.value <= 991), Ie = computed(() => e.value <= 576), Me = computed(() => e.value <= 768), Ee = computed(() => e.value <= 992), Be = computed(() => e.value <= 1200);
  return onMounted(() => {
    ke(), window.addEventListener("resize", ke);
  }), onUnmounted(() => {
    window.removeEventListener("resize", ke);
  }), {
    width: e,
    height: j,
    isMobile: Se,
    isTablet: xe,
    isSmall: Ie,
    isMedium: Me,
    isLarge: Ee,
    isExtraLarge: Be
  };
};
function watchDebounced(e, j, ke) {
  const { debounce: Se = 0, ...xe } = ke || {};
  if (Se === 0)
    return watch(e, j, xe);
  let Ie = null;
  return watch(e, (Ee, Be, $e) => {
    Ie !== null && clearTimeout(Ie), Ie = setTimeout(
      () => j(Ee, Be, $e),
      Se
    );
  }, xe);
}
const className$1H = "sat-drawer", css$1H = bemBuilder(className$1H);
bemBuilder(className$1H, !0);
const __variableDynamicImportRuntimeHelper = (e, j, ke) => {
  const Se = e[j];
  return Se ? typeof Se == "function" ? Se() : Promise.resolve(Se) : new Promise((xe, Ie) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(Ie.bind(null, /* @__PURE__ */ new Error("Unknown variable dynamic import: " + j + (j.split("/").length !== ke ? ". Note that variables only represent file names one level deep." : ""))));
  });
}, className$1G = "atom-icon", css$1G = bemBuilder(className$1G);
bemBuilder(className$1G, !0);
const _sfc_main$1Q = /* @__PURE__ */ defineComponent({
  __name: "AtomIcon",
  props: {
    name: {},
    color: { default: "color-base-20" },
    size: { default: "medium" },
    ignoreColor: { type: Boolean, default: !1 }
  },
  setup(e) {
    const j = e, ke = {
      xs: "8px",
      "x-small": "8px",
      "extra-small": "8px",
      sm: "14px",
      small: "14px",
      md: "21px",
      medium: "21px",
      lg: "28px",
      large: "28px",
      xl: "42px",
      "x-large": "42px",
      "2xl": "56px",
      "2x-large": "56px"
    }, Se = computed(() => ke[j.size] ?? `${j.size}px`), xe = computed(() => ({
      width: Se.value,
      minWidth: Se.value,
      height: Se.value,
      minHeight: Se.value,
      color: j.ignoreColor ? "currentColor" : `var(--${j.color})`
    })), Ie = computed(() => defineAsyncComponent(async () => __variableDynamicImportRuntimeHelper(/* @__PURE__ */ Object.assign({ "./assets/add.svg": () => import("./add-DE33bM7z.js"), "./assets/arrow-left.svg": () => import("./arrow-left-DDcdrKxA.js"), "./assets/arrow-right.svg": () => import("./arrow-right-C3auEGK-.js"), "./assets/back.svg": () => import("./back-CTpofX_i.js"), "./assets/card.svg": () => import("./card-BPDepAhe.js"), "./assets/caret-right-alt.svg": () => import("./caret-right-alt-BTfgfM_H.js"), "./assets/caret-right.svg": () => import("./caret-right-DVtxQs9T.js"), "./assets/caret-up.svg": () => import("./caret-up-Kcqp2EM-.js"), "./assets/check.svg": () => import("./check-BxIyLa34.js"), "./assets/checkmark.svg": () => import("./checkmark-DJDeRMX0.js"), "./assets/close-circle.svg": () => import("./close-circle-DxuOlnQl.js"), "./assets/close.svg": () => import("./close-CV2TTARC.js"), "./assets/copy.svg": () => import("./copy-Ph6BqHH1.js"), "./assets/crown.svg": () => import("./crown-W_RMSVjT.js"), "./assets/delete.svg": () => import("./delete-BggKkuZB.js"), "./assets/diamond.svg": () => import("./diamond-C-5mXF2t.js"), "./assets/discount.svg": () => import("./discount-FFqqLsqW.js"), "./assets/dish.svg": () => import("./dish-1IL5HIbJ.js"), "./assets/dollar-sign.svg": () => import("./dollar-sign-C56gNaX-.js"), "./assets/facebook.svg": () => import("./facebook-B1qqImPk.js"), "./assets/food.svg": () => import("./food-wPEvoDTY.js"), "./assets/ghost-checkmark.svg": () => import("./ghost-checkmark-BC9J5qYr.js"), "./assets/gift-box.svg": () => import("./gift-box-DIt2UfQG.js"), "./assets/info.svg": () => import("./info-t_ta5vwP.js"), "./assets/instagram.svg": () => import("./instagram-553EAmS7.js"), "./assets/languages.svg": () => import("./languages-Ct0n09QO.js"), "./assets/linkedin.svg": () => import("./linkedin-CC3ADCap.js"), "./assets/location.svg": () => import("./location-D0gqaA5n.js"), "./assets/minus.svg": () => import("./minus-DdzTldff.js"), "./assets/nav.svg": () => import("./nav-BbPjHryz.js"), "./assets/outlet.svg": () => import("./outlet-DlxC1V0a.js"), "./assets/pencil-circle.svg": () => import("./pencil-circle-CFJY4kM5.js"), "./assets/people.svg": () => import("./people-Di0DmYka.js"), "./assets/pin.svg": () => import("./pin-BNRc5Wbp.js"), "./assets/placeholder-photo.svg": () => import("./placeholder-photo-B7mZ4I71.js"), "./assets/plus.svg": () => import("./plus-CBnro2A7.js"), "./assets/rating-ghost.svg": () => import("./rating-ghost-DqIPnk6e.js"), "./assets/rating.svg": () => import("./rating-grS7xUIF.js"), "./assets/scooter.svg": () => import("./scooter-BkjR6MQQ.js"), "./assets/search.svg": () => import("./search-Bw1Jkbo4.js"), "./assets/sms.svg": () => import("./sms-aNEkTjQR.js"), "./assets/speech-bubble.svg": () => import("./speech-bubble-BsgVtYRZ.js"), "./assets/tap.svg": () => import("./tap-DMwwOmWL.js"), "./assets/tiktok.svg": () => import("./tiktok-DB4354-d.js"), "./assets/time.svg": () => import("./time-Drkj3xVg.js"), "./assets/translate.svg": () => import("./translate-CQtUHgj-.js"), "./assets/twitter.svg": () => import("./twitter-a5fJqvX7.js"), "./assets/user-circle.svg": () => import("./user-circle-Bmc3_3UM.js"), "./assets/user.svg": () => import("./user-m-61MrUd.js"), "./assets/warning.svg": () => import("./warning-DQEfnH-7.js"), "./assets/whatsapp.svg": () => import("./whatsapp-DlO4sRlS.js"), "./assets/youtube.svg": () => import("./youtube-BbTp3mVs.js") }), `./assets/${j.name}.svg`, 3)));
    return (Me, Ee) => (openBlock(), createBlock(resolveDynamicComponent(Ie.value), {
      key: j.name,
      class: normalizeClass(unref(css$1G)()),
      style: normalizeStyle(xe.value)
    }, null, 8, ["class", "style"]));
  }
});
var AtomIconNameEnum = /* @__PURE__ */ ((e) => (e.ADD = "add", e.ARROW_LEFT = "arrow-left", e.ARROW_RIGHT = "arrow-right", e.BACK = "back", e.CARD = "card", e.CARET_RIGHT = "caret-right", e.CARET_RIGHT_ALT = "caret-right-alt", e.CARET_UP = "caret-up", e.CHECK = "check", e.CHECKMARK = "checkmark", e.CLOSE = "close", e.CLOSE_CIRCLE = "close-circle", e.CROWN = "crown", e.COPY = "copy", e.DELETE = "delete", e.DIAMOND = "diamond", e.DISCOUNT = "discount", e.DISH = "dish", e.DOLLAR_SIGN = "dollar-sign", e.FACEBOOK = "facebook", e.FOOD = "food", e.GHOST_CHECKMARK = "ghost-checkmark", e.INFO = "info", e.INSTAGRAM = "instagram", e.LANGUAGES = "languages", e.LINKEDIN = "linkedin", e.LOCATION = "location", e.MINUS = "minus", e.NAV = "nav", e.OUTLET = "outlet", e.PENCIL_CIRCLE = "pencil-circle", e.PEOPLE = "people", e.PIN = "pin", e.PLACEHOLDER_PHOTO = "placeholder-photo", e.PLUS = "plus", e.RATING = "rating", e.RATING_GHOST = "rating-ghost", e.SCOOTER = "scooter", e.SEARCH = "search", e.GIFT_BOX = "gift-box", e.SMS = "sms", e.SPEECH_BUBBLE = "speech-bubble", e.TAP = "tap", e.TRANSLATE = "translate", e.TIKTOK = "tiktok", e.TIME = "time", e.TWITTER = "twitter", e.USER = "user", e.USER_CIRCLE = "user-circle", e.YOUTUBE = "youtube", e.WARNING = "warning", e.WHATSAPP = "whatsapp", e))(AtomIconNameEnum || {});
const useAtomIcon = () => ({
  preloadAssets: () => {
    Object.values(AtomIconNameEnum).forEach(
      (j) => __variableDynamicImportRuntimeHelper(/* @__PURE__ */ Object.assign({ "./assets/add.svg": () => import("./add-DE33bM7z.js"), "./assets/arrow-left.svg": () => import("./arrow-left-DDcdrKxA.js"), "./assets/arrow-right.svg": () => import("./arrow-right-C3auEGK-.js"), "./assets/back.svg": () => import("./back-CTpofX_i.js"), "./assets/card.svg": () => import("./card-BPDepAhe.js"), "./assets/caret-right-alt.svg": () => import("./caret-right-alt-BTfgfM_H.js"), "./assets/caret-right.svg": () => import("./caret-right-DVtxQs9T.js"), "./assets/caret-up.svg": () => import("./caret-up-Kcqp2EM-.js"), "./assets/check.svg": () => import("./check-BxIyLa34.js"), "./assets/checkmark.svg": () => import("./checkmark-DJDeRMX0.js"), "./assets/close-circle.svg": () => import("./close-circle-DxuOlnQl.js"), "./assets/close.svg": () => import("./close-CV2TTARC.js"), "./assets/copy.svg": () => import("./copy-Ph6BqHH1.js"), "./assets/crown.svg": () => import("./crown-W_RMSVjT.js"), "./assets/delete.svg": () => import("./delete-BggKkuZB.js"), "./assets/diamond.svg": () => import("./diamond-C-5mXF2t.js"), "./assets/discount.svg": () => import("./discount-FFqqLsqW.js"), "./assets/dish.svg": () => import("./dish-1IL5HIbJ.js"), "./assets/dollar-sign.svg": () => import("./dollar-sign-C56gNaX-.js"), "./assets/facebook.svg": () => import("./facebook-B1qqImPk.js"), "./assets/food.svg": () => import("./food-wPEvoDTY.js"), "./assets/ghost-checkmark.svg": () => import("./ghost-checkmark-BC9J5qYr.js"), "./assets/gift-box.svg": () => import("./gift-box-DIt2UfQG.js"), "./assets/info.svg": () => import("./info-t_ta5vwP.js"), "./assets/instagram.svg": () => import("./instagram-553EAmS7.js"), "./assets/languages.svg": () => import("./languages-Ct0n09QO.js"), "./assets/linkedin.svg": () => import("./linkedin-CC3ADCap.js"), "./assets/location.svg": () => import("./location-D0gqaA5n.js"), "./assets/minus.svg": () => import("./minus-DdzTldff.js"), "./assets/nav.svg": () => import("./nav-BbPjHryz.js"), "./assets/outlet.svg": () => import("./outlet-DlxC1V0a.js"), "./assets/pencil-circle.svg": () => import("./pencil-circle-CFJY4kM5.js"), "./assets/people.svg": () => import("./people-Di0DmYka.js"), "./assets/pin.svg": () => import("./pin-BNRc5Wbp.js"), "./assets/placeholder-photo.svg": () => import("./placeholder-photo-B7mZ4I71.js"), "./assets/plus.svg": () => import("./plus-CBnro2A7.js"), "./assets/rating-ghost.svg": () => import("./rating-ghost-DqIPnk6e.js"), "./assets/rating.svg": () => import("./rating-grS7xUIF.js"), "./assets/scooter.svg": () => import("./scooter-BkjR6MQQ.js"), "./assets/search.svg": () => import("./search-Bw1Jkbo4.js"), "./assets/sms.svg": () => import("./sms-aNEkTjQR.js"), "./assets/speech-bubble.svg": () => import("./speech-bubble-BsgVtYRZ.js"), "./assets/tap.svg": () => import("./tap-DMwwOmWL.js"), "./assets/tiktok.svg": () => import("./tiktok-DB4354-d.js"), "./assets/time.svg": () => import("./time-Drkj3xVg.js"), "./assets/translate.svg": () => import("./translate-CQtUHgj-.js"), "./assets/twitter.svg": () => import("./twitter-a5fJqvX7.js"), "./assets/user-circle.svg": () => import("./user-circle-Bmc3_3UM.js"), "./assets/user.svg": () => import("./user-m-61MrUd.js"), "./assets/warning.svg": () => import("./warning-DQEfnH-7.js"), "./assets/whatsapp.svg": () => import("./whatsapp-DlO4sRlS.js"), "./assets/youtube.svg": () => import("./youtube-BbTp3mVs.js") }), `./assets/${j}.svg`, 3)
    );
  }
});
function I$1(e, j) {
  let ke;
  const Se = computed(() => {
    if (j.value.container)
      return e.value.closest(j.value.container) ?? void 0;
  }), xe = computed(() => {
    const Fe = j.value.scrollContainer;
    return Fe ? document.querySelector(Fe) ?? window : window;
  }), Ie = () => {
    if (!ke || j.value.disabled) return;
    const { top: Fe, left: Ve, width: je } = ke.getBoundingClientRect(), { topOffset: Ge, zIndex: De } = j.value;
    if (ke.style.height = `${e.value.scrollHeight}px`, Fe < Ge) {
      e.value.style.position = "fixed", e.value.style.top = `${Ge}px`, e.value.style.left = `${Ve}px`, e.value.style.width = `${je}px`, e.value.style.zIndex = String(De), e.value.classList.add("v-sticky--active");
      const Ue = Me();
      Ue < 0 && (e.value.style.top = String(Ue + Ge) + "px");
    } else
      ke.style.height = "0px", Ee();
  }, Me = () => {
    if (!Se.value) return 0;
    const { topOffset: Fe, bottomOffset: Ve } = j.value, { bottom: je } = Se.value.getBoundingClientRect();
    return je - e.value.scrollHeight - Ve - Fe;
  }, Ee = () => {
    ["position", "top", "bottom", "left", "width", "z-index"].forEach(
      (Fe) => {
        e.value.style.removeProperty(Fe);
      }
    ), e.value.classList.remove("v-sticky--active");
  }, Be = async () => {
    if (ke = document.createElement("div"), !e.value.parentNode) return;
    ke.classList.add("v-sticky__placeholder");
    const { position: Fe, top: Ve } = window.getComputedStyle(e.value);
    Fe !== "static" && Fe !== "relative" && (ke.style.position = Fe, ke.style.width = "100%", ke.style.top = Ve), e.value.parentNode.insertBefore(ke, e.value), Ie();
  }, $e = () => {
    if (!ke) return;
    const { parentNode: Fe } = ke;
    Fe && Fe.removeChild(ke);
  }, Le = () => {
    requestAnimationFrame(Ie);
  };
  return { initialize: () => {
    xe.value.addEventListener("scroll", Le, {
      passive: !0
    }), xe.value.addEventListener("resize", Le, {
      passive: !0
    }), Be();
  }, destroy: () => {
    xe.value.removeEventListener("scroll", Le), xe.value.removeEventListener("resize", Le), Ee(), $e();
  } };
}
const w$1 = (e, j) => {
  if (j.value.disabled) return;
  const ke = ref({
    ...j.value,
    scrollContainer: j.value.scrollContainer,
    container: j.value.container,
    topOffset: j.value.topOffset || 0,
    bottomOffset: j.value.bottomOffset || 0,
    zIndex: j.value.zIndex || 0,
    disabled: j.value.disabled || !1
  }), Se = ref(e), { initialize: xe, destroy: Ie } = I$1(Se, ke);
  Se.value.__stickyCleanup = Ie, xe();
}, N$1 = {
  mounted(e, j) {
    w$1(e, j);
  },
  updated(e, j) {
    e.__stickyCleanup && e.__stickyCleanup(), w$1(e, j);
  },
  unmounted(e) {
    e.__stickyCleanup && e.__stickyCleanup();
  }
};
var c$2 = /* @__PURE__ */ ((e) => (e.UP = "up", e.DOWN = "down", e.LEFT = "left", e.RIGHT = "right", e))(c$2 || {});
const k$1 = 100, z$1 = 500, b$2 = {
  clientX: null,
  clientY: null,
  xDiff: null,
  yDiff: null,
  startEl: null,
  timeDown: 0
}, m$3 = (e, j) => {
  switch (e) {
    case c$2.DOWN:
      return j.scrollTop > 0;
    case c$2.UP:
      return j.scrollTop + j.clientHeight < j.scrollHeight;
    case c$2.RIGHT:
      return j.scrollLeft > 0;
    case c$2.LEFT:
      return j.scrollLeft + j.clientWidth < j.scrollWidth;
    default:
      return !0;
  }
}, x$3 = (e, j, ke) => {
  !ke || !j || m$3(j.type, e.currentTarget) || (ke.timeDown = Date.now(), ke.startEl = e.currentTarget, ke.clientX = e.touches[0].clientX, ke.clientY = e.touches[0].clientY, ke.xDiff = 0, ke.yDiff = 0);
}, _$1 = (e, j, ke) => {
  if (!j || !ke || !ke.clientX || !ke.clientY || m$3(j.type, e.currentTarget))
    return;
  const Se = e.touches[0].clientX, xe = e.touches[0].clientY;
  ke.xDiff = ke.clientX - Se, ke.yDiff = ke.clientY - xe;
}, S$3 = (e, j, ke) => {
  if (!j || !ke || ke.startEl !== e.currentTarget || m$3(j.type, e.currentTarget))
    return;
  let Se = "";
  const xe = j.threshold || k$1, Ie = j.timeout || z$1, Me = e.changedTouches || e.touches || [], Ee = Math.abs(Number(ke.xDiff)), Be = Math.abs(Number(ke.yDiff)), $e = Ee > Be, Le = Date.now() - ke.timeDown < Ie;
  if ($e && Ee > xe && Le ? Se = Number(ke.xDiff) > 0 ? c$2.LEFT : c$2.RIGHT : Be > xe && Le && (Se = Number(ke.yDiff) > 0 ? c$2.UP : c$2.DOWN), Se) {
    const Fe = Me[0] || {}, Ve = {
      dir: Se,
      xStart: ke.clientX || -1,
      xEnd: parseInt(Fe.clientX || -1, 10),
      yStart: ke.clientY || -1,
      yEnd: parseInt(Fe.clientY || -1, 10)
    };
    j.type === Se && j.onSwipe(Ve);
  }
  ke.clientX = null, ke.clientY = null, ke.timeDown = 0;
}, X$2 = {
  created: (e, j) => {
    const ke = j.value;
    if (ke.ignore) return;
    const Se = reactive({
      ...b$2
    });
    e.addEventListener(
      "touchstart",
      (xe) => {
        x$3(xe, ke, Se);
      },
      !1
    ), e.addEventListener(
      "touchmove",
      (xe) => {
        _$1(xe, ke, Se);
      },
      !1
    ), e.addEventListener(
      "touchend",
      (xe) => {
        S$3(xe, ke, Se);
      },
      !1
    );
  },
  beforeUnmount: (e) => {
    e.removeEventListener("touchstart", x$3, !1), e.removeEventListener("touchmove", _$1, !1), e.removeEventListener("touchend", S$3, !1);
  }
};
function Y$2(e, j) {
  const ke = inject(e, j);
  if (!ke)
    throw new Error(`Could not resolve ${e.description}`);
  return ke;
}
const _sfc_main$1P = /* @__PURE__ */ defineComponent({
  __name: "SatDrawer",
  props: {
    hPosition: { default: "center" },
    modelValue: { type: Boolean, default: !1 },
    withTransparentFade: { type: Boolean, default: !1 },
    maxWidth: {},
    logo: { default: "" },
    lockBody: { type: Boolean, default: !0 },
    showLogo: { type: Boolean, default: !1 },
    useSwipe: { type: Boolean, default: !1 },
    fullHeight: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: j }) {
    useCssVars((Ge) => ({
      v698d8c5b: xe.value,
      fc1d8d00: Ie.value
    }));
    const ke = e, Se = j, xe = computed(
      () => ke.maxWidth ? `${ke.maxWidth}px` : "100%"
    ), Ie = computed(() => `url(${ke.logo})`), Me = ref(!1), Ee = ref(!1);
    onMounted(() => {
      $e(ke.modelValue);
    }), onBeforeUnmount(() => {
      ke.lockBody && unlockBody();
    }), watch(
      () => ke.modelValue,
      (Ge) => {
        $e(Ge);
      }
    );
    const Be = () => {
      Se("update:modelValue", !1), je();
    }, $e = (Ge) => {
      Ge ? Ve() : Fe(), ke.lockBody && (Ge ? lockBody() : unlockBody());
    }, Le = () => Ee.value = !0, Fe = () => Ee.value = !1, Ve = () => Me.value = !0, je = () => Me.value = !1;
    return (Ge, De) => (openBlock(), createBlock(Transition, {
      name: "sat-drawer-fade",
      onEnter: Le
    }, {
      default: withCtx(() => [
        Me.value ? (openBlock(), createElementBlock("div", {
          key: 0,
          role: "drawer",
          "aria-modal": "true",
          class: normalizeClass({
            [unref(css$1H)()]: !0,
            [unref(css$1H)("", ke.hPosition)]: !0,
            [unref(css$1H)("", "full-height")]: ke.fullHeight
          })
        }, [
          createElementVNode("div", {
            class: normalizeClass(unref(css$1H)("content"))
          }, [
            createElementVNode("div", {
              class: normalizeClass(unref(css$1H)("filler"))
            }, [
              createVNode(Transition, {
                name: "sat-drawer-slide-up",
                onLeave: Be
              }, {
                default: withCtx(() => [
                  Ee.value ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    class: normalizeClass([
                      unref(css$1H)("aligner"),
                      { [unref(css$1H)("aligner", "with-logo")]: ke.showLogo }
                    ]),
                    onClick: withModifiers(Fe, ["self"])
                  }, [
                    ke.showLogo ? (openBlock(), createElementBlock("div", {
                      key: 0,
                      class: normalizeClass(unref(css$1H)("logo-container"))
                    }, [
                      ke.logo ? (openBlock(), createElementBlock("div", {
                        key: 0,
                        class: normalizeClass(unref(css$1H)("logo"))
                      }, null, 2)) : (openBlock(), createElementBlock("span", {
                        key: 1,
                        class: normalizeClass(unref(css$1H)("default-logo"))
                      }, [
                        createVNode(unref(_sfc_main$1Q), {
                          name: "outlet",
                          color: "color-base-70"
                        })
                      ], 2))
                    ], 2)) : createCommentVNode("", !0),
                    withDirectives((openBlock(), createElementBlock("div", {
                      class: normalizeClass(unref(css$1H)("shelve"))
                    }, [
                      renderSlot(Ge.$slots, "default", {}, void 0, !0)
                    ], 2)), [
                      [unref(X$2), {
                        type: "down",
                        threshold: 150,
                        onSwipe: Fe,
                        ignore: !ke.useSwipe,
                        timeout: 500
                      }]
                    ])
                  ], 2)) : createCommentVNode("", !0)
                ]),
                _: 3
              })
            ], 2)
          ], 2),
          createElementVNode("div", {
            class: normalizeClass({
              [unref(css$1H)("fade")]: !0,
              [unref(css$1H)("fade", "transparent")]: ke.withTransparentFade
            }),
            onClick: withModifiers(Fe, ["self"])
          }, null, 2)
        ], 2)) : createCommentVNode("", !0)
      ]),
      _: 3
    }));
  }
}), SatDrawer = /* @__PURE__ */ _export_sfc(_sfc_main$1P, [["__scopeId", "data-v-c4baae13"]]), AtomDrawer = SatDrawer, className$1F = "elastic-panel", css$1F = bemBuilder(className$1F);
bemBuilder(className$1F, !0);
const className$1E = "mol-modal", css$1E = bemBuilder(className$1E);
bemBuilder(className$1E, !0);
const className$1D = "atom-card", css$1D = bemBuilder(className$1D);
bemBuilder(className$1D, !0);
const _sfc_main$1O = /* @__PURE__ */ defineComponent({
  __name: "AtomCard",
  props: {
    padding: { default: "medium" },
    radii: { default: "medium" },
    elevation: { default: "none" }
  },
  setup(e) {
    const j = e;
    return (ke, Se) => (openBlock(), createElementBlock("div", {
      class: normalizeClass([
        unref(css$1D)(),
        unref(css$1D)("", `padding-${j.padding}`),
        unref(css$1D)("", `radii-${j.radii}`),
        unref(css$1D)("", `elevation-${j.elevation}`)
      ])
    }, [
      renderSlot(ke.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), AtomCard = /* @__PURE__ */ _export_sfc(_sfc_main$1O, [["__scopeId", "data-v-12f2a747"]]), className$1C = "atom-overlay", css$1C = bemBuilder(className$1C);
bemBuilder(className$1C, !0);
const _sfc_main$1N = /* @__PURE__ */ defineComponent({
  __name: "AtomOverlay",
  setup(e) {
    return (j, ke) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$1C)())
    }, null, 2));
  }
}), AtomOverlay = /* @__PURE__ */ _export_sfc(_sfc_main$1N, [["__scopeId", "data-v-afdba736"]]), className$1B = "sat-icon-button", css$1B = bemBuilder(className$1B);
bemBuilder(className$1B, !0);
const _sfc_main$1M = /* @__PURE__ */ defineComponent({
  __name: "SatIconButton",
  props: {
    iconName: {},
    route: {},
    variant: { default: "primary" },
    theme: { default: "filled" },
    size: { default: "medium" },
    disabled: { type: Boolean },
    type: { default: "rounded" }
  },
  emits: ["click"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, { routerComponent: xe } = useSatelliteUtils(), Ie = computed(() => ke.route ? xe() : "button");
    return (Me, Ee) => (openBlock(), createBlock(resolveDynamicComponent(Ie.value), {
      to: ke.route,
      class: normalizeClass([
        unref(css$1B)(),
        unref(css$1B)("", ke.size),
        unref(css$1B)(ke.variant, ke.theme),
        ke.type && unref(css$1B)("", ke.type)
      ]),
      disabled: ke.disabled,
      onClick: Ee[0] || (Ee[0] = (Be) => Se("click", Be))
    }, {
      default: withCtx(() => [
        (openBlock(), createBlock(unref(_sfc_main$1Q), {
          key: ke.iconName,
          name: ke.iconName,
          size: ke.size === "extra-small" ? "small" : "medium",
          "ignore-color": ""
        }, null, 8, ["name", "size"]))
      ]),
      _: 1
    }, 8, ["to", "class", "disabled"]));
  }
}), SatIconButton = /* @__PURE__ */ _export_sfc(_sfc_main$1M, [["__scopeId", "data-v-7a8b72e9"]]), MolIconButton = SatIconButton, _sfc_main$1L = /* @__PURE__ */ defineComponent({
  __name: "MolModal",
  props: {
    modelValue: { type: Boolean, default: !1 },
    lockBody: { type: Boolean, default: !0 },
    widthFitContent: { type: Boolean, default: !1 },
    width: {},
    padding: { default: "large" },
    outerGap: { default: "md" },
    showClose: { type: Boolean, default: !1 },
    innerScroll: { type: Boolean, default: !1 }
  },
  emits: ["close", "update:modelValue"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = ref(!1);
    onMounted(() => {
      Ie(ke.modelValue);
    }), watch(
      () => ke.modelValue,
      ($e) => {
        Ie($e);
      }
    );
    const Ie = ($e) => {
      $e ? (ke.lockBody && lockBody(), Me()) : (ke.lockBody && unlockBody(), Ee());
    }, Me = () => xe.value = !0, Ee = () => xe.value = !1, Be = computed(() => ke.widthFitContent ? { maxWidth: ke.widthFitContent ? "fit-content" : "347px" } : ke.width ? { width: ke.width } : { maxWidth: "347px" });
    return ($e, Le) => (openBlock(), createBlock(Transition, { name: "mol-modal-fade" }, {
      default: withCtx(() => [
        xe.value ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass([
            unref(css$1E)(),
            unref(css$1E)("", `outer-gap-${ke.outerGap}`),
            {
              [unref(css$1E)("", "closable")]: ke.showClose,
              [unref(css$1E)("", "inner-scroll")]: ke.innerScroll
            }
          ])
        }, [
          createVNode(unref(AtomOverlay), {
            style: { height: "100vh", position: "fixed" },
            onClick: Le[0] || (Le[0] = withModifiers((Fe) => Se("close", Fe), ["self"]))
          }),
          createElementVNode("div", {
            class: normalizeClass(unref(css$1E)("container")),
            style: normalizeStyle(Be.value)
          }, [
            ke.showClose ? (openBlock(), createBlock(unref(SatIconButton), {
              key: 0,
              class: normalizeClass(unref(css$1E)("close")),
              "icon-name": "close",
              size: "small",
              onClick: Le[1] || (Le[1] = (Fe) => Se("close", Fe))
            }, null, 8, ["class"])) : createCommentVNode("", !0),
            createVNode(unref(AtomCard), {
              class: normalizeClass(unref(css$1E)("card")),
              elevation: "large",
              padding: ke.padding
            }, {
              default: withCtx(() => [
                renderSlot($e.$slots, "default", {}, void 0, !0)
              ]),
              _: 3
            }, 8, ["class", "padding"])
          ], 6)
        ], 2)) : createCommentVNode("", !0)
      ]),
      _: 3
    }));
  }
}), MolModal = /* @__PURE__ */ _export_sfc(_sfc_main$1L, [["__scopeId", "data-v-1704652f"]]);
function useMolModal() {
  const e = ref(!1);
  return {
    isModalVisible: e,
    showModal: () => e.value = !0,
    hideModal: () => e.value = !1,
    toggleModal: () => e.value = !e.value
  };
}
const _sfc_main$1K = /* @__PURE__ */ defineComponent({
  __name: "SatElasticPanel",
  props: {
    hPosition: { default: "center" },
    modelValue: { type: Boolean, default: !1 },
    withTransparentFade: { type: Boolean, default: !1 },
    maxWidth: {},
    logo: { default: "" },
    showLogo: { type: Boolean, default: !1 },
    useSwipe: { type: Boolean, default: !1 },
    fullHeight: { type: Boolean, default: !1 },
    lockBody: { type: Boolean, default: !0 },
    widthFitContent: { type: Boolean, default: !1 },
    innerScroll: { type: Boolean, default: !1 },
    padding: { default: "large" },
    showClose: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: j }) {
    const ke = e, { isMobile: Se } = useWindowResize(), xe = j, Ie = computed(() => Se.value ? SatDrawer : MolModal), Me = computed(() => Se.value ? {
      hPosition: ke.hPosition,
      modelValue: ke.modelValue,
      withTransparentFade: ke.withTransparentFade,
      maxWidth: ke.maxWidth,
      lockBody: ke.lockBody,
      logo: ke.logo,
      showLogo: ke.showLogo,
      padding: ke.padding,
      useSwipe: ke.useSwipe,
      fullHeight: ke.fullHeight,
      widthFitContent: ke.widthFitContent
    } : {
      modelValue: ke.modelValue,
      lockBody: ke.lockBody,
      widthFitContent: ke.widthFitContent,
      innerScroll: ke.innerScroll,
      padding: ke.padding,
      showClose: ke.showClose
    }), Ee = ($e) => {
      xe("update:modelValue", $e);
    }, Be = () => {
      xe("update:modelValue", !1);
    };
    return ($e, Le) => (openBlock(), createBlock(resolveDynamicComponent(Ie.value), mergeProps({
      "model-value": ke.modelValue
    }, Me.value, {
      class: unref(css$1F)(),
      "onUpdate:modelValue": Ee,
      onClose: Be
    }), {
      default: withCtx(() => [
        renderSlot($e.$slots, "default")
      ]),
      _: 3
    }, 16, ["model-value", "class"]));
  }
}), className$1A = "sat-form-control", css$1A = bemBuilder(className$1A);
bemBuilder(className$1A, !0);
const _sfc_main$1J = /* @__PURE__ */ defineComponent({
  __name: "SatFormControl",
  props: {
    label: {},
    errorMessage: {},
    required: { type: Boolean, default: !1 },
    optional: { type: Boolean, default: !1 },
    requiredFlag: {},
    optionalFlag: {}
  },
  setup(e) {
    const j = e;
    return (ke, Se) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$1A)())
    }, [
      j.label ? (openBlock(), createBlock(unref(AtomText), {
        key: 0,
        type: "body-bold",
        tag: "div",
        class: normalizeClass(unref(css$1A)("label"))
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(j.label) + " ", 1),
          j.required ? (openBlock(), createBlock(unref(AtomText), {
            key: 0,
            "data-test": "required",
            type: "small",
            color: "color-text-secondary"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t)("form_control.required_flag", j.requiredFlag)), 1)
            ]),
            _: 1
          })) : createCommentVNode("", !0),
          j.optional ? (openBlock(), createBlock(unref(AtomText), {
            key: 1,
            "data-test": "optional",
            type: "small",
            color: "color-text-secondary"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t)("form_control.optional_flag", j.optionalFlag)), 1)
            ]),
            _: 1
          })) : createCommentVNode("", !0)
        ]),
        _: 1
      }, 8, ["class"])) : createCommentVNode("", !0),
      renderSlot(ke.$slots, "default", {}, void 0, !0),
      j.errorMessage?.length ? (openBlock(), createBlock(unref(AtomText), {
        key: 1,
        color: "color-coral",
        class: normalizeClass(unref(css$1A)("error"))
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(j.errorMessage), 1)
        ]),
        _: 1
      }, 8, ["class"])) : createCommentVNode("", !0)
    ], 2));
  }
}), SatFormControl = /* @__PURE__ */ _export_sfc(_sfc_main$1J, [["__scopeId", "data-v-94b4033e"]]), MolFormControl = SatFormControl, className$1z = "sat-input-search", css$1z = bemBuilder(className$1z);
bemBuilder(className$1z, !0);
const _hoisted_1$y = ["placeholder", "value", "autofocus"], _sfc_main$1I = /* @__PURE__ */ defineComponent({
  __name: "SatInputSearch",
  props: {
    modelValue: {},
    value: { default: "" },
    placeholder: {},
    autoFocus: { type: Boolean, default: !1 },
    isMenuSearch: { type: Boolean, default: !1 },
    clearable: { type: Boolean, default: !1 },
    keepClearVisible: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "input", "keyup", "change", "blur", "focus", "clear"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = ref(!1), Ie = ref(), Me = () => {
      if (!Ie.value)
        throw new Error("Satellite:InputSearch - Input element is not defined.");
      ke.autoFocus ? Ie.value.focus() : Ie.value.blur();
    }, Ee = computed(() => ke.clearable ? ke.keepClearVisible ? !0 : !!(Be.value ? ke.modelValue : ke.value) : !1), Be = computed(() => ke.modelValue !== void 0);
    onMounted(Me), watch(() => ke.autoFocus, Me);
    function $e(De) {
      Se("change", De.target.value);
    }
    function Le(De) {
      Se("input", De.target.value), Be.value && Se("update:modelValue", De.target.value);
    }
    function Fe(De) {
      Se("keyup", De.target.value);
    }
    function Ve(De) {
      xe.value = !1, Se("blur", De.target.value);
    }
    function je(De) {
      xe.value = !0, Se("focus", De.target.value);
    }
    const Ge = () => {
      Se("clear");
    };
    return (De, Ue) => (openBlock(), createElementBlock("label", {
      class: normalizeClass({
        [unref(css$1z)()]: !0,
        [unref(css$1z)("", "focus")]: xe.value,
        [unref(css$1z)("", "is-menu-search")]: ke.isMenuSearch
      })
    }, [
      createVNode(unref(_sfc_main$1Q), {
        class: normalizeClass(unref(css$1z)("icon")),
        name: "search",
        color: "color-text-body"
      }, null, 8, ["class"]),
      createElementVNode("input", {
        ref_key: "inputElement",
        ref: Ie,
        type: "text",
        class: normalizeClass(unref(css$1z)("field")),
        placeholder: ke.placeholder,
        value: Be.value ? ke.modelValue : ke.value,
        autofocus: ke.autoFocus,
        onInput: Ue[0] || (Ue[0] = (Re) => Le(Re)),
        onChange: Ue[1] || (Ue[1] = (Re) => $e(Re)),
        onKeyup: Ue[2] || (Ue[2] = (Re) => Fe(Re)),
        onFocus: Ue[3] || (Ue[3] = (Re) => je(Re)),
        onBlur: Ue[4] || (Ue[4] = (Re) => Ve(Re))
      }, null, 42, _hoisted_1$y),
      Ee.value ? (openBlock(), createBlock(unref(SatIconButton), {
        key: 0,
        "icon-name": "close",
        variant: "primary",
        disabled: !1,
        theme: "filled",
        size: "extra-small",
        type: "rounded",
        onClick: Ge
      })) : createCommentVNode("", !0)
    ], 2));
  }
}), SatInputSearch = /* @__PURE__ */ _export_sfc(_sfc_main$1I, [["__scopeId", "data-v-122e0989"]]);
var E$2 = Object.defineProperty, M = Object.defineProperties, x$2 = Object.getOwnPropertyDescriptors, V = Object.getOwnPropertySymbols, I = Object.prototype.hasOwnProperty, N = Object.prototype.propertyIsEnumerable, C$2 = (e, j, ke) => j in e ? E$2(e, j, { enumerable: !0, configurable: !0, writable: !0, value: ke }) : e[j] = ke, f$1 = (e, j) => {
  for (var ke in j || (j = {}))
    I.call(j, ke) && C$2(e, ke, j[ke]);
  if (V)
    for (var ke of V(j))
      N.call(j, ke) && C$2(e, ke, j[ke]);
  return e;
}, m$2 = (e, j) => M(e, x$2(j));
const U = {
  props: {
    autoscroll: {
      type: Boolean,
      default: !0
    }
  },
  watch: {
    typeAheadPointer() {
      this.autoscroll && this.maybeAdjustScroll();
    },
    open(e) {
      this.autoscroll && e && this.$nextTick(() => this.maybeAdjustScroll());
    }
  },
  methods: {
    maybeAdjustScroll() {
      var e;
      const j = ((e = this.$refs.dropdownMenu) == null ? void 0 : e.children[this.typeAheadPointer]) || !1;
      if (j) {
        const ke = this.getDropdownViewport(), { top: Se, bottom: xe, height: Ie } = j.getBoundingClientRect();
        if (Se < ke.top)
          return this.$refs.dropdownMenu.scrollTop = j.offsetTop;
        if (xe > ke.bottom)
          return this.$refs.dropdownMenu.scrollTop = j.offsetTop - (ke.height - Ie);
      }
    },
    getDropdownViewport() {
      return this.$refs.dropdownMenu ? this.$refs.dropdownMenu.getBoundingClientRect() : {
        height: 0,
        top: 0,
        bottom: 0
      };
    }
  }
}, q$1 = {
  data() {
    return {
      typeAheadPointer: -1
    };
  },
  watch: {
    filteredOptions() {
      for (let e = 0; e < this.filteredOptions.length; e++)
        if (this.selectable(this.filteredOptions[e])) {
          this.typeAheadPointer = e;
          break;
        }
    },
    open(e) {
      e && this.typeAheadToLastSelected();
    },
    selectedValue() {
      this.open && this.typeAheadToLastSelected();
    }
  },
  methods: {
    typeAheadUp() {
      for (let e = this.typeAheadPointer - 1; e >= 0; e--)
        if (this.selectable(this.filteredOptions[e])) {
          this.typeAheadPointer = e;
          break;
        }
    },
    typeAheadDown() {
      for (let e = this.typeAheadPointer + 1; e < this.filteredOptions.length; e++)
        if (this.selectable(this.filteredOptions[e])) {
          this.typeAheadPointer = e;
          break;
        }
    },
    typeAheadSelect() {
      const e = this.filteredOptions[this.typeAheadPointer];
      e && this.selectable(e) && this.select(e);
    },
    typeAheadToLastSelected() {
      this.typeAheadPointer = this.selectedValue.length !== 0 ? this.filteredOptions.indexOf(this.selectedValue[this.selectedValue.length - 1]) : -1;
    }
  }
}, J = {
  props: {
    loading: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      mutableLoading: !1
    };
  },
  watch: {
    search() {
      this.$emit("search", this.search, this.toggleLoading);
    },
    loading(e) {
      this.mutableLoading = e;
    }
  },
  methods: {
    toggleLoading(e = null) {
      return e == null ? this.mutableLoading = !this.mutableLoading : this.mutableLoading = e;
    }
  }
}, S$2 = (e, j) => {
  const ke = e.__vccOpts || e;
  for (const [Se, xe] of j)
    ke[Se] = xe;
  return ke;
}, H$1 = {}, X$1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "10"
}, Y$1 = /* @__PURE__ */ createElementVNode("path", { d: "M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z" }, null, -1), Q$1 = [
  Y$1
];
function G$1(e, j) {
  return openBlock(), createElementBlock("svg", X$1, Q$1);
}
const W$1 = /* @__PURE__ */ S$2(H$1, [["render", G$1]]), Z$1 = {}, ee$1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "10"
}, te$1 = /* @__PURE__ */ createElementVNode("path", { d: "M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z" }, null, -1), se = [
  te$1
];
function ie(e, j) {
  return openBlock(), createElementBlock("svg", ee$1, se);
}
const oe$1 = /* @__PURE__ */ S$2(Z$1, [["render", ie]]), T$1 = {
  Deselect: W$1,
  OpenIndicator: oe$1
}, ne = {
  mounted(e, { instance: j }) {
    if (j.appendToBody) {
      const {
        height: ke,
        top: Se,
        left: xe,
        width: Ie
      } = j.$refs.toggle.getBoundingClientRect();
      let Me = window.scrollX || window.pageXOffset, Ee = window.scrollY || window.pageYOffset;
      e.unbindPosition = j.calculatePosition(e, j, {
        width: Ie + "px",
        left: Me + xe + "px",
        top: Ee + Se + ke + "px"
      }), document.body.appendChild(e);
    }
  },
  unmounted(e, { instance: j }) {
    j.appendToBody && (e.unbindPosition && typeof e.unbindPosition == "function" && e.unbindPosition(), e.parentNode && e.parentNode.removeChild(e));
  }
};
function le$1(e) {
  const j = {};
  return Object.keys(e).sort().forEach((ke) => {
    j[ke] = e[ke];
  }), JSON.stringify(j);
}
let ae$1 = 0;
function re$1() {
  return ++ae$1;
}
const de$1 = {
  components: f$1({}, T$1),
  directives: { appendToBody: ne },
  mixins: [U, q$1, J],
  compatConfig: {
    MODE: 3
  },
  emits: [
    "open",
    "close",
    "update:modelValue",
    "search",
    "search:compositionstart",
    "search:compositionend",
    "search:keydown",
    "search:blur",
    "search:focus",
    "search:input",
    "option:created",
    "option:selecting",
    "option:selected",
    "option:deselecting",
    "option:deselected"
  ],
  props: {
    modelValue: {},
    components: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    clearable: {
      type: Boolean,
      default: !0
    },
    deselectFromDropdown: {
      type: Boolean,
      default: !1
    },
    searchable: {
      type: Boolean,
      default: !0
    },
    multiple: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    transition: {
      type: String,
      default: "vs__fade"
    },
    clearSearchOnSelect: {
      type: Boolean,
      default: !0
    },
    closeOnSelect: {
      type: Boolean,
      default: !0
    },
    label: {
      type: String,
      default: "label"
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    reduce: {
      type: Function,
      default: (e) => e
    },
    selectable: {
      type: Function,
      default: (e) => !0
    },
    getOptionLabel: {
      type: Function,
      default(e) {
        return typeof e == "object" ? e.hasOwnProperty(this.label) ? e[this.label] : console.warn(`[vue-select warn]: Label key "option.${this.label}" does not exist in options object ${JSON.stringify(e)}.
https://vue-select.org/api/props.html#getoptionlabel`) : e;
      }
    },
    getOptionKey: {
      type: Function,
      default(e) {
        if (typeof e != "object")
          return e;
        try {
          return e.hasOwnProperty("id") ? e.id : le$1(e);
        } catch (j) {
          return console.warn(`[vue-select warn]: Could not stringify this option to generate unique key. Please provide'getOptionKey' prop to return a unique key for each option.
https://vue-select.org/api/props.html#getoptionkey`, e, j);
        }
      }
    },
    onTab: {
      type: Function,
      default: function() {
        this.selectOnTab && !this.isComposing && this.typeAheadSelect();
      }
    },
    taggable: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      type: Number,
      default: null
    },
    pushTags: {
      type: Boolean,
      default: !1
    },
    filterable: {
      type: Boolean,
      default: !0
    },
    filterBy: {
      type: Function,
      default(e, j, ke) {
        return (j || "").toLocaleLowerCase().indexOf(ke.toLocaleLowerCase()) > -1;
      }
    },
    filter: {
      type: Function,
      default(e, j) {
        return e.filter((ke) => {
          let Se = this.getOptionLabel(ke);
          return typeof Se == "number" && (Se = Se.toString()), this.filterBy(ke, Se, j);
        });
      }
    },
    createOption: {
      type: Function,
      default(e) {
        return typeof this.optionList[0] == "object" ? { [this.label]: e } : e;
      }
    },
    resetOnOptionsChange: {
      default: !1,
      validator: (e) => ["function", "boolean"].includes(typeof e)
    },
    clearSearchOnBlur: {
      type: Function,
      default: function({ clearSearchOnSelect: e, multiple: j }) {
        return e && !j;
      }
    },
    noDrop: {
      type: Boolean,
      default: !1
    },
    inputId: {
      type: String
    },
    dir: {
      type: String,
      default: "auto"
    },
    selectOnTab: {
      type: Boolean,
      default: !1
    },
    selectOnKeyCodes: {
      type: Array,
      default: () => [13]
    },
    searchInputQuerySelector: {
      type: String,
      default: "[type=search]"
    },
    mapKeydown: {
      type: Function,
      default: (e, j) => e
    },
    appendToBody: {
      type: Boolean,
      default: !1
    },
    calculatePosition: {
      type: Function,
      default(e, j, { width: ke, top: Se, left: xe }) {
        e.style.top = Se, e.style.left = xe, e.style.width = ke;
      }
    },
    dropdownShouldOpen: {
      type: Function,
      default({ noDrop: e, open: j, mutableLoading: ke }) {
        return e ? !1 : j && !ke;
      }
    },
    uid: {
      type: [String, Number],
      default: () => re$1()
    }
  },
  data() {
    return {
      search: "",
      open: !1,
      isComposing: !1,
      pushedTags: [],
      _value: [],
      deselectButtons: []
    };
  },
  computed: {
    isReducingValues() {
      return this.$props.reduce !== this.$options.props.reduce.default;
    },
    isTrackingValues() {
      return typeof this.modelValue > "u" || this.isReducingValues;
    },
    selectedValue() {
      let e = this.modelValue;
      return this.isTrackingValues && (e = this.$data._value), e != null && e !== "" ? [].concat(e) : [];
    },
    optionList() {
      return this.options.concat(this.pushTags ? this.pushedTags : []);
    },
    searchEl() {
      return this.$slots.search ? this.$refs.selectedOptions.querySelector(this.searchInputQuerySelector) : this.$refs.search;
    },
    scope() {
      const e = {
        search: this.search,
        loading: this.loading,
        searching: this.searching,
        filteredOptions: this.filteredOptions
      };
      return {
        search: {
          attributes: f$1({
            disabled: this.disabled,
            placeholder: this.searchPlaceholder,
            tabindex: this.tabindex,
            readonly: !this.searchable,
            id: this.inputId,
            "aria-autocomplete": "list",
            "aria-labelledby": `vs${this.uid}__combobox`,
            "aria-controls": `vs${this.uid}__listbox`,
            ref: "search",
            type: "search",
            autocomplete: this.autocomplete,
            value: this.search
          }, this.dropdownOpen && this.filteredOptions[this.typeAheadPointer] ? {
            "aria-activedescendant": `vs${this.uid}__option-${this.typeAheadPointer}`
          } : {}),
          events: {
            compositionstart: () => this.isComposing = !0,
            compositionend: () => this.isComposing = !1,
            keydown: this.onSearchKeyDown,
            blur: this.onSearchBlur,
            focus: this.onSearchFocus,
            input: (j) => this.search = j.target.value
          }
        },
        spinner: {
          loading: this.mutableLoading
        },
        noOptions: {
          search: this.search,
          loading: this.mutableLoading,
          searching: this.searching
        },
        openIndicator: {
          attributes: {
            ref: "openIndicator",
            role: "presentation",
            class: "vs__open-indicator"
          }
        },
        listHeader: e,
        listFooter: e,
        header: m$2(f$1({}, e), { deselect: this.deselect }),
        footer: m$2(f$1({}, e), { deselect: this.deselect })
      };
    },
    childComponents() {
      return f$1(f$1({}, T$1), this.components);
    },
    stateClasses() {
      return {
        "vs--open": this.dropdownOpen,
        "vs--single": !this.multiple,
        "vs--multiple": this.multiple,
        "vs--searching": this.searching && !this.noDrop,
        "vs--searchable": this.searchable && !this.noDrop,
        "vs--unsearchable": !this.searchable,
        "vs--loading": this.mutableLoading,
        "vs--disabled": this.disabled
      };
    },
    searching() {
      return !!this.search;
    },
    dropdownOpen() {
      return this.dropdownShouldOpen(this);
    },
    searchPlaceholder() {
      return this.isValueEmpty && this.placeholder ? this.placeholder : void 0;
    },
    filteredOptions() {
      const e = [].concat(this.optionList);
      if (!this.filterable && !this.taggable)
        return e;
      const j = this.search.length ? this.filter(e, this.search, this) : e;
      if (this.taggable && this.search.length) {
        const ke = this.createOption(this.search);
        this.optionExists(ke) || j.unshift(ke);
      }
      return j;
    },
    isValueEmpty() {
      return this.selectedValue.length === 0;
    },
    showClearButton() {
      return !this.multiple && this.clearable && !this.open && !this.isValueEmpty;
    }
  },
  watch: {
    options(e, j) {
      const ke = () => typeof this.resetOnOptionsChange == "function" ? this.resetOnOptionsChange(e, j, this.selectedValue) : this.resetOnOptionsChange;
      !this.taggable && ke() && this.clearSelection(), this.modelValue && this.isTrackingValues && this.setInternalValueFromOptions(this.modelValue);
    },
    modelValue: {
      immediate: !0,
      handler(e) {
        this.isTrackingValues && this.setInternalValueFromOptions(e);
      }
    },
    multiple() {
      this.clearSelection();
    },
    open(e) {
      this.$emit(e ? "open" : "close");
    }
  },
  created() {
    this.mutableLoading = this.loading;
  },
  methods: {
    setInternalValueFromOptions(e) {
      Array.isArray(e) ? this.$data._value = e.map((j) => this.findOptionFromReducedValue(j)) : this.$data._value = this.findOptionFromReducedValue(e);
    },
    select(e) {
      this.$emit("option:selecting", e), this.isOptionSelected(e) ? this.deselectFromDropdown && (this.clearable || this.multiple && this.selectedValue.length > 1) && this.deselect(e) : (this.taggable && !this.optionExists(e) && (this.$emit("option:created", e), this.pushTag(e)), this.multiple && (e = this.selectedValue.concat(e)), this.updateValue(e), this.$emit("option:selected", e)), this.onAfterSelect(e);
    },
    deselect(e) {
      this.$emit("option:deselecting", e), this.updateValue(this.selectedValue.filter((j) => !this.optionComparator(j, e))), this.$emit("option:deselected", e);
    },
    clearSelection() {
      this.updateValue(this.multiple ? [] : null);
    },
    onAfterSelect(e) {
      this.closeOnSelect && (this.open = !this.open, this.searchEl.blur()), this.clearSearchOnSelect && (this.search = "");
    },
    updateValue(e) {
      typeof this.modelValue > "u" && (this.$data._value = e), e !== null && (Array.isArray(e) ? e = e.map((j) => this.reduce(j)) : e = this.reduce(e)), this.$emit("update:modelValue", e);
    },
    toggleDropdown(e) {
      const j = e.target !== this.searchEl;
      j && e.preventDefault();
      const ke = [
        ...this.deselectButtons || [],
        this.$refs.clearButton
      ];
      if (this.searchEl === void 0 || ke.filter(Boolean).some((Se) => Se.contains(e.target) || Se === e.target)) {
        e.preventDefault();
        return;
      }
      this.open && j ? this.searchEl.blur() : this.disabled || (this.open = !0, this.searchEl.focus());
    },
    isOptionSelected(e) {
      return this.selectedValue.some((j) => this.optionComparator(j, e));
    },
    isOptionDeselectable(e) {
      return this.isOptionSelected(e) && this.deselectFromDropdown;
    },
    optionComparator(e, j) {
      return this.getOptionKey(e) === this.getOptionKey(j);
    },
    findOptionFromReducedValue(e) {
      const j = (Se) => JSON.stringify(this.reduce(Se)) === JSON.stringify(e), ke = [...this.options, ...this.pushedTags].filter(j);
      return ke.length === 1 ? ke[0] : ke.find((Se) => this.optionComparator(Se, this.$data._value)) || e;
    },
    closeSearchOptions() {
      this.open = !1, this.$emit("search:blur");
    },
    maybeDeleteValue() {
      if (!this.searchEl.value.length && this.selectedValue && this.selectedValue.length && this.clearable) {
        let e = null;
        this.multiple && (e = [
          ...this.selectedValue.slice(0, this.selectedValue.length - 1)
        ]), this.updateValue(e);
      }
    },
    optionExists(e) {
      return this.optionList.some((j) => this.optionComparator(j, e));
    },
    normalizeOptionForSlot(e) {
      return typeof e == "object" ? e : { [this.label]: e };
    },
    pushTag(e) {
      this.pushedTags.push(e);
    },
    onEscape() {
      this.search.length ? this.search = "" : this.searchEl.blur();
    },
    onSearchBlur() {
      if (this.mousedown && !this.searching)
        this.mousedown = !1;
      else {
        const { clearSearchOnSelect: e, multiple: j } = this;
        this.clearSearchOnBlur({ clearSearchOnSelect: e, multiple: j }) && (this.search = ""), this.closeSearchOptions();
        return;
      }
      if (this.search.length === 0 && this.options.length === 0) {
        this.closeSearchOptions();
        return;
      }
    },
    onSearchFocus() {
      this.open = !0, this.$emit("search:focus");
    },
    onMousedown() {
      this.mousedown = !0;
    },
    onMouseUp() {
      this.mousedown = !1;
    },
    onSearchKeyDown(e) {
      const j = (xe) => (xe.preventDefault(), !this.isComposing && this.typeAheadSelect()), ke = {
        8: (xe) => this.maybeDeleteValue(),
        9: (xe) => this.onTab(),
        27: (xe) => this.onEscape(),
        38: (xe) => (xe.preventDefault(), this.typeAheadUp()),
        40: (xe) => (xe.preventDefault(), this.typeAheadDown())
      };
      this.selectOnKeyCodes.forEach((xe) => ke[xe] = j);
      const Se = this.mapKeydown(ke, this);
      if (typeof Se[e.keyCode] == "function")
        return Se[e.keyCode](e);
    }
  }
}, he$1 = ["dir"], ce$1 = ["id", "aria-expanded", "aria-owns"], ue$1 = {
  ref: "selectedOptions",
  class: "vs__selected-options"
}, pe$1 = ["disabled", "title", "aria-label", "onClick"], fe$1 = {
  ref: "actions",
  class: "vs__actions"
}, ge = ["disabled"], ye = { class: "vs__spinner" }, me$1 = ["id"], be = ["id", "aria-selected", "onMouseover", "onClick"], _e$1 = {
  key: 0,
  class: "vs__no-options"
}, Oe = /* @__PURE__ */ createTextVNode(" Sorry, no matching options. "), we = ["id"];
function ve(e, j, ke, Se, xe, Ie) {
  const Me = resolveDirective("append-to-body");
  return openBlock(), createElementBlock("div", {
    dir: ke.dir,
    class: normalizeClass(["v-select", Ie.stateClasses])
  }, [
    renderSlot(e.$slots, "header", normalizeProps(guardReactiveProps(Ie.scope.header))),
    createElementVNode("div", {
      id: `vs${ke.uid}__combobox`,
      ref: "toggle",
      class: "vs__dropdown-toggle",
      role: "combobox",
      "aria-expanded": Ie.dropdownOpen.toString(),
      "aria-owns": `vs${ke.uid}__listbox`,
      "aria-label": "Search for option",
      onMousedown: j[1] || (j[1] = (Ee) => Ie.toggleDropdown(Ee))
    }, [
      createElementVNode("div", ue$1, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(Ie.selectedValue, (Ee, Be) => renderSlot(e.$slots, "selected-option-container", {
          option: Ie.normalizeOptionForSlot(Ee),
          deselect: Ie.deselect,
          multiple: ke.multiple,
          disabled: ke.disabled
        }, () => [
          (openBlock(), createElementBlock("span", {
            key: ke.getOptionKey(Ee),
            class: "vs__selected"
          }, [
            renderSlot(e.$slots, "selected-option", normalizeProps(guardReactiveProps(Ie.normalizeOptionForSlot(Ee))), () => [
              createTextVNode(toDisplayString(ke.getOptionLabel(Ee)), 1)
            ]),
            ke.multiple ? (openBlock(), createElementBlock("button", {
              key: 0,
              ref_for: !0,
              ref: ($e) => xe.deselectButtons[Be] = $e,
              disabled: ke.disabled,
              type: "button",
              class: "vs__deselect",
              title: `Deselect ${ke.getOptionLabel(Ee)}`,
              "aria-label": `Deselect ${ke.getOptionLabel(Ee)}`,
              onClick: ($e) => Ie.deselect(Ee)
            }, [
              (openBlock(), createBlock(resolveDynamicComponent(Ie.childComponents.Deselect)))
            ], 8, pe$1)) : createCommentVNode("", !0)
          ]))
        ])), 256)),
        renderSlot(e.$slots, "search", normalizeProps(guardReactiveProps(Ie.scope.search)), () => [
          createElementVNode("input", mergeProps({ class: "vs__search" }, Ie.scope.search.attributes, toHandlers(Ie.scope.search.events)), null, 16)
        ])
      ], 512),
      createElementVNode("div", fe$1, [
        withDirectives(createElementVNode("button", {
          ref: "clearButton",
          disabled: ke.disabled,
          type: "button",
          class: "vs__clear",
          title: "Clear Selected",
          "aria-label": "Clear Selected",
          onClick: j[0] || (j[0] = (...Ee) => Ie.clearSelection && Ie.clearSelection(...Ee))
        }, [
          (openBlock(), createBlock(resolveDynamicComponent(Ie.childComponents.Deselect)))
        ], 8, ge), [
          [vShow, Ie.showClearButton]
        ]),
        renderSlot(e.$slots, "open-indicator", normalizeProps(guardReactiveProps(Ie.scope.openIndicator)), () => [
          ke.noDrop ? createCommentVNode("", !0) : (openBlock(), createBlock(resolveDynamicComponent(Ie.childComponents.OpenIndicator), normalizeProps(mergeProps({ key: 0 }, Ie.scope.openIndicator.attributes)), null, 16))
        ]),
        renderSlot(e.$slots, "spinner", normalizeProps(guardReactiveProps(Ie.scope.spinner)), () => [
          withDirectives(createElementVNode("div", ye, "Loading...", 512), [
            [vShow, e.mutableLoading]
          ])
        ])
      ], 512)
    ], 40, ce$1),
    createVNode(Transition, { name: ke.transition }, {
      default: withCtx(() => [
        Ie.dropdownOpen ? withDirectives((openBlock(), createElementBlock("ul", {
          id: `vs${ke.uid}__listbox`,
          ref: "dropdownMenu",
          key: `vs${ke.uid}__listbox`,
          class: "vs__dropdown-menu",
          role: "listbox",
          tabindex: "-1",
          onMousedown: j[2] || (j[2] = withModifiers((...Ee) => Ie.onMousedown && Ie.onMousedown(...Ee), ["prevent"])),
          onMouseup: j[3] || (j[3] = (...Ee) => Ie.onMouseUp && Ie.onMouseUp(...Ee))
        }, [
          renderSlot(e.$slots, "list-header", normalizeProps(guardReactiveProps(Ie.scope.listHeader))),
          (openBlock(!0), createElementBlock(Fragment, null, renderList(Ie.filteredOptions, (Ee, Be) => (openBlock(), createElementBlock("li", {
            id: `vs${ke.uid}__option-${Be}`,
            key: ke.getOptionKey(Ee),
            role: "option",
            class: normalizeClass(["vs__dropdown-option", {
              "vs__dropdown-option--deselect": Ie.isOptionDeselectable(Ee) && Be === e.typeAheadPointer,
              "vs__dropdown-option--selected": Ie.isOptionSelected(Ee),
              "vs__dropdown-option--highlight": Be === e.typeAheadPointer,
              "vs__dropdown-option--disabled": !ke.selectable(Ee)
            }]),
            "aria-selected": Be === e.typeAheadPointer ? !0 : null,
            onMouseover: ($e) => ke.selectable(Ee) ? e.typeAheadPointer = Be : null,
            onClick: withModifiers(($e) => ke.selectable(Ee) ? Ie.select(Ee) : null, ["prevent", "stop"])
          }, [
            renderSlot(e.$slots, "option", normalizeProps(guardReactiveProps(Ie.normalizeOptionForSlot(Ee))), () => [
              createTextVNode(toDisplayString(ke.getOptionLabel(Ee)), 1)
            ])
          ], 42, be))), 128)),
          Ie.filteredOptions.length === 0 ? (openBlock(), createElementBlock("li", _e$1, [
            renderSlot(e.$slots, "no-options", normalizeProps(guardReactiveProps(Ie.scope.noOptions)), () => [
              Oe
            ])
          ])) : createCommentVNode("", !0),
          renderSlot(e.$slots, "list-footer", normalizeProps(guardReactiveProps(Ie.scope.listFooter)))
        ], 40, me$1)), [
          [Me]
        ]) : (openBlock(), createElementBlock("ul", {
          key: 1,
          id: `vs${ke.uid}__listbox`,
          role: "listbox",
          style: { display: "none", visibility: "hidden" }
        }, null, 8, we))
      ]),
      _: 3
    }, 8, ["name"]),
    renderSlot(e.$slots, "footer", normalizeProps(guardReactiveProps(Ie.scope.footer)))
  ], 10, he$1);
}
const Ce = /* @__PURE__ */ S$2(de$1, [["render", ve]]), _sfc_main$1H = /* @__PURE__ */ defineComponent({
  __name: "ClearSelection",
  setup(e) {
    return (j, ke) => (openBlock(), createBlock(unref(SatIconButton), {
      "icon-name": "close",
      size: "extra-small"
    }));
  }
}), className$1y = "sat-select", css$1y = bemBuilder(className$1y);
bemBuilder(className$1y, !0);
var top = "top", bottom = "bottom", right = "right", left = "left", auto = "auto", basePlacements = [top, bottom, right, left], start = "start", end = "end", clippingParents = "clippingParents", viewport = "viewport", popper = "popper", reference = "reference", variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(e, j) {
  return e.concat([j + "-" + start, j + "-" + end]);
}, []), placements$1 = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(e, j) {
  return e.concat([j, j + "-" + start, j + "-" + end]);
}, []), beforeRead = "beforeRead", read = "read", afterRead = "afterRead", beforeMain = "beforeMain", main = "main", afterMain = "afterMain", beforeWrite = "beforeWrite", write = "write", afterWrite = "afterWrite", modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
function getNodeName(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function getWindow(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var j = e.ownerDocument;
    return j && j.defaultView || window;
  }
  return e;
}
function isElement(e) {
  var j = getWindow(e).Element;
  return e instanceof j || e instanceof Element;
}
function isHTMLElement$1(e) {
  var j = getWindow(e).HTMLElement;
  return e instanceof j || e instanceof HTMLElement;
}
function isShadowRoot(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var j = getWindow(e).ShadowRoot;
  return e instanceof j || e instanceof ShadowRoot;
}
function applyStyles(e) {
  var j = e.state;
  Object.keys(j.elements).forEach(function(ke) {
    var Se = j.styles[ke] || {}, xe = j.attributes[ke] || {}, Ie = j.elements[ke];
    !isHTMLElement$1(Ie) || !getNodeName(Ie) || (Object.assign(Ie.style, Se), Object.keys(xe).forEach(function(Me) {
      var Ee = xe[Me];
      Ee === !1 ? Ie.removeAttribute(Me) : Ie.setAttribute(Me, Ee === !0 ? "" : Ee);
    }));
  });
}
function effect$2(e) {
  var j = e.state, ke = {
    popper: {
      position: j.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(j.elements.popper.style, ke.popper), j.styles = ke, j.elements.arrow && Object.assign(j.elements.arrow.style, ke.arrow), function() {
    Object.keys(j.elements).forEach(function(Se) {
      var xe = j.elements[Se], Ie = j.attributes[Se] || {}, Me = Object.keys(j.styles.hasOwnProperty(Se) ? j.styles[Se] : ke[Se]), Ee = Me.reduce(function(Be, $e) {
        return Be[$e] = "", Be;
      }, {});
      !isHTMLElement$1(xe) || !getNodeName(xe) || (Object.assign(xe.style, Ee), Object.keys(Ie).forEach(function(Be) {
        xe.removeAttribute(Be);
      }));
    });
  };
}
const applyStyles$1 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement(e) {
  return e.split("-")[0];
}
var max$1 = Math.max, min$1 = Math.min, round = Math.round;
function getUAString() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(j) {
    return j.brand + "/" + j.version;
  }).join(" ") : navigator.userAgent;
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect(e, j, ke) {
  j === void 0 && (j = !1), ke === void 0 && (ke = !1);
  var Se = e.getBoundingClientRect(), xe = 1, Ie = 1;
  j && isHTMLElement$1(e) && (xe = e.offsetWidth > 0 && round(Se.width) / e.offsetWidth || 1, Ie = e.offsetHeight > 0 && round(Se.height) / e.offsetHeight || 1);
  var Me = isElement(e) ? getWindow(e) : window, Ee = Me.visualViewport, Be = !isLayoutViewport() && ke, $e = (Se.left + (Be && Ee ? Ee.offsetLeft : 0)) / xe, Le = (Se.top + (Be && Ee ? Ee.offsetTop : 0)) / Ie, Fe = Se.width / xe, Ve = Se.height / Ie;
  return {
    width: Fe,
    height: Ve,
    top: Le,
    right: $e + Fe,
    bottom: Le + Ve,
    left: $e,
    x: $e,
    y: Le
  };
}
function getLayoutRect(e) {
  var j = getBoundingClientRect(e), ke = e.offsetWidth, Se = e.offsetHeight;
  return Math.abs(j.width - ke) <= 1 && (ke = j.width), Math.abs(j.height - Se) <= 1 && (Se = j.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: ke,
    height: Se
  };
}
function contains(e, j) {
  var ke = j.getRootNode && j.getRootNode();
  if (e.contains(j))
    return !0;
  if (ke && isShadowRoot(ke)) {
    var Se = j;
    do {
      if (Se && e.isSameNode(Se))
        return !0;
      Se = Se.parentNode || Se.host;
    } while (Se);
  }
  return !1;
}
function getComputedStyle$1(e) {
  return getWindow(e).getComputedStyle(e);
}
function isTableElement(e) {
  return ["table", "td", "th"].indexOf(getNodeName(e)) >= 0;
}
function getDocumentElement(e) {
  return ((isElement(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function getParentNode(e) {
  return getNodeName(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (isShadowRoot(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(e)
  );
}
function getTrueOffsetParent(e) {
  return !isHTMLElement$1(e) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(e).position === "fixed" ? null : e.offsetParent;
}
function getContainingBlock(e) {
  var j = /firefox/i.test(getUAString()), ke = /Trident/i.test(getUAString());
  if (ke && isHTMLElement$1(e)) {
    var Se = getComputedStyle$1(e);
    if (Se.position === "fixed")
      return null;
  }
  var xe = getParentNode(e);
  for (isShadowRoot(xe) && (xe = xe.host); isHTMLElement$1(xe) && ["html", "body"].indexOf(getNodeName(xe)) < 0; ) {
    var Ie = getComputedStyle$1(xe);
    if (Ie.transform !== "none" || Ie.perspective !== "none" || Ie.contain === "paint" || ["transform", "perspective"].indexOf(Ie.willChange) !== -1 || j && Ie.willChange === "filter" || j && Ie.filter && Ie.filter !== "none")
      return xe;
    xe = xe.parentNode;
  }
  return null;
}
function getOffsetParent(e) {
  for (var j = getWindow(e), ke = getTrueOffsetParent(e); ke && isTableElement(ke) && getComputedStyle$1(ke).position === "static"; )
    ke = getTrueOffsetParent(ke);
  return ke && (getNodeName(ke) === "html" || getNodeName(ke) === "body" && getComputedStyle$1(ke).position === "static") ? j : ke || getContainingBlock(e) || j;
}
function getMainAxisFromPlacement(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function within(e, j, ke) {
  return max$1(e, min$1(j, ke));
}
function withinMaxClamp(e, j, ke) {
  var Se = within(e, j, ke);
  return Se > ke ? ke : Se;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(e) {
  return Object.assign({}, getFreshSideObject(), e);
}
function expandToHashMap(e, j) {
  return j.reduce(function(ke, Se) {
    return ke[Se] = e, ke;
  }, {});
}
var toPaddingObject = function(j, ke) {
  return j = typeof j == "function" ? j(Object.assign({}, ke.rects, {
    placement: ke.placement
  })) : j, mergePaddingObject(typeof j != "number" ? j : expandToHashMap(j, basePlacements));
};
function arrow$1(e) {
  var j, ke = e.state, Se = e.name, xe = e.options, Ie = ke.elements.arrow, Me = ke.modifiersData.popperOffsets, Ee = getBasePlacement(ke.placement), Be = getMainAxisFromPlacement(Ee), $e = [left, right].indexOf(Ee) >= 0, Le = $e ? "height" : "width";
  if (!(!Ie || !Me)) {
    var Fe = toPaddingObject(xe.padding, ke), Ve = getLayoutRect(Ie), je = Be === "y" ? top : left, Ge = Be === "y" ? bottom : right, De = ke.rects.reference[Le] + ke.rects.reference[Be] - Me[Be] - ke.rects.popper[Le], Ue = Me[Be] - ke.rects.reference[Be], Re = getOffsetParent(Ie), Ye = Re ? Be === "y" ? Re.clientHeight || 0 : Re.clientWidth || 0 : 0, We = De / 2 - Ue / 2, qe = Fe[je], Je = Ye - Ve[Le] - Fe[Ge], Ke = Ye / 2 - Ve[Le] / 2 + We, xt = within(qe, Ke, Je), Ct = Be;
    ke.modifiersData[Se] = (j = {}, j[Ct] = xt, j.centerOffset = xt - Ke, j);
  }
}
function effect$1(e) {
  var j = e.state, ke = e.options, Se = ke.element, xe = Se === void 0 ? "[data-popper-arrow]" : Se;
  xe != null && (typeof xe == "string" && (xe = j.elements.popper.querySelector(xe), !xe) || contains(j.elements.popper, xe) && (j.elements.arrow = xe));
}
const arrow$2 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: arrow$1,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(e) {
  return e.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(e, j) {
  var ke = e.x, Se = e.y, xe = j.devicePixelRatio || 1;
  return {
    x: round(ke * xe) / xe || 0,
    y: round(Se * xe) / xe || 0
  };
}
function mapToStyles(e) {
  var j, ke = e.popper, Se = e.popperRect, xe = e.placement, Ie = e.variation, Me = e.offsets, Ee = e.position, Be = e.gpuAcceleration, $e = e.adaptive, Le = e.roundOffsets, Fe = e.isFixed, Ve = Me.x, je = Ve === void 0 ? 0 : Ve, Ge = Me.y, De = Ge === void 0 ? 0 : Ge, Ue = typeof Le == "function" ? Le({
    x: je,
    y: De
  }) : {
    x: je,
    y: De
  };
  je = Ue.x, De = Ue.y;
  var Re = Me.hasOwnProperty("x"), Ye = Me.hasOwnProperty("y"), We = left, qe = top, Je = window;
  if ($e) {
    var Ke = getOffsetParent(ke), xt = "clientHeight", Ct = "clientWidth";
    if (Ke === getWindow(ke) && (Ke = getDocumentElement(ke), getComputedStyle$1(Ke).position !== "static" && Ee === "absolute" && (xt = "scrollHeight", Ct = "scrollWidth")), Ke = Ke, xe === top || (xe === left || xe === right) && Ie === end) {
      qe = bottom;
      var It = Fe && Ke === Je && Je.visualViewport ? Je.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        Ke[xt]
      );
      De -= It - Se.height, De *= Be ? 1 : -1;
    }
    if (xe === left || (xe === top || xe === bottom) && Ie === end) {
      We = right;
      var Nt = Fe && Ke === Je && Je.visualViewport ? Je.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        Ke[Ct]
      );
      je -= Nt - Se.width, je *= Be ? 1 : -1;
    }
  }
  var Bt = Object.assign({
    position: Ee
  }, $e && unsetSides), At = Le === !0 ? roundOffsetsByDPR({
    x: je,
    y: De
  }, getWindow(ke)) : {
    x: je,
    y: De
  };
  if (je = At.x, De = At.y, Be) {
    var Ft;
    return Object.assign({}, Bt, (Ft = {}, Ft[qe] = Ye ? "0" : "", Ft[We] = Re ? "0" : "", Ft.transform = (Je.devicePixelRatio || 1) <= 1 ? "translate(" + je + "px, " + De + "px)" : "translate3d(" + je + "px, " + De + "px, 0)", Ft));
  }
  return Object.assign({}, Bt, (j = {}, j[qe] = Ye ? De + "px" : "", j[We] = Re ? je + "px" : "", j.transform = "", j));
}
function computeStyles(e) {
  var j = e.state, ke = e.options, Se = ke.gpuAcceleration, xe = Se === void 0 ? !0 : Se, Ie = ke.adaptive, Me = Ie === void 0 ? !0 : Ie, Ee = ke.roundOffsets, Be = Ee === void 0 ? !0 : Ee, $e = {
    placement: getBasePlacement(j.placement),
    variation: getVariation(j.placement),
    popper: j.elements.popper,
    popperRect: j.rects.popper,
    gpuAcceleration: xe,
    isFixed: j.options.strategy === "fixed"
  };
  j.modifiersData.popperOffsets != null && (j.styles.popper = Object.assign({}, j.styles.popper, mapToStyles(Object.assign({}, $e, {
    offsets: j.modifiersData.popperOffsets,
    position: j.options.strategy,
    adaptive: Me,
    roundOffsets: Be
  })))), j.modifiersData.arrow != null && (j.styles.arrow = Object.assign({}, j.styles.arrow, mapToStyles(Object.assign({}, $e, {
    offsets: j.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: Be
  })))), j.attributes.popper = Object.assign({}, j.attributes.popper, {
    "data-popper-placement": j.placement
  });
}
const computeStyles$1 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: !0
};
function effect(e) {
  var j = e.state, ke = e.instance, Se = e.options, xe = Se.scroll, Ie = xe === void 0 ? !0 : xe, Me = Se.resize, Ee = Me === void 0 ? !0 : Me, Be = getWindow(j.elements.popper), $e = [].concat(j.scrollParents.reference, j.scrollParents.popper);
  return Ie && $e.forEach(function(Le) {
    Le.addEventListener("scroll", ke.update, passive);
  }), Ee && Be.addEventListener("resize", ke.update, passive), function() {
    Ie && $e.forEach(function(Le) {
      Le.removeEventListener("scroll", ke.update, passive);
    }), Ee && Be.removeEventListener("resize", ke.update, passive);
  };
}
const eventListeners = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect,
  data: {}
};
var hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement$1(e) {
  return e.replace(/left|right|bottom|top/g, function(j) {
    return hash$1[j];
  });
}
var hash = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(e) {
  return e.replace(/start|end/g, function(j) {
    return hash[j];
  });
}
function getWindowScroll(e) {
  var j = getWindow(e), ke = j.pageXOffset, Se = j.pageYOffset;
  return {
    scrollLeft: ke,
    scrollTop: Se
  };
}
function getWindowScrollBarX(e) {
  return getBoundingClientRect(getDocumentElement(e)).left + getWindowScroll(e).scrollLeft;
}
function getViewportRect(e, j) {
  var ke = getWindow(e), Se = getDocumentElement(e), xe = ke.visualViewport, Ie = Se.clientWidth, Me = Se.clientHeight, Ee = 0, Be = 0;
  if (xe) {
    Ie = xe.width, Me = xe.height;
    var $e = isLayoutViewport();
    ($e || !$e && j === "fixed") && (Ee = xe.offsetLeft, Be = xe.offsetTop);
  }
  return {
    width: Ie,
    height: Me,
    x: Ee + getWindowScrollBarX(e),
    y: Be
  };
}
function getDocumentRect(e) {
  var j, ke = getDocumentElement(e), Se = getWindowScroll(e), xe = (j = e.ownerDocument) == null ? void 0 : j.body, Ie = max$1(ke.scrollWidth, ke.clientWidth, xe ? xe.scrollWidth : 0, xe ? xe.clientWidth : 0), Me = max$1(ke.scrollHeight, ke.clientHeight, xe ? xe.scrollHeight : 0, xe ? xe.clientHeight : 0), Ee = -Se.scrollLeft + getWindowScrollBarX(e), Be = -Se.scrollTop;
  return getComputedStyle$1(xe || ke).direction === "rtl" && (Ee += max$1(ke.clientWidth, xe ? xe.clientWidth : 0) - Ie), {
    width: Ie,
    height: Me,
    x: Ee,
    y: Be
  };
}
function isScrollParent(e) {
  var j = getComputedStyle$1(e), ke = j.overflow, Se = j.overflowX, xe = j.overflowY;
  return /auto|scroll|overlay|hidden/.test(ke + xe + Se);
}
function getScrollParent(e) {
  return ["html", "body", "#document"].indexOf(getNodeName(e)) >= 0 ? e.ownerDocument.body : isHTMLElement$1(e) && isScrollParent(e) ? e : getScrollParent(getParentNode(e));
}
function listScrollParents(e, j) {
  var ke;
  j === void 0 && (j = []);
  var Se = getScrollParent(e), xe = Se === ((ke = e.ownerDocument) == null ? void 0 : ke.body), Ie = getWindow(Se), Me = xe ? [Ie].concat(Ie.visualViewport || [], isScrollParent(Se) ? Se : []) : Se, Ee = j.concat(Me);
  return xe ? Ee : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    Ee.concat(listScrollParents(getParentNode(Me)))
  );
}
function rectToClientRect$1(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function getInnerBoundingClientRect(e, j) {
  var ke = getBoundingClientRect(e, !1, j === "fixed");
  return ke.top = ke.top + e.clientTop, ke.left = ke.left + e.clientLeft, ke.bottom = ke.top + e.clientHeight, ke.right = ke.left + e.clientWidth, ke.width = e.clientWidth, ke.height = e.clientHeight, ke.x = ke.left, ke.y = ke.top, ke;
}
function getClientRectFromMixedType(e, j, ke) {
  return j === viewport ? rectToClientRect$1(getViewportRect(e, ke)) : isElement(j) ? getInnerBoundingClientRect(j, ke) : rectToClientRect$1(getDocumentRect(getDocumentElement(e)));
}
function getClippingParents(e) {
  var j = listScrollParents(getParentNode(e)), ke = ["absolute", "fixed"].indexOf(getComputedStyle$1(e).position) >= 0, Se = ke && isHTMLElement$1(e) ? getOffsetParent(e) : e;
  return isElement(Se) ? j.filter(function(xe) {
    return isElement(xe) && contains(xe, Se) && getNodeName(xe) !== "body";
  }) : [];
}
function getClippingRect(e, j, ke, Se) {
  var xe = j === "clippingParents" ? getClippingParents(e) : [].concat(j), Ie = [].concat(xe, [ke]), Me = Ie[0], Ee = Ie.reduce(function(Be, $e) {
    var Le = getClientRectFromMixedType(e, $e, Se);
    return Be.top = max$1(Le.top, Be.top), Be.right = min$1(Le.right, Be.right), Be.bottom = min$1(Le.bottom, Be.bottom), Be.left = max$1(Le.left, Be.left), Be;
  }, getClientRectFromMixedType(e, Me, Se));
  return Ee.width = Ee.right - Ee.left, Ee.height = Ee.bottom - Ee.top, Ee.x = Ee.left, Ee.y = Ee.top, Ee;
}
function computeOffsets(e) {
  var j = e.reference, ke = e.element, Se = e.placement, xe = Se ? getBasePlacement(Se) : null, Ie = Se ? getVariation(Se) : null, Me = j.x + j.width / 2 - ke.width / 2, Ee = j.y + j.height / 2 - ke.height / 2, Be;
  switch (xe) {
    case top:
      Be = {
        x: Me,
        y: j.y - ke.height
      };
      break;
    case bottom:
      Be = {
        x: Me,
        y: j.y + j.height
      };
      break;
    case right:
      Be = {
        x: j.x + j.width,
        y: Ee
      };
      break;
    case left:
      Be = {
        x: j.x - ke.width,
        y: Ee
      };
      break;
    default:
      Be = {
        x: j.x,
        y: j.y
      };
  }
  var $e = xe ? getMainAxisFromPlacement(xe) : null;
  if ($e != null) {
    var Le = $e === "y" ? "height" : "width";
    switch (Ie) {
      case start:
        Be[$e] = Be[$e] - (j[Le] / 2 - ke[Le] / 2);
        break;
      case end:
        Be[$e] = Be[$e] + (j[Le] / 2 - ke[Le] / 2);
        break;
    }
  }
  return Be;
}
function detectOverflow$1(e, j) {
  j === void 0 && (j = {});
  var ke = j, Se = ke.placement, xe = Se === void 0 ? e.placement : Se, Ie = ke.strategy, Me = Ie === void 0 ? e.strategy : Ie, Ee = ke.boundary, Be = Ee === void 0 ? clippingParents : Ee, $e = ke.rootBoundary, Le = $e === void 0 ? viewport : $e, Fe = ke.elementContext, Ve = Fe === void 0 ? popper : Fe, je = ke.altBoundary, Ge = je === void 0 ? !1 : je, De = ke.padding, Ue = De === void 0 ? 0 : De, Re = mergePaddingObject(typeof Ue != "number" ? Ue : expandToHashMap(Ue, basePlacements)), Ye = Ve === popper ? reference : popper, We = e.rects.popper, qe = e.elements[Ge ? Ye : Ve], Je = getClippingRect(isElement(qe) ? qe : qe.contextElement || getDocumentElement(e.elements.popper), Be, Le, Me), Ke = getBoundingClientRect(e.elements.reference), xt = computeOffsets({
    reference: Ke,
    element: We,
    placement: xe
  }), Ct = rectToClientRect$1(Object.assign({}, We, xt)), It = Ve === popper ? Ct : Ke, Nt = {
    top: Je.top - It.top + Re.top,
    bottom: It.bottom - Je.bottom + Re.bottom,
    left: Je.left - It.left + Re.left,
    right: It.right - Je.right + Re.right
  }, Bt = e.modifiersData.offset;
  if (Ve === popper && Bt) {
    var At = Bt[xe];
    Object.keys(Nt).forEach(function(Ft) {
      var Dt = [right, bottom].indexOf(Ft) >= 0 ? 1 : -1, zt = [top, bottom].indexOf(Ft) >= 0 ? "y" : "x";
      Nt[Ft] += At[zt] * Dt;
    });
  }
  return Nt;
}
function computeAutoPlacement(e, j) {
  j === void 0 && (j = {});
  var ke = j, Se = ke.placement, xe = ke.boundary, Ie = ke.rootBoundary, Me = ke.padding, Ee = ke.flipVariations, Be = ke.allowedAutoPlacements, $e = Be === void 0 ? placements$1 : Be, Le = getVariation(Se), Fe = Le ? Ee ? variationPlacements : variationPlacements.filter(function(Ge) {
    return getVariation(Ge) === Le;
  }) : basePlacements, Ve = Fe.filter(function(Ge) {
    return $e.indexOf(Ge) >= 0;
  });
  Ve.length === 0 && (Ve = Fe);
  var je = Ve.reduce(function(Ge, De) {
    return Ge[De] = detectOverflow$1(e, {
      placement: De,
      boundary: xe,
      rootBoundary: Ie,
      padding: Me
    })[getBasePlacement(De)], Ge;
  }, {});
  return Object.keys(je).sort(function(Ge, De) {
    return je[Ge] - je[De];
  });
}
function getExpandedFallbackPlacements(e) {
  if (getBasePlacement(e) === auto)
    return [];
  var j = getOppositePlacement$1(e);
  return [getOppositeVariationPlacement(e), j, getOppositeVariationPlacement(j)];
}
function flip$1(e) {
  var j = e.state, ke = e.options, Se = e.name;
  if (!j.modifiersData[Se]._skip) {
    for (var xe = ke.mainAxis, Ie = xe === void 0 ? !0 : xe, Me = ke.altAxis, Ee = Me === void 0 ? !0 : Me, Be = ke.fallbackPlacements, $e = ke.padding, Le = ke.boundary, Fe = ke.rootBoundary, Ve = ke.altBoundary, je = ke.flipVariations, Ge = je === void 0 ? !0 : je, De = ke.allowedAutoPlacements, Ue = j.options.placement, Re = getBasePlacement(Ue), Ye = Re === Ue, We = Be || (Ye || !Ge ? [getOppositePlacement$1(Ue)] : getExpandedFallbackPlacements(Ue)), qe = [Ue].concat(We).reduce(function(Zt, Ot) {
      return Zt.concat(getBasePlacement(Ot) === auto ? computeAutoPlacement(j, {
        placement: Ot,
        boundary: Le,
        rootBoundary: Fe,
        padding: $e,
        flipVariations: Ge,
        allowedAutoPlacements: De
      }) : Ot);
    }, []), Je = j.rects.reference, Ke = j.rects.popper, xt = /* @__PURE__ */ new Map(), Ct = !0, It = qe[0], Nt = 0; Nt < qe.length; Nt++) {
      var Bt = qe[Nt], At = getBasePlacement(Bt), Ft = getVariation(Bt) === start, Dt = [top, bottom].indexOf(At) >= 0, zt = Dt ? "width" : "height", kt = detectOverflow$1(j, {
        placement: Bt,
        boundary: Le,
        rootBoundary: Fe,
        altBoundary: Ve,
        padding: $e
      }), Et = Dt ? Ft ? right : left : Ft ? bottom : top;
      Je[zt] > Ke[zt] && (Et = getOppositePlacement$1(Et));
      var Qe = getOppositePlacement$1(Et), Xe = [];
      if (Ie && Xe.push(kt[At] <= 0), Ee && Xe.push(kt[Et] <= 0, kt[Qe] <= 0), Xe.every(function(Zt) {
        return Zt;
      })) {
        It = Bt, Ct = !1;
        break;
      }
      xt.set(Bt, Xe);
    }
    if (Ct)
      for (var Vt = Ge ? 3 : 1, Lt = function(Ot) {
        var Ht = qe.find(function(Rt) {
          var jt = xt.get(Rt);
          if (jt)
            return jt.slice(0, Ot).every(function(Yt) {
              return Yt;
            });
        });
        if (Ht)
          return It = Ht, "break";
      }, Gt = Vt; Gt > 0; Gt--) {
        var Wt = Lt(Gt);
        if (Wt === "break") break;
      }
    j.placement !== It && (j.modifiersData[Se]._skip = !0, j.placement = It, j.reset = !0);
  }
}
const flip$2 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: flip$1,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function getSideOffsets(e, j, ke) {
  return ke === void 0 && (ke = {
    x: 0,
    y: 0
  }), {
    top: e.top - j.height - ke.y,
    right: e.right - j.width + ke.x,
    bottom: e.bottom - j.height + ke.y,
    left: e.left - j.width - ke.x
  };
}
function isAnySideFullyClipped(e) {
  return [top, right, bottom, left].some(function(j) {
    return e[j] >= 0;
  });
}
function hide(e) {
  var j = e.state, ke = e.name, Se = j.rects.reference, xe = j.rects.popper, Ie = j.modifiersData.preventOverflow, Me = detectOverflow$1(j, {
    elementContext: "reference"
  }), Ee = detectOverflow$1(j, {
    altBoundary: !0
  }), Be = getSideOffsets(Me, Se), $e = getSideOffsets(Ee, xe, Ie), Le = isAnySideFullyClipped(Be), Fe = isAnySideFullyClipped($e);
  j.modifiersData[ke] = {
    referenceClippingOffsets: Be,
    popperEscapeOffsets: $e,
    isReferenceHidden: Le,
    hasPopperEscaped: Fe
  }, j.attributes.popper = Object.assign({}, j.attributes.popper, {
    "data-popper-reference-hidden": Le,
    "data-popper-escaped": Fe
  });
}
const hide$1 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(e, j, ke) {
  var Se = getBasePlacement(e), xe = [left, top].indexOf(Se) >= 0 ? -1 : 1, Ie = typeof ke == "function" ? ke(Object.assign({}, j, {
    placement: e
  })) : ke, Me = Ie[0], Ee = Ie[1];
  return Me = Me || 0, Ee = (Ee || 0) * xe, [left, right].indexOf(Se) >= 0 ? {
    x: Ee,
    y: Me
  } : {
    x: Me,
    y: Ee
  };
}
function offset$1(e) {
  var j = e.state, ke = e.options, Se = e.name, xe = ke.offset, Ie = xe === void 0 ? [0, 0] : xe, Me = placements$1.reduce(function(Le, Fe) {
    return Le[Fe] = distanceAndSkiddingToXY(Fe, j.rects, Ie), Le;
  }, {}), Ee = Me[j.placement], Be = Ee.x, $e = Ee.y;
  j.modifiersData.popperOffsets != null && (j.modifiersData.popperOffsets.x += Be, j.modifiersData.popperOffsets.y += $e), j.modifiersData[Se] = Me;
}
const offset$2 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset$1
};
function popperOffsets(e) {
  var j = e.state, ke = e.name;
  j.modifiersData[ke] = computeOffsets({
    reference: j.rects.reference,
    element: j.rects.popper,
    placement: j.placement
  });
}
const popperOffsets$1 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(e) {
  return e === "x" ? "y" : "x";
}
function preventOverflow(e) {
  var j = e.state, ke = e.options, Se = e.name, xe = ke.mainAxis, Ie = xe === void 0 ? !0 : xe, Me = ke.altAxis, Ee = Me === void 0 ? !1 : Me, Be = ke.boundary, $e = ke.rootBoundary, Le = ke.altBoundary, Fe = ke.padding, Ve = ke.tether, je = Ve === void 0 ? !0 : Ve, Ge = ke.tetherOffset, De = Ge === void 0 ? 0 : Ge, Ue = detectOverflow$1(j, {
    boundary: Be,
    rootBoundary: $e,
    padding: Fe,
    altBoundary: Le
  }), Re = getBasePlacement(j.placement), Ye = getVariation(j.placement), We = !Ye, qe = getMainAxisFromPlacement(Re), Je = getAltAxis(qe), Ke = j.modifiersData.popperOffsets, xt = j.rects.reference, Ct = j.rects.popper, It = typeof De == "function" ? De(Object.assign({}, j.rects, {
    placement: j.placement
  })) : De, Nt = typeof It == "number" ? {
    mainAxis: It,
    altAxis: It
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, It), Bt = j.modifiersData.offset ? j.modifiersData.offset[j.placement] : null, At = {
    x: 0,
    y: 0
  };
  if (Ke) {
    if (Ie) {
      var Ft, Dt = qe === "y" ? top : left, zt = qe === "y" ? bottom : right, kt = qe === "y" ? "height" : "width", Et = Ke[qe], Qe = Et + Ue[Dt], Xe = Et - Ue[zt], Vt = je ? -Ct[kt] / 2 : 0, Lt = Ye === start ? xt[kt] : Ct[kt], Gt = Ye === start ? -Ct[kt] : -xt[kt], Wt = j.elements.arrow, Zt = je && Wt ? getLayoutRect(Wt) : {
        width: 0,
        height: 0
      }, Ot = j.modifiersData["arrow#persistent"] ? j.modifiersData["arrow#persistent"].padding : getFreshSideObject(), Ht = Ot[Dt], Rt = Ot[zt], jt = within(0, xt[kt], Zt[kt]), Yt = We ? xt[kt] / 2 - Vt - jt - Ht - Nt.mainAxis : Lt - jt - Ht - Nt.mainAxis, Ut = We ? -xt[kt] / 2 + Vt + jt + Rt + Nt.mainAxis : Gt + jt + Rt + Nt.mainAxis, Qt = j.elements.arrow && getOffsetParent(j.elements.arrow), Kt = Qt ? qe === "y" ? Qt.clientTop || 0 : Qt.clientLeft || 0 : 0, Jt = (Ft = Bt?.[qe]) != null ? Ft : 0, qt = Et + Yt - Jt - Kt, er = Et + Ut - Jt, rr = within(je ? min$1(Qe, qt) : Qe, Et, je ? max$1(Xe, er) : Xe);
      Ke[qe] = rr, At[qe] = rr - Et;
    }
    if (Ee) {
      var ar, ir = qe === "x" ? top : left, or = qe === "x" ? bottom : right, tr = Ke[Je], Xt = Je === "y" ? "height" : "width", lr = tr + Ue[ir], cr = tr - Ue[or], sr = [top, left].indexOf(Re) !== -1, ur = (ar = Bt?.[Je]) != null ? ar : 0, nr = sr ? lr : tr - xt[Xt] - Ct[Xt] - ur + Nt.altAxis, dr = sr ? tr + xt[Xt] + Ct[Xt] - ur - Nt.altAxis : cr, fr = je && sr ? withinMaxClamp(nr, tr, dr) : within(je ? nr : lr, tr, je ? dr : cr);
      Ke[Je] = fr, At[Je] = fr - tr;
    }
    j.modifiersData[Se] = At;
  }
}
const preventOverflow$1 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function getNodeScroll(e) {
  return e === getWindow(e) || !isHTMLElement$1(e) ? getWindowScroll(e) : getHTMLElementScroll(e);
}
function isElementScaled(e) {
  var j = e.getBoundingClientRect(), ke = round(j.width) / e.offsetWidth || 1, Se = round(j.height) / e.offsetHeight || 1;
  return ke !== 1 || Se !== 1;
}
function getCompositeRect(e, j, ke) {
  ke === void 0 && (ke = !1);
  var Se = isHTMLElement$1(j), xe = isHTMLElement$1(j) && isElementScaled(j), Ie = getDocumentElement(j), Me = getBoundingClientRect(e, xe, ke), Ee = {
    scrollLeft: 0,
    scrollTop: 0
  }, Be = {
    x: 0,
    y: 0
  };
  return (Se || !Se && !ke) && ((getNodeName(j) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  isScrollParent(Ie)) && (Ee = getNodeScroll(j)), isHTMLElement$1(j) ? (Be = getBoundingClientRect(j, !0), Be.x += j.clientLeft, Be.y += j.clientTop) : Ie && (Be.x = getWindowScrollBarX(Ie))), {
    x: Me.left + Ee.scrollLeft - Be.x,
    y: Me.top + Ee.scrollTop - Be.y,
    width: Me.width,
    height: Me.height
  };
}
function order(e) {
  var j = /* @__PURE__ */ new Map(), ke = /* @__PURE__ */ new Set(), Se = [];
  e.forEach(function(Ie) {
    j.set(Ie.name, Ie);
  });
  function xe(Ie) {
    ke.add(Ie.name);
    var Me = [].concat(Ie.requires || [], Ie.requiresIfExists || []);
    Me.forEach(function(Ee) {
      if (!ke.has(Ee)) {
        var Be = j.get(Ee);
        Be && xe(Be);
      }
    }), Se.push(Ie);
  }
  return e.forEach(function(Ie) {
    ke.has(Ie.name) || xe(Ie);
  }), Se;
}
function orderModifiers(e) {
  var j = order(e);
  return modifierPhases.reduce(function(ke, Se) {
    return ke.concat(j.filter(function(xe) {
      return xe.phase === Se;
    }));
  }, []);
}
function debounce(e) {
  var j;
  return function() {
    return j || (j = new Promise(function(ke) {
      Promise.resolve().then(function() {
        j = void 0, ke(e());
      });
    })), j;
  };
}
function mergeByName(e) {
  var j = e.reduce(function(ke, Se) {
    var xe = ke[Se.name];
    return ke[Se.name] = xe ? Object.assign({}, xe, Se, {
      options: Object.assign({}, xe.options, Se.options),
      data: Object.assign({}, xe.data, Se.data)
    }) : Se, ke;
  }, {});
  return Object.keys(j).map(function(ke) {
    return j[ke];
  });
}
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var e = arguments.length, j = new Array(e), ke = 0; ke < e; ke++)
    j[ke] = arguments[ke];
  return !j.some(function(Se) {
    return !(Se && typeof Se.getBoundingClientRect == "function");
  });
}
function popperGenerator(e) {
  e === void 0 && (e = {});
  var j = e, ke = j.defaultModifiers, Se = ke === void 0 ? [] : ke, xe = j.defaultOptions, Ie = xe === void 0 ? DEFAULT_OPTIONS : xe;
  return function(Ee, Be, $e) {
    $e === void 0 && ($e = Ie);
    var Le = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, Ie),
      modifiersData: {},
      elements: {
        reference: Ee,
        popper: Be
      },
      attributes: {},
      styles: {}
    }, Fe = [], Ve = !1, je = {
      state: Le,
      setOptions: function(Re) {
        var Ye = typeof Re == "function" ? Re(Le.options) : Re;
        De(), Le.options = Object.assign({}, Ie, Le.options, Ye), Le.scrollParents = {
          reference: isElement(Ee) ? listScrollParents(Ee) : Ee.contextElement ? listScrollParents(Ee.contextElement) : [],
          popper: listScrollParents(Be)
        };
        var We = orderModifiers(mergeByName([].concat(Se, Le.options.modifiers)));
        return Le.orderedModifiers = We.filter(function(qe) {
          return qe.enabled;
        }), Ge(), je.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!Ve) {
          var Re = Le.elements, Ye = Re.reference, We = Re.popper;
          if (areValidElements(Ye, We)) {
            Le.rects = {
              reference: getCompositeRect(Ye, getOffsetParent(We), Le.options.strategy === "fixed"),
              popper: getLayoutRect(We)
            }, Le.reset = !1, Le.placement = Le.options.placement, Le.orderedModifiers.forEach(function(Nt) {
              return Le.modifiersData[Nt.name] = Object.assign({}, Nt.data);
            });
            for (var qe = 0; qe < Le.orderedModifiers.length; qe++) {
              if (Le.reset === !0) {
                Le.reset = !1, qe = -1;
                continue;
              }
              var Je = Le.orderedModifiers[qe], Ke = Je.fn, xt = Je.options, Ct = xt === void 0 ? {} : xt, It = Je.name;
              typeof Ke == "function" && (Le = Ke({
                state: Le,
                options: Ct,
                name: It,
                instance: je
              }) || Le);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function() {
        return new Promise(function(Ue) {
          je.forceUpdate(), Ue(Le);
        });
      }),
      destroy: function() {
        De(), Ve = !0;
      }
    };
    if (!areValidElements(Ee, Be))
      return je;
    je.setOptions($e).then(function(Ue) {
      !Ve && $e.onFirstUpdate && $e.onFirstUpdate(Ue);
    });
    function Ge() {
      Le.orderedModifiers.forEach(function(Ue) {
        var Re = Ue.name, Ye = Ue.options, We = Ye === void 0 ? {} : Ye, qe = Ue.effect;
        if (typeof qe == "function") {
          var Je = qe({
            state: Le,
            name: Re,
            instance: je,
            options: We
          }), Ke = function() {
          };
          Fe.push(Je || Ke);
        }
      });
    }
    function De() {
      Fe.forEach(function(Ue) {
        return Ue();
      }), Fe = [];
    }
    return je;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$2, flip$2, preventOverflow$1, arrow$2, hide$1], createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});
const _sfc_main$1G = /* @__PURE__ */ defineComponent({
  __name: "SatSelect",
  props: {
    options: {},
    hasErrors: { type: Boolean, default: !1 },
    placeholder: {},
    clearable: { type: Boolean, default: !1 },
    searchable: { type: Boolean, default: !1 },
    appendToBody: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    value: {},
    size: { default: "large" }
  },
  emits: ["select", "clear"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = ref(), Ie = (Ee) => {
      if (Ee) {
        Se("select", Ee);
        return;
      }
      Se("clear");
    }, Me = (Ee, Be, { width: $e }) => {
      Ee.style.width = $e;
      const Le = createPopper(Be.$refs.toggle, Ee, {
        placement: "bottom",
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, 5]
            }
          },
          {
            name: "toggleClass",
            enabled: !0,
            phase: "write",
            fn({ state: Fe }) {
              Be.$el.classList.toggle("drop-up", Fe.placement === "top");
            }
          }
        ]
      });
      return () => Le.destroy();
    };
    return watch(
      () => ke.value,
      (Ee) => {
        xe.value = Ee;
      },
      { immediate: !0 }
    ), (Ee, Be) => (openBlock(), createBlock(unref(Ce), {
      modelValue: xe.value,
      "onUpdate:modelValue": [
        Be[0] || (Be[0] = ($e) => xe.value = $e),
        Ie
      ],
      class: normalizeClass([
        unref(css$1y)(),
        unref(css$1y)("", ke.size),
        {
          [unref(css$1y)("", "error")]: ke.hasErrors,
          [unref(css$1y)("", "disabled")]: ke.disabled
        }
      ]),
      label: "name",
      options: ke.options,
      placeholder: ke.placeholder,
      clearable: ke.clearable,
      disabled: ke.disabled,
      searchable: ke.searchable,
      "append-to-body": ke.appendToBody,
      components: {
        Deselect: _sfc_main$1H
      },
      "calculate-position": ke.appendToBody ? Me : void 0
    }, {
      "open-indicator": withCtx(() => [
        createVNode(unref(_sfc_main$1Q), {
          class: normalizeClass(unref(css$1y)("open-indicator")),
          name: "caret-up",
          size: "small",
          color: "color-text-secondary"
        }, null, 8, ["class"])
      ]),
      _: 1
    }, 8, ["modelValue", "class", "options", "placeholder", "clearable", "disabled", "searchable", "append-to-body", "components", "calculate-position"]));
  }
}), SatSelect = /* @__PURE__ */ _export_sfc(_sfc_main$1G, [["__scopeId", "data-v-d57d2790"]]), className$1x = "sat-business-header", css$1x = bemBuilder(className$1x);
bemBuilder(className$1x, !0);
const _hoisted_1$x = ["href"], _sfc_main$1F = /* @__PURE__ */ defineComponent({
  __name: "SatBusinessHeader",
  props: {
    coverImage: {},
    logoLink: {},
    logoUrl: {},
    logoAlt: {},
    userLoyaltyBalance: {},
    userLoyaltyPoints: {},
    loyaltyProgram: {},
    loginLabel: {},
    loginLink: {},
    isLoggedIn: { type: Boolean },
    profileLink: {},
    hideNav: { type: Boolean }
  },
  emits: ["logoClick", "loginClick", "profileClick", "viewedLoyaltyProgram"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = (Me) => {
      Se("viewedLoyaltyProgram", Me);
    }, Ie = computed(() => ke.userLoyaltyPoints ? ke.userLoyaltyPoints.toString() : toMoney(
      ke.userLoyaltyBalance?.value ?? 0,
      ke.userLoyaltyBalance?.currency
    ));
    return (Me, Ee) => (openBlock(), createElementBlock("div", {
      class: normalizeClass([unref(css$1x)(), { [unref(css$1x)("", "without-cover")]: !ke.coverImage }])
    }, [
      ke.coverImage ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(unref(css$1x)("cover")),
        style: normalizeStyle(`background-image: url(${ke.coverImage})`)
      }, null, 6)) : createCommentVNode("", !0),
      ke.hideNav ? createCommentVNode("", !0) : withDirectives((openBlock(), createElementBlock("div", {
        key: 1,
        class: normalizeClass(unref(css$1x)("nav"))
      }, [
        createElementVNode("div", null, [
          ke.logoLink && ke.logoUrl && ke.logoAlt ? (openBlock(), createElementBlock("a", {
            key: 0,
            href: ke.logoLink,
            "data-test": "logo",
            onClick: Ee[0] || (Ee[0] = withModifiers((Be) => Se("logoClick", Be), ["prevent"]))
          }, [
            createVNode(unref(AtomImage), {
              class: normalizeClass(unref(css$1x)("logo")),
              src: ke.logoUrl,
              alt: ke.logoAlt,
              type: "circle",
              height: 49,
              width: 49
            }, null, 8, ["class", "src", "alt"])
          ], 8, _hoisted_1$x)) : createCommentVNode("", !0)
        ]),
        createElementVNode("div", {
          class: normalizeClass(unref(css$1x)("actions"))
        }, [
          renderSlot(Me.$slots, "actions", {}, void 0, !0),
          !ke.isLoggedIn && ke.loginLink && ke.loginLabel ? (openBlock(), createBlock(unref(MolButtonRound), {
            key: 0,
            "data-test": "login",
            label: ke.loginLabel,
            to: ke.loginLink,
            onClick: Ee[1] || (Ee[1] = withModifiers((Be) => Se("loginClick", Be), ["prevent"]))
          }, null, 8, ["label", "to"])) : ke.isLoggedIn ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            ke.loyaltyProgram ? (openBlock(), createBlock(unref(MolButtonRound), {
              key: 0,
              "icon-name": "diamond",
              "data-test": "loyalty",
              label: Ie.value,
              to: "",
              shadow: "",
              onClick: withModifiers(xe, ["prevent"])
            }, null, 8, ["label"])) : createCommentVNode("", !0),
            ke.profileLink ? (openBlock(), createBlock(unref(MolButtonRound), {
              key: 1,
              "data-test": "profile",
              "icon-name": "user-circle",
              to: ke.profileLink,
              shadow: "",
              onClick: Ee[2] || (Ee[2] = withModifiers((Be) => Se("profileClick", Be), ["prevent"]))
            }, null, 8, ["to"])) : createCommentVNode("", !0)
          ], 64)) : createCommentVNode("", !0)
        ], 2)
      ], 2)), [
        [unref(N$1), { zIndex: 5 }]
      ])
    ], 2));
  }
}), SatBusinessHeader = /* @__PURE__ */ _export_sfc(_sfc_main$1F, [["__scopeId", "data-v-b5377eb7"]]), className$1w = "sat-tab-navigation", css$1w = bemBuilder(className$1w);
bemBuilder(className$1w, !0);
const _hoisted_1$w = ["href", "onClick"], _sfc_main$1E = /* @__PURE__ */ defineComponent({
  __name: "SatTabNavigation",
  props: {
    items: {},
    activeItemId: {}
  },
  emits: ["back", "select"],
  setup(e, { emit: j }) {
    const ke = e, Se = j;
    return (xe, Ie) => (openBlock(), createElementBlock("nav", {
      class: normalizeClass(unref(css$1w)())
    }, [
      createVNode(unref(SatIconButton), {
        "icon-name": "back",
        size: "small",
        variant: "secondary",
        theme: "tailored",
        onClick: Ie[0] || (Ie[0] = withModifiers((Me) => Se("back", Me), ["prevent"]))
      }),
      ke.items.length ? (openBlock(), createElementBlock("ul", {
        key: 0,
        class: normalizeClass(unref(css$1w)("list"))
      }, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(ke.items, (Me) => (openBlock(), createElementBlock("li", {
          key: Me.id
        }, [
          createElementVNode("a", {
            href: Me.link,
            class: normalizeClass([
              unref(css$1w)("list-item"),
              { [unref(css$1w)("list-item", "active")]: ke.activeItemId === Me.id }
            ]),
            onClick: withModifiers((Ee) => Se("select", Me, Ee), ["prevent"])
          }, [
            createVNode(unref(AtomText), {
              class: normalizeClass(unref(css$1w)("name")),
              type: "body-bold"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(Me.name), 1)
              ]),
              _: 2
            }, 1032, ["class"]),
            Me.tagline ? (openBlock(), createBlock(unref(AtomText), {
              key: 0,
              color: "color-text-secondary",
              type: "small"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(Me.tagline), 1)
              ]),
              _: 2
            }, 1024)) : createCommentVNode("", !0)
          ], 10, _hoisted_1$w)
        ]))), 128))
      ], 2)) : createCommentVNode("", !0)
    ], 2));
  }
}), SatTabNavigation = /* @__PURE__ */ _export_sfc(_sfc_main$1E, [["__scopeId", "data-v-b894b74a"]]), className$1v = "sat-quick-add-button", css$1v = bemBuilder(className$1v);
bemBuilder(className$1v, !0);
const _sfc_main$1D = /* @__PURE__ */ defineComponent({
  __name: "SatQuickAddButton",
  props: {
    value: { default: "" },
    count: { default: 0 },
    disabled: { type: Boolean },
    showDelete: { type: Boolean, default: !0 },
    isAnimated: { type: Boolean, default: !0 },
    size: { default: "medium" }
  },
  emits: ["change", "increase", "decrease", "cleared"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = computed(() => ke.count === 0), Ie = computed(() => ke.count === 1), Me = computed(() => ke.count > 0), Ee = computed(() => ke.size === "extra-small" || ke.size === "small" ? "small-bold" : "body-bold"), Be = computed(
      () => ke.showDelete && (xe.value || Ie.value) ? "delete" : "minus"
    ), $e = (Fe) => {
      if (xe.value) return;
      const Ve = ke.count - 1;
      Se("change", Ve, ke.value, Fe), Se("decrease", Ve, ke.value, Fe), Ve === 0 && Se("cleared", ke.value, Fe);
    }, Le = (Fe) => {
      const Ve = ke.count + 1;
      Se("change", Ve, ke.value, Fe), Se("increase", Ve, ke.value, Fe);
    };
    return (Fe, Ve) => (openBlock(), createElementBlock("div", {
      class: normalizeClass([
        unref(css$1v)(),
        unref(css$1v)("", ke.size),
        {
          [unref(css$1v)("", "has-counts")]: !ke.isAnimated || Me.value,
          [unref(css$1v)("", "animated")]: ke.isAnimated
        }
      ])
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$1v)("input"))
      }, [
        (openBlock(), createBlock(unref(SatIconButton), {
          key: Be.value,
          theme: "filled",
          size: ke.size,
          "icon-name": Be.value,
          disabled: ke.disabled,
          class: normalizeClass([unref(css$1v)("icon-button"), unref(css$1v)("count", "decrease")]),
          onClick: withModifiers($e, ["prevent"])
        }, null, 8, ["size", "icon-name", "disabled", "class"])),
        createVNode(unref(AtomText), {
          class: normalizeClass(unref(css$1v)("amount")),
          type: Ee.value
        }, {
          default: withCtx(() => [
            createElementVNode("span", null, toDisplayString(ke.count), 1)
          ]),
          _: 1
        }, 8, ["class", "type"]),
        createVNode(unref(SatIconButton), {
          key: "increase",
          theme: "filled",
          size: ke.size,
          "icon-name": "plus",
          disabled: ke.disabled,
          class: normalizeClass([unref(css$1v)("icon-button"), unref(css$1v)("count", "increase")]),
          onClick: withModifiers(Le, ["prevent"])
        }, null, 8, ["size", "disabled", "class"])
      ], 2)
    ], 2));
  }
}), SatQuickAddButton = /* @__PURE__ */ _export_sfc(_sfc_main$1D, [["__scopeId", "data-v-9d3aaff2"]]), className$1u = "sat-counter", css$1u = bemBuilder(className$1u);
bemBuilder(className$1u, !0);
const className$1t = "atom-input", css$1t = bemBuilder(className$1t);
bemBuilder(className$1t, !0);
const _hoisted_1$v = ["placeholder", "value", "type", "disabled"], _sfc_main$1C = /* @__PURE__ */ defineComponent({
  __name: "AtomInput",
  props: {
    placeholder: {},
    hasError: { type: Boolean },
    value: { default: "" },
    disabled: { type: Boolean },
    type: { default: "text" },
    autofocus: { type: Boolean },
    size: { default: "large" }
  },
  emits: ["keyup", "change", "focus", "blur"],
  setup(e, { emit: j }) {
    const ke = e, Se = j;
    function xe($e) {
      ke.disabled || Se("change", $e.target.value);
    }
    function Ie($e) {
      ke.disabled || Se("keyup", $e.target.value);
    }
    function Me($e) {
      ke.disabled || Se("blur", $e.target.value);
    }
    function Ee($e) {
      ke.disabled || Se("focus", $e.target.value);
    }
    const Be = ref();
    return onMounted(() => {
      ke.autofocus && Be.value && Be.value.focus();
    }), ($e, Le) => (openBlock(), createElementBlock("div", {
      class: normalizeClass([
        unref(css$1t)(),
        {
          [unref(css$1t)("", "error")]: ke.hasError,
          [unref(css$1t)("", "disabled")]: ke.disabled
        }
      ])
    }, [
      createElementVNode("input", {
        ref_key: "inputRef",
        ref: Be,
        class: normalizeClass([unref(css$1t)("field"), unref(css$1t)("field", ke.size)]),
        placeholder: ke.placeholder,
        value: ke.value,
        type: ke.type,
        disabled: ke.disabled,
        onChange: Le[0] || (Le[0] = (Fe) => xe(Fe)),
        onKeyup: Le[1] || (Le[1] = (Fe) => Ie(Fe)),
        onFocus: Le[2] || (Le[2] = (Fe) => Ee(Fe)),
        onBlur: Le[3] || (Le[3] = (Fe) => Me(Fe))
      }, null, 42, _hoisted_1$v)
    ], 2));
  }
}), AtomInput = /* @__PURE__ */ _export_sfc(_sfc_main$1C, [["__scopeId", "data-v-4a6a7e9b"]]), _sfc_main$1B = /* @__PURE__ */ defineComponent({
  __name: "SatCounter",
  props: {
    size: { default: "large" },
    showDelete: { type: Boolean, default: !0 },
    value: { default: "" },
    count: {},
    minCount: { default: 0 },
    disabled: { type: Boolean }
  },
  emits: ["change", "increase", "decrease", "cleared"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = computed(() => ke.count === 0), Ie = computed(() => ke.count === 1), Me = computed(() => ke.count > 0), Ee = ref(ke.count.toString()), Be = computed(
      () => Ee.value === ke.minCount.toString()
    );
    watch(
      () => ke.count,
      (Ge) => {
        Ee.value = Ge.toString();
      }
    );
    const $e = (Ge) => {
      const De = Ge.replace(/\D+/g, ""), Ue = De === "" ? 0 : parseInt(De, 10);
      if (Ue < ke.minCount || De === "") {
        Ee.value = ke.minCount.toString(), Se("change", ke.minCount, ke.value);
        return;
      }
      if (Ee.value = De, Ue === 0) {
        Se("cleared", ke.value);
        return;
      }
      Se("change", Ue, ke.value);
    }, Le = computed(
      () => ke.showDelete && (xe.value || Ie.value) ? "delete" : "minus"
    ), Fe = computed(() => ({
      small: "extra-small",
      large: "medium"
    })[ke.size]), Ve = () => {
      if (xe.value) return;
      const Ge = ke.count - 1;
      if (!(Ge < ke.minCount)) {
        if (Se("decrease", Ge, ke.value), Ge === 0) {
          Se("cleared", ke.value);
          return;
        }
        Se("change", Ge, ke.value);
      }
    }, je = () => {
      const Ge = ke.count + 1;
      Se("change", Ge, ke.value), Se("increase", Ge, ke.value);
    };
    return (Ge, De) => (openBlock(), createElementBlock("div", {
      class: normalizeClass([
        unref(css$1u)(),
        unref(css$1u)("", "animated"),
        { [unref(css$1u)("", "has-counts")]: Me.value }
      ])
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$1u)("input"))
      }, [
        (openBlock(), createBlock(unref(SatIconButton), {
          key: Le.value,
          size: Fe.value,
          disabled: ke.disabled || Be.value,
          variant: "neutral",
          theme: "ghost",
          class: normalizeClass([unref(css$1u)("icon-button"), unref(css$1u)("icon-button", "decrease")]),
          "icon-name": Le.value,
          onClick: Ve
        }, null, 8, ["size", "disabled", "class", "icon-name"])),
        createVNode(AtomInput, {
          class: normalizeClass(unref(css$1u)("quantity")),
          value: Ee.value,
          size: ke.size,
          disabled: ke.disabled,
          onChange: $e
        }, null, 8, ["class", "value", "size", "disabled"]),
        createVNode(unref(SatIconButton), {
          class: normalizeClass([unref(css$1u)("icon-button"), unref(css$1u)("icon-button", "increase")]),
          disabled: ke.disabled,
          variant: "neutral",
          theme: "ghost",
          size: Fe.value,
          "icon-name": "plus",
          onClick: je
        }, null, 8, ["class", "disabled", "size"])
      ], 2)
    ], 2));
  }
}), SatCounter = /* @__PURE__ */ _export_sfc(_sfc_main$1B, [["__scopeId", "data-v-ce97d2f0"]]), className$1s = "sat-language-switcher", css$1s = bemBuilder(className$1s);
bemBuilder(className$1s, !0);
const supportedLanguages = {
  ar: "العربية",
  da: "Dansk",
  de: "Deutsch",
  en: "English",
  "en-US": "English (United States)",
  es: "Español",
  "es-419": "Español (Latinoamérica)",
  "es-MX": "Español (Mexico)",
  fr: "Français",
  it: "Italiano",
  ja: "日本語",
  ko: "한국어",
  nl: "Nederlands",
  no: "Norsk",
  pl: "Polski",
  pt: "Português",
  "pt-BR": "Português (Brasil)",
  "pt-PT": "Português (Portugal)",
  ro: "Română",
  ru: "Русский",
  th: "ไทย",
  tr: "Türkçe",
  "zh-CN": "简体中文",
  "zh-TW": "繁體中文"
}, _hoisted_1$u = ["aria-expanded"], _hoisted_2$8 = ["onClick"], _sfc_main$1A = /* @__PURE__ */ defineComponent({
  __name: "SatLanguageSwitcher",
  props: {
    languages: {},
    selected: {},
    iconName: { default: "translate" },
    color: { default: "color-text-body" },
    iconSize: { default: 24 },
    aligment: { default: "left" }
  },
  emits: ["select"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = ref(!1), Ie = ref(null), Me = () => {
      xe.value = !xe.value;
    }, Ee = ($e) => {
      Se("select", $e), xe.value = !1;
    }, Be = ($e) => {
      Ie.value && !Ie.value.contains($e.target) && (xe.value = !1);
    };
    return onMounted(() => {
      document.addEventListener("click", Be);
    }), onUnmounted(() => {
      document.removeEventListener("click", Be);
    }), ($e, Le) => (openBlock(), createElementBlock("div", {
      ref_key: "dropdownRef",
      ref: Ie,
      class: normalizeClass(unref(css$1s)()),
      onClick: withModifiers(Me, ["self", "stop"])
    }, [
      createElementVNode("span", {
        class: normalizeClass(unref(css$1s)("button")),
        "aria-haspopup": "true",
        "aria-expanded": xe.value
      }, [
        (openBlock(), createBlock(unref(_sfc_main$1Q), {
          key: ke.iconName,
          name: ke.iconName,
          size: ke.iconSize,
          color: ke.color,
          class: normalizeClass(unref(css$1s)("icon")),
          onClick: Me
        }, null, 8, ["name", "size", "color", "class"]))
      ], 10, _hoisted_1$u),
      xe.value ? (openBlock(), createBlock(unref(AtomCard), {
        key: 0,
        class: normalizeClass([unref(css$1s)("dropdown"), unref(css$1s)("dropdown", ke.aligment)]),
        padding: "none",
        radii: "small",
        elevation: "small"
      }, {
        default: withCtx(() => [
          createElementVNode("ul", {
            class: normalizeClass(unref(css$1s)("options-list"))
          }, [
            (openBlock(!0), createElementBlock(Fragment, null, renderList(ke.languages, (Fe) => (openBlock(), createElementBlock("li", {
              key: Fe,
              class: normalizeClass({
                [unref(css$1s)("option")]: !0,
                [unref(css$1s)("option", "selected")]: Fe === ke.selected
              }),
              onClick: (Ve) => Ee(Fe)
            }, [
              createVNode(unref(AtomText), {
                class: normalizeClass(unref(css$1s)("option-text")),
                type: "body",
                color: Fe === ke.selected ? "color-primary" : "color-text-secondary"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(supportedLanguages)[Fe]), 1)
                ]),
                _: 2
              }, 1032, ["class", "color"])
            ], 10, _hoisted_2$8))), 128))
          ], 2)
        ]),
        _: 1
      }, 8, ["class"])) : createCommentVNode("", !0)
    ], 2));
  }
}), SatLanguageSwitcher = /* @__PURE__ */ _export_sfc(_sfc_main$1A, [["__scopeId", "data-v-9a3e60da"]]), className$1r = "sat-link", css$1r = bemBuilder(className$1r);
bemBuilder(className$1r, !0);
const _hoisted_1$t = ["href", "target"], _sfc_main$1z = /* @__PURE__ */ defineComponent({
  __name: "SatLink",
  props: {
    href: {},
    route: {},
    target: { default: "_self" },
    type: { default: "body" },
    color: { default: "color-primary" },
    underlined: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = useSlots(), Ie = () => h$2(
      AtomText,
      {
        class: css$1r("label"),
        type: ke.type,
        color: ke.color
      },
      xe
    ), Me = (Be) => {
      Se("click", Be);
    }, { routerComponent: Ee } = useSatelliteUtils();
    return (Be, $e) => ke.route ? (openBlock(), createBlock(resolveDynamicComponent(unref(Ee)()), {
      key: 0,
      to: ke.route,
      class: normalizeClass({
        [unref(css$1r)()]: !0,
        [unref(css$1r)("", "underlined")]: ke.underlined
      }),
      onClick: Me
    }, {
      default: withCtx(() => [
        (openBlock(), createBlock(resolveDynamicComponent(Ie())))
      ]),
      _: 1
    }, 8, ["to", "class"])) : (openBlock(), createElementBlock("a", {
      key: 1,
      href: ke.href ?? "javascript:;",
      class: normalizeClass({
        [unref(css$1r)()]: !0,
        [unref(css$1r)("", "underlined")]: ke.underlined
      }),
      target: ke.target,
      rel: "noopener noreferrer",
      onClick: Me
    }, [
      (openBlock(), createBlock(resolveDynamicComponent(Ie())))
    ], 10, _hoisted_1$t));
  }
}), SatLink = /* @__PURE__ */ _export_sfc(_sfc_main$1z, [["__scopeId", "data-v-1c4bc56d"]]), className$1q = "sat-progress-bar", css$1q = bemBuilder(className$1q);
bemBuilder(className$1q, !0);
const _sfc_main$1y = /* @__PURE__ */ defineComponent({
  __name: "SatProgressBar",
  props: {
    steps: {},
    activeStep: {}
  },
  setup(e) {
    useCssVars((Ee) => ({
      v13a94996: xe.value,
      v39efd02e: Ie.value
    }));
    const j = e, ke = computed(() => {
      const Ee = j.steps.indexOf(j.activeStep);
      if (Ee < 0)
        throw new Error("Invalid active step");
      return Ee;
    }), Se = computed(() => ke.value === 0), xe = computed(() => {
      const Ee = (ke.value + 1) / j.steps.length * 100, Be = Se.value ? 5 : 0;
      return `calc(${Ee}% - ${Be}px)`;
    }), Ie = computed(() => `calc(${ke.value / (j.steps.length - 1) * 100}% + 6px)`), Me = (Ee) => {
      const Be = j.steps.indexOf(Ee);
      if (Be < 0)
        throw new Error("Invalid step given");
      return Be <= ke.value ? "color-mint" : "color-base-50";
    };
    return (Ee, Be) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$1q)())
    }, [
      createElementVNode("ul", {
        class: normalizeClass(unref(css$1q)("steps"))
      }, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(j.steps, ($e, Le) => (openBlock(), createElementBlock("li", {
          key: Le,
          class: normalizeClass(unref(css$1q)("step"))
        }, [
          createVNode(unref(AtomText), {
            type: Le === ke.value ? "body-bold" : "body",
            color: Me($e),
            class: normalizeClass(unref(css$1q)("label"))
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString($e), 1)
            ]),
            _: 2
          }, 1032, ["type", "color", "class"])
        ], 2))), 128))
      ], 2),
      createElementVNode("div", {
        class: normalizeClass(unref(css$1q)("line"))
      }, [
        createElementVNode("span", {
          class: normalizeClass(unref(css$1q)("progress"))
        }, null, 2)
      ], 2)
    ], 2));
  }
}), SatProgressBar = /* @__PURE__ */ _export_sfc(_sfc_main$1y, [["__scopeId", "data-v-e2bc1586"]]), className$1p = "sat-progress-tracker", css$1p = bemBuilder(className$1p);
bemBuilder(className$1p, !0);
const _sfc_main$1x = /* @__PURE__ */ defineComponent({
  __name: "SatProgressTracker",
  props: {
    min: {},
    max: {},
    current: {},
    additionalValues: {}
  },
  setup(e) {
    const j = e, ke = computed(() => {
      const Me = (j.additionalValues || []).filter((Ee) => Ee > j.min && Ee < j.max).sort();
      return [j.min, ...Me, j.max];
    }), Se = (Me) => {
      const Ee = (Me - j.min) / (j.max - j.min) * 100;
      return `${Ee >= 100 ? 100 : Ee}%`;
    }, xe = ref(j.min);
    function Ie(Me) {
      const Ee = xe.value, Be = 500, $e = performance.now();
      function Le(Fe) {
        const Ve = Fe - $e, je = Math.min(Ve / Be, 1);
        xe.value = Math.round(
          Ee + (Me - Ee) * je
        ), je < 1 && requestAnimationFrame(Le);
      }
      requestAnimationFrame(Le);
    }
    return watch(
      () => j.current,
      (Me) => {
        Ie(Me);
      },
      { immediate: !0 }
    ), onMounted(() => {
      Ie(j.current);
    }), (Me, Ee) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$1p)(""))
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$1p)("track"))
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(css$1p)("fill")),
          style: normalizeStyle({ width: Se(xe.value) })
        }, null, 6),
        (openBlock(!0), createElementBlock(Fragment, null, renderList(ke.value, (Be, $e) => (openBlock(), createElementBlock("div", {
          key: $e,
          class: normalizeClass(unref(css$1p)("circle")),
          style: normalizeStyle({
            left: Se(Be),
            backgroundColor: xe.value >= Be ? "var(--color-primary)" : "var(--color-base-80)"
          })
        }, [
          createElementVNode("span", {
            class: normalizeClass(unref(css$1p)("circle-label"))
          }, [
            createVNode(unref(AtomText), null, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(Be), 1)
              ]),
              _: 2
            }, 1024)
          ], 2)
        ], 6))), 128))
      ], 2)
    ], 2));
  }
}), SatProgressTracker = /* @__PURE__ */ _export_sfc(_sfc_main$1x, [["__scopeId", "data-v-5366c257"]]), className$1o = "atom-money", css$1o = bemBuilder(className$1o);
bemBuilder(className$1o, !0);
const _sfc_main$1w = /* @__PURE__ */ defineComponent({
  __name: "AtomMoney",
  props: {
    amount: {},
    currency: {},
    locale: {},
    hideCents: { type: Boolean, default: !1 },
    hideSymbol: { type: Boolean, default: !1 },
    inUnitOutput: { type: Boolean, default: !1 }
  },
  setup(e) {
    const j = e, ke = computed(() => toMoney(j.amount, j.currency, {
      locale: j.locale,
      hideCents: j.hideCents,
      hideSymbol: j.hideSymbol,
      inUnitOutput: j.inUnitOutput
    }));
    return (Se, xe) => (openBlock(), createElementBlock("span", {
      class: normalizeClass(unref(css$1o)()),
      "data-test": "atom-money"
    }, toDisplayString(ke.value), 3));
  }
}), className$1n = "sat-button-money", css$1n = bemBuilder(className$1n);
bemBuilder(className$1n, !0);
const _sfc_main$1v = /* @__PURE__ */ defineComponent({
  __name: "SatButtonMoney",
  props: {
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    price: {},
    type: { default: "button" },
    size: { default: "medium" },
    theme: {},
    variant: {},
    hideCents: { type: Boolean, default: !0 },
    locale: {}
  },
  emits: ["click"],
  setup(e, { emit: j }) {
    const ke = e, Se = j;
    return (xe, Ie) => (openBlock(), createBlock(unref(AtomButton), {
      class: normalizeClass([unref(css$1n)(""), { [unref(css$1n)("", "loading")]: ke.loading }]),
      disabled: ke.disabled || ke.loading,
      "is-loading": ke.loading,
      theme: ke.theme,
      variant: ke.variant,
      type: ke.type,
      size: ke.size,
      onClick: Ie[0] || (Ie[0] = (Me) => Se("click", Me))
    }, {
      default: withCtx(() => [
        createElementVNode("span", {
          class: normalizeClass(unref(css$1n)("label"))
        }, [
          renderSlot(xe.$slots, "default", {}, void 0, !0)
        ], 2),
        createVNode(unref(_sfc_main$1w), {
          class: normalizeClass(unref(css$1n)("money")),
          amount: ke.price.value,
          currency: ke.price.currency,
          "hide-cents": ke.hideCents,
          locale: ke.locale
        }, null, 8, ["class", "amount", "currency", "hide-cents", "locale"])
      ]),
      _: 3
    }, 8, ["class", "disabled", "is-loading", "theme", "variant", "type", "size"]));
  }
}), SatButtonMoney = /* @__PURE__ */ _export_sfc(_sfc_main$1v, [["__scopeId", "data-v-97b1cf8c"]]), MolButtonMoney = SatButtonMoney, className$1m = "sat-virtual-keyboard", css$1m = bemBuilder(className$1m);
bemBuilder(className$1m, !0);
const _sfc_main$1u = /* @__PURE__ */ defineComponent({
  __name: "SatVirtualKeyboard",
  emits: ["change", "keyup", "clear"],
  setup(e, { emit: j }) {
    const ke = j, Se = ref(""), xe = [1, 2, 3, 4, 5, 6, 7, 8, 9], Ie = (Fe) => {
      const Ve = Fe.toString();
      Se.value += Ve, Be(), $e(Ve);
    }, Me = () => {
      Se.value = Se.value.slice(0, -1), Be(), $e("backspace");
    }, Ee = () => {
      Se.value = "", Be(), $e("clear"), Le();
    }, Be = () => {
      ke("change", Se.value);
    }, $e = (Fe) => {
      ke("keyup", Fe);
    }, Le = () => {
      ke("clear");
    };
    return (Fe, Ve) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$1m)())
    }, [
      (openBlock(), createElementBlock(Fragment, null, renderList(xe, (je) => createVNode(unref(AtomButton), {
        key: je,
        "data-test": `key-${je}`,
        variant: "secondary",
        size: "large",
        onClick: (Ge) => Ie(je)
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(je), 1)
        ]),
        _: 2
      }, 1032, ["data-test", "onClick"])), 64)),
      createVNode(unref(AtomButton), {
        size: "large",
        variant: "secondary",
        "data-test": "key-backspace",
        onClick: Me
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(unref(t)("virtual_keyboard.backspace_label")), 1)
        ]),
        _: 1
      }),
      createVNode(unref(AtomButton), {
        size: "large",
        "data-test": "key-0",
        variant: "secondary",
        onClick: Ve[0] || (Ve[0] = (je) => Ie(0))
      }, {
        default: withCtx(() => [...Ve[1] || (Ve[1] = [
          createTextVNode(" 0 ", -1)
        ])]),
        _: 1
      }),
      createVNode(unref(AtomButton), {
        size: "large",
        variant: "secondary",
        "data-test": "key-clear",
        onClick: Ee
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(unref(t)("virtual_keyboard.clear_label")), 1)
        ]),
        _: 1
      })
    ], 2));
  }
}), SatVirtualKeyboard = /* @__PURE__ */ _export_sfc(_sfc_main$1u, [["__scopeId", "data-v-ea5fcb16"]]), className$1l = "sat-lottie-json", css$1l = bemBuilder(className$1l);
bemBuilder(className$1l, !0);
var lottie$2 = { exports: {} }, lottie$1 = lottie$2.exports, hasRequiredLottie;
function requireLottie() {
  return hasRequiredLottie || (hasRequiredLottie = 1, function(module, exports) {
    typeof document < "u" && typeof navigator < "u" && function(e, j) {
      module.exports = j();
    }(lottie$1, function() {
      var svgNS = "http://www.w3.org/2000/svg", locationHref = "", _useWebWorker = !1, initialDefaultFrame = -999999, setWebWorker = function(j) {
        _useWebWorker = !!j;
      }, getWebWorker = function() {
        return _useWebWorker;
      }, setLocationHref = function(j) {
        locationHref = j;
      }, getLocationHref = function() {
        return locationHref;
      };
      function createTag(e) {
        return document.createElement(e);
      }
      function extendPrototype(e, j) {
        var ke, Se = e.length, xe;
        for (ke = 0; ke < Se; ke += 1) {
          xe = e[ke].prototype;
          for (var Ie in xe)
            Object.prototype.hasOwnProperty.call(xe, Ie) && (j.prototype[Ie] = xe[Ie]);
        }
      }
      function getDescriptor(e, j) {
        return Object.getOwnPropertyDescriptor(e, j);
      }
      function createProxyFunction(e) {
        function j() {
        }
        return j.prototype = e, j;
      }
      var audioControllerFactory = function() {
        function e(j) {
          this.audios = [], this.audioFactory = j, this._volume = 1, this._isMuted = !1;
        }
        return e.prototype = {
          addAudio: function(ke) {
            this.audios.push(ke);
          },
          pause: function() {
            var ke, Se = this.audios.length;
            for (ke = 0; ke < Se; ke += 1)
              this.audios[ke].pause();
          },
          resume: function() {
            var ke, Se = this.audios.length;
            for (ke = 0; ke < Se; ke += 1)
              this.audios[ke].resume();
          },
          setRate: function(ke) {
            var Se, xe = this.audios.length;
            for (Se = 0; Se < xe; Se += 1)
              this.audios[Se].setRate(ke);
          },
          createAudio: function(ke) {
            return this.audioFactory ? this.audioFactory(ke) : window.Howl ? new window.Howl({
              src: [ke]
            }) : {
              isPlaying: !1,
              play: function() {
                this.isPlaying = !0;
              },
              seek: function() {
                this.isPlaying = !1;
              },
              playing: function() {
              },
              rate: function() {
              },
              setVolume: function() {
              }
            };
          },
          setAudioFactory: function(ke) {
            this.audioFactory = ke;
          },
          setVolume: function(ke) {
            this._volume = ke, this._updateVolume();
          },
          mute: function() {
            this._isMuted = !0, this._updateVolume();
          },
          unmute: function() {
            this._isMuted = !1, this._updateVolume();
          },
          getVolume: function() {
            return this._volume;
          },
          _updateVolume: function() {
            var ke, Se = this.audios.length;
            for (ke = 0; ke < Se; ke += 1)
              this.audios[ke].volume(this._volume * (this._isMuted ? 0 : 1));
          }
        }, function() {
          return new e();
        };
      }(), createTypedArray = /* @__PURE__ */ function() {
        function e(ke, Se) {
          var xe = 0, Ie = [], Me;
          switch (ke) {
            case "int16":
            case "uint8c":
              Me = 1;
              break;
            default:
              Me = 1.1;
              break;
          }
          for (xe = 0; xe < Se; xe += 1)
            Ie.push(Me);
          return Ie;
        }
        function j(ke, Se) {
          return ke === "float32" ? new Float32Array(Se) : ke === "int16" ? new Int16Array(Se) : ke === "uint8c" ? new Uint8ClampedArray(Se) : e(ke, Se);
        }
        return typeof Uint8ClampedArray == "function" && typeof Float32Array == "function" ? j : e;
      }();
      function createSizedArray(e) {
        return Array.apply(null, {
          length: e
        });
      }
      function _typeof$6(e) {
        "@babel/helpers - typeof";
        return _typeof$6 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(j) {
          return typeof j;
        } : function(j) {
          return j && typeof Symbol == "function" && j.constructor === Symbol && j !== Symbol.prototype ? "symbol" : typeof j;
        }, _typeof$6(e);
      }
      var subframeEnabled = !0, expressionsPlugin = null, expressionsInterfaces = null, idPrefix$1 = "", isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), bmPow = Math.pow, bmSqrt = Math.sqrt, bmFloor = Math.floor, bmMax = Math.max, bmMin = Math.min, BMMath = {};
      (function() {
        var e = ["abs", "acos", "acosh", "asin", "asinh", "atan", "atanh", "atan2", "ceil", "cbrt", "expm1", "clz32", "cos", "cosh", "exp", "floor", "fround", "hypot", "imul", "log", "log1p", "log2", "log10", "max", "min", "pow", "random", "round", "sign", "sin", "sinh", "sqrt", "tan", "tanh", "trunc", "E", "LN10", "LN2", "LOG10E", "LOG2E", "PI", "SQRT1_2", "SQRT2"], j, ke = e.length;
        for (j = 0; j < ke; j += 1)
          BMMath[e[j]] = Math[e[j]];
      })(), BMMath.random = Math.random, BMMath.abs = function(e) {
        var j = _typeof$6(e);
        if (j === "object" && e.length) {
          var ke = createSizedArray(e.length), Se, xe = e.length;
          for (Se = 0; Se < xe; Se += 1)
            ke[Se] = Math.abs(e[Se]);
          return ke;
        }
        return Math.abs(e);
      };
      var defaultCurveSegments = 150, degToRads = Math.PI / 180, roundCorner = 0.5519;
      function styleDiv(e) {
        e.style.position = "absolute", e.style.top = 0, e.style.left = 0, e.style.display = "block", e.style.transformOrigin = "0 0", e.style.webkitTransformOrigin = "0 0", e.style.backfaceVisibility = "visible", e.style.webkitBackfaceVisibility = "visible", e.style.transformStyle = "preserve-3d", e.style.webkitTransformStyle = "preserve-3d", e.style.mozTransformStyle = "preserve-3d";
      }
      function BMEnterFrameEvent(e, j, ke, Se) {
        this.type = e, this.currentTime = j, this.totalTime = ke, this.direction = Se < 0 ? -1 : 1;
      }
      function BMCompleteEvent(e, j) {
        this.type = e, this.direction = j < 0 ? -1 : 1;
      }
      function BMCompleteLoopEvent(e, j, ke, Se) {
        this.type = e, this.currentLoop = ke, this.totalLoops = j, this.direction = Se < 0 ? -1 : 1;
      }
      function BMSegmentStartEvent(e, j, ke) {
        this.type = e, this.firstFrame = j, this.totalFrames = ke;
      }
      function BMDestroyEvent(e, j) {
        this.type = e, this.target = j;
      }
      function BMRenderFrameErrorEvent(e, j) {
        this.type = "renderFrameError", this.nativeError = e, this.currentTime = j;
      }
      function BMConfigErrorEvent(e) {
        this.type = "configError", this.nativeError = e;
      }
      var createElementID = /* @__PURE__ */ function() {
        var e = 0;
        return function() {
          return e += 1, idPrefix$1 + "__lottie_element_" + e;
        };
      }();
      function HSVtoRGB(e, j, ke) {
        var Se, xe, Ie, Me, Ee, Be, $e, Le;
        switch (Me = Math.floor(e * 6), Ee = e * 6 - Me, Be = ke * (1 - j), $e = ke * (1 - Ee * j), Le = ke * (1 - (1 - Ee) * j), Me % 6) {
          case 0:
            Se = ke, xe = Le, Ie = Be;
            break;
          case 1:
            Se = $e, xe = ke, Ie = Be;
            break;
          case 2:
            Se = Be, xe = ke, Ie = Le;
            break;
          case 3:
            Se = Be, xe = $e, Ie = ke;
            break;
          case 4:
            Se = Le, xe = Be, Ie = ke;
            break;
          case 5:
            Se = ke, xe = Be, Ie = $e;
            break;
        }
        return [Se, xe, Ie];
      }
      function RGBtoHSV(e, j, ke) {
        var Se = Math.max(e, j, ke), xe = Math.min(e, j, ke), Ie = Se - xe, Me, Ee = Se === 0 ? 0 : Ie / Se, Be = Se / 255;
        switch (Se) {
          case xe:
            Me = 0;
            break;
          case e:
            Me = j - ke + Ie * (j < ke ? 6 : 0), Me /= 6 * Ie;
            break;
          case j:
            Me = ke - e + Ie * 2, Me /= 6 * Ie;
            break;
          case ke:
            Me = e - j + Ie * 4, Me /= 6 * Ie;
            break;
        }
        return [Me, Ee, Be];
      }
      function addSaturationToRGB(e, j) {
        var ke = RGBtoHSV(e[0] * 255, e[1] * 255, e[2] * 255);
        return ke[1] += j, ke[1] > 1 ? ke[1] = 1 : ke[1] <= 0 && (ke[1] = 0), HSVtoRGB(ke[0], ke[1], ke[2]);
      }
      function addBrightnessToRGB(e, j) {
        var ke = RGBtoHSV(e[0] * 255, e[1] * 255, e[2] * 255);
        return ke[2] += j, ke[2] > 1 ? ke[2] = 1 : ke[2] < 0 && (ke[2] = 0), HSVtoRGB(ke[0], ke[1], ke[2]);
      }
      function addHueToRGB(e, j) {
        var ke = RGBtoHSV(e[0] * 255, e[1] * 255, e[2] * 255);
        return ke[0] += j / 360, ke[0] > 1 ? ke[0] -= 1 : ke[0] < 0 && (ke[0] += 1), HSVtoRGB(ke[0], ke[1], ke[2]);
      }
      var rgbToHex = function() {
        var e = [], j, ke;
        for (j = 0; j < 256; j += 1)
          ke = j.toString(16), e[j] = ke.length === 1 ? "0" + ke : ke;
        return function(Se, xe, Ie) {
          return Se < 0 && (Se = 0), xe < 0 && (xe = 0), Ie < 0 && (Ie = 0), "#" + e[Se] + e[xe] + e[Ie];
        };
      }(), setSubframeEnabled = function(j) {
        subframeEnabled = !!j;
      }, getSubframeEnabled = function() {
        return subframeEnabled;
      }, setExpressionsPlugin = function(j) {
        expressionsPlugin = j;
      }, getExpressionsPlugin = function() {
        return expressionsPlugin;
      }, setExpressionInterfaces = function(j) {
        expressionsInterfaces = j;
      }, getExpressionInterfaces = function() {
        return expressionsInterfaces;
      }, setDefaultCurveSegments = function(j) {
        defaultCurveSegments = j;
      }, getDefaultCurveSegments = function() {
        return defaultCurveSegments;
      }, setIdPrefix = function(j) {
        idPrefix$1 = j;
      };
      function createNS(e) {
        return document.createElementNS(svgNS, e);
      }
      function _typeof$5(e) {
        "@babel/helpers - typeof";
        return _typeof$5 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(j) {
          return typeof j;
        } : function(j) {
          return j && typeof Symbol == "function" && j.constructor === Symbol && j !== Symbol.prototype ? "symbol" : typeof j;
        }, _typeof$5(e);
      }
      var dataManager = /* @__PURE__ */ function() {
        var e = 1, j = [], ke, Se, xe = {
          onmessage: function() {
          },
          postMessage: function(je) {
            ke({
              data: je
            });
          }
        }, Ie = {
          postMessage: function(je) {
            xe.onmessage({
              data: je
            });
          }
        };
        function Me(Ve) {
          if (window.Worker && window.Blob && getWebWorker()) {
            var je = new Blob(["var _workerSelf = self; self.onmessage = ", Ve.toString()], {
              type: "text/javascript"
            }), Ge = URL.createObjectURL(je);
            return new Worker(Ge);
          }
          return ke = Ve, xe;
        }
        function Ee() {
          Se || (Se = Me(function(je) {
            function Ge() {
              function Ue(zt, kt) {
                var Et, Qe, Xe = zt.length, Vt, Lt, Gt, Wt;
                for (Qe = 0; Qe < Xe; Qe += 1)
                  if (Et = zt[Qe], "ks" in Et && !Et.completed) {
                    if (Et.completed = !0, Et.hasMask) {
                      var Zt = Et.masksProperties;
                      for (Lt = Zt.length, Vt = 0; Vt < Lt; Vt += 1)
                        if (Zt[Vt].pt.k.i)
                          Je(Zt[Vt].pt.k);
                        else
                          for (Wt = Zt[Vt].pt.k.length, Gt = 0; Gt < Wt; Gt += 1)
                            Zt[Vt].pt.k[Gt].s && Je(Zt[Vt].pt.k[Gt].s[0]), Zt[Vt].pt.k[Gt].e && Je(Zt[Vt].pt.k[Gt].e[0]);
                    }
                    Et.ty === 0 ? (Et.layers = We(Et.refId, kt), Ue(Et.layers, kt)) : Et.ty === 4 ? qe(Et.shapes) : Et.ty === 5 && Ft(Et);
                  }
              }
              function Re(zt, kt) {
                if (zt) {
                  var Et = 0, Qe = zt.length;
                  for (Et = 0; Et < Qe; Et += 1)
                    zt[Et].t === 1 && (zt[Et].data.layers = We(zt[Et].data.refId, kt), Ue(zt[Et].data.layers, kt));
                }
              }
              function Ye(zt, kt) {
                for (var Et = 0, Qe = kt.length; Et < Qe; ) {
                  if (kt[Et].id === zt)
                    return kt[Et];
                  Et += 1;
                }
                return null;
              }
              function We(zt, kt) {
                var Et = Ye(zt, kt);
                return Et ? Et.layers.__used ? JSON.parse(JSON.stringify(Et.layers)) : (Et.layers.__used = !0, Et.layers) : null;
              }
              function qe(zt) {
                var kt, Et = zt.length, Qe, Xe;
                for (kt = Et - 1; kt >= 0; kt -= 1)
                  if (zt[kt].ty === "sh")
                    if (zt[kt].ks.k.i)
                      Je(zt[kt].ks.k);
                    else
                      for (Xe = zt[kt].ks.k.length, Qe = 0; Qe < Xe; Qe += 1)
                        zt[kt].ks.k[Qe].s && Je(zt[kt].ks.k[Qe].s[0]), zt[kt].ks.k[Qe].e && Je(zt[kt].ks.k[Qe].e[0]);
                  else zt[kt].ty === "gr" && qe(zt[kt].it);
              }
              function Je(zt) {
                var kt, Et = zt.i.length;
                for (kt = 0; kt < Et; kt += 1)
                  zt.i[kt][0] += zt.v[kt][0], zt.i[kt][1] += zt.v[kt][1], zt.o[kt][0] += zt.v[kt][0], zt.o[kt][1] += zt.v[kt][1];
              }
              function Ke(zt, kt) {
                var Et = kt ? kt.split(".") : [100, 100, 100];
                return zt[0] > Et[0] ? !0 : Et[0] > zt[0] ? !1 : zt[1] > Et[1] ? !0 : Et[1] > zt[1] ? !1 : zt[2] > Et[2] ? !0 : Et[2] > zt[2] ? !1 : null;
              }
              var xt = /* @__PURE__ */ function() {
                var zt = [4, 4, 14];
                function kt(Qe) {
                  var Xe = Qe.t.d;
                  Qe.t.d = {
                    k: [{
                      s: Xe,
                      t: 0
                    }]
                  };
                }
                function Et(Qe) {
                  var Xe, Vt = Qe.length;
                  for (Xe = 0; Xe < Vt; Xe += 1)
                    Qe[Xe].ty === 5 && kt(Qe[Xe]);
                }
                return function(Qe) {
                  if (Ke(zt, Qe.v) && (Et(Qe.layers), Qe.assets)) {
                    var Xe, Vt = Qe.assets.length;
                    for (Xe = 0; Xe < Vt; Xe += 1)
                      Qe.assets[Xe].layers && Et(Qe.assets[Xe].layers);
                  }
                };
              }(), Ct = /* @__PURE__ */ function() {
                var zt = [4, 7, 99];
                return function(kt) {
                  if (kt.chars && !Ke(zt, kt.v)) {
                    var Et, Qe = kt.chars.length;
                    for (Et = 0; Et < Qe; Et += 1) {
                      var Xe = kt.chars[Et];
                      Xe.data && Xe.data.shapes && (qe(Xe.data.shapes), Xe.data.ip = 0, Xe.data.op = 99999, Xe.data.st = 0, Xe.data.sr = 1, Xe.data.ks = {
                        p: {
                          k: [0, 0],
                          a: 0
                        },
                        s: {
                          k: [100, 100],
                          a: 0
                        },
                        a: {
                          k: [0, 0],
                          a: 0
                        },
                        r: {
                          k: 0,
                          a: 0
                        },
                        o: {
                          k: 100,
                          a: 0
                        }
                      }, kt.chars[Et].t || (Xe.data.shapes.push({
                        ty: "no"
                      }), Xe.data.shapes[0].it.push({
                        p: {
                          k: [0, 0],
                          a: 0
                        },
                        s: {
                          k: [100, 100],
                          a: 0
                        },
                        a: {
                          k: [0, 0],
                          a: 0
                        },
                        r: {
                          k: 0,
                          a: 0
                        },
                        o: {
                          k: 100,
                          a: 0
                        },
                        sk: {
                          k: 0,
                          a: 0
                        },
                        sa: {
                          k: 0,
                          a: 0
                        },
                        ty: "tr"
                      })));
                    }
                  }
                };
              }(), It = /* @__PURE__ */ function() {
                var zt = [5, 7, 15];
                function kt(Qe) {
                  var Xe = Qe.t.p;
                  typeof Xe.a == "number" && (Xe.a = {
                    a: 0,
                    k: Xe.a
                  }), typeof Xe.p == "number" && (Xe.p = {
                    a: 0,
                    k: Xe.p
                  }), typeof Xe.r == "number" && (Xe.r = {
                    a: 0,
                    k: Xe.r
                  });
                }
                function Et(Qe) {
                  var Xe, Vt = Qe.length;
                  for (Xe = 0; Xe < Vt; Xe += 1)
                    Qe[Xe].ty === 5 && kt(Qe[Xe]);
                }
                return function(Qe) {
                  if (Ke(zt, Qe.v) && (Et(Qe.layers), Qe.assets)) {
                    var Xe, Vt = Qe.assets.length;
                    for (Xe = 0; Xe < Vt; Xe += 1)
                      Qe.assets[Xe].layers && Et(Qe.assets[Xe].layers);
                  }
                };
              }(), Nt = /* @__PURE__ */ function() {
                var zt = [4, 1, 9];
                function kt(Qe) {
                  var Xe, Vt = Qe.length, Lt, Gt;
                  for (Xe = 0; Xe < Vt; Xe += 1)
                    if (Qe[Xe].ty === "gr")
                      kt(Qe[Xe].it);
                    else if (Qe[Xe].ty === "fl" || Qe[Xe].ty === "st")
                      if (Qe[Xe].c.k && Qe[Xe].c.k[0].i)
                        for (Gt = Qe[Xe].c.k.length, Lt = 0; Lt < Gt; Lt += 1)
                          Qe[Xe].c.k[Lt].s && (Qe[Xe].c.k[Lt].s[0] /= 255, Qe[Xe].c.k[Lt].s[1] /= 255, Qe[Xe].c.k[Lt].s[2] /= 255, Qe[Xe].c.k[Lt].s[3] /= 255), Qe[Xe].c.k[Lt].e && (Qe[Xe].c.k[Lt].e[0] /= 255, Qe[Xe].c.k[Lt].e[1] /= 255, Qe[Xe].c.k[Lt].e[2] /= 255, Qe[Xe].c.k[Lt].e[3] /= 255);
                      else
                        Qe[Xe].c.k[0] /= 255, Qe[Xe].c.k[1] /= 255, Qe[Xe].c.k[2] /= 255, Qe[Xe].c.k[3] /= 255;
                }
                function Et(Qe) {
                  var Xe, Vt = Qe.length;
                  for (Xe = 0; Xe < Vt; Xe += 1)
                    Qe[Xe].ty === 4 && kt(Qe[Xe].shapes);
                }
                return function(Qe) {
                  if (Ke(zt, Qe.v) && (Et(Qe.layers), Qe.assets)) {
                    var Xe, Vt = Qe.assets.length;
                    for (Xe = 0; Xe < Vt; Xe += 1)
                      Qe.assets[Xe].layers && Et(Qe.assets[Xe].layers);
                  }
                };
              }(), Bt = /* @__PURE__ */ function() {
                var zt = [4, 4, 18];
                function kt(Qe) {
                  var Xe, Vt = Qe.length, Lt, Gt;
                  for (Xe = Vt - 1; Xe >= 0; Xe -= 1)
                    if (Qe[Xe].ty === "sh")
                      if (Qe[Xe].ks.k.i)
                        Qe[Xe].ks.k.c = Qe[Xe].closed;
                      else
                        for (Gt = Qe[Xe].ks.k.length, Lt = 0; Lt < Gt; Lt += 1)
                          Qe[Xe].ks.k[Lt].s && (Qe[Xe].ks.k[Lt].s[0].c = Qe[Xe].closed), Qe[Xe].ks.k[Lt].e && (Qe[Xe].ks.k[Lt].e[0].c = Qe[Xe].closed);
                    else Qe[Xe].ty === "gr" && kt(Qe[Xe].it);
                }
                function Et(Qe) {
                  var Xe, Vt, Lt = Qe.length, Gt, Wt, Zt, Ot;
                  for (Vt = 0; Vt < Lt; Vt += 1) {
                    if (Xe = Qe[Vt], Xe.hasMask) {
                      var Ht = Xe.masksProperties;
                      for (Wt = Ht.length, Gt = 0; Gt < Wt; Gt += 1)
                        if (Ht[Gt].pt.k.i)
                          Ht[Gt].pt.k.c = Ht[Gt].cl;
                        else
                          for (Ot = Ht[Gt].pt.k.length, Zt = 0; Zt < Ot; Zt += 1)
                            Ht[Gt].pt.k[Zt].s && (Ht[Gt].pt.k[Zt].s[0].c = Ht[Gt].cl), Ht[Gt].pt.k[Zt].e && (Ht[Gt].pt.k[Zt].e[0].c = Ht[Gt].cl);
                    }
                    Xe.ty === 4 && kt(Xe.shapes);
                  }
                }
                return function(Qe) {
                  if (Ke(zt, Qe.v) && (Et(Qe.layers), Qe.assets)) {
                    var Xe, Vt = Qe.assets.length;
                    for (Xe = 0; Xe < Vt; Xe += 1)
                      Qe.assets[Xe].layers && Et(Qe.assets[Xe].layers);
                  }
                };
              }();
              function At(zt) {
                zt.__complete || (Nt(zt), xt(zt), Ct(zt), It(zt), Bt(zt), Ue(zt.layers, zt.assets), Re(zt.chars, zt.assets), zt.__complete = !0);
              }
              function Ft(zt) {
                zt.t.a.length === 0 && "m" in zt.t.p;
              }
              var Dt = {};
              return Dt.completeData = At, Dt.checkColors = Nt, Dt.checkChars = Ct, Dt.checkPathProperties = It, Dt.checkShapes = Bt, Dt.completeLayers = Ue, Dt;
            }
            if (Ie.dataManager || (Ie.dataManager = Ge()), Ie.assetLoader || (Ie.assetLoader = /* @__PURE__ */ function() {
              function Ue(Ye) {
                var We = Ye.getResponseHeader("content-type");
                return We && Ye.responseType === "json" && We.indexOf("json") !== -1 || Ye.response && _typeof$5(Ye.response) === "object" ? Ye.response : Ye.response && typeof Ye.response == "string" ? JSON.parse(Ye.response) : Ye.responseText ? JSON.parse(Ye.responseText) : null;
              }
              function Re(Ye, We, qe, Je) {
                var Ke, xt = new XMLHttpRequest();
                try {
                  xt.responseType = "json";
                } catch {
                }
                xt.onreadystatechange = function() {
                  if (xt.readyState === 4)
                    if (xt.status === 200)
                      Ke = Ue(xt), qe(Ke);
                    else
                      try {
                        Ke = Ue(xt), qe(Ke);
                      } catch (Ct) {
                        Je && Je(Ct);
                      }
                };
                try {
                  xt.open(["G", "E", "T"].join(""), Ye, !0);
                } catch {
                  xt.open(["G", "E", "T"].join(""), We + "/" + Ye, !0);
                }
                xt.send();
              }
              return {
                load: Re
              };
            }()), je.data.type === "loadAnimation")
              Ie.assetLoader.load(je.data.path, je.data.fullPath, function(Ue) {
                Ie.dataManager.completeData(Ue), Ie.postMessage({
                  id: je.data.id,
                  payload: Ue,
                  status: "success"
                });
              }, function() {
                Ie.postMessage({
                  id: je.data.id,
                  status: "error"
                });
              });
            else if (je.data.type === "complete") {
              var De = je.data.animation;
              Ie.dataManager.completeData(De), Ie.postMessage({
                id: je.data.id,
                payload: De,
                status: "success"
              });
            } else je.data.type === "loadData" && Ie.assetLoader.load(je.data.path, je.data.fullPath, function(Ue) {
              Ie.postMessage({
                id: je.data.id,
                payload: Ue,
                status: "success"
              });
            }, function() {
              Ie.postMessage({
                id: je.data.id,
                status: "error"
              });
            });
          }), Se.onmessage = function(Ve) {
            var je = Ve.data, Ge = je.id, De = j[Ge];
            j[Ge] = null, je.status === "success" ? De.onComplete(je.payload) : De.onError && De.onError();
          });
        }
        function Be(Ve, je) {
          e += 1;
          var Ge = "processId_" + e;
          return j[Ge] = {
            onComplete: Ve,
            onError: je
          }, Ge;
        }
        function $e(Ve, je, Ge) {
          Ee();
          var De = Be(je, Ge);
          Se.postMessage({
            type: "loadAnimation",
            path: Ve,
            fullPath: window.location.origin + window.location.pathname,
            id: De
          });
        }
        function Le(Ve, je, Ge) {
          Ee();
          var De = Be(je, Ge);
          Se.postMessage({
            type: "loadData",
            path: Ve,
            fullPath: window.location.origin + window.location.pathname,
            id: De
          });
        }
        function Fe(Ve, je, Ge) {
          Ee();
          var De = Be(je, Ge);
          Se.postMessage({
            type: "complete",
            animation: Ve,
            id: De
          });
        }
        return {
          loadAnimation: $e,
          loadData: Le,
          completeAnimation: Fe
        };
      }(), ImagePreloader = function() {
        var e = function() {
          var Re = createTag("canvas");
          Re.width = 1, Re.height = 1;
          var Ye = Re.getContext("2d");
          return Ye.fillStyle = "rgba(0,0,0,0)", Ye.fillRect(0, 0, 1, 1), Re;
        }();
        function j() {
          this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
        }
        function ke() {
          this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
        }
        function Se(Re, Ye, We) {
          var qe = "";
          if (Re.e)
            qe = Re.p;
          else if (Ye) {
            var Je = Re.p;
            Je.indexOf("images/") !== -1 && (Je = Je.split("/")[1]), qe = Ye + Je;
          } else
            qe = We, qe += Re.u ? Re.u : "", qe += Re.p;
          return qe;
        }
        function xe(Re) {
          var Ye = 0, We = setInterval((function() {
            var qe = Re.getBBox();
            (qe.width || Ye > 500) && (this._imageLoaded(), clearInterval(We)), Ye += 1;
          }).bind(this), 50);
        }
        function Ie(Re) {
          var Ye = Se(Re, this.assetsPath, this.path), We = createNS("image");
          isSafari ? this.testImageLoaded(We) : We.addEventListener("load", this._imageLoaded, !1), We.addEventListener("error", (function() {
            qe.img = e, this._imageLoaded();
          }).bind(this), !1), We.setAttributeNS("http://www.w3.org/1999/xlink", "href", Ye), this._elementHelper.append ? this._elementHelper.append(We) : this._elementHelper.appendChild(We);
          var qe = {
            img: We,
            assetData: Re
          };
          return qe;
        }
        function Me(Re) {
          var Ye = Se(Re, this.assetsPath, this.path), We = createTag("img");
          We.crossOrigin = "anonymous", We.addEventListener("load", this._imageLoaded, !1), We.addEventListener("error", (function() {
            qe.img = e, this._imageLoaded();
          }).bind(this), !1), We.src = Ye;
          var qe = {
            img: We,
            assetData: Re
          };
          return qe;
        }
        function Ee(Re) {
          var Ye = {
            assetData: Re
          }, We = Se(Re, this.assetsPath, this.path);
          return dataManager.loadData(We, (function(qe) {
            Ye.img = qe, this._footageLoaded();
          }).bind(this), (function() {
            Ye.img = {}, this._footageLoaded();
          }).bind(this)), Ye;
        }
        function Be(Re, Ye) {
          this.imagesLoadedCb = Ye;
          var We, qe = Re.length;
          for (We = 0; We < qe; We += 1)
            Re[We].layers || (!Re[We].t || Re[We].t === "seq" ? (this.totalImages += 1, this.images.push(this._createImageData(Re[We]))) : Re[We].t === 3 && (this.totalFootages += 1, this.images.push(this.createFootageData(Re[We]))));
        }
        function $e(Re) {
          this.path = Re || "";
        }
        function Le(Re) {
          this.assetsPath = Re || "";
        }
        function Fe(Re) {
          for (var Ye = 0, We = this.images.length; Ye < We; ) {
            if (this.images[Ye].assetData === Re)
              return this.images[Ye].img;
            Ye += 1;
          }
          return null;
        }
        function Ve() {
          this.imagesLoadedCb = null, this.images.length = 0;
        }
        function je() {
          return this.totalImages === this.loadedAssets;
        }
        function Ge() {
          return this.totalFootages === this.loadedFootagesCount;
        }
        function De(Re, Ye) {
          Re === "svg" ? (this._elementHelper = Ye, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this);
        }
        function Ue() {
          this._imageLoaded = j.bind(this), this._footageLoaded = ke.bind(this), this.testImageLoaded = xe.bind(this), this.createFootageData = Ee.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
        }
        return Ue.prototype = {
          loadAssets: Be,
          setAssetsPath: Le,
          setPath: $e,
          loadedImages: je,
          loadedFootages: Ge,
          destroy: Ve,
          getAsset: Fe,
          createImgData: Me,
          createImageData: Ie,
          imageLoaded: j,
          footageLoaded: ke,
          setCacheType: De
        }, Ue;
      }();
      function BaseEvent() {
      }
      BaseEvent.prototype = {
        triggerEvent: function(j, ke) {
          if (this._cbs[j])
            for (var Se = this._cbs[j], xe = 0; xe < Se.length; xe += 1)
              Se[xe](ke);
        },
        addEventListener: function(j, ke) {
          return this._cbs[j] || (this._cbs[j] = []), this._cbs[j].push(ke), (function() {
            this.removeEventListener(j, ke);
          }).bind(this);
        },
        removeEventListener: function(j, ke) {
          if (!ke)
            this._cbs[j] = null;
          else if (this._cbs[j]) {
            for (var Se = 0, xe = this._cbs[j].length; Se < xe; )
              this._cbs[j][Se] === ke && (this._cbs[j].splice(Se, 1), Se -= 1, xe -= 1), Se += 1;
            this._cbs[j].length || (this._cbs[j] = null);
          }
        }
      };
      var markerParser = /* @__PURE__ */ function() {
        function e(j) {
          for (var ke = j.split(`\r
`), Se = {}, xe, Ie = 0, Me = 0; Me < ke.length; Me += 1)
            xe = ke[Me].split(":"), xe.length === 2 && (Se[xe[0]] = xe[1].trim(), Ie += 1);
          if (Ie === 0)
            throw new Error();
          return Se;
        }
        return function(j) {
          for (var ke = [], Se = 0; Se < j.length; Se += 1) {
            var xe = j[Se], Ie = {
              time: xe.tm,
              duration: xe.dr
            };
            try {
              Ie.payload = JSON.parse(j[Se].cm);
            } catch {
              try {
                Ie.payload = e(j[Se].cm);
              } catch {
                Ie.payload = {
                  name: j[Se].cm
                };
              }
            }
            ke.push(Ie);
          }
          return ke;
        };
      }(), ProjectInterface = /* @__PURE__ */ function() {
        function e(j) {
          this.compositions.push(j);
        }
        return function() {
          function j(ke) {
            for (var Se = 0, xe = this.compositions.length; Se < xe; ) {
              if (this.compositions[Se].data && this.compositions[Se].data.nm === ke)
                return this.compositions[Se].prepareFrame && this.compositions[Se].data.xt && this.compositions[Se].prepareFrame(this.currentFrame), this.compositions[Se].compInterface;
              Se += 1;
            }
            return null;
          }
          return j.compositions = [], j.currentFrame = 0, j.registerComposition = e, j;
        };
      }(), renderers = {}, registerRenderer = function(j, ke) {
        renderers[j] = ke;
      };
      function getRenderer(e) {
        return renderers[e];
      }
      function getRegisteredRenderer() {
        if (renderers.canvas)
          return "canvas";
        for (var e in renderers)
          if (renderers[e])
            return e;
        return "";
      }
      function _typeof$4(e) {
        "@babel/helpers - typeof";
        return _typeof$4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(j) {
          return typeof j;
        } : function(j) {
          return j && typeof Symbol == "function" && j.constructor === Symbol && j !== Symbol.prototype ? "symbol" : typeof j;
        }, _typeof$4(e);
      }
      var AnimationItem = function() {
        this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = createElementID(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = getSubframeEnabled(), this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = ProjectInterface(), this.imagePreloader = new ImagePreloader(), this.audioController = audioControllerFactory(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this), this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0), this.expressionsPlugin = getExpressionsPlugin();
      };
      extendPrototype([BaseEvent], AnimationItem), AnimationItem.prototype.setParams = function(e) {
        (e.wrapper || e.container) && (this.wrapper = e.wrapper || e.container);
        var j = "svg";
        e.animType ? j = e.animType : e.renderer && (j = e.renderer);
        var ke = getRenderer(j);
        this.renderer = new ke(this, e.rendererSettings), this.imagePreloader.setCacheType(j, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = j, e.loop === "" || e.loop === null || e.loop === void 0 || e.loop === !0 ? this.loop = !0 : e.loop === !1 ? this.loop = !1 : this.loop = parseInt(e.loop, 10), this.autoplay = "autoplay" in e ? e.autoplay : !0, this.name = e.name ? e.name : "", this.autoloadSegments = Object.prototype.hasOwnProperty.call(e, "autoloadSegments") ? e.autoloadSegments : !0, this.assetsPath = e.assetsPath, this.initialSegment = e.initialSegment, e.audioFactory && this.audioController.setAudioFactory(e.audioFactory), e.animationData ? this.setupAnimation(e.animationData) : e.path && (e.path.lastIndexOf("\\") !== -1 ? this.path = e.path.substr(0, e.path.lastIndexOf("\\") + 1) : this.path = e.path.substr(0, e.path.lastIndexOf("/") + 1), this.fileName = e.path.substr(e.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), dataManager.loadAnimation(e.path, this.configAnimation, this.onSetupError));
      }, AnimationItem.prototype.onSetupError = function() {
        this.trigger("data_failed");
      }, AnimationItem.prototype.setupAnimation = function(e) {
        dataManager.completeAnimation(e, this.configAnimation);
      }, AnimationItem.prototype.setData = function(e, j) {
        j && _typeof$4(j) !== "object" && (j = JSON.parse(j));
        var ke = {
          wrapper: e,
          animationData: j
        }, Se = e.attributes;
        ke.path = Se.getNamedItem("data-animation-path") ? Se.getNamedItem("data-animation-path").value : Se.getNamedItem("data-bm-path") ? Se.getNamedItem("data-bm-path").value : Se.getNamedItem("bm-path") ? Se.getNamedItem("bm-path").value : "", ke.animType = Se.getNamedItem("data-anim-type") ? Se.getNamedItem("data-anim-type").value : Se.getNamedItem("data-bm-type") ? Se.getNamedItem("data-bm-type").value : Se.getNamedItem("bm-type") ? Se.getNamedItem("bm-type").value : Se.getNamedItem("data-bm-renderer") ? Se.getNamedItem("data-bm-renderer").value : Se.getNamedItem("bm-renderer") ? Se.getNamedItem("bm-renderer").value : getRegisteredRenderer() || "canvas";
        var xe = Se.getNamedItem("data-anim-loop") ? Se.getNamedItem("data-anim-loop").value : Se.getNamedItem("data-bm-loop") ? Se.getNamedItem("data-bm-loop").value : Se.getNamedItem("bm-loop") ? Se.getNamedItem("bm-loop").value : "";
        xe === "false" ? ke.loop = !1 : xe === "true" ? ke.loop = !0 : xe !== "" && (ke.loop = parseInt(xe, 10));
        var Ie = Se.getNamedItem("data-anim-autoplay") ? Se.getNamedItem("data-anim-autoplay").value : Se.getNamedItem("data-bm-autoplay") ? Se.getNamedItem("data-bm-autoplay").value : Se.getNamedItem("bm-autoplay") ? Se.getNamedItem("bm-autoplay").value : !0;
        ke.autoplay = Ie !== "false", ke.name = Se.getNamedItem("data-name") ? Se.getNamedItem("data-name").value : Se.getNamedItem("data-bm-name") ? Se.getNamedItem("data-bm-name").value : Se.getNamedItem("bm-name") ? Se.getNamedItem("bm-name").value : "";
        var Me = Se.getNamedItem("data-anim-prerender") ? Se.getNamedItem("data-anim-prerender").value : Se.getNamedItem("data-bm-prerender") ? Se.getNamedItem("data-bm-prerender").value : Se.getNamedItem("bm-prerender") ? Se.getNamedItem("bm-prerender").value : "";
        Me === "false" && (ke.prerender = !1), ke.path ? this.setParams(ke) : this.trigger("destroy");
      }, AnimationItem.prototype.includeLayers = function(e) {
        e.op > this.animationData.op && (this.animationData.op = e.op, this.totalFrames = Math.floor(e.op - this.animationData.ip));
        var j = this.animationData.layers, ke, Se = j.length, xe = e.layers, Ie, Me = xe.length;
        for (Ie = 0; Ie < Me; Ie += 1)
          for (ke = 0; ke < Se; ) {
            if (j[ke].id === xe[Ie].id) {
              j[ke] = xe[Ie];
              break;
            }
            ke += 1;
          }
        if ((e.chars || e.fonts) && (this.renderer.globalData.fontManager.addChars(e.chars), this.renderer.globalData.fontManager.addFonts(e.fonts, this.renderer.globalData.defs)), e.assets)
          for (Se = e.assets.length, ke = 0; ke < Se; ke += 1)
            this.animationData.assets.push(e.assets[ke]);
        this.animationData.__complete = !1, dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
      }, AnimationItem.prototype.onSegmentComplete = function(e) {
        this.animationData = e;
        var j = getExpressionsPlugin();
        j && j.initExpressions(this), this.loadNextSegment();
      }, AnimationItem.prototype.loadNextSegment = function() {
        var e = this.animationData.segments;
        if (!e || e.length === 0 || !this.autoloadSegments) {
          this.trigger("data_ready"), this.timeCompleted = this.totalFrames;
          return;
        }
        var j = e.shift();
        this.timeCompleted = j.time * this.frameRate;
        var ke = this.path + this.fileName + "_" + this.segmentPos + ".json";
        this.segmentPos += 1, dataManager.loadData(ke, this.includeLayers.bind(this), (function() {
          this.trigger("data_failed");
        }).bind(this));
      }, AnimationItem.prototype.loadSegments = function() {
        var e = this.animationData.segments;
        e || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
      }, AnimationItem.prototype.imagesLoaded = function() {
        this.trigger("loaded_images"), this.checkLoaded();
      }, AnimationItem.prototype.preloadImages = function() {
        this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
      }, AnimationItem.prototype.configAnimation = function(e) {
        if (this.renderer)
          try {
            this.animationData = e, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(e), e.assets || (e.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(e.assets), this.markers = markerParser(e.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
          } catch (j) {
            this.triggerConfigError(j);
          }
      }, AnimationItem.prototype.waitForFontsLoaded = function() {
        this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
      }, AnimationItem.prototype.checkLoaded = function() {
        if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== "canvas") && this.imagePreloader.loadedFootages()) {
          this.isLoaded = !0;
          var e = getExpressionsPlugin();
          e && e.initExpressions(this), this.renderer.initItems(), setTimeout((function() {
            this.trigger("DOMLoaded");
          }).bind(this), 0), this.gotoFrame(), this.autoplay && this.play();
        }
      }, AnimationItem.prototype.resize = function(e, j) {
        var ke = typeof e == "number" ? e : void 0, Se = typeof j == "number" ? j : void 0;
        this.renderer.updateContainerSize(ke, Se);
      }, AnimationItem.prototype.setSubframe = function(e) {
        this.isSubframeEnabled = !!e;
      }, AnimationItem.prototype.gotoFrame = function() {
        this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
      }, AnimationItem.prototype.renderFrame = function() {
        if (!(this.isLoaded === !1 || !this.renderer))
          try {
            this.expressionsPlugin && this.expressionsPlugin.resetFrame(), this.renderer.renderFrame(this.currentFrame + this.firstFrame);
          } catch (e) {
            this.triggerRenderFrameError(e);
          }
      }, AnimationItem.prototype.play = function(e) {
        e && this.name !== e || this.isPaused === !0 && (this.isPaused = !1, this.trigger("_play"), this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
      }, AnimationItem.prototype.pause = function(e) {
        e && this.name !== e || this.isPaused === !1 && (this.isPaused = !0, this.trigger("_pause"), this._idle = !0, this.trigger("_idle"), this.audioController.pause());
      }, AnimationItem.prototype.togglePause = function(e) {
        e && this.name !== e || (this.isPaused === !0 ? this.play() : this.pause());
      }, AnimationItem.prototype.stop = function(e) {
        e && this.name !== e || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
      }, AnimationItem.prototype.getMarkerData = function(e) {
        for (var j, ke = 0; ke < this.markers.length; ke += 1)
          if (j = this.markers[ke], j.payload && j.payload.name === e)
            return j;
        return null;
      }, AnimationItem.prototype.goToAndStop = function(e, j, ke) {
        if (!(ke && this.name !== ke)) {
          var Se = Number(e);
          if (isNaN(Se)) {
            var xe = this.getMarkerData(e);
            xe && this.goToAndStop(xe.time, !0);
          } else j ? this.setCurrentRawFrameValue(e) : this.setCurrentRawFrameValue(e * this.frameModifier);
          this.pause();
        }
      }, AnimationItem.prototype.goToAndPlay = function(e, j, ke) {
        if (!(ke && this.name !== ke)) {
          var Se = Number(e);
          if (isNaN(Se)) {
            var xe = this.getMarkerData(e);
            xe && (xe.duration ? this.playSegments([xe.time, xe.time + xe.duration], !0) : this.goToAndStop(xe.time, !0));
          } else
            this.goToAndStop(Se, j, ke);
          this.play();
        }
      }, AnimationItem.prototype.advanceTime = function(e) {
        if (!(this.isPaused === !0 || this.isLoaded === !1)) {
          var j = this.currentRawFrame + e * this.frameModifier, ke = !1;
          j >= this.totalFrames - 1 && this.frameModifier > 0 ? !this.loop || this.playCount === this.loop ? this.checkSegments(j > this.totalFrames ? j % this.totalFrames : 0) || (ke = !0, j = this.totalFrames - 1) : j >= this.totalFrames ? (this.playCount += 1, this.checkSegments(j % this.totalFrames) || (this.setCurrentRawFrameValue(j % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(j) : j < 0 ? this.checkSegments(j % this.totalFrames) || (this.loop && !(this.playCount-- <= 0 && this.loop !== !0) ? (this.setCurrentRawFrameValue(this.totalFrames + j % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0) : (ke = !0, j = 0)) : this.setCurrentRawFrameValue(j), ke && (this.setCurrentRawFrameValue(j), this.pause(), this.trigger("complete"));
        }
      }, AnimationItem.prototype.adjustSegment = function(e, j) {
        this.playCount = 0, e[1] < e[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = e[0] - e[1], this.timeCompleted = this.totalFrames, this.firstFrame = e[1], this.setCurrentRawFrameValue(this.totalFrames - 1e-3 - j)) : e[1] > e[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = e[1] - e[0], this.timeCompleted = this.totalFrames, this.firstFrame = e[0], this.setCurrentRawFrameValue(1e-3 + j)), this.trigger("segmentStart");
      }, AnimationItem.prototype.setSegment = function(e, j) {
        var ke = -1;
        this.isPaused && (this.currentRawFrame + this.firstFrame < e ? ke = e : this.currentRawFrame + this.firstFrame > j && (ke = j - e)), this.firstFrame = e, this.totalFrames = j - e, this.timeCompleted = this.totalFrames, ke !== -1 && this.goToAndStop(ke, !0);
      }, AnimationItem.prototype.playSegments = function(e, j) {
        if (j && (this.segments.length = 0), _typeof$4(e[0]) === "object") {
          var ke, Se = e.length;
          for (ke = 0; ke < Se; ke += 1)
            this.segments.push(e[ke]);
        } else
          this.segments.push(e);
        this.segments.length && j && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
      }, AnimationItem.prototype.resetSegments = function(e) {
        this.segments.length = 0, this.segments.push([this.animationData.ip, this.animationData.op]), e && this.checkSegments(0);
      }, AnimationItem.prototype.checkSegments = function(e) {
        return this.segments.length ? (this.adjustSegment(this.segments.shift(), e), !0) : !1;
      }, AnimationItem.prototype.destroy = function(e) {
        e && this.name !== e || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.expressionsPlugin = null, this.imagePreloader = null, this.projectInterface = null);
      }, AnimationItem.prototype.setCurrentRawFrameValue = function(e) {
        this.currentRawFrame = e, this.gotoFrame();
      }, AnimationItem.prototype.setSpeed = function(e) {
        this.playSpeed = e, this.updaFrameModifier();
      }, AnimationItem.prototype.setDirection = function(e) {
        this.playDirection = e < 0 ? -1 : 1, this.updaFrameModifier();
      }, AnimationItem.prototype.setLoop = function(e) {
        this.loop = e;
      }, AnimationItem.prototype.setVolume = function(e, j) {
        j && this.name !== j || this.audioController.setVolume(e);
      }, AnimationItem.prototype.getVolume = function() {
        return this.audioController.getVolume();
      }, AnimationItem.prototype.mute = function(e) {
        e && this.name !== e || this.audioController.mute();
      }, AnimationItem.prototype.unmute = function(e) {
        e && this.name !== e || this.audioController.unmute();
      }, AnimationItem.prototype.updaFrameModifier = function() {
        this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
      }, AnimationItem.prototype.getPath = function() {
        return this.path;
      }, AnimationItem.prototype.getAssetsPath = function(e) {
        var j = "";
        if (e.e)
          j = e.p;
        else if (this.assetsPath) {
          var ke = e.p;
          ke.indexOf("images/") !== -1 && (ke = ke.split("/")[1]), j = this.assetsPath + ke;
        } else
          j = this.path, j += e.u ? e.u : "", j += e.p;
        return j;
      }, AnimationItem.prototype.getAssetData = function(e) {
        for (var j = 0, ke = this.assets.length; j < ke; ) {
          if (e === this.assets[j].id)
            return this.assets[j];
          j += 1;
        }
        return null;
      }, AnimationItem.prototype.hide = function() {
        this.renderer.hide();
      }, AnimationItem.prototype.show = function() {
        this.renderer.show();
      }, AnimationItem.prototype.getDuration = function(e) {
        return e ? this.totalFrames : this.totalFrames / this.frameRate;
      }, AnimationItem.prototype.updateDocumentData = function(e, j, ke) {
        try {
          var Se = this.renderer.getElementByPath(e);
          Se.updateDocumentData(j, ke);
        } catch {
        }
      }, AnimationItem.prototype.trigger = function(e) {
        if (this._cbs && this._cbs[e])
          switch (e) {
            case "enterFrame":
              this.triggerEvent(e, new BMEnterFrameEvent(e, this.currentFrame, this.totalFrames, this.frameModifier));
              break;
            case "drawnFrame":
              this.drawnFrameEvent.currentTime = this.currentFrame, this.drawnFrameEvent.totalTime = this.totalFrames, this.drawnFrameEvent.direction = this.frameModifier, this.triggerEvent(e, this.drawnFrameEvent);
              break;
            case "loopComplete":
              this.triggerEvent(e, new BMCompleteLoopEvent(e, this.loop, this.playCount, this.frameMult));
              break;
            case "complete":
              this.triggerEvent(e, new BMCompleteEvent(e, this.frameMult));
              break;
            case "segmentStart":
              this.triggerEvent(e, new BMSegmentStartEvent(e, this.firstFrame, this.totalFrames));
              break;
            case "destroy":
              this.triggerEvent(e, new BMDestroyEvent(e, this));
              break;
            default:
              this.triggerEvent(e);
          }
        e === "enterFrame" && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(e, this.currentFrame, this.totalFrames, this.frameMult)), e === "loopComplete" && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(e, this.loop, this.playCount, this.frameMult)), e === "complete" && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(e, this.frameMult)), e === "segmentStart" && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(e, this.firstFrame, this.totalFrames)), e === "destroy" && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(e, this));
      }, AnimationItem.prototype.triggerRenderFrameError = function(e) {
        var j = new BMRenderFrameErrorEvent(e, this.currentFrame);
        this.triggerEvent("error", j), this.onError && this.onError.call(this, j);
      }, AnimationItem.prototype.triggerConfigError = function(e) {
        var j = new BMConfigErrorEvent(e, this.currentFrame);
        this.triggerEvent("error", j), this.onError && this.onError.call(this, j);
      };
      var animationManager = function() {
        var e = {}, j = [], ke = 0, Se = 0, xe = 0, Ie = !0, Me = !1;
        function Ee(kt) {
          for (var Et = 0, Qe = kt.target; Et < Se; )
            j[Et].animation === Qe && (j.splice(Et, 1), Et -= 1, Se -= 1, Qe.isPaused || Fe()), Et += 1;
        }
        function Be(kt, Et) {
          if (!kt)
            return null;
          for (var Qe = 0; Qe < Se; ) {
            if (j[Qe].elem === kt && j[Qe].elem !== null)
              return j[Qe].animation;
            Qe += 1;
          }
          var Xe = new AnimationItem();
          return Ve(Xe, kt), Xe.setData(kt, Et), Xe;
        }
        function $e() {
          var kt, Et = j.length, Qe = [];
          for (kt = 0; kt < Et; kt += 1)
            Qe.push(j[kt].animation);
          return Qe;
        }
        function Le() {
          xe += 1, Nt();
        }
        function Fe() {
          xe -= 1;
        }
        function Ve(kt, Et) {
          kt.addEventListener("destroy", Ee), kt.addEventListener("_active", Le), kt.addEventListener("_idle", Fe), j.push({
            elem: Et,
            animation: kt
          }), Se += 1;
        }
        function je(kt) {
          var Et = new AnimationItem();
          return Ve(Et, null), Et.setParams(kt), Et;
        }
        function Ge(kt, Et) {
          var Qe;
          for (Qe = 0; Qe < Se; Qe += 1)
            j[Qe].animation.setSpeed(kt, Et);
        }
        function De(kt, Et) {
          var Qe;
          for (Qe = 0; Qe < Se; Qe += 1)
            j[Qe].animation.setDirection(kt, Et);
        }
        function Ue(kt) {
          var Et;
          for (Et = 0; Et < Se; Et += 1)
            j[Et].animation.play(kt);
        }
        function Re(kt) {
          var Et = kt - ke, Qe;
          for (Qe = 0; Qe < Se; Qe += 1)
            j[Qe].animation.advanceTime(Et);
          ke = kt, xe && !Me ? window.requestAnimationFrame(Re) : Ie = !0;
        }
        function Ye(kt) {
          ke = kt, window.requestAnimationFrame(Re);
        }
        function We(kt) {
          var Et;
          for (Et = 0; Et < Se; Et += 1)
            j[Et].animation.pause(kt);
        }
        function qe(kt, Et, Qe) {
          var Xe;
          for (Xe = 0; Xe < Se; Xe += 1)
            j[Xe].animation.goToAndStop(kt, Et, Qe);
        }
        function Je(kt) {
          var Et;
          for (Et = 0; Et < Se; Et += 1)
            j[Et].animation.stop(kt);
        }
        function Ke(kt) {
          var Et;
          for (Et = 0; Et < Se; Et += 1)
            j[Et].animation.togglePause(kt);
        }
        function xt(kt) {
          var Et;
          for (Et = Se - 1; Et >= 0; Et -= 1)
            j[Et].animation.destroy(kt);
        }
        function Ct(kt, Et, Qe) {
          var Xe = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))), Vt, Lt = Xe.length;
          for (Vt = 0; Vt < Lt; Vt += 1)
            Qe && Xe[Vt].setAttribute("data-bm-type", Qe), Be(Xe[Vt], kt);
          if (Et && Lt === 0) {
            Qe || (Qe = "svg");
            var Gt = document.getElementsByTagName("body")[0];
            Gt.innerText = "";
            var Wt = createTag("div");
            Wt.style.width = "100%", Wt.style.height = "100%", Wt.setAttribute("data-bm-type", Qe), Gt.appendChild(Wt), Be(Wt, kt);
          }
        }
        function It() {
          var kt;
          for (kt = 0; kt < Se; kt += 1)
            j[kt].animation.resize();
        }
        function Nt() {
          !Me && xe && Ie && (window.requestAnimationFrame(Ye), Ie = !1);
        }
        function Bt() {
          Me = !0;
        }
        function At() {
          Me = !1, Nt();
        }
        function Ft(kt, Et) {
          var Qe;
          for (Qe = 0; Qe < Se; Qe += 1)
            j[Qe].animation.setVolume(kt, Et);
        }
        function Dt(kt) {
          var Et;
          for (Et = 0; Et < Se; Et += 1)
            j[Et].animation.mute(kt);
        }
        function zt(kt) {
          var Et;
          for (Et = 0; Et < Se; Et += 1)
            j[Et].animation.unmute(kt);
        }
        return e.registerAnimation = Be, e.loadAnimation = je, e.setSpeed = Ge, e.setDirection = De, e.play = Ue, e.pause = We, e.stop = Je, e.togglePause = Ke, e.searchAnimations = Ct, e.resize = It, e.goToAndStop = qe, e.destroy = xt, e.freeze = Bt, e.unfreeze = At, e.setVolume = Ft, e.mute = Dt, e.unmute = zt, e.getRegisteredAnimations = $e, e;
      }(), BezierFactory = function() {
        var e = {};
        e.getBezierEasing = ke;
        var j = {};
        function ke(Ye, We, qe, Je, Ke) {
          var xt = Ke || ("bez_" + Ye + "_" + We + "_" + qe + "_" + Je).replace(/\./g, "p");
          if (j[xt])
            return j[xt];
          var Ct = new Re([Ye, We, qe, Je]);
          return j[xt] = Ct, Ct;
        }
        var Se = 4, xe = 1e-3, Ie = 1e-7, Me = 10, Ee = 11, Be = 1 / (Ee - 1), $e = typeof Float32Array == "function";
        function Le(Ye, We) {
          return 1 - 3 * We + 3 * Ye;
        }
        function Fe(Ye, We) {
          return 3 * We - 6 * Ye;
        }
        function Ve(Ye) {
          return 3 * Ye;
        }
        function je(Ye, We, qe) {
          return ((Le(We, qe) * Ye + Fe(We, qe)) * Ye + Ve(We)) * Ye;
        }
        function Ge(Ye, We, qe) {
          return 3 * Le(We, qe) * Ye * Ye + 2 * Fe(We, qe) * Ye + Ve(We);
        }
        function De(Ye, We, qe, Je, Ke) {
          var xt, Ct, It = 0;
          do
            Ct = We + (qe - We) / 2, xt = je(Ct, Je, Ke) - Ye, xt > 0 ? qe = Ct : We = Ct;
          while (Math.abs(xt) > Ie && ++It < Me);
          return Ct;
        }
        function Ue(Ye, We, qe, Je) {
          for (var Ke = 0; Ke < Se; ++Ke) {
            var xt = Ge(We, qe, Je);
            if (xt === 0) return We;
            var Ct = je(We, qe, Je) - Ye;
            We -= Ct / xt;
          }
          return We;
        }
        function Re(Ye) {
          this._p = Ye, this._mSampleValues = $e ? new Float32Array(Ee) : new Array(Ee), this._precomputed = !1, this.get = this.get.bind(this);
        }
        return Re.prototype = {
          get: function(We) {
            var qe = this._p[0], Je = this._p[1], Ke = this._p[2], xt = this._p[3];
            return this._precomputed || this._precompute(), qe === Je && Ke === xt ? We : We === 0 ? 0 : We === 1 ? 1 : je(this._getTForX(We), Je, xt);
          },
          // Private part
          _precompute: function() {
            var We = this._p[0], qe = this._p[1], Je = this._p[2], Ke = this._p[3];
            this._precomputed = !0, (We !== qe || Je !== Ke) && this._calcSampleValues();
          },
          _calcSampleValues: function() {
            for (var We = this._p[0], qe = this._p[2], Je = 0; Je < Ee; ++Je)
              this._mSampleValues[Je] = je(Je * Be, We, qe);
          },
          /**
               * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
               */
          _getTForX: function(We) {
            for (var qe = this._p[0], Je = this._p[2], Ke = this._mSampleValues, xt = 0, Ct = 1, It = Ee - 1; Ct !== It && Ke[Ct] <= We; ++Ct)
              xt += Be;
            --Ct;
            var Nt = (We - Ke[Ct]) / (Ke[Ct + 1] - Ke[Ct]), Bt = xt + Nt * Be, At = Ge(Bt, qe, Je);
            return At >= xe ? Ue(We, Bt, qe, Je) : At === 0 ? Bt : De(We, xt, xt + Be, qe, Je);
          }
        }, e;
      }(), pooling = /* @__PURE__ */ function() {
        function e(j) {
          return j.concat(createSizedArray(j.length));
        }
        return {
          double: e
        };
      }(), poolFactory = /* @__PURE__ */ function() {
        return function(e, j, ke) {
          var Se = 0, xe = e, Ie = createSizedArray(xe), Me = {
            newElement: Ee,
            release: Be
          };
          function Ee() {
            var $e;
            return Se ? (Se -= 1, $e = Ie[Se]) : $e = j(), $e;
          }
          function Be($e) {
            Se === xe && (Ie = pooling.double(Ie), xe *= 2), ke && ke($e), Ie[Se] = $e, Se += 1;
          }
          return Me;
        };
      }(), bezierLengthPool = function() {
        function e() {
          return {
            addedLength: 0,
            percents: createTypedArray("float32", getDefaultCurveSegments()),
            lengths: createTypedArray("float32", getDefaultCurveSegments())
          };
        }
        return poolFactory(8, e);
      }(), segmentsLengthPool = function() {
        function e() {
          return {
            lengths: [],
            totalLength: 0
          };
        }
        function j(ke) {
          var Se, xe = ke.lengths.length;
          for (Se = 0; Se < xe; Se += 1)
            bezierLengthPool.release(ke.lengths[Se]);
          ke.lengths.length = 0;
        }
        return poolFactory(8, e, j);
      }();
      function bezFunction() {
        var e = Math;
        function j(Ve, je, Ge, De, Ue, Re) {
          var Ye = Ve * De + je * Ue + Ge * Re - Ue * De - Re * Ve - Ge * je;
          return Ye > -1e-3 && Ye < 1e-3;
        }
        function ke(Ve, je, Ge, De, Ue, Re, Ye, We, qe) {
          if (Ge === 0 && Re === 0 && qe === 0)
            return j(Ve, je, De, Ue, Ye, We);
          var Je = e.sqrt(e.pow(De - Ve, 2) + e.pow(Ue - je, 2) + e.pow(Re - Ge, 2)), Ke = e.sqrt(e.pow(Ye - Ve, 2) + e.pow(We - je, 2) + e.pow(qe - Ge, 2)), xt = e.sqrt(e.pow(Ye - De, 2) + e.pow(We - Ue, 2) + e.pow(qe - Re, 2)), Ct;
          return Je > Ke ? Je > xt ? Ct = Je - Ke - xt : Ct = xt - Ke - Je : xt > Ke ? Ct = xt - Ke - Je : Ct = Ke - Je - xt, Ct > -1e-4 && Ct < 1e-4;
        }
        var Se = /* @__PURE__ */ function() {
          return function(Ve, je, Ge, De) {
            var Ue = getDefaultCurveSegments(), Re, Ye, We, qe, Je, Ke = 0, xt, Ct = [], It = [], Nt = bezierLengthPool.newElement();
            for (We = Ge.length, Re = 0; Re < Ue; Re += 1) {
              for (Je = Re / (Ue - 1), xt = 0, Ye = 0; Ye < We; Ye += 1)
                qe = bmPow(1 - Je, 3) * Ve[Ye] + 3 * bmPow(1 - Je, 2) * Je * Ge[Ye] + 3 * (1 - Je) * bmPow(Je, 2) * De[Ye] + bmPow(Je, 3) * je[Ye], Ct[Ye] = qe, It[Ye] !== null && (xt += bmPow(Ct[Ye] - It[Ye], 2)), It[Ye] = Ct[Ye];
              xt && (xt = bmSqrt(xt), Ke += xt), Nt.percents[Re] = Je, Nt.lengths[Re] = Ke;
            }
            return Nt.addedLength = Ke, Nt;
          };
        }();
        function xe(Ve) {
          var je = segmentsLengthPool.newElement(), Ge = Ve.c, De = Ve.v, Ue = Ve.o, Re = Ve.i, Ye, We = Ve._length, qe = je.lengths, Je = 0;
          for (Ye = 0; Ye < We - 1; Ye += 1)
            qe[Ye] = Se(De[Ye], De[Ye + 1], Ue[Ye], Re[Ye + 1]), Je += qe[Ye].addedLength;
          return Ge && We && (qe[Ye] = Se(De[Ye], De[0], Ue[Ye], Re[0]), Je += qe[Ye].addedLength), je.totalLength = Je, je;
        }
        function Ie(Ve) {
          this.segmentLength = 0, this.points = new Array(Ve);
        }
        function Me(Ve, je) {
          this.partialLength = Ve, this.point = je;
        }
        var Ee = /* @__PURE__ */ function() {
          var Ve = {};
          return function(je, Ge, De, Ue) {
            var Re = (je[0] + "_" + je[1] + "_" + Ge[0] + "_" + Ge[1] + "_" + De[0] + "_" + De[1] + "_" + Ue[0] + "_" + Ue[1]).replace(/\./g, "p");
            if (!Ve[Re]) {
              var Ye = getDefaultCurveSegments(), We, qe, Je, Ke, xt, Ct = 0, It, Nt, Bt = null;
              je.length === 2 && (je[0] !== Ge[0] || je[1] !== Ge[1]) && j(je[0], je[1], Ge[0], Ge[1], je[0] + De[0], je[1] + De[1]) && j(je[0], je[1], Ge[0], Ge[1], Ge[0] + Ue[0], Ge[1] + Ue[1]) && (Ye = 2);
              var At = new Ie(Ye);
              for (Je = De.length, We = 0; We < Ye; We += 1) {
                for (Nt = createSizedArray(Je), xt = We / (Ye - 1), It = 0, qe = 0; qe < Je; qe += 1)
                  Ke = bmPow(1 - xt, 3) * je[qe] + 3 * bmPow(1 - xt, 2) * xt * (je[qe] + De[qe]) + 3 * (1 - xt) * bmPow(xt, 2) * (Ge[qe] + Ue[qe]) + bmPow(xt, 3) * Ge[qe], Nt[qe] = Ke, Bt !== null && (It += bmPow(Nt[qe] - Bt[qe], 2));
                It = bmSqrt(It), Ct += It, At.points[We] = new Me(It, Nt), Bt = Nt;
              }
              At.segmentLength = Ct, Ve[Re] = At;
            }
            return Ve[Re];
          };
        }();
        function Be(Ve, je) {
          var Ge = je.percents, De = je.lengths, Ue = Ge.length, Re = bmFloor((Ue - 1) * Ve), Ye = Ve * je.addedLength, We = 0;
          if (Re === Ue - 1 || Re === 0 || Ye === De[Re])
            return Ge[Re];
          for (var qe = De[Re] > Ye ? -1 : 1, Je = !0; Je; )
            if (De[Re] <= Ye && De[Re + 1] > Ye ? (We = (Ye - De[Re]) / (De[Re + 1] - De[Re]), Je = !1) : Re += qe, Re < 0 || Re >= Ue - 1) {
              if (Re === Ue - 1)
                return Ge[Re];
              Je = !1;
            }
          return Ge[Re] + (Ge[Re + 1] - Ge[Re]) * We;
        }
        function $e(Ve, je, Ge, De, Ue, Re) {
          var Ye = Be(Ue, Re), We = 1 - Ye, qe = e.round((We * We * We * Ve[0] + (Ye * We * We + We * Ye * We + We * We * Ye) * Ge[0] + (Ye * Ye * We + We * Ye * Ye + Ye * We * Ye) * De[0] + Ye * Ye * Ye * je[0]) * 1e3) / 1e3, Je = e.round((We * We * We * Ve[1] + (Ye * We * We + We * Ye * We + We * We * Ye) * Ge[1] + (Ye * Ye * We + We * Ye * Ye + Ye * We * Ye) * De[1] + Ye * Ye * Ye * je[1]) * 1e3) / 1e3;
          return [qe, Je];
        }
        var Le = createTypedArray("float32", 8);
        function Fe(Ve, je, Ge, De, Ue, Re, Ye) {
          Ue < 0 ? Ue = 0 : Ue > 1 && (Ue = 1);
          var We = Be(Ue, Ye);
          Re = Re > 1 ? 1 : Re;
          var qe = Be(Re, Ye), Je, Ke = Ve.length, xt = 1 - We, Ct = 1 - qe, It = xt * xt * xt, Nt = We * xt * xt * 3, Bt = We * We * xt * 3, At = We * We * We, Ft = xt * xt * Ct, Dt = We * xt * Ct + xt * We * Ct + xt * xt * qe, zt = We * We * Ct + xt * We * qe + We * xt * qe, kt = We * We * qe, Et = xt * Ct * Ct, Qe = We * Ct * Ct + xt * qe * Ct + xt * Ct * qe, Xe = We * qe * Ct + xt * qe * qe + We * Ct * qe, Vt = We * qe * qe, Lt = Ct * Ct * Ct, Gt = qe * Ct * Ct + Ct * qe * Ct + Ct * Ct * qe, Wt = qe * qe * Ct + Ct * qe * qe + qe * Ct * qe, Zt = qe * qe * qe;
          for (Je = 0; Je < Ke; Je += 1)
            Le[Je * 4] = e.round((It * Ve[Je] + Nt * Ge[Je] + Bt * De[Je] + At * je[Je]) * 1e3) / 1e3, Le[Je * 4 + 1] = e.round((Ft * Ve[Je] + Dt * Ge[Je] + zt * De[Je] + kt * je[Je]) * 1e3) / 1e3, Le[Je * 4 + 2] = e.round((Et * Ve[Je] + Qe * Ge[Je] + Xe * De[Je] + Vt * je[Je]) * 1e3) / 1e3, Le[Je * 4 + 3] = e.round((Lt * Ve[Je] + Gt * Ge[Je] + Wt * De[Je] + Zt * je[Je]) * 1e3) / 1e3;
          return Le;
        }
        return {
          getSegmentsLength: xe,
          getNewSegment: Fe,
          getPointInSegment: $e,
          buildBezierData: Ee,
          pointOnLine2D: j,
          pointOnLine3D: ke
        };
      }
      var bez = bezFunction(), initFrame = initialDefaultFrame, mathAbs = Math.abs;
      function interpolateValue(e, j) {
        var ke = this.offsetTime, Se;
        this.propType === "multidimensional" && (Se = createTypedArray("float32", this.pv.length));
        for (var xe = j.lastIndex, Ie = xe, Me = this.keyframes.length - 1, Ee = !0, Be, $e, Le; Ee; ) {
          if (Be = this.keyframes[Ie], $e = this.keyframes[Ie + 1], Ie === Me - 1 && e >= $e.t - ke) {
            Be.h && (Be = $e), xe = 0;
            break;
          }
          if ($e.t - ke > e) {
            xe = Ie;
            break;
          }
          Ie < Me - 1 ? Ie += 1 : (xe = 0, Ee = !1);
        }
        Le = this.keyframesMetadata[Ie] || {};
        var Fe, Ve, je, Ge, De, Ue, Re = $e.t - ke, Ye = Be.t - ke, We;
        if (Be.to) {
          Le.bezierData || (Le.bezierData = bez.buildBezierData(Be.s, $e.s || Be.e, Be.to, Be.ti));
          var qe = Le.bezierData;
          if (e >= Re || e < Ye) {
            var Je = e >= Re ? qe.points.length - 1 : 0;
            for (Ve = qe.points[Je].point.length, Fe = 0; Fe < Ve; Fe += 1)
              Se[Fe] = qe.points[Je].point[Fe];
          } else {
            Le.__fnct ? Ue = Le.__fnct : (Ue = BezierFactory.getBezierEasing(Be.o.x, Be.o.y, Be.i.x, Be.i.y, Be.n).get, Le.__fnct = Ue), je = Ue((e - Ye) / (Re - Ye));
            var Ke = qe.segmentLength * je, xt, Ct = j.lastFrame < e && j._lastKeyframeIndex === Ie ? j._lastAddedLength : 0;
            for (De = j.lastFrame < e && j._lastKeyframeIndex === Ie ? j._lastPoint : 0, Ee = !0, Ge = qe.points.length; Ee; ) {
              if (Ct += qe.points[De].partialLength, Ke === 0 || je === 0 || De === qe.points.length - 1) {
                for (Ve = qe.points[De].point.length, Fe = 0; Fe < Ve; Fe += 1)
                  Se[Fe] = qe.points[De].point[Fe];
                break;
              } else if (Ke >= Ct && Ke < Ct + qe.points[De + 1].partialLength) {
                for (xt = (Ke - Ct) / qe.points[De + 1].partialLength, Ve = qe.points[De].point.length, Fe = 0; Fe < Ve; Fe += 1)
                  Se[Fe] = qe.points[De].point[Fe] + (qe.points[De + 1].point[Fe] - qe.points[De].point[Fe]) * xt;
                break;
              }
              De < Ge - 1 ? De += 1 : Ee = !1;
            }
            j._lastPoint = De, j._lastAddedLength = Ct - qe.points[De].partialLength, j._lastKeyframeIndex = Ie;
          }
        } else {
          var It, Nt, Bt, At, Ft;
          if (Me = Be.s.length, We = $e.s || Be.e, this.sh && Be.h !== 1)
            if (e >= Re)
              Se[0] = We[0], Se[1] = We[1], Se[2] = We[2];
            else if (e <= Ye)
              Se[0] = Be.s[0], Se[1] = Be.s[1], Se[2] = Be.s[2];
            else {
              var Dt = createQuaternion(Be.s), zt = createQuaternion(We), kt = (e - Ye) / (Re - Ye);
              quaternionToEuler(Se, slerp(Dt, zt, kt));
            }
          else
            for (Ie = 0; Ie < Me; Ie += 1)
              Be.h !== 1 && (e >= Re ? je = 1 : e < Ye ? je = 0 : (Be.o.x.constructor === Array ? (Le.__fnct || (Le.__fnct = []), Le.__fnct[Ie] ? Ue = Le.__fnct[Ie] : (It = Be.o.x[Ie] === void 0 ? Be.o.x[0] : Be.o.x[Ie], Nt = Be.o.y[Ie] === void 0 ? Be.o.y[0] : Be.o.y[Ie], Bt = Be.i.x[Ie] === void 0 ? Be.i.x[0] : Be.i.x[Ie], At = Be.i.y[Ie] === void 0 ? Be.i.y[0] : Be.i.y[Ie], Ue = BezierFactory.getBezierEasing(It, Nt, Bt, At).get, Le.__fnct[Ie] = Ue)) : Le.__fnct ? Ue = Le.__fnct : (It = Be.o.x, Nt = Be.o.y, Bt = Be.i.x, At = Be.i.y, Ue = BezierFactory.getBezierEasing(It, Nt, Bt, At).get, Be.keyframeMetadata = Ue), je = Ue((e - Ye) / (Re - Ye)))), We = $e.s || Be.e, Ft = Be.h === 1 ? Be.s[Ie] : Be.s[Ie] + (We[Ie] - Be.s[Ie]) * je, this.propType === "multidimensional" ? Se[Ie] = Ft : Se = Ft;
        }
        return j.lastIndex = xe, Se;
      }
      function slerp(e, j, ke) {
        var Se = [], xe = e[0], Ie = e[1], Me = e[2], Ee = e[3], Be = j[0], $e = j[1], Le = j[2], Fe = j[3], Ve, je, Ge, De, Ue;
        return je = xe * Be + Ie * $e + Me * Le + Ee * Fe, je < 0 && (je = -je, Be = -Be, $e = -$e, Le = -Le, Fe = -Fe), 1 - je > 1e-6 ? (Ve = Math.acos(je), Ge = Math.sin(Ve), De = Math.sin((1 - ke) * Ve) / Ge, Ue = Math.sin(ke * Ve) / Ge) : (De = 1 - ke, Ue = ke), Se[0] = De * xe + Ue * Be, Se[1] = De * Ie + Ue * $e, Se[2] = De * Me + Ue * Le, Se[3] = De * Ee + Ue * Fe, Se;
      }
      function quaternionToEuler(e, j) {
        var ke = j[0], Se = j[1], xe = j[2], Ie = j[3], Me = Math.atan2(2 * Se * Ie - 2 * ke * xe, 1 - 2 * Se * Se - 2 * xe * xe), Ee = Math.asin(2 * ke * Se + 2 * xe * Ie), Be = Math.atan2(2 * ke * Ie - 2 * Se * xe, 1 - 2 * ke * ke - 2 * xe * xe);
        e[0] = Me / degToRads, e[1] = Ee / degToRads, e[2] = Be / degToRads;
      }
      function createQuaternion(e) {
        var j = e[0] * degToRads, ke = e[1] * degToRads, Se = e[2] * degToRads, xe = Math.cos(j / 2), Ie = Math.cos(ke / 2), Me = Math.cos(Se / 2), Ee = Math.sin(j / 2), Be = Math.sin(ke / 2), $e = Math.sin(Se / 2), Le = xe * Ie * Me - Ee * Be * $e, Fe = Ee * Be * Me + xe * Ie * $e, Ve = Ee * Ie * Me + xe * Be * $e, je = xe * Be * Me - Ee * Ie * $e;
        return [Fe, Ve, je, Le];
      }
      function getValueAtCurrentTime() {
        var e = this.comp.renderedFrame - this.offsetTime, j = this.keyframes[0].t - this.offsetTime, ke = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
        if (!(e === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= ke && e >= ke || this._caching.lastFrame < j && e < j))) {
          this._caching.lastFrame >= e && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
          var Se = this.interpolateValue(e, this._caching);
          this.pv = Se;
        }
        return this._caching.lastFrame = e, this.pv;
      }
      function setVValue(e) {
        var j;
        if (this.propType === "unidimensional")
          j = e * this.mult, mathAbs(this.v - j) > 1e-5 && (this.v = j, this._mdf = !0);
        else
          for (var ke = 0, Se = this.v.length; ke < Se; )
            j = e[ke] * this.mult, mathAbs(this.v[ke] - j) > 1e-5 && (this.v[ke] = j, this._mdf = !0), ke += 1;
      }
      function processEffectsSequence() {
        if (!(this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length)) {
          if (this.lock) {
            this.setVValue(this.pv);
            return;
          }
          this.lock = !0, this._mdf = this._isFirstFrame;
          var e, j = this.effectsSequence.length, ke = this.kf ? this.pv : this.data.k;
          for (e = 0; e < j; e += 1)
            ke = this.effectsSequence[e](ke);
          this.setVValue(ke), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
        }
      }
      function addEffect(e) {
        this.effectsSequence.push(e), this.container.addDynamicProperty(this);
      }
      function ValueProperty(e, j, ke, Se) {
        this.propType = "unidimensional", this.mult = ke || 1, this.data = j, this.v = ke ? j.k * ke : j.k, this.pv = j.k, this._mdf = !1, this.elem = e, this.container = Se, this.comp = e.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
      }
      function MultiDimensionalProperty(e, j, ke, Se) {
        this.propType = "multidimensional", this.mult = ke || 1, this.data = j, this._mdf = !1, this.elem = e, this.container = Se, this.comp = e.comp, this.k = !1, this.kf = !1, this.frameId = -1;
        var xe, Ie = j.k.length;
        for (this.v = createTypedArray("float32", Ie), this.pv = createTypedArray("float32", Ie), this.vel = createTypedArray("float32", Ie), xe = 0; xe < Ie; xe += 1)
          this.v[xe] = j.k[xe] * this.mult, this.pv[xe] = j.k[xe];
        this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
      }
      function KeyframedValueProperty(e, j, ke, Se) {
        this.propType = "unidimensional", this.keyframes = j.k, this.keyframesMetadata = [], this.offsetTime = e.data.st, this.frameId = -1, this._caching = {
          lastFrame: initFrame,
          lastIndex: 0,
          value: 0,
          _lastKeyframeIndex: -1
        }, this.k = !0, this.kf = !0, this.data = j, this.mult = ke || 1, this.elem = e, this.container = Se, this.comp = e.comp, this.v = initFrame, this.pv = initFrame, this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.effectsSequence = [getValueAtCurrentTime.bind(this)], this.addEffect = addEffect;
      }
      function KeyframedMultidimensionalProperty(e, j, ke, Se) {
        this.propType = "multidimensional";
        var xe, Ie = j.k.length, Me, Ee, Be, $e;
        for (xe = 0; xe < Ie - 1; xe += 1)
          j.k[xe].to && j.k[xe].s && j.k[xe + 1] && j.k[xe + 1].s && (Me = j.k[xe].s, Ee = j.k[xe + 1].s, Be = j.k[xe].to, $e = j.k[xe].ti, (Me.length === 2 && !(Me[0] === Ee[0] && Me[1] === Ee[1]) && bez.pointOnLine2D(Me[0], Me[1], Ee[0], Ee[1], Me[0] + Be[0], Me[1] + Be[1]) && bez.pointOnLine2D(Me[0], Me[1], Ee[0], Ee[1], Ee[0] + $e[0], Ee[1] + $e[1]) || Me.length === 3 && !(Me[0] === Ee[0] && Me[1] === Ee[1] && Me[2] === Ee[2]) && bez.pointOnLine3D(Me[0], Me[1], Me[2], Ee[0], Ee[1], Ee[2], Me[0] + Be[0], Me[1] + Be[1], Me[2] + Be[2]) && bez.pointOnLine3D(Me[0], Me[1], Me[2], Ee[0], Ee[1], Ee[2], Ee[0] + $e[0], Ee[1] + $e[1], Ee[2] + $e[2])) && (j.k[xe].to = null, j.k[xe].ti = null), Me[0] === Ee[0] && Me[1] === Ee[1] && Be[0] === 0 && Be[1] === 0 && $e[0] === 0 && $e[1] === 0 && (Me.length === 2 || Me[2] === Ee[2] && Be[2] === 0 && $e[2] === 0) && (j.k[xe].to = null, j.k[xe].ti = null));
        this.effectsSequence = [getValueAtCurrentTime.bind(this)], this.data = j, this.keyframes = j.k, this.keyframesMetadata = [], this.offsetTime = e.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = ke || 1, this.elem = e, this.container = Se, this.comp = e.comp, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.frameId = -1;
        var Le = j.k[0].s.length;
        for (this.v = createTypedArray("float32", Le), this.pv = createTypedArray("float32", Le), xe = 0; xe < Le; xe += 1)
          this.v[xe] = initFrame, this.pv[xe] = initFrame;
        this._caching = {
          lastFrame: initFrame,
          lastIndex: 0,
          value: createTypedArray("float32", Le)
        }, this.addEffect = addEffect;
      }
      var PropertyFactory = /* @__PURE__ */ function() {
        function e(ke, Se, xe, Ie, Me) {
          Se.sid && (Se = ke.globalData.slotManager.getProp(Se));
          var Ee;
          if (!Se.k.length)
            Ee = new ValueProperty(ke, Se, Ie, Me);
          else if (typeof Se.k[0] == "number")
            Ee = new MultiDimensionalProperty(ke, Se, Ie, Me);
          else
            switch (xe) {
              case 0:
                Ee = new KeyframedValueProperty(ke, Se, Ie, Me);
                break;
              case 1:
                Ee = new KeyframedMultidimensionalProperty(ke, Se, Ie, Me);
                break;
            }
          return Ee.effectsSequence.length && Me.addDynamicProperty(Ee), Ee;
        }
        var j = {
          getProp: e
        };
        return j;
      }();
      function DynamicPropertyContainer() {
      }
      DynamicPropertyContainer.prototype = {
        addDynamicProperty: function(j) {
          this.dynamicProperties.indexOf(j) === -1 && (this.dynamicProperties.push(j), this.container.addDynamicProperty(this), this._isAnimated = !0);
        },
        iterateDynamicProperties: function() {
          this._mdf = !1;
          var j, ke = this.dynamicProperties.length;
          for (j = 0; j < ke; j += 1)
            this.dynamicProperties[j].getValue(), this.dynamicProperties[j]._mdf && (this._mdf = !0);
        },
        initDynamicPropertyContainer: function(j) {
          this.container = j, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
        }
      };
      var pointPool = function() {
        function e() {
          return createTypedArray("float32", 2);
        }
        return poolFactory(8, e);
      }();
      function ShapePath() {
        this.c = !1, this._length = 0, this._maxLength = 8, this.v = createSizedArray(this._maxLength), this.o = createSizedArray(this._maxLength), this.i = createSizedArray(this._maxLength);
      }
      ShapePath.prototype.setPathData = function(e, j) {
        this.c = e, this.setLength(j);
        for (var ke = 0; ke < j; )
          this.v[ke] = pointPool.newElement(), this.o[ke] = pointPool.newElement(), this.i[ke] = pointPool.newElement(), ke += 1;
      }, ShapePath.prototype.setLength = function(e) {
        for (; this._maxLength < e; )
          this.doubleArrayLength();
        this._length = e;
      }, ShapePath.prototype.doubleArrayLength = function() {
        this.v = this.v.concat(createSizedArray(this._maxLength)), this.i = this.i.concat(createSizedArray(this._maxLength)), this.o = this.o.concat(createSizedArray(this._maxLength)), this._maxLength *= 2;
      }, ShapePath.prototype.setXYAt = function(e, j, ke, Se, xe) {
        var Ie;
        switch (this._length = Math.max(this._length, Se + 1), this._length >= this._maxLength && this.doubleArrayLength(), ke) {
          case "v":
            Ie = this.v;
            break;
          case "i":
            Ie = this.i;
            break;
          case "o":
            Ie = this.o;
            break;
          default:
            Ie = [];
            break;
        }
        (!Ie[Se] || Ie[Se] && !xe) && (Ie[Se] = pointPool.newElement()), Ie[Se][0] = e, Ie[Se][1] = j;
      }, ShapePath.prototype.setTripleAt = function(e, j, ke, Se, xe, Ie, Me, Ee) {
        this.setXYAt(e, j, "v", Me, Ee), this.setXYAt(ke, Se, "o", Me, Ee), this.setXYAt(xe, Ie, "i", Me, Ee);
      }, ShapePath.prototype.reverse = function() {
        var e = new ShapePath();
        e.setPathData(this.c, this._length);
        var j = this.v, ke = this.o, Se = this.i, xe = 0;
        this.c && (e.setTripleAt(j[0][0], j[0][1], Se[0][0], Se[0][1], ke[0][0], ke[0][1], 0, !1), xe = 1);
        var Ie = this._length - 1, Me = this._length, Ee;
        for (Ee = xe; Ee < Me; Ee += 1)
          e.setTripleAt(j[Ie][0], j[Ie][1], Se[Ie][0], Se[Ie][1], ke[Ie][0], ke[Ie][1], Ee, !1), Ie -= 1;
        return e;
      }, ShapePath.prototype.length = function() {
        return this._length;
      };
      var shapePool = function() {
        function e() {
          return new ShapePath();
        }
        function j(xe) {
          var Ie = xe._length, Me;
          for (Me = 0; Me < Ie; Me += 1)
            pointPool.release(xe.v[Me]), pointPool.release(xe.i[Me]), pointPool.release(xe.o[Me]), xe.v[Me] = null, xe.i[Me] = null, xe.o[Me] = null;
          xe._length = 0, xe.c = !1;
        }
        function ke(xe) {
          var Ie = Se.newElement(), Me, Ee = xe._length === void 0 ? xe.v.length : xe._length;
          for (Ie.setLength(Ee), Ie.c = xe.c, Me = 0; Me < Ee; Me += 1)
            Ie.setTripleAt(xe.v[Me][0], xe.v[Me][1], xe.o[Me][0], xe.o[Me][1], xe.i[Me][0], xe.i[Me][1], Me);
          return Ie;
        }
        var Se = poolFactory(4, e, j);
        return Se.clone = ke, Se;
      }();
      function ShapeCollection() {
        this._length = 0, this._maxLength = 4, this.shapes = createSizedArray(this._maxLength);
      }
      ShapeCollection.prototype.addShape = function(e) {
        this._length === this._maxLength && (this.shapes = this.shapes.concat(createSizedArray(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = e, this._length += 1;
      }, ShapeCollection.prototype.releaseShapes = function() {
        var e;
        for (e = 0; e < this._length; e += 1)
          shapePool.release(this.shapes[e]);
        this._length = 0;
      };
      var shapeCollectionPool = function() {
        var e = {
          newShapeCollection: xe,
          release: Ie
        }, j = 0, ke = 4, Se = createSizedArray(ke);
        function xe() {
          var Me;
          return j ? (j -= 1, Me = Se[j]) : Me = new ShapeCollection(), Me;
        }
        function Ie(Me) {
          var Ee, Be = Me._length;
          for (Ee = 0; Ee < Be; Ee += 1)
            shapePool.release(Me.shapes[Ee]);
          Me._length = 0, j === ke && (Se = pooling.double(Se), ke *= 2), Se[j] = Me, j += 1;
        }
        return e;
      }(), ShapePropertyFactory = function() {
        var e = -999999;
        function j(Re, Ye, We) {
          var qe = We.lastIndex, Je, Ke, xt, Ct, It, Nt, Bt, At, Ft, Dt = this.keyframes;
          if (Re < Dt[0].t - this.offsetTime)
            Je = Dt[0].s[0], xt = !0, qe = 0;
          else if (Re >= Dt[Dt.length - 1].t - this.offsetTime)
            Je = Dt[Dt.length - 1].s ? Dt[Dt.length - 1].s[0] : Dt[Dt.length - 2].e[0], xt = !0;
          else {
            for (var zt = qe, kt = Dt.length - 1, Et = !0, Qe, Xe, Vt; Et && (Qe = Dt[zt], Xe = Dt[zt + 1], !(Xe.t - this.offsetTime > Re)); )
              zt < kt - 1 ? zt += 1 : Et = !1;
            if (Vt = this.keyframesMetadata[zt] || {}, xt = Qe.h === 1, qe = zt, !xt) {
              if (Re >= Xe.t - this.offsetTime)
                At = 1;
              else if (Re < Qe.t - this.offsetTime)
                At = 0;
              else {
                var Lt;
                Vt.__fnct ? Lt = Vt.__fnct : (Lt = BezierFactory.getBezierEasing(Qe.o.x, Qe.o.y, Qe.i.x, Qe.i.y).get, Vt.__fnct = Lt), At = Lt((Re - (Qe.t - this.offsetTime)) / (Xe.t - this.offsetTime - (Qe.t - this.offsetTime)));
              }
              Ke = Xe.s ? Xe.s[0] : Qe.e[0];
            }
            Je = Qe.s[0];
          }
          for (Nt = Ye._length, Bt = Je.i[0].length, We.lastIndex = qe, Ct = 0; Ct < Nt; Ct += 1)
            for (It = 0; It < Bt; It += 1)
              Ft = xt ? Je.i[Ct][It] : Je.i[Ct][It] + (Ke.i[Ct][It] - Je.i[Ct][It]) * At, Ye.i[Ct][It] = Ft, Ft = xt ? Je.o[Ct][It] : Je.o[Ct][It] + (Ke.o[Ct][It] - Je.o[Ct][It]) * At, Ye.o[Ct][It] = Ft, Ft = xt ? Je.v[Ct][It] : Je.v[Ct][It] + (Ke.v[Ct][It] - Je.v[Ct][It]) * At, Ye.v[Ct][It] = Ft;
        }
        function ke() {
          var Re = this.comp.renderedFrame - this.offsetTime, Ye = this.keyframes[0].t - this.offsetTime, We = this.keyframes[this.keyframes.length - 1].t - this.offsetTime, qe = this._caching.lastFrame;
          return qe !== e && (qe < Ye && Re < Ye || qe > We && Re > We) || (this._caching.lastIndex = qe < Re ? this._caching.lastIndex : 0, this.interpolateShape(Re, this.pv, this._caching)), this._caching.lastFrame = Re, this.pv;
        }
        function Se() {
          this.paths = this.localShapeCollection;
        }
        function xe(Re, Ye) {
          if (Re._length !== Ye._length || Re.c !== Ye.c)
            return !1;
          var We, qe = Re._length;
          for (We = 0; We < qe; We += 1)
            if (Re.v[We][0] !== Ye.v[We][0] || Re.v[We][1] !== Ye.v[We][1] || Re.o[We][0] !== Ye.o[We][0] || Re.o[We][1] !== Ye.o[We][1] || Re.i[We][0] !== Ye.i[We][0] || Re.i[We][1] !== Ye.i[We][1])
              return !1;
          return !0;
        }
        function Ie(Re) {
          xe(this.v, Re) || (this.v = shapePool.clone(Re), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
        }
        function Me() {
          if (this.elem.globalData.frameId !== this.frameId) {
            if (!this.effectsSequence.length) {
              this._mdf = !1;
              return;
            }
            if (this.lock) {
              this.setVValue(this.pv);
              return;
            }
            this.lock = !0, this._mdf = !1;
            var Re;
            this.kf ? Re = this.pv : this.data.ks ? Re = this.data.ks.k : Re = this.data.pt.k;
            var Ye, We = this.effectsSequence.length;
            for (Ye = 0; Ye < We; Ye += 1)
              Re = this.effectsSequence[Ye](Re);
            this.setVValue(Re), this.lock = !1, this.frameId = this.elem.globalData.frameId;
          }
        }
        function Ee(Re, Ye, We) {
          this.propType = "shape", this.comp = Re.comp, this.container = Re, this.elem = Re, this.data = Ye, this.k = !1, this.kf = !1, this._mdf = !1;
          var qe = We === 3 ? Ye.pt.k : Ye.ks.k;
          this.v = shapePool.clone(qe), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = Se, this.effectsSequence = [];
        }
        function Be(Re) {
          this.effectsSequence.push(Re), this.container.addDynamicProperty(this);
        }
        Ee.prototype.interpolateShape = j, Ee.prototype.getValue = Me, Ee.prototype.setVValue = Ie, Ee.prototype.addEffect = Be;
        function $e(Re, Ye, We) {
          this.propType = "shape", this.comp = Re.comp, this.elem = Re, this.container = Re, this.offsetTime = Re.data.st, this.keyframes = We === 3 ? Ye.pt.k : Ye.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
          var qe = this.keyframes[0].s[0].i.length;
          this.v = shapePool.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, qe), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = e, this.reset = Se, this._caching = {
            lastFrame: e,
            lastIndex: 0
          }, this.effectsSequence = [ke.bind(this)];
        }
        $e.prototype.getValue = Me, $e.prototype.interpolateShape = j, $e.prototype.setVValue = Ie, $e.prototype.addEffect = Be;
        var Le = function() {
          var Re = roundCorner;
          function Ye(We, qe) {
            this.v = shapePool.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = qe.d, this.elem = We, this.comp = We.comp, this.frameId = -1, this.initDynamicPropertyContainer(We), this.p = PropertyFactory.getProp(We, qe.p, 1, 0, this), this.s = PropertyFactory.getProp(We, qe.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
          }
          return Ye.prototype = {
            reset: Se,
            getValue: function() {
              this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
            },
            convertEllToPath: function() {
              var qe = this.p.v[0], Je = this.p.v[1], Ke = this.s.v[0] / 2, xt = this.s.v[1] / 2, Ct = this.d !== 3, It = this.v;
              It.v[0][0] = qe, It.v[0][1] = Je - xt, It.v[1][0] = Ct ? qe + Ke : qe - Ke, It.v[1][1] = Je, It.v[2][0] = qe, It.v[2][1] = Je + xt, It.v[3][0] = Ct ? qe - Ke : qe + Ke, It.v[3][1] = Je, It.i[0][0] = Ct ? qe - Ke * Re : qe + Ke * Re, It.i[0][1] = Je - xt, It.i[1][0] = Ct ? qe + Ke : qe - Ke, It.i[1][1] = Je - xt * Re, It.i[2][0] = Ct ? qe + Ke * Re : qe - Ke * Re, It.i[2][1] = Je + xt, It.i[3][0] = Ct ? qe - Ke : qe + Ke, It.i[3][1] = Je + xt * Re, It.o[0][0] = Ct ? qe + Ke * Re : qe - Ke * Re, It.o[0][1] = Je - xt, It.o[1][0] = Ct ? qe + Ke : qe - Ke, It.o[1][1] = Je + xt * Re, It.o[2][0] = Ct ? qe - Ke * Re : qe + Ke * Re, It.o[2][1] = Je + xt, It.o[3][0] = Ct ? qe - Ke : qe + Ke, It.o[3][1] = Je - xt * Re;
            }
          }, extendPrototype([DynamicPropertyContainer], Ye), Ye;
        }(), Fe = function() {
          function Re(Ye, We) {
            this.v = shapePool.newElement(), this.v.setPathData(!0, 0), this.elem = Ye, this.comp = Ye.comp, this.data = We, this.frameId = -1, this.d = We.d, this.initDynamicPropertyContainer(Ye), We.sy === 1 ? (this.ir = PropertyFactory.getProp(Ye, We.ir, 0, 0, this), this.is = PropertyFactory.getProp(Ye, We.is, 0, 0.01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = PropertyFactory.getProp(Ye, We.pt, 0, 0, this), this.p = PropertyFactory.getProp(Ye, We.p, 1, 0, this), this.r = PropertyFactory.getProp(Ye, We.r, 0, degToRads, this), this.or = PropertyFactory.getProp(Ye, We.or, 0, 0, this), this.os = PropertyFactory.getProp(Ye, We.os, 0, 0.01, this), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
          }
          return Re.prototype = {
            reset: Se,
            getValue: function() {
              this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
            },
            convertStarToPath: function() {
              var We = Math.floor(this.pt.v) * 2, qe = Math.PI * 2 / We, Je = !0, Ke = this.or.v, xt = this.ir.v, Ct = this.os.v, It = this.is.v, Nt = 2 * Math.PI * Ke / (We * 2), Bt = 2 * Math.PI * xt / (We * 2), At, Ft, Dt, zt, kt = -Math.PI / 2;
              kt += this.r.v;
              var Et = this.data.d === 3 ? -1 : 1;
              for (this.v._length = 0, At = 0; At < We; At += 1) {
                Ft = Je ? Ke : xt, Dt = Je ? Ct : It, zt = Je ? Nt : Bt;
                var Qe = Ft * Math.cos(kt), Xe = Ft * Math.sin(kt), Vt = Qe === 0 && Xe === 0 ? 0 : Xe / Math.sqrt(Qe * Qe + Xe * Xe), Lt = Qe === 0 && Xe === 0 ? 0 : -Qe / Math.sqrt(Qe * Qe + Xe * Xe);
                Qe += +this.p.v[0], Xe += +this.p.v[1], this.v.setTripleAt(Qe, Xe, Qe - Vt * zt * Dt * Et, Xe - Lt * zt * Dt * Et, Qe + Vt * zt * Dt * Et, Xe + Lt * zt * Dt * Et, At, !0), Je = !Je, kt += qe * Et;
              }
            },
            convertPolygonToPath: function() {
              var We = Math.floor(this.pt.v), qe = Math.PI * 2 / We, Je = this.or.v, Ke = this.os.v, xt = 2 * Math.PI * Je / (We * 4), Ct, It = -Math.PI * 0.5, Nt = this.data.d === 3 ? -1 : 1;
              for (It += this.r.v, this.v._length = 0, Ct = 0; Ct < We; Ct += 1) {
                var Bt = Je * Math.cos(It), At = Je * Math.sin(It), Ft = Bt === 0 && At === 0 ? 0 : At / Math.sqrt(Bt * Bt + At * At), Dt = Bt === 0 && At === 0 ? 0 : -Bt / Math.sqrt(Bt * Bt + At * At);
                Bt += +this.p.v[0], At += +this.p.v[1], this.v.setTripleAt(Bt, At, Bt - Ft * xt * Ke * Nt, At - Dt * xt * Ke * Nt, Bt + Ft * xt * Ke * Nt, At + Dt * xt * Ke * Nt, Ct, !0), It += qe * Nt;
              }
              this.paths.length = 0, this.paths[0] = this.v;
            }
          }, extendPrototype([DynamicPropertyContainer], Re), Re;
        }(), Ve = function() {
          function Re(Ye, We) {
            this.v = shapePool.newElement(), this.v.c = !0, this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = Ye, this.comp = Ye.comp, this.frameId = -1, this.d = We.d, this.initDynamicPropertyContainer(Ye), this.p = PropertyFactory.getProp(Ye, We.p, 1, 0, this), this.s = PropertyFactory.getProp(Ye, We.s, 1, 0, this), this.r = PropertyFactory.getProp(Ye, We.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
          }
          return Re.prototype = {
            convertRectToPath: function() {
              var We = this.p.v[0], qe = this.p.v[1], Je = this.s.v[0] / 2, Ke = this.s.v[1] / 2, xt = bmMin(Je, Ke, this.r.v), Ct = xt * (1 - roundCorner);
              this.v._length = 0, this.d === 2 || this.d === 1 ? (this.v.setTripleAt(We + Je, qe - Ke + xt, We + Je, qe - Ke + xt, We + Je, qe - Ke + Ct, 0, !0), this.v.setTripleAt(We + Je, qe + Ke - xt, We + Je, qe + Ke - Ct, We + Je, qe + Ke - xt, 1, !0), xt !== 0 ? (this.v.setTripleAt(We + Je - xt, qe + Ke, We + Je - xt, qe + Ke, We + Je - Ct, qe + Ke, 2, !0), this.v.setTripleAt(We - Je + xt, qe + Ke, We - Je + Ct, qe + Ke, We - Je + xt, qe + Ke, 3, !0), this.v.setTripleAt(We - Je, qe + Ke - xt, We - Je, qe + Ke - xt, We - Je, qe + Ke - Ct, 4, !0), this.v.setTripleAt(We - Je, qe - Ke + xt, We - Je, qe - Ke + Ct, We - Je, qe - Ke + xt, 5, !0), this.v.setTripleAt(We - Je + xt, qe - Ke, We - Je + xt, qe - Ke, We - Je + Ct, qe - Ke, 6, !0), this.v.setTripleAt(We + Je - xt, qe - Ke, We + Je - Ct, qe - Ke, We + Je - xt, qe - Ke, 7, !0)) : (this.v.setTripleAt(We - Je, qe + Ke, We - Je + Ct, qe + Ke, We - Je, qe + Ke, 2), this.v.setTripleAt(We - Je, qe - Ke, We - Je, qe - Ke + Ct, We - Je, qe - Ke, 3))) : (this.v.setTripleAt(We + Je, qe - Ke + xt, We + Je, qe - Ke + Ct, We + Je, qe - Ke + xt, 0, !0), xt !== 0 ? (this.v.setTripleAt(We + Je - xt, qe - Ke, We + Je - xt, qe - Ke, We + Je - Ct, qe - Ke, 1, !0), this.v.setTripleAt(We - Je + xt, qe - Ke, We - Je + Ct, qe - Ke, We - Je + xt, qe - Ke, 2, !0), this.v.setTripleAt(We - Je, qe - Ke + xt, We - Je, qe - Ke + xt, We - Je, qe - Ke + Ct, 3, !0), this.v.setTripleAt(We - Je, qe + Ke - xt, We - Je, qe + Ke - Ct, We - Je, qe + Ke - xt, 4, !0), this.v.setTripleAt(We - Je + xt, qe + Ke, We - Je + xt, qe + Ke, We - Je + Ct, qe + Ke, 5, !0), this.v.setTripleAt(We + Je - xt, qe + Ke, We + Je - Ct, qe + Ke, We + Je - xt, qe + Ke, 6, !0), this.v.setTripleAt(We + Je, qe + Ke - xt, We + Je, qe + Ke - xt, We + Je, qe + Ke - Ct, 7, !0)) : (this.v.setTripleAt(We - Je, qe - Ke, We - Je + Ct, qe - Ke, We - Je, qe - Ke, 1, !0), this.v.setTripleAt(We - Je, qe + Ke, We - Je, qe + Ke - Ct, We - Je, qe + Ke, 2, !0), this.v.setTripleAt(We + Je, qe + Ke, We + Je - Ct, qe + Ke, We + Je, qe + Ke, 3, !0)));
            },
            getValue: function() {
              this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
            },
            reset: Se
          }, extendPrototype([DynamicPropertyContainer], Re), Re;
        }();
        function je(Re, Ye, We) {
          var qe;
          if (We === 3 || We === 4) {
            var Je = We === 3 ? Ye.pt : Ye.ks, Ke = Je.k;
            Ke.length ? qe = new $e(Re, Ye, We) : qe = new Ee(Re, Ye, We);
          } else We === 5 ? qe = new Ve(Re, Ye) : We === 6 ? qe = new Le(Re, Ye) : We === 7 && (qe = new Fe(Re, Ye));
          return qe.k && Re.addDynamicProperty(qe), qe;
        }
        function Ge() {
          return Ee;
        }
        function De() {
          return $e;
        }
        var Ue = {};
        return Ue.getShapeProp = je, Ue.getConstructorFunction = Ge, Ue.getKeyframedConstructorFunction = De, Ue;
      }();
      var Matrix = /* @__PURE__ */ function() {
        var e = Math.cos, j = Math.sin, ke = Math.tan, Se = Math.round;
        function xe() {
          return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
        }
        function Ie(Qe) {
          if (Qe === 0)
            return this;
          var Xe = e(Qe), Vt = j(Qe);
          return this._t(Xe, -Vt, 0, 0, Vt, Xe, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function Me(Qe) {
          if (Qe === 0)
            return this;
          var Xe = e(Qe), Vt = j(Qe);
          return this._t(1, 0, 0, 0, 0, Xe, -Vt, 0, 0, Vt, Xe, 0, 0, 0, 0, 1);
        }
        function Ee(Qe) {
          if (Qe === 0)
            return this;
          var Xe = e(Qe), Vt = j(Qe);
          return this._t(Xe, 0, Vt, 0, 0, 1, 0, 0, -Vt, 0, Xe, 0, 0, 0, 0, 1);
        }
        function Be(Qe) {
          if (Qe === 0)
            return this;
          var Xe = e(Qe), Vt = j(Qe);
          return this._t(Xe, -Vt, 0, 0, Vt, Xe, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function $e(Qe, Xe) {
          return this._t(1, Xe, Qe, 1, 0, 0);
        }
        function Le(Qe, Xe) {
          return this.shear(ke(Qe), ke(Xe));
        }
        function Fe(Qe, Xe) {
          var Vt = e(Xe), Lt = j(Xe);
          return this._t(Vt, Lt, 0, 0, -Lt, Vt, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, ke(Qe), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(Vt, -Lt, 0, 0, Lt, Vt, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function Ve(Qe, Xe, Vt) {
          return !Vt && Vt !== 0 && (Vt = 1), Qe === 1 && Xe === 1 && Vt === 1 ? this : this._t(Qe, 0, 0, 0, 0, Xe, 0, 0, 0, 0, Vt, 0, 0, 0, 0, 1);
        }
        function je(Qe, Xe, Vt, Lt, Gt, Wt, Zt, Ot, Ht, Rt, jt, Yt, Ut, Qt, Kt, Jt) {
          return this.props[0] = Qe, this.props[1] = Xe, this.props[2] = Vt, this.props[3] = Lt, this.props[4] = Gt, this.props[5] = Wt, this.props[6] = Zt, this.props[7] = Ot, this.props[8] = Ht, this.props[9] = Rt, this.props[10] = jt, this.props[11] = Yt, this.props[12] = Ut, this.props[13] = Qt, this.props[14] = Kt, this.props[15] = Jt, this;
        }
        function Ge(Qe, Xe, Vt) {
          return Vt = Vt || 0, Qe !== 0 || Xe !== 0 || Vt !== 0 ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, Qe, Xe, Vt, 1) : this;
        }
        function De(Qe, Xe, Vt, Lt, Gt, Wt, Zt, Ot, Ht, Rt, jt, Yt, Ut, Qt, Kt, Jt) {
          var qt = this.props;
          if (Qe === 1 && Xe === 0 && Vt === 0 && Lt === 0 && Gt === 0 && Wt === 1 && Zt === 0 && Ot === 0 && Ht === 0 && Rt === 0 && jt === 1 && Yt === 0)
            return qt[12] = qt[12] * Qe + qt[15] * Ut, qt[13] = qt[13] * Wt + qt[15] * Qt, qt[14] = qt[14] * jt + qt[15] * Kt, qt[15] *= Jt, this._identityCalculated = !1, this;
          var er = qt[0], rr = qt[1], ar = qt[2], ir = qt[3], or = qt[4], tr = qt[5], Xt = qt[6], lr = qt[7], cr = qt[8], sr = qt[9], ur = qt[10], nr = qt[11], dr = qt[12], fr = qt[13], pr = qt[14], hr = qt[15];
          return qt[0] = er * Qe + rr * Gt + ar * Ht + ir * Ut, qt[1] = er * Xe + rr * Wt + ar * Rt + ir * Qt, qt[2] = er * Vt + rr * Zt + ar * jt + ir * Kt, qt[3] = er * Lt + rr * Ot + ar * Yt + ir * Jt, qt[4] = or * Qe + tr * Gt + Xt * Ht + lr * Ut, qt[5] = or * Xe + tr * Wt + Xt * Rt + lr * Qt, qt[6] = or * Vt + tr * Zt + Xt * jt + lr * Kt, qt[7] = or * Lt + tr * Ot + Xt * Yt + lr * Jt, qt[8] = cr * Qe + sr * Gt + ur * Ht + nr * Ut, qt[9] = cr * Xe + sr * Wt + ur * Rt + nr * Qt, qt[10] = cr * Vt + sr * Zt + ur * jt + nr * Kt, qt[11] = cr * Lt + sr * Ot + ur * Yt + nr * Jt, qt[12] = dr * Qe + fr * Gt + pr * Ht + hr * Ut, qt[13] = dr * Xe + fr * Wt + pr * Rt + hr * Qt, qt[14] = dr * Vt + fr * Zt + pr * jt + hr * Kt, qt[15] = dr * Lt + fr * Ot + pr * Yt + hr * Jt, this._identityCalculated = !1, this;
        }
        function Ue(Qe) {
          var Xe = Qe.props;
          return this.transform(Xe[0], Xe[1], Xe[2], Xe[3], Xe[4], Xe[5], Xe[6], Xe[7], Xe[8], Xe[9], Xe[10], Xe[11], Xe[12], Xe[13], Xe[14], Xe[15]);
        }
        function Re() {
          return this._identityCalculated || (this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1), this._identityCalculated = !0), this._identity;
        }
        function Ye(Qe) {
          for (var Xe = 0; Xe < 16; ) {
            if (Qe.props[Xe] !== this.props[Xe])
              return !1;
            Xe += 1;
          }
          return !0;
        }
        function We(Qe) {
          var Xe;
          for (Xe = 0; Xe < 16; Xe += 1)
            Qe.props[Xe] = this.props[Xe];
          return Qe;
        }
        function qe(Qe) {
          var Xe;
          for (Xe = 0; Xe < 16; Xe += 1)
            this.props[Xe] = Qe[Xe];
        }
        function Je(Qe, Xe, Vt) {
          return {
            x: Qe * this.props[0] + Xe * this.props[4] + Vt * this.props[8] + this.props[12],
            y: Qe * this.props[1] + Xe * this.props[5] + Vt * this.props[9] + this.props[13],
            z: Qe * this.props[2] + Xe * this.props[6] + Vt * this.props[10] + this.props[14]
          };
        }
        function Ke(Qe, Xe, Vt) {
          return Qe * this.props[0] + Xe * this.props[4] + Vt * this.props[8] + this.props[12];
        }
        function xt(Qe, Xe, Vt) {
          return Qe * this.props[1] + Xe * this.props[5] + Vt * this.props[9] + this.props[13];
        }
        function Ct(Qe, Xe, Vt) {
          return Qe * this.props[2] + Xe * this.props[6] + Vt * this.props[10] + this.props[14];
        }
        function It() {
          var Qe = this.props[0] * this.props[5] - this.props[1] * this.props[4], Xe = this.props[5] / Qe, Vt = -this.props[1] / Qe, Lt = -this.props[4] / Qe, Gt = this.props[0] / Qe, Wt = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / Qe, Zt = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / Qe, Ot = new Matrix();
          return Ot.props[0] = Xe, Ot.props[1] = Vt, Ot.props[4] = Lt, Ot.props[5] = Gt, Ot.props[12] = Wt, Ot.props[13] = Zt, Ot;
        }
        function Nt(Qe) {
          var Xe = this.getInverseMatrix();
          return Xe.applyToPointArray(Qe[0], Qe[1], Qe[2] || 0);
        }
        function Bt(Qe) {
          var Xe, Vt = Qe.length, Lt = [];
          for (Xe = 0; Xe < Vt; Xe += 1)
            Lt[Xe] = Nt(Qe[Xe]);
          return Lt;
        }
        function At(Qe, Xe, Vt) {
          var Lt = createTypedArray("float32", 6);
          if (this.isIdentity())
            Lt[0] = Qe[0], Lt[1] = Qe[1], Lt[2] = Xe[0], Lt[3] = Xe[1], Lt[4] = Vt[0], Lt[5] = Vt[1];
          else {
            var Gt = this.props[0], Wt = this.props[1], Zt = this.props[4], Ot = this.props[5], Ht = this.props[12], Rt = this.props[13];
            Lt[0] = Qe[0] * Gt + Qe[1] * Zt + Ht, Lt[1] = Qe[0] * Wt + Qe[1] * Ot + Rt, Lt[2] = Xe[0] * Gt + Xe[1] * Zt + Ht, Lt[3] = Xe[0] * Wt + Xe[1] * Ot + Rt, Lt[4] = Vt[0] * Gt + Vt[1] * Zt + Ht, Lt[5] = Vt[0] * Wt + Vt[1] * Ot + Rt;
          }
          return Lt;
        }
        function Ft(Qe, Xe, Vt) {
          var Lt;
          return this.isIdentity() ? Lt = [Qe, Xe, Vt] : Lt = [Qe * this.props[0] + Xe * this.props[4] + Vt * this.props[8] + this.props[12], Qe * this.props[1] + Xe * this.props[5] + Vt * this.props[9] + this.props[13], Qe * this.props[2] + Xe * this.props[6] + Vt * this.props[10] + this.props[14]], Lt;
        }
        function Dt(Qe, Xe) {
          if (this.isIdentity())
            return Qe + "," + Xe;
          var Vt = this.props;
          return Math.round((Qe * Vt[0] + Xe * Vt[4] + Vt[12]) * 100) / 100 + "," + Math.round((Qe * Vt[1] + Xe * Vt[5] + Vt[13]) * 100) / 100;
        }
        function zt() {
          for (var Qe = 0, Xe = this.props, Vt = "matrix3d(", Lt = 1e4; Qe < 16; )
            Vt += Se(Xe[Qe] * Lt) / Lt, Vt += Qe === 15 ? ")" : ",", Qe += 1;
          return Vt;
        }
        function kt(Qe) {
          var Xe = 1e4;
          return Qe < 1e-6 && Qe > 0 || Qe > -1e-6 && Qe < 0 ? Se(Qe * Xe) / Xe : Qe;
        }
        function Et() {
          var Qe = this.props, Xe = kt(Qe[0]), Vt = kt(Qe[1]), Lt = kt(Qe[4]), Gt = kt(Qe[5]), Wt = kt(Qe[12]), Zt = kt(Qe[13]);
          return "matrix(" + Xe + "," + Vt + "," + Lt + "," + Gt + "," + Wt + "," + Zt + ")";
        }
        return function() {
          this.reset = xe, this.rotate = Ie, this.rotateX = Me, this.rotateY = Ee, this.rotateZ = Be, this.skew = Le, this.skewFromAxis = Fe, this.shear = $e, this.scale = Ve, this.setTransform = je, this.translate = Ge, this.transform = De, this.multiply = Ue, this.applyToPoint = Je, this.applyToX = Ke, this.applyToY = xt, this.applyToZ = Ct, this.applyToPointArray = Ft, this.applyToTriplePoints = At, this.applyToPointStringified = Dt, this.toCSS = zt, this.to2dCSS = Et, this.clone = We, this.cloneFromProps = qe, this.equals = Ye, this.inversePoints = Bt, this.inversePoint = Nt, this.getInverseMatrix = It, this._t = this.transform, this.isIdentity = Re, this._identity = !0, this._identityCalculated = !1, this.props = createTypedArray("float32", 16), this.reset();
        };
      }();
      function _typeof$3(e) {
        "@babel/helpers - typeof";
        return _typeof$3 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(j) {
          return typeof j;
        } : function(j) {
          return j && typeof Symbol == "function" && j.constructor === Symbol && j !== Symbol.prototype ? "symbol" : typeof j;
        }, _typeof$3(e);
      }
      var lottie = {};
      function setLocation(e) {
        setLocationHref(e);
      }
      function searchAnimations() {
        animationManager.searchAnimations();
      }
      function setSubframeRendering(e) {
        setSubframeEnabled(e);
      }
      function setPrefix(e) {
        setIdPrefix(e);
      }
      function loadAnimation(e) {
        return animationManager.loadAnimation(e);
      }
      function setQuality(e) {
        if (typeof e == "string")
          switch (e) {
            case "high":
              setDefaultCurveSegments(200);
              break;
            default:
            case "medium":
              setDefaultCurveSegments(50);
              break;
            case "low":
              setDefaultCurveSegments(10);
              break;
          }
        else !isNaN(e) && e > 1 && setDefaultCurveSegments(e);
      }
      function inBrowser() {
        return typeof navigator < "u";
      }
      function installPlugin(e, j) {
        e === "expressions" && setExpressionsPlugin(j);
      }
      function getFactory(e) {
        switch (e) {
          case "propertyFactory":
            return PropertyFactory;
          case "shapePropertyFactory":
            return ShapePropertyFactory;
          case "matrix":
            return Matrix;
          default:
            return null;
        }
      }
      lottie.play = animationManager.play, lottie.pause = animationManager.pause, lottie.setLocationHref = setLocation, lottie.togglePause = animationManager.togglePause, lottie.setSpeed = animationManager.setSpeed, lottie.setDirection = animationManager.setDirection, lottie.stop = animationManager.stop, lottie.searchAnimations = searchAnimations, lottie.registerAnimation = animationManager.registerAnimation, lottie.loadAnimation = loadAnimation, lottie.setSubframeRendering = setSubframeRendering, lottie.resize = animationManager.resize, lottie.goToAndStop = animationManager.goToAndStop, lottie.destroy = animationManager.destroy, lottie.setQuality = setQuality, lottie.inBrowser = inBrowser, lottie.installPlugin = installPlugin, lottie.freeze = animationManager.freeze, lottie.unfreeze = animationManager.unfreeze, lottie.setVolume = animationManager.setVolume, lottie.mute = animationManager.mute, lottie.unmute = animationManager.unmute, lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations, lottie.useWebWorker = setWebWorker, lottie.setIDPrefix = setPrefix, lottie.__getFactory = getFactory, lottie.version = "5.13.0";
      function checkReady() {
        document.readyState === "complete" && (clearInterval(readyStateCheckInterval), searchAnimations());
      }
      function getQueryVariable(e) {
        for (var j = queryString.split("&"), ke = 0; ke < j.length; ke += 1) {
          var Se = j[ke].split("=");
          if (decodeURIComponent(Se[0]) == e)
            return decodeURIComponent(Se[1]);
        }
        return null;
      }
      var queryString = "";
      {
        var scripts = document.getElementsByTagName("script"), index = scripts.length - 1, myScript = scripts[index] || {
          src: ""
        };
        queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : "", getQueryVariable("renderer");
      }
      var readyStateCheckInterval = setInterval(checkReady, 100);
      try {
        _typeof$3(exports) !== "object" && (window.bodymovin = lottie);
      } catch (e) {
      }
      var ShapeModifiers = function() {
        var e = {}, j = {};
        e.registerModifier = ke, e.getModifier = Se;
        function ke(xe, Ie) {
          j[xe] || (j[xe] = Ie);
        }
        function Se(xe, Ie, Me) {
          return new j[xe](Ie, Me);
        }
        return e;
      }();
      function ShapeModifier() {
      }
      ShapeModifier.prototype.initModifierProperties = function() {
      }, ShapeModifier.prototype.addShapeToModifier = function() {
      }, ShapeModifier.prototype.addShape = function(e) {
        if (!this.closed) {
          e.sh.container.addDynamicProperty(e.sh);
          var j = {
            shape: e.sh,
            data: e,
            localShapeCollection: shapeCollectionPool.newShapeCollection()
          };
          this.shapes.push(j), this.addShapeToModifier(j), this._isAnimated && e.setAsAnimated();
        }
      }, ShapeModifier.prototype.init = function(e, j) {
        this.shapes = [], this.elem = e, this.initDynamicPropertyContainer(e), this.initModifierProperties(e, j), this.frameId = initialDefaultFrame, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
      }, ShapeModifier.prototype.processKeys = function() {
        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
      }, extendPrototype([DynamicPropertyContainer], ShapeModifier);
      function TrimModifier() {
      }
      extendPrototype([ShapeModifier], TrimModifier), TrimModifier.prototype.initModifierProperties = function(e, j) {
        this.s = PropertyFactory.getProp(e, j.s, 0, 0.01, this), this.e = PropertyFactory.getProp(e, j.e, 0, 0.01, this), this.o = PropertyFactory.getProp(e, j.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = j.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
      }, TrimModifier.prototype.addShapeToModifier = function(e) {
        e.pathsData = [];
      }, TrimModifier.prototype.calculateShapeEdges = function(e, j, ke, Se, xe) {
        var Ie = [];
        j <= 1 ? Ie.push({
          s: e,
          e: j
        }) : e >= 1 ? Ie.push({
          s: e - 1,
          e: j - 1
        }) : (Ie.push({
          s: e,
          e: 1
        }), Ie.push({
          s: 0,
          e: j - 1
        }));
        var Me = [], Ee, Be = Ie.length, $e;
        for (Ee = 0; Ee < Be; Ee += 1)
          if ($e = Ie[Ee], !($e.e * xe < Se || $e.s * xe > Se + ke)) {
            var Le, Fe;
            $e.s * xe <= Se ? Le = 0 : Le = ($e.s * xe - Se) / ke, $e.e * xe >= Se + ke ? Fe = 1 : Fe = ($e.e * xe - Se) / ke, Me.push([Le, Fe]);
          }
        return Me.length || Me.push([0, 0]), Me;
      }, TrimModifier.prototype.releasePathsData = function(e) {
        var j, ke = e.length;
        for (j = 0; j < ke; j += 1)
          segmentsLengthPool.release(e[j]);
        return e.length = 0, e;
      }, TrimModifier.prototype.processShapes = function(e) {
        var j, ke;
        if (this._mdf || e) {
          var Se = this.o.v % 360 / 360;
          if (Se < 0 && (Se += 1), this.s.v > 1 ? j = 1 + Se : this.s.v < 0 ? j = 0 + Se : j = this.s.v + Se, this.e.v > 1 ? ke = 1 + Se : this.e.v < 0 ? ke = 0 + Se : ke = this.e.v + Se, j > ke) {
            var xe = j;
            j = ke, ke = xe;
          }
          j = Math.round(j * 1e4) * 1e-4, ke = Math.round(ke * 1e4) * 1e-4, this.sValue = j, this.eValue = ke;
        } else
          j = this.sValue, ke = this.eValue;
        var Ie, Me, Ee = this.shapes.length, Be, $e, Le, Fe, Ve, je = 0;
        if (ke === j)
          for (Me = 0; Me < Ee; Me += 1)
            this.shapes[Me].localShapeCollection.releaseShapes(), this.shapes[Me].shape._mdf = !0, this.shapes[Me].shape.paths = this.shapes[Me].localShapeCollection, this._mdf && (this.shapes[Me].pathsData.length = 0);
        else if (ke === 1 && j === 0 || ke === 0 && j === 1) {
          if (this._mdf)
            for (Me = 0; Me < Ee; Me += 1)
              this.shapes[Me].pathsData.length = 0, this.shapes[Me].shape._mdf = !0;
        } else {
          var Ge = [], De, Ue;
          for (Me = 0; Me < Ee; Me += 1)
            if (De = this.shapes[Me], !De.shape._mdf && !this._mdf && !e && this.m !== 2)
              De.shape.paths = De.localShapeCollection;
            else {
              if (Ie = De.shape.paths, $e = Ie._length, Ve = 0, !De.shape._mdf && De.pathsData.length)
                Ve = De.totalShapeLength;
              else {
                for (Le = this.releasePathsData(De.pathsData), Be = 0; Be < $e; Be += 1)
                  Fe = bez.getSegmentsLength(Ie.shapes[Be]), Le.push(Fe), Ve += Fe.totalLength;
                De.totalShapeLength = Ve, De.pathsData = Le;
              }
              je += Ve, De.shape._mdf = !0;
            }
          var Re = j, Ye = ke, We = 0, qe;
          for (Me = Ee - 1; Me >= 0; Me -= 1)
            if (De = this.shapes[Me], De.shape._mdf) {
              for (Ue = De.localShapeCollection, Ue.releaseShapes(), this.m === 2 && Ee > 1 ? (qe = this.calculateShapeEdges(j, ke, De.totalShapeLength, We, je), We += De.totalShapeLength) : qe = [[Re, Ye]], $e = qe.length, Be = 0; Be < $e; Be += 1) {
                Re = qe[Be][0], Ye = qe[Be][1], Ge.length = 0, Ye <= 1 ? Ge.push({
                  s: De.totalShapeLength * Re,
                  e: De.totalShapeLength * Ye
                }) : Re >= 1 ? Ge.push({
                  s: De.totalShapeLength * (Re - 1),
                  e: De.totalShapeLength * (Ye - 1)
                }) : (Ge.push({
                  s: De.totalShapeLength * Re,
                  e: De.totalShapeLength
                }), Ge.push({
                  s: 0,
                  e: De.totalShapeLength * (Ye - 1)
                }));
                var Je = this.addShapes(De, Ge[0]);
                if (Ge[0].s !== Ge[0].e) {
                  if (Ge.length > 1) {
                    var Ke = De.shape.paths.shapes[De.shape.paths._length - 1];
                    if (Ke.c) {
                      var xt = Je.pop();
                      this.addPaths(Je, Ue), Je = this.addShapes(De, Ge[1], xt);
                    } else
                      this.addPaths(Je, Ue), Je = this.addShapes(De, Ge[1]);
                  }
                  this.addPaths(Je, Ue);
                }
              }
              De.shape.paths = Ue;
            }
        }
      }, TrimModifier.prototype.addPaths = function(e, j) {
        var ke, Se = e.length;
        for (ke = 0; ke < Se; ke += 1)
          j.addShape(e[ke]);
      }, TrimModifier.prototype.addSegment = function(e, j, ke, Se, xe, Ie, Me) {
        xe.setXYAt(j[0], j[1], "o", Ie), xe.setXYAt(ke[0], ke[1], "i", Ie + 1), Me && xe.setXYAt(e[0], e[1], "v", Ie), xe.setXYAt(Se[0], Se[1], "v", Ie + 1);
      }, TrimModifier.prototype.addSegmentFromArray = function(e, j, ke, Se) {
        j.setXYAt(e[1], e[5], "o", ke), j.setXYAt(e[2], e[6], "i", ke + 1), Se && j.setXYAt(e[0], e[4], "v", ke), j.setXYAt(e[3], e[7], "v", ke + 1);
      }, TrimModifier.prototype.addShapes = function(e, j, ke) {
        var Se = e.pathsData, xe = e.shape.paths.shapes, Ie, Me = e.shape.paths._length, Ee, Be, $e = 0, Le, Fe, Ve, je, Ge = [], De, Ue = !0;
        for (ke ? (Fe = ke._length, De = ke._length) : (ke = shapePool.newElement(), Fe = 0, De = 0), Ge.push(ke), Ie = 0; Ie < Me; Ie += 1) {
          for (Ve = Se[Ie].lengths, ke.c = xe[Ie].c, Be = xe[Ie].c ? Ve.length : Ve.length + 1, Ee = 1; Ee < Be; Ee += 1)
            if (Le = Ve[Ee - 1], $e + Le.addedLength < j.s)
              $e += Le.addedLength, ke.c = !1;
            else if ($e > j.e) {
              ke.c = !1;
              break;
            } else
              j.s <= $e && j.e >= $e + Le.addedLength ? (this.addSegment(xe[Ie].v[Ee - 1], xe[Ie].o[Ee - 1], xe[Ie].i[Ee], xe[Ie].v[Ee], ke, Fe, Ue), Ue = !1) : (je = bez.getNewSegment(xe[Ie].v[Ee - 1], xe[Ie].v[Ee], xe[Ie].o[Ee - 1], xe[Ie].i[Ee], (j.s - $e) / Le.addedLength, (j.e - $e) / Le.addedLength, Ve[Ee - 1]), this.addSegmentFromArray(je, ke, Fe, Ue), Ue = !1, ke.c = !1), $e += Le.addedLength, Fe += 1;
          if (xe[Ie].c && Ve.length) {
            if (Le = Ve[Ee - 1], $e <= j.e) {
              var Re = Ve[Ee - 1].addedLength;
              j.s <= $e && j.e >= $e + Re ? (this.addSegment(xe[Ie].v[Ee - 1], xe[Ie].o[Ee - 1], xe[Ie].i[0], xe[Ie].v[0], ke, Fe, Ue), Ue = !1) : (je = bez.getNewSegment(xe[Ie].v[Ee - 1], xe[Ie].v[0], xe[Ie].o[Ee - 1], xe[Ie].i[0], (j.s - $e) / Re, (j.e - $e) / Re, Ve[Ee - 1]), this.addSegmentFromArray(je, ke, Fe, Ue), Ue = !1, ke.c = !1);
            } else
              ke.c = !1;
            $e += Le.addedLength, Fe += 1;
          }
          if (ke._length && (ke.setXYAt(ke.v[De][0], ke.v[De][1], "i", De), ke.setXYAt(ke.v[ke._length - 1][0], ke.v[ke._length - 1][1], "o", ke._length - 1)), $e > j.e)
            break;
          Ie < Me - 1 && (ke = shapePool.newElement(), Ue = !0, Ge.push(ke), Fe = 0);
        }
        return Ge;
      };
      function PuckerAndBloatModifier() {
      }
      extendPrototype([ShapeModifier], PuckerAndBloatModifier), PuckerAndBloatModifier.prototype.initModifierProperties = function(e, j) {
        this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(e, j.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
      }, PuckerAndBloatModifier.prototype.processPath = function(e, j) {
        var ke = j / 100, Se = [0, 0], xe = e._length, Ie = 0;
        for (Ie = 0; Ie < xe; Ie += 1)
          Se[0] += e.v[Ie][0], Se[1] += e.v[Ie][1];
        Se[0] /= xe, Se[1] /= xe;
        var Me = shapePool.newElement();
        Me.c = e.c;
        var Ee, Be, $e, Le, Fe, Ve;
        for (Ie = 0; Ie < xe; Ie += 1)
          Ee = e.v[Ie][0] + (Se[0] - e.v[Ie][0]) * ke, Be = e.v[Ie][1] + (Se[1] - e.v[Ie][1]) * ke, $e = e.o[Ie][0] + (Se[0] - e.o[Ie][0]) * -ke, Le = e.o[Ie][1] + (Se[1] - e.o[Ie][1]) * -ke, Fe = e.i[Ie][0] + (Se[0] - e.i[Ie][0]) * -ke, Ve = e.i[Ie][1] + (Se[1] - e.i[Ie][1]) * -ke, Me.setTripleAt(Ee, Be, $e, Le, Fe, Ve, Ie);
        return Me;
      }, PuckerAndBloatModifier.prototype.processShapes = function(e) {
        var j, ke, Se = this.shapes.length, xe, Ie, Me = this.amount.v;
        if (Me !== 0) {
          var Ee, Be;
          for (ke = 0; ke < Se; ke += 1) {
            if (Ee = this.shapes[ke], Be = Ee.localShapeCollection, !(!Ee.shape._mdf && !this._mdf && !e))
              for (Be.releaseShapes(), Ee.shape._mdf = !0, j = Ee.shape.paths.shapes, Ie = Ee.shape.paths._length, xe = 0; xe < Ie; xe += 1)
                Be.addShape(this.processPath(j[xe], Me));
            Ee.shape.paths = Ee.localShapeCollection;
          }
        }
        this.dynamicProperties.length || (this._mdf = !1);
      };
      var TransformPropertyFactory = function() {
        var e = [0, 0];
        function j(Be) {
          var $e = this._mdf;
          this.iterateDynamicProperties(), this._mdf = this._mdf || $e, this.a && Be.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && Be.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && Be.skewFromAxis(-this.sk.v, this.sa.v), this.r ? Be.rotate(-this.r.v) : Be.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? Be.translate(this.px.v, this.py.v, -this.pz.v) : Be.translate(this.px.v, this.py.v, 0) : Be.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
        }
        function ke(Be) {
          if (this.elem.globalData.frameId !== this.frameId) {
            if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || Be) {
              var $e;
              if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
                var Le, Fe;
                if ($e = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime)
                  this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (Le = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / $e, 0), Fe = this.p.getValueAtTime(this.p.keyframes[0].t / $e, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (Le = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / $e, 0), Fe = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / $e, 0)) : (Le = this.p.pv, Fe = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / $e, this.p.offsetTime));
                else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                  Le = [], Fe = [];
                  var Ve = this.px, je = this.py;
                  Ve._caching.lastFrame + Ve.offsetTime <= Ve.keyframes[0].t ? (Le[0] = Ve.getValueAtTime((Ve.keyframes[0].t + 0.01) / $e, 0), Le[1] = je.getValueAtTime((je.keyframes[0].t + 0.01) / $e, 0), Fe[0] = Ve.getValueAtTime(Ve.keyframes[0].t / $e, 0), Fe[1] = je.getValueAtTime(je.keyframes[0].t / $e, 0)) : Ve._caching.lastFrame + Ve.offsetTime >= Ve.keyframes[Ve.keyframes.length - 1].t ? (Le[0] = Ve.getValueAtTime(Ve.keyframes[Ve.keyframes.length - 1].t / $e, 0), Le[1] = je.getValueAtTime(je.keyframes[je.keyframes.length - 1].t / $e, 0), Fe[0] = Ve.getValueAtTime((Ve.keyframes[Ve.keyframes.length - 1].t - 0.01) / $e, 0), Fe[1] = je.getValueAtTime((je.keyframes[je.keyframes.length - 1].t - 0.01) / $e, 0)) : (Le = [Ve.pv, je.pv], Fe[0] = Ve.getValueAtTime((Ve._caching.lastFrame + Ve.offsetTime - 0.01) / $e, Ve.offsetTime), Fe[1] = je.getValueAtTime((je._caching.lastFrame + je.offsetTime - 0.01) / $e, je.offsetTime));
                } else
                  Fe = e, Le = Fe;
                this.v.rotate(-Math.atan2(Le[1] - Fe[1], Le[0] - Fe[0]));
              }
              this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
            }
            this.frameId = this.elem.globalData.frameId;
          }
        }
        function Se() {
          if (this.appliedTransformations = 0, this.pre.reset(), !this.a.effectsSequence.length)
            this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1;
          else
            return;
          if (!this.s.effectsSequence.length)
            this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2;
          else
            return;
          if (this.sk)
            if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length)
              this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
            else
              return;
          this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : !this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length && (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
        }
        function xe() {
        }
        function Ie(Be) {
          this._addDynamicProperty(Be), this.elem.addDynamicProperty(Be), this._isDirty = !0;
        }
        function Me(Be, $e, Le) {
          if (this.elem = Be, this.frameId = -1, this.propType = "transform", this.data = $e, this.v = new Matrix(), this.pre = new Matrix(), this.appliedTransformations = 0, this.initDynamicPropertyContainer(Le || Be), $e.p && $e.p.s ? (this.px = PropertyFactory.getProp(Be, $e.p.x, 0, 0, this), this.py = PropertyFactory.getProp(Be, $e.p.y, 0, 0, this), $e.p.z && (this.pz = PropertyFactory.getProp(Be, $e.p.z, 0, 0, this))) : this.p = PropertyFactory.getProp(Be, $e.p || {
            k: [0, 0, 0]
          }, 1, 0, this), $e.rx) {
            if (this.rx = PropertyFactory.getProp(Be, $e.rx, 0, degToRads, this), this.ry = PropertyFactory.getProp(Be, $e.ry, 0, degToRads, this), this.rz = PropertyFactory.getProp(Be, $e.rz, 0, degToRads, this), $e.or.k[0].ti) {
              var Fe, Ve = $e.or.k.length;
              for (Fe = 0; Fe < Ve; Fe += 1)
                $e.or.k[Fe].to = null, $e.or.k[Fe].ti = null;
            }
            this.or = PropertyFactory.getProp(Be, $e.or, 1, degToRads, this), this.or.sh = !0;
          } else
            this.r = PropertyFactory.getProp(Be, $e.r || {
              k: 0
            }, 0, degToRads, this);
          $e.sk && (this.sk = PropertyFactory.getProp(Be, $e.sk, 0, degToRads, this), this.sa = PropertyFactory.getProp(Be, $e.sa, 0, degToRads, this)), this.a = PropertyFactory.getProp(Be, $e.a || {
            k: [0, 0, 0]
          }, 1, 0, this), this.s = PropertyFactory.getProp(Be, $e.s || {
            k: [100, 100, 100]
          }, 1, 0.01, this), $e.o ? this.o = PropertyFactory.getProp(Be, $e.o, 0, 0.01, Be) : this.o = {
            _mdf: !1,
            v: 1
          }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
        }
        Me.prototype = {
          applyToMatrix: j,
          getValue: ke,
          precalculateMatrix: Se,
          autoOrient: xe
        }, extendPrototype([DynamicPropertyContainer], Me), Me.prototype.addDynamicProperty = Ie, Me.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
        function Ee(Be, $e, Le) {
          return new Me(Be, $e, Le);
        }
        return {
          getTransformProperty: Ee
        };
      }();
      function RepeaterModifier() {
      }
      extendPrototype([ShapeModifier], RepeaterModifier), RepeaterModifier.prototype.initModifierProperties = function(e, j) {
        this.getValue = this.processKeys, this.c = PropertyFactory.getProp(e, j.c, 0, null, this), this.o = PropertyFactory.getProp(e, j.o, 0, null, this), this.tr = TransformPropertyFactory.getTransformProperty(e, j.tr, this), this.so = PropertyFactory.getProp(e, j.tr.so, 0, 0.01, this), this.eo = PropertyFactory.getProp(e, j.tr.eo, 0, 0.01, this), this.data = j, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new Matrix(), this.rMatrix = new Matrix(), this.sMatrix = new Matrix(), this.tMatrix = new Matrix(), this.matrix = new Matrix();
      }, RepeaterModifier.prototype.applyTransforms = function(e, j, ke, Se, xe, Ie) {
        var Me = Ie ? -1 : 1, Ee = Se.s.v[0] + (1 - Se.s.v[0]) * (1 - xe), Be = Se.s.v[1] + (1 - Se.s.v[1]) * (1 - xe);
        e.translate(Se.p.v[0] * Me * xe, Se.p.v[1] * Me * xe, Se.p.v[2]), j.translate(-Se.a.v[0], -Se.a.v[1], Se.a.v[2]), j.rotate(-Se.r.v * Me * xe), j.translate(Se.a.v[0], Se.a.v[1], Se.a.v[2]), ke.translate(-Se.a.v[0], -Se.a.v[1], Se.a.v[2]), ke.scale(Ie ? 1 / Ee : Ee, Ie ? 1 / Be : Be), ke.translate(Se.a.v[0], Se.a.v[1], Se.a.v[2]);
      }, RepeaterModifier.prototype.init = function(e, j, ke, Se) {
        for (this.elem = e, this.arr = j, this.pos = ke, this.elemsData = Se, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(e), this.initModifierProperties(e, j[ke]); ke > 0; )
          ke -= 1, this._elements.unshift(j[ke]);
        this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
      }, RepeaterModifier.prototype.resetElements = function(e) {
        var j, ke = e.length;
        for (j = 0; j < ke; j += 1)
          e[j]._processed = !1, e[j].ty === "gr" && this.resetElements(e[j].it);
      }, RepeaterModifier.prototype.cloneElements = function(e) {
        var j = JSON.parse(JSON.stringify(e));
        return this.resetElements(j), j;
      }, RepeaterModifier.prototype.changeGroupRender = function(e, j) {
        var ke, Se = e.length;
        for (ke = 0; ke < Se; ke += 1)
          e[ke]._render = j, e[ke].ty === "gr" && this.changeGroupRender(e[ke].it, j);
      }, RepeaterModifier.prototype.processShapes = function(e) {
        var j, ke, Se, xe, Ie, Me = !1;
        if (this._mdf || e) {
          var Ee = Math.ceil(this.c.v);
          if (this._groups.length < Ee) {
            for (; this._groups.length < Ee; ) {
              var Be = {
                it: this.cloneElements(this._elements),
                ty: "gr"
              };
              Be.it.push({
                a: {
                  a: 0,
                  ix: 1,
                  k: [0, 0]
                },
                nm: "Transform",
                o: {
                  a: 0,
                  ix: 7,
                  k: 100
                },
                p: {
                  a: 0,
                  ix: 2,
                  k: [0, 0]
                },
                r: {
                  a: 1,
                  ix: 6,
                  k: [{
                    s: 0,
                    e: 0,
                    t: 0
                  }, {
                    s: 0,
                    e: 0,
                    t: 1
                  }]
                },
                s: {
                  a: 0,
                  ix: 3,
                  k: [100, 100]
                },
                sa: {
                  a: 0,
                  ix: 5,
                  k: 0
                },
                sk: {
                  a: 0,
                  ix: 4,
                  k: 0
                },
                ty: "tr"
              }), this.arr.splice(0, 0, Be), this._groups.splice(0, 0, Be), this._currentCopies += 1;
            }
            this.elem.reloadShapes(), Me = !0;
          }
          Ie = 0;
          var $e;
          for (Se = 0; Se <= this._groups.length - 1; Se += 1) {
            if ($e = Ie < Ee, this._groups[Se]._render = $e, this.changeGroupRender(this._groups[Se].it, $e), !$e) {
              var Le = this.elemsData[Se].it, Fe = Le[Le.length - 1];
              Fe.transform.op.v !== 0 ? (Fe.transform.op._mdf = !0, Fe.transform.op.v = 0) : Fe.transform.op._mdf = !1;
            }
            Ie += 1;
          }
          this._currentCopies = Ee;
          var Ve = this.o.v, je = Ve % 1, Ge = Ve > 0 ? Math.floor(Ve) : Math.ceil(Ve), De = this.pMatrix.props, Ue = this.rMatrix.props, Re = this.sMatrix.props;
          this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
          var Ye = 0;
          if (Ve > 0) {
            for (; Ye < Ge; )
              this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), Ye += 1;
            je && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, je, !1), Ye += je);
          } else if (Ve < 0) {
            for (; Ye > Ge; )
              this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), Ye -= 1;
            je && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -je, !0), Ye -= je);
          }
          Se = this.data.m === 1 ? 0 : this._currentCopies - 1, xe = this.data.m === 1 ? 1 : -1, Ie = this._currentCopies;
          for (var We, qe; Ie; ) {
            if (j = this.elemsData[Se].it, ke = j[j.length - 1].transform.mProps.v.props, qe = ke.length, j[j.length - 1].transform.mProps._mdf = !0, j[j.length - 1].transform.op._mdf = !0, j[j.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (Se / (this._currentCopies - 1)), Ye !== 0) {
              for ((Se !== 0 && xe === 1 || Se !== this._currentCopies - 1 && xe === -1) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(Ue[0], Ue[1], Ue[2], Ue[3], Ue[4], Ue[5], Ue[6], Ue[7], Ue[8], Ue[9], Ue[10], Ue[11], Ue[12], Ue[13], Ue[14], Ue[15]), this.matrix.transform(Re[0], Re[1], Re[2], Re[3], Re[4], Re[5], Re[6], Re[7], Re[8], Re[9], Re[10], Re[11], Re[12], Re[13], Re[14], Re[15]), this.matrix.transform(De[0], De[1], De[2], De[3], De[4], De[5], De[6], De[7], De[8], De[9], De[10], De[11], De[12], De[13], De[14], De[15]), We = 0; We < qe; We += 1)
                ke[We] = this.matrix.props[We];
              this.matrix.reset();
            } else
              for (this.matrix.reset(), We = 0; We < qe; We += 1)
                ke[We] = this.matrix.props[We];
            Ye += 1, Ie -= 1, Se += xe;
          }
        } else
          for (Ie = this._currentCopies, Se = 0, xe = 1; Ie; )
            j = this.elemsData[Se].it, ke = j[j.length - 1].transform.mProps.v.props, j[j.length - 1].transform.mProps._mdf = !1, j[j.length - 1].transform.op._mdf = !1, Ie -= 1, Se += xe;
        return Me;
      }, RepeaterModifier.prototype.addShape = function() {
      };
      function RoundCornersModifier() {
      }
      extendPrototype([ShapeModifier], RoundCornersModifier), RoundCornersModifier.prototype.initModifierProperties = function(e, j) {
        this.getValue = this.processKeys, this.rd = PropertyFactory.getProp(e, j.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
      }, RoundCornersModifier.prototype.processPath = function(e, j) {
        var ke = shapePool.newElement();
        ke.c = e.c;
        var Se, xe = e._length, Ie, Me, Ee, Be, $e, Le, Fe = 0, Ve, je, Ge, De, Ue, Re;
        for (Se = 0; Se < xe; Se += 1)
          Ie = e.v[Se], Ee = e.o[Se], Me = e.i[Se], Ie[0] === Ee[0] && Ie[1] === Ee[1] && Ie[0] === Me[0] && Ie[1] === Me[1] ? (Se === 0 || Se === xe - 1) && !e.c ? (ke.setTripleAt(Ie[0], Ie[1], Ee[0], Ee[1], Me[0], Me[1], Fe), Fe += 1) : (Se === 0 ? Be = e.v[xe - 1] : Be = e.v[Se - 1], $e = Math.sqrt(Math.pow(Ie[0] - Be[0], 2) + Math.pow(Ie[1] - Be[1], 2)), Le = $e ? Math.min($e / 2, j) / $e : 0, Ue = Ie[0] + (Be[0] - Ie[0]) * Le, Ve = Ue, Re = Ie[1] - (Ie[1] - Be[1]) * Le, je = Re, Ge = Ve - (Ve - Ie[0]) * roundCorner, De = je - (je - Ie[1]) * roundCorner, ke.setTripleAt(Ve, je, Ge, De, Ue, Re, Fe), Fe += 1, Se === xe - 1 ? Be = e.v[0] : Be = e.v[Se + 1], $e = Math.sqrt(Math.pow(Ie[0] - Be[0], 2) + Math.pow(Ie[1] - Be[1], 2)), Le = $e ? Math.min($e / 2, j) / $e : 0, Ge = Ie[0] + (Be[0] - Ie[0]) * Le, Ve = Ge, De = Ie[1] + (Be[1] - Ie[1]) * Le, je = De, Ue = Ve - (Ve - Ie[0]) * roundCorner, Re = je - (je - Ie[1]) * roundCorner, ke.setTripleAt(Ve, je, Ge, De, Ue, Re, Fe), Fe += 1) : (ke.setTripleAt(e.v[Se][0], e.v[Se][1], e.o[Se][0], e.o[Se][1], e.i[Se][0], e.i[Se][1], Fe), Fe += 1);
        return ke;
      }, RoundCornersModifier.prototype.processShapes = function(e) {
        var j, ke, Se = this.shapes.length, xe, Ie, Me = this.rd.v;
        if (Me !== 0) {
          var Ee, Be;
          for (ke = 0; ke < Se; ke += 1) {
            if (Ee = this.shapes[ke], Be = Ee.localShapeCollection, !(!Ee.shape._mdf && !this._mdf && !e))
              for (Be.releaseShapes(), Ee.shape._mdf = !0, j = Ee.shape.paths.shapes, Ie = Ee.shape.paths._length, xe = 0; xe < Ie; xe += 1)
                Be.addShape(this.processPath(j[xe], Me));
            Ee.shape.paths = Ee.localShapeCollection;
          }
        }
        this.dynamicProperties.length || (this._mdf = !1);
      };
      function floatEqual(e, j) {
        return Math.abs(e - j) * 1e5 <= Math.min(Math.abs(e), Math.abs(j));
      }
      function floatZero(e) {
        return Math.abs(e) <= 1e-5;
      }
      function lerp(e, j, ke) {
        return e * (1 - ke) + j * ke;
      }
      function lerpPoint(e, j, ke) {
        return [lerp(e[0], j[0], ke), lerp(e[1], j[1], ke)];
      }
      function quadRoots(e, j, ke) {
        if (e === 0) return [];
        var Se = j * j - 4 * e * ke;
        if (Se < 0) return [];
        var xe = -j / (2 * e);
        if (Se === 0) return [xe];
        var Ie = Math.sqrt(Se) / (2 * e);
        return [xe - Ie, xe + Ie];
      }
      function polynomialCoefficients(e, j, ke, Se) {
        return [-e + 3 * j - 3 * ke + Se, 3 * e - 6 * j + 3 * ke, -3 * e + 3 * j, e];
      }
      function singlePoint(e) {
        return new PolynomialBezier(e, e, e, e, !1);
      }
      function PolynomialBezier(e, j, ke, Se, xe) {
        xe && pointEqual(e, j) && (j = lerpPoint(e, Se, 1 / 3)), xe && pointEqual(ke, Se) && (ke = lerpPoint(e, Se, 2 / 3));
        var Ie = polynomialCoefficients(e[0], j[0], ke[0], Se[0]), Me = polynomialCoefficients(e[1], j[1], ke[1], Se[1]);
        this.a = [Ie[0], Me[0]], this.b = [Ie[1], Me[1]], this.c = [Ie[2], Me[2]], this.d = [Ie[3], Me[3]], this.points = [e, j, ke, Se];
      }
      PolynomialBezier.prototype.point = function(e) {
        return [((this.a[0] * e + this.b[0]) * e + this.c[0]) * e + this.d[0], ((this.a[1] * e + this.b[1]) * e + this.c[1]) * e + this.d[1]];
      }, PolynomialBezier.prototype.derivative = function(e) {
        return [(3 * e * this.a[0] + 2 * this.b[0]) * e + this.c[0], (3 * e * this.a[1] + 2 * this.b[1]) * e + this.c[1]];
      }, PolynomialBezier.prototype.tangentAngle = function(e) {
        var j = this.derivative(e);
        return Math.atan2(j[1], j[0]);
      }, PolynomialBezier.prototype.normalAngle = function(e) {
        var j = this.derivative(e);
        return Math.atan2(j[0], j[1]);
      }, PolynomialBezier.prototype.inflectionPoints = function() {
        var e = this.a[1] * this.b[0] - this.a[0] * this.b[1];
        if (floatZero(e)) return [];
        var j = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / e, ke = j * j - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / e;
        if (ke < 0) return [];
        var Se = Math.sqrt(ke);
        return floatZero(Se) ? Se > 0 && Se < 1 ? [j] : [] : [j - Se, j + Se].filter(function(xe) {
          return xe > 0 && xe < 1;
        });
      }, PolynomialBezier.prototype.split = function(e) {
        if (e <= 0) return [singlePoint(this.points[0]), this];
        if (e >= 1) return [this, singlePoint(this.points[this.points.length - 1])];
        var j = lerpPoint(this.points[0], this.points[1], e), ke = lerpPoint(this.points[1], this.points[2], e), Se = lerpPoint(this.points[2], this.points[3], e), xe = lerpPoint(j, ke, e), Ie = lerpPoint(ke, Se, e), Me = lerpPoint(xe, Ie, e);
        return [new PolynomialBezier(this.points[0], j, xe, Me, !0), new PolynomialBezier(Me, Ie, Se, this.points[3], !0)];
      };
      function extrema(e, j) {
        var ke = e.points[0][j], Se = e.points[e.points.length - 1][j];
        if (ke > Se) {
          var xe = Se;
          Se = ke, ke = xe;
        }
        for (var Ie = quadRoots(3 * e.a[j], 2 * e.b[j], e.c[j]), Me = 0; Me < Ie.length; Me += 1)
          if (Ie[Me] > 0 && Ie[Me] < 1) {
            var Ee = e.point(Ie[Me])[j];
            Ee < ke ? ke = Ee : Ee > Se && (Se = Ee);
          }
        return {
          min: ke,
          max: Se
        };
      }
      PolynomialBezier.prototype.bounds = function() {
        return {
          x: extrema(this, 0),
          y: extrema(this, 1)
        };
      }, PolynomialBezier.prototype.boundingBox = function() {
        var e = this.bounds();
        return {
          left: e.x.min,
          right: e.x.max,
          top: e.y.min,
          bottom: e.y.max,
          width: e.x.max - e.x.min,
          height: e.y.max - e.y.min,
          cx: (e.x.max + e.x.min) / 2,
          cy: (e.y.max + e.y.min) / 2
        };
      };
      function intersectData(e, j, ke) {
        var Se = e.boundingBox();
        return {
          cx: Se.cx,
          cy: Se.cy,
          width: Se.width,
          height: Se.height,
          bez: e,
          t: (j + ke) / 2,
          t1: j,
          t2: ke
        };
      }
      function splitData(e) {
        var j = e.bez.split(0.5);
        return [intersectData(j[0], e.t1, e.t), intersectData(j[1], e.t, e.t2)];
      }
      function boxIntersect(e, j) {
        return Math.abs(e.cx - j.cx) * 2 < e.width + j.width && Math.abs(e.cy - j.cy) * 2 < e.height + j.height;
      }
      function intersectsImpl(e, j, ke, Se, xe, Ie) {
        if (boxIntersect(e, j)) {
          if (ke >= Ie || e.width <= Se && e.height <= Se && j.width <= Se && j.height <= Se) {
            xe.push([e.t, j.t]);
            return;
          }
          var Me = splitData(e), Ee = splitData(j);
          intersectsImpl(Me[0], Ee[0], ke + 1, Se, xe, Ie), intersectsImpl(Me[0], Ee[1], ke + 1, Se, xe, Ie), intersectsImpl(Me[1], Ee[0], ke + 1, Se, xe, Ie), intersectsImpl(Me[1], Ee[1], ke + 1, Se, xe, Ie);
        }
      }
      PolynomialBezier.prototype.intersections = function(e, j, ke) {
        j === void 0 && (j = 2), ke === void 0 && (ke = 7);
        var Se = [];
        return intersectsImpl(intersectData(this, 0, 1), intersectData(e, 0, 1), 0, j, Se, ke), Se;
      }, PolynomialBezier.shapeSegment = function(e, j) {
        var ke = (j + 1) % e.length();
        return new PolynomialBezier(e.v[j], e.o[j], e.i[ke], e.v[ke], !0);
      }, PolynomialBezier.shapeSegmentInverted = function(e, j) {
        var ke = (j + 1) % e.length();
        return new PolynomialBezier(e.v[ke], e.i[ke], e.o[j], e.v[j], !0);
      };
      function crossProduct(e, j) {
        return [e[1] * j[2] - e[2] * j[1], e[2] * j[0] - e[0] * j[2], e[0] * j[1] - e[1] * j[0]];
      }
      function lineIntersection(e, j, ke, Se) {
        var xe = [e[0], e[1], 1], Ie = [j[0], j[1], 1], Me = [ke[0], ke[1], 1], Ee = [Se[0], Se[1], 1], Be = crossProduct(crossProduct(xe, Ie), crossProduct(Me, Ee));
        return floatZero(Be[2]) ? null : [Be[0] / Be[2], Be[1] / Be[2]];
      }
      function polarOffset(e, j, ke) {
        return [e[0] + Math.cos(j) * ke, e[1] - Math.sin(j) * ke];
      }
      function pointDistance(e, j) {
        return Math.hypot(e[0] - j[0], e[1] - j[1]);
      }
      function pointEqual(e, j) {
        return floatEqual(e[0], j[0]) && floatEqual(e[1], j[1]);
      }
      function ZigZagModifier() {
      }
      extendPrototype([ShapeModifier], ZigZagModifier), ZigZagModifier.prototype.initModifierProperties = function(e, j) {
        this.getValue = this.processKeys, this.amplitude = PropertyFactory.getProp(e, j.s, 0, null, this), this.frequency = PropertyFactory.getProp(e, j.r, 0, null, this), this.pointsType = PropertyFactory.getProp(e, j.pt, 0, null, this), this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
      };
      function setPoint(e, j, ke, Se, xe, Ie, Me) {
        var Ee = ke - Math.PI / 2, Be = ke + Math.PI / 2, $e = j[0] + Math.cos(ke) * Se * xe, Le = j[1] - Math.sin(ke) * Se * xe;
        e.setTripleAt($e, Le, $e + Math.cos(Ee) * Ie, Le - Math.sin(Ee) * Ie, $e + Math.cos(Be) * Me, Le - Math.sin(Be) * Me, e.length());
      }
      function getPerpendicularVector(e, j) {
        var ke = [j[0] - e[0], j[1] - e[1]], Se = -Math.PI * 0.5, xe = [Math.cos(Se) * ke[0] - Math.sin(Se) * ke[1], Math.sin(Se) * ke[0] + Math.cos(Se) * ke[1]];
        return xe;
      }
      function getProjectingAngle(e, j) {
        var ke = j === 0 ? e.length() - 1 : j - 1, Se = (j + 1) % e.length(), xe = e.v[ke], Ie = e.v[Se], Me = getPerpendicularVector(xe, Ie);
        return Math.atan2(0, 1) - Math.atan2(Me[1], Me[0]);
      }
      function zigZagCorner(e, j, ke, Se, xe, Ie, Me) {
        var Ee = getProjectingAngle(j, ke), Be = j.v[ke % j._length], $e = j.v[ke === 0 ? j._length - 1 : ke - 1], Le = j.v[(ke + 1) % j._length], Fe = Ie === 2 ? Math.sqrt(Math.pow(Be[0] - $e[0], 2) + Math.pow(Be[1] - $e[1], 2)) : 0, Ve = Ie === 2 ? Math.sqrt(Math.pow(Be[0] - Le[0], 2) + Math.pow(Be[1] - Le[1], 2)) : 0;
        setPoint(e, j.v[ke % j._length], Ee, Me, Se, Ve / ((xe + 1) * 2), Fe / ((xe + 1) * 2));
      }
      function zigZagSegment(e, j, ke, Se, xe, Ie) {
        for (var Me = 0; Me < Se; Me += 1) {
          var Ee = (Me + 1) / (Se + 1), Be = xe === 2 ? Math.sqrt(Math.pow(j.points[3][0] - j.points[0][0], 2) + Math.pow(j.points[3][1] - j.points[0][1], 2)) : 0, $e = j.normalAngle(Ee), Le = j.point(Ee);
          setPoint(e, Le, $e, Ie, ke, Be / ((Se + 1) * 2), Be / ((Se + 1) * 2)), Ie = -Ie;
        }
        return Ie;
      }
      ZigZagModifier.prototype.processPath = function(e, j, ke, Se) {
        var xe = e._length, Ie = shapePool.newElement();
        if (Ie.c = e.c, e.c || (xe -= 1), xe === 0) return Ie;
        var Me = -1, Ee = PolynomialBezier.shapeSegment(e, 0);
        zigZagCorner(Ie, e, 0, j, ke, Se, Me);
        for (var Be = 0; Be < xe; Be += 1)
          Me = zigZagSegment(Ie, Ee, j, ke, Se, -Me), Be === xe - 1 && !e.c ? Ee = null : Ee = PolynomialBezier.shapeSegment(e, (Be + 1) % xe), zigZagCorner(Ie, e, Be + 1, j, ke, Se, Me);
        return Ie;
      }, ZigZagModifier.prototype.processShapes = function(e) {
        var j, ke, Se = this.shapes.length, xe, Ie, Me = this.amplitude.v, Ee = Math.max(0, Math.round(this.frequency.v)), Be = this.pointsType.v;
        if (Me !== 0) {
          var $e, Le;
          for (ke = 0; ke < Se; ke += 1) {
            if ($e = this.shapes[ke], Le = $e.localShapeCollection, !(!$e.shape._mdf && !this._mdf && !e))
              for (Le.releaseShapes(), $e.shape._mdf = !0, j = $e.shape.paths.shapes, Ie = $e.shape.paths._length, xe = 0; xe < Ie; xe += 1)
                Le.addShape(this.processPath(j[xe], Me, Ee, Be));
            $e.shape.paths = $e.localShapeCollection;
          }
        }
        this.dynamicProperties.length || (this._mdf = !1);
      };
      function linearOffset(e, j, ke) {
        var Se = Math.atan2(j[0] - e[0], j[1] - e[1]);
        return [polarOffset(e, Se, ke), polarOffset(j, Se, ke)];
      }
      function offsetSegment(e, j) {
        var ke, Se, xe, Ie, Me, Ee, Be;
        Be = linearOffset(e.points[0], e.points[1], j), ke = Be[0], Se = Be[1], Be = linearOffset(e.points[1], e.points[2], j), xe = Be[0], Ie = Be[1], Be = linearOffset(e.points[2], e.points[3], j), Me = Be[0], Ee = Be[1];
        var $e = lineIntersection(ke, Se, xe, Ie);
        $e === null && ($e = Se);
        var Le = lineIntersection(Me, Ee, xe, Ie);
        return Le === null && (Le = Me), new PolynomialBezier(ke, $e, Le, Ee);
      }
      function joinLines(e, j, ke, Se, xe) {
        var Ie = j.points[3], Me = ke.points[0];
        if (Se === 3 || pointEqual(Ie, Me)) return Ie;
        if (Se === 2) {
          var Ee = -j.tangentAngle(1), Be = -ke.tangentAngle(0) + Math.PI, $e = lineIntersection(Ie, polarOffset(Ie, Ee + Math.PI / 2, 100), Me, polarOffset(Me, Ee + Math.PI / 2, 100)), Le = $e ? pointDistance($e, Ie) : pointDistance(Ie, Me) / 2, Fe = polarOffset(Ie, Ee, 2 * Le * roundCorner);
          return e.setXYAt(Fe[0], Fe[1], "o", e.length() - 1), Fe = polarOffset(Me, Be, 2 * Le * roundCorner), e.setTripleAt(Me[0], Me[1], Me[0], Me[1], Fe[0], Fe[1], e.length()), Me;
        }
        var Ve = pointEqual(Ie, j.points[2]) ? j.points[0] : j.points[2], je = pointEqual(Me, ke.points[1]) ? ke.points[3] : ke.points[1], Ge = lineIntersection(Ve, Ie, Me, je);
        return Ge && pointDistance(Ge, Ie) < xe ? (e.setTripleAt(Ge[0], Ge[1], Ge[0], Ge[1], Ge[0], Ge[1], e.length()), Ge) : Ie;
      }
      function getIntersection(e, j) {
        var ke = e.intersections(j);
        return ke.length && floatEqual(ke[0][0], 1) && ke.shift(), ke.length ? ke[0] : null;
      }
      function pruneSegmentIntersection(e, j) {
        var ke = e.slice(), Se = j.slice(), xe = getIntersection(e[e.length - 1], j[0]);
        return xe && (ke[e.length - 1] = e[e.length - 1].split(xe[0])[0], Se[0] = j[0].split(xe[1])[1]), e.length > 1 && j.length > 1 && (xe = getIntersection(e[0], j[j.length - 1]), xe) ? [[e[0].split(xe[0])[0]], [j[j.length - 1].split(xe[1])[1]]] : [ke, Se];
      }
      function pruneIntersections(e) {
        for (var j, ke = 1; ke < e.length; ke += 1)
          j = pruneSegmentIntersection(e[ke - 1], e[ke]), e[ke - 1] = j[0], e[ke] = j[1];
        return e.length > 1 && (j = pruneSegmentIntersection(e[e.length - 1], e[0]), e[e.length - 1] = j[0], e[0] = j[1]), e;
      }
      function offsetSegmentSplit(e, j) {
        var ke = e.inflectionPoints(), Se, xe, Ie, Me;
        if (ke.length === 0)
          return [offsetSegment(e, j)];
        if (ke.length === 1 || floatEqual(ke[1], 1))
          return Ie = e.split(ke[0]), Se = Ie[0], xe = Ie[1], [offsetSegment(Se, j), offsetSegment(xe, j)];
        Ie = e.split(ke[0]), Se = Ie[0];
        var Ee = (ke[1] - ke[0]) / (1 - ke[0]);
        return Ie = Ie[1].split(Ee), Me = Ie[0], xe = Ie[1], [offsetSegment(Se, j), offsetSegment(Me, j), offsetSegment(xe, j)];
      }
      function OffsetPathModifier() {
      }
      extendPrototype([ShapeModifier], OffsetPathModifier), OffsetPathModifier.prototype.initModifierProperties = function(e, j) {
        this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(e, j.a, 0, null, this), this.miterLimit = PropertyFactory.getProp(e, j.ml, 0, null, this), this.lineJoin = j.lj, this._isAnimated = this.amount.effectsSequence.length !== 0;
      }, OffsetPathModifier.prototype.processPath = function(e, j, ke, Se) {
        var xe = shapePool.newElement();
        xe.c = e.c;
        var Ie = e.length();
        e.c || (Ie -= 1);
        var Me, Ee, Be, $e = [];
        for (Me = 0; Me < Ie; Me += 1)
          Be = PolynomialBezier.shapeSegment(e, Me), $e.push(offsetSegmentSplit(Be, j));
        if (!e.c)
          for (Me = Ie - 1; Me >= 0; Me -= 1)
            Be = PolynomialBezier.shapeSegmentInverted(e, Me), $e.push(offsetSegmentSplit(Be, j));
        $e = pruneIntersections($e);
        var Le = null, Fe = null;
        for (Me = 0; Me < $e.length; Me += 1) {
          var Ve = $e[Me];
          for (Fe && (Le = joinLines(xe, Fe, Ve[0], ke, Se)), Fe = Ve[Ve.length - 1], Ee = 0; Ee < Ve.length; Ee += 1)
            Be = Ve[Ee], Le && pointEqual(Be.points[0], Le) ? xe.setXYAt(Be.points[1][0], Be.points[1][1], "o", xe.length() - 1) : xe.setTripleAt(Be.points[0][0], Be.points[0][1], Be.points[1][0], Be.points[1][1], Be.points[0][0], Be.points[0][1], xe.length()), xe.setTripleAt(Be.points[3][0], Be.points[3][1], Be.points[3][0], Be.points[3][1], Be.points[2][0], Be.points[2][1], xe.length()), Le = Be.points[3];
        }
        return $e.length && joinLines(xe, Fe, $e[0][0], ke, Se), xe;
      }, OffsetPathModifier.prototype.processShapes = function(e) {
        var j, ke, Se = this.shapes.length, xe, Ie, Me = this.amount.v, Ee = this.miterLimit.v, Be = this.lineJoin;
        if (Me !== 0) {
          var $e, Le;
          for (ke = 0; ke < Se; ke += 1) {
            if ($e = this.shapes[ke], Le = $e.localShapeCollection, !(!$e.shape._mdf && !this._mdf && !e))
              for (Le.releaseShapes(), $e.shape._mdf = !0, j = $e.shape.paths.shapes, Ie = $e.shape.paths._length, xe = 0; xe < Ie; xe += 1)
                Le.addShape(this.processPath(j[xe], Me, Be, Ee));
            $e.shape.paths = $e.localShapeCollection;
          }
        }
        this.dynamicProperties.length || (this._mdf = !1);
      };
      function getFontProperties(e) {
        for (var j = e.fStyle ? e.fStyle.split(" ") : [], ke = "normal", Se = "normal", xe = j.length, Ie, Me = 0; Me < xe; Me += 1)
          switch (Ie = j[Me].toLowerCase(), Ie) {
            case "italic":
              Se = "italic";
              break;
            case "bold":
              ke = "700";
              break;
            case "black":
              ke = "900";
              break;
            case "medium":
              ke = "500";
              break;
            case "regular":
            case "normal":
              ke = "400";
              break;
            case "light":
            case "thin":
              ke = "200";
              break;
          }
        return {
          style: Se,
          weight: e.fWeight || ke
        };
      }
      var FontManager = function() {
        var e = 5e3, j = {
          w: 0,
          size: 0,
          shapes: [],
          data: {
            shapes: []
          }
        }, ke = [];
        ke = ke.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
        var Se = 127988, xe = 917631, Ie = 917601, Me = 917626, Ee = 65039, Be = 8205, $e = 127462, Le = 127487, Fe = ["d83cdffb", "d83cdffc", "d83cdffd", "d83cdffe", "d83cdfff"];
        function Ve(kt) {
          var Et = kt.split(","), Qe, Xe = Et.length, Vt = [];
          for (Qe = 0; Qe < Xe; Qe += 1)
            Et[Qe] !== "sans-serif" && Et[Qe] !== "monospace" && Vt.push(Et[Qe]);
          return Vt.join(",");
        }
        function je(kt, Et) {
          var Qe = createTag("span");
          Qe.setAttribute("aria-hidden", !0), Qe.style.fontFamily = Et;
          var Xe = createTag("span");
          Xe.innerText = "giItT1WQy@!-/#", Qe.style.position = "absolute", Qe.style.left = "-10000px", Qe.style.top = "-10000px", Qe.style.fontSize = "300px", Qe.style.fontVariant = "normal", Qe.style.fontStyle = "normal", Qe.style.fontWeight = "normal", Qe.style.letterSpacing = "0", Qe.appendChild(Xe), document.body.appendChild(Qe);
          var Vt = Xe.offsetWidth;
          return Xe.style.fontFamily = Ve(kt) + ", " + Et, {
            node: Xe,
            w: Vt,
            parent: Qe
          };
        }
        function Ge() {
          var kt, Et = this.fonts.length, Qe, Xe, Vt = Et;
          for (kt = 0; kt < Et; kt += 1)
            this.fonts[kt].loaded ? Vt -= 1 : this.fonts[kt].fOrigin === "n" || this.fonts[kt].origin === 0 ? this.fonts[kt].loaded = !0 : (Qe = this.fonts[kt].monoCase.node, Xe = this.fonts[kt].monoCase.w, Qe.offsetWidth !== Xe ? (Vt -= 1, this.fonts[kt].loaded = !0) : (Qe = this.fonts[kt].sansCase.node, Xe = this.fonts[kt].sansCase.w, Qe.offsetWidth !== Xe && (Vt -= 1, this.fonts[kt].loaded = !0)), this.fonts[kt].loaded && (this.fonts[kt].sansCase.parent.parentNode.removeChild(this.fonts[kt].sansCase.parent), this.fonts[kt].monoCase.parent.parentNode.removeChild(this.fonts[kt].monoCase.parent)));
          Vt !== 0 && Date.now() - this.initTime < e ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
        }
        function De(kt, Et) {
          var Qe = document.body && Et ? "svg" : "canvas", Xe, Vt = getFontProperties(kt);
          if (Qe === "svg") {
            var Lt = createNS("text");
            Lt.style.fontSize = "100px", Lt.setAttribute("font-family", kt.fFamily), Lt.setAttribute("font-style", Vt.style), Lt.setAttribute("font-weight", Vt.weight), Lt.textContent = "1", kt.fClass ? (Lt.style.fontFamily = "inherit", Lt.setAttribute("class", kt.fClass)) : Lt.style.fontFamily = kt.fFamily, Et.appendChild(Lt), Xe = Lt;
          } else {
            var Gt = new OffscreenCanvas(500, 500).getContext("2d");
            Gt.font = Vt.style + " " + Vt.weight + " 100px " + kt.fFamily, Xe = Gt;
          }
          function Wt(Zt) {
            return Qe === "svg" ? (Xe.textContent = Zt, Xe.getComputedTextLength()) : Xe.measureText(Zt).width;
          }
          return {
            measureText: Wt
          };
        }
        function Ue(kt, Et) {
          if (!kt) {
            this.isLoaded = !0;
            return;
          }
          if (this.chars) {
            this.isLoaded = !0, this.fonts = kt.list;
            return;
          }
          if (!document.body) {
            this.isLoaded = !0, kt.list.forEach(function(jt) {
              jt.helper = De(jt), jt.cache = {};
            }), this.fonts = kt.list;
            return;
          }
          var Qe = kt.list, Xe, Vt = Qe.length, Lt = Vt;
          for (Xe = 0; Xe < Vt; Xe += 1) {
            var Gt = !0, Wt, Zt;
            if (Qe[Xe].loaded = !1, Qe[Xe].monoCase = je(Qe[Xe].fFamily, "monospace"), Qe[Xe].sansCase = je(Qe[Xe].fFamily, "sans-serif"), !Qe[Xe].fPath)
              Qe[Xe].loaded = !0, Lt -= 1;
            else if (Qe[Xe].fOrigin === "p" || Qe[Xe].origin === 3) {
              if (Wt = document.querySelectorAll('style[f-forigin="p"][f-family="' + Qe[Xe].fFamily + '"], style[f-origin="3"][f-family="' + Qe[Xe].fFamily + '"]'), Wt.length > 0 && (Gt = !1), Gt) {
                var Ot = createTag("style");
                Ot.setAttribute("f-forigin", Qe[Xe].fOrigin), Ot.setAttribute("f-origin", Qe[Xe].origin), Ot.setAttribute("f-family", Qe[Xe].fFamily), Ot.type = "text/css", Ot.innerText = "@font-face {font-family: " + Qe[Xe].fFamily + "; font-style: normal; src: url('" + Qe[Xe].fPath + "');}", Et.appendChild(Ot);
              }
            } else if (Qe[Xe].fOrigin === "g" || Qe[Xe].origin === 1) {
              for (Wt = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), Zt = 0; Zt < Wt.length; Zt += 1)
                Wt[Zt].href.indexOf(Qe[Xe].fPath) !== -1 && (Gt = !1);
              if (Gt) {
                var Ht = createTag("link");
                Ht.setAttribute("f-forigin", Qe[Xe].fOrigin), Ht.setAttribute("f-origin", Qe[Xe].origin), Ht.type = "text/css", Ht.rel = "stylesheet", Ht.href = Qe[Xe].fPath, document.body.appendChild(Ht);
              }
            } else if (Qe[Xe].fOrigin === "t" || Qe[Xe].origin === 2) {
              for (Wt = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), Zt = 0; Zt < Wt.length; Zt += 1)
                Qe[Xe].fPath === Wt[Zt].src && (Gt = !1);
              if (Gt) {
                var Rt = createTag("link");
                Rt.setAttribute("f-forigin", Qe[Xe].fOrigin), Rt.setAttribute("f-origin", Qe[Xe].origin), Rt.setAttribute("rel", "stylesheet"), Rt.setAttribute("href", Qe[Xe].fPath), Et.appendChild(Rt);
              }
            }
            Qe[Xe].helper = De(Qe[Xe], Et), Qe[Xe].cache = {}, this.fonts.push(Qe[Xe]);
          }
          Lt === 0 ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
        }
        function Re(kt) {
          if (kt) {
            this.chars || (this.chars = []);
            var Et, Qe = kt.length, Xe, Vt = this.chars.length, Lt;
            for (Et = 0; Et < Qe; Et += 1) {
              for (Xe = 0, Lt = !1; Xe < Vt; )
                this.chars[Xe].style === kt[Et].style && this.chars[Xe].fFamily === kt[Et].fFamily && this.chars[Xe].ch === kt[Et].ch && (Lt = !0), Xe += 1;
              Lt || (this.chars.push(kt[Et]), Vt += 1);
            }
          }
        }
        function Ye(kt, Et, Qe) {
          for (var Xe = 0, Vt = this.chars.length; Xe < Vt; ) {
            if (this.chars[Xe].ch === kt && this.chars[Xe].style === Et && this.chars[Xe].fFamily === Qe)
              return this.chars[Xe];
            Xe += 1;
          }
          return (typeof kt == "string" && kt.charCodeAt(0) !== 13 || !kt) && console && console.warn && !this._warned && (this._warned = !0, console.warn("Missing character from exported characters list: ", kt, Et, Qe)), j;
        }
        function We(kt, Et, Qe) {
          var Xe = this.getFontByName(Et), Vt = kt;
          if (!Xe.cache[Vt]) {
            var Lt = Xe.helper;
            if (kt === " ") {
              var Gt = Lt.measureText("|" + kt + "|"), Wt = Lt.measureText("||");
              Xe.cache[Vt] = (Gt - Wt) / 100;
            } else
              Xe.cache[Vt] = Lt.measureText(kt) / 100;
          }
          return Xe.cache[Vt] * Qe;
        }
        function qe(kt) {
          for (var Et = 0, Qe = this.fonts.length; Et < Qe; ) {
            if (this.fonts[Et].fName === kt)
              return this.fonts[Et];
            Et += 1;
          }
          return this.fonts[0];
        }
        function Je(kt) {
          var Et = 0, Qe = kt.charCodeAt(0);
          if (Qe >= 55296 && Qe <= 56319) {
            var Xe = kt.charCodeAt(1);
            Xe >= 56320 && Xe <= 57343 && (Et = (Qe - 55296) * 1024 + Xe - 56320 + 65536);
          }
          return Et;
        }
        function Ke(kt, Et) {
          var Qe = kt.toString(16) + Et.toString(16);
          return Fe.indexOf(Qe) !== -1;
        }
        function xt(kt) {
          return kt === Be;
        }
        function Ct(kt) {
          return kt === Ee;
        }
        function It(kt) {
          var Et = Je(kt);
          return Et >= $e && Et <= Le;
        }
        function Nt(kt) {
          return It(kt.substr(0, 2)) && It(kt.substr(2, 2));
        }
        function Bt(kt) {
          return ke.indexOf(kt) !== -1;
        }
        function At(kt, Et) {
          var Qe = Je(kt.substr(Et, 2));
          if (Qe !== Se)
            return !1;
          var Xe = 0;
          for (Et += 2; Xe < 5; ) {
            if (Qe = Je(kt.substr(Et, 2)), Qe < Ie || Qe > Me)
              return !1;
            Xe += 1, Et += 2;
          }
          return Je(kt.substr(Et, 2)) === xe;
        }
        function Ft() {
          this.isLoaded = !0;
        }
        var Dt = function() {
          this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
        };
        Dt.isModifier = Ke, Dt.isZeroWidthJoiner = xt, Dt.isFlagEmoji = Nt, Dt.isRegionalCode = It, Dt.isCombinedCharacter = Bt, Dt.isRegionalFlag = At, Dt.isVariationSelector = Ct, Dt.BLACK_FLAG_CODE_POINT = Se;
        var zt = {
          addChars: Re,
          addFonts: Ue,
          getCharData: Ye,
          getFontByName: qe,
          measureText: We,
          checkLoadedFonts: Ge,
          setIsLoaded: Ft
        };
        return Dt.prototype = zt, Dt;
      }();
      function SlotManager(e) {
        this.animationData = e;
      }
      SlotManager.prototype.getProp = function(e) {
        return this.animationData.slots && this.animationData.slots[e.sid] ? Object.assign(e, this.animationData.slots[e.sid].p) : e;
      };
      function slotFactory(e) {
        return new SlotManager(e);
      }
      function RenderableElement() {
      }
      RenderableElement.prototype = {
        initRenderable: function() {
          this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
        },
        addRenderableComponent: function(j) {
          this.renderableComponents.indexOf(j) === -1 && this.renderableComponents.push(j);
        },
        removeRenderableComponent: function(j) {
          this.renderableComponents.indexOf(j) !== -1 && this.renderableComponents.splice(this.renderableComponents.indexOf(j), 1);
        },
        prepareRenderableFrame: function(j) {
          this.checkLayerLimits(j);
        },
        checkTransparency: function() {
          this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
        },
        /**
           * @function
           * Initializes frame related properties.
           *
           * @param {number} num
           * current frame number in Layer's time
           *
           */
        checkLayerLimits: function(j) {
          this.data.ip - this.data.st <= j && this.data.op - this.data.st > j ? this.isInRange !== !0 && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : this.isInRange !== !1 && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
        },
        renderRenderable: function() {
          var j, ke = this.renderableComponents.length;
          for (j = 0; j < ke; j += 1)
            this.renderableComponents[j].renderFrame(this._isFirstFrame);
        },
        sourceRectAtTime: function() {
          return {
            top: 0,
            left: 0,
            width: 100,
            height: 100
          };
        },
        getLayerSize: function() {
          return this.data.ty === 5 ? {
            w: this.data.textData.width,
            h: this.data.textData.height
          } : {
            w: this.data.width,
            h: this.data.height
          };
        }
      };
      var getBlendMode = /* @__PURE__ */ function() {
        var e = {
          0: "source-over",
          1: "multiply",
          2: "screen",
          3: "overlay",
          4: "darken",
          5: "lighten",
          6: "color-dodge",
          7: "color-burn",
          8: "hard-light",
          9: "soft-light",
          10: "difference",
          11: "exclusion",
          12: "hue",
          13: "saturation",
          14: "color",
          15: "luminosity"
        };
        return function(j) {
          return e[j] || "";
        };
      }();
      function SliderEffect(e, j, ke) {
        this.p = PropertyFactory.getProp(j, e.v, 0, 0, ke);
      }
      function AngleEffect(e, j, ke) {
        this.p = PropertyFactory.getProp(j, e.v, 0, 0, ke);
      }
      function ColorEffect(e, j, ke) {
        this.p = PropertyFactory.getProp(j, e.v, 1, 0, ke);
      }
      function PointEffect(e, j, ke) {
        this.p = PropertyFactory.getProp(j, e.v, 1, 0, ke);
      }
      function LayerIndexEffect(e, j, ke) {
        this.p = PropertyFactory.getProp(j, e.v, 0, 0, ke);
      }
      function MaskIndexEffect(e, j, ke) {
        this.p = PropertyFactory.getProp(j, e.v, 0, 0, ke);
      }
      function CheckboxEffect(e, j, ke) {
        this.p = PropertyFactory.getProp(j, e.v, 0, 0, ke);
      }
      function NoValueEffect() {
        this.p = {};
      }
      function EffectsManager(e, j) {
        var ke = e.ef || [];
        this.effectElements = [];
        var Se, xe = ke.length, Ie;
        for (Se = 0; Se < xe; Se += 1)
          Ie = new GroupEffect(ke[Se], j), this.effectElements.push(Ie);
      }
      function GroupEffect(e, j) {
        this.init(e, j);
      }
      extendPrototype([DynamicPropertyContainer], GroupEffect), GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties, GroupEffect.prototype.init = function(e, j) {
        this.data = e, this.effectElements = [], this.initDynamicPropertyContainer(j);
        var ke, Se = this.data.ef.length, xe, Ie = this.data.ef;
        for (ke = 0; ke < Se; ke += 1) {
          switch (xe = null, Ie[ke].ty) {
            case 0:
              xe = new SliderEffect(Ie[ke], j, this);
              break;
            case 1:
              xe = new AngleEffect(Ie[ke], j, this);
              break;
            case 2:
              xe = new ColorEffect(Ie[ke], j, this);
              break;
            case 3:
              xe = new PointEffect(Ie[ke], j, this);
              break;
            case 4:
            case 7:
              xe = new CheckboxEffect(Ie[ke], j, this);
              break;
            case 10:
              xe = new LayerIndexEffect(Ie[ke], j, this);
              break;
            case 11:
              xe = new MaskIndexEffect(Ie[ke], j, this);
              break;
            case 5:
              xe = new EffectsManager(Ie[ke], j);
              break;
            // case 6:
            default:
              xe = new NoValueEffect(Ie[ke]);
              break;
          }
          xe && this.effectElements.push(xe);
        }
      };
      function BaseElement() {
      }
      BaseElement.prototype = {
        checkMasks: function() {
          if (!this.data.hasMask)
            return !1;
          for (var j = 0, ke = this.data.masksProperties.length; j < ke; ) {
            if (this.data.masksProperties[j].mode !== "n" && this.data.masksProperties[j].cl !== !1)
              return !0;
            j += 1;
          }
          return !1;
        },
        initExpressions: function() {
          var j = getExpressionInterfaces();
          if (j) {
            var ke = j("layer"), Se = j("effects"), xe = j("shape"), Ie = j("text"), Me = j("comp");
            this.layerInterface = ke(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
            var Ee = Se.createEffectsInterface(this, this.layerInterface);
            this.layerInterface.registerEffectsInterface(Ee), this.data.ty === 0 || this.data.xt ? this.compInterface = Me(this) : this.data.ty === 4 ? (this.layerInterface.shapeInterface = xe(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : this.data.ty === 5 && (this.layerInterface.textInterface = Ie(this), this.layerInterface.text = this.layerInterface.textInterface);
          }
        },
        setBlendMode: function() {
          var j = getBlendMode(this.data.bm), ke = this.baseElement || this.layerElement;
          ke.style["mix-blend-mode"] = j;
        },
        initBaseData: function(j, ke, Se) {
          this.globalData = ke, this.comp = Se, this.data = j, this.layerId = createElementID(), this.data.sr || (this.data.sr = 1), this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
        },
        getType: function() {
          return this.type;
        },
        sourceRectAtTime: function() {
        }
      };
      function FrameElement() {
      }
      FrameElement.prototype = {
        /**
           * @function
           * Initializes frame related properties.
           *
           */
        initFrame: function() {
          this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
        },
        /**
           * @function
           * Calculates all dynamic values
           *
           * @param {number} num
           * current frame number in Layer's time
           * @param {boolean} isVisible
           * if layers is currently in range
           *
           */
        prepareProperties: function(j, ke) {
          var Se, xe = this.dynamicProperties.length;
          for (Se = 0; Se < xe; Se += 1)
            (ke || this._isParent && this.dynamicProperties[Se].propType === "transform") && (this.dynamicProperties[Se].getValue(), this.dynamicProperties[Se]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
        },
        addDynamicProperty: function(j) {
          this.dynamicProperties.indexOf(j) === -1 && this.dynamicProperties.push(j);
        }
      };
      function FootageElement(e, j, ke) {
        this.initFrame(), this.initRenderable(), this.assetData = j.getAssetData(e.refId), this.footageData = j.imageLoader.getAsset(this.assetData), this.initBaseData(e, j, ke);
      }
      FootageElement.prototype.prepareFrame = function() {
      }, extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement), FootageElement.prototype.getBaseElement = function() {
        return null;
      }, FootageElement.prototype.renderFrame = function() {
      }, FootageElement.prototype.destroy = function() {
      }, FootageElement.prototype.initExpressions = function() {
        var e = getExpressionInterfaces();
        if (e) {
          var j = e("footage");
          this.layerInterface = j(this);
        }
      }, FootageElement.prototype.getFootageData = function() {
        return this.footageData;
      };
      function AudioElement(e, j, ke) {
        this.initFrame(), this.initRenderable(), this.assetData = j.getAssetData(e.refId), this.initBaseData(e, j, ke), this._isPlaying = !1, this._canPlay = !1;
        var Se = this.globalData.getAssetsPath(this.assetData);
        this.audio = this.globalData.audioController.createAudio(Se), this._currentTime = 0, this.globalData.audioController.addAudio(this), this._volumeMultiplier = 1, this._volume = 1, this._previousVolume = null, this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, j.frameRate, this) : {
          _placeholder: !0
        }, this.lv = PropertyFactory.getProp(this, e.au && e.au.lv ? e.au.lv : {
          k: [100]
        }, 1, 0.01, this);
      }
      AudioElement.prototype.prepareFrame = function(e) {
        if (this.prepareRenderableFrame(e, !0), this.prepareProperties(e, !0), this.tm._placeholder)
          this._currentTime = e / this.data.sr;
        else {
          var j = this.tm.v;
          this._currentTime = j;
        }
        this._volume = this.lv.v[0];
        var ke = this._volume * this._volumeMultiplier;
        this._previousVolume !== ke && (this._previousVolume = ke, this.audio.volume(ke));
      }, extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement), AudioElement.prototype.renderFrame = function() {
        this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
      }, AudioElement.prototype.show = function() {
      }, AudioElement.prototype.hide = function() {
        this.audio.pause(), this._isPlaying = !1;
      }, AudioElement.prototype.pause = function() {
        this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
      }, AudioElement.prototype.resume = function() {
        this._canPlay = !0;
      }, AudioElement.prototype.setRate = function(e) {
        this.audio.rate(e);
      }, AudioElement.prototype.volume = function(e) {
        this._volumeMultiplier = e, this._previousVolume = e * this._volume, this.audio.volume(this._previousVolume);
      }, AudioElement.prototype.getBaseElement = function() {
        return null;
      }, AudioElement.prototype.destroy = function() {
      }, AudioElement.prototype.sourceRectAtTime = function() {
      }, AudioElement.prototype.initExpressions = function() {
      };
      function BaseRenderer() {
      }
      BaseRenderer.prototype.checkLayers = function(e) {
        var j, ke = this.layers.length, Se;
        for (this.completeLayers = !0, j = ke - 1; j >= 0; j -= 1)
          this.elements[j] || (Se = this.layers[j], Se.ip - Se.st <= e - this.layers[j].st && Se.op - Se.st > e - this.layers[j].st && this.buildItem(j)), this.completeLayers = this.elements[j] ? this.completeLayers : !1;
        this.checkPendingElements();
      }, BaseRenderer.prototype.createItem = function(e) {
        switch (e.ty) {
          case 2:
            return this.createImage(e);
          case 0:
            return this.createComp(e);
          case 1:
            return this.createSolid(e);
          case 3:
            return this.createNull(e);
          case 4:
            return this.createShape(e);
          case 5:
            return this.createText(e);
          case 6:
            return this.createAudio(e);
          case 13:
            return this.createCamera(e);
          case 15:
            return this.createFootage(e);
          default:
            return this.createNull(e);
        }
      }, BaseRenderer.prototype.createCamera = function() {
        throw new Error("You're using a 3d camera. Try the html renderer.");
      }, BaseRenderer.prototype.createAudio = function(e) {
        return new AudioElement(e, this.globalData, this);
      }, BaseRenderer.prototype.createFootage = function(e) {
        return new FootageElement(e, this.globalData, this);
      }, BaseRenderer.prototype.buildAllItems = function() {
        var e, j = this.layers.length;
        for (e = 0; e < j; e += 1)
          this.buildItem(e);
        this.checkPendingElements();
      }, BaseRenderer.prototype.includeLayers = function(e) {
        this.completeLayers = !1;
        var j, ke = e.length, Se, xe = this.layers.length;
        for (j = 0; j < ke; j += 1)
          for (Se = 0; Se < xe; ) {
            if (this.layers[Se].id === e[j].id) {
              this.layers[Se] = e[j];
              break;
            }
            Se += 1;
          }
      }, BaseRenderer.prototype.setProjectInterface = function(e) {
        this.globalData.projectInterface = e;
      }, BaseRenderer.prototype.initItems = function() {
        this.globalData.progressiveLoad || this.buildAllItems();
      }, BaseRenderer.prototype.buildElementParenting = function(e, j, ke) {
        for (var Se = this.elements, xe = this.layers, Ie = 0, Me = xe.length; Ie < Me; )
          xe[Ie].ind == j && (!Se[Ie] || Se[Ie] === !0 ? (this.buildItem(Ie), this.addPendingElement(e)) : (ke.push(Se[Ie]), Se[Ie].setAsParent(), xe[Ie].parent !== void 0 ? this.buildElementParenting(e, xe[Ie].parent, ke) : e.setHierarchy(ke))), Ie += 1;
      }, BaseRenderer.prototype.addPendingElement = function(e) {
        this.pendingElements.push(e);
      }, BaseRenderer.prototype.searchExtraCompositions = function(e) {
        var j, ke = e.length;
        for (j = 0; j < ke; j += 1)
          if (e[j].xt) {
            var Se = this.createComp(e[j]);
            Se.initExpressions(), this.globalData.projectInterface.registerComposition(Se);
          }
      }, BaseRenderer.prototype.getElementById = function(e) {
        var j, ke = this.elements.length;
        for (j = 0; j < ke; j += 1)
          if (this.elements[j].data.ind === e)
            return this.elements[j];
        return null;
      }, BaseRenderer.prototype.getElementByPath = function(e) {
        var j = e.shift(), ke;
        if (typeof j == "number")
          ke = this.elements[j];
        else {
          var Se, xe = this.elements.length;
          for (Se = 0; Se < xe; Se += 1)
            if (this.elements[Se].data.nm === j) {
              ke = this.elements[Se];
              break;
            }
        }
        return e.length === 0 ? ke : ke.getElementByPath(e);
      }, BaseRenderer.prototype.setupGlobalData = function(e, j) {
        this.globalData.fontManager = new FontManager(), this.globalData.slotManager = slotFactory(e), this.globalData.fontManager.addChars(e.chars), this.globalData.fontManager.addFonts(e.fonts, j), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = e.fr, this.globalData.nm = e.nm, this.globalData.compSize = {
          w: e.w,
          h: e.h
        };
      };
      var effectTypes = {
        TRANSFORM_EFFECT: "transformEFfect"
      };
      function TransformElement() {
      }
      TransformElement.prototype = {
        initTransform: function() {
          var j = new Matrix();
          this.finalTransform = {
            mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
              o: 0
            },
            _matMdf: !1,
            _localMatMdf: !1,
            _opMdf: !1,
            mat: j,
            localMat: j,
            localOpacity: 1
          }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
        },
        renderTransform: function() {
          if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
            var j, ke = this.finalTransform.mat, Se = 0, xe = this.hierarchy.length;
            if (!this.finalTransform._matMdf)
              for (; Se < xe; ) {
                if (this.hierarchy[Se].finalTransform.mProp._mdf) {
                  this.finalTransform._matMdf = !0;
                  break;
                }
                Se += 1;
              }
            if (this.finalTransform._matMdf)
              for (j = this.finalTransform.mProp.v.props, ke.cloneFromProps(j), Se = 0; Se < xe; Se += 1)
                ke.multiply(this.hierarchy[Se].finalTransform.mProp.v);
          }
          (!this.localTransforms || this.finalTransform._matMdf) && (this.finalTransform._localMatMdf = this.finalTransform._matMdf), this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v);
        },
        renderLocalTransform: function() {
          if (this.localTransforms) {
            var j = 0, ke = this.localTransforms.length;
            if (this.finalTransform._localMatMdf = this.finalTransform._matMdf, !this.finalTransform._localMatMdf || !this.finalTransform._opMdf)
              for (; j < ke; )
                this.localTransforms[j]._mdf && (this.finalTransform._localMatMdf = !0), this.localTransforms[j]._opMdf && !this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v, this.finalTransform._opMdf = !0), j += 1;
            if (this.finalTransform._localMatMdf) {
              var Se = this.finalTransform.localMat;
              for (this.localTransforms[0].matrix.clone(Se), j = 1; j < ke; j += 1) {
                var xe = this.localTransforms[j].matrix;
                Se.multiply(xe);
              }
              Se.multiply(this.finalTransform.mat);
            }
            if (this.finalTransform._opMdf) {
              var Ie = this.finalTransform.localOpacity;
              for (j = 0; j < ke; j += 1)
                Ie *= this.localTransforms[j].opacity * 0.01;
              this.finalTransform.localOpacity = Ie;
            }
          }
        },
        searchEffectTransforms: function() {
          if (this.renderableEffectsManager) {
            var j = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
            if (j.length) {
              this.localTransforms = [], this.finalTransform.localMat = new Matrix();
              var ke = 0, Se = j.length;
              for (ke = 0; ke < Se; ke += 1)
                this.localTransforms.push(j[ke]);
            }
          }
        },
        globalToLocal: function(j) {
          var ke = [];
          ke.push(this.finalTransform);
          for (var Se = !0, xe = this.comp; Se; )
            xe.finalTransform ? (xe.data.hasMask && ke.splice(0, 0, xe.finalTransform), xe = xe.comp) : Se = !1;
          var Ie, Me = ke.length, Ee;
          for (Ie = 0; Ie < Me; Ie += 1)
            Ee = ke[Ie].mat.applyToPointArray(0, 0, 0), j = [j[0] - Ee[0], j[1] - Ee[1], 0];
          return j;
        },
        mHelper: new Matrix()
      };
      function MaskElement(e, j, ke) {
        this.data = e, this.element = j, this.globalData = ke, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
        var Se = this.globalData.defs, xe, Ie = this.masksProperties ? this.masksProperties.length : 0;
        this.viewData = createSizedArray(Ie), this.solidPath = "";
        var Me, Ee = this.masksProperties, Be = 0, $e = [], Le, Fe, Ve = createElementID(), je, Ge, De, Ue, Re = "clipPath", Ye = "clip-path";
        for (xe = 0; xe < Ie; xe += 1)
          if ((Ee[xe].mode !== "a" && Ee[xe].mode !== "n" || Ee[xe].inv || Ee[xe].o.k !== 100 || Ee[xe].o.x) && (Re = "mask", Ye = "mask"), (Ee[xe].mode === "s" || Ee[xe].mode === "i") && Be === 0 ? (je = createNS("rect"), je.setAttribute("fill", "#ffffff"), je.setAttribute("width", this.element.comp.data.w || 0), je.setAttribute("height", this.element.comp.data.h || 0), $e.push(je)) : je = null, Me = createNS("path"), Ee[xe].mode === "n")
            this.viewData[xe] = {
              op: PropertyFactory.getProp(this.element, Ee[xe].o, 0, 0.01, this.element),
              prop: ShapePropertyFactory.getShapeProp(this.element, Ee[xe], 3),
              elem: Me,
              lastPath: ""
            }, Se.appendChild(Me);
          else {
            Be += 1, Me.setAttribute("fill", Ee[xe].mode === "s" ? "#000000" : "#ffffff"), Me.setAttribute("clip-rule", "nonzero");
            var We;
            if (Ee[xe].x.k !== 0 ? (Re = "mask", Ye = "mask", Ue = PropertyFactory.getProp(this.element, Ee[xe].x, 0, null, this.element), We = createElementID(), Ge = createNS("filter"), Ge.setAttribute("id", We), De = createNS("feMorphology"), De.setAttribute("operator", "erode"), De.setAttribute("in", "SourceGraphic"), De.setAttribute("radius", "0"), Ge.appendChild(De), Se.appendChild(Ge), Me.setAttribute("stroke", Ee[xe].mode === "s" ? "#000000" : "#ffffff")) : (De = null, Ue = null), this.storedData[xe] = {
              elem: Me,
              x: Ue,
              expan: De,
              lastPath: "",
              lastOperator: "",
              filterId: We,
              lastRadius: 0
            }, Ee[xe].mode === "i") {
              Fe = $e.length;
              var qe = createNS("g");
              for (Le = 0; Le < Fe; Le += 1)
                qe.appendChild($e[Le]);
              var Je = createNS("mask");
              Je.setAttribute("mask-type", "alpha"), Je.setAttribute("id", Ve + "_" + Be), Je.appendChild(Me), Se.appendChild(Je), qe.setAttribute("mask", "url(" + getLocationHref() + "#" + Ve + "_" + Be + ")"), $e.length = 0, $e.push(qe);
            } else
              $e.push(Me);
            Ee[xe].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[xe] = {
              elem: Me,
              lastPath: "",
              op: PropertyFactory.getProp(this.element, Ee[xe].o, 0, 0.01, this.element),
              prop: ShapePropertyFactory.getShapeProp(this.element, Ee[xe], 3),
              invRect: je
            }, this.viewData[xe].prop.k || this.drawPath(Ee[xe], this.viewData[xe].prop.v, this.viewData[xe]);
          }
        for (this.maskElement = createNS(Re), Ie = $e.length, xe = 0; xe < Ie; xe += 1)
          this.maskElement.appendChild($e[xe]);
        Be > 0 && (this.maskElement.setAttribute("id", Ve), this.element.maskedElement.setAttribute(Ye, "url(" + getLocationHref() + "#" + Ve + ")"), Se.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
      }
      MaskElement.prototype.getMaskProperty = function(e) {
        return this.viewData[e].prop;
      }, MaskElement.prototype.renderFrame = function(e) {
        var j = this.element.finalTransform.mat, ke, Se = this.masksProperties.length;
        for (ke = 0; ke < Se; ke += 1)
          if ((this.viewData[ke].prop._mdf || e) && this.drawPath(this.masksProperties[ke], this.viewData[ke].prop.v, this.viewData[ke]), (this.viewData[ke].op._mdf || e) && this.viewData[ke].elem.setAttribute("fill-opacity", this.viewData[ke].op.v), this.masksProperties[ke].mode !== "n" && (this.viewData[ke].invRect && (this.element.finalTransform.mProp._mdf || e) && this.viewData[ke].invRect.setAttribute("transform", j.getInverseMatrix().to2dCSS()), this.storedData[ke].x && (this.storedData[ke].x._mdf || e))) {
            var xe = this.storedData[ke].expan;
            this.storedData[ke].x.v < 0 ? (this.storedData[ke].lastOperator !== "erode" && (this.storedData[ke].lastOperator = "erode", this.storedData[ke].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[ke].filterId + ")")), xe.setAttribute("radius", -this.storedData[ke].x.v)) : (this.storedData[ke].lastOperator !== "dilate" && (this.storedData[ke].lastOperator = "dilate", this.storedData[ke].elem.setAttribute("filter", null)), this.storedData[ke].elem.setAttribute("stroke-width", this.storedData[ke].x.v * 2));
          }
      }, MaskElement.prototype.getMaskelement = function() {
        return this.maskElement;
      }, MaskElement.prototype.createLayerSolidPath = function() {
        var e = "M0,0 ";
        return e += " h" + this.globalData.compSize.w, e += " v" + this.globalData.compSize.h, e += " h-" + this.globalData.compSize.w, e += " v-" + this.globalData.compSize.h + " ", e;
      }, MaskElement.prototype.drawPath = function(e, j, ke) {
        var Se = " M" + j.v[0][0] + "," + j.v[0][1], xe, Ie;
        for (Ie = j._length, xe = 1; xe < Ie; xe += 1)
          Se += " C" + j.o[xe - 1][0] + "," + j.o[xe - 1][1] + " " + j.i[xe][0] + "," + j.i[xe][1] + " " + j.v[xe][0] + "," + j.v[xe][1];
        if (j.c && Ie > 1 && (Se += " C" + j.o[xe - 1][0] + "," + j.o[xe - 1][1] + " " + j.i[0][0] + "," + j.i[0][1] + " " + j.v[0][0] + "," + j.v[0][1]), ke.lastPath !== Se) {
          var Me = "";
          ke.elem && (j.c && (Me = e.inv ? this.solidPath + Se : Se), ke.elem.setAttribute("d", Me)), ke.lastPath = Se;
        }
      }, MaskElement.prototype.destroy = function() {
        this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
      };
      var filtersFactory = function() {
        var e = {};
        e.createFilter = j, e.createAlphaToLuminanceFilter = ke;
        function j(Se, xe) {
          var Ie = createNS("filter");
          return Ie.setAttribute("id", Se), xe !== !0 && (Ie.setAttribute("filterUnits", "objectBoundingBox"), Ie.setAttribute("x", "0%"), Ie.setAttribute("y", "0%"), Ie.setAttribute("width", "100%"), Ie.setAttribute("height", "100%")), Ie;
        }
        function ke() {
          var Se = createNS("feColorMatrix");
          return Se.setAttribute("type", "matrix"), Se.setAttribute("color-interpolation-filters", "sRGB"), Se.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), Se;
        }
        return e;
      }(), featureSupport = function() {
        var e = {
          maskType: !0,
          svgLumaHidden: !0,
          offscreenCanvas: typeof OffscreenCanvas < "u"
        };
        return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (e.maskType = !1), /firefox/i.test(navigator.userAgent) && (e.svgLumaHidden = !1), e;
      }(), registeredEffects$1 = {}, idPrefix = "filter_result_";
      function SVGEffects(e) {
        var j, ke = "SourceGraphic", Se = e.data.ef ? e.data.ef.length : 0, xe = createElementID(), Ie = filtersFactory.createFilter(xe, !0), Me = 0;
        this.filters = [];
        var Ee;
        for (j = 0; j < Se; j += 1) {
          Ee = null;
          var Be = e.data.ef[j].ty;
          if (registeredEffects$1[Be]) {
            var $e = registeredEffects$1[Be].effect;
            Ee = new $e(Ie, e.effectsManager.effectElements[j], e, idPrefix + Me, ke), ke = idPrefix + Me, registeredEffects$1[Be].countsAsEffect && (Me += 1);
          }
          Ee && this.filters.push(Ee);
        }
        Me && (e.globalData.defs.appendChild(Ie), e.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + xe + ")")), this.filters.length && e.addRenderableComponent(this);
      }
      SVGEffects.prototype.renderFrame = function(e) {
        var j, ke = this.filters.length;
        for (j = 0; j < ke; j += 1)
          this.filters[j].renderFrame(e);
      }, SVGEffects.prototype.getEffects = function(e) {
        var j, ke = this.filters.length, Se = [];
        for (j = 0; j < ke; j += 1)
          this.filters[j].type === e && Se.push(this.filters[j]);
        return Se;
      };
      function registerEffect$1(e, j, ke) {
        registeredEffects$1[e] = {
          effect: j,
          countsAsEffect: ke
        };
      }
      function SVGBaseElement() {
      }
      SVGBaseElement.prototype = {
        initRendererElement: function() {
          this.layerElement = createNS("g");
        },
        createContainerElements: function() {
          this.matteElement = createNS("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
          var j = null;
          if (this.data.td) {
            this.matteMasks = {};
            var ke = createNS("g");
            ke.setAttribute("id", this.layerId), ke.appendChild(this.layerElement), j = ke, this.globalData.defs.appendChild(ke);
          } else this.data.tt ? (this.matteElement.appendChild(this.layerElement), j = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
          if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.ty === 0 && !this.data.hd) {
            var Se = createNS("clipPath"), xe = createNS("path");
            xe.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
            var Ie = createElementID();
            if (Se.setAttribute("id", Ie), Se.appendChild(xe), this.globalData.defs.appendChild(Se), this.checkMasks()) {
              var Me = createNS("g");
              Me.setAttribute("clip-path", "url(" + getLocationHref() + "#" + Ie + ")"), Me.appendChild(this.layerElement), this.transformedElement = Me, j ? j.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
            } else
              this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + Ie + ")");
          }
          this.data.bm !== 0 && this.setBlendMode();
        },
        renderElement: function() {
          this.finalTransform._localMatMdf && this.transformedElement.setAttribute("transform", this.finalTransform.localMat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.localOpacity);
        },
        destroyBaseElement: function() {
          this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
        },
        getBaseElement: function() {
          return this.data.hd ? null : this.baseElement;
        },
        createRenderableComponents: function() {
          this.maskManager = new MaskElement(this.data, this, this.globalData), this.renderableEffectsManager = new SVGEffects(this), this.searchEffectTransforms();
        },
        getMatte: function(j) {
          if (this.matteMasks || (this.matteMasks = {}), !this.matteMasks[j]) {
            var ke = this.layerId + "_" + j, Se, xe, Ie, Me;
            if (j === 1 || j === 3) {
              var Ee = createNS("mask");
              Ee.setAttribute("id", ke), Ee.setAttribute("mask-type", j === 3 ? "luminance" : "alpha"), Ie = createNS("use"), Ie.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), Ee.appendChild(Ie), this.globalData.defs.appendChild(Ee), !featureSupport.maskType && j === 1 && (Ee.setAttribute("mask-type", "luminance"), Se = createElementID(), xe = filtersFactory.createFilter(Se), this.globalData.defs.appendChild(xe), xe.appendChild(filtersFactory.createAlphaToLuminanceFilter()), Me = createNS("g"), Me.appendChild(Ie), Ee.appendChild(Me), Me.setAttribute("filter", "url(" + getLocationHref() + "#" + Se + ")"));
            } else if (j === 2) {
              var Be = createNS("mask");
              Be.setAttribute("id", ke), Be.setAttribute("mask-type", "alpha");
              var $e = createNS("g");
              Be.appendChild($e), Se = createElementID(), xe = filtersFactory.createFilter(Se);
              var Le = createNS("feComponentTransfer");
              Le.setAttribute("in", "SourceGraphic"), xe.appendChild(Le);
              var Fe = createNS("feFuncA");
              Fe.setAttribute("type", "table"), Fe.setAttribute("tableValues", "1.0 0.0"), Le.appendChild(Fe), this.globalData.defs.appendChild(xe);
              var Ve = createNS("rect");
              Ve.setAttribute("width", this.comp.data.w), Ve.setAttribute("height", this.comp.data.h), Ve.setAttribute("x", "0"), Ve.setAttribute("y", "0"), Ve.setAttribute("fill", "#ffffff"), Ve.setAttribute("opacity", "0"), $e.setAttribute("filter", "url(" + getLocationHref() + "#" + Se + ")"), $e.appendChild(Ve), Ie = createNS("use"), Ie.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), $e.appendChild(Ie), featureSupport.maskType || (Be.setAttribute("mask-type", "luminance"), xe.appendChild(filtersFactory.createAlphaToLuminanceFilter()), Me = createNS("g"), $e.appendChild(Ve), Me.appendChild(this.layerElement), $e.appendChild(Me)), this.globalData.defs.appendChild(Be);
            }
            this.matteMasks[j] = ke;
          }
          return this.matteMasks[j];
        },
        setMatte: function(j) {
          this.matteElement && this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + j + ")");
        }
      };
      function HierarchyElement() {
      }
      HierarchyElement.prototype = {
        /**
           * @function
           * Initializes hierarchy properties
           *
           */
        initHierarchy: function() {
          this.hierarchy = [], this._isParent = !1, this.checkParenting();
        },
        /**
           * @function
           * Sets layer's hierarchy.
           * @param {array} hierarch
           * layer's parent list
           *
           */
        setHierarchy: function(j) {
          this.hierarchy = j;
        },
        /**
           * @function
           * Sets layer as parent.
           *
           */
        setAsParent: function() {
          this._isParent = !0;
        },
        /**
           * @function
           * Searches layer's parenting chain
           *
           */
        checkParenting: function() {
          this.data.parent !== void 0 && this.comp.buildElementParenting(this, this.data.parent, []);
        }
      };
      function RenderableDOMElement() {
      }
      (function() {
        var e = {
          initElement: function(ke, Se, xe) {
            this.initFrame(), this.initBaseData(ke, Se, xe), this.initTransform(ke, Se, xe), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
          },
          hide: function() {
            if (!this.hidden && (!this.isInRange || this.isTransparent)) {
              var ke = this.baseElement || this.layerElement;
              ke.style.display = "none", this.hidden = !0;
            }
          },
          show: function() {
            if (this.isInRange && !this.isTransparent) {
              if (!this.data.hd) {
                var ke = this.baseElement || this.layerElement;
                ke.style.display = "block";
              }
              this.hidden = !1, this._isFirstFrame = !0;
            }
          },
          renderFrame: function() {
            this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
          },
          renderInnerContent: function() {
          },
          prepareFrame: function(ke) {
            this._mdf = !1, this.prepareRenderableFrame(ke), this.prepareProperties(ke, this.isInRange), this.checkTransparency();
          },
          destroy: function() {
            this.innerElem = null, this.destroyBaseElement();
          }
        };
        extendPrototype([RenderableElement, createProxyFunction(e)], RenderableDOMElement);
      })();
      function IImageElement(e, j, ke) {
        this.assetData = j.getAssetData(e.refId), this.assetData && this.assetData.sid && (this.assetData = j.slotManager.getProp(this.assetData)), this.initElement(e, j, ke), this.sourceRect = {
          top: 0,
          left: 0,
          width: this.assetData.w,
          height: this.assetData.h
        };
      }
      extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement), IImageElement.prototype.createContent = function() {
        var e = this.globalData.getAssetsPath(this.assetData);
        this.innerElem = createNS("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", e), this.layerElement.appendChild(this.innerElem);
      }, IImageElement.prototype.sourceRectAtTime = function() {
        return this.sourceRect;
      };
      function ProcessedElement(e, j) {
        this.elem = e, this.pos = j;
      }
      function IShapeElement() {
      }
      IShapeElement.prototype = {
        addShapeToModifiers: function(j) {
          var ke, Se = this.shapeModifiers.length;
          for (ke = 0; ke < Se; ke += 1)
            this.shapeModifiers[ke].addShape(j);
        },
        isShapeInAnimatedModifiers: function(j) {
          for (var ke = 0, Se = this.shapeModifiers.length; ke < Se; )
            if (this.shapeModifiers[ke].isAnimatedWithShape(j))
              return !0;
          return !1;
        },
        renderModifiers: function() {
          if (this.shapeModifiers.length) {
            var j, ke = this.shapes.length;
            for (j = 0; j < ke; j += 1)
              this.shapes[j].sh.reset();
            ke = this.shapeModifiers.length;
            var Se;
            for (j = ke - 1; j >= 0 && (Se = this.shapeModifiers[j].processShapes(this._isFirstFrame), !Se); j -= 1)
              ;
          }
        },
        searchProcessedElement: function(j) {
          for (var ke = this.processedElements, Se = 0, xe = ke.length; Se < xe; ) {
            if (ke[Se].elem === j)
              return ke[Se].pos;
            Se += 1;
          }
          return 0;
        },
        addProcessedElement: function(j, ke) {
          for (var Se = this.processedElements, xe = Se.length; xe; )
            if (xe -= 1, Se[xe].elem === j) {
              Se[xe].pos = ke;
              return;
            }
          Se.push(new ProcessedElement(j, ke));
        },
        prepareFrame: function(j) {
          this.prepareRenderableFrame(j), this.prepareProperties(j, this.isInRange);
        }
      };
      var lineCapEnum = {
        1: "butt",
        2: "round",
        3: "square"
      }, lineJoinEnum = {
        1: "miter",
        2: "round",
        3: "bevel"
      };
      function SVGShapeData(e, j, ke) {
        this.caches = [], this.styles = [], this.transformers = e, this.lStr = "", this.sh = ke, this.lvl = j, this._isAnimated = !!ke.k;
        for (var Se = 0, xe = e.length; Se < xe; ) {
          if (e[Se].mProps.dynamicProperties.length) {
            this._isAnimated = !0;
            break;
          }
          Se += 1;
        }
      }
      SVGShapeData.prototype.setAsAnimated = function() {
        this._isAnimated = !0;
      };
      function SVGStyleData(e, j) {
        this.data = e, this.type = e.ty, this.d = "", this.lvl = j, this._mdf = !1, this.closed = e.hd === !0, this.pElem = createNS("path"), this.msElem = null;
      }
      SVGStyleData.prototype.reset = function() {
        this.d = "", this._mdf = !1;
      };
      function DashProperty(e, j, ke, Se) {
        this.elem = e, this.frameId = -1, this.dataProps = createSizedArray(j.length), this.renderer = ke, this.k = !1, this.dashStr = "", this.dashArray = createTypedArray("float32", j.length ? j.length - 1 : 0), this.dashoffset = createTypedArray("float32", 1), this.initDynamicPropertyContainer(Se);
        var xe, Ie = j.length || 0, Me;
        for (xe = 0; xe < Ie; xe += 1)
          Me = PropertyFactory.getProp(e, j[xe].v, 0, 0, this), this.k = Me.k || this.k, this.dataProps[xe] = {
            n: j[xe].n,
            p: Me
          };
        this.k || this.getValue(!0), this._isAnimated = this.k;
      }
      DashProperty.prototype.getValue = function(e) {
        if (!(this.elem.globalData.frameId === this.frameId && !e) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || e, this._mdf)) {
          var j = 0, ke = this.dataProps.length;
          for (this.renderer === "svg" && (this.dashStr = ""), j = 0; j < ke; j += 1)
            this.dataProps[j].n !== "o" ? this.renderer === "svg" ? this.dashStr += " " + this.dataProps[j].p.v : this.dashArray[j] = this.dataProps[j].p.v : this.dashoffset[0] = this.dataProps[j].p.v;
        }
      }, extendPrototype([DynamicPropertyContainer], DashProperty);
      function SVGStrokeStyleData(e, j, ke) {
        this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(e, j.o, 0, 0.01, this), this.w = PropertyFactory.getProp(e, j.w, 0, null, this), this.d = new DashProperty(e, j.d || {}, "svg", this), this.c = PropertyFactory.getProp(e, j.c, 1, 255, this), this.style = ke, this._isAnimated = !!this._isAnimated;
      }
      extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);
      function SVGFillStyleData(e, j, ke) {
        this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(e, j.o, 0, 0.01, this), this.c = PropertyFactory.getProp(e, j.c, 1, 255, this), this.style = ke;
      }
      extendPrototype([DynamicPropertyContainer], SVGFillStyleData);
      function SVGNoStyleData(e, j, ke) {
        this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.style = ke;
      }
      extendPrototype([DynamicPropertyContainer], SVGNoStyleData);
      function GradientProperty(e, j, ke) {
        this.data = j, this.c = createTypedArray("uint8c", j.p * 4);
        var Se = j.k.k[0].s ? j.k.k[0].s.length - j.p * 4 : j.k.k.length - j.p * 4;
        this.o = createTypedArray("float32", Se), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = Se, this.initDynamicPropertyContainer(ke), this.prop = PropertyFactory.getProp(e, j.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
      }
      GradientProperty.prototype.comparePoints = function(e, j) {
        for (var ke = 0, Se = this.o.length / 2, xe; ke < Se; ) {
          if (xe = Math.abs(e[ke * 4] - e[j * 4 + ke * 2]), xe > 0.01)
            return !1;
          ke += 1;
        }
        return !0;
      }, GradientProperty.prototype.checkCollapsable = function() {
        if (this.o.length / 2 !== this.c.length / 4)
          return !1;
        if (this.data.k.k[0].s)
          for (var e = 0, j = this.data.k.k.length; e < j; ) {
            if (!this.comparePoints(this.data.k.k[e].s, this.data.p))
              return !1;
            e += 1;
          }
        else if (!this.comparePoints(this.data.k.k, this.data.p))
          return !1;
        return !0;
      }, GradientProperty.prototype.getValue = function(e) {
        if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || e) {
          var j, ke = this.data.p * 4, Se, xe;
          for (j = 0; j < ke; j += 1)
            Se = j % 4 === 0 ? 100 : 255, xe = Math.round(this.prop.v[j] * Se), this.c[j] !== xe && (this.c[j] = xe, this._cmdf = !e);
          if (this.o.length)
            for (ke = this.prop.v.length, j = this.data.p * 4; j < ke; j += 1)
              Se = j % 2 === 0 ? 100 : 1, xe = j % 2 === 0 ? Math.round(this.prop.v[j] * 100) : this.prop.v[j], this.o[j - this.data.p * 4] !== xe && (this.o[j - this.data.p * 4] = xe, this._omdf = !e);
          this._mdf = !e;
        }
      }, extendPrototype([DynamicPropertyContainer], GradientProperty);
      function SVGGradientFillStyleData(e, j, ke) {
        this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.initGradientData(e, j, ke);
      }
      SVGGradientFillStyleData.prototype.initGradientData = function(e, j, ke) {
        this.o = PropertyFactory.getProp(e, j.o, 0, 0.01, this), this.s = PropertyFactory.getProp(e, j.s, 1, null, this), this.e = PropertyFactory.getProp(e, j.e, 1, null, this), this.h = PropertyFactory.getProp(e, j.h || {
          k: 0
        }, 0, 0.01, this), this.a = PropertyFactory.getProp(e, j.a || {
          k: 0
        }, 0, degToRads, this), this.g = new GradientProperty(e, j.g, this), this.style = ke, this.stops = [], this.setGradientData(ke.pElem, j), this.setGradientOpacity(j, ke), this._isAnimated = !!this._isAnimated;
      }, SVGGradientFillStyleData.prototype.setGradientData = function(e, j) {
        var ke = createElementID(), Se = createNS(j.t === 1 ? "linearGradient" : "radialGradient");
        Se.setAttribute("id", ke), Se.setAttribute("spreadMethod", "pad"), Se.setAttribute("gradientUnits", "userSpaceOnUse");
        var xe = [], Ie, Me, Ee;
        for (Ee = j.g.p * 4, Me = 0; Me < Ee; Me += 4)
          Ie = createNS("stop"), Se.appendChild(Ie), xe.push(Ie);
        e.setAttribute(j.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + ke + ")"), this.gf = Se, this.cst = xe;
      }, SVGGradientFillStyleData.prototype.setGradientOpacity = function(e, j) {
        if (this.g._hasOpacity && !this.g._collapsable) {
          var ke, Se, xe, Ie = createNS("mask"), Me = createNS("path");
          Ie.appendChild(Me);
          var Ee = createElementID(), Be = createElementID();
          Ie.setAttribute("id", Be);
          var $e = createNS(e.t === 1 ? "linearGradient" : "radialGradient");
          $e.setAttribute("id", Ee), $e.setAttribute("spreadMethod", "pad"), $e.setAttribute("gradientUnits", "userSpaceOnUse"), xe = e.g.k.k[0].s ? e.g.k.k[0].s.length : e.g.k.k.length;
          var Le = this.stops;
          for (Se = e.g.p * 4; Se < xe; Se += 2)
            ke = createNS("stop"), ke.setAttribute("stop-color", "rgb(255,255,255)"), $e.appendChild(ke), Le.push(ke);
          Me.setAttribute(e.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + Ee + ")"), e.ty === "gs" && (Me.setAttribute("stroke-linecap", lineCapEnum[e.lc || 2]), Me.setAttribute("stroke-linejoin", lineJoinEnum[e.lj || 2]), e.lj === 1 && Me.setAttribute("stroke-miterlimit", e.ml)), this.of = $e, this.ms = Ie, this.ost = Le, this.maskId = Be, j.msElem = Me;
        }
      }, extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);
      function SVGGradientStrokeStyleData(e, j, ke) {
        this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.w = PropertyFactory.getProp(e, j.w, 0, null, this), this.d = new DashProperty(e, j.d || {}, "svg", this), this.initGradientData(e, j, ke), this._isAnimated = !!this._isAnimated;
      }
      extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);
      function ShapeGroupData() {
        this.it = [], this.prevViewData = [], this.gr = createNS("g");
      }
      function SVGTransformData(e, j, ke) {
        this.transform = {
          mProps: e,
          op: j,
          container: ke
        }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
      }
      var buildShapeString = function(j, ke, Se, xe) {
        if (ke === 0)
          return "";
        var Ie = j.o, Me = j.i, Ee = j.v, Be, $e = " M" + xe.applyToPointStringified(Ee[0][0], Ee[0][1]);
        for (Be = 1; Be < ke; Be += 1)
          $e += " C" + xe.applyToPointStringified(Ie[Be - 1][0], Ie[Be - 1][1]) + " " + xe.applyToPointStringified(Me[Be][0], Me[Be][1]) + " " + xe.applyToPointStringified(Ee[Be][0], Ee[Be][1]);
        return Se && ke && ($e += " C" + xe.applyToPointStringified(Ie[Be - 1][0], Ie[Be - 1][1]) + " " + xe.applyToPointStringified(Me[0][0], Me[0][1]) + " " + xe.applyToPointStringified(Ee[0][0], Ee[0][1]), $e += "z"), $e;
      }, SVGElementsRenderer = function() {
        var e = new Matrix(), j = new Matrix(), ke = {
          createRenderFunction: Se
        };
        function Se(Fe) {
          switch (Fe.ty) {
            case "fl":
              return Ee;
            case "gf":
              return $e;
            case "gs":
              return Be;
            case "st":
              return Le;
            case "sh":
            case "el":
            case "rc":
            case "sr":
              return Me;
            case "tr":
              return xe;
            case "no":
              return Ie;
            default:
              return null;
          }
        }
        function xe(Fe, Ve, je) {
          (je || Ve.transform.op._mdf) && Ve.transform.container.setAttribute("opacity", Ve.transform.op.v), (je || Ve.transform.mProps._mdf) && Ve.transform.container.setAttribute("transform", Ve.transform.mProps.v.to2dCSS());
        }
        function Ie() {
        }
        function Me(Fe, Ve, je) {
          var Ge, De, Ue, Re, Ye, We, qe = Ve.styles.length, Je = Ve.lvl, Ke, xt, Ct, It;
          for (We = 0; We < qe; We += 1) {
            if (Re = Ve.sh._mdf || je, Ve.styles[We].lvl < Je) {
              for (xt = j.reset(), Ct = Je - Ve.styles[We].lvl, It = Ve.transformers.length - 1; !Re && Ct > 0; )
                Re = Ve.transformers[It].mProps._mdf || Re, Ct -= 1, It -= 1;
              if (Re)
                for (Ct = Je - Ve.styles[We].lvl, It = Ve.transformers.length - 1; Ct > 0; )
                  xt.multiply(Ve.transformers[It].mProps.v), Ct -= 1, It -= 1;
            } else
              xt = e;
            if (Ke = Ve.sh.paths, De = Ke._length, Re) {
              for (Ue = "", Ge = 0; Ge < De; Ge += 1)
                Ye = Ke.shapes[Ge], Ye && Ye._length && (Ue += buildShapeString(Ye, Ye._length, Ye.c, xt));
              Ve.caches[We] = Ue;
            } else
              Ue = Ve.caches[We];
            Ve.styles[We].d += Fe.hd === !0 ? "" : Ue, Ve.styles[We]._mdf = Re || Ve.styles[We]._mdf;
          }
        }
        function Ee(Fe, Ve, je) {
          var Ge = Ve.style;
          (Ve.c._mdf || je) && Ge.pElem.setAttribute("fill", "rgb(" + bmFloor(Ve.c.v[0]) + "," + bmFloor(Ve.c.v[1]) + "," + bmFloor(Ve.c.v[2]) + ")"), (Ve.o._mdf || je) && Ge.pElem.setAttribute("fill-opacity", Ve.o.v);
        }
        function Be(Fe, Ve, je) {
          $e(Fe, Ve, je), Le(Fe, Ve, je);
        }
        function $e(Fe, Ve, je) {
          var Ge = Ve.gf, De = Ve.g._hasOpacity, Ue = Ve.s.v, Re = Ve.e.v;
          if (Ve.o._mdf || je) {
            var Ye = Fe.ty === "gf" ? "fill-opacity" : "stroke-opacity";
            Ve.style.pElem.setAttribute(Ye, Ve.o.v);
          }
          if (Ve.s._mdf || je) {
            var We = Fe.t === 1 ? "x1" : "cx", qe = We === "x1" ? "y1" : "cy";
            Ge.setAttribute(We, Ue[0]), Ge.setAttribute(qe, Ue[1]), De && !Ve.g._collapsable && (Ve.of.setAttribute(We, Ue[0]), Ve.of.setAttribute(qe, Ue[1]));
          }
          var Je, Ke, xt, Ct;
          if (Ve.g._cmdf || je) {
            Je = Ve.cst;
            var It = Ve.g.c;
            for (xt = Je.length, Ke = 0; Ke < xt; Ke += 1)
              Ct = Je[Ke], Ct.setAttribute("offset", It[Ke * 4] + "%"), Ct.setAttribute("stop-color", "rgb(" + It[Ke * 4 + 1] + "," + It[Ke * 4 + 2] + "," + It[Ke * 4 + 3] + ")");
          }
          if (De && (Ve.g._omdf || je)) {
            var Nt = Ve.g.o;
            for (Ve.g._collapsable ? Je = Ve.cst : Je = Ve.ost, xt = Je.length, Ke = 0; Ke < xt; Ke += 1)
              Ct = Je[Ke], Ve.g._collapsable || Ct.setAttribute("offset", Nt[Ke * 2] + "%"), Ct.setAttribute("stop-opacity", Nt[Ke * 2 + 1]);
          }
          if (Fe.t === 1)
            (Ve.e._mdf || je) && (Ge.setAttribute("x2", Re[0]), Ge.setAttribute("y2", Re[1]), De && !Ve.g._collapsable && (Ve.of.setAttribute("x2", Re[0]), Ve.of.setAttribute("y2", Re[1])));
          else {
            var Bt;
            if ((Ve.s._mdf || Ve.e._mdf || je) && (Bt = Math.sqrt(Math.pow(Ue[0] - Re[0], 2) + Math.pow(Ue[1] - Re[1], 2)), Ge.setAttribute("r", Bt), De && !Ve.g._collapsable && Ve.of.setAttribute("r", Bt)), Ve.s._mdf || Ve.e._mdf || Ve.h._mdf || Ve.a._mdf || je) {
              Bt || (Bt = Math.sqrt(Math.pow(Ue[0] - Re[0], 2) + Math.pow(Ue[1] - Re[1], 2)));
              var At = Math.atan2(Re[1] - Ue[1], Re[0] - Ue[0]), Ft = Ve.h.v;
              Ft >= 1 ? Ft = 0.99 : Ft <= -1 && (Ft = -0.99);
              var Dt = Bt * Ft, zt = Math.cos(At + Ve.a.v) * Dt + Ue[0], kt = Math.sin(At + Ve.a.v) * Dt + Ue[1];
              Ge.setAttribute("fx", zt), Ge.setAttribute("fy", kt), De && !Ve.g._collapsable && (Ve.of.setAttribute("fx", zt), Ve.of.setAttribute("fy", kt));
            }
          }
        }
        function Le(Fe, Ve, je) {
          var Ge = Ve.style, De = Ve.d;
          De && (De._mdf || je) && De.dashStr && (Ge.pElem.setAttribute("stroke-dasharray", De.dashStr), Ge.pElem.setAttribute("stroke-dashoffset", De.dashoffset[0])), Ve.c && (Ve.c._mdf || je) && Ge.pElem.setAttribute("stroke", "rgb(" + bmFloor(Ve.c.v[0]) + "," + bmFloor(Ve.c.v[1]) + "," + bmFloor(Ve.c.v[2]) + ")"), (Ve.o._mdf || je) && Ge.pElem.setAttribute("stroke-opacity", Ve.o.v), (Ve.w._mdf || je) && (Ge.pElem.setAttribute("stroke-width", Ve.w.v), Ge.msElem && Ge.msElem.setAttribute("stroke-width", Ve.w.v));
        }
        return ke;
      }();
      function SVGShapeElement(e, j, ke) {
        this.shapes = [], this.shapesData = e.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(e, j, ke), this.prevViewData = [];
      }
      extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement), SVGShapeElement.prototype.initSecondaryElement = function() {
      }, SVGShapeElement.prototype.identityMatrix = new Matrix(), SVGShapeElement.prototype.buildExpressionInterface = function() {
      }, SVGShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
      }, SVGShapeElement.prototype.filterUniqueShapes = function() {
        var e, j = this.shapes.length, ke, Se, xe = this.stylesList.length, Ie, Me = [], Ee = !1;
        for (Se = 0; Se < xe; Se += 1) {
          for (Ie = this.stylesList[Se], Ee = !1, Me.length = 0, e = 0; e < j; e += 1)
            ke = this.shapes[e], ke.styles.indexOf(Ie) !== -1 && (Me.push(ke), Ee = ke._isAnimated || Ee);
          Me.length > 1 && Ee && this.setShapesAsAnimated(Me);
        }
      }, SVGShapeElement.prototype.setShapesAsAnimated = function(e) {
        var j, ke = e.length;
        for (j = 0; j < ke; j += 1)
          e[j].setAsAnimated();
      }, SVGShapeElement.prototype.createStyleElement = function(e, j) {
        var ke, Se = new SVGStyleData(e, j), xe = Se.pElem;
        if (e.ty === "st")
          ke = new SVGStrokeStyleData(this, e, Se);
        else if (e.ty === "fl")
          ke = new SVGFillStyleData(this, e, Se);
        else if (e.ty === "gf" || e.ty === "gs") {
          var Ie = e.ty === "gf" ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
          ke = new Ie(this, e, Se), this.globalData.defs.appendChild(ke.gf), ke.maskId && (this.globalData.defs.appendChild(ke.ms), this.globalData.defs.appendChild(ke.of), xe.setAttribute("mask", "url(" + getLocationHref() + "#" + ke.maskId + ")"));
        } else e.ty === "no" && (ke = new SVGNoStyleData(this, e, Se));
        return (e.ty === "st" || e.ty === "gs") && (xe.setAttribute("stroke-linecap", lineCapEnum[e.lc || 2]), xe.setAttribute("stroke-linejoin", lineJoinEnum[e.lj || 2]), xe.setAttribute("fill-opacity", "0"), e.lj === 1 && xe.setAttribute("stroke-miterlimit", e.ml)), e.r === 2 && xe.setAttribute("fill-rule", "evenodd"), e.ln && xe.setAttribute("id", e.ln), e.cl && xe.setAttribute("class", e.cl), e.bm && (xe.style["mix-blend-mode"] = getBlendMode(e.bm)), this.stylesList.push(Se), this.addToAnimatedContents(e, ke), ke;
      }, SVGShapeElement.prototype.createGroupElement = function(e) {
        var j = new ShapeGroupData();
        return e.ln && j.gr.setAttribute("id", e.ln), e.cl && j.gr.setAttribute("class", e.cl), e.bm && (j.gr.style["mix-blend-mode"] = getBlendMode(e.bm)), j;
      }, SVGShapeElement.prototype.createTransformElement = function(e, j) {
        var ke = TransformPropertyFactory.getTransformProperty(this, e, this), Se = new SVGTransformData(ke, ke.o, j);
        return this.addToAnimatedContents(e, Se), Se;
      }, SVGShapeElement.prototype.createShapeElement = function(e, j, ke) {
        var Se = 4;
        e.ty === "rc" ? Se = 5 : e.ty === "el" ? Se = 6 : e.ty === "sr" && (Se = 7);
        var xe = ShapePropertyFactory.getShapeProp(this, e, Se, this), Ie = new SVGShapeData(j, ke, xe);
        return this.shapes.push(Ie), this.addShapeToModifiers(Ie), this.addToAnimatedContents(e, Ie), Ie;
      }, SVGShapeElement.prototype.addToAnimatedContents = function(e, j) {
        for (var ke = 0, Se = this.animatedContents.length; ke < Se; ) {
          if (this.animatedContents[ke].element === j)
            return;
          ke += 1;
        }
        this.animatedContents.push({
          fn: SVGElementsRenderer.createRenderFunction(e),
          element: j,
          data: e
        });
      }, SVGShapeElement.prototype.setElementStyles = function(e) {
        var j = e.styles, ke, Se = this.stylesList.length;
        for (ke = 0; ke < Se; ke += 1)
          j.indexOf(this.stylesList[ke]) === -1 && !this.stylesList[ke].closed && j.push(this.stylesList[ke]);
      }, SVGShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = !0;
        var e, j = this.itemsData.length;
        for (e = 0; e < j; e += 1)
          this.prevViewData[e] = this.itemsData[e];
        for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), j = this.dynamicProperties.length, e = 0; e < j; e += 1)
          this.dynamicProperties[e].getValue();
        this.renderModifiers();
      }, SVGShapeElement.prototype.searchShapes = function(e, j, ke, Se, xe, Ie, Me) {
        var Ee = [].concat(Ie), Be, $e = e.length - 1, Le, Fe, Ve = [], je = [], Ge, De, Ue;
        for (Be = $e; Be >= 0; Be -= 1) {
          if (Ue = this.searchProcessedElement(e[Be]), Ue ? j[Be] = ke[Ue - 1] : e[Be]._render = Me, e[Be].ty === "fl" || e[Be].ty === "st" || e[Be].ty === "gf" || e[Be].ty === "gs" || e[Be].ty === "no")
            Ue ? j[Be].style.closed = e[Be].hd : j[Be] = this.createStyleElement(e[Be], xe), e[Be]._render && j[Be].style.pElem.parentNode !== Se && Se.appendChild(j[Be].style.pElem), Ve.push(j[Be].style);
          else if (e[Be].ty === "gr") {
            if (!Ue)
              j[Be] = this.createGroupElement(e[Be]);
            else
              for (Fe = j[Be].it.length, Le = 0; Le < Fe; Le += 1)
                j[Be].prevViewData[Le] = j[Be].it[Le];
            this.searchShapes(e[Be].it, j[Be].it, j[Be].prevViewData, j[Be].gr, xe + 1, Ee, Me), e[Be]._render && j[Be].gr.parentNode !== Se && Se.appendChild(j[Be].gr);
          } else e[Be].ty === "tr" ? (Ue || (j[Be] = this.createTransformElement(e[Be], Se)), Ge = j[Be].transform, Ee.push(Ge)) : e[Be].ty === "sh" || e[Be].ty === "rc" || e[Be].ty === "el" || e[Be].ty === "sr" ? (Ue || (j[Be] = this.createShapeElement(e[Be], Ee, xe)), this.setElementStyles(j[Be])) : e[Be].ty === "tm" || e[Be].ty === "rd" || e[Be].ty === "ms" || e[Be].ty === "pb" || e[Be].ty === "zz" || e[Be].ty === "op" ? (Ue ? (De = j[Be], De.closed = !1) : (De = ShapeModifiers.getModifier(e[Be].ty), De.init(this, e[Be]), j[Be] = De, this.shapeModifiers.push(De)), je.push(De)) : e[Be].ty === "rp" && (Ue ? (De = j[Be], De.closed = !0) : (De = ShapeModifiers.getModifier(e[Be].ty), j[Be] = De, De.init(this, e, Be, j), this.shapeModifiers.push(De), Me = !1), je.push(De));
          this.addProcessedElement(e[Be], Be + 1);
        }
        for ($e = Ve.length, Be = 0; Be < $e; Be += 1)
          Ve[Be].closed = !0;
        for ($e = je.length, Be = 0; Be < $e; Be += 1)
          je[Be].closed = !0;
      }, SVGShapeElement.prototype.renderInnerContent = function() {
        this.renderModifiers();
        var e, j = this.stylesList.length;
        for (e = 0; e < j; e += 1)
          this.stylesList[e].reset();
        for (this.renderShape(), e = 0; e < j; e += 1)
          (this.stylesList[e]._mdf || this._isFirstFrame) && (this.stylesList[e].msElem && (this.stylesList[e].msElem.setAttribute("d", this.stylesList[e].d), this.stylesList[e].d = "M0 0" + this.stylesList[e].d), this.stylesList[e].pElem.setAttribute("d", this.stylesList[e].d || "M0 0"));
      }, SVGShapeElement.prototype.renderShape = function() {
        var e, j = this.animatedContents.length, ke;
        for (e = 0; e < j; e += 1)
          ke = this.animatedContents[e], (this._isFirstFrame || ke.element._isAnimated) && ke.data !== !0 && ke.fn(ke.data, ke.element, this._isFirstFrame);
      }, SVGShapeElement.prototype.destroy = function() {
        this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
      };
      function LetterProps(e, j, ke, Se, xe, Ie) {
        this.o = e, this.sw = j, this.sc = ke, this.fc = Se, this.m = xe, this.p = Ie, this._mdf = {
          o: !0,
          sw: !!j,
          sc: !!ke,
          fc: !!Se,
          m: !0,
          p: !0
        };
      }
      LetterProps.prototype.update = function(e, j, ke, Se, xe, Ie) {
        this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
        var Me = !1;
        return this.o !== e && (this.o = e, this._mdf.o = !0, Me = !0), this.sw !== j && (this.sw = j, this._mdf.sw = !0, Me = !0), this.sc !== ke && (this.sc = ke, this._mdf.sc = !0, Me = !0), this.fc !== Se && (this.fc = Se, this._mdf.fc = !0, Me = !0), this.m !== xe && (this.m = xe, this._mdf.m = !0, Me = !0), Ie.length && (this.p[0] !== Ie[0] || this.p[1] !== Ie[1] || this.p[4] !== Ie[4] || this.p[5] !== Ie[5] || this.p[12] !== Ie[12] || this.p[13] !== Ie[13]) && (this.p = Ie, this._mdf.p = !0, Me = !0), Me;
      };
      function TextProperty(e, j) {
        this._frameId = initialDefaultFrame, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, j.d && j.d.sid && (j.d = e.globalData.slotManager.getProp(j.d)), this.data = j, this.elem = e, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = {
          ascent: 0,
          boxWidth: this.defaultBoxWidth,
          f: "",
          fStyle: "",
          fWeight: "",
          fc: "",
          j: "",
          justifyOffset: "",
          l: [],
          lh: 0,
          lineWidths: [],
          ls: "",
          of: "",
          s: "",
          sc: "",
          sw: 0,
          t: 0,
          tr: 0,
          sz: 0,
          ps: null,
          fillColorAnim: !1,
          strokeColorAnim: !1,
          strokeWidthAnim: !1,
          yOffset: 0,
          finalSize: 0,
          finalText: [],
          finalLineHeight: 0,
          __complete: !1
        }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
      }
      TextProperty.prototype.defaultBoxWidth = [0, 0], TextProperty.prototype.copyData = function(e, j) {
        for (var ke in j)
          Object.prototype.hasOwnProperty.call(j, ke) && (e[ke] = j[ke]);
        return e;
      }, TextProperty.prototype.setCurrentData = function(e) {
        e.__complete || this.completeTextData(e), this.currentData = e, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
      }, TextProperty.prototype.searchProperty = function() {
        return this.searchKeyframes();
      }, TextProperty.prototype.searchKeyframes = function() {
        return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
      }, TextProperty.prototype.addEffect = function(e) {
        this.effectsSequence.push(e), this.elem.addDynamicProperty(this);
      }, TextProperty.prototype.getValue = function(e) {
        if (!((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !e)) {
          this.currentData.t = this.data.d.k[this.keysIndex].s.t;
          var j = this.currentData, ke = this.keysIndex;
          if (this.lock) {
            this.setCurrentData(this.currentData);
            return;
          }
          this.lock = !0, this._mdf = !1;
          var Se, xe = this.effectsSequence.length, Ie = e || this.data.d.k[this.keysIndex].s;
          for (Se = 0; Se < xe; Se += 1)
            ke !== this.keysIndex ? Ie = this.effectsSequence[Se](Ie, Ie.t) : Ie = this.effectsSequence[Se](this.currentData, Ie.t);
          j !== Ie && this.setCurrentData(Ie), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
        }
      }, TextProperty.prototype.getKeyframeValue = function() {
        for (var e = this.data.d.k, j = this.elem.comp.renderedFrame, ke = 0, Se = e.length; ke <= Se - 1 && !(ke === Se - 1 || e[ke + 1].t > j); )
          ke += 1;
        return this.keysIndex !== ke && (this.keysIndex = ke), this.data.d.k[this.keysIndex].s;
      }, TextProperty.prototype.buildFinalText = function(e) {
        for (var j = [], ke = 0, Se = e.length, xe, Ie, Me = !1, Ee = !1, Be = ""; ke < Se; )
          Me = Ee, Ee = !1, xe = e.charCodeAt(ke), Be = e.charAt(ke), FontManager.isCombinedCharacter(xe) ? Me = !0 : xe >= 55296 && xe <= 56319 ? FontManager.isRegionalFlag(e, ke) ? Be = e.substr(ke, 14) : (Ie = e.charCodeAt(ke + 1), Ie >= 56320 && Ie <= 57343 && (FontManager.isModifier(xe, Ie) ? (Be = e.substr(ke, 2), Me = !0) : FontManager.isFlagEmoji(e.substr(ke, 4)) ? Be = e.substr(ke, 4) : Be = e.substr(ke, 2))) : xe > 56319 ? (Ie = e.charCodeAt(ke + 1), FontManager.isVariationSelector(xe) && (Me = !0)) : FontManager.isZeroWidthJoiner(xe) && (Me = !0, Ee = !0), Me ? (j[j.length - 1] += Be, Me = !1) : j.push(Be), ke += Be.length;
        return j;
      }, TextProperty.prototype.completeTextData = function(e) {
        e.__complete = !0;
        var j = this.elem.globalData.fontManager, ke = this.data, Se = [], xe, Ie, Me, Ee = 0, Be, $e = ke.m.g, Le = 0, Fe = 0, Ve = 0, je = [], Ge = 0, De = 0, Ue, Re, Ye = j.getFontByName(e.f), We, qe = 0, Je = getFontProperties(Ye);
        e.fWeight = Je.weight, e.fStyle = Je.style, e.finalSize = e.s, e.finalText = this.buildFinalText(e.t), Ie = e.finalText.length, e.finalLineHeight = e.lh;
        var Ke = e.tr / 1e3 * e.finalSize, xt;
        if (e.sz)
          for (var Ct = !0, It = e.sz[0], Nt = e.sz[1], Bt, At; Ct; ) {
            At = this.buildFinalText(e.t), Bt = 0, Ge = 0, Ie = At.length, Ke = e.tr / 1e3 * e.finalSize;
            var Ft = -1;
            for (xe = 0; xe < Ie; xe += 1)
              xt = At[xe].charCodeAt(0), Me = !1, At[xe] === " " ? Ft = xe : (xt === 13 || xt === 3) && (Ge = 0, Me = !0, Bt += e.finalLineHeight || e.finalSize * 1.2), j.chars ? (We = j.getCharData(At[xe], Ye.fStyle, Ye.fFamily), qe = Me ? 0 : We.w * e.finalSize / 100) : qe = j.measureText(At[xe], e.f, e.finalSize), Ge + qe > It && At[xe] !== " " ? (Ft === -1 ? Ie += 1 : xe = Ft, Bt += e.finalLineHeight || e.finalSize * 1.2, At.splice(xe, Ft === xe ? 1 : 0, "\r"), Ft = -1, Ge = 0) : (Ge += qe, Ge += Ke);
            Bt += Ye.ascent * e.finalSize / 100, this.canResize && e.finalSize > this.minimumFontSize && Nt < Bt ? (e.finalSize -= 1, e.finalLineHeight = e.finalSize * e.lh / e.s) : (e.finalText = At, Ie = e.finalText.length, Ct = !1);
          }
        Ge = -Ke, qe = 0;
        var Dt = 0, zt;
        for (xe = 0; xe < Ie; xe += 1)
          if (Me = !1, zt = e.finalText[xe], xt = zt.charCodeAt(0), xt === 13 || xt === 3 ? (Dt = 0, je.push(Ge), De = Ge > De ? Ge : De, Ge = -2 * Ke, Be = "", Me = !0, Ve += 1) : Be = zt, j.chars ? (We = j.getCharData(zt, Ye.fStyle, j.getFontByName(e.f).fFamily), qe = Me ? 0 : We.w * e.finalSize / 100) : qe = j.measureText(Be, e.f, e.finalSize), zt === " " ? Dt += qe + Ke : (Ge += qe + Ke + Dt, Dt = 0), Se.push({
            l: qe,
            an: qe,
            add: Le,
            n: Me,
            anIndexes: [],
            val: Be,
            line: Ve,
            animatorJustifyOffset: 0
          }), $e == 2) {
            if (Le += qe, Be === "" || Be === " " || xe === Ie - 1) {
              for ((Be === "" || Be === " ") && (Le -= qe); Fe <= xe; )
                Se[Fe].an = Le, Se[Fe].ind = Ee, Se[Fe].extra = qe, Fe += 1;
              Ee += 1, Le = 0;
            }
          } else if ($e == 3) {
            if (Le += qe, Be === "" || xe === Ie - 1) {
              for (Be === "" && (Le -= qe); Fe <= xe; )
                Se[Fe].an = Le, Se[Fe].ind = Ee, Se[Fe].extra = qe, Fe += 1;
              Le = 0, Ee += 1;
            }
          } else
            Se[Ee].ind = Ee, Se[Ee].extra = 0, Ee += 1;
        if (e.l = Se, De = Ge > De ? Ge : De, je.push(Ge), e.sz)
          e.boxWidth = e.sz[0], e.justifyOffset = 0;
        else
          switch (e.boxWidth = De, e.j) {
            case 1:
              e.justifyOffset = -e.boxWidth;
              break;
            case 2:
              e.justifyOffset = -e.boxWidth / 2;
              break;
            default:
              e.justifyOffset = 0;
          }
        e.lineWidths = je;
        var kt = ke.a, Et, Qe;
        Re = kt.length;
        var Xe, Vt, Lt = [];
        for (Ue = 0; Ue < Re; Ue += 1) {
          for (Et = kt[Ue], Et.a.sc && (e.strokeColorAnim = !0), Et.a.sw && (e.strokeWidthAnim = !0), (Et.a.fc || Et.a.fh || Et.a.fs || Et.a.fb) && (e.fillColorAnim = !0), Vt = 0, Xe = Et.s.b, xe = 0; xe < Ie; xe += 1)
            Qe = Se[xe], Qe.anIndexes[Ue] = Vt, (Xe == 1 && Qe.val !== "" || Xe == 2 && Qe.val !== "" && Qe.val !== " " || Xe == 3 && (Qe.n || Qe.val == " " || xe == Ie - 1) || Xe == 4 && (Qe.n || xe == Ie - 1)) && (Et.s.rn === 1 && Lt.push(Vt), Vt += 1);
          ke.a[Ue].s.totalChars = Vt;
          var Gt = -1, Wt;
          if (Et.s.rn === 1)
            for (xe = 0; xe < Ie; xe += 1)
              Qe = Se[xe], Gt != Qe.anIndexes[Ue] && (Gt = Qe.anIndexes[Ue], Wt = Lt.splice(Math.floor(Math.random() * Lt.length), 1)[0]), Qe.anIndexes[Ue] = Wt;
        }
        e.yOffset = e.finalLineHeight || e.finalSize * 1.2, e.ls = e.ls || 0, e.ascent = Ye.ascent * e.finalSize / 100;
      }, TextProperty.prototype.updateDocumentData = function(e, j) {
        j = j === void 0 ? this.keysIndex : j;
        var ke = this.copyData({}, this.data.d.k[j].s);
        ke = this.copyData(ke, e), this.data.d.k[j].s = ke, this.recalculate(j), this.setCurrentData(ke), this.elem.addDynamicProperty(this);
      }, TextProperty.prototype.recalculate = function(e) {
        var j = this.data.d.k[e].s;
        j.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(j);
      }, TextProperty.prototype.canResizeFont = function(e) {
        this.canResize = e, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
      }, TextProperty.prototype.setMinimumFontSize = function(e) {
        this.minimumFontSize = Math.floor(e) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
      };
      var TextSelectorProp = function() {
        var e = Math.max, j = Math.min, ke = Math.floor;
        function Se(Ie, Me) {
          this._currentTextLength = -1, this.k = !1, this.data = Me, this.elem = Ie, this.comp = Ie.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(Ie), this.s = PropertyFactory.getProp(Ie, Me.s || {
            k: 0
          }, 0, 0, this), "e" in Me ? this.e = PropertyFactory.getProp(Ie, Me.e, 0, 0, this) : this.e = {
            v: 100
          }, this.o = PropertyFactory.getProp(Ie, Me.o || {
            k: 0
          }, 0, 0, this), this.xe = PropertyFactory.getProp(Ie, Me.xe || {
            k: 0
          }, 0, 0, this), this.ne = PropertyFactory.getProp(Ie, Me.ne || {
            k: 0
          }, 0, 0, this), this.sm = PropertyFactory.getProp(Ie, Me.sm || {
            k: 100
          }, 0, 0, this), this.a = PropertyFactory.getProp(Ie, Me.a, 0, 0.01, this), this.dynamicProperties.length || this.getValue();
        }
        Se.prototype = {
          getMult: function(Me) {
            this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
            var Ee = 0, Be = 0, $e = 1, Le = 1;
            this.ne.v > 0 ? Ee = this.ne.v / 100 : Be = -this.ne.v / 100, this.xe.v > 0 ? $e = 1 - this.xe.v / 100 : Le = 1 + this.xe.v / 100;
            var Fe = BezierFactory.getBezierEasing(Ee, Be, $e, Le).get, Ve = 0, je = this.finalS, Ge = this.finalE, De = this.data.sh;
            if (De === 2)
              Ge === je ? Ve = Me >= Ge ? 1 : 0 : Ve = e(0, j(0.5 / (Ge - je) + (Me - je) / (Ge - je), 1)), Ve = Fe(Ve);
            else if (De === 3)
              Ge === je ? Ve = Me >= Ge ? 0 : 1 : Ve = 1 - e(0, j(0.5 / (Ge - je) + (Me - je) / (Ge - je), 1)), Ve = Fe(Ve);
            else if (De === 4)
              Ge === je ? Ve = 0 : (Ve = e(0, j(0.5 / (Ge - je) + (Me - je) / (Ge - je), 1)), Ve < 0.5 ? Ve *= 2 : Ve = 1 - 2 * (Ve - 0.5)), Ve = Fe(Ve);
            else if (De === 5) {
              if (Ge === je)
                Ve = 0;
              else {
                var Ue = Ge - je;
                Me = j(e(0, Me + 0.5 - je), Ge - je);
                var Re = -Ue / 2 + Me, Ye = Ue / 2;
                Ve = Math.sqrt(1 - Re * Re / (Ye * Ye));
              }
              Ve = Fe(Ve);
            } else De === 6 ? (Ge === je ? Ve = 0 : (Me = j(e(0, Me + 0.5 - je), Ge - je), Ve = (1 + Math.cos(Math.PI + Math.PI * 2 * Me / (Ge - je))) / 2), Ve = Fe(Ve)) : (Me >= ke(je) && (Me - je < 0 ? Ve = e(0, j(j(Ge, 1) - (je - Me), 1)) : Ve = e(0, j(Ge - Me, 1))), Ve = Fe(Ve));
            if (this.sm.v !== 100) {
              var We = this.sm.v * 0.01;
              We === 0 && (We = 1e-8);
              var qe = 0.5 - We * 0.5;
              Ve < qe ? Ve = 0 : (Ve = (Ve - qe) / We, Ve > 1 && (Ve = 1));
            }
            return Ve * this.a.v;
          },
          getValue: function(Me) {
            this.iterateDynamicProperties(), this._mdf = Me || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, Me && this.data.r === 2 && (this.e.v = this._currentTextLength);
            var Ee = this.data.r === 2 ? 1 : 100 / this.data.totalChars, Be = this.o.v / Ee, $e = this.s.v / Ee + Be, Le = this.e.v / Ee + Be;
            if ($e > Le) {
              var Fe = $e;
              $e = Le, Le = Fe;
            }
            this.finalS = $e, this.finalE = Le;
          }
        }, extendPrototype([DynamicPropertyContainer], Se);
        function xe(Ie, Me, Ee) {
          return new Se(Ie, Me);
        }
        return {
          getTextSelectorProp: xe
        };
      }();
      function TextAnimatorDataProperty(e, j, ke) {
        var Se = {
          propType: !1
        }, xe = PropertyFactory.getProp, Ie = j.a;
        this.a = {
          r: Ie.r ? xe(e, Ie.r, 0, degToRads, ke) : Se,
          rx: Ie.rx ? xe(e, Ie.rx, 0, degToRads, ke) : Se,
          ry: Ie.ry ? xe(e, Ie.ry, 0, degToRads, ke) : Se,
          sk: Ie.sk ? xe(e, Ie.sk, 0, degToRads, ke) : Se,
          sa: Ie.sa ? xe(e, Ie.sa, 0, degToRads, ke) : Se,
          s: Ie.s ? xe(e, Ie.s, 1, 0.01, ke) : Se,
          a: Ie.a ? xe(e, Ie.a, 1, 0, ke) : Se,
          o: Ie.o ? xe(e, Ie.o, 0, 0.01, ke) : Se,
          p: Ie.p ? xe(e, Ie.p, 1, 0, ke) : Se,
          sw: Ie.sw ? xe(e, Ie.sw, 0, 0, ke) : Se,
          sc: Ie.sc ? xe(e, Ie.sc, 1, 0, ke) : Se,
          fc: Ie.fc ? xe(e, Ie.fc, 1, 0, ke) : Se,
          fh: Ie.fh ? xe(e, Ie.fh, 0, 0, ke) : Se,
          fs: Ie.fs ? xe(e, Ie.fs, 0, 0.01, ke) : Se,
          fb: Ie.fb ? xe(e, Ie.fb, 0, 0.01, ke) : Se,
          t: Ie.t ? xe(e, Ie.t, 0, 0, ke) : Se
        }, this.s = TextSelectorProp.getTextSelectorProp(e, j.s, ke), this.s.t = j.s.t;
      }
      function TextAnimatorProperty(e, j, ke) {
        this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = e, this._renderType = j, this._elem = ke, this._animatorsData = createSizedArray(this._textData.a.length), this._pathData = {}, this._moreOptions = {
          alignment: {}
        }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(ke);
      }
      TextAnimatorProperty.prototype.searchProperties = function() {
        var e, j = this._textData.a.length, ke, Se = PropertyFactory.getProp;
        for (e = 0; e < j; e += 1)
          ke = this._textData.a[e], this._animatorsData[e] = new TextAnimatorDataProperty(this._elem, ke, this);
        this._textData.p && "m" in this._textData.p ? (this._pathData = {
          a: Se(this._elem, this._textData.p.a, 0, 0, this),
          f: Se(this._elem, this._textData.p.f, 0, 0, this),
          l: Se(this._elem, this._textData.p.l, 0, 0, this),
          r: Se(this._elem, this._textData.p.r, 0, 0, this),
          p: Se(this._elem, this._textData.p.p, 0, 0, this),
          m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
        }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = Se(this._elem, this._textData.m.a, 1, 0, this);
      }, TextAnimatorProperty.prototype.getMeasures = function(e, j) {
        if (this.lettersChangedFlag = j, !(!this._mdf && !this._isFirstFrame && !j && (!this._hasMaskedPath || !this._pathData.m._mdf))) {
          this._isFirstFrame = !1;
          var ke = this._moreOptions.alignment.v, Se = this._animatorsData, xe = this._textData, Ie = this.mHelper, Me = this._renderType, Ee = this.renderedLetters.length, Be, $e, Le, Fe, Ve = e.l, je, Ge, De, Ue, Re, Ye, We, qe, Je, Ke, xt, Ct, It, Nt, Bt;
          if (this._hasMaskedPath) {
            if (Bt = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
              var At = Bt.v;
              this._pathData.r.v && (At = At.reverse()), je = {
                tLength: 0,
                segments: []
              }, Fe = At._length - 1;
              var Ft;
              for (Ct = 0, Le = 0; Le < Fe; Le += 1)
                Ft = bez.buildBezierData(At.v[Le], At.v[Le + 1], [At.o[Le][0] - At.v[Le][0], At.o[Le][1] - At.v[Le][1]], [At.i[Le + 1][0] - At.v[Le + 1][0], At.i[Le + 1][1] - At.v[Le + 1][1]]), je.tLength += Ft.segmentLength, je.segments.push(Ft), Ct += Ft.segmentLength;
              Le = Fe, Bt.v.c && (Ft = bez.buildBezierData(At.v[Le], At.v[0], [At.o[Le][0] - At.v[Le][0], At.o[Le][1] - At.v[Le][1]], [At.i[0][0] - At.v[0][0], At.i[0][1] - At.v[0][1]]), je.tLength += Ft.segmentLength, je.segments.push(Ft), Ct += Ft.segmentLength), this._pathData.pi = je;
            }
            if (je = this._pathData.pi, Ge = this._pathData.f.v, We = 0, Ye = 1, Ue = 0, Re = !0, Ke = je.segments, Ge < 0 && Bt.v.c)
              for (je.tLength < Math.abs(Ge) && (Ge = -Math.abs(Ge) % je.tLength), We = Ke.length - 1, Je = Ke[We].points, Ye = Je.length - 1; Ge < 0; )
                Ge += Je[Ye].partialLength, Ye -= 1, Ye < 0 && (We -= 1, Je = Ke[We].points, Ye = Je.length - 1);
            Je = Ke[We].points, qe = Je[Ye - 1], De = Je[Ye], xt = De.partialLength;
          }
          Fe = Ve.length, Be = 0, $e = 0;
          var Dt = e.finalSize * 1.2 * 0.714, zt = !0, kt, Et, Qe, Xe, Vt;
          Xe = Se.length;
          var Lt, Gt = -1, Wt, Zt, Ot, Ht = Ge, Rt = We, jt = Ye, Yt = -1, Ut, Qt, Kt, Jt, qt, er, rr, ar, ir = "", or = this.defaultPropsArray, tr;
          if (e.j === 2 || e.j === 1) {
            var Xt = 0, lr = 0, cr = e.j === 2 ? -0.5 : -1, sr = 0, ur = !0;
            for (Le = 0; Le < Fe; Le += 1)
              if (Ve[Le].n) {
                for (Xt && (Xt += lr); sr < Le; )
                  Ve[sr].animatorJustifyOffset = Xt, sr += 1;
                Xt = 0, ur = !0;
              } else {
                for (Qe = 0; Qe < Xe; Qe += 1)
                  kt = Se[Qe].a, kt.t.propType && (ur && e.j === 2 && (lr += kt.t.v * cr), Et = Se[Qe].s, Lt = Et.getMult(Ve[Le].anIndexes[Qe], xe.a[Qe].s.totalChars), Lt.length ? Xt += kt.t.v * Lt[0] * cr : Xt += kt.t.v * Lt * cr);
                ur = !1;
              }
            for (Xt && (Xt += lr); sr < Le; )
              Ve[sr].animatorJustifyOffset = Xt, sr += 1;
          }
          for (Le = 0; Le < Fe; Le += 1) {
            if (Ie.reset(), Ut = 1, Ve[Le].n)
              Be = 0, $e += e.yOffset, $e += zt ? 1 : 0, Ge = Ht, zt = !1, this._hasMaskedPath && (We = Rt, Ye = jt, Je = Ke[We].points, qe = Je[Ye - 1], De = Je[Ye], xt = De.partialLength, Ue = 0), ir = "", ar = "", er = "", tr = "", or = this.defaultPropsArray;
            else {
              if (this._hasMaskedPath) {
                if (Yt !== Ve[Le].line) {
                  switch (e.j) {
                    case 1:
                      Ge += Ct - e.lineWidths[Ve[Le].line];
                      break;
                    case 2:
                      Ge += (Ct - e.lineWidths[Ve[Le].line]) / 2;
                      break;
                  }
                  Yt = Ve[Le].line;
                }
                Gt !== Ve[Le].ind && (Ve[Gt] && (Ge += Ve[Gt].extra), Ge += Ve[Le].an / 2, Gt = Ve[Le].ind), Ge += ke[0] * Ve[Le].an * 5e-3;
                var nr = 0;
                for (Qe = 0; Qe < Xe; Qe += 1)
                  kt = Se[Qe].a, kt.p.propType && (Et = Se[Qe].s, Lt = Et.getMult(Ve[Le].anIndexes[Qe], xe.a[Qe].s.totalChars), Lt.length ? nr += kt.p.v[0] * Lt[0] : nr += kt.p.v[0] * Lt), kt.a.propType && (Et = Se[Qe].s, Lt = Et.getMult(Ve[Le].anIndexes[Qe], xe.a[Qe].s.totalChars), Lt.length ? nr += kt.a.v[0] * Lt[0] : nr += kt.a.v[0] * Lt);
                for (Re = !0, this._pathData.a.v && (Ge = Ve[0].an * 0.5 + (Ct - this._pathData.f.v - Ve[0].an * 0.5 - Ve[Ve.length - 1].an * 0.5) * Gt / (Fe - 1), Ge += this._pathData.f.v); Re; )
                  Ue + xt >= Ge + nr || !Je ? (It = (Ge + nr - Ue) / De.partialLength, Zt = qe.point[0] + (De.point[0] - qe.point[0]) * It, Ot = qe.point[1] + (De.point[1] - qe.point[1]) * It, Ie.translate(-ke[0] * Ve[Le].an * 5e-3, -(ke[1] * Dt) * 0.01), Re = !1) : Je && (Ue += De.partialLength, Ye += 1, Ye >= Je.length && (Ye = 0, We += 1, Ke[We] ? Je = Ke[We].points : Bt.v.c ? (Ye = 0, We = 0, Je = Ke[We].points) : (Ue -= De.partialLength, Je = null)), Je && (qe = De, De = Je[Ye], xt = De.partialLength));
                Wt = Ve[Le].an / 2 - Ve[Le].add, Ie.translate(-Wt, 0, 0);
              } else
                Wt = Ve[Le].an / 2 - Ve[Le].add, Ie.translate(-Wt, 0, 0), Ie.translate(-ke[0] * Ve[Le].an * 5e-3, -ke[1] * Dt * 0.01, 0);
              for (Qe = 0; Qe < Xe; Qe += 1)
                kt = Se[Qe].a, kt.t.propType && (Et = Se[Qe].s, Lt = Et.getMult(Ve[Le].anIndexes[Qe], xe.a[Qe].s.totalChars), (Be !== 0 || e.j !== 0) && (this._hasMaskedPath ? Lt.length ? Ge += kt.t.v * Lt[0] : Ge += kt.t.v * Lt : Lt.length ? Be += kt.t.v * Lt[0] : Be += kt.t.v * Lt));
              for (e.strokeWidthAnim && (Kt = e.sw || 0), e.strokeColorAnim && (e.sc ? Qt = [e.sc[0], e.sc[1], e.sc[2]] : Qt = [0, 0, 0]), e.fillColorAnim && e.fc && (Jt = [e.fc[0], e.fc[1], e.fc[2]]), Qe = 0; Qe < Xe; Qe += 1)
                kt = Se[Qe].a, kt.a.propType && (Et = Se[Qe].s, Lt = Et.getMult(Ve[Le].anIndexes[Qe], xe.a[Qe].s.totalChars), Lt.length ? Ie.translate(-kt.a.v[0] * Lt[0], -kt.a.v[1] * Lt[1], kt.a.v[2] * Lt[2]) : Ie.translate(-kt.a.v[0] * Lt, -kt.a.v[1] * Lt, kt.a.v[2] * Lt));
              for (Qe = 0; Qe < Xe; Qe += 1)
                kt = Se[Qe].a, kt.s.propType && (Et = Se[Qe].s, Lt = Et.getMult(Ve[Le].anIndexes[Qe], xe.a[Qe].s.totalChars), Lt.length ? Ie.scale(1 + (kt.s.v[0] - 1) * Lt[0], 1 + (kt.s.v[1] - 1) * Lt[1], 1) : Ie.scale(1 + (kt.s.v[0] - 1) * Lt, 1 + (kt.s.v[1] - 1) * Lt, 1));
              for (Qe = 0; Qe < Xe; Qe += 1) {
                if (kt = Se[Qe].a, Et = Se[Qe].s, Lt = Et.getMult(Ve[Le].anIndexes[Qe], xe.a[Qe].s.totalChars), kt.sk.propType && (Lt.length ? Ie.skewFromAxis(-kt.sk.v * Lt[0], kt.sa.v * Lt[1]) : Ie.skewFromAxis(-kt.sk.v * Lt, kt.sa.v * Lt)), kt.r.propType && (Lt.length ? Ie.rotateZ(-kt.r.v * Lt[2]) : Ie.rotateZ(-kt.r.v * Lt)), kt.ry.propType && (Lt.length ? Ie.rotateY(kt.ry.v * Lt[1]) : Ie.rotateY(kt.ry.v * Lt)), kt.rx.propType && (Lt.length ? Ie.rotateX(kt.rx.v * Lt[0]) : Ie.rotateX(kt.rx.v * Lt)), kt.o.propType && (Lt.length ? Ut += (kt.o.v * Lt[0] - Ut) * Lt[0] : Ut += (kt.o.v * Lt - Ut) * Lt), e.strokeWidthAnim && kt.sw.propType && (Lt.length ? Kt += kt.sw.v * Lt[0] : Kt += kt.sw.v * Lt), e.strokeColorAnim && kt.sc.propType)
                  for (qt = 0; qt < 3; qt += 1)
                    Lt.length ? Qt[qt] += (kt.sc.v[qt] - Qt[qt]) * Lt[0] : Qt[qt] += (kt.sc.v[qt] - Qt[qt]) * Lt;
                if (e.fillColorAnim && e.fc) {
                  if (kt.fc.propType)
                    for (qt = 0; qt < 3; qt += 1)
                      Lt.length ? Jt[qt] += (kt.fc.v[qt] - Jt[qt]) * Lt[0] : Jt[qt] += (kt.fc.v[qt] - Jt[qt]) * Lt;
                  kt.fh.propType && (Lt.length ? Jt = addHueToRGB(Jt, kt.fh.v * Lt[0]) : Jt = addHueToRGB(Jt, kt.fh.v * Lt)), kt.fs.propType && (Lt.length ? Jt = addSaturationToRGB(Jt, kt.fs.v * Lt[0]) : Jt = addSaturationToRGB(Jt, kt.fs.v * Lt)), kt.fb.propType && (Lt.length ? Jt = addBrightnessToRGB(Jt, kt.fb.v * Lt[0]) : Jt = addBrightnessToRGB(Jt, kt.fb.v * Lt));
                }
              }
              for (Qe = 0; Qe < Xe; Qe += 1)
                kt = Se[Qe].a, kt.p.propType && (Et = Se[Qe].s, Lt = Et.getMult(Ve[Le].anIndexes[Qe], xe.a[Qe].s.totalChars), this._hasMaskedPath ? Lt.length ? Ie.translate(0, kt.p.v[1] * Lt[0], -kt.p.v[2] * Lt[1]) : Ie.translate(0, kt.p.v[1] * Lt, -kt.p.v[2] * Lt) : Lt.length ? Ie.translate(kt.p.v[0] * Lt[0], kt.p.v[1] * Lt[1], -kt.p.v[2] * Lt[2]) : Ie.translate(kt.p.v[0] * Lt, kt.p.v[1] * Lt, -kt.p.v[2] * Lt));
              if (e.strokeWidthAnim && (er = Kt < 0 ? 0 : Kt), e.strokeColorAnim && (rr = "rgb(" + Math.round(Qt[0] * 255) + "," + Math.round(Qt[1] * 255) + "," + Math.round(Qt[2] * 255) + ")"), e.fillColorAnim && e.fc && (ar = "rgb(" + Math.round(Jt[0] * 255) + "," + Math.round(Jt[1] * 255) + "," + Math.round(Jt[2] * 255) + ")"), this._hasMaskedPath) {
                if (Ie.translate(0, -e.ls), Ie.translate(0, ke[1] * Dt * 0.01 + $e, 0), this._pathData.p.v) {
                  Nt = (De.point[1] - qe.point[1]) / (De.point[0] - qe.point[0]);
                  var dr = Math.atan(Nt) * 180 / Math.PI;
                  De.point[0] < qe.point[0] && (dr += 180), Ie.rotate(-dr * Math.PI / 180);
                }
                Ie.translate(Zt, Ot, 0), Ge -= ke[0] * Ve[Le].an * 5e-3, Ve[Le + 1] && Gt !== Ve[Le + 1].ind && (Ge += Ve[Le].an / 2, Ge += e.tr * 1e-3 * e.finalSize);
              } else {
                switch (Ie.translate(Be, $e, 0), e.ps && Ie.translate(e.ps[0], e.ps[1] + e.ascent, 0), e.j) {
                  case 1:
                    Ie.translate(Ve[Le].animatorJustifyOffset + e.justifyOffset + (e.boxWidth - e.lineWidths[Ve[Le].line]), 0, 0);
                    break;
                  case 2:
                    Ie.translate(Ve[Le].animatorJustifyOffset + e.justifyOffset + (e.boxWidth - e.lineWidths[Ve[Le].line]) / 2, 0, 0);
                    break;
                }
                Ie.translate(0, -e.ls), Ie.translate(Wt, 0, 0), Ie.translate(ke[0] * Ve[Le].an * 5e-3, ke[1] * Dt * 0.01, 0), Be += Ve[Le].l + e.tr * 1e-3 * e.finalSize;
              }
              Me === "html" ? ir = Ie.toCSS() : Me === "svg" ? ir = Ie.to2dCSS() : or = [Ie.props[0], Ie.props[1], Ie.props[2], Ie.props[3], Ie.props[4], Ie.props[5], Ie.props[6], Ie.props[7], Ie.props[8], Ie.props[9], Ie.props[10], Ie.props[11], Ie.props[12], Ie.props[13], Ie.props[14], Ie.props[15]], tr = Ut;
            }
            Ee <= Le ? (Vt = new LetterProps(tr, er, rr, ar, ir, or), this.renderedLetters.push(Vt), Ee += 1, this.lettersChangedFlag = !0) : (Vt = this.renderedLetters[Le], this.lettersChangedFlag = Vt.update(tr, er, rr, ar, ir, or) || this.lettersChangedFlag);
          }
        }
      }, TextAnimatorProperty.prototype.getValue = function() {
        this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
      }, TextAnimatorProperty.prototype.mHelper = new Matrix(), TextAnimatorProperty.prototype.defaultPropsArray = [], extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);
      function ITextElement() {
      }
      ITextElement.prototype.initElement = function(e, j, ke) {
        this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(e, j, ke), this.textProperty = new TextProperty(this, e.t, this.dynamicProperties), this.textAnimator = new TextAnimatorProperty(e.t, this.renderType, this), this.initTransform(e, j, ke), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
      }, ITextElement.prototype.prepareFrame = function(e) {
        this._mdf = !1, this.prepareRenderableFrame(e), this.prepareProperties(e, this.isInRange);
      }, ITextElement.prototype.createPathShape = function(e, j) {
        var ke, Se = j.length, xe, Ie = "";
        for (ke = 0; ke < Se; ke += 1)
          j[ke].ty === "sh" && (xe = j[ke].ks.k, Ie += buildShapeString(xe, xe.i.length, !0, e));
        return Ie;
      }, ITextElement.prototype.updateDocumentData = function(e, j) {
        this.textProperty.updateDocumentData(e, j);
      }, ITextElement.prototype.canResizeFont = function(e) {
        this.textProperty.canResizeFont(e);
      }, ITextElement.prototype.setMinimumFontSize = function(e) {
        this.textProperty.setMinimumFontSize(e);
      }, ITextElement.prototype.applyTextPropertiesToMatrix = function(e, j, ke, Se, xe) {
        switch (e.ps && j.translate(e.ps[0], e.ps[1] + e.ascent, 0), j.translate(0, -e.ls, 0), e.j) {
          case 1:
            j.translate(e.justifyOffset + (e.boxWidth - e.lineWidths[ke]), 0, 0);
            break;
          case 2:
            j.translate(e.justifyOffset + (e.boxWidth - e.lineWidths[ke]) / 2, 0, 0);
            break;
        }
        j.translate(Se, xe, 0);
      }, ITextElement.prototype.buildColor = function(e) {
        return "rgb(" + Math.round(e[0] * 255) + "," + Math.round(e[1] * 255) + "," + Math.round(e[2] * 255) + ")";
      }, ITextElement.prototype.emptyProp = new LetterProps(), ITextElement.prototype.destroy = function() {
      }, ITextElement.prototype.validateText = function() {
        (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
      };
      var emptyShapeData = {
        shapes: []
      };
      function SVGTextLottieElement(e, j, ke) {
        this.textSpans = [], this.renderType = "svg", this.initElement(e, j, ke);
      }
      extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement), SVGTextLottieElement.prototype.createContent = function() {
        this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = createNS("text"));
      }, SVGTextLottieElement.prototype.buildTextContents = function(e) {
        for (var j = 0, ke = e.length, Se = [], xe = ""; j < ke; )
          e[j] === "\r" || e[j] === "" ? (Se.push(xe), xe = "") : xe += e[j], j += 1;
        return Se.push(xe), Se;
      }, SVGTextLottieElement.prototype.buildShapeData = function(e, j) {
        if (e.shapes && e.shapes.length) {
          var ke = e.shapes[0];
          if (ke.it) {
            var Se = ke.it[ke.it.length - 1];
            Se.s && (Se.s.k[0] = j, Se.s.k[1] = j);
          }
        }
        return e;
      }, SVGTextLottieElement.prototype.buildNewText = function() {
        this.addDynamicProperty(this);
        var e, j, ke = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(ke ? ke.l.length : 0), ke.fc ? this.layerElement.setAttribute("fill", this.buildColor(ke.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), ke.sc && (this.layerElement.setAttribute("stroke", this.buildColor(ke.sc)), this.layerElement.setAttribute("stroke-width", ke.sw)), this.layerElement.setAttribute("font-size", ke.finalSize);
        var Se = this.globalData.fontManager.getFontByName(ke.f);
        if (Se.fClass)
          this.layerElement.setAttribute("class", Se.fClass);
        else {
          this.layerElement.setAttribute("font-family", Se.fFamily);
          var xe = ke.fWeight, Ie = ke.fStyle;
          this.layerElement.setAttribute("font-style", Ie), this.layerElement.setAttribute("font-weight", xe);
        }
        this.layerElement.setAttribute("aria-label", ke.t);
        var Me = ke.l || [], Ee = !!this.globalData.fontManager.chars;
        j = Me.length;
        var Be, $e = this.mHelper, Le = "", Fe = this.data.singleShape, Ve = 0, je = 0, Ge = !0, De = ke.tr * 1e-3 * ke.finalSize;
        if (Fe && !Ee && !ke.sz) {
          var Ue = this.textContainer, Re = "start";
          switch (ke.j) {
            case 1:
              Re = "end";
              break;
            case 2:
              Re = "middle";
              break;
            default:
              Re = "start";
              break;
          }
          Ue.setAttribute("text-anchor", Re), Ue.setAttribute("letter-spacing", De);
          var Ye = this.buildTextContents(ke.finalText);
          for (j = Ye.length, je = ke.ps ? ke.ps[1] + ke.ascent : 0, e = 0; e < j; e += 1)
            Be = this.textSpans[e].span || createNS("tspan"), Be.textContent = Ye[e], Be.setAttribute("x", 0), Be.setAttribute("y", je), Be.style.display = "inherit", Ue.appendChild(Be), this.textSpans[e] || (this.textSpans[e] = {
              span: null,
              glyph: null
            }), this.textSpans[e].span = Be, je += ke.finalLineHeight;
          this.layerElement.appendChild(Ue);
        } else {
          var We = this.textSpans.length, qe;
          for (e = 0; e < j; e += 1) {
            if (this.textSpans[e] || (this.textSpans[e] = {
              span: null,
              childSpan: null,
              glyph: null
            }), !Ee || !Fe || e === 0) {
              if (Be = We > e ? this.textSpans[e].span : createNS(Ee ? "g" : "text"), We <= e) {
                if (Be.setAttribute("stroke-linecap", "butt"), Be.setAttribute("stroke-linejoin", "round"), Be.setAttribute("stroke-miterlimit", "4"), this.textSpans[e].span = Be, Ee) {
                  var Je = createNS("g");
                  Be.appendChild(Je), this.textSpans[e].childSpan = Je;
                }
                this.textSpans[e].span = Be, this.layerElement.appendChild(Be);
              }
              Be.style.display = "inherit";
            }
            if ($e.reset(), Fe && (Me[e].n && (Ve = -De, je += ke.yOffset, je += Ge ? 1 : 0, Ge = !1), this.applyTextPropertiesToMatrix(ke, $e, Me[e].line, Ve, je), Ve += Me[e].l || 0, Ve += De), Ee) {
              qe = this.globalData.fontManager.getCharData(ke.finalText[e], Se.fStyle, this.globalData.fontManager.getFontByName(ke.f).fFamily);
              var Ke;
              if (qe.t === 1)
                Ke = new SVGCompElement(qe.data, this.globalData, this);
              else {
                var xt = emptyShapeData;
                qe.data && qe.data.shapes && (xt = this.buildShapeData(qe.data, ke.finalSize)), Ke = new SVGShapeElement(xt, this.globalData, this);
              }
              if (this.textSpans[e].glyph) {
                var Ct = this.textSpans[e].glyph;
                this.textSpans[e].childSpan.removeChild(Ct.layerElement), Ct.destroy();
              }
              this.textSpans[e].glyph = Ke, Ke._debug = !0, Ke.prepareFrame(0), Ke.renderFrame(), this.textSpans[e].childSpan.appendChild(Ke.layerElement), qe.t === 1 && this.textSpans[e].childSpan.setAttribute("transform", "scale(" + ke.finalSize / 100 + "," + ke.finalSize / 100 + ")");
            } else
              Fe && Be.setAttribute("transform", "translate(" + $e.props[12] + "," + $e.props[13] + ")"), Be.textContent = Me[e].val, Be.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
          }
          Fe && Be && Be.setAttribute("d", Le);
        }
        for (; e < this.textSpans.length; )
          this.textSpans[e].span.style.display = "none", e += 1;
        this._sizeChanged = !0;
      }, SVGTextLottieElement.prototype.sourceRectAtTime = function() {
        if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
          this._sizeChanged = !1;
          var e = this.layerElement.getBBox();
          this.bbox = {
            top: e.y,
            left: e.x,
            width: e.width,
            height: e.height
          };
        }
        return this.bbox;
      }, SVGTextLottieElement.prototype.getValue = function() {
        var e, j = this.textSpans.length, ke;
        for (this.renderedFrame = this.comp.renderedFrame, e = 0; e < j; e += 1)
          ke = this.textSpans[e].glyph, ke && (ke.prepareFrame(this.comp.renderedFrame - this.data.st), ke._mdf && (this._mdf = !0));
      }, SVGTextLottieElement.prototype.renderInnerContent = function() {
        if (this.validateText(), (!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
          this._sizeChanged = !0;
          var e, j, ke = this.textAnimator.renderedLetters, Se = this.textProperty.currentData.l;
          j = Se.length;
          var xe, Ie, Me;
          for (e = 0; e < j; e += 1)
            Se[e].n || (xe = ke[e], Ie = this.textSpans[e].span, Me = this.textSpans[e].glyph, Me && Me.renderFrame(), xe._mdf.m && Ie.setAttribute("transform", xe.m), xe._mdf.o && Ie.setAttribute("opacity", xe.o), xe._mdf.sw && Ie.setAttribute("stroke-width", xe.sw), xe._mdf.sc && Ie.setAttribute("stroke", xe.sc), xe._mdf.fc && Ie.setAttribute("fill", xe.fc));
        }
      };
      function ISolidElement(e, j, ke) {
        this.initElement(e, j, ke);
      }
      extendPrototype([IImageElement], ISolidElement), ISolidElement.prototype.createContent = function() {
        var e = createNS("rect");
        e.setAttribute("width", this.data.sw), e.setAttribute("height", this.data.sh), e.setAttribute("fill", this.data.sc), this.layerElement.appendChild(e);
      };
      function NullElement(e, j, ke) {
        this.initFrame(), this.initBaseData(e, j, ke), this.initFrame(), this.initTransform(e, j, ke), this.initHierarchy();
      }
      NullElement.prototype.prepareFrame = function(e) {
        this.prepareProperties(e, !0);
      }, NullElement.prototype.renderFrame = function() {
      }, NullElement.prototype.getBaseElement = function() {
        return null;
      }, NullElement.prototype.destroy = function() {
      }, NullElement.prototype.sourceRectAtTime = function() {
      }, NullElement.prototype.hide = function() {
      }, extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement);
      function SVGRendererBase() {
      }
      extendPrototype([BaseRenderer], SVGRendererBase), SVGRendererBase.prototype.createNull = function(e) {
        return new NullElement(e, this.globalData, this);
      }, SVGRendererBase.prototype.createShape = function(e) {
        return new SVGShapeElement(e, this.globalData, this);
      }, SVGRendererBase.prototype.createText = function(e) {
        return new SVGTextLottieElement(e, this.globalData, this);
      }, SVGRendererBase.prototype.createImage = function(e) {
        return new IImageElement(e, this.globalData, this);
      }, SVGRendererBase.prototype.createSolid = function(e) {
        return new ISolidElement(e, this.globalData, this);
      }, SVGRendererBase.prototype.configAnimation = function(e) {
        this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + e.w + " " + e.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", e.w), this.svgElement.setAttribute("height", e.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width), this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), this.renderConfig.focusable !== void 0 && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
        var j = this.globalData.defs;
        this.setupGlobalData(e, j), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = e;
        var ke = createNS("clipPath"), Se = createNS("rect");
        Se.setAttribute("width", e.w), Se.setAttribute("height", e.h), Se.setAttribute("x", 0), Se.setAttribute("y", 0);
        var xe = createElementID();
        ke.setAttribute("id", xe), ke.appendChild(Se), this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + xe + ")"), j.appendChild(ke), this.layers = e.layers, this.elements = createSizedArray(e.layers.length);
      }, SVGRendererBase.prototype.destroy = function() {
        this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
        var e, j = this.layers ? this.layers.length : 0;
        for (e = 0; e < j; e += 1)
          this.elements[e] && this.elements[e].destroy && this.elements[e].destroy();
        this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
      }, SVGRendererBase.prototype.updateContainerSize = function() {
      }, SVGRendererBase.prototype.findIndexByInd = function(e) {
        var j = 0, ke = this.layers.length;
        for (j = 0; j < ke; j += 1)
          if (this.layers[j].ind === e)
            return j;
        return -1;
      }, SVGRendererBase.prototype.buildItem = function(e) {
        var j = this.elements;
        if (!(j[e] || this.layers[e].ty === 99)) {
          j[e] = !0;
          var ke = this.createItem(this.layers[e]);
          if (j[e] = ke, getExpressionsPlugin() && (this.layers[e].ty === 0 && this.globalData.projectInterface.registerComposition(ke), ke.initExpressions()), this.appendElementInPos(ke, e), this.layers[e].tt) {
            var Se = "tp" in this.layers[e] ? this.findIndexByInd(this.layers[e].tp) : e - 1;
            if (Se === -1)
              return;
            if (!this.elements[Se] || this.elements[Se] === !0)
              this.buildItem(Se), this.addPendingElement(ke);
            else {
              var xe = j[Se], Ie = xe.getMatte(this.layers[e].tt);
              ke.setMatte(Ie);
            }
          }
        }
      }, SVGRendererBase.prototype.checkPendingElements = function() {
        for (; this.pendingElements.length; ) {
          var e = this.pendingElements.pop();
          if (e.checkParenting(), e.data.tt)
            for (var j = 0, ke = this.elements.length; j < ke; ) {
              if (this.elements[j] === e) {
                var Se = "tp" in e.data ? this.findIndexByInd(e.data.tp) : j - 1, xe = this.elements[Se], Ie = xe.getMatte(this.layers[j].tt);
                e.setMatte(Ie);
                break;
              }
              j += 1;
            }
        }
      }, SVGRendererBase.prototype.renderFrame = function(e) {
        if (!(this.renderedFrame === e || this.destroyed)) {
          e === null ? e = this.renderedFrame : this.renderedFrame = e, this.globalData.frameNum = e, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = e, this.globalData._mdf = !1;
          var j, ke = this.layers.length;
          for (this.completeLayers || this.checkLayers(e), j = ke - 1; j >= 0; j -= 1)
            (this.completeLayers || this.elements[j]) && this.elements[j].prepareFrame(e - this.layers[j].st);
          if (this.globalData._mdf)
            for (j = 0; j < ke; j += 1)
              (this.completeLayers || this.elements[j]) && this.elements[j].renderFrame();
        }
      }, SVGRendererBase.prototype.appendElementInPos = function(e, j) {
        var ke = e.getBaseElement();
        if (ke) {
          for (var Se = 0, xe; Se < j; )
            this.elements[Se] && this.elements[Se] !== !0 && this.elements[Se].getBaseElement() && (xe = this.elements[Se].getBaseElement()), Se += 1;
          xe ? this.layerElement.insertBefore(ke, xe) : this.layerElement.appendChild(ke);
        }
      }, SVGRendererBase.prototype.hide = function() {
        this.layerElement.style.display = "none";
      }, SVGRendererBase.prototype.show = function() {
        this.layerElement.style.display = "block";
      };
      function ICompElement() {
      }
      extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement), ICompElement.prototype.initElement = function(e, j, ke) {
        this.initFrame(), this.initBaseData(e, j, ke), this.initTransform(e, j, ke), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), (this.data.xt || !j.progressiveLoad) && this.buildAllItems(), this.hide();
      }, ICompElement.prototype.prepareFrame = function(e) {
        if (this._mdf = !1, this.prepareRenderableFrame(e), this.prepareProperties(e, this.isInRange), !(!this.isInRange && !this.data.xt)) {
          if (this.tm._placeholder)
            this.renderedFrame = e / this.data.sr;
          else {
            var j = this.tm.v;
            j === this.data.op && (j = this.data.op - 1), this.renderedFrame = j;
          }
          var ke, Se = this.elements.length;
          for (this.completeLayers || this.checkLayers(this.renderedFrame), ke = Se - 1; ke >= 0; ke -= 1)
            (this.completeLayers || this.elements[ke]) && (this.elements[ke].prepareFrame(this.renderedFrame - this.layers[ke].st), this.elements[ke]._mdf && (this._mdf = !0));
        }
      }, ICompElement.prototype.renderInnerContent = function() {
        var e, j = this.layers.length;
        for (e = 0; e < j; e += 1)
          (this.completeLayers || this.elements[e]) && this.elements[e].renderFrame();
      }, ICompElement.prototype.setElements = function(e) {
        this.elements = e;
      }, ICompElement.prototype.getElements = function() {
        return this.elements;
      }, ICompElement.prototype.destroyElements = function() {
        var e, j = this.layers.length;
        for (e = 0; e < j; e += 1)
          this.elements[e] && this.elements[e].destroy();
      }, ICompElement.prototype.destroy = function() {
        this.destroyElements(), this.destroyBaseElement();
      };
      function SVGCompElement(e, j, ke) {
        this.layers = e.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(e, j, ke), this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, j.frameRate, this) : {
          _placeholder: !0
        };
      }
      extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement), SVGCompElement.prototype.createComp = function(e) {
        return new SVGCompElement(e, this.globalData, this);
      };
      function SVGRenderer(e, j) {
        this.animationItem = e, this.layers = null, this.renderedFrame = -1, this.svgElement = createNS("svg");
        var ke = "";
        if (j && j.title) {
          var Se = createNS("title"), xe = createElementID();
          Se.setAttribute("id", xe), Se.textContent = j.title, this.svgElement.appendChild(Se), ke += xe;
        }
        if (j && j.description) {
          var Ie = createNS("desc"), Me = createElementID();
          Ie.setAttribute("id", Me), Ie.textContent = j.description, this.svgElement.appendChild(Ie), ke += " " + Me;
        }
        ke && this.svgElement.setAttribute("aria-labelledby", ke);
        var Ee = createNS("defs");
        this.svgElement.appendChild(Ee);
        var Be = createNS("g");
        this.svgElement.appendChild(Be), this.layerElement = Be, this.renderConfig = {
          preserveAspectRatio: j && j.preserveAspectRatio || "xMidYMid meet",
          imagePreserveAspectRatio: j && j.imagePreserveAspectRatio || "xMidYMid slice",
          contentVisibility: j && j.contentVisibility || "visible",
          progressiveLoad: j && j.progressiveLoad || !1,
          hideOnTransparent: !(j && j.hideOnTransparent === !1),
          viewBoxOnly: j && j.viewBoxOnly || !1,
          viewBoxSize: j && j.viewBoxSize || !1,
          className: j && j.className || "",
          id: j && j.id || "",
          focusable: j && j.focusable,
          filterSize: {
            width: j && j.filterSize && j.filterSize.width || "100%",
            height: j && j.filterSize && j.filterSize.height || "100%",
            x: j && j.filterSize && j.filterSize.x || "0%",
            y: j && j.filterSize && j.filterSize.y || "0%"
          },
          width: j && j.width,
          height: j && j.height,
          runExpressions: !j || j.runExpressions === void 0 || j.runExpressions
        }, this.globalData = {
          _mdf: !1,
          frameNum: -1,
          defs: Ee,
          renderConfig: this.renderConfig
        }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
      }
      extendPrototype([SVGRendererBase], SVGRenderer), SVGRenderer.prototype.createComp = function(e) {
        return new SVGCompElement(e, this.globalData, this);
      };
      function ShapeTransformManager() {
        this.sequences = {}, this.sequenceList = [], this.transform_key_count = 0;
      }
      ShapeTransformManager.prototype = {
        addTransformSequence: function(j) {
          var ke, Se = j.length, xe = "_";
          for (ke = 0; ke < Se; ke += 1)
            xe += j[ke].transform.key + "_";
          var Ie = this.sequences[xe];
          return Ie || (Ie = {
            transforms: [].concat(j),
            finalTransform: new Matrix(),
            _mdf: !1
          }, this.sequences[xe] = Ie, this.sequenceList.push(Ie)), Ie;
        },
        processSequence: function(j, ke) {
          for (var Se = 0, xe = j.transforms.length, Ie = ke; Se < xe && !ke; ) {
            if (j.transforms[Se].transform.mProps._mdf) {
              Ie = !0;
              break;
            }
            Se += 1;
          }
          if (Ie)
            for (j.finalTransform.reset(), Se = xe - 1; Se >= 0; Se -= 1)
              j.finalTransform.multiply(j.transforms[Se].transform.mProps.v);
          j._mdf = Ie;
        },
        processSequences: function(j) {
          var ke, Se = this.sequenceList.length;
          for (ke = 0; ke < Se; ke += 1)
            this.processSequence(this.sequenceList[ke], j);
        },
        getNewKey: function() {
          return this.transform_key_count += 1, "_" + this.transform_key_count;
        }
      };
      var lumaLoader = function() {
        var j = "__lottie_element_luma_buffer", ke = null, Se = null, xe = null;
        function Ie() {
          var Be = createNS("svg"), $e = createNS("filter"), Le = createNS("feColorMatrix");
          return $e.setAttribute("id", j), Le.setAttribute("type", "matrix"), Le.setAttribute("color-interpolation-filters", "sRGB"), Le.setAttribute("values", "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0"), $e.appendChild(Le), Be.appendChild($e), Be.setAttribute("id", j + "_svg"), featureSupport.svgLumaHidden && (Be.style.display = "none"), Be;
        }
        function Me() {
          ke || (xe = Ie(), document.body.appendChild(xe), ke = createTag("canvas"), Se = ke.getContext("2d"), Se.filter = "url(#" + j + ")", Se.fillStyle = "rgba(0,0,0,0)", Se.fillRect(0, 0, 1, 1));
        }
        function Ee(Be) {
          return ke || Me(), ke.width = Be.width, ke.height = Be.height, Se.filter = "url(#" + j + ")", ke;
        }
        return {
          load: Me,
          get: Ee
        };
      };
      function createCanvas(e, j) {
        if (featureSupport.offscreenCanvas)
          return new OffscreenCanvas(e, j);
        var ke = createTag("canvas");
        return ke.width = e, ke.height = j, ke;
      }
      var assetLoader = function() {
        return {
          loadLumaCanvas: lumaLoader.load,
          getLumaCanvas: lumaLoader.get,
          createCanvas
        };
      }(), registeredEffects = {};
      function CVEffects(e) {
        var j, ke = e.data.ef ? e.data.ef.length : 0;
        this.filters = [];
        var Se;
        for (j = 0; j < ke; j += 1) {
          Se = null;
          var xe = e.data.ef[j].ty;
          if (registeredEffects[xe]) {
            var Ie = registeredEffects[xe].effect;
            Se = new Ie(e.effectsManager.effectElements[j], e);
          }
          Se && this.filters.push(Se);
        }
        this.filters.length && e.addRenderableComponent(this);
      }
      CVEffects.prototype.renderFrame = function(e) {
        var j, ke = this.filters.length;
        for (j = 0; j < ke; j += 1)
          this.filters[j].renderFrame(e);
      }, CVEffects.prototype.getEffects = function(e) {
        var j, ke = this.filters.length, Se = [];
        for (j = 0; j < ke; j += 1)
          this.filters[j].type === e && Se.push(this.filters[j]);
        return Se;
      };
      function registerEffect(e, j) {
        registeredEffects[e] = {
          effect: j
        };
      }
      function CVMaskElement(e, j) {
        this.data = e, this.element = j, this.masksProperties = this.data.masksProperties || [], this.viewData = createSizedArray(this.masksProperties.length);
        var ke, Se = this.masksProperties.length, xe = !1;
        for (ke = 0; ke < Se; ke += 1)
          this.masksProperties[ke].mode !== "n" && (xe = !0), this.viewData[ke] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[ke], 3);
        this.hasMasks = xe, xe && this.element.addRenderableComponent(this);
      }
      CVMaskElement.prototype.renderFrame = function() {
        if (this.hasMasks) {
          var e = this.element.finalTransform.mat, j = this.element.canvasContext, ke, Se = this.masksProperties.length, xe, Ie, Me;
          for (j.beginPath(), ke = 0; ke < Se; ke += 1)
            if (this.masksProperties[ke].mode !== "n") {
              this.masksProperties[ke].inv && (j.moveTo(0, 0), j.lineTo(this.element.globalData.compSize.w, 0), j.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h), j.lineTo(0, this.element.globalData.compSize.h), j.lineTo(0, 0)), Me = this.viewData[ke].v, xe = e.applyToPointArray(Me.v[0][0], Me.v[0][1], 0), j.moveTo(xe[0], xe[1]);
              var Ee, Be = Me._length;
              for (Ee = 1; Ee < Be; Ee += 1)
                Ie = e.applyToTriplePoints(Me.o[Ee - 1], Me.i[Ee], Me.v[Ee]), j.bezierCurveTo(Ie[0], Ie[1], Ie[2], Ie[3], Ie[4], Ie[5]);
              Ie = e.applyToTriplePoints(Me.o[Ee - 1], Me.i[0], Me.v[0]), j.bezierCurveTo(Ie[0], Ie[1], Ie[2], Ie[3], Ie[4], Ie[5]);
            }
          this.element.globalData.renderer.save(!0), j.clip();
        }
      }, CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty, CVMaskElement.prototype.destroy = function() {
        this.element = null;
      };
      function CVBaseElement() {
      }
      var operationsMap = {
        1: "source-in",
        2: "source-out",
        3: "source-in",
        4: "source-out"
      };
      CVBaseElement.prototype = {
        createElements: function() {
        },
        initRendererElement: function() {
        },
        createContainerElements: function() {
          if (this.data.tt >= 1) {
            this.buffers = [];
            var j = this.globalData.canvasContext, ke = assetLoader.createCanvas(j.canvas.width, j.canvas.height);
            this.buffers.push(ke);
            var Se = assetLoader.createCanvas(j.canvas.width, j.canvas.height);
            this.buffers.push(Se), this.data.tt >= 3 && !document._isProxy && assetLoader.loadLumaCanvas();
          }
          this.canvasContext = this.globalData.canvasContext, this.transformCanvas = this.globalData.transformCanvas, this.renderableEffectsManager = new CVEffects(this), this.searchEffectTransforms();
        },
        createContent: function() {
        },
        setBlendMode: function() {
          var j = this.globalData;
          if (j.blendMode !== this.data.bm) {
            j.blendMode = this.data.bm;
            var ke = getBlendMode(this.data.bm);
            j.canvasContext.globalCompositeOperation = ke;
          }
        },
        createRenderableComponents: function() {
          this.maskManager = new CVMaskElement(this.data, this), this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
        },
        hideElement: function() {
          !this.hidden && (!this.isInRange || this.isTransparent) && (this.hidden = !0);
        },
        showElement: function() {
          this.isInRange && !this.isTransparent && (this.hidden = !1, this._isFirstFrame = !0, this.maskManager._isFirstFrame = !0);
        },
        clearCanvas: function(j) {
          j.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
        },
        prepareLayer: function() {
          if (this.data.tt >= 1) {
            var j = this.buffers[0], ke = j.getContext("2d");
            this.clearCanvas(ke), ke.drawImage(this.canvasContext.canvas, 0, 0), this.currentTransform = this.canvasContext.getTransform(), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
          }
        },
        exitLayer: function() {
          if (this.data.tt >= 1) {
            var j = this.buffers[1], ke = j.getContext("2d");
            this.clearCanvas(ke), ke.drawImage(this.canvasContext.canvas, 0, 0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
            var Se = this.comp.getElementById("tp" in this.data ? this.data.tp : this.data.ind - 1);
            if (Se.renderFrame(!0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.data.tt >= 3 && !document._isProxy) {
              var xe = assetLoader.getLumaCanvas(this.canvasContext.canvas), Ie = xe.getContext("2d");
              Ie.drawImage(this.canvasContext.canvas, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.drawImage(xe, 0, 0);
            }
            this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt], this.canvasContext.drawImage(j, 0, 0), this.canvasContext.globalCompositeOperation = "destination-over", this.canvasContext.drawImage(this.buffers[0], 0, 0), this.canvasContext.setTransform(this.currentTransform), this.canvasContext.globalCompositeOperation = "source-over";
          }
        },
        renderFrame: function(j) {
          if (!(this.hidden || this.data.hd) && !(this.data.td === 1 && !j)) {
            this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.setBlendMode();
            var ke = this.data.ty === 0;
            this.prepareLayer(), this.globalData.renderer.save(ke), this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props), this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity), this.renderInnerContent(), this.globalData.renderer.restore(ke), this.exitLayer(), this.maskManager.hasMasks && this.globalData.renderer.restore(!0), this._isFirstFrame && (this._isFirstFrame = !1);
          }
        },
        destroy: function() {
          this.canvasContext = null, this.data = null, this.globalData = null, this.maskManager.destroy();
        },
        mHelper: new Matrix()
      }, CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement, CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
      function CVShapeData(e, j, ke, Se) {
        this.styledShapes = [], this.tr = [0, 0, 0, 0, 0, 0];
        var xe = 4;
        j.ty === "rc" ? xe = 5 : j.ty === "el" ? xe = 6 : j.ty === "sr" && (xe = 7), this.sh = ShapePropertyFactory.getShapeProp(e, j, xe, e);
        var Ie, Me = ke.length, Ee;
        for (Ie = 0; Ie < Me; Ie += 1)
          ke[Ie].closed || (Ee = {
            transforms: Se.addTransformSequence(ke[Ie].transforms),
            trNodes: []
          }, this.styledShapes.push(Ee), ke[Ie].elements.push(Ee));
      }
      CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
      function CVShapeElement(e, j, ke) {
        this.shapes = [], this.shapesData = e.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this.transformsManager = new ShapeTransformManager(), this.initElement(e, j, ke);
      }
      extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement), CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement, CVShapeElement.prototype.transformHelper = {
        opacity: 1,
        _opMdf: !1
      }, CVShapeElement.prototype.dashResetter = [], CVShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
      }, CVShapeElement.prototype.createStyleElement = function(e, j) {
        var ke = {
          data: e,
          type: e.ty,
          preTransforms: this.transformsManager.addTransformSequence(j),
          transforms: [],
          elements: [],
          closed: e.hd === !0
        }, Se = {};
        if (e.ty === "fl" || e.ty === "st" ? (Se.c = PropertyFactory.getProp(this, e.c, 1, 255, this), Se.c.k || (ke.co = "rgb(" + bmFloor(Se.c.v[0]) + "," + bmFloor(Se.c.v[1]) + "," + bmFloor(Se.c.v[2]) + ")")) : (e.ty === "gf" || e.ty === "gs") && (Se.s = PropertyFactory.getProp(this, e.s, 1, null, this), Se.e = PropertyFactory.getProp(this, e.e, 1, null, this), Se.h = PropertyFactory.getProp(this, e.h || {
          k: 0
        }, 0, 0.01, this), Se.a = PropertyFactory.getProp(this, e.a || {
          k: 0
        }, 0, degToRads, this), Se.g = new GradientProperty(this, e.g, this)), Se.o = PropertyFactory.getProp(this, e.o, 0, 0.01, this), e.ty === "st" || e.ty === "gs") {
          if (ke.lc = lineCapEnum[e.lc || 2], ke.lj = lineJoinEnum[e.lj || 2], e.lj == 1 && (ke.ml = e.ml), Se.w = PropertyFactory.getProp(this, e.w, 0, null, this), Se.w.k || (ke.wi = Se.w.v), e.d) {
            var xe = new DashProperty(this, e.d, "canvas", this);
            Se.d = xe, Se.d.k || (ke.da = Se.d.dashArray, ke.do = Se.d.dashoffset[0]);
          }
        } else
          ke.r = e.r === 2 ? "evenodd" : "nonzero";
        return this.stylesList.push(ke), Se.style = ke, Se;
      }, CVShapeElement.prototype.createGroupElement = function() {
        var e = {
          it: [],
          prevViewData: []
        };
        return e;
      }, CVShapeElement.prototype.createTransformElement = function(e) {
        var j = {
          transform: {
            opacity: 1,
            _opMdf: !1,
            key: this.transformsManager.getNewKey(),
            op: PropertyFactory.getProp(this, e.o, 0, 0.01, this),
            mProps: TransformPropertyFactory.getTransformProperty(this, e, this)
          }
        };
        return j;
      }, CVShapeElement.prototype.createShapeElement = function(e) {
        var j = new CVShapeData(this, e, this.stylesList, this.transformsManager);
        return this.shapes.push(j), this.addShapeToModifiers(j), j;
      }, CVShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = !0;
        var e, j = this.itemsData.length;
        for (e = 0; e < j; e += 1)
          this.prevViewData[e] = this.itemsData[e];
        for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []), j = this.dynamicProperties.length, e = 0; e < j; e += 1)
          this.dynamicProperties[e].getValue();
        this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
      }, CVShapeElement.prototype.addTransformToStyleList = function(e) {
        var j, ke = this.stylesList.length;
        for (j = 0; j < ke; j += 1)
          this.stylesList[j].closed || this.stylesList[j].transforms.push(e);
      }, CVShapeElement.prototype.removeTransformFromStyleList = function() {
        var e, j = this.stylesList.length;
        for (e = 0; e < j; e += 1)
          this.stylesList[e].closed || this.stylesList[e].transforms.pop();
      }, CVShapeElement.prototype.closeStyles = function(e) {
        var j, ke = e.length;
        for (j = 0; j < ke; j += 1)
          e[j].closed = !0;
      }, CVShapeElement.prototype.searchShapes = function(e, j, ke, Se, xe) {
        var Ie, Me = e.length - 1, Ee, Be, $e = [], Le = [], Fe, Ve, je, Ge = [].concat(xe);
        for (Ie = Me; Ie >= 0; Ie -= 1) {
          if (Fe = this.searchProcessedElement(e[Ie]), Fe ? j[Ie] = ke[Fe - 1] : e[Ie]._shouldRender = Se, e[Ie].ty === "fl" || e[Ie].ty === "st" || e[Ie].ty === "gf" || e[Ie].ty === "gs")
            Fe ? j[Ie].style.closed = !1 : j[Ie] = this.createStyleElement(e[Ie], Ge), $e.push(j[Ie].style);
          else if (e[Ie].ty === "gr") {
            if (!Fe)
              j[Ie] = this.createGroupElement(e[Ie]);
            else
              for (Be = j[Ie].it.length, Ee = 0; Ee < Be; Ee += 1)
                j[Ie].prevViewData[Ee] = j[Ie].it[Ee];
            this.searchShapes(e[Ie].it, j[Ie].it, j[Ie].prevViewData, Se, Ge);
          } else e[Ie].ty === "tr" ? (Fe || (je = this.createTransformElement(e[Ie]), j[Ie] = je), Ge.push(j[Ie]), this.addTransformToStyleList(j[Ie])) : e[Ie].ty === "sh" || e[Ie].ty === "rc" || e[Ie].ty === "el" || e[Ie].ty === "sr" ? Fe || (j[Ie] = this.createShapeElement(e[Ie])) : e[Ie].ty === "tm" || e[Ie].ty === "rd" || e[Ie].ty === "pb" || e[Ie].ty === "zz" || e[Ie].ty === "op" ? (Fe ? (Ve = j[Ie], Ve.closed = !1) : (Ve = ShapeModifiers.getModifier(e[Ie].ty), Ve.init(this, e[Ie]), j[Ie] = Ve, this.shapeModifiers.push(Ve)), Le.push(Ve)) : e[Ie].ty === "rp" && (Fe ? (Ve = j[Ie], Ve.closed = !0) : (Ve = ShapeModifiers.getModifier(e[Ie].ty), j[Ie] = Ve, Ve.init(this, e, Ie, j), this.shapeModifiers.push(Ve), Se = !1), Le.push(Ve));
          this.addProcessedElement(e[Ie], Ie + 1);
        }
        for (this.removeTransformFromStyleList(), this.closeStyles($e), Me = Le.length, Ie = 0; Ie < Me; Ie += 1)
          Le[Ie].closed = !0;
      }, CVShapeElement.prototype.renderInnerContent = function() {
        this.transformHelper.opacity = 1, this.transformHelper._opMdf = !1, this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame), this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
      }, CVShapeElement.prototype.renderShapeTransform = function(e, j) {
        (e._opMdf || j.op._mdf || this._isFirstFrame) && (j.opacity = e.opacity, j.opacity *= j.op.v, j._opMdf = !0);
      }, CVShapeElement.prototype.drawLayer = function() {
        var e, j = this.stylesList.length, ke, Se, xe, Ie, Me, Ee, Be = this.globalData.renderer, $e = this.globalData.canvasContext, Le, Fe;
        for (e = 0; e < j; e += 1)
          if (Fe = this.stylesList[e], Le = Fe.type, !((Le === "st" || Le === "gs") && Fe.wi === 0 || !Fe.data._shouldRender || Fe.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
            for (Be.save(), Me = Fe.elements, Le === "st" || Le === "gs" ? (Be.ctxStrokeStyle(Le === "st" ? Fe.co : Fe.grd), Be.ctxLineWidth(Fe.wi), Be.ctxLineCap(Fe.lc), Be.ctxLineJoin(Fe.lj), Be.ctxMiterLimit(Fe.ml || 0)) : Be.ctxFillStyle(Le === "fl" ? Fe.co : Fe.grd), Be.ctxOpacity(Fe.coOp), Le !== "st" && Le !== "gs" && $e.beginPath(), Be.ctxTransform(Fe.preTransforms.finalTransform.props), Se = Me.length, ke = 0; ke < Se; ke += 1) {
              for ((Le === "st" || Le === "gs") && ($e.beginPath(), Fe.da && ($e.setLineDash(Fe.da), $e.lineDashOffset = Fe.do)), Ee = Me[ke].trNodes, Ie = Ee.length, xe = 0; xe < Ie; xe += 1)
                Ee[xe].t === "m" ? $e.moveTo(Ee[xe].p[0], Ee[xe].p[1]) : Ee[xe].t === "c" ? $e.bezierCurveTo(Ee[xe].pts[0], Ee[xe].pts[1], Ee[xe].pts[2], Ee[xe].pts[3], Ee[xe].pts[4], Ee[xe].pts[5]) : $e.closePath();
              (Le === "st" || Le === "gs") && (Be.ctxStroke(), Fe.da && $e.setLineDash(this.dashResetter));
            }
            Le !== "st" && Le !== "gs" && this.globalData.renderer.ctxFill(Fe.r), Be.restore();
          }
      }, CVShapeElement.prototype.renderShape = function(e, j, ke, Se) {
        var xe, Ie = j.length - 1, Me;
        for (Me = e, xe = Ie; xe >= 0; xe -= 1)
          j[xe].ty === "tr" ? (Me = ke[xe].transform, this.renderShapeTransform(e, Me)) : j[xe].ty === "sh" || j[xe].ty === "el" || j[xe].ty === "rc" || j[xe].ty === "sr" ? this.renderPath(j[xe], ke[xe]) : j[xe].ty === "fl" ? this.renderFill(j[xe], ke[xe], Me) : j[xe].ty === "st" ? this.renderStroke(j[xe], ke[xe], Me) : j[xe].ty === "gf" || j[xe].ty === "gs" ? this.renderGradientFill(j[xe], ke[xe], Me) : j[xe].ty === "gr" ? this.renderShape(Me, j[xe].it, ke[xe].it) : j[xe].ty;
        Se && this.drawLayer();
      }, CVShapeElement.prototype.renderStyledShape = function(e, j) {
        if (this._isFirstFrame || j._mdf || e.transforms._mdf) {
          var ke = e.trNodes, Se = j.paths, xe, Ie, Me, Ee = Se._length;
          ke.length = 0;
          var Be = e.transforms.finalTransform;
          for (Me = 0; Me < Ee; Me += 1) {
            var $e = Se.shapes[Me];
            if ($e && $e.v) {
              for (Ie = $e._length, xe = 1; xe < Ie; xe += 1)
                xe === 1 && ke.push({
                  t: "m",
                  p: Be.applyToPointArray($e.v[0][0], $e.v[0][1], 0)
                }), ke.push({
                  t: "c",
                  pts: Be.applyToTriplePoints($e.o[xe - 1], $e.i[xe], $e.v[xe])
                });
              Ie === 1 && ke.push({
                t: "m",
                p: Be.applyToPointArray($e.v[0][0], $e.v[0][1], 0)
              }), $e.c && Ie && (ke.push({
                t: "c",
                pts: Be.applyToTriplePoints($e.o[xe - 1], $e.i[0], $e.v[0])
              }), ke.push({
                t: "z"
              }));
            }
          }
          e.trNodes = ke;
        }
      }, CVShapeElement.prototype.renderPath = function(e, j) {
        if (e.hd !== !0 && e._shouldRender) {
          var ke, Se = j.styledShapes.length;
          for (ke = 0; ke < Se; ke += 1)
            this.renderStyledShape(j.styledShapes[ke], j.sh);
        }
      }, CVShapeElement.prototype.renderFill = function(e, j, ke) {
        var Se = j.style;
        (j.c._mdf || this._isFirstFrame) && (Se.co = "rgb(" + bmFloor(j.c.v[0]) + "," + bmFloor(j.c.v[1]) + "," + bmFloor(j.c.v[2]) + ")"), (j.o._mdf || ke._opMdf || this._isFirstFrame) && (Se.coOp = j.o.v * ke.opacity);
      }, CVShapeElement.prototype.renderGradientFill = function(e, j, ke) {
        var Se = j.style, xe;
        if (!Se.grd || j.g._mdf || j.s._mdf || j.e._mdf || e.t !== 1 && (j.h._mdf || j.a._mdf)) {
          var Ie = this.globalData.canvasContext, Me = j.s.v, Ee = j.e.v;
          if (e.t === 1)
            xe = Ie.createLinearGradient(Me[0], Me[1], Ee[0], Ee[1]);
          else {
            var Be = Math.sqrt(Math.pow(Me[0] - Ee[0], 2) + Math.pow(Me[1] - Ee[1], 2)), $e = Math.atan2(Ee[1] - Me[1], Ee[0] - Me[0]), Le = j.h.v;
            Le >= 1 ? Le = 0.99 : Le <= -1 && (Le = -0.99);
            var Fe = Be * Le, Ve = Math.cos($e + j.a.v) * Fe + Me[0], je = Math.sin($e + j.a.v) * Fe + Me[1];
            xe = Ie.createRadialGradient(Ve, je, 0, Me[0], Me[1], Be);
          }
          var Ge, De = e.g.p, Ue = j.g.c, Re = 1;
          for (Ge = 0; Ge < De; Ge += 1)
            j.g._hasOpacity && j.g._collapsable && (Re = j.g.o[Ge * 2 + 1]), xe.addColorStop(Ue[Ge * 4] / 100, "rgba(" + Ue[Ge * 4 + 1] + "," + Ue[Ge * 4 + 2] + "," + Ue[Ge * 4 + 3] + "," + Re + ")");
          Se.grd = xe;
        }
        Se.coOp = j.o.v * ke.opacity;
      }, CVShapeElement.prototype.renderStroke = function(e, j, ke) {
        var Se = j.style, xe = j.d;
        xe && (xe._mdf || this._isFirstFrame) && (Se.da = xe.dashArray, Se.do = xe.dashoffset[0]), (j.c._mdf || this._isFirstFrame) && (Se.co = "rgb(" + bmFloor(j.c.v[0]) + "," + bmFloor(j.c.v[1]) + "," + bmFloor(j.c.v[2]) + ")"), (j.o._mdf || ke._opMdf || this._isFirstFrame) && (Se.coOp = j.o.v * ke.opacity), (j.w._mdf || this._isFirstFrame) && (Se.wi = j.w.v);
      }, CVShapeElement.prototype.destroy = function() {
        this.shapesData = null, this.globalData = null, this.canvasContext = null, this.stylesList.length = 0, this.itemsData.length = 0;
      };
      function CVTextElement(e, j, ke) {
        this.textSpans = [], this.yOffset = 0, this.fillColorAnim = !1, this.strokeColorAnim = !1, this.strokeWidthAnim = !1, this.stroke = !1, this.fill = !1, this.justifyOffset = 0, this.currentRender = null, this.renderType = "canvas", this.values = {
          fill: "rgba(0,0,0,0)",
          stroke: "rgba(0,0,0,0)",
          sWidth: 0,
          fValue: ""
        }, this.initElement(e, j, ke);
      }
      extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement), CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d"), CVTextElement.prototype.buildNewText = function() {
        var e = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(e.l ? e.l.length : 0);
        var j = !1;
        e.fc ? (j = !0, this.values.fill = this.buildColor(e.fc)) : this.values.fill = "rgba(0,0,0,0)", this.fill = j;
        var ke = !1;
        e.sc && (ke = !0, this.values.stroke = this.buildColor(e.sc), this.values.sWidth = e.sw);
        var Se = this.globalData.fontManager.getFontByName(e.f), xe, Ie, Me = e.l, Ee = this.mHelper;
        this.stroke = ke, this.values.fValue = e.finalSize + "px " + this.globalData.fontManager.getFontByName(e.f).fFamily, Ie = e.finalText.length;
        var Be, $e, Le, Fe, Ve, je, Ge, De, Ue, Re, Ye = this.data.singleShape, We = e.tr * 1e-3 * e.finalSize, qe = 0, Je = 0, Ke = !0, xt = 0;
        for (xe = 0; xe < Ie; xe += 1) {
          Be = this.globalData.fontManager.getCharData(e.finalText[xe], Se.fStyle, this.globalData.fontManager.getFontByName(e.f).fFamily), $e = Be && Be.data || {}, Ee.reset(), Ye && Me[xe].n && (qe = -We, Je += e.yOffset, Je += Ke ? 1 : 0, Ke = !1), Ve = $e.shapes ? $e.shapes[0].it : [], Ge = Ve.length, Ee.scale(e.finalSize / 100, e.finalSize / 100), Ye && this.applyTextPropertiesToMatrix(e, Ee, Me[xe].line, qe, Je), Ue = createSizedArray(Ge - 1);
          var Ct = 0;
          for (je = 0; je < Ge; je += 1)
            if (Ve[je].ty === "sh") {
              for (Fe = Ve[je].ks.k.i.length, De = Ve[je].ks.k, Re = [], Le = 1; Le < Fe; Le += 1)
                Le === 1 && Re.push(Ee.applyToX(De.v[0][0], De.v[0][1], 0), Ee.applyToY(De.v[0][0], De.v[0][1], 0)), Re.push(Ee.applyToX(De.o[Le - 1][0], De.o[Le - 1][1], 0), Ee.applyToY(De.o[Le - 1][0], De.o[Le - 1][1], 0), Ee.applyToX(De.i[Le][0], De.i[Le][1], 0), Ee.applyToY(De.i[Le][0], De.i[Le][1], 0), Ee.applyToX(De.v[Le][0], De.v[Le][1], 0), Ee.applyToY(De.v[Le][0], De.v[Le][1], 0));
              Re.push(Ee.applyToX(De.o[Le - 1][0], De.o[Le - 1][1], 0), Ee.applyToY(De.o[Le - 1][0], De.o[Le - 1][1], 0), Ee.applyToX(De.i[0][0], De.i[0][1], 0), Ee.applyToY(De.i[0][0], De.i[0][1], 0), Ee.applyToX(De.v[0][0], De.v[0][1], 0), Ee.applyToY(De.v[0][0], De.v[0][1], 0)), Ue[Ct] = Re, Ct += 1;
            }
          Ye && (qe += Me[xe].l, qe += We), this.textSpans[xt] ? this.textSpans[xt].elem = Ue : this.textSpans[xt] = {
            elem: Ue
          }, xt += 1;
        }
      }, CVTextElement.prototype.renderInnerContent = function() {
        this.validateText();
        var e = this.canvasContext;
        e.font = this.values.fValue, this.globalData.renderer.ctxLineCap("butt"), this.globalData.renderer.ctxLineJoin("miter"), this.globalData.renderer.ctxMiterLimit(4), this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        var j, ke, Se, xe, Ie, Me, Ee = this.textAnimator.renderedLetters, Be = this.textProperty.currentData.l;
        ke = Be.length;
        var $e, Le = null, Fe = null, Ve = null, je, Ge, De = this.globalData.renderer;
        for (j = 0; j < ke; j += 1)
          if (!Be[j].n) {
            if ($e = Ee[j], $e && (De.save(), De.ctxTransform($e.p), De.ctxOpacity($e.o)), this.fill) {
              for ($e && $e.fc ? Le !== $e.fc && (De.ctxFillStyle($e.fc), Le = $e.fc) : Le !== this.values.fill && (Le = this.values.fill, De.ctxFillStyle(this.values.fill)), je = this.textSpans[j].elem, xe = je.length, this.globalData.canvasContext.beginPath(), Se = 0; Se < xe; Se += 1)
                for (Ge = je[Se], Me = Ge.length, this.globalData.canvasContext.moveTo(Ge[0], Ge[1]), Ie = 2; Ie < Me; Ie += 6)
                  this.globalData.canvasContext.bezierCurveTo(Ge[Ie], Ge[Ie + 1], Ge[Ie + 2], Ge[Ie + 3], Ge[Ie + 4], Ge[Ie + 5]);
              this.globalData.canvasContext.closePath(), De.ctxFill();
            }
            if (this.stroke) {
              for ($e && $e.sw ? Ve !== $e.sw && (Ve = $e.sw, De.ctxLineWidth($e.sw)) : Ve !== this.values.sWidth && (Ve = this.values.sWidth, De.ctxLineWidth(this.values.sWidth)), $e && $e.sc ? Fe !== $e.sc && (Fe = $e.sc, De.ctxStrokeStyle($e.sc)) : Fe !== this.values.stroke && (Fe = this.values.stroke, De.ctxStrokeStyle(this.values.stroke)), je = this.textSpans[j].elem, xe = je.length, this.globalData.canvasContext.beginPath(), Se = 0; Se < xe; Se += 1)
                for (Ge = je[Se], Me = Ge.length, this.globalData.canvasContext.moveTo(Ge[0], Ge[1]), Ie = 2; Ie < Me; Ie += 6)
                  this.globalData.canvasContext.bezierCurveTo(Ge[Ie], Ge[Ie + 1], Ge[Ie + 2], Ge[Ie + 3], Ge[Ie + 4], Ge[Ie + 5]);
              this.globalData.canvasContext.closePath(), De.ctxStroke();
            }
            $e && this.globalData.renderer.restore();
          }
      };
      function CVImageElement(e, j, ke) {
        this.assetData = j.getAssetData(e.refId), this.img = j.imageLoader.getAsset(this.assetData), this.initElement(e, j, ke);
      }
      extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement), CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVImageElement.prototype.createContent = function() {
        if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
          var e = createTag("canvas");
          e.width = this.assetData.w, e.height = this.assetData.h;
          var j = e.getContext("2d"), ke = this.img.width, Se = this.img.height, xe = ke / Se, Ie = this.assetData.w / this.assetData.h, Me, Ee, Be = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
          xe > Ie && Be === "xMidYMid slice" || xe < Ie && Be !== "xMidYMid slice" ? (Ee = Se, Me = Ee * Ie) : (Me = ke, Ee = Me / Ie), j.drawImage(this.img, (ke - Me) / 2, (Se - Ee) / 2, Me, Ee, 0, 0, this.assetData.w, this.assetData.h), this.img = e;
        }
      }, CVImageElement.prototype.renderInnerContent = function() {
        this.canvasContext.drawImage(this.img, 0, 0);
      }, CVImageElement.prototype.destroy = function() {
        this.img = null;
      };
      function CVSolidElement(e, j, ke) {
        this.initElement(e, j, ke);
      }
      extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement), CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVSolidElement.prototype.renderInnerContent = function() {
        this.globalData.renderer.ctxFillStyle(this.data.sc), this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh);
      };
      function CanvasRendererBase() {
      }
      extendPrototype([BaseRenderer], CanvasRendererBase), CanvasRendererBase.prototype.createShape = function(e) {
        return new CVShapeElement(e, this.globalData, this);
      }, CanvasRendererBase.prototype.createText = function(e) {
        return new CVTextElement(e, this.globalData, this);
      }, CanvasRendererBase.prototype.createImage = function(e) {
        return new CVImageElement(e, this.globalData, this);
      }, CanvasRendererBase.prototype.createSolid = function(e) {
        return new CVSolidElement(e, this.globalData, this);
      }, CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, CanvasRendererBase.prototype.ctxTransform = function(e) {
        e[0] === 1 && e[1] === 0 && e[4] === 0 && e[5] === 1 && e[12] === 0 && e[13] === 0 || this.canvasContext.transform(e[0], e[1], e[4], e[5], e[12], e[13]);
      }, CanvasRendererBase.prototype.ctxOpacity = function(e) {
        this.canvasContext.globalAlpha *= e < 0 ? 0 : e;
      }, CanvasRendererBase.prototype.ctxFillStyle = function(e) {
        this.canvasContext.fillStyle = e;
      }, CanvasRendererBase.prototype.ctxStrokeStyle = function(e) {
        this.canvasContext.strokeStyle = e;
      }, CanvasRendererBase.prototype.ctxLineWidth = function(e) {
        this.canvasContext.lineWidth = e;
      }, CanvasRendererBase.prototype.ctxLineCap = function(e) {
        this.canvasContext.lineCap = e;
      }, CanvasRendererBase.prototype.ctxLineJoin = function(e) {
        this.canvasContext.lineJoin = e;
      }, CanvasRendererBase.prototype.ctxMiterLimit = function(e) {
        this.canvasContext.miterLimit = e;
      }, CanvasRendererBase.prototype.ctxFill = function(e) {
        this.canvasContext.fill(e);
      }, CanvasRendererBase.prototype.ctxFillRect = function(e, j, ke, Se) {
        this.canvasContext.fillRect(e, j, ke, Se);
      }, CanvasRendererBase.prototype.ctxStroke = function() {
        this.canvasContext.stroke();
      }, CanvasRendererBase.prototype.reset = function() {
        if (!this.renderConfig.clearCanvas) {
          this.canvasContext.restore();
          return;
        }
        this.contextData.reset();
      }, CanvasRendererBase.prototype.save = function() {
        this.canvasContext.save();
      }, CanvasRendererBase.prototype.restore = function(e) {
        if (!this.renderConfig.clearCanvas) {
          this.canvasContext.restore();
          return;
        }
        e && (this.globalData.blendMode = "source-over"), this.contextData.restore(e);
      }, CanvasRendererBase.prototype.configAnimation = function(e) {
        if (this.animationItem.wrapper) {
          this.animationItem.container = createTag("canvas");
          var j = this.animationItem.container.style;
          j.width = "100%", j.height = "100%";
          var ke = "0px 0px 0px";
          j.transformOrigin = ke, j.mozTransformOrigin = ke, j.webkitTransformOrigin = ke, j["-webkit-transform"] = ke, j.contentVisibility = this.renderConfig.contentVisibility, this.animationItem.wrapper.appendChild(this.animationItem.container), this.canvasContext = this.animationItem.container.getContext("2d"), this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.animationItem.container.setAttribute("id", this.renderConfig.id);
        } else
          this.canvasContext = this.renderConfig.context;
        this.contextData.setContext(this.canvasContext), this.data = e, this.layers = e.layers, this.transformCanvas = {
          w: e.w,
          h: e.h,
          sx: 0,
          sy: 0,
          tx: 0,
          ty: 0
        }, this.setupGlobalData(e, document.body), this.globalData.canvasContext = this.canvasContext, this.globalData.renderer = this, this.globalData.isDashed = !1, this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.globalData.transformCanvas = this.transformCanvas, this.elements = createSizedArray(e.layers.length), this.updateContainerSize();
      }, CanvasRendererBase.prototype.updateContainerSize = function(e, j) {
        this.reset();
        var ke, Se;
        e ? (ke = e, Se = j, this.canvasContext.canvas.width = ke, this.canvasContext.canvas.height = Se) : (this.animationItem.wrapper && this.animationItem.container ? (ke = this.animationItem.wrapper.offsetWidth, Se = this.animationItem.wrapper.offsetHeight) : (ke = this.canvasContext.canvas.width, Se = this.canvasContext.canvas.height), this.canvasContext.canvas.width = ke * this.renderConfig.dpr, this.canvasContext.canvas.height = Se * this.renderConfig.dpr);
        var xe, Ie;
        if (this.renderConfig.preserveAspectRatio.indexOf("meet") !== -1 || this.renderConfig.preserveAspectRatio.indexOf("slice") !== -1) {
          var Me = this.renderConfig.preserveAspectRatio.split(" "), Ee = Me[1] || "meet", Be = Me[0] || "xMidYMid", $e = Be.substr(0, 4), Le = Be.substr(4);
          xe = ke / Se, Ie = this.transformCanvas.w / this.transformCanvas.h, Ie > xe && Ee === "meet" || Ie < xe && Ee === "slice" ? (this.transformCanvas.sx = ke / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = ke / (this.transformCanvas.w / this.renderConfig.dpr)) : (this.transformCanvas.sx = Se / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.sy = Se / (this.transformCanvas.h / this.renderConfig.dpr)), $e === "xMid" && (Ie < xe && Ee === "meet" || Ie > xe && Ee === "slice") ? this.transformCanvas.tx = (ke - this.transformCanvas.w * (Se / this.transformCanvas.h)) / 2 * this.renderConfig.dpr : $e === "xMax" && (Ie < xe && Ee === "meet" || Ie > xe && Ee === "slice") ? this.transformCanvas.tx = (ke - this.transformCanvas.w * (Se / this.transformCanvas.h)) * this.renderConfig.dpr : this.transformCanvas.tx = 0, Le === "YMid" && (Ie > xe && Ee === "meet" || Ie < xe && Ee === "slice") ? this.transformCanvas.ty = (Se - this.transformCanvas.h * (ke / this.transformCanvas.w)) / 2 * this.renderConfig.dpr : Le === "YMax" && (Ie > xe && Ee === "meet" || Ie < xe && Ee === "slice") ? this.transformCanvas.ty = (Se - this.transformCanvas.h * (ke / this.transformCanvas.w)) * this.renderConfig.dpr : this.transformCanvas.ty = 0;
        } else this.renderConfig.preserveAspectRatio === "none" ? (this.transformCanvas.sx = ke / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = Se / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.tx = 0, this.transformCanvas.ty = 0) : (this.transformCanvas.sx = this.renderConfig.dpr, this.transformCanvas.sy = this.renderConfig.dpr, this.transformCanvas.tx = 0, this.transformCanvas.ty = 0);
        this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1], this.ctxTransform(this.transformCanvas.props), this.canvasContext.beginPath(), this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h), this.canvasContext.closePath(), this.canvasContext.clip(), this.renderFrame(this.renderedFrame, !0);
      }, CanvasRendererBase.prototype.destroy = function() {
        this.renderConfig.clearCanvas && this.animationItem.wrapper && (this.animationItem.wrapper.innerText = "");
        var e, j = this.layers ? this.layers.length : 0;
        for (e = j - 1; e >= 0; e -= 1)
          this.elements[e] && this.elements[e].destroy && this.elements[e].destroy();
        this.elements.length = 0, this.globalData.canvasContext = null, this.animationItem.container = null, this.destroyed = !0;
      }, CanvasRendererBase.prototype.renderFrame = function(e, j) {
        if (!(this.renderedFrame === e && this.renderConfig.clearCanvas === !0 && !j || this.destroyed || e === -1)) {
          this.renderedFrame = e, this.globalData.frameNum = e - this.animationItem._isFirstFrame, this.globalData.frameId += 1, this.globalData._mdf = !this.renderConfig.clearCanvas || j, this.globalData.projectInterface.currentFrame = e;
          var ke, Se = this.layers.length;
          for (this.completeLayers || this.checkLayers(e), ke = Se - 1; ke >= 0; ke -= 1)
            (this.completeLayers || this.elements[ke]) && this.elements[ke].prepareFrame(e - this.layers[ke].st);
          if (this.globalData._mdf) {
            for (this.renderConfig.clearCanvas === !0 ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h) : this.save(), ke = Se - 1; ke >= 0; ke -= 1)
              (this.completeLayers || this.elements[ke]) && this.elements[ke].renderFrame();
            this.renderConfig.clearCanvas !== !0 && this.restore();
          }
        }
      }, CanvasRendererBase.prototype.buildItem = function(e) {
        var j = this.elements;
        if (!(j[e] || this.layers[e].ty === 99)) {
          var ke = this.createItem(this.layers[e], this, this.globalData);
          j[e] = ke, ke.initExpressions();
        }
      }, CanvasRendererBase.prototype.checkPendingElements = function() {
        for (; this.pendingElements.length; ) {
          var e = this.pendingElements.pop();
          e.checkParenting();
        }
      }, CanvasRendererBase.prototype.hide = function() {
        this.animationItem.container.style.display = "none";
      }, CanvasRendererBase.prototype.show = function() {
        this.animationItem.container.style.display = "block";
      };
      function CanvasContext() {
        this.opacity = -1, this.transform = createTypedArray("float32", 16), this.fillStyle = "", this.strokeStyle = "", this.lineWidth = "", this.lineCap = "", this.lineJoin = "", this.miterLimit = "", this.id = Math.random();
      }
      function CVContextData() {
        this.stack = [], this.cArrPos = 0, this.cTr = new Matrix();
        var e, j = 15;
        for (e = 0; e < j; e += 1) {
          var ke = new CanvasContext();
          this.stack[e] = ke;
        }
        this._length = j, this.nativeContext = null, this.transformMat = new Matrix(), this.currentOpacity = 1, this.currentFillStyle = "", this.appliedFillStyle = "", this.currentStrokeStyle = "", this.appliedStrokeStyle = "", this.currentLineWidth = "", this.appliedLineWidth = "", this.currentLineCap = "", this.appliedLineCap = "", this.currentLineJoin = "", this.appliedLineJoin = "", this.appliedMiterLimit = "", this.currentMiterLimit = "";
      }
      CVContextData.prototype.duplicate = function() {
        var e = this._length * 2, j = 0;
        for (j = this._length; j < e; j += 1)
          this.stack[j] = new CanvasContext();
        this._length = e;
      }, CVContextData.prototype.reset = function() {
        this.cArrPos = 0, this.cTr.reset(), this.stack[this.cArrPos].opacity = 1;
      }, CVContextData.prototype.restore = function(e) {
        this.cArrPos -= 1;
        var j = this.stack[this.cArrPos], ke = j.transform, Se, xe = this.cTr.props;
        for (Se = 0; Se < 16; Se += 1)
          xe[Se] = ke[Se];
        if (e) {
          this.nativeContext.restore();
          var Ie = this.stack[this.cArrPos + 1];
          this.appliedFillStyle = Ie.fillStyle, this.appliedStrokeStyle = Ie.strokeStyle, this.appliedLineWidth = Ie.lineWidth, this.appliedLineCap = Ie.lineCap, this.appliedLineJoin = Ie.lineJoin, this.appliedMiterLimit = Ie.miterLimit;
        }
        this.nativeContext.setTransform(ke[0], ke[1], ke[4], ke[5], ke[12], ke[13]), (e || j.opacity !== -1 && this.currentOpacity !== j.opacity) && (this.nativeContext.globalAlpha = j.opacity, this.currentOpacity = j.opacity), this.currentFillStyle = j.fillStyle, this.currentStrokeStyle = j.strokeStyle, this.currentLineWidth = j.lineWidth, this.currentLineCap = j.lineCap, this.currentLineJoin = j.lineJoin, this.currentMiterLimit = j.miterLimit;
      }, CVContextData.prototype.save = function(e) {
        e && this.nativeContext.save();
        var j = this.cTr.props;
        this._length <= this.cArrPos && this.duplicate();
        var ke = this.stack[this.cArrPos], Se;
        for (Se = 0; Se < 16; Se += 1)
          ke.transform[Se] = j[Se];
        this.cArrPos += 1;
        var xe = this.stack[this.cArrPos];
        xe.opacity = ke.opacity, xe.fillStyle = ke.fillStyle, xe.strokeStyle = ke.strokeStyle, xe.lineWidth = ke.lineWidth, xe.lineCap = ke.lineCap, xe.lineJoin = ke.lineJoin, xe.miterLimit = ke.miterLimit;
      }, CVContextData.prototype.setOpacity = function(e) {
        this.stack[this.cArrPos].opacity = e;
      }, CVContextData.prototype.setContext = function(e) {
        this.nativeContext = e;
      }, CVContextData.prototype.fillStyle = function(e) {
        this.stack[this.cArrPos].fillStyle !== e && (this.currentFillStyle = e, this.stack[this.cArrPos].fillStyle = e);
      }, CVContextData.prototype.strokeStyle = function(e) {
        this.stack[this.cArrPos].strokeStyle !== e && (this.currentStrokeStyle = e, this.stack[this.cArrPos].strokeStyle = e);
      }, CVContextData.prototype.lineWidth = function(e) {
        this.stack[this.cArrPos].lineWidth !== e && (this.currentLineWidth = e, this.stack[this.cArrPos].lineWidth = e);
      }, CVContextData.prototype.lineCap = function(e) {
        this.stack[this.cArrPos].lineCap !== e && (this.currentLineCap = e, this.stack[this.cArrPos].lineCap = e);
      }, CVContextData.prototype.lineJoin = function(e) {
        this.stack[this.cArrPos].lineJoin !== e && (this.currentLineJoin = e, this.stack[this.cArrPos].lineJoin = e);
      }, CVContextData.prototype.miterLimit = function(e) {
        this.stack[this.cArrPos].miterLimit !== e && (this.currentMiterLimit = e, this.stack[this.cArrPos].miterLimit = e);
      }, CVContextData.prototype.transform = function(e) {
        this.transformMat.cloneFromProps(e);
        var j = this.cTr;
        this.transformMat.multiply(j), j.cloneFromProps(this.transformMat.props);
        var ke = j.props;
        this.nativeContext.setTransform(ke[0], ke[1], ke[4], ke[5], ke[12], ke[13]);
      }, CVContextData.prototype.opacity = function(e) {
        var j = this.stack[this.cArrPos].opacity;
        j *= e < 0 ? 0 : e, this.stack[this.cArrPos].opacity !== j && (this.currentOpacity !== e && (this.nativeContext.globalAlpha = e, this.currentOpacity = e), this.stack[this.cArrPos].opacity = j);
      }, CVContextData.prototype.fill = function(e) {
        this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fill(e);
      }, CVContextData.prototype.fillRect = function(e, j, ke, Se) {
        this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fillRect(e, j, ke, Se);
      }, CVContextData.prototype.stroke = function() {
        this.appliedStrokeStyle !== this.currentStrokeStyle && (this.appliedStrokeStyle = this.currentStrokeStyle, this.nativeContext.strokeStyle = this.appliedStrokeStyle), this.appliedLineWidth !== this.currentLineWidth && (this.appliedLineWidth = this.currentLineWidth, this.nativeContext.lineWidth = this.appliedLineWidth), this.appliedLineCap !== this.currentLineCap && (this.appliedLineCap = this.currentLineCap, this.nativeContext.lineCap = this.appliedLineCap), this.appliedLineJoin !== this.currentLineJoin && (this.appliedLineJoin = this.currentLineJoin, this.nativeContext.lineJoin = this.appliedLineJoin), this.appliedMiterLimit !== this.currentMiterLimit && (this.appliedMiterLimit = this.currentMiterLimit, this.nativeContext.miterLimit = this.appliedMiterLimit), this.nativeContext.stroke();
      };
      function CVCompElement(e, j, ke) {
        this.completeLayers = !1, this.layers = e.layers, this.pendingElements = [], this.elements = createSizedArray(this.layers.length), this.initElement(e, j, ke), this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, j.frameRate, this) : {
          _placeholder: !0
        };
      }
      extendPrototype([CanvasRendererBase, ICompElement, CVBaseElement], CVCompElement), CVCompElement.prototype.renderInnerContent = function() {
        var e = this.canvasContext;
        e.beginPath(), e.moveTo(0, 0), e.lineTo(this.data.w, 0), e.lineTo(this.data.w, this.data.h), e.lineTo(0, this.data.h), e.lineTo(0, 0), e.clip();
        var j, ke = this.layers.length;
        for (j = ke - 1; j >= 0; j -= 1)
          (this.completeLayers || this.elements[j]) && this.elements[j].renderFrame();
      }, CVCompElement.prototype.destroy = function() {
        var e, j = this.layers.length;
        for (e = j - 1; e >= 0; e -= 1)
          this.elements[e] && this.elements[e].destroy();
        this.layers = null, this.elements = null;
      }, CVCompElement.prototype.createComp = function(e) {
        return new CVCompElement(e, this.globalData, this);
      };
      function CanvasRenderer(e, j) {
        this.animationItem = e, this.renderConfig = {
          clearCanvas: j && j.clearCanvas !== void 0 ? j.clearCanvas : !0,
          context: j && j.context || null,
          progressiveLoad: j && j.progressiveLoad || !1,
          preserveAspectRatio: j && j.preserveAspectRatio || "xMidYMid meet",
          imagePreserveAspectRatio: j && j.imagePreserveAspectRatio || "xMidYMid slice",
          contentVisibility: j && j.contentVisibility || "visible",
          className: j && j.className || "",
          id: j && j.id || "",
          runExpressions: !j || j.runExpressions === void 0 || j.runExpressions
        }, this.renderConfig.dpr = j && j.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = j && j.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
          frameNum: -1,
          _mdf: !1,
          renderConfig: this.renderConfig,
          currentGlobalAlpha: -1
        }, this.contextData = new CVContextData(), this.elements = [], this.pendingElements = [], this.transformMat = new Matrix(), this.completeLayers = !1, this.rendererType = "canvas", this.renderConfig.clearCanvas && (this.ctxTransform = this.contextData.transform.bind(this.contextData), this.ctxOpacity = this.contextData.opacity.bind(this.contextData), this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData), this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData), this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData), this.ctxLineCap = this.contextData.lineCap.bind(this.contextData), this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData), this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData), this.ctxFill = this.contextData.fill.bind(this.contextData), this.ctxFillRect = this.contextData.fillRect.bind(this.contextData), this.ctxStroke = this.contextData.stroke.bind(this.contextData), this.save = this.contextData.save.bind(this.contextData));
      }
      extendPrototype([CanvasRendererBase], CanvasRenderer), CanvasRenderer.prototype.createComp = function(e) {
        return new CVCompElement(e, this.globalData, this);
      };
      function HBaseElement() {
      }
      HBaseElement.prototype = {
        checkBlendMode: function() {
        },
        initRendererElement: function() {
          this.baseElement = createTag(this.data.tg || "div"), this.data.hasMask ? (this.svgElement = createNS("svg"), this.layerElement = createNS("g"), this.maskedElement = this.layerElement, this.svgElement.appendChild(this.layerElement), this.baseElement.appendChild(this.svgElement)) : this.layerElement = this.baseElement, styleDiv(this.baseElement);
        },
        createContainerElements: function() {
          this.renderableEffectsManager = new CVEffects(this), this.transformedElement = this.baseElement, this.maskedElement = this.layerElement, this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.bm !== 0 && this.setBlendMode();
        },
        renderElement: function() {
          var j = this.transformedElement ? this.transformedElement.style : {};
          if (this.finalTransform._matMdf) {
            var ke = this.finalTransform.mat.toCSS();
            j.transform = ke, j.webkitTransform = ke;
          }
          this.finalTransform._opMdf && (j.opacity = this.finalTransform.mProp.o.v);
        },
        renderFrame: function() {
          this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
        },
        destroy: function() {
          this.layerElement = null, this.transformedElement = null, this.matteElement && (this.matteElement = null), this.maskManager && (this.maskManager.destroy(), this.maskManager = null);
        },
        createRenderableComponents: function() {
          this.maskManager = new MaskElement(this.data, this, this.globalData);
        },
        addEffects: function() {
        },
        setMatte: function() {
        }
      }, HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement, HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy, HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;
      function HSolidElement(e, j, ke) {
        this.initElement(e, j, ke);
      }
      extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement), HSolidElement.prototype.createContent = function() {
        var e;
        this.data.hasMask ? (e = createNS("rect"), e.setAttribute("width", this.data.sw), e.setAttribute("height", this.data.sh), e.setAttribute("fill", this.data.sc), this.svgElement.setAttribute("width", this.data.sw), this.svgElement.setAttribute("height", this.data.sh)) : (e = createTag("div"), e.style.width = this.data.sw + "px", e.style.height = this.data.sh + "px", e.style.backgroundColor = this.data.sc), this.layerElement.appendChild(e);
      };
      function HShapeElement(e, j, ke) {
        this.shapes = [], this.shapesData = e.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.shapesContainer = createNS("g"), this.initElement(e, j, ke), this.prevViewData = [], this.currentBBox = {
          x: 999999,
          y: -999999,
          h: 0,
          w: 0
        };
      }
      extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement), HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent, HShapeElement.prototype.createContent = function() {
        var e;
        if (this.baseElement.style.fontSize = 0, this.data.hasMask)
          this.layerElement.appendChild(this.shapesContainer), e = this.svgElement;
        else {
          e = createNS("svg");
          var j = this.comp.data ? this.comp.data : this.globalData.compSize;
          e.setAttribute("width", j.w), e.setAttribute("height", j.h), e.appendChild(this.shapesContainer), this.layerElement.appendChild(e);
        }
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], !0), this.filterUniqueShapes(), this.shapeCont = e;
      }, HShapeElement.prototype.getTransformedPoint = function(e, j) {
        var ke, Se = e.length;
        for (ke = 0; ke < Se; ke += 1)
          j = e[ke].mProps.v.applyToPointArray(j[0], j[1], 0);
        return j;
      }, HShapeElement.prototype.calculateShapeBoundingBox = function(e, j) {
        var ke = e.sh.v, Se = e.transformers, xe, Ie = ke._length, Me, Ee, Be, $e;
        if (!(Ie <= 1)) {
          for (xe = 0; xe < Ie - 1; xe += 1)
            Me = this.getTransformedPoint(Se, ke.v[xe]), Ee = this.getTransformedPoint(Se, ke.o[xe]), Be = this.getTransformedPoint(Se, ke.i[xe + 1]), $e = this.getTransformedPoint(Se, ke.v[xe + 1]), this.checkBounds(Me, Ee, Be, $e, j);
          ke.c && (Me = this.getTransformedPoint(Se, ke.v[xe]), Ee = this.getTransformedPoint(Se, ke.o[xe]), Be = this.getTransformedPoint(Se, ke.i[0]), $e = this.getTransformedPoint(Se, ke.v[0]), this.checkBounds(Me, Ee, Be, $e, j));
        }
      }, HShapeElement.prototype.checkBounds = function(e, j, ke, Se, xe) {
        this.getBoundsOfCurve(e, j, ke, Se);
        var Ie = this.shapeBoundingBox;
        xe.x = bmMin(Ie.left, xe.x), xe.xMax = bmMax(Ie.right, xe.xMax), xe.y = bmMin(Ie.top, xe.y), xe.yMax = bmMax(Ie.bottom, xe.yMax);
      }, HShapeElement.prototype.shapeBoundingBox = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      }, HShapeElement.prototype.tempBoundingBox = {
        x: 0,
        xMax: 0,
        y: 0,
        yMax: 0,
        width: 0,
        height: 0
      }, HShapeElement.prototype.getBoundsOfCurve = function(e, j, ke, Se) {
        for (var xe = [[e[0], Se[0]], [e[1], Se[1]]], Ie, Me, Ee, Be, $e, Le, Fe, Ve = 0; Ve < 2; ++Ve)
          Me = 6 * e[Ve] - 12 * j[Ve] + 6 * ke[Ve], Ie = -3 * e[Ve] + 9 * j[Ve] - 9 * ke[Ve] + 3 * Se[Ve], Ee = 3 * j[Ve] - 3 * e[Ve], Me |= 0, Ie |= 0, Ee |= 0, Ie === 0 && Me === 0 || (Ie === 0 ? (Be = -Ee / Me, Be > 0 && Be < 1 && xe[Ve].push(this.calculateF(Be, e, j, ke, Se, Ve))) : ($e = Me * Me - 4 * Ee * Ie, $e >= 0 && (Le = (-Me + bmSqrt($e)) / (2 * Ie), Le > 0 && Le < 1 && xe[Ve].push(this.calculateF(Le, e, j, ke, Se, Ve)), Fe = (-Me - bmSqrt($e)) / (2 * Ie), Fe > 0 && Fe < 1 && xe[Ve].push(this.calculateF(Fe, e, j, ke, Se, Ve)))));
        this.shapeBoundingBox.left = bmMin.apply(null, xe[0]), this.shapeBoundingBox.top = bmMin.apply(null, xe[1]), this.shapeBoundingBox.right = bmMax.apply(null, xe[0]), this.shapeBoundingBox.bottom = bmMax.apply(null, xe[1]);
      }, HShapeElement.prototype.calculateF = function(e, j, ke, Se, xe, Ie) {
        return bmPow(1 - e, 3) * j[Ie] + 3 * bmPow(1 - e, 2) * e * ke[Ie] + 3 * (1 - e) * bmPow(e, 2) * Se[Ie] + bmPow(e, 3) * xe[Ie];
      }, HShapeElement.prototype.calculateBoundingBox = function(e, j) {
        var ke, Se = e.length;
        for (ke = 0; ke < Se; ke += 1)
          e[ke] && e[ke].sh ? this.calculateShapeBoundingBox(e[ke], j) : e[ke] && e[ke].it ? this.calculateBoundingBox(e[ke].it, j) : e[ke] && e[ke].style && e[ke].w && this.expandStrokeBoundingBox(e[ke].w, j);
      }, HShapeElement.prototype.expandStrokeBoundingBox = function(e, j) {
        var ke = 0;
        if (e.keyframes) {
          for (var Se = 0; Se < e.keyframes.length; Se += 1) {
            var xe = e.keyframes[Se].s;
            xe > ke && (ke = xe);
          }
          ke *= e.mult;
        } else
          ke = e.v * e.mult;
        j.x -= ke, j.xMax += ke, j.y -= ke, j.yMax += ke;
      }, HShapeElement.prototype.currentBoxContains = function(e) {
        return this.currentBBox.x <= e.x && this.currentBBox.y <= e.y && this.currentBBox.width + this.currentBBox.x >= e.x + e.width && this.currentBBox.height + this.currentBBox.y >= e.y + e.height;
      }, HShapeElement.prototype.renderInnerContent = function() {
        if (this._renderShapeFrame(), !this.hidden && (this._isFirstFrame || this._mdf)) {
          var e = this.tempBoundingBox, j = 999999;
          if (e.x = j, e.xMax = -j, e.y = j, e.yMax = -j, this.calculateBoundingBox(this.itemsData, e), e.width = e.xMax < e.x ? 0 : e.xMax - e.x, e.height = e.yMax < e.y ? 0 : e.yMax - e.y, this.currentBoxContains(e))
            return;
          var ke = !1;
          if (this.currentBBox.w !== e.width && (this.currentBBox.w = e.width, this.shapeCont.setAttribute("width", e.width), ke = !0), this.currentBBox.h !== e.height && (this.currentBBox.h = e.height, this.shapeCont.setAttribute("height", e.height), ke = !0), ke || this.currentBBox.x !== e.x || this.currentBBox.y !== e.y) {
            this.currentBBox.w = e.width, this.currentBBox.h = e.height, this.currentBBox.x = e.x, this.currentBBox.y = e.y, this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
            var Se = this.shapeCont.style, xe = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
            Se.transform = xe, Se.webkitTransform = xe;
          }
        }
      };
      function HTextElement(e, j, ke) {
        this.textSpans = [], this.textPaths = [], this.currentBBox = {
          x: 999999,
          y: -999999,
          h: 0,
          w: 0
        }, this.renderType = "svg", this.isMasked = !1, this.initElement(e, j, ke);
      }
      extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement), HTextElement.prototype.createContent = function() {
        if (this.isMasked = this.checkMasks(), this.isMasked) {
          this.renderType = "svg", this.compW = this.comp.data.w, this.compH = this.comp.data.h, this.svgElement.setAttribute("width", this.compW), this.svgElement.setAttribute("height", this.compH);
          var e = createNS("g");
          this.maskedElement.appendChild(e), this.innerElem = e;
        } else
          this.renderType = "html", this.innerElem = this.layerElement;
        this.checkParenting();
      }, HTextElement.prototype.buildNewText = function() {
        var e = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(e.l ? e.l.length : 0);
        var j = this.innerElem.style, ke = e.fc ? this.buildColor(e.fc) : "rgba(0,0,0,0)";
        j.fill = ke, j.color = ke, e.sc && (j.stroke = this.buildColor(e.sc), j.strokeWidth = e.sw + "px");
        var Se = this.globalData.fontManager.getFontByName(e.f);
        if (!this.globalData.fontManager.chars)
          if (j.fontSize = e.finalSize + "px", j.lineHeight = e.finalSize + "px", Se.fClass)
            this.innerElem.className = Se.fClass;
          else {
            j.fontFamily = Se.fFamily;
            var xe = e.fWeight, Ie = e.fStyle;
            j.fontStyle = Ie, j.fontWeight = xe;
          }
        var Me, Ee, Be = e.l;
        Ee = Be.length;
        var $e, Le, Fe, Ve = this.mHelper, je, Ge = "", De = 0;
        for (Me = 0; Me < Ee; Me += 1) {
          if (this.globalData.fontManager.chars ? (this.textPaths[De] ? $e = this.textPaths[De] : ($e = createNS("path"), $e.setAttribute("stroke-linecap", lineCapEnum[1]), $e.setAttribute("stroke-linejoin", lineJoinEnum[2]), $e.setAttribute("stroke-miterlimit", "4")), this.isMasked || (this.textSpans[De] ? (Le = this.textSpans[De], Fe = Le.children[0]) : (Le = createTag("div"), Le.style.lineHeight = 0, Fe = createNS("svg"), Fe.appendChild($e), styleDiv(Le)))) : this.isMasked ? $e = this.textPaths[De] ? this.textPaths[De] : createNS("text") : this.textSpans[De] ? (Le = this.textSpans[De], $e = this.textPaths[De]) : (Le = createTag("span"), styleDiv(Le), $e = createTag("span"), styleDiv($e), Le.appendChild($e)), this.globalData.fontManager.chars) {
            var Ue = this.globalData.fontManager.getCharData(e.finalText[Me], Se.fStyle, this.globalData.fontManager.getFontByName(e.f).fFamily), Re;
            if (Ue ? Re = Ue.data : Re = null, Ve.reset(), Re && Re.shapes && Re.shapes.length && (je = Re.shapes[0].it, Ve.scale(e.finalSize / 100, e.finalSize / 100), Ge = this.createPathShape(Ve, je), $e.setAttribute("d", Ge)), this.isMasked)
              this.innerElem.appendChild($e);
            else {
              if (this.innerElem.appendChild(Le), Re && Re.shapes) {
                document.body.appendChild(Fe);
                var Ye = Fe.getBBox();
                Fe.setAttribute("width", Ye.width + 2), Fe.setAttribute("height", Ye.height + 2), Fe.setAttribute("viewBox", Ye.x - 1 + " " + (Ye.y - 1) + " " + (Ye.width + 2) + " " + (Ye.height + 2));
                var We = Fe.style, qe = "translate(" + (Ye.x - 1) + "px," + (Ye.y - 1) + "px)";
                We.transform = qe, We.webkitTransform = qe, Be[Me].yOffset = Ye.y - 1;
              } else
                Fe.setAttribute("width", 1), Fe.setAttribute("height", 1);
              Le.appendChild(Fe);
            }
          } else if ($e.textContent = Be[Me].val, $e.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.isMasked)
            this.innerElem.appendChild($e);
          else {
            this.innerElem.appendChild(Le);
            var Je = $e.style, Ke = "translate3d(0," + -e.finalSize / 1.2 + "px,0)";
            Je.transform = Ke, Je.webkitTransform = Ke;
          }
          this.isMasked ? this.textSpans[De] = $e : this.textSpans[De] = Le, this.textSpans[De].style.display = "block", this.textPaths[De] = $e, De += 1;
        }
        for (; De < this.textSpans.length; )
          this.textSpans[De].style.display = "none", De += 1;
      }, HTextElement.prototype.renderInnerContent = function() {
        this.validateText();
        var e;
        if (this.data.singleShape) {
          if (!this._isFirstFrame && !this.lettersChangedFlag)
            return;
          if (this.isMasked && this.finalTransform._matMdf) {
            this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH), e = this.svgElement.style;
            var j = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
            e.transform = j, e.webkitTransform = j;
          }
        }
        if (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), !(!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag)) {
          var ke, Se, xe = 0, Ie = this.textAnimator.renderedLetters, Me = this.textProperty.currentData.l;
          Se = Me.length;
          var Ee, Be, $e;
          for (ke = 0; ke < Se; ke += 1)
            Me[ke].n ? xe += 1 : (Be = this.textSpans[ke], $e = this.textPaths[ke], Ee = Ie[xe], xe += 1, Ee._mdf.m && (this.isMasked ? Be.setAttribute("transform", Ee.m) : (Be.style.webkitTransform = Ee.m, Be.style.transform = Ee.m)), Be.style.opacity = Ee.o, Ee.sw && Ee._mdf.sw && $e.setAttribute("stroke-width", Ee.sw), Ee.sc && Ee._mdf.sc && $e.setAttribute("stroke", Ee.sc), Ee.fc && Ee._mdf.fc && ($e.setAttribute("fill", Ee.fc), $e.style.color = Ee.fc));
          if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
            var Le = this.innerElem.getBBox();
            this.currentBBox.w !== Le.width && (this.currentBBox.w = Le.width, this.svgElement.setAttribute("width", Le.width)), this.currentBBox.h !== Le.height && (this.currentBBox.h = Le.height, this.svgElement.setAttribute("height", Le.height));
            var Fe = 1;
            if (this.currentBBox.w !== Le.width + Fe * 2 || this.currentBBox.h !== Le.height + Fe * 2 || this.currentBBox.x !== Le.x - Fe || this.currentBBox.y !== Le.y - Fe) {
              this.currentBBox.w = Le.width + Fe * 2, this.currentBBox.h = Le.height + Fe * 2, this.currentBBox.x = Le.x - Fe, this.currentBBox.y = Le.y - Fe, this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h), e = this.svgElement.style;
              var Ve = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
              e.transform = Ve, e.webkitTransform = Ve;
            }
          }
        }
      };
      function HCameraElement(e, j, ke) {
        this.initFrame(), this.initBaseData(e, j, ke), this.initHierarchy();
        var Se = PropertyFactory.getProp;
        if (this.pe = Se(this, e.pe, 0, 0, this), e.ks.p.s ? (this.px = Se(this, e.ks.p.x, 1, 0, this), this.py = Se(this, e.ks.p.y, 1, 0, this), this.pz = Se(this, e.ks.p.z, 1, 0, this)) : this.p = Se(this, e.ks.p, 1, 0, this), e.ks.a && (this.a = Se(this, e.ks.a, 1, 0, this)), e.ks.or.k.length && e.ks.or.k[0].to) {
          var xe, Ie = e.ks.or.k.length;
          for (xe = 0; xe < Ie; xe += 1)
            e.ks.or.k[xe].to = null, e.ks.or.k[xe].ti = null;
        }
        this.or = Se(this, e.ks.or, 1, degToRads, this), this.or.sh = !0, this.rx = Se(this, e.ks.rx, 0, degToRads, this), this.ry = Se(this, e.ks.ry, 0, degToRads, this), this.rz = Se(this, e.ks.rz, 0, degToRads, this), this.mat = new Matrix(), this._prevMat = new Matrix(), this._isFirstFrame = !0, this.finalTransform = {
          mProp: this
        };
      }
      extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement), HCameraElement.prototype.setup = function() {
        var e, j = this.comp.threeDElements.length, ke, Se, xe;
        for (e = 0; e < j; e += 1)
          if (ke = this.comp.threeDElements[e], ke.type === "3d") {
            Se = ke.perspectiveElem.style, xe = ke.container.style;
            var Ie = this.pe.v + "px", Me = "0px 0px 0px", Ee = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
            Se.perspective = Ie, Se.webkitPerspective = Ie, xe.transformOrigin = Me, xe.mozTransformOrigin = Me, xe.webkitTransformOrigin = Me, Se.transform = Ee, Se.webkitTransform = Ee;
          }
      }, HCameraElement.prototype.createElements = function() {
      }, HCameraElement.prototype.hide = function() {
      }, HCameraElement.prototype.renderFrame = function() {
        var e = this._isFirstFrame, j, ke;
        if (this.hierarchy)
          for (ke = this.hierarchy.length, j = 0; j < ke; j += 1)
            e = this.hierarchy[j].finalTransform.mProp._mdf || e;
        if (e || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
          if (this.mat.reset(), this.hierarchy)
            for (ke = this.hierarchy.length - 1, j = ke; j >= 0; j -= 1) {
              var Se = this.hierarchy[j].finalTransform.mProp;
              this.mat.translate(-Se.p.v[0], -Se.p.v[1], Se.p.v[2]), this.mat.rotateX(-Se.or.v[0]).rotateY(-Se.or.v[1]).rotateZ(Se.or.v[2]), this.mat.rotateX(-Se.rx.v).rotateY(-Se.ry.v).rotateZ(Se.rz.v), this.mat.scale(1 / Se.s.v[0], 1 / Se.s.v[1], 1 / Se.s.v[2]), this.mat.translate(Se.a.v[0], Se.a.v[1], Se.a.v[2]);
            }
          if (this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v), this.a) {
            var xe;
            this.p ? xe = [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]] : xe = [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
            var Ie = Math.sqrt(Math.pow(xe[0], 2) + Math.pow(xe[1], 2) + Math.pow(xe[2], 2)), Me = [xe[0] / Ie, xe[1] / Ie, xe[2] / Ie], Ee = Math.sqrt(Me[2] * Me[2] + Me[0] * Me[0]), Be = Math.atan2(Me[1], Ee), $e = Math.atan2(Me[0], -Me[2]);
            this.mat.rotateY($e).rotateX(-Be);
          }
          this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]), this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0), this.mat.translate(0, 0, this.pe.v);
          var Le = !this._prevMat.equals(this.mat);
          if ((Le || this.pe._mdf) && this.comp.threeDElements) {
            ke = this.comp.threeDElements.length;
            var Fe, Ve, je;
            for (j = 0; j < ke; j += 1)
              if (Fe = this.comp.threeDElements[j], Fe.type === "3d") {
                if (Le) {
                  var Ge = this.mat.toCSS();
                  je = Fe.container.style, je.transform = Ge, je.webkitTransform = Ge;
                }
                this.pe._mdf && (Ve = Fe.perspectiveElem.style, Ve.perspective = this.pe.v + "px", Ve.webkitPerspective = this.pe.v + "px");
              }
            this.mat.clone(this._prevMat);
          }
        }
        this._isFirstFrame = !1;
      }, HCameraElement.prototype.prepareFrame = function(e) {
        this.prepareProperties(e, !0);
      }, HCameraElement.prototype.destroy = function() {
      }, HCameraElement.prototype.getBaseElement = function() {
        return null;
      };
      function HImageElement(e, j, ke) {
        this.assetData = j.getAssetData(e.refId), this.initElement(e, j, ke);
      }
      extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement), HImageElement.prototype.createContent = function() {
        var e = this.globalData.getAssetsPath(this.assetData), j = new Image();
        this.data.hasMask ? (this.imageElem = createNS("image"), this.imageElem.setAttribute("width", this.assetData.w + "px"), this.imageElem.setAttribute("height", this.assetData.h + "px"), this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", e), this.layerElement.appendChild(this.imageElem), this.baseElement.setAttribute("width", this.assetData.w), this.baseElement.setAttribute("height", this.assetData.h)) : this.layerElement.appendChild(j), j.crossOrigin = "anonymous", j.src = e, this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
      };
      function HybridRendererBase(e, j) {
        this.animationItem = e, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
          className: j && j.className || "",
          imagePreserveAspectRatio: j && j.imagePreserveAspectRatio || "xMidYMid slice",
          hideOnTransparent: !(j && j.hideOnTransparent === !1),
          filterSize: {
            width: j && j.filterSize && j.filterSize.width || "400%",
            height: j && j.filterSize && j.filterSize.height || "400%",
            x: j && j.filterSize && j.filterSize.x || "-100%",
            y: j && j.filterSize && j.filterSize.y || "-100%"
          }
        }, this.globalData = {
          _mdf: !1,
          frameNum: -1,
          renderConfig: this.renderConfig
        }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
      }
      extendPrototype([BaseRenderer], HybridRendererBase), HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem, HybridRendererBase.prototype.checkPendingElements = function() {
        for (; this.pendingElements.length; ) {
          var e = this.pendingElements.pop();
          e.checkParenting();
        }
      }, HybridRendererBase.prototype.appendElementInPos = function(e, j) {
        var ke = e.getBaseElement();
        if (ke) {
          var Se = this.layers[j];
          if (!Se.ddd || !this.supports3d)
            if (this.threeDElements)
              this.addTo3dContainer(ke, j);
            else {
              for (var xe = 0, Ie, Me, Ee; xe < j; )
                this.elements[xe] && this.elements[xe] !== !0 && this.elements[xe].getBaseElement && (Me = this.elements[xe], Ee = this.layers[xe].ddd ? this.getThreeDContainerByPos(xe) : Me.getBaseElement(), Ie = Ee || Ie), xe += 1;
              Ie ? (!Se.ddd || !this.supports3d) && this.layerElement.insertBefore(ke, Ie) : (!Se.ddd || !this.supports3d) && this.layerElement.appendChild(ke);
            }
          else
            this.addTo3dContainer(ke, j);
        }
      }, HybridRendererBase.prototype.createShape = function(e) {
        return this.supports3d ? new HShapeElement(e, this.globalData, this) : new SVGShapeElement(e, this.globalData, this);
      }, HybridRendererBase.prototype.createText = function(e) {
        return this.supports3d ? new HTextElement(e, this.globalData, this) : new SVGTextLottieElement(e, this.globalData, this);
      }, HybridRendererBase.prototype.createCamera = function(e) {
        return this.camera = new HCameraElement(e, this.globalData, this), this.camera;
      }, HybridRendererBase.prototype.createImage = function(e) {
        return this.supports3d ? new HImageElement(e, this.globalData, this) : new IImageElement(e, this.globalData, this);
      }, HybridRendererBase.prototype.createSolid = function(e) {
        return this.supports3d ? new HSolidElement(e, this.globalData, this) : new ISolidElement(e, this.globalData, this);
      }, HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, HybridRendererBase.prototype.getThreeDContainerByPos = function(e) {
        for (var j = 0, ke = this.threeDElements.length; j < ke; ) {
          if (this.threeDElements[j].startPos <= e && this.threeDElements[j].endPos >= e)
            return this.threeDElements[j].perspectiveElem;
          j += 1;
        }
        return null;
      }, HybridRendererBase.prototype.createThreeDContainer = function(e, j) {
        var ke = createTag("div"), Se, xe;
        styleDiv(ke);
        var Ie = createTag("div");
        if (styleDiv(Ie), j === "3d") {
          Se = ke.style, Se.width = this.globalData.compSize.w + "px", Se.height = this.globalData.compSize.h + "px";
          var Me = "50% 50%";
          Se.webkitTransformOrigin = Me, Se.mozTransformOrigin = Me, Se.transformOrigin = Me, xe = Ie.style;
          var Ee = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
          xe.transform = Ee, xe.webkitTransform = Ee;
        }
        ke.appendChild(Ie);
        var Be = {
          container: Ie,
          perspectiveElem: ke,
          startPos: e,
          endPos: e,
          type: j
        };
        return this.threeDElements.push(Be), Be;
      }, HybridRendererBase.prototype.build3dContainers = function() {
        var e, j = this.layers.length, ke, Se = "";
        for (e = 0; e < j; e += 1)
          this.layers[e].ddd && this.layers[e].ty !== 3 ? (Se !== "3d" && (Se = "3d", ke = this.createThreeDContainer(e, "3d")), ke.endPos = Math.max(ke.endPos, e)) : (Se !== "2d" && (Se = "2d", ke = this.createThreeDContainer(e, "2d")), ke.endPos = Math.max(ke.endPos, e));
        for (j = this.threeDElements.length, e = j - 1; e >= 0; e -= 1)
          this.resizerElem.appendChild(this.threeDElements[e].perspectiveElem);
      }, HybridRendererBase.prototype.addTo3dContainer = function(e, j) {
        for (var ke = 0, Se = this.threeDElements.length; ke < Se; ) {
          if (j <= this.threeDElements[ke].endPos) {
            for (var xe = this.threeDElements[ke].startPos, Ie; xe < j; )
              this.elements[xe] && this.elements[xe].getBaseElement && (Ie = this.elements[xe].getBaseElement()), xe += 1;
            Ie ? this.threeDElements[ke].container.insertBefore(e, Ie) : this.threeDElements[ke].container.appendChild(e);
            break;
          }
          ke += 1;
        }
      }, HybridRendererBase.prototype.configAnimation = function(e) {
        var j = createTag("div"), ke = this.animationItem.wrapper, Se = j.style;
        Se.width = e.w + "px", Se.height = e.h + "px", this.resizerElem = j, styleDiv(j), Se.transformStyle = "flat", Se.mozTransformStyle = "flat", Se.webkitTransformStyle = "flat", this.renderConfig.className && j.setAttribute("class", this.renderConfig.className), ke.appendChild(j), Se.overflow = "hidden";
        var xe = createNS("svg");
        xe.setAttribute("width", "1"), xe.setAttribute("height", "1"), styleDiv(xe), this.resizerElem.appendChild(xe);
        var Ie = createNS("defs");
        xe.appendChild(Ie), this.data = e, this.setupGlobalData(e, xe), this.globalData.defs = Ie, this.layers = e.layers, this.layerElement = this.resizerElem, this.build3dContainers(), this.updateContainerSize();
      }, HybridRendererBase.prototype.destroy = function() {
        this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.animationItem.container = null, this.globalData.defs = null;
        var e, j = this.layers ? this.layers.length : 0;
        for (e = 0; e < j; e += 1)
          this.elements[e] && this.elements[e].destroy && this.elements[e].destroy();
        this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
      }, HybridRendererBase.prototype.updateContainerSize = function() {
        var e = this.animationItem.wrapper.offsetWidth, j = this.animationItem.wrapper.offsetHeight, ke = e / j, Se = this.globalData.compSize.w / this.globalData.compSize.h, xe, Ie, Me, Ee;
        Se > ke ? (xe = e / this.globalData.compSize.w, Ie = e / this.globalData.compSize.w, Me = 0, Ee = (j - this.globalData.compSize.h * (e / this.globalData.compSize.w)) / 2) : (xe = j / this.globalData.compSize.h, Ie = j / this.globalData.compSize.h, Me = (e - this.globalData.compSize.w * (j / this.globalData.compSize.h)) / 2, Ee = 0);
        var Be = this.resizerElem.style;
        Be.webkitTransform = "matrix3d(" + xe + ",0,0,0,0," + Ie + ",0,0,0,0,1,0," + Me + "," + Ee + ",0,1)", Be.transform = Be.webkitTransform;
      }, HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame, HybridRendererBase.prototype.hide = function() {
        this.resizerElem.style.display = "none";
      }, HybridRendererBase.prototype.show = function() {
        this.resizerElem.style.display = "block";
      }, HybridRendererBase.prototype.initItems = function() {
        if (this.buildAllItems(), this.camera)
          this.camera.setup();
        else {
          var e = this.globalData.compSize.w, j = this.globalData.compSize.h, ke, Se = this.threeDElements.length;
          for (ke = 0; ke < Se; ke += 1) {
            var xe = this.threeDElements[ke].perspectiveElem.style;
            xe.webkitPerspective = Math.sqrt(Math.pow(e, 2) + Math.pow(j, 2)) + "px", xe.perspective = xe.webkitPerspective;
          }
        }
      }, HybridRendererBase.prototype.searchExtraCompositions = function(e) {
        var j, ke = e.length, Se = createTag("div");
        for (j = 0; j < ke; j += 1)
          if (e[j].xt) {
            var xe = this.createComp(e[j], Se, this.globalData.comp, null);
            xe.initExpressions(), this.globalData.projectInterface.registerComposition(xe);
          }
      };
      function HCompElement(e, j, ke) {
        this.layers = e.layers, this.supports3d = !e.hasMask, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(e, j, ke), this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, j.frameRate, this) : {
          _placeholder: !0
        };
      }
      extendPrototype([HybridRendererBase, ICompElement, HBaseElement], HCompElement), HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements, HCompElement.prototype.createContainerElements = function() {
        this._createBaseContainerElements(), this.data.hasMask ? (this.svgElement.setAttribute("width", this.data.w), this.svgElement.setAttribute("height", this.data.h), this.transformedElement = this.baseElement) : this.transformedElement = this.layerElement;
      }, HCompElement.prototype.addTo3dContainer = function(e, j) {
        for (var ke = 0, Se; ke < j; )
          this.elements[ke] && this.elements[ke].getBaseElement && (Se = this.elements[ke].getBaseElement()), ke += 1;
        Se ? this.layerElement.insertBefore(e, Se) : this.layerElement.appendChild(e);
      }, HCompElement.prototype.createComp = function(e) {
        return this.supports3d ? new HCompElement(e, this.globalData, this) : new SVGCompElement(e, this.globalData, this);
      };
      function HybridRenderer(e, j) {
        this.animationItem = e, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
          className: j && j.className || "",
          imagePreserveAspectRatio: j && j.imagePreserveAspectRatio || "xMidYMid slice",
          hideOnTransparent: !(j && j.hideOnTransparent === !1),
          filterSize: {
            width: j && j.filterSize && j.filterSize.width || "400%",
            height: j && j.filterSize && j.filterSize.height || "400%",
            x: j && j.filterSize && j.filterSize.x || "-100%",
            y: j && j.filterSize && j.filterSize.y || "-100%"
          },
          runExpressions: !j || j.runExpressions === void 0 || j.runExpressions
        }, this.globalData = {
          _mdf: !1,
          frameNum: -1,
          renderConfig: this.renderConfig
        }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
      }
      extendPrototype([HybridRendererBase], HybridRenderer), HybridRenderer.prototype.createComp = function(e) {
        return this.supports3d ? new HCompElement(e, this.globalData, this) : new SVGCompElement(e, this.globalData, this);
      };
      var CompExpressionInterface = /* @__PURE__ */ function() {
        return function(e) {
          function j(ke) {
            for (var Se = 0, xe = e.layers.length; Se < xe; ) {
              if (e.layers[Se].nm === ke || e.layers[Se].ind === ke)
                return e.elements[Se].layerInterface;
              Se += 1;
            }
            return null;
          }
          return Object.defineProperty(j, "_name", {
            value: e.data.nm
          }), j.layer = j, j.pixelAspect = 1, j.height = e.data.h || e.globalData.compSize.h, j.width = e.data.w || e.globalData.compSize.w, j.pixelAspect = 1, j.frameDuration = 1 / e.globalData.frameRate, j.displayStartTime = 0, j.numLayers = e.layers.length, j;
        };
      }();
      function _typeof$2(e) {
        "@babel/helpers - typeof";
        return _typeof$2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(j) {
          return typeof j;
        } : function(j) {
          return j && typeof Symbol == "function" && j.constructor === Symbol && j !== Symbol.prototype ? "symbol" : typeof j;
        }, _typeof$2(e);
      }
      function seedRandom(e, j) {
        var ke = this, Se = 256, xe = 6, Ie = 52, Me = "random", Ee = j.pow(Se, xe), Be = j.pow(2, Ie), $e = Be * 2, Le = Se - 1, Fe;
        function Ve(We, qe, Je) {
          var Ke = [];
          qe = qe === !0 ? {
            entropy: !0
          } : qe || {};
          var xt = Ue(De(qe.entropy ? [We, Ye(e)] : We === null ? Re() : We, 3), Ke), Ct = new je(Ke), It = function() {
            for (var Bt = Ct.g(xe), At = Ee, Ft = 0; Bt < Be; )
              Bt = (Bt + Ft) * Se, At *= Se, Ft = Ct.g(1);
            for (; Bt >= $e; )
              Bt /= 2, At /= 2, Ft >>>= 1;
            return (Bt + Ft) / At;
          };
          return It.int32 = function() {
            return Ct.g(4) | 0;
          }, It.quick = function() {
            return Ct.g(4) / 4294967296;
          }, It.double = It, Ue(Ye(Ct.S), e), (qe.pass || Je || function(Nt, Bt, At, Ft) {
            return Ft && (Ft.S && Ge(Ft, Ct), Nt.state = function() {
              return Ge(Ct, {});
            }), At ? (j[Me] = Nt, Bt) : Nt;
          })(It, xt, "global" in qe ? qe.global : this == j, qe.state);
        }
        j["seed" + Me] = Ve;
        function je(We) {
          var qe, Je = We.length, Ke = this, xt = 0, Ct = Ke.i = Ke.j = 0, It = Ke.S = [];
          for (Je || (We = [Je++]); xt < Se; )
            It[xt] = xt++;
          for (xt = 0; xt < Se; xt++)
            It[xt] = It[Ct = Le & Ct + We[xt % Je] + (qe = It[xt])], It[Ct] = qe;
          Ke.g = function(Nt) {
            for (var Bt, At = 0, Ft = Ke.i, Dt = Ke.j, zt = Ke.S; Nt--; )
              Bt = zt[Ft = Le & Ft + 1], At = At * Se + zt[Le & (zt[Ft] = zt[Dt = Le & Dt + Bt]) + (zt[Dt] = Bt)];
            return Ke.i = Ft, Ke.j = Dt, At;
          };
        }
        function Ge(We, qe) {
          return qe.i = We.i, qe.j = We.j, qe.S = We.S.slice(), qe;
        }
        function De(We, qe) {
          var Je = [], Ke = _typeof$2(We), xt;
          if (qe && Ke == "object")
            for (xt in We)
              try {
                Je.push(De(We[xt], qe - 1));
              } catch {
              }
          return Je.length ? Je : Ke == "string" ? We : We + "\0";
        }
        function Ue(We, qe) {
          for (var Je = We + "", Ke, xt = 0; xt < Je.length; )
            qe[Le & xt] = Le & (Ke ^= qe[Le & xt] * 19) + Je.charCodeAt(xt++);
          return Ye(qe);
        }
        function Re() {
          try {
            var We = new Uint8Array(Se);
            return (ke.crypto || ke.msCrypto).getRandomValues(We), Ye(We);
          } catch {
            var qe = ke.navigator, Je = qe && qe.plugins;
            return [+/* @__PURE__ */ new Date(), ke, Je, ke.screen, Ye(e)];
          }
        }
        function Ye(We) {
          return String.fromCharCode.apply(0, We);
        }
        Ue(j.random(), e);
      }
      function initialize$2(e) {
        seedRandom([], e);
      }
      var propTypes = {
        SHAPE: "shape"
      };
      function _typeof$1(e) {
        "@babel/helpers - typeof";
        return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(j) {
          return typeof j;
        } : function(j) {
          return j && typeof Symbol == "function" && j.constructor === Symbol && j !== Symbol.prototype ? "symbol" : typeof j;
        }, _typeof$1(e);
      }
      var ExpressionManager = function() {
        var ob = {}, Math = BMMath, window = null, document = null, XMLHttpRequest = null, fetch = null, frames = null, _lottieGlobal = {};
        initialize$2(BMMath);
        function resetFrame() {
          _lottieGlobal = {};
        }
        function $bm_isInstanceOfArray(e) {
          return e.constructor === Array || e.constructor === Float32Array;
        }
        function isNumerable(e, j) {
          return e === "number" || j instanceof Number || e === "boolean" || e === "string";
        }
        function $bm_neg(e) {
          var j = _typeof$1(e);
          if (j === "number" || e instanceof Number || j === "boolean")
            return -e;
          if ($bm_isInstanceOfArray(e)) {
            var ke, Se = e.length, xe = [];
            for (ke = 0; ke < Se; ke += 1)
              xe[ke] = -e[ke];
            return xe;
          }
          return e.propType ? e.v : -e;
        }
        var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, "easeIn").get, easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, "easeOut").get, easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, "easeInOut").get;
        function sum(e, j) {
          var ke = _typeof$1(e), Se = _typeof$1(j);
          if (isNumerable(ke, e) && isNumerable(Se, j) || ke === "string" || Se === "string")
            return e + j;
          if ($bm_isInstanceOfArray(e) && isNumerable(Se, j))
            return e = e.slice(0), e[0] += j, e;
          if (isNumerable(ke, e) && $bm_isInstanceOfArray(j))
            return j = j.slice(0), j[0] = e + j[0], j;
          if ($bm_isInstanceOfArray(e) && $bm_isInstanceOfArray(j)) {
            for (var xe = 0, Ie = e.length, Me = j.length, Ee = []; xe < Ie || xe < Me; )
              (typeof e[xe] == "number" || e[xe] instanceof Number) && (typeof j[xe] == "number" || j[xe] instanceof Number) ? Ee[xe] = e[xe] + j[xe] : Ee[xe] = j[xe] === void 0 ? e[xe] : e[xe] || j[xe], xe += 1;
            return Ee;
          }
          return 0;
        }
        var add = sum;
        function sub(e, j) {
          var ke = _typeof$1(e), Se = _typeof$1(j);
          if (isNumerable(ke, e) && isNumerable(Se, j))
            return ke === "string" && (e = parseInt(e, 10)), Se === "string" && (j = parseInt(j, 10)), e - j;
          if ($bm_isInstanceOfArray(e) && isNumerable(Se, j))
            return e = e.slice(0), e[0] -= j, e;
          if (isNumerable(ke, e) && $bm_isInstanceOfArray(j))
            return j = j.slice(0), j[0] = e - j[0], j;
          if ($bm_isInstanceOfArray(e) && $bm_isInstanceOfArray(j)) {
            for (var xe = 0, Ie = e.length, Me = j.length, Ee = []; xe < Ie || xe < Me; )
              (typeof e[xe] == "number" || e[xe] instanceof Number) && (typeof j[xe] == "number" || j[xe] instanceof Number) ? Ee[xe] = e[xe] - j[xe] : Ee[xe] = j[xe] === void 0 ? e[xe] : e[xe] || j[xe], xe += 1;
            return Ee;
          }
          return 0;
        }
        function mul(e, j) {
          var ke = _typeof$1(e), Se = _typeof$1(j), xe;
          if (isNumerable(ke, e) && isNumerable(Se, j))
            return e * j;
          var Ie, Me;
          if ($bm_isInstanceOfArray(e) && isNumerable(Se, j)) {
            for (Me = e.length, xe = createTypedArray("float32", Me), Ie = 0; Ie < Me; Ie += 1)
              xe[Ie] = e[Ie] * j;
            return xe;
          }
          if (isNumerable(ke, e) && $bm_isInstanceOfArray(j)) {
            for (Me = j.length, xe = createTypedArray("float32", Me), Ie = 0; Ie < Me; Ie += 1)
              xe[Ie] = e * j[Ie];
            return xe;
          }
          return 0;
        }
        function div(e, j) {
          var ke = _typeof$1(e), Se = _typeof$1(j), xe;
          if (isNumerable(ke, e) && isNumerable(Se, j))
            return e / j;
          var Ie, Me;
          if ($bm_isInstanceOfArray(e) && isNumerable(Se, j)) {
            for (Me = e.length, xe = createTypedArray("float32", Me), Ie = 0; Ie < Me; Ie += 1)
              xe[Ie] = e[Ie] / j;
            return xe;
          }
          if (isNumerable(ke, e) && $bm_isInstanceOfArray(j)) {
            for (Me = j.length, xe = createTypedArray("float32", Me), Ie = 0; Ie < Me; Ie += 1)
              xe[Ie] = e / j[Ie];
            return xe;
          }
          return 0;
        }
        function mod(e, j) {
          return typeof e == "string" && (e = parseInt(e, 10)), typeof j == "string" && (j = parseInt(j, 10)), e % j;
        }
        var $bm_sum = sum, $bm_sub = sub, $bm_mul = mul, $bm_div = div, $bm_mod = mod;
        function clamp(e, j, ke) {
          if (j > ke) {
            var Se = ke;
            ke = j, j = Se;
          }
          return Math.min(Math.max(e, j), ke);
        }
        function radiansToDegrees(e) {
          return e / degToRads;
        }
        var radians_to_degrees = radiansToDegrees;
        function degreesToRadians(e) {
          return e * degToRads;
        }
        var degrees_to_radians = radiansToDegrees, helperLengthArray = [0, 0, 0, 0, 0, 0];
        function length(e, j) {
          if (typeof e == "number" || e instanceof Number)
            return j = j || 0, Math.abs(e - j);
          j || (j = helperLengthArray);
          var ke, Se = Math.min(e.length, j.length), xe = 0;
          for (ke = 0; ke < Se; ke += 1)
            xe += Math.pow(j[ke] - e[ke], 2);
          return Math.sqrt(xe);
        }
        function normalize(e) {
          return div(e, length(e));
        }
        function rgbToHsl(e) {
          var j = e[0], ke = e[1], Se = e[2], xe = Math.max(j, ke, Se), Ie = Math.min(j, ke, Se), Me, Ee, Be = (xe + Ie) / 2;
          if (xe === Ie)
            Me = 0, Ee = 0;
          else {
            var $e = xe - Ie;
            switch (Ee = Be > 0.5 ? $e / (2 - xe - Ie) : $e / (xe + Ie), xe) {
              case j:
                Me = (ke - Se) / $e + (ke < Se ? 6 : 0);
                break;
              case ke:
                Me = (Se - j) / $e + 2;
                break;
              case Se:
                Me = (j - ke) / $e + 4;
                break;
            }
            Me /= 6;
          }
          return [Me, Ee, Be, e[3]];
        }
        function hue2rgb(e, j, ke) {
          return ke < 0 && (ke += 1), ke > 1 && (ke -= 1), ke < 1 / 6 ? e + (j - e) * 6 * ke : ke < 1 / 2 ? j : ke < 2 / 3 ? e + (j - e) * (2 / 3 - ke) * 6 : e;
        }
        function hslToRgb(e) {
          var j = e[0], ke = e[1], Se = e[2], xe, Ie, Me;
          if (ke === 0)
            xe = Se, Me = Se, Ie = Se;
          else {
            var Ee = Se < 0.5 ? Se * (1 + ke) : Se + ke - Se * ke, Be = 2 * Se - Ee;
            xe = hue2rgb(Be, Ee, j + 1 / 3), Ie = hue2rgb(Be, Ee, j), Me = hue2rgb(Be, Ee, j - 1 / 3);
          }
          return [xe, Ie, Me, e[3]];
        }
        function linear(e, j, ke, Se, xe) {
          if ((Se === void 0 || xe === void 0) && (Se = j, xe = ke, j = 0, ke = 1), ke < j) {
            var Ie = ke;
            ke = j, j = Ie;
          }
          if (e <= j)
            return Se;
          if (e >= ke)
            return xe;
          var Me = ke === j ? 0 : (e - j) / (ke - j);
          if (!Se.length)
            return Se + (xe - Se) * Me;
          var Ee, Be = Se.length, $e = createTypedArray("float32", Be);
          for (Ee = 0; Ee < Be; Ee += 1)
            $e[Ee] = Se[Ee] + (xe[Ee] - Se[Ee]) * Me;
          return $e;
        }
        function random(e, j) {
          if (j === void 0 && (e === void 0 ? (e = 0, j = 1) : (j = e, e = void 0)), j.length) {
            var ke, Se = j.length;
            e || (e = createTypedArray("float32", Se));
            var xe = createTypedArray("float32", Se), Ie = BMMath.random();
            for (ke = 0; ke < Se; ke += 1)
              xe[ke] = e[ke] + Ie * (j[ke] - e[ke]);
            return xe;
          }
          e === void 0 && (e = 0);
          var Me = BMMath.random();
          return e + Me * (j - e);
        }
        function createPath(e, j, ke, Se) {
          var xe, Ie = e.length, Me = shapePool.newElement();
          Me.setPathData(!!Se, Ie);
          var Ee = [0, 0], Be, $e;
          for (xe = 0; xe < Ie; xe += 1)
            Be = j && j[xe] ? j[xe] : Ee, $e = ke && ke[xe] ? ke[xe] : Ee, Me.setTripleAt(e[xe][0], e[xe][1], $e[0] + e[xe][0], $e[1] + e[xe][1], Be[0] + e[xe][0], Be[1] + e[xe][1], xe, !0);
          return Me;
        }
        function initiateExpression(elem, data, property) {
          function noOp(e) {
            return e;
          }
          if (!elem.globalData.renderConfig.runExpressions)
            return noOp;
          var val = data.x, needsVelocity = /velocity(?![\w\d])/.test(val), _needsRandom = val.indexOf("random") !== -1, elemType = elem.data.ty, transform, $bm_transform, content, effect, thisProperty = property;
          thisProperty._name = elem.data.nm, thisProperty.valueAtTime = thisProperty.getValueAtTime, Object.defineProperty(thisProperty, "value", {
            get: function() {
              return thisProperty.v;
            }
          }), elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate, elem.comp.displayStartTime = 0;
          var inPoint = elem.data.ip / elem.comp.globalData.frameRate, outPoint = elem.data.op / elem.comp.globalData.frameRate, width = elem.data.sw ? elem.data.sw : 0, height = elem.data.sh ? elem.data.sh : 0, name = elem.data.nm, loopIn, loop_in, loopOut, loop_out, smooth, toWorld, fromWorld, fromComp, toComp, fromCompToSurface, position, rotation, anchorPoint, scale, thisLayer, thisComp, mask, valueAtTime, velocityAtTime, scoped_bm_rt, expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0], numKeys = property.kf ? data.k.length : 0, active = !this.data || this.data.hd !== !0, wiggle = (function e(j, ke) {
            var Se, xe, Ie = this.pv.length ? this.pv.length : 1, Me = createTypedArray("float32", Ie);
            j = 5;
            var Ee = Math.floor(time * j);
            for (Se = 0, xe = 0; Se < Ee; ) {
              for (xe = 0; xe < Ie; xe += 1)
                Me[xe] += -ke + ke * 2 * BMMath.random();
              Se += 1;
            }
            var Be = time * j, $e = Be - Math.floor(Be), Le = createTypedArray("float32", Ie);
            if (Ie > 1) {
              for (xe = 0; xe < Ie; xe += 1)
                Le[xe] = this.pv[xe] + Me[xe] + (-ke + ke * 2 * BMMath.random()) * $e;
              return Le;
            }
            return this.pv + Me[0] + (-ke + ke * 2 * BMMath.random()) * $e;
          }).bind(this);
          thisProperty.loopIn && (loopIn = thisProperty.loopIn.bind(thisProperty), loop_in = loopIn), thisProperty.loopOut && (loopOut = thisProperty.loopOut.bind(thisProperty), loop_out = loopOut), thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty));
          function loopInDuration(e, j) {
            return loopIn(e, j, !0);
          }
          function loopOutDuration(e, j) {
            return loopOut(e, j, !0);
          }
          this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)), this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
          var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
          function lookAt(e, j) {
            var ke = [j[0] - e[0], j[1] - e[1], j[2] - e[2]], Se = Math.atan2(ke[0], Math.sqrt(ke[1] * ke[1] + ke[2] * ke[2])) / degToRads, xe = -Math.atan2(ke[1], ke[2]) / degToRads;
            return [xe, Se, 0];
          }
          function easeOut(e, j, ke, Se, xe) {
            return applyEase(easeOutBez, e, j, ke, Se, xe);
          }
          function easeIn(e, j, ke, Se, xe) {
            return applyEase(easeInBez, e, j, ke, Se, xe);
          }
          function ease(e, j, ke, Se, xe) {
            return applyEase(easeInOutBez, e, j, ke, Se, xe);
          }
          function applyEase(e, j, ke, Se, xe, Ie) {
            xe === void 0 ? (xe = ke, Ie = Se) : j = (j - ke) / (Se - ke), j > 1 ? j = 1 : j < 0 && (j = 0);
            var Me = e(j);
            if ($bm_isInstanceOfArray(xe)) {
              var Ee, Be = xe.length, $e = createTypedArray("float32", Be);
              for (Ee = 0; Ee < Be; Ee += 1)
                $e[Ee] = (Ie[Ee] - xe[Ee]) * Me + xe[Ee];
              return $e;
            }
            return (Ie - xe) * Me + xe;
          }
          function nearestKey(e) {
            var j, ke = data.k.length, Se, xe;
            if (!data.k.length || typeof data.k[0] == "number")
              Se = 0, xe = 0;
            else if (Se = -1, e *= elem.comp.globalData.frameRate, e < data.k[0].t)
              Se = 1, xe = data.k[0].t;
            else {
              for (j = 0; j < ke - 1; j += 1)
                if (e === data.k[j].t) {
                  Se = j + 1, xe = data.k[j].t;
                  break;
                } else if (e > data.k[j].t && e < data.k[j + 1].t) {
                  e - data.k[j].t > data.k[j + 1].t - e ? (Se = j + 2, xe = data.k[j + 1].t) : (Se = j + 1, xe = data.k[j].t);
                  break;
                }
              Se === -1 && (Se = j + 1, xe = data.k[j].t);
            }
            var Ie = {};
            return Ie.index = Se, Ie.time = xe / elem.comp.globalData.frameRate, Ie;
          }
          function key(e) {
            var j, ke, Se;
            if (!data.k.length || typeof data.k[0] == "number")
              throw new Error("The property has no keyframe at index " + e);
            e -= 1, j = {
              time: data.k[e].t / elem.comp.globalData.frameRate,
              value: []
            };
            var xe = Object.prototype.hasOwnProperty.call(data.k[e], "s") ? data.k[e].s : data.k[e - 1].e;
            for (Se = xe.length, ke = 0; ke < Se; ke += 1)
              j[ke] = xe[ke], j.value[ke] = xe[ke];
            return j;
          }
          function framesToTime(e, j) {
            return j || (j = elem.comp.globalData.frameRate), e / j;
          }
          function timeToFrames(e, j) {
            return !e && e !== 0 && (e = time), j || (j = elem.comp.globalData.frameRate), e * j;
          }
          function seedRandom(e) {
            BMMath.seedrandom(randSeed + e);
          }
          function sourceRectAtTime() {
            return elem.sourceRectAtTime();
          }
          function substring(e, j) {
            return typeof value == "string" ? j === void 0 ? value.substring(e) : value.substring(e, j) : "";
          }
          function substr(e, j) {
            return typeof value == "string" ? j === void 0 ? value.substr(e) : value.substr(e, j) : "";
          }
          function posterizeTime(e) {
            time = e === 0 ? 0 : Math.floor(time * e) / e, value = valueAtTime(time);
          }
          var time, velocity, value, text, textIndex, textTotal, selectorValue, index = elem.data.ind, hasParent = !!(elem.hierarchy && elem.hierarchy.length), parent, randSeed = Math.floor(Math.random() * 1e6), globalData = elem.globalData;
          function executeExpression(e) {
            return value = e, this.frameExpressionId === elem.globalData.frameId && this.propType !== "textSelector" ? value : (this.propType === "textSelector" && (textIndex = this.textIndex, textTotal = this.textTotal, selectorValue = this.selectorValue), thisLayer || (text = elem.layerInterface.text, thisLayer = elem.layerInterface, thisComp = elem.comp.compInterface, toWorld = thisLayer.toWorld.bind(thisLayer), fromWorld = thisLayer.fromWorld.bind(thisLayer), fromComp = thisLayer.fromComp.bind(thisLayer), toComp = thisLayer.toComp.bind(thisLayer), mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null, fromCompToSurface = fromComp), transform || (transform = elem.layerInterface("ADBE Transform Group"), $bm_transform = transform, transform && (anchorPoint = transform.anchorPoint)), elemType === 4 && !content && (content = thisLayer("ADBE Root Vectors Group")), effect || (effect = thisLayer(4)), hasParent = !!(elem.hierarchy && elem.hierarchy.length), hasParent && !parent && (parent = elem.hierarchy[0].layerInterface), time = this.comp.renderedFrame / this.comp.globalData.frameRate, _needsRandom && seedRandom(randSeed + time), needsVelocity && (velocity = velocityAtTime(time)), expression_function(), this.frameExpressionId = elem.globalData.frameId, scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt, scoped_bm_rt);
          }
          return executeExpression.__preventDeadCodeRemoval = [$bm_transform, anchorPoint, time, velocity, inPoint, outPoint, width, height, name, loop_in, loop_out, smooth, toComp, fromCompToSurface, toWorld, fromWorld, mask, position, rotation, scale, thisComp, numKeys, active, wiggle, loopInDuration, loopOutDuration, comp, lookAt, easeOut, easeIn, ease, nearestKey, key, text, textIndex, textTotal, selectorValue, framesToTime, timeToFrames, sourceRectAtTime, substring, substr, posterizeTime, index, globalData], executeExpression;
        }
        return ob.initiateExpression = initiateExpression, ob.__preventDeadCodeRemoval = [window, document, XMLHttpRequest, fetch, frames, $bm_neg, add, $bm_sum, $bm_sub, $bm_mul, $bm_div, $bm_mod, clamp, radians_to_degrees, degreesToRadians, degrees_to_radians, normalize, rgbToHsl, hslToRgb, linear, random, createPath, _lottieGlobal], ob.resetFrame = resetFrame, ob;
      }(), Expressions = function() {
        var e = {};
        e.initExpressions = j, e.resetFrame = ExpressionManager.resetFrame;
        function j(ke) {
          var Se = 0, xe = [];
          function Ie() {
            Se += 1;
          }
          function Me() {
            Se -= 1, Se === 0 && Be();
          }
          function Ee($e) {
            xe.indexOf($e) === -1 && xe.push($e);
          }
          function Be() {
            var $e, Le = xe.length;
            for ($e = 0; $e < Le; $e += 1)
              xe[$e].release();
            xe.length = 0;
          }
          ke.renderer.compInterface = CompExpressionInterface(ke.renderer), ke.renderer.globalData.projectInterface.registerComposition(ke.renderer), ke.renderer.globalData.pushExpression = Ie, ke.renderer.globalData.popExpression = Me, ke.renderer.globalData.registerExpressionProperty = Ee;
        }
        return e;
      }(), MaskManagerInterface = function() {
        function e(ke, Se) {
          this._mask = ke, this._data = Se;
        }
        Object.defineProperty(e.prototype, "maskPath", {
          get: function() {
            return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
          }
        }), Object.defineProperty(e.prototype, "maskOpacity", {
          get: function() {
            return this._mask.op.k && this._mask.op.getValue(), this._mask.op.v * 100;
          }
        });
        var j = function(Se) {
          var xe = createSizedArray(Se.viewData.length), Ie, Me = Se.viewData.length;
          for (Ie = 0; Ie < Me; Ie += 1)
            xe[Ie] = new e(Se.viewData[Ie], Se.masksProperties[Ie]);
          var Ee = function($e) {
            for (Ie = 0; Ie < Me; ) {
              if (Se.masksProperties[Ie].nm === $e)
                return xe[Ie];
              Ie += 1;
            }
            return null;
          };
          return Ee;
        };
        return j;
      }(), ExpressionPropertyInterface = /* @__PURE__ */ function() {
        var e = {
          pv: 0,
          v: 0,
          mult: 1
        }, j = {
          pv: [0, 0, 0],
          v: [0, 0, 0],
          mult: 1
        };
        function ke(Me, Ee, Be) {
          Object.defineProperty(Me, "velocity", {
            get: function() {
              return Ee.getVelocityAtTime(Ee.comp.currentFrame);
            }
          }), Me.numKeys = Ee.keyframes ? Ee.keyframes.length : 0, Me.key = function($e) {
            if (!Me.numKeys)
              return 0;
            var Le = "";
            "s" in Ee.keyframes[$e - 1] ? Le = Ee.keyframes[$e - 1].s : "e" in Ee.keyframes[$e - 2] ? Le = Ee.keyframes[$e - 2].e : Le = Ee.keyframes[$e - 2].s;
            var Fe = Be === "unidimensional" ? new Number(Le) : Object.assign({}, Le);
            return Fe.time = Ee.keyframes[$e - 1].t / Ee.elem.comp.globalData.frameRate, Fe.value = Be === "unidimensional" ? Le[0] : Le, Fe;
          }, Me.valueAtTime = Ee.getValueAtTime, Me.speedAtTime = Ee.getSpeedAtTime, Me.velocityAtTime = Ee.getVelocityAtTime, Me.propertyGroup = Ee.propertyGroup;
        }
        function Se(Me) {
          (!Me || !("pv" in Me)) && (Me = e);
          var Ee = 1 / Me.mult, Be = Me.pv * Ee, $e = new Number(Be);
          return $e.value = Be, ke($e, Me, "unidimensional"), function() {
            return Me.k && Me.getValue(), Be = Me.v * Ee, $e.value !== Be && ($e = new Number(Be), $e.value = Be, $e[0] = Be, ke($e, Me, "unidimensional")), $e;
          };
        }
        function xe(Me) {
          (!Me || !("pv" in Me)) && (Me = j);
          var Ee = 1 / Me.mult, Be = Me.data && Me.data.l || Me.pv.length, $e = createTypedArray("float32", Be), Le = createTypedArray("float32", Be);
          return $e.value = Le, ke($e, Me, "multidimensional"), function() {
            Me.k && Me.getValue();
            for (var Fe = 0; Fe < Be; Fe += 1)
              Le[Fe] = Me.v[Fe] * Ee, $e[Fe] = Le[Fe];
            return $e;
          };
        }
        function Ie() {
          return e;
        }
        return function(Me) {
          return Me ? Me.propType === "unidimensional" ? Se(Me) : xe(Me) : Ie;
        };
      }(), TransformExpressionInterface = /* @__PURE__ */ function() {
        return function(e) {
          function j(Me) {
            switch (Me) {
              case "scale":
              case "Scale":
              case "ADBE Scale":
              case 6:
                return j.scale;
              case "rotation":
              case "Rotation":
              case "ADBE Rotation":
              case "ADBE Rotate Z":
              case 10:
                return j.rotation;
              case "ADBE Rotate X":
                return j.xRotation;
              case "ADBE Rotate Y":
                return j.yRotation;
              case "position":
              case "Position":
              case "ADBE Position":
              case 2:
                return j.position;
              case "ADBE Position_0":
                return j.xPosition;
              case "ADBE Position_1":
                return j.yPosition;
              case "ADBE Position_2":
                return j.zPosition;
              case "anchorPoint":
              case "AnchorPoint":
              case "Anchor Point":
              case "ADBE AnchorPoint":
              case 1:
                return j.anchorPoint;
              case "opacity":
              case "Opacity":
              case 11:
                return j.opacity;
              default:
                return null;
            }
          }
          Object.defineProperty(j, "rotation", {
            get: ExpressionPropertyInterface(e.r || e.rz)
          }), Object.defineProperty(j, "zRotation", {
            get: ExpressionPropertyInterface(e.rz || e.r)
          }), Object.defineProperty(j, "xRotation", {
            get: ExpressionPropertyInterface(e.rx)
          }), Object.defineProperty(j, "yRotation", {
            get: ExpressionPropertyInterface(e.ry)
          }), Object.defineProperty(j, "scale", {
            get: ExpressionPropertyInterface(e.s)
          });
          var ke, Se, xe, Ie;
          return e.p ? Ie = ExpressionPropertyInterface(e.p) : (ke = ExpressionPropertyInterface(e.px), Se = ExpressionPropertyInterface(e.py), e.pz && (xe = ExpressionPropertyInterface(e.pz))), Object.defineProperty(j, "position", {
            get: function() {
              return e.p ? Ie() : [ke(), Se(), xe ? xe() : 0];
            }
          }), Object.defineProperty(j, "xPosition", {
            get: ExpressionPropertyInterface(e.px)
          }), Object.defineProperty(j, "yPosition", {
            get: ExpressionPropertyInterface(e.py)
          }), Object.defineProperty(j, "zPosition", {
            get: ExpressionPropertyInterface(e.pz)
          }), Object.defineProperty(j, "anchorPoint", {
            get: ExpressionPropertyInterface(e.a)
          }), Object.defineProperty(j, "opacity", {
            get: ExpressionPropertyInterface(e.o)
          }), Object.defineProperty(j, "skew", {
            get: ExpressionPropertyInterface(e.sk)
          }), Object.defineProperty(j, "skewAxis", {
            get: ExpressionPropertyInterface(e.sa)
          }), Object.defineProperty(j, "orientation", {
            get: ExpressionPropertyInterface(e.or)
          }), j;
        };
      }(), LayerExpressionInterface = /* @__PURE__ */ function() {
        function e($e) {
          var Le = new Matrix();
          if ($e !== void 0) {
            var Fe = this._elem.finalTransform.mProp.getValueAtTime($e);
            Fe.clone(Le);
          } else {
            var Ve = this._elem.finalTransform.mProp;
            Ve.applyToMatrix(Le);
          }
          return Le;
        }
        function j($e, Le) {
          var Fe = this.getMatrix(Le);
          return Fe.props[12] = 0, Fe.props[13] = 0, Fe.props[14] = 0, this.applyPoint(Fe, $e);
        }
        function ke($e, Le) {
          var Fe = this.getMatrix(Le);
          return this.applyPoint(Fe, $e);
        }
        function Se($e, Le) {
          var Fe = this.getMatrix(Le);
          return Fe.props[12] = 0, Fe.props[13] = 0, Fe.props[14] = 0, this.invertPoint(Fe, $e);
        }
        function xe($e, Le) {
          var Fe = this.getMatrix(Le);
          return this.invertPoint(Fe, $e);
        }
        function Ie($e, Le) {
          if (this._elem.hierarchy && this._elem.hierarchy.length) {
            var Fe, Ve = this._elem.hierarchy.length;
            for (Fe = 0; Fe < Ve; Fe += 1)
              this._elem.hierarchy[Fe].finalTransform.mProp.applyToMatrix($e);
          }
          return $e.applyToPointArray(Le[0], Le[1], Le[2] || 0);
        }
        function Me($e, Le) {
          if (this._elem.hierarchy && this._elem.hierarchy.length) {
            var Fe, Ve = this._elem.hierarchy.length;
            for (Fe = 0; Fe < Ve; Fe += 1)
              this._elem.hierarchy[Fe].finalTransform.mProp.applyToMatrix($e);
          }
          return $e.inversePoint(Le);
        }
        function Ee($e) {
          var Le = new Matrix();
          if (Le.reset(), this._elem.finalTransform.mProp.applyToMatrix(Le), this._elem.hierarchy && this._elem.hierarchy.length) {
            var Fe, Ve = this._elem.hierarchy.length;
            for (Fe = 0; Fe < Ve; Fe += 1)
              this._elem.hierarchy[Fe].finalTransform.mProp.applyToMatrix(Le);
            return Le.inversePoint($e);
          }
          return Le.inversePoint($e);
        }
        function Be() {
          return [1, 1, 1, 1];
        }
        return function($e) {
          var Le;
          function Fe(De) {
            je.mask = new MaskManagerInterface(De, $e);
          }
          function Ve(De) {
            je.effect = De;
          }
          function je(De) {
            switch (De) {
              case "ADBE Root Vectors Group":
              case "Contents":
              case 2:
                return je.shapeInterface;
              case 1:
              case 6:
              case "Transform":
              case "transform":
              case "ADBE Transform Group":
                return Le;
              case 4:
              case "ADBE Effect Parade":
              case "effects":
              case "Effects":
                return je.effect;
              case "ADBE Text Properties":
                return je.textInterface;
              default:
                return null;
            }
          }
          je.getMatrix = e, je.invertPoint = Me, je.applyPoint = Ie, je.toWorld = ke, je.toWorldVec = j, je.fromWorld = xe, je.fromWorldVec = Se, je.toComp = ke, je.fromComp = Ee, je.sampleImage = Be, je.sourceRectAtTime = $e.sourceRectAtTime.bind($e), je._elem = $e, Le = TransformExpressionInterface($e.finalTransform.mProp);
          var Ge = getDescriptor(Le, "anchorPoint");
          return Object.defineProperties(je, {
            hasParent: {
              get: function() {
                return $e.hierarchy.length;
              }
            },
            parent: {
              get: function() {
                return $e.hierarchy[0].layerInterface;
              }
            },
            rotation: getDescriptor(Le, "rotation"),
            scale: getDescriptor(Le, "scale"),
            position: getDescriptor(Le, "position"),
            opacity: getDescriptor(Le, "opacity"),
            anchorPoint: Ge,
            anchor_point: Ge,
            transform: {
              get: function() {
                return Le;
              }
            },
            active: {
              get: function() {
                return $e.isInRange;
              }
            }
          }), je.startTime = $e.data.st, je.index = $e.data.ind, je.source = $e.data.refId, je.height = $e.data.ty === 0 ? $e.data.h : 100, je.width = $e.data.ty === 0 ? $e.data.w : 100, je.inPoint = $e.data.ip / $e.comp.globalData.frameRate, je.outPoint = $e.data.op / $e.comp.globalData.frameRate, je._name = $e.data.nm, je.registerMaskInterface = Fe, je.registerEffectsInterface = Ve, je;
        };
      }(), propertyGroupFactory = /* @__PURE__ */ function() {
        return function(e, j) {
          return function(ke) {
            return ke = ke === void 0 ? 1 : ke, ke <= 0 ? e : j(ke - 1);
          };
        };
      }(), PropertyInterface = /* @__PURE__ */ function() {
        return function(e, j) {
          var ke = {
            _name: e
          };
          function Se(xe) {
            return xe = xe === void 0 ? 1 : xe, xe <= 0 ? ke : j(xe - 1);
          }
          return Se;
        };
      }(), EffectsExpressionInterface = /* @__PURE__ */ function() {
        var e = {
          createEffectsInterface: j
        };
        function j(xe, Ie) {
          if (xe.effectsManager) {
            var Me = [], Ee = xe.data.ef, Be, $e = xe.effectsManager.effectElements.length;
            for (Be = 0; Be < $e; Be += 1)
              Me.push(ke(Ee[Be], xe.effectsManager.effectElements[Be], Ie, xe));
            var Le = xe.data.ef || [], Fe = function(je) {
              for (Be = 0, $e = Le.length; Be < $e; ) {
                if (je === Le[Be].nm || je === Le[Be].mn || je === Le[Be].ix)
                  return Me[Be];
                Be += 1;
              }
              return null;
            };
            return Object.defineProperty(Fe, "numProperties", {
              get: function() {
                return Le.length;
              }
            }), Fe;
          }
          return null;
        }
        function ke(xe, Ie, Me, Ee) {
          function Be(je) {
            for (var Ge = xe.ef, De = 0, Ue = Ge.length; De < Ue; ) {
              if (je === Ge[De].nm || je === Ge[De].mn || je === Ge[De].ix)
                return Ge[De].ty === 5 ? Le[De] : Le[De]();
              De += 1;
            }
            throw new Error();
          }
          var $e = propertyGroupFactory(Be, Me), Le = [], Fe, Ve = xe.ef.length;
          for (Fe = 0; Fe < Ve; Fe += 1)
            xe.ef[Fe].ty === 5 ? Le.push(ke(xe.ef[Fe], Ie.effectElements[Fe], Ie.effectElements[Fe].propertyGroup, Ee)) : Le.push(Se(Ie.effectElements[Fe], xe.ef[Fe].ty, Ee, $e));
          return xe.mn === "ADBE Color Control" && Object.defineProperty(Be, "color", {
            get: function() {
              return Le[0]();
            }
          }), Object.defineProperties(Be, {
            numProperties: {
              get: function() {
                return xe.np;
              }
            },
            _name: {
              value: xe.nm
            },
            propertyGroup: {
              value: $e
            }
          }), Be.enabled = xe.en !== 0, Be.active = Be.enabled, Be;
        }
        function Se(xe, Ie, Me, Ee) {
          var Be = ExpressionPropertyInterface(xe.p);
          function $e() {
            return Ie === 10 ? Me.comp.compInterface(xe.p.v) : Be();
          }
          return xe.p.setGroupProperty && xe.p.setGroupProperty(PropertyInterface("", Ee)), $e;
        }
        return e;
      }(), ShapePathInterface = /* @__PURE__ */ function() {
        return function(j, ke, Se) {
          var xe = ke.sh;
          function Ie(Ee) {
            return Ee === "Shape" || Ee === "shape" || Ee === "Path" || Ee === "path" || Ee === "ADBE Vector Shape" || Ee === 2 ? Ie.path : null;
          }
          var Me = propertyGroupFactory(Ie, Se);
          return xe.setGroupProperty(PropertyInterface("Path", Me)), Object.defineProperties(Ie, {
            path: {
              get: function() {
                return xe.k && xe.getValue(), xe;
              }
            },
            shape: {
              get: function() {
                return xe.k && xe.getValue(), xe;
              }
            },
            _name: {
              value: j.nm
            },
            ix: {
              value: j.ix
            },
            propertyIndex: {
              value: j.ix
            },
            mn: {
              value: j.mn
            },
            propertyGroup: {
              value: Se
            }
          }), Ie;
        };
      }(), ShapeExpressionInterface = /* @__PURE__ */ function() {
        function e(Ge, De, Ue) {
          var Re = [], Ye, We = Ge ? Ge.length : 0;
          for (Ye = 0; Ye < We; Ye += 1)
            Ge[Ye].ty === "gr" ? Re.push(ke(Ge[Ye], De[Ye], Ue)) : Ge[Ye].ty === "fl" ? Re.push(Se(Ge[Ye], De[Ye], Ue)) : Ge[Ye].ty === "st" ? Re.push(Me(Ge[Ye], De[Ye], Ue)) : Ge[Ye].ty === "tm" ? Re.push(Ee(Ge[Ye], De[Ye], Ue)) : Ge[Ye].ty === "tr" || (Ge[Ye].ty === "el" ? Re.push($e(Ge[Ye], De[Ye], Ue)) : Ge[Ye].ty === "sr" ? Re.push(Le(Ge[Ye], De[Ye], Ue)) : Ge[Ye].ty === "sh" ? Re.push(ShapePathInterface(Ge[Ye], De[Ye], Ue)) : Ge[Ye].ty === "rc" ? Re.push(Fe(Ge[Ye], De[Ye], Ue)) : Ge[Ye].ty === "rd" ? Re.push(Ve(Ge[Ye], De[Ye], Ue)) : Ge[Ye].ty === "rp" ? Re.push(je(Ge[Ye], De[Ye], Ue)) : Ge[Ye].ty === "gf" ? Re.push(xe(Ge[Ye], De[Ye], Ue)) : Re.push(Ie(Ge[Ye], De[Ye])));
          return Re;
        }
        function j(Ge, De, Ue) {
          var Re, Ye = function(Je) {
            for (var Ke = 0, xt = Re.length; Ke < xt; ) {
              if (Re[Ke]._name === Je || Re[Ke].mn === Je || Re[Ke].propertyIndex === Je || Re[Ke].ix === Je || Re[Ke].ind === Je)
                return Re[Ke];
              Ke += 1;
            }
            return typeof Je == "number" ? Re[Je - 1] : null;
          };
          Ye.propertyGroup = propertyGroupFactory(Ye, Ue), Re = e(Ge.it, De.it, Ye.propertyGroup), Ye.numProperties = Re.length;
          var We = Be(Ge.it[Ge.it.length - 1], De.it[De.it.length - 1], Ye.propertyGroup);
          return Ye.transform = We, Ye.propertyIndex = Ge.cix, Ye._name = Ge.nm, Ye;
        }
        function ke(Ge, De, Ue) {
          var Re = function(Je) {
            switch (Je) {
              case "ADBE Vectors Group":
              case "Contents":
              case 2:
                return Re.content;
              // Not necessary for now. Keeping them here in case a new case appears
              // case 'ADBE Vector Transform Group':
              // case 3:
              default:
                return Re.transform;
            }
          };
          Re.propertyGroup = propertyGroupFactory(Re, Ue);
          var Ye = j(Ge, De, Re.propertyGroup), We = Be(Ge.it[Ge.it.length - 1], De.it[De.it.length - 1], Re.propertyGroup);
          return Re.content = Ye, Re.transform = We, Object.defineProperty(Re, "_name", {
            get: function() {
              return Ge.nm;
            }
          }), Re.numProperties = Ge.np, Re.propertyIndex = Ge.ix, Re.nm = Ge.nm, Re.mn = Ge.mn, Re;
        }
        function Se(Ge, De, Ue) {
          function Re(Ye) {
            return Ye === "Color" || Ye === "color" ? Re.color : Ye === "Opacity" || Ye === "opacity" ? Re.opacity : null;
          }
          return Object.defineProperties(Re, {
            color: {
              get: ExpressionPropertyInterface(De.c)
            },
            opacity: {
              get: ExpressionPropertyInterface(De.o)
            },
            _name: {
              value: Ge.nm
            },
            mn: {
              value: Ge.mn
            }
          }), De.c.setGroupProperty(PropertyInterface("Color", Ue)), De.o.setGroupProperty(PropertyInterface("Opacity", Ue)), Re;
        }
        function xe(Ge, De, Ue) {
          function Re(Ye) {
            return Ye === "Start Point" || Ye === "start point" ? Re.startPoint : Ye === "End Point" || Ye === "end point" ? Re.endPoint : Ye === "Opacity" || Ye === "opacity" ? Re.opacity : null;
          }
          return Object.defineProperties(Re, {
            startPoint: {
              get: ExpressionPropertyInterface(De.s)
            },
            endPoint: {
              get: ExpressionPropertyInterface(De.e)
            },
            opacity: {
              get: ExpressionPropertyInterface(De.o)
            },
            type: {
              get: function() {
                return "a";
              }
            },
            _name: {
              value: Ge.nm
            },
            mn: {
              value: Ge.mn
            }
          }), De.s.setGroupProperty(PropertyInterface("Start Point", Ue)), De.e.setGroupProperty(PropertyInterface("End Point", Ue)), De.o.setGroupProperty(PropertyInterface("Opacity", Ue)), Re;
        }
        function Ie() {
          function Ge() {
            return null;
          }
          return Ge;
        }
        function Me(Ge, De, Ue) {
          var Re = propertyGroupFactory(xt, Ue), Ye = propertyGroupFactory(Ke, Re);
          function We(Ct) {
            Object.defineProperty(Ke, Ge.d[Ct].nm, {
              get: ExpressionPropertyInterface(De.d.dataProps[Ct].p)
            });
          }
          var qe, Je = Ge.d ? Ge.d.length : 0, Ke = {};
          for (qe = 0; qe < Je; qe += 1)
            We(qe), De.d.dataProps[qe].p.setGroupProperty(Ye);
          function xt(Ct) {
            return Ct === "Color" || Ct === "color" ? xt.color : Ct === "Opacity" || Ct === "opacity" ? xt.opacity : Ct === "Stroke Width" || Ct === "stroke width" ? xt.strokeWidth : null;
          }
          return Object.defineProperties(xt, {
            color: {
              get: ExpressionPropertyInterface(De.c)
            },
            opacity: {
              get: ExpressionPropertyInterface(De.o)
            },
            strokeWidth: {
              get: ExpressionPropertyInterface(De.w)
            },
            dash: {
              get: function() {
                return Ke;
              }
            },
            _name: {
              value: Ge.nm
            },
            mn: {
              value: Ge.mn
            }
          }), De.c.setGroupProperty(PropertyInterface("Color", Re)), De.o.setGroupProperty(PropertyInterface("Opacity", Re)), De.w.setGroupProperty(PropertyInterface("Stroke Width", Re)), xt;
        }
        function Ee(Ge, De, Ue) {
          function Re(We) {
            return We === Ge.e.ix || We === "End" || We === "end" ? Re.end : We === Ge.s.ix ? Re.start : We === Ge.o.ix ? Re.offset : null;
          }
          var Ye = propertyGroupFactory(Re, Ue);
          return Re.propertyIndex = Ge.ix, De.s.setGroupProperty(PropertyInterface("Start", Ye)), De.e.setGroupProperty(PropertyInterface("End", Ye)), De.o.setGroupProperty(PropertyInterface("Offset", Ye)), Re.propertyIndex = Ge.ix, Re.propertyGroup = Ue, Object.defineProperties(Re, {
            start: {
              get: ExpressionPropertyInterface(De.s)
            },
            end: {
              get: ExpressionPropertyInterface(De.e)
            },
            offset: {
              get: ExpressionPropertyInterface(De.o)
            },
            _name: {
              value: Ge.nm
            }
          }), Re.mn = Ge.mn, Re;
        }
        function Be(Ge, De, Ue) {
          function Re(We) {
            return Ge.a.ix === We || We === "Anchor Point" ? Re.anchorPoint : Ge.o.ix === We || We === "Opacity" ? Re.opacity : Ge.p.ix === We || We === "Position" ? Re.position : Ge.r.ix === We || We === "Rotation" || We === "ADBE Vector Rotation" ? Re.rotation : Ge.s.ix === We || We === "Scale" ? Re.scale : Ge.sk && Ge.sk.ix === We || We === "Skew" ? Re.skew : Ge.sa && Ge.sa.ix === We || We === "Skew Axis" ? Re.skewAxis : null;
          }
          var Ye = propertyGroupFactory(Re, Ue);
          return De.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", Ye)), De.transform.mProps.p.setGroupProperty(PropertyInterface("Position", Ye)), De.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", Ye)), De.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", Ye)), De.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", Ye)), De.transform.mProps.sk && (De.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", Ye)), De.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", Ye))), De.transform.op.setGroupProperty(PropertyInterface("Opacity", Ye)), Object.defineProperties(Re, {
            opacity: {
              get: ExpressionPropertyInterface(De.transform.mProps.o)
            },
            position: {
              get: ExpressionPropertyInterface(De.transform.mProps.p)
            },
            anchorPoint: {
              get: ExpressionPropertyInterface(De.transform.mProps.a)
            },
            scale: {
              get: ExpressionPropertyInterface(De.transform.mProps.s)
            },
            rotation: {
              get: ExpressionPropertyInterface(De.transform.mProps.r)
            },
            skew: {
              get: ExpressionPropertyInterface(De.transform.mProps.sk)
            },
            skewAxis: {
              get: ExpressionPropertyInterface(De.transform.mProps.sa)
            },
            _name: {
              value: Ge.nm
            }
          }), Re.ty = "tr", Re.mn = Ge.mn, Re.propertyGroup = Ue, Re;
        }
        function $e(Ge, De, Ue) {
          function Re(qe) {
            return Ge.p.ix === qe ? Re.position : Ge.s.ix === qe ? Re.size : null;
          }
          var Ye = propertyGroupFactory(Re, Ue);
          Re.propertyIndex = Ge.ix;
          var We = De.sh.ty === "tm" ? De.sh.prop : De.sh;
          return We.s.setGroupProperty(PropertyInterface("Size", Ye)), We.p.setGroupProperty(PropertyInterface("Position", Ye)), Object.defineProperties(Re, {
            size: {
              get: ExpressionPropertyInterface(We.s)
            },
            position: {
              get: ExpressionPropertyInterface(We.p)
            },
            _name: {
              value: Ge.nm
            }
          }), Re.mn = Ge.mn, Re;
        }
        function Le(Ge, De, Ue) {
          function Re(qe) {
            return Ge.p.ix === qe ? Re.position : Ge.r.ix === qe ? Re.rotation : Ge.pt.ix === qe ? Re.points : Ge.or.ix === qe || qe === "ADBE Vector Star Outer Radius" ? Re.outerRadius : Ge.os.ix === qe ? Re.outerRoundness : Ge.ir && (Ge.ir.ix === qe || qe === "ADBE Vector Star Inner Radius") ? Re.innerRadius : Ge.is && Ge.is.ix === qe ? Re.innerRoundness : null;
          }
          var Ye = propertyGroupFactory(Re, Ue), We = De.sh.ty === "tm" ? De.sh.prop : De.sh;
          return Re.propertyIndex = Ge.ix, We.or.setGroupProperty(PropertyInterface("Outer Radius", Ye)), We.os.setGroupProperty(PropertyInterface("Outer Roundness", Ye)), We.pt.setGroupProperty(PropertyInterface("Points", Ye)), We.p.setGroupProperty(PropertyInterface("Position", Ye)), We.r.setGroupProperty(PropertyInterface("Rotation", Ye)), Ge.ir && (We.ir.setGroupProperty(PropertyInterface("Inner Radius", Ye)), We.is.setGroupProperty(PropertyInterface("Inner Roundness", Ye))), Object.defineProperties(Re, {
            position: {
              get: ExpressionPropertyInterface(We.p)
            },
            rotation: {
              get: ExpressionPropertyInterface(We.r)
            },
            points: {
              get: ExpressionPropertyInterface(We.pt)
            },
            outerRadius: {
              get: ExpressionPropertyInterface(We.or)
            },
            outerRoundness: {
              get: ExpressionPropertyInterface(We.os)
            },
            innerRadius: {
              get: ExpressionPropertyInterface(We.ir)
            },
            innerRoundness: {
              get: ExpressionPropertyInterface(We.is)
            },
            _name: {
              value: Ge.nm
            }
          }), Re.mn = Ge.mn, Re;
        }
        function Fe(Ge, De, Ue) {
          function Re(qe) {
            return Ge.p.ix === qe ? Re.position : Ge.r.ix === qe ? Re.roundness : Ge.s.ix === qe || qe === "Size" || qe === "ADBE Vector Rect Size" ? Re.size : null;
          }
          var Ye = propertyGroupFactory(Re, Ue), We = De.sh.ty === "tm" ? De.sh.prop : De.sh;
          return Re.propertyIndex = Ge.ix, We.p.setGroupProperty(PropertyInterface("Position", Ye)), We.s.setGroupProperty(PropertyInterface("Size", Ye)), We.r.setGroupProperty(PropertyInterface("Rotation", Ye)), Object.defineProperties(Re, {
            position: {
              get: ExpressionPropertyInterface(We.p)
            },
            roundness: {
              get: ExpressionPropertyInterface(We.r)
            },
            size: {
              get: ExpressionPropertyInterface(We.s)
            },
            _name: {
              value: Ge.nm
            }
          }), Re.mn = Ge.mn, Re;
        }
        function Ve(Ge, De, Ue) {
          function Re(qe) {
            return Ge.r.ix === qe || qe === "Round Corners 1" ? Re.radius : null;
          }
          var Ye = propertyGroupFactory(Re, Ue), We = De;
          return Re.propertyIndex = Ge.ix, We.rd.setGroupProperty(PropertyInterface("Radius", Ye)), Object.defineProperties(Re, {
            radius: {
              get: ExpressionPropertyInterface(We.rd)
            },
            _name: {
              value: Ge.nm
            }
          }), Re.mn = Ge.mn, Re;
        }
        function je(Ge, De, Ue) {
          function Re(qe) {
            return Ge.c.ix === qe || qe === "Copies" ? Re.copies : Ge.o.ix === qe || qe === "Offset" ? Re.offset : null;
          }
          var Ye = propertyGroupFactory(Re, Ue), We = De;
          return Re.propertyIndex = Ge.ix, We.c.setGroupProperty(PropertyInterface("Copies", Ye)), We.o.setGroupProperty(PropertyInterface("Offset", Ye)), Object.defineProperties(Re, {
            copies: {
              get: ExpressionPropertyInterface(We.c)
            },
            offset: {
              get: ExpressionPropertyInterface(We.o)
            },
            _name: {
              value: Ge.nm
            }
          }), Re.mn = Ge.mn, Re;
        }
        return function(Ge, De, Ue) {
          var Re;
          function Ye(qe) {
            if (typeof qe == "number")
              return qe = qe === void 0 ? 1 : qe, qe === 0 ? Ue : Re[qe - 1];
            for (var Je = 0, Ke = Re.length; Je < Ke; ) {
              if (Re[Je]._name === qe)
                return Re[Je];
              Je += 1;
            }
            return null;
          }
          function We() {
            return Ue;
          }
          return Ye.propertyGroup = propertyGroupFactory(Ye, We), Re = e(Ge, De, Ye.propertyGroup), Ye.numProperties = Re.length, Ye._name = "Contents", Ye;
        };
      }(), TextExpressionInterface = /* @__PURE__ */ function() {
        return function(e) {
          var j;
          function ke(Se) {
            switch (Se) {
              case "ADBE Text Document":
                return ke.sourceText;
              default:
                return null;
            }
          }
          return Object.defineProperty(ke, "sourceText", {
            get: function() {
              e.textProperty.getValue();
              var xe = e.textProperty.currentData.t;
              return (!j || xe !== j.value) && (j = new String(xe), j.value = xe || new String(xe), Object.defineProperty(j, "style", {
                get: function() {
                  return {
                    fillColor: e.textProperty.currentData.fc
                  };
                }
              })), j;
            }
          }), ke;
        };
      }();
      function _typeof(e) {
        "@babel/helpers - typeof";
        return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(j) {
          return typeof j;
        } : function(j) {
          return j && typeof Symbol == "function" && j.constructor === Symbol && j !== Symbol.prototype ? "symbol" : typeof j;
        }, _typeof(e);
      }
      var FootageInterface = /* @__PURE__ */ function() {
        var e = function(Se) {
          var xe = "", Ie = Se.getFootageData();
          function Me() {
            return xe = "", Ie = Se.getFootageData(), Ee;
          }
          function Ee(Be) {
            if (Ie[Be])
              return xe = Be, Ie = Ie[Be], _typeof(Ie) === "object" ? Ee : Ie;
            var $e = Be.indexOf(xe);
            if ($e !== -1) {
              var Le = parseInt(Be.substr($e + xe.length), 10);
              return Ie = Ie[Le], _typeof(Ie) === "object" ? Ee : Ie;
            }
            return "";
          }
          return Me;
        }, j = function(Se) {
          function xe(Ie) {
            return Ie === "Outline" ? xe.outlineInterface() : null;
          }
          return xe._name = "Outline", xe.outlineInterface = e(Se), xe;
        };
        return function(ke) {
          function Se(xe) {
            return xe === "Data" ? Se.dataInterface : null;
          }
          return Se._name = "Data", Se.dataInterface = j(ke), Se;
        };
      }(), interfaces = {
        layer: LayerExpressionInterface,
        effects: EffectsExpressionInterface,
        comp: CompExpressionInterface,
        shape: ShapeExpressionInterface,
        text: TextExpressionInterface,
        footage: FootageInterface
      };
      function getInterface(e) {
        return interfaces[e] || null;
      }
      var expressionHelpers = /* @__PURE__ */ function() {
        function e(Me, Ee, Be) {
          Ee.x && (Be.k = !0, Be.x = !0, Be.initiateExpression = ExpressionManager.initiateExpression, Be.effectsSequence.push(Be.initiateExpression(Me, Ee, Be).bind(Be)));
        }
        function j(Me) {
          return Me *= this.elem.globalData.frameRate, Me -= this.offsetTime, Me !== this._cachingAtTime.lastFrame && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < Me ? this._cachingAtTime.lastIndex : 0, this._cachingAtTime.value = this.interpolateValue(Me, this._cachingAtTime), this._cachingAtTime.lastFrame = Me), this._cachingAtTime.value;
        }
        function ke(Me) {
          var Ee = -0.01, Be = this.getValueAtTime(Me), $e = this.getValueAtTime(Me + Ee), Le = 0;
          if (Be.length) {
            var Fe;
            for (Fe = 0; Fe < Be.length; Fe += 1)
              Le += Math.pow($e[Fe] - Be[Fe], 2);
            Le = Math.sqrt(Le) * 100;
          } else
            Le = 0;
          return Le;
        }
        function Se(Me) {
          if (this.vel !== void 0)
            return this.vel;
          var Ee = -1e-3, Be = this.getValueAtTime(Me), $e = this.getValueAtTime(Me + Ee), Le;
          if (Be.length) {
            Le = createTypedArray("float32", Be.length);
            var Fe;
            for (Fe = 0; Fe < Be.length; Fe += 1)
              Le[Fe] = ($e[Fe] - Be[Fe]) / Ee;
          } else
            Le = ($e - Be) / Ee;
          return Le;
        }
        function xe() {
          return this.pv;
        }
        function Ie(Me) {
          this.propertyGroup = Me;
        }
        return {
          searchExpressions: e,
          getSpeedAtTime: ke,
          getVelocityAtTime: Se,
          getValueAtTime: j,
          getStaticValueAtTime: xe,
          setGroupProperty: Ie
        };
      }();
      function addPropertyDecorator() {
        function e(Ve, je, Ge) {
          if (!this.k || !this.keyframes)
            return this.pv;
          Ve = Ve ? Ve.toLowerCase() : "";
          var De = this.comp.renderedFrame, Ue = this.keyframes, Re = Ue[Ue.length - 1].t;
          if (De <= Re)
            return this.pv;
          var Ye, We;
          Ge ? (je ? Ye = Math.abs(Re - this.elem.comp.globalData.frameRate * je) : Ye = Math.max(0, Re - this.elem.data.ip), We = Re - Ye) : ((!je || je > Ue.length - 1) && (je = Ue.length - 1), We = Ue[Ue.length - 1 - je].t, Ye = Re - We);
          var qe, Je, Ke;
          if (Ve === "pingpong") {
            var xt = Math.floor((De - We) / Ye);
            if (xt % 2 !== 0)
              return this.getValueAtTime((Ye - (De - We) % Ye + We) / this.comp.globalData.frameRate, 0);
          } else if (Ve === "offset") {
            var Ct = this.getValueAtTime(We / this.comp.globalData.frameRate, 0), It = this.getValueAtTime(Re / this.comp.globalData.frameRate, 0), Nt = this.getValueAtTime(((De - We) % Ye + We) / this.comp.globalData.frameRate, 0), Bt = Math.floor((De - We) / Ye);
            if (this.pv.length) {
              for (Ke = new Array(Ct.length), Je = Ke.length, qe = 0; qe < Je; qe += 1)
                Ke[qe] = (It[qe] - Ct[qe]) * Bt + Nt[qe];
              return Ke;
            }
            return (It - Ct) * Bt + Nt;
          } else if (Ve === "continue") {
            var At = this.getValueAtTime(Re / this.comp.globalData.frameRate, 0), Ft = this.getValueAtTime((Re - 1e-3) / this.comp.globalData.frameRate, 0);
            if (this.pv.length) {
              for (Ke = new Array(At.length), Je = Ke.length, qe = 0; qe < Je; qe += 1)
                Ke[qe] = At[qe] + (At[qe] - Ft[qe]) * ((De - Re) / this.comp.globalData.frameRate) / 5e-4;
              return Ke;
            }
            return At + (At - Ft) * ((De - Re) / 1e-3);
          }
          return this.getValueAtTime(((De - We) % Ye + We) / this.comp.globalData.frameRate, 0);
        }
        function j(Ve, je, Ge) {
          if (!this.k)
            return this.pv;
          Ve = Ve ? Ve.toLowerCase() : "";
          var De = this.comp.renderedFrame, Ue = this.keyframes, Re = Ue[0].t;
          if (De >= Re)
            return this.pv;
          var Ye, We;
          Ge ? (je ? Ye = Math.abs(this.elem.comp.globalData.frameRate * je) : Ye = Math.max(0, this.elem.data.op - Re), We = Re + Ye) : ((!je || je > Ue.length - 1) && (je = Ue.length - 1), We = Ue[je].t, Ye = We - Re);
          var qe, Je, Ke;
          if (Ve === "pingpong") {
            var xt = Math.floor((Re - De) / Ye);
            if (xt % 2 === 0)
              return this.getValueAtTime(((Re - De) % Ye + Re) / this.comp.globalData.frameRate, 0);
          } else if (Ve === "offset") {
            var Ct = this.getValueAtTime(Re / this.comp.globalData.frameRate, 0), It = this.getValueAtTime(We / this.comp.globalData.frameRate, 0), Nt = this.getValueAtTime((Ye - (Re - De) % Ye + Re) / this.comp.globalData.frameRate, 0), Bt = Math.floor((Re - De) / Ye) + 1;
            if (this.pv.length) {
              for (Ke = new Array(Ct.length), Je = Ke.length, qe = 0; qe < Je; qe += 1)
                Ke[qe] = Nt[qe] - (It[qe] - Ct[qe]) * Bt;
              return Ke;
            }
            return Nt - (It - Ct) * Bt;
          } else if (Ve === "continue") {
            var At = this.getValueAtTime(Re / this.comp.globalData.frameRate, 0), Ft = this.getValueAtTime((Re + 1e-3) / this.comp.globalData.frameRate, 0);
            if (this.pv.length) {
              for (Ke = new Array(At.length), Je = Ke.length, qe = 0; qe < Je; qe += 1)
                Ke[qe] = At[qe] + (At[qe] - Ft[qe]) * (Re - De) / 1e-3;
              return Ke;
            }
            return At + (At - Ft) * (Re - De) / 1e-3;
          }
          return this.getValueAtTime((Ye - ((Re - De) % Ye + Re)) / this.comp.globalData.frameRate, 0);
        }
        function ke(Ve, je) {
          if (!this.k)
            return this.pv;
          if (Ve = (Ve || 0.4) * 0.5, je = Math.floor(je || 5), je <= 1)
            return this.pv;
          var Ge = this.comp.renderedFrame / this.comp.globalData.frameRate, De = Ge - Ve, Ue = Ge + Ve, Re = je > 1 ? (Ue - De) / (je - 1) : 1, Ye = 0, We = 0, qe;
          this.pv.length ? qe = createTypedArray("float32", this.pv.length) : qe = 0;
          for (var Je; Ye < je; ) {
            if (Je = this.getValueAtTime(De + Ye * Re), this.pv.length)
              for (We = 0; We < this.pv.length; We += 1)
                qe[We] += Je[We];
            else
              qe += Je;
            Ye += 1;
          }
          if (this.pv.length)
            for (We = 0; We < this.pv.length; We += 1)
              qe[We] /= je;
          else
            qe /= je;
          return qe;
        }
        function Se(Ve) {
          this._transformCachingAtTime || (this._transformCachingAtTime = {
            v: new Matrix()
          });
          var je = this._transformCachingAtTime.v;
          if (je.cloneFromProps(this.pre.props), this.appliedTransformations < 1) {
            var Ge = this.a.getValueAtTime(Ve);
            je.translate(-Ge[0] * this.a.mult, -Ge[1] * this.a.mult, Ge[2] * this.a.mult);
          }
          if (this.appliedTransformations < 2) {
            var De = this.s.getValueAtTime(Ve);
            je.scale(De[0] * this.s.mult, De[1] * this.s.mult, De[2] * this.s.mult);
          }
          if (this.sk && this.appliedTransformations < 3) {
            var Ue = this.sk.getValueAtTime(Ve), Re = this.sa.getValueAtTime(Ve);
            je.skewFromAxis(-Ue * this.sk.mult, Re * this.sa.mult);
          }
          if (this.r && this.appliedTransformations < 4) {
            var Ye = this.r.getValueAtTime(Ve);
            je.rotate(-Ye * this.r.mult);
          } else if (!this.r && this.appliedTransformations < 4) {
            var We = this.rz.getValueAtTime(Ve), qe = this.ry.getValueAtTime(Ve), Je = this.rx.getValueAtTime(Ve), Ke = this.or.getValueAtTime(Ve);
            je.rotateZ(-We * this.rz.mult).rotateY(qe * this.ry.mult).rotateX(Je * this.rx.mult).rotateZ(-Ke[2] * this.or.mult).rotateY(Ke[1] * this.or.mult).rotateX(Ke[0] * this.or.mult);
          }
          if (this.data.p && this.data.p.s) {
            var xt = this.px.getValueAtTime(Ve), Ct = this.py.getValueAtTime(Ve);
            if (this.data.p.z) {
              var It = this.pz.getValueAtTime(Ve);
              je.translate(xt * this.px.mult, Ct * this.py.mult, -It * this.pz.mult);
            } else
              je.translate(xt * this.px.mult, Ct * this.py.mult, 0);
          } else {
            var Nt = this.p.getValueAtTime(Ve);
            je.translate(Nt[0] * this.p.mult, Nt[1] * this.p.mult, -Nt[2] * this.p.mult);
          }
          return je;
        }
        function xe() {
          return this.v.clone(new Matrix());
        }
        var Ie = TransformPropertyFactory.getTransformProperty;
        TransformPropertyFactory.getTransformProperty = function(Ve, je, Ge) {
          var De = Ie(Ve, je, Ge);
          return De.dynamicProperties.length ? De.getValueAtTime = Se.bind(De) : De.getValueAtTime = xe.bind(De), De.setGroupProperty = expressionHelpers.setGroupProperty, De;
        };
        var Me = PropertyFactory.getProp;
        PropertyFactory.getProp = function(Ve, je, Ge, De, Ue) {
          var Re = Me(Ve, je, Ge, De, Ue);
          Re.kf ? Re.getValueAtTime = expressionHelpers.getValueAtTime.bind(Re) : Re.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(Re), Re.setGroupProperty = expressionHelpers.setGroupProperty, Re.loopOut = e, Re.loopIn = j, Re.smooth = ke, Re.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(Re), Re.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(Re), Re.numKeys = je.a === 1 ? je.k.length : 0, Re.propertyIndex = je.ix;
          var Ye = 0;
          return Ge !== 0 && (Ye = createTypedArray("float32", je.a === 1 ? je.k[0].s.length : je.k.length)), Re._cachingAtTime = {
            lastFrame: initialDefaultFrame,
            lastIndex: 0,
            value: Ye
          }, expressionHelpers.searchExpressions(Ve, je, Re), Re.k && Ue.addDynamicProperty(Re), Re;
        };
        function Ee(Ve) {
          return this._cachingAtTime || (this._cachingAtTime = {
            shapeValue: shapePool.clone(this.pv),
            lastIndex: 0,
            lastTime: initialDefaultFrame
          }), Ve *= this.elem.globalData.frameRate, Ve -= this.offsetTime, Ve !== this._cachingAtTime.lastTime && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < Ve ? this._caching.lastIndex : 0, this._cachingAtTime.lastTime = Ve, this.interpolateShape(Ve, this._cachingAtTime.shapeValue, this._cachingAtTime)), this._cachingAtTime.shapeValue;
        }
        var Be = ShapePropertyFactory.getConstructorFunction(), $e = ShapePropertyFactory.getKeyframedConstructorFunction();
        function Le() {
        }
        Le.prototype = {
          vertices: function(je, Ge) {
            this.k && this.getValue();
            var De = this.v;
            Ge !== void 0 && (De = this.getValueAtTime(Ge, 0));
            var Ue, Re = De._length, Ye = De[je], We = De.v, qe = createSizedArray(Re);
            for (Ue = 0; Ue < Re; Ue += 1)
              je === "i" || je === "o" ? qe[Ue] = [Ye[Ue][0] - We[Ue][0], Ye[Ue][1] - We[Ue][1]] : qe[Ue] = [Ye[Ue][0], Ye[Ue][1]];
            return qe;
          },
          points: function(je) {
            return this.vertices("v", je);
          },
          inTangents: function(je) {
            return this.vertices("i", je);
          },
          outTangents: function(je) {
            return this.vertices("o", je);
          },
          isClosed: function() {
            return this.v.c;
          },
          pointOnPath: function(je, Ge) {
            var De = this.v;
            Ge !== void 0 && (De = this.getValueAtTime(Ge, 0)), this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(De));
            for (var Ue = this._segmentsLength, Re = Ue.lengths, Ye = Ue.totalLength * je, We = 0, qe = Re.length, Je = 0, Ke; We < qe; ) {
              if (Je + Re[We].addedLength > Ye) {
                var xt = We, Ct = De.c && We === qe - 1 ? 0 : We + 1, It = (Ye - Je) / Re[We].addedLength;
                Ke = bez.getPointInSegment(De.v[xt], De.v[Ct], De.o[xt], De.i[Ct], It, Re[We]);
                break;
              } else
                Je += Re[We].addedLength;
              We += 1;
            }
            return Ke || (Ke = De.c ? [De.v[0][0], De.v[0][1]] : [De.v[De._length - 1][0], De.v[De._length - 1][1]]), Ke;
          },
          vectorOnPath: function(je, Ge, De) {
            je == 1 ? je = this.v.c : je == 0 && (je = 0.999);
            var Ue = this.pointOnPath(je, Ge), Re = this.pointOnPath(je + 1e-3, Ge), Ye = Re[0] - Ue[0], We = Re[1] - Ue[1], qe = Math.sqrt(Math.pow(Ye, 2) + Math.pow(We, 2));
            if (qe === 0)
              return [0, 0];
            var Je = De === "tangent" ? [Ye / qe, We / qe] : [-We / qe, Ye / qe];
            return Je;
          },
          tangentOnPath: function(je, Ge) {
            return this.vectorOnPath(je, Ge, "tangent");
          },
          normalOnPath: function(je, Ge) {
            return this.vectorOnPath(je, Ge, "normal");
          },
          setGroupProperty: expressionHelpers.setGroupProperty,
          getValueAtTime: expressionHelpers.getStaticValueAtTime
        }, extendPrototype([Le], Be), extendPrototype([Le], $e), $e.prototype.getValueAtTime = Ee, $e.prototype.initiateExpression = ExpressionManager.initiateExpression;
        var Fe = ShapePropertyFactory.getShapeProp;
        ShapePropertyFactory.getShapeProp = function(Ve, je, Ge, De, Ue) {
          var Re = Fe(Ve, je, Ge, De, Ue);
          return Re.propertyIndex = je.ix, Re.lock = !1, Ge === 3 ? expressionHelpers.searchExpressions(Ve, je.pt, Re) : Ge === 4 && expressionHelpers.searchExpressions(Ve, je.ks, Re), Re.k && Ve.addDynamicProperty(Re), Re;
        };
      }
      function initialize$1() {
        addPropertyDecorator();
      }
      function addDecorator() {
        function e() {
          return this.data.d.x ? (this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this), this.addEffect(this.getExpressionValue.bind(this)), !0) : null;
        }
        TextProperty.prototype.getExpressionValue = function(j, ke) {
          var Se = this.calculateExpression(ke);
          if (j.t !== Se) {
            var xe = {};
            return this.copyData(xe, j), xe.t = Se.toString(), xe.__complete = !1, xe;
          }
          return j;
        }, TextProperty.prototype.searchProperty = function() {
          var j = this.searchKeyframes(), ke = this.searchExpressions();
          return this.kf = j || ke, this.kf;
        }, TextProperty.prototype.searchExpressions = e;
      }
      function initialize() {
        addDecorator();
      }
      function SVGComposableEffect() {
      }
      SVGComposableEffect.prototype = {
        createMergeNode: function e(j, ke) {
          var Se = createNS("feMerge");
          Se.setAttribute("result", j);
          var xe, Ie;
          for (Ie = 0; Ie < ke.length; Ie += 1)
            xe = createNS("feMergeNode"), xe.setAttribute("in", ke[Ie]), Se.appendChild(xe), Se.appendChild(xe);
          return Se;
        }
      };
      var linearFilterValue = "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
      function SVGTintFilter(e, j, ke, Se, xe) {
        this.filterManager = j;
        var Ie = createNS("feColorMatrix");
        Ie.setAttribute("type", "matrix"), Ie.setAttribute("color-interpolation-filters", "linearRGB"), Ie.setAttribute("values", linearFilterValue + " 1 0"), this.linearFilter = Ie, Ie.setAttribute("result", Se + "_tint_1"), e.appendChild(Ie), Ie = createNS("feColorMatrix"), Ie.setAttribute("type", "matrix"), Ie.setAttribute("color-interpolation-filters", "sRGB"), Ie.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), Ie.setAttribute("result", Se + "_tint_2"), e.appendChild(Ie), this.matrixFilter = Ie;
        var Me = this.createMergeNode(Se, [xe, Se + "_tint_1", Se + "_tint_2"]);
        e.appendChild(Me);
      }
      extendPrototype([SVGComposableEffect], SVGTintFilter), SVGTintFilter.prototype.renderFrame = function(e) {
        if (e || this.filterManager._mdf) {
          var j = this.filterManager.effectElements[0].p.v, ke = this.filterManager.effectElements[1].p.v, Se = this.filterManager.effectElements[2].p.v / 100;
          this.linearFilter.setAttribute("values", linearFilterValue + " " + Se + " 0"), this.matrixFilter.setAttribute("values", ke[0] - j[0] + " 0 0 0 " + j[0] + " " + (ke[1] - j[1]) + " 0 0 0 " + j[1] + " " + (ke[2] - j[2]) + " 0 0 0 " + j[2] + " 0 0 0 1 0");
        }
      };
      function SVGFillFilter(e, j, ke, Se) {
        this.filterManager = j;
        var xe = createNS("feColorMatrix");
        xe.setAttribute("type", "matrix"), xe.setAttribute("color-interpolation-filters", "sRGB"), xe.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), xe.setAttribute("result", Se), e.appendChild(xe), this.matrixFilter = xe;
      }
      SVGFillFilter.prototype.renderFrame = function(e) {
        if (e || this.filterManager._mdf) {
          var j = this.filterManager.effectElements[2].p.v, ke = this.filterManager.effectElements[6].p.v;
          this.matrixFilter.setAttribute("values", "0 0 0 0 " + j[0] + " 0 0 0 0 " + j[1] + " 0 0 0 0 " + j[2] + " 0 0 0 " + ke + " 0");
        }
      };
      function SVGStrokeEffect(e, j, ke) {
        this.initialized = !1, this.filterManager = j, this.elem = ke, this.paths = [];
      }
      SVGStrokeEffect.prototype.initialize = function() {
        var e = this.elem.layerElement.children || this.elem.layerElement.childNodes, j, ke, Se, xe;
        for (this.filterManager.effectElements[1].p.v === 1 ? (xe = this.elem.maskManager.masksProperties.length, Se = 0) : (Se = this.filterManager.effectElements[0].p.v - 1, xe = Se + 1), ke = createNS("g"), ke.setAttribute("fill", "none"), ke.setAttribute("stroke-linecap", "round"), ke.setAttribute("stroke-dashoffset", 1), Se; Se < xe; Se += 1)
          j = createNS("path"), ke.appendChild(j), this.paths.push({
            p: j,
            m: Se
          });
        if (this.filterManager.effectElements[10].p.v === 3) {
          var Ie = createNS("mask"), Me = createElementID();
          Ie.setAttribute("id", Me), Ie.setAttribute("mask-type", "alpha"), Ie.appendChild(ke), this.elem.globalData.defs.appendChild(Ie);
          var Ee = createNS("g");
          for (Ee.setAttribute("mask", "url(" + getLocationHref() + "#" + Me + ")"); e[0]; )
            Ee.appendChild(e[0]);
          this.elem.layerElement.appendChild(Ee), this.masker = Ie, ke.setAttribute("stroke", "#fff");
        } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
          if (this.filterManager.effectElements[10].p.v === 2)
            for (e = this.elem.layerElement.children || this.elem.layerElement.childNodes; e.length; )
              this.elem.layerElement.removeChild(e[0]);
          this.elem.layerElement.appendChild(ke), this.elem.layerElement.removeAttribute("mask"), ke.setAttribute("stroke", "#fff");
        }
        this.initialized = !0, this.pathMasker = ke;
      }, SVGStrokeEffect.prototype.renderFrame = function(e) {
        this.initialized || this.initialize();
        var j, ke = this.paths.length, Se, xe;
        for (j = 0; j < ke; j += 1)
          if (this.paths[j].m !== -1 && (Se = this.elem.maskManager.viewData[this.paths[j].m], xe = this.paths[j].p, (e || this.filterManager._mdf || Se.prop._mdf) && xe.setAttribute("d", Se.lastPath), e || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || Se.prop._mdf)) {
            var Ie;
            if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
              var Me = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01, Ee = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01, Be = xe.getTotalLength();
              Ie = "0 0 0 " + Be * Me + " ";
              var $e = Be * (Ee - Me), Le = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01, Fe = Math.floor($e / Le), Ve;
              for (Ve = 0; Ve < Fe; Ve += 1)
                Ie += "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + " ";
              Ie += "0 " + Be * 10 + " 0 0";
            } else
              Ie = "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
            xe.setAttribute("stroke-dasharray", Ie);
          }
        if ((e || this.filterManager.effectElements[4].p._mdf) && this.pathMasker.setAttribute("stroke-width", this.filterManager.effectElements[4].p.v * 2), (e || this.filterManager.effectElements[6].p._mdf) && this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v), (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) && (e || this.filterManager.effectElements[3].p._mdf)) {
          var je = this.filterManager.effectElements[3].p.v;
          this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(je[0] * 255) + "," + bmFloor(je[1] * 255) + "," + bmFloor(je[2] * 255) + ")");
        }
      };
      function SVGTritoneFilter(e, j, ke, Se) {
        this.filterManager = j;
        var xe = createNS("feColorMatrix");
        xe.setAttribute("type", "matrix"), xe.setAttribute("color-interpolation-filters", "linearRGB"), xe.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), e.appendChild(xe);
        var Ie = createNS("feComponentTransfer");
        Ie.setAttribute("color-interpolation-filters", "sRGB"), Ie.setAttribute("result", Se), this.matrixFilter = Ie;
        var Me = createNS("feFuncR");
        Me.setAttribute("type", "table"), Ie.appendChild(Me), this.feFuncR = Me;
        var Ee = createNS("feFuncG");
        Ee.setAttribute("type", "table"), Ie.appendChild(Ee), this.feFuncG = Ee;
        var Be = createNS("feFuncB");
        Be.setAttribute("type", "table"), Ie.appendChild(Be), this.feFuncB = Be, e.appendChild(Ie);
      }
      SVGTritoneFilter.prototype.renderFrame = function(e) {
        if (e || this.filterManager._mdf) {
          var j = this.filterManager.effectElements[0].p.v, ke = this.filterManager.effectElements[1].p.v, Se = this.filterManager.effectElements[2].p.v, xe = Se[0] + " " + ke[0] + " " + j[0], Ie = Se[1] + " " + ke[1] + " " + j[1], Me = Se[2] + " " + ke[2] + " " + j[2];
          this.feFuncR.setAttribute("tableValues", xe), this.feFuncG.setAttribute("tableValues", Ie), this.feFuncB.setAttribute("tableValues", Me);
        }
      };
      function SVGProLevelsFilter(e, j, ke, Se) {
        this.filterManager = j;
        var xe = this.filterManager.effectElements, Ie = createNS("feComponentTransfer");
        (xe[10].p.k || xe[10].p.v !== 0 || xe[11].p.k || xe[11].p.v !== 1 || xe[12].p.k || xe[12].p.v !== 1 || xe[13].p.k || xe[13].p.v !== 0 || xe[14].p.k || xe[14].p.v !== 1) && (this.feFuncR = this.createFeFunc("feFuncR", Ie)), (xe[17].p.k || xe[17].p.v !== 0 || xe[18].p.k || xe[18].p.v !== 1 || xe[19].p.k || xe[19].p.v !== 1 || xe[20].p.k || xe[20].p.v !== 0 || xe[21].p.k || xe[21].p.v !== 1) && (this.feFuncG = this.createFeFunc("feFuncG", Ie)), (xe[24].p.k || xe[24].p.v !== 0 || xe[25].p.k || xe[25].p.v !== 1 || xe[26].p.k || xe[26].p.v !== 1 || xe[27].p.k || xe[27].p.v !== 0 || xe[28].p.k || xe[28].p.v !== 1) && (this.feFuncB = this.createFeFunc("feFuncB", Ie)), (xe[31].p.k || xe[31].p.v !== 0 || xe[32].p.k || xe[32].p.v !== 1 || xe[33].p.k || xe[33].p.v !== 1 || xe[34].p.k || xe[34].p.v !== 0 || xe[35].p.k || xe[35].p.v !== 1) && (this.feFuncA = this.createFeFunc("feFuncA", Ie)), (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) && (Ie.setAttribute("color-interpolation-filters", "sRGB"), e.appendChild(Ie)), (xe[3].p.k || xe[3].p.v !== 0 || xe[4].p.k || xe[4].p.v !== 1 || xe[5].p.k || xe[5].p.v !== 1 || xe[6].p.k || xe[6].p.v !== 0 || xe[7].p.k || xe[7].p.v !== 1) && (Ie = createNS("feComponentTransfer"), Ie.setAttribute("color-interpolation-filters", "sRGB"), Ie.setAttribute("result", Se), e.appendChild(Ie), this.feFuncRComposed = this.createFeFunc("feFuncR", Ie), this.feFuncGComposed = this.createFeFunc("feFuncG", Ie), this.feFuncBComposed = this.createFeFunc("feFuncB", Ie));
      }
      SVGProLevelsFilter.prototype.createFeFunc = function(e, j) {
        var ke = createNS(e);
        return ke.setAttribute("type", "table"), j.appendChild(ke), ke;
      }, SVGProLevelsFilter.prototype.getTableValue = function(e, j, ke, Se, xe) {
        for (var Ie = 0, Me = 256, Ee, Be = Math.min(e, j), $e = Math.max(e, j), Le = Array.call(null, {
          length: Me
        }), Fe, Ve = 0, je = xe - Se, Ge = j - e; Ie <= 256; )
          Ee = Ie / 256, Ee <= Be ? Fe = Ge < 0 ? xe : Se : Ee >= $e ? Fe = Ge < 0 ? Se : xe : Fe = Se + je * Math.pow((Ee - e) / Ge, 1 / ke), Le[Ve] = Fe, Ve += 1, Ie += 256 / (Me - 1);
        return Le.join(" ");
      }, SVGProLevelsFilter.prototype.renderFrame = function(e) {
        if (e || this.filterManager._mdf) {
          var j, ke = this.filterManager.effectElements;
          this.feFuncRComposed && (e || ke[3].p._mdf || ke[4].p._mdf || ke[5].p._mdf || ke[6].p._mdf || ke[7].p._mdf) && (j = this.getTableValue(ke[3].p.v, ke[4].p.v, ke[5].p.v, ke[6].p.v, ke[7].p.v), this.feFuncRComposed.setAttribute("tableValues", j), this.feFuncGComposed.setAttribute("tableValues", j), this.feFuncBComposed.setAttribute("tableValues", j)), this.feFuncR && (e || ke[10].p._mdf || ke[11].p._mdf || ke[12].p._mdf || ke[13].p._mdf || ke[14].p._mdf) && (j = this.getTableValue(ke[10].p.v, ke[11].p.v, ke[12].p.v, ke[13].p.v, ke[14].p.v), this.feFuncR.setAttribute("tableValues", j)), this.feFuncG && (e || ke[17].p._mdf || ke[18].p._mdf || ke[19].p._mdf || ke[20].p._mdf || ke[21].p._mdf) && (j = this.getTableValue(ke[17].p.v, ke[18].p.v, ke[19].p.v, ke[20].p.v, ke[21].p.v), this.feFuncG.setAttribute("tableValues", j)), this.feFuncB && (e || ke[24].p._mdf || ke[25].p._mdf || ke[26].p._mdf || ke[27].p._mdf || ke[28].p._mdf) && (j = this.getTableValue(ke[24].p.v, ke[25].p.v, ke[26].p.v, ke[27].p.v, ke[28].p.v), this.feFuncB.setAttribute("tableValues", j)), this.feFuncA && (e || ke[31].p._mdf || ke[32].p._mdf || ke[33].p._mdf || ke[34].p._mdf || ke[35].p._mdf) && (j = this.getTableValue(ke[31].p.v, ke[32].p.v, ke[33].p.v, ke[34].p.v, ke[35].p.v), this.feFuncA.setAttribute("tableValues", j));
        }
      };
      function SVGDropShadowEffect(e, j, ke, Se, xe) {
        var Ie = j.container.globalData.renderConfig.filterSize, Me = j.data.fs || Ie;
        e.setAttribute("x", Me.x || Ie.x), e.setAttribute("y", Me.y || Ie.y), e.setAttribute("width", Me.width || Ie.width), e.setAttribute("height", Me.height || Ie.height), this.filterManager = j;
        var Ee = createNS("feGaussianBlur");
        Ee.setAttribute("in", "SourceAlpha"), Ee.setAttribute("result", Se + "_drop_shadow_1"), Ee.setAttribute("stdDeviation", "0"), this.feGaussianBlur = Ee, e.appendChild(Ee);
        var Be = createNS("feOffset");
        Be.setAttribute("dx", "25"), Be.setAttribute("dy", "0"), Be.setAttribute("in", Se + "_drop_shadow_1"), Be.setAttribute("result", Se + "_drop_shadow_2"), this.feOffset = Be, e.appendChild(Be);
        var $e = createNS("feFlood");
        $e.setAttribute("flood-color", "#00ff00"), $e.setAttribute("flood-opacity", "1"), $e.setAttribute("result", Se + "_drop_shadow_3"), this.feFlood = $e, e.appendChild($e);
        var Le = createNS("feComposite");
        Le.setAttribute("in", Se + "_drop_shadow_3"), Le.setAttribute("in2", Se + "_drop_shadow_2"), Le.setAttribute("operator", "in"), Le.setAttribute("result", Se + "_drop_shadow_4"), e.appendChild(Le);
        var Fe = this.createMergeNode(Se, [Se + "_drop_shadow_4", xe]);
        e.appendChild(Fe);
      }
      extendPrototype([SVGComposableEffect], SVGDropShadowEffect), SVGDropShadowEffect.prototype.renderFrame = function(e) {
        if (e || this.filterManager._mdf) {
          if ((e || this.filterManager.effectElements[4].p._mdf) && this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4), e || this.filterManager.effectElements[0].p._mdf) {
            var j = this.filterManager.effectElements[0].p.v;
            this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(j[0] * 255), Math.round(j[1] * 255), Math.round(j[2] * 255)));
          }
          if ((e || this.filterManager.effectElements[1].p._mdf) && this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255), e || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
            var ke = this.filterManager.effectElements[3].p.v, Se = (this.filterManager.effectElements[2].p.v - 90) * degToRads, xe = ke * Math.cos(Se), Ie = ke * Math.sin(Se);
            this.feOffset.setAttribute("dx", xe), this.feOffset.setAttribute("dy", Ie);
          }
        }
      };
      var _svgMatteSymbols = [];
      function SVGMatte3Effect(e, j, ke) {
        this.initialized = !1, this.filterManager = j, this.filterElem = e, this.elem = ke, ke.matteElement = createNS("g"), ke.matteElement.appendChild(ke.layerElement), ke.matteElement.appendChild(ke.transformedElement), ke.baseElement = ke.matteElement;
      }
      SVGMatte3Effect.prototype.findSymbol = function(e) {
        for (var j = 0, ke = _svgMatteSymbols.length; j < ke; ) {
          if (_svgMatteSymbols[j] === e)
            return _svgMatteSymbols[j];
          j += 1;
        }
        return null;
      }, SVGMatte3Effect.prototype.replaceInParent = function(e, j) {
        var ke = e.layerElement.parentNode;
        if (ke) {
          for (var Se = ke.children, xe = 0, Ie = Se.length; xe < Ie && Se[xe] !== e.layerElement; )
            xe += 1;
          var Me;
          xe <= Ie - 2 && (Me = Se[xe + 1]);
          var Ee = createNS("use");
          Ee.setAttribute("href", "#" + j), Me ? ke.insertBefore(Ee, Me) : ke.appendChild(Ee);
        }
      }, SVGMatte3Effect.prototype.setElementAsMask = function(e, j) {
        if (!this.findSymbol(j)) {
          var ke = createElementID(), Se = createNS("mask");
          Se.setAttribute("id", j.layerId), Se.setAttribute("mask-type", "alpha"), _svgMatteSymbols.push(j);
          var xe = e.globalData.defs;
          xe.appendChild(Se);
          var Ie = createNS("symbol");
          Ie.setAttribute("id", ke), this.replaceInParent(j, ke), Ie.appendChild(j.layerElement), xe.appendChild(Ie);
          var Me = createNS("use");
          Me.setAttribute("href", "#" + ke), Se.appendChild(Me), j.data.hd = !1, j.show();
        }
        e.setMatte(j.layerId);
      }, SVGMatte3Effect.prototype.initialize = function() {
        for (var e = this.filterManager.effectElements[0].p.v, j = this.elem.comp.elements, ke = 0, Se = j.length; ke < Se; )
          j[ke] && j[ke].data.ind === e && this.setElementAsMask(this.elem, j[ke]), ke += 1;
        this.initialized = !0;
      }, SVGMatte3Effect.prototype.renderFrame = function() {
        this.initialized || this.initialize();
      };
      function SVGGaussianBlurEffect(e, j, ke, Se) {
        e.setAttribute("x", "-100%"), e.setAttribute("y", "-100%"), e.setAttribute("width", "300%"), e.setAttribute("height", "300%"), this.filterManager = j;
        var xe = createNS("feGaussianBlur");
        xe.setAttribute("result", Se), e.appendChild(xe), this.feGaussianBlur = xe;
      }
      SVGGaussianBlurEffect.prototype.renderFrame = function(e) {
        if (e || this.filterManager._mdf) {
          var j = 0.3, ke = this.filterManager.effectElements[0].p.v * j, Se = this.filterManager.effectElements[1].p.v, xe = Se == 3 ? 0 : ke, Ie = Se == 2 ? 0 : ke;
          this.feGaussianBlur.setAttribute("stdDeviation", xe + " " + Ie);
          var Me = this.filterManager.effectElements[2].p.v == 1 ? "wrap" : "duplicate";
          this.feGaussianBlur.setAttribute("edgeMode", Me);
        }
      };
      function TransformEffect() {
      }
      TransformEffect.prototype.init = function(e) {
        this.effectsManager = e, this.type = effectTypes.TRANSFORM_EFFECT, this.matrix = new Matrix(), this.opacity = -1, this._mdf = !1, this._opMdf = !1;
      }, TransformEffect.prototype.renderFrame = function(e) {
        if (this._opMdf = !1, this._mdf = !1, e || this.effectsManager._mdf) {
          var j = this.effectsManager.effectElements, ke = j[0].p.v, Se = j[1].p.v, xe = j[2].p.v === 1, Ie = j[3].p.v, Me = xe ? Ie : j[4].p.v, Ee = j[5].p.v, Be = j[6].p.v, $e = j[7].p.v;
          this.matrix.reset(), this.matrix.translate(-ke[0], -ke[1], ke[2]), this.matrix.scale(Me * 0.01, Ie * 0.01, 1), this.matrix.rotate(-$e * degToRads), this.matrix.skewFromAxis(-Ee * degToRads, (Be + 90) * degToRads), this.matrix.translate(Se[0], Se[1], 0), this._mdf = !0, this.opacity !== j[8].p.v && (this.opacity = j[8].p.v, this._opMdf = !0);
        }
      };
      function SVGTransformEffect(e, j) {
        this.init(j);
      }
      extendPrototype([TransformEffect], SVGTransformEffect);
      function CVTransformEffect(e) {
        this.init(e);
      }
      return extendPrototype([TransformEffect], CVTransformEffect), registerRenderer("canvas", CanvasRenderer), registerRenderer("html", HybridRenderer), registerRenderer("svg", SVGRenderer), ShapeModifiers.registerModifier("tm", TrimModifier), ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier), ShapeModifiers.registerModifier("rp", RepeaterModifier), ShapeModifiers.registerModifier("rd", RoundCornersModifier), ShapeModifiers.registerModifier("zz", ZigZagModifier), ShapeModifiers.registerModifier("op", OffsetPathModifier), setExpressionsPlugin(Expressions), setExpressionInterfaces(getInterface), initialize$1(), initialize(), registerEffect$1(20, SVGTintFilter, !0), registerEffect$1(21, SVGFillFilter, !0), registerEffect$1(22, SVGStrokeEffect, !1), registerEffect$1(23, SVGTritoneFilter, !0), registerEffect$1(24, SVGProLevelsFilter, !0), registerEffect$1(25, SVGDropShadowEffect, !0), registerEffect$1(28, SVGMatte3Effect, !1), registerEffect$1(29, SVGGaussianBlurEffect, !0), registerEffect$1(35, SVGTransformEffect, !1), registerEffect(35, CVTransformEffect), lottie;
    });
  }(lottie$2, lottie$2.exports)), lottie$2.exports;
}
var lottieExports = /* @__PURE__ */ requireLottie();
const lottie = /* @__PURE__ */ getDefaultExportFromCjs(lottieExports), _sfc_main$1t = /* @__PURE__ */ defineComponent({
  __name: "SatLottieJson",
  props: {
    path: {},
    data: {},
    loop: { type: [Boolean, Number], default: !0 },
    autoplay: { type: Boolean, default: !0 },
    width: {},
    height: {},
    file: {}
  },
  setup(e) {
    const j = e, ke = ref(null);
    let Se;
    const xe = computed(() => {
      const Ee = {};
      return j.width && (Ee.width = j.width), j.height && (Ee.height = j.height), Ee;
    }), Ie = async () => (await __variableDynamicImportRuntimeHelper(/* @__PURE__ */ Object.assign({ "./assets/failure-times.json": () => import("./failure-times-BSJ86xTc.js"), "./assets/food-packs.json": () => import("./food-packs-DU39LB4O.js"), "./assets/pos-terminal.json": () => import("./pos-terminal-DH_c7MAn.js"), "./assets/success-check.json": () => import("./success-check-CB1CkzlM.js") }), `./assets/${j.file}.json`, 3)).default, Me = async () => {
      if (!ke.value) return;
      let Ee = j.data;
      j.file && (Ee = await Ie()), Se = lottie.loadAnimation({
        container: ke.value,
        loop: j.loop,
        autoplay: j.autoplay,
        animationData: Ee,
        path: j.path
      });
    };
    return watch(
      () => j,
      async () => {
        Se && Se.destroy(), await Me();
      },
      { deep: !0 }
    ), onMounted(() => {
      Me();
    }), onBeforeUnmount(() => {
      Se && Se.destroy();
    }), (Ee, Be) => (openBlock(), createElementBlock("div", {
      ref_key: "container",
      ref: ke,
      class: normalizeClass(unref(css$1l)("")),
      style: normalizeStyle(xe.value)
    }, null, 6));
  }
}), SatLottieJson = /* @__PURE__ */ _export_sfc(_sfc_main$1t, [["__scopeId", "data-v-4d8b99ef"]]);
var SatLottieJsonEnum = /* @__PURE__ */ ((e) => (e.POST_TERMINAL = "pos-terminal", e.SUCCESS_CHECK = "success-check", e.FAILURE_TIMES = "failure-times", e.FOOD_PACKS = "food-packs", e))(SatLottieJsonEnum || {});
const useSatLottieJson = () => ({
  preloadAssets: () => {
    Object.values(SatLottieJsonEnum).forEach(
      (j) => __variableDynamicImportRuntimeHelper(/* @__PURE__ */ Object.assign({ "./assets/failure-times.json": () => import("./failure-times-BSJ86xTc.js"), "./assets/food-packs.json": () => import("./food-packs-DU39LB4O.js"), "./assets/pos-terminal.json": () => import("./pos-terminal-DH_c7MAn.js"), "./assets/success-check.json": () => import("./success-check-CB1CkzlM.js") }), `./assets/${j}.json`, 3)
    );
  }
}), sides = ["top", "right", "bottom", "left"], alignments = ["start", "end"], placements = /* @__PURE__ */ sides.reduce((e, j) => e.concat(j, j + "-" + alignments[0], j + "-" + alignments[1]), []), min = Math.min, max = Math.max, oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp(e, j, ke) {
  return max(e, min(j, ke));
}
function evaluate(e, j) {
  return typeof e == "function" ? e(j) : e;
}
function getSide(e) {
  return e.split("-")[0];
}
function getAlignment(e) {
  return e.split("-")[1];
}
function getOppositeAxis(e) {
  return e === "x" ? "y" : "x";
}
function getAxisLength(e) {
  return e === "y" ? "height" : "width";
}
function getSideAxis(e) {
  return ["top", "bottom"].includes(getSide(e)) ? "y" : "x";
}
function getAlignmentAxis(e) {
  return getOppositeAxis(getSideAxis(e));
}
function getAlignmentSides(e, j, ke) {
  ke === void 0 && (ke = !1);
  const Se = getAlignment(e), xe = getAlignmentAxis(e), Ie = getAxisLength(xe);
  let Me = xe === "x" ? Se === (ke ? "end" : "start") ? "right" : "left" : Se === "start" ? "bottom" : "top";
  return j.reference[Ie] > j.floating[Ie] && (Me = getOppositePlacement(Me)), [Me, getOppositePlacement(Me)];
}
function getExpandedPlacements(e) {
  const j = getOppositePlacement(e);
  return [getOppositeAlignmentPlacement(e), j, getOppositeAlignmentPlacement(j)];
}
function getOppositeAlignmentPlacement(e) {
  return e.replace(/start|end/g, (j) => oppositeAlignmentMap[j]);
}
function getSideList(e, j, ke) {
  const Se = ["left", "right"], xe = ["right", "left"], Ie = ["top", "bottom"], Me = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return ke ? j ? xe : Se : j ? Se : xe;
    case "left":
    case "right":
      return j ? Ie : Me;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(e, j, ke, Se) {
  const xe = getAlignment(e);
  let Ie = getSideList(getSide(e), ke === "start", Se);
  return xe && (Ie = Ie.map((Me) => Me + "-" + xe), j && (Ie = Ie.concat(Ie.map(getOppositeAlignmentPlacement)))), Ie;
}
function getOppositePlacement(e) {
  return e.replace(/left|right|bottom|top/g, (j) => oppositeSideMap[j]);
}
function expandPaddingObject(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function getPaddingObject(e) {
  return typeof e != "number" ? expandPaddingObject(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function rectToClientRect(e) {
  const {
    x: j,
    y: ke,
    width: Se,
    height: xe
  } = e;
  return {
    width: Se,
    height: xe,
    top: ke,
    left: j,
    right: j + Se,
    bottom: ke + xe,
    x: j,
    y: ke
  };
}
function computeCoordsFromPlacement(e, j, ke) {
  let {
    reference: Se,
    floating: xe
  } = e;
  const Ie = getSideAxis(j), Me = getAlignmentAxis(j), Ee = getAxisLength(Me), Be = getSide(j), $e = Ie === "y", Le = Se.x + Se.width / 2 - xe.width / 2, Fe = Se.y + Se.height / 2 - xe.height / 2, Ve = Se[Ee] / 2 - xe[Ee] / 2;
  let je;
  switch (Be) {
    case "top":
      je = {
        x: Le,
        y: Se.y - xe.height
      };
      break;
    case "bottom":
      je = {
        x: Le,
        y: Se.y + Se.height
      };
      break;
    case "right":
      je = {
        x: Se.x + Se.width,
        y: Fe
      };
      break;
    case "left":
      je = {
        x: Se.x - xe.width,
        y: Fe
      };
      break;
    default:
      je = {
        x: Se.x,
        y: Se.y
      };
  }
  switch (getAlignment(j)) {
    case "start":
      je[Me] -= Ve * (ke && $e ? -1 : 1);
      break;
    case "end":
      je[Me] += Ve * (ke && $e ? -1 : 1);
      break;
  }
  return je;
}
const computePosition = async (e, j, ke) => {
  const {
    placement: Se = "bottom",
    strategy: xe = "absolute",
    middleware: Ie = [],
    platform: Me
  } = ke, Ee = Ie.filter(Boolean), Be = await (Me.isRTL == null ? void 0 : Me.isRTL(j));
  let $e = await Me.getElementRects({
    reference: e,
    floating: j,
    strategy: xe
  }), {
    x: Le,
    y: Fe
  } = computeCoordsFromPlacement($e, Se, Be), Ve = Se, je = {}, Ge = 0;
  for (let De = 0; De < Ee.length; De++) {
    const {
      name: Ue,
      fn: Re
    } = Ee[De], {
      x: Ye,
      y: We,
      data: qe,
      reset: Je
    } = await Re({
      x: Le,
      y: Fe,
      initialPlacement: Se,
      placement: Ve,
      strategy: xe,
      middlewareData: je,
      rects: $e,
      platform: Me,
      elements: {
        reference: e,
        floating: j
      }
    });
    Le = Ye ?? Le, Fe = We ?? Fe, je = {
      ...je,
      [Ue]: {
        ...je[Ue],
        ...qe
      }
    }, Je && Ge <= 50 && (Ge++, typeof Je == "object" && (Je.placement && (Ve = Je.placement), Je.rects && ($e = Je.rects === !0 ? await Me.getElementRects({
      reference: e,
      floating: j,
      strategy: xe
    }) : Je.rects), {
      x: Le,
      y: Fe
    } = computeCoordsFromPlacement($e, Ve, Be)), De = -1);
  }
  return {
    x: Le,
    y: Fe,
    placement: Ve,
    strategy: xe,
    middlewareData: je
  };
};
async function detectOverflow(e, j) {
  var ke;
  j === void 0 && (j = {});
  const {
    x: Se,
    y: xe,
    platform: Ie,
    rects: Me,
    elements: Ee,
    strategy: Be
  } = e, {
    boundary: $e = "clippingAncestors",
    rootBoundary: Le = "viewport",
    elementContext: Fe = "floating",
    altBoundary: Ve = !1,
    padding: je = 0
  } = evaluate(j, e), Ge = getPaddingObject(je), Ue = Ee[Ve ? Fe === "floating" ? "reference" : "floating" : Fe], Re = rectToClientRect(await Ie.getClippingRect({
    element: (ke = await (Ie.isElement == null ? void 0 : Ie.isElement(Ue))) == null || ke ? Ue : Ue.contextElement || await (Ie.getDocumentElement == null ? void 0 : Ie.getDocumentElement(Ee.floating)),
    boundary: $e,
    rootBoundary: Le,
    strategy: Be
  })), Ye = Fe === "floating" ? {
    x: Se,
    y: xe,
    width: Me.floating.width,
    height: Me.floating.height
  } : Me.reference, We = await (Ie.getOffsetParent == null ? void 0 : Ie.getOffsetParent(Ee.floating)), qe = await (Ie.isElement == null ? void 0 : Ie.isElement(We)) ? await (Ie.getScale == null ? void 0 : Ie.getScale(We)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, Je = rectToClientRect(Ie.convertOffsetParentRelativeRectToViewportRelativeRect ? await Ie.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: Ee,
    rect: Ye,
    offsetParent: We,
    strategy: Be
  }) : Ye);
  return {
    top: (Re.top - Je.top + Ge.top) / qe.y,
    bottom: (Je.bottom - Re.bottom + Ge.bottom) / qe.y,
    left: (Re.left - Je.left + Ge.left) / qe.x,
    right: (Je.right - Re.right + Ge.right) / qe.x
  };
}
const arrow = (e) => ({
  name: "arrow",
  options: e,
  async fn(j) {
    const {
      x: ke,
      y: Se,
      placement: xe,
      rects: Ie,
      platform: Me,
      elements: Ee,
      middlewareData: Be
    } = j, {
      element: $e,
      padding: Le = 0
    } = evaluate(e, j) || {};
    if ($e == null)
      return {};
    const Fe = getPaddingObject(Le), Ve = {
      x: ke,
      y: Se
    }, je = getAlignmentAxis(xe), Ge = getAxisLength(je), De = await Me.getDimensions($e), Ue = je === "y", Re = Ue ? "top" : "left", Ye = Ue ? "bottom" : "right", We = Ue ? "clientHeight" : "clientWidth", qe = Ie.reference[Ge] + Ie.reference[je] - Ve[je] - Ie.floating[Ge], Je = Ve[je] - Ie.reference[je], Ke = await (Me.getOffsetParent == null ? void 0 : Me.getOffsetParent($e));
    let xt = Ke ? Ke[We] : 0;
    (!xt || !await (Me.isElement == null ? void 0 : Me.isElement(Ke))) && (xt = Ee.floating[We] || Ie.floating[Ge]);
    const Ct = qe / 2 - Je / 2, It = xt / 2 - De[Ge] / 2 - 1, Nt = min(Fe[Re], It), Bt = min(Fe[Ye], It), At = Nt, Ft = xt - De[Ge] - Bt, Dt = xt / 2 - De[Ge] / 2 + Ct, zt = clamp(At, Dt, Ft), kt = !Be.arrow && getAlignment(xe) != null && Dt !== zt && Ie.reference[Ge] / 2 - (Dt < At ? Nt : Bt) - De[Ge] / 2 < 0, Et = kt ? Dt < At ? Dt - At : Dt - Ft : 0;
    return {
      [je]: Ve[je] + Et,
      data: {
        [je]: zt,
        centerOffset: Dt - zt - Et,
        ...kt && {
          alignmentOffset: Et
        }
      },
      reset: kt
    };
  }
});
function getPlacementList(e, j, ke) {
  return (e ? [...ke.filter((xe) => getAlignment(xe) === e), ...ke.filter((xe) => getAlignment(xe) !== e)] : ke.filter((xe) => getSide(xe) === xe)).filter((xe) => e ? getAlignment(xe) === e || (j ? getOppositeAlignmentPlacement(xe) !== xe : !1) : !0);
}
const autoPlacement = function(e) {
  return e === void 0 && (e = {}), {
    name: "autoPlacement",
    options: e,
    async fn(j) {
      var ke, Se, xe;
      const {
        rects: Ie,
        middlewareData: Me,
        placement: Ee,
        platform: Be,
        elements: $e
      } = j, {
        crossAxis: Le = !1,
        alignment: Fe,
        allowedPlacements: Ve = placements,
        autoAlignment: je = !0,
        ...Ge
      } = evaluate(e, j), De = Fe !== void 0 || Ve === placements ? getPlacementList(Fe || null, je, Ve) : Ve, Ue = await detectOverflow(j, Ge), Re = ((ke = Me.autoPlacement) == null ? void 0 : ke.index) || 0, Ye = De[Re];
      if (Ye == null)
        return {};
      const We = getAlignmentSides(Ye, Ie, await (Be.isRTL == null ? void 0 : Be.isRTL($e.floating)));
      if (Ee !== Ye)
        return {
          reset: {
            placement: De[0]
          }
        };
      const qe = [Ue[getSide(Ye)], Ue[We[0]], Ue[We[1]]], Je = [...((Se = Me.autoPlacement) == null ? void 0 : Se.overflows) || [], {
        placement: Ye,
        overflows: qe
      }], Ke = De[Re + 1];
      if (Ke)
        return {
          data: {
            index: Re + 1,
            overflows: Je
          },
          reset: {
            placement: Ke
          }
        };
      const xt = Je.map((Nt) => {
        const Bt = getAlignment(Nt.placement);
        return [Nt.placement, Bt && Le ? (
          // Check along the mainAxis and main crossAxis side.
          Nt.overflows.slice(0, 2).reduce((At, Ft) => At + Ft, 0)
        ) : (
          // Check only the mainAxis.
          Nt.overflows[0]
        ), Nt.overflows];
      }).sort((Nt, Bt) => Nt[1] - Bt[1]), It = ((xe = xt.filter((Nt) => Nt[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        getAlignment(Nt[0]) ? 2 : 3
      ).every((Bt) => Bt <= 0))[0]) == null ? void 0 : xe[0]) || xt[0][0];
      return It !== Ee ? {
        data: {
          index: Re + 1,
          overflows: Je
        },
        reset: {
          placement: It
        }
      } : {};
    }
  };
}, flip = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(j) {
      var ke, Se;
      const {
        placement: xe,
        middlewareData: Ie,
        rects: Me,
        initialPlacement: Ee,
        platform: Be,
        elements: $e
      } = j, {
        mainAxis: Le = !0,
        crossAxis: Fe = !0,
        fallbackPlacements: Ve,
        fallbackStrategy: je = "bestFit",
        fallbackAxisSideDirection: Ge = "none",
        flipAlignment: De = !0,
        ...Ue
      } = evaluate(e, j);
      if ((ke = Ie.arrow) != null && ke.alignmentOffset)
        return {};
      const Re = getSide(xe), Ye = getSideAxis(Ee), We = getSide(Ee) === Ee, qe = await (Be.isRTL == null ? void 0 : Be.isRTL($e.floating)), Je = Ve || (We || !De ? [getOppositePlacement(Ee)] : getExpandedPlacements(Ee)), Ke = Ge !== "none";
      !Ve && Ke && Je.push(...getOppositeAxisPlacements(Ee, De, Ge, qe));
      const xt = [Ee, ...Je], Ct = await detectOverflow(j, Ue), It = [];
      let Nt = ((Se = Ie.flip) == null ? void 0 : Se.overflows) || [];
      if (Le && It.push(Ct[Re]), Fe) {
        const Dt = getAlignmentSides(xe, Me, qe);
        It.push(Ct[Dt[0]], Ct[Dt[1]]);
      }
      if (Nt = [...Nt, {
        placement: xe,
        overflows: It
      }], !It.every((Dt) => Dt <= 0)) {
        var Bt, At;
        const Dt = (((Bt = Ie.flip) == null ? void 0 : Bt.index) || 0) + 1, zt = xt[Dt];
        if (zt)
          return {
            data: {
              index: Dt,
              overflows: Nt
            },
            reset: {
              placement: zt
            }
          };
        let kt = (At = Nt.filter((Et) => Et.overflows[0] <= 0).sort((Et, Qe) => Et.overflows[1] - Qe.overflows[1])[0]) == null ? void 0 : At.placement;
        if (!kt)
          switch (je) {
            case "bestFit": {
              var Ft;
              const Et = (Ft = Nt.filter((Qe) => {
                if (Ke) {
                  const Xe = getSideAxis(Qe.placement);
                  return Xe === Ye || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  Xe === "y";
                }
                return !0;
              }).map((Qe) => [Qe.placement, Qe.overflows.filter((Xe) => Xe > 0).reduce((Xe, Vt) => Xe + Vt, 0)]).sort((Qe, Xe) => Qe[1] - Xe[1])[0]) == null ? void 0 : Ft[0];
              Et && (kt = Et);
              break;
            }
            case "initialPlacement":
              kt = Ee;
              break;
          }
        if (xe !== kt)
          return {
            reset: {
              placement: kt
            }
          };
      }
      return {};
    }
  };
};
async function convertValueToCoords(e, j) {
  const {
    placement: ke,
    platform: Se,
    elements: xe
  } = e, Ie = await (Se.isRTL == null ? void 0 : Se.isRTL(xe.floating)), Me = getSide(ke), Ee = getAlignment(ke), Be = getSideAxis(ke) === "y", $e = ["left", "top"].includes(Me) ? -1 : 1, Le = Ie && Be ? -1 : 1, Fe = evaluate(j, e);
  let {
    mainAxis: Ve,
    crossAxis: je,
    alignmentAxis: Ge
  } = typeof Fe == "number" ? {
    mainAxis: Fe,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: Fe.mainAxis || 0,
    crossAxis: Fe.crossAxis || 0,
    alignmentAxis: Fe.alignmentAxis
  };
  return Ee && typeof Ge == "number" && (je = Ee === "end" ? Ge * -1 : Ge), Be ? {
    x: je * Le,
    y: Ve * $e
  } : {
    x: Ve * $e,
    y: je * Le
  };
}
const offset = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(j) {
      var ke, Se;
      const {
        x: xe,
        y: Ie,
        placement: Me,
        middlewareData: Ee
      } = j, Be = await convertValueToCoords(j, e);
      return Me === ((ke = Ee.offset) == null ? void 0 : ke.placement) && (Se = Ee.arrow) != null && Se.alignmentOffset ? {} : {
        x: xe + Be.x,
        y: Ie + Be.y,
        data: {
          ...Be,
          placement: Me
        }
      };
    }
  };
}, shift = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(j) {
      const {
        x: ke,
        y: Se,
        placement: xe
      } = j, {
        mainAxis: Ie = !0,
        crossAxis: Me = !1,
        limiter: Ee = {
          fn: (Ue) => {
            let {
              x: Re,
              y: Ye
            } = Ue;
            return {
              x: Re,
              y: Ye
            };
          }
        },
        ...Be
      } = evaluate(e, j), $e = {
        x: ke,
        y: Se
      }, Le = await detectOverflow(j, Be), Fe = getSideAxis(getSide(xe)), Ve = getOppositeAxis(Fe);
      let je = $e[Ve], Ge = $e[Fe];
      if (Ie) {
        const Ue = Ve === "y" ? "top" : "left", Re = Ve === "y" ? "bottom" : "right", Ye = je + Le[Ue], We = je - Le[Re];
        je = clamp(Ye, je, We);
      }
      if (Me) {
        const Ue = Fe === "y" ? "top" : "left", Re = Fe === "y" ? "bottom" : "right", Ye = Ge + Le[Ue], We = Ge - Le[Re];
        Ge = clamp(Ye, Ge, We);
      }
      const De = Ee.fn({
        ...j,
        [Ve]: je,
        [Fe]: Ge
      });
      return {
        ...De,
        data: {
          x: De.x - ke,
          y: De.y - Se,
          enabled: {
            [Ve]: Ie,
            [Fe]: Me
          }
        }
      };
    }
  };
}, size = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(j) {
      var ke, Se;
      const {
        placement: xe,
        rects: Ie,
        platform: Me,
        elements: Ee
      } = j, {
        apply: Be = () => {
        },
        ...$e
      } = evaluate(e, j), Le = await detectOverflow(j, $e), Fe = getSide(xe), Ve = getAlignment(xe), je = getSideAxis(xe) === "y", {
        width: Ge,
        height: De
      } = Ie.floating;
      let Ue, Re;
      Fe === "top" || Fe === "bottom" ? (Ue = Fe, Re = Ve === (await (Me.isRTL == null ? void 0 : Me.isRTL(Ee.floating)) ? "start" : "end") ? "left" : "right") : (Re = Fe, Ue = Ve === "end" ? "top" : "bottom");
      const Ye = De - Le.top - Le.bottom, We = Ge - Le.left - Le.right, qe = min(De - Le[Ue], Ye), Je = min(Ge - Le[Re], We), Ke = !j.middlewareData.shift;
      let xt = qe, Ct = Je;
      if ((ke = j.middlewareData.shift) != null && ke.enabled.x && (Ct = We), (Se = j.middlewareData.shift) != null && Se.enabled.y && (xt = Ye), Ke && !Ve) {
        const Nt = max(Le.left, 0), Bt = max(Le.right, 0), At = max(Le.top, 0), Ft = max(Le.bottom, 0);
        je ? Ct = Ge - 2 * (Nt !== 0 || Bt !== 0 ? Nt + Bt : max(Le.left, Le.right)) : xt = De - 2 * (At !== 0 || Ft !== 0 ? At + Ft : max(Le.top, Le.bottom));
      }
      await Be({
        ...j,
        availableWidth: Ct,
        availableHeight: xt
      });
      const It = await Me.getDimensions(Ee.floating);
      return Ge !== It.width || De !== It.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function n$1(e) {
  var j;
  return ((j = e.ownerDocument) == null ? void 0 : j.defaultView) || window;
}
function o(e) {
  return n$1(e).getComputedStyle(e);
}
const i = Math.min, r = Math.max, l = Math.round;
function c$1(e) {
  const j = o(e);
  let ke = parseFloat(j.width), Se = parseFloat(j.height);
  const xe = e.offsetWidth, Ie = e.offsetHeight, Me = l(ke) !== xe || l(Se) !== Ie;
  return Me && (ke = xe, Se = Ie), { width: ke, height: Se, fallback: Me };
}
function s(e) {
  return h$1(e) ? (e.nodeName || "").toLowerCase() : "";
}
let f;
function u() {
  if (f) return f;
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? (f = e.brands.map((j) => j.brand + "/" + j.version).join(" "), f) : navigator.userAgent;
}
function a(e) {
  return e instanceof n$1(e).HTMLElement;
}
function d$1(e) {
  return e instanceof n$1(e).Element;
}
function h$1(e) {
  return e instanceof n$1(e).Node;
}
function p(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof n$1(e).ShadowRoot || e instanceof ShadowRoot;
}
function g$1(e) {
  const { overflow: j, overflowX: ke, overflowY: Se, display: xe } = o(e);
  return /auto|scroll|overlay|hidden|clip/.test(j + Se + ke) && !["inline", "contents"].includes(xe);
}
function m$1(e) {
  return ["table", "td", "th"].includes(s(e));
}
function y$1(e) {
  const j = /firefox/i.test(u()), ke = o(e), Se = ke.backdropFilter || ke.WebkitBackdropFilter;
  return ke.transform !== "none" || ke.perspective !== "none" || !!Se && Se !== "none" || j && ke.willChange === "filter" || j && !!ke.filter && ke.filter !== "none" || ["transform", "perspective"].some((xe) => ke.willChange.includes(xe)) || ["paint", "layout", "strict", "content"].some((xe) => {
    const Ie = ke.contain;
    return Ie != null && Ie.includes(xe);
  });
}
function x$1() {
  return !/^((?!chrome|android).)*safari/i.test(u());
}
function w(e) {
  return ["html", "body", "#document"].includes(s(e));
}
function v(e) {
  return d$1(e) ? e : e.contextElement;
}
const b$1 = { x: 1, y: 1 };
function L(e) {
  const j = v(e);
  if (!a(j)) return b$1;
  const ke = j.getBoundingClientRect(), { width: Se, height: xe, fallback: Ie } = c$1(j);
  let Me = (Ie ? l(ke.width) : ke.width) / Se, Ee = (Ie ? l(ke.height) : ke.height) / xe;
  return Me && Number.isFinite(Me) || (Me = 1), Ee && Number.isFinite(Ee) || (Ee = 1), { x: Me, y: Ee };
}
function E$1(e, j, ke, Se) {
  var xe, Ie;
  j === void 0 && (j = !1), ke === void 0 && (ke = !1);
  const Me = e.getBoundingClientRect(), Ee = v(e);
  let Be = b$1;
  j && (Se ? d$1(Se) && (Be = L(Se)) : Be = L(e));
  const $e = Ee ? n$1(Ee) : window, Le = !x$1() && ke;
  let Fe = (Me.left + (Le && ((xe = $e.visualViewport) == null ? void 0 : xe.offsetLeft) || 0)) / Be.x, Ve = (Me.top + (Le && ((Ie = $e.visualViewport) == null ? void 0 : Ie.offsetTop) || 0)) / Be.y, je = Me.width / Be.x, Ge = Me.height / Be.y;
  if (Ee) {
    const De = n$1(Ee), Ue = Se && d$1(Se) ? n$1(Se) : Se;
    let Re = De.frameElement;
    for (; Re && Se && Ue !== De; ) {
      const Ye = L(Re), We = Re.getBoundingClientRect(), qe = getComputedStyle(Re);
      We.x += (Re.clientLeft + parseFloat(qe.paddingLeft)) * Ye.x, We.y += (Re.clientTop + parseFloat(qe.paddingTop)) * Ye.y, Fe *= Ye.x, Ve *= Ye.y, je *= Ye.x, Ge *= Ye.y, Fe += We.x, Ve += We.y, Re = n$1(Re).frameElement;
    }
  }
  return { width: je, height: Ge, top: Ve, right: Fe + je, bottom: Ve + Ge, left: Fe, x: Fe, y: Ve };
}
function R(e) {
  return ((h$1(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function T(e) {
  return d$1(e) ? { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop } : { scrollLeft: e.pageXOffset, scrollTop: e.pageYOffset };
}
function C$1(e) {
  return E$1(R(e)).left + T(e).scrollLeft;
}
function F(e) {
  if (s(e) === "html") return e;
  const j = e.assignedSlot || e.parentNode || p(e) && e.host || R(e);
  return p(j) ? j.host : j;
}
function W(e) {
  const j = F(e);
  return w(j) ? j.ownerDocument.body : a(j) && g$1(j) ? j : W(j);
}
function D(e, j) {
  var ke;
  j === void 0 && (j = []);
  const Se = W(e), xe = Se === ((ke = e.ownerDocument) == null ? void 0 : ke.body), Ie = n$1(Se);
  return xe ? j.concat(Ie, Ie.visualViewport || [], g$1(Se) ? Se : []) : j.concat(Se, D(Se));
}
function S$1(e, j, ke) {
  return j === "viewport" ? rectToClientRect(function(Se, xe) {
    const Ie = n$1(Se), Me = R(Se), Ee = Ie.visualViewport;
    let Be = Me.clientWidth, $e = Me.clientHeight, Le = 0, Fe = 0;
    if (Ee) {
      Be = Ee.width, $e = Ee.height;
      const Ve = x$1();
      (Ve || !Ve && xe === "fixed") && (Le = Ee.offsetLeft, Fe = Ee.offsetTop);
    }
    return { width: Be, height: $e, x: Le, y: Fe };
  }(e, ke)) : d$1(j) ? rectToClientRect(function(Se, xe) {
    const Ie = E$1(Se, !0, xe === "fixed"), Me = Ie.top + Se.clientTop, Ee = Ie.left + Se.clientLeft, Be = a(Se) ? L(Se) : { x: 1, y: 1 };
    return { width: Se.clientWidth * Be.x, height: Se.clientHeight * Be.y, x: Ee * Be.x, y: Me * Be.y };
  }(j, ke)) : rectToClientRect(function(Se) {
    const xe = R(Se), Ie = T(Se), Me = Se.ownerDocument.body, Ee = r(xe.scrollWidth, xe.clientWidth, Me.scrollWidth, Me.clientWidth), Be = r(xe.scrollHeight, xe.clientHeight, Me.scrollHeight, Me.clientHeight);
    let $e = -Ie.scrollLeft + C$1(Se);
    const Le = -Ie.scrollTop;
    return o(Me).direction === "rtl" && ($e += r(xe.clientWidth, Me.clientWidth) - Ee), { width: Ee, height: Be, x: $e, y: Le };
  }(R(e)));
}
function A(e) {
  return a(e) && o(e).position !== "fixed" ? e.offsetParent : null;
}
function H(e) {
  const j = n$1(e);
  let ke = A(e);
  for (; ke && m$1(ke) && o(ke).position === "static"; ) ke = A(ke);
  return ke && (s(ke) === "html" || s(ke) === "body" && o(ke).position === "static" && !y$1(ke)) ? j : ke || function(Se) {
    let xe = F(Se);
    for (; a(xe) && !w(xe); ) {
      if (y$1(xe)) return xe;
      xe = F(xe);
    }
    return null;
  }(e) || j;
}
function O(e, j, ke) {
  const Se = a(j), xe = R(j), Ie = E$1(e, !0, ke === "fixed", j);
  let Me = { scrollLeft: 0, scrollTop: 0 };
  const Ee = { x: 0, y: 0 };
  if (Se || !Se && ke !== "fixed") if ((s(j) !== "body" || g$1(xe)) && (Me = T(j)), a(j)) {
    const Be = E$1(j, !0);
    Ee.x = Be.x + j.clientLeft, Ee.y = Be.y + j.clientTop;
  } else xe && (Ee.x = C$1(xe));
  return { x: Ie.left + Me.scrollLeft - Ee.x, y: Ie.top + Me.scrollTop - Ee.y, width: Ie.width, height: Ie.height };
}
const P = { getClippingRect: function(e) {
  let { element: j, boundary: ke, rootBoundary: Se, strategy: xe } = e;
  const Ie = ke === "clippingAncestors" ? function($e, Le) {
    const Fe = Le.get($e);
    if (Fe) return Fe;
    let Ve = D($e).filter((Ue) => d$1(Ue) && s(Ue) !== "body"), je = null;
    const Ge = o($e).position === "fixed";
    let De = Ge ? F($e) : $e;
    for (; d$1(De) && !w(De); ) {
      const Ue = o(De), Re = y$1(De);
      (Ge ? Re || je : Re || Ue.position !== "static" || !je || !["absolute", "fixed"].includes(je.position)) ? je = Ue : Ve = Ve.filter((Ye) => Ye !== De), De = F(De);
    }
    return Le.set($e, Ve), Ve;
  }(j, this._c) : [].concat(ke), Me = [...Ie, Se], Ee = Me[0], Be = Me.reduce(($e, Le) => {
    const Fe = S$1(j, Le, xe);
    return $e.top = r(Fe.top, $e.top), $e.right = i(Fe.right, $e.right), $e.bottom = i(Fe.bottom, $e.bottom), $e.left = r(Fe.left, $e.left), $e;
  }, S$1(j, Ee, xe));
  return { width: Be.right - Be.left, height: Be.bottom - Be.top, x: Be.left, y: Be.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(e) {
  let { rect: j, offsetParent: ke, strategy: Se } = e;
  const xe = a(ke), Ie = R(ke);
  if (ke === Ie) return j;
  let Me = { scrollLeft: 0, scrollTop: 0 }, Ee = { x: 1, y: 1 };
  const Be = { x: 0, y: 0 };
  if ((xe || !xe && Se !== "fixed") && ((s(ke) !== "body" || g$1(Ie)) && (Me = T(ke)), a(ke))) {
    const $e = E$1(ke);
    Ee = L(ke), Be.x = $e.x + ke.clientLeft, Be.y = $e.y + ke.clientTop;
  }
  return { width: j.width * Ee.x, height: j.height * Ee.y, x: j.x * Ee.x - Me.scrollLeft * Ee.x + Be.x, y: j.y * Ee.y - Me.scrollTop * Ee.y + Be.y };
}, isElement: d$1, getDimensions: function(e) {
  return a(e) ? c$1(e) : e.getBoundingClientRect();
}, getOffsetParent: H, getDocumentElement: R, getScale: L, async getElementRects(e) {
  let { reference: j, floating: ke, strategy: Se } = e;
  const xe = this.getOffsetParent || H, Ie = this.getDimensions;
  return { reference: O(j, await xe(ke), Se), floating: { x: 0, y: 0, ...await Ie(ke) } };
}, getClientRects: (e) => Array.from(e.getClientRects()), isRTL: (e) => o(e).direction === "rtl" }, B$1 = (e, j, ke) => {
  const Se = /* @__PURE__ */ new Map(), xe = { platform: P, ...ke }, Ie = { ...xe.platform, _c: Se };
  return computePosition(e, j, { ...xe, platform: Ie });
}, h = {
  // Disable popper components
  disabled: !1,
  // Default position offset along main axis (px)
  distance: 5,
  // Default position offset along cross axis (px)
  skidding: 0,
  // Default container where the tooltip will be appended
  container: "body",
  // Element used to compute position and size boundaries
  boundary: void 0,
  // Skip delay & CSS transitions when another popper is shown, so that the popper appear to instanly move to the new position.
  instantMove: !1,
  // Auto destroy tooltip DOM nodes (ms)
  disposeTimeout: 150,
  // Triggers on the popper itself
  popperTriggers: [],
  // Positioning strategy
  strategy: "absolute",
  // Prevent overflow
  preventOverflow: !0,
  // Flip to the opposite placement if needed
  flip: !0,
  // Shift on the cross axis to prevent the popper from overflowing
  shift: !0,
  // Overflow padding (px)
  overflowPadding: 0,
  // Arrow padding (px)
  arrowPadding: 0,
  // Compute arrow overflow (useful to hide it)
  arrowOverflow: !0,
  /**
   * By default, compute autohide on 'click'.
   */
  autoHideOnMousedown: !1,
  // Themes
  themes: {
    tooltip: {
      // Default tooltip placement relative to target element
      placement: "top",
      // Default events that trigger the tooltip
      triggers: ["hover", "focus", "touch"],
      // Close tooltip on click on tooltip target
      hideTriggers: (e) => [...e, "click"],
      // Delay (ms)
      delay: {
        show: 200,
        hide: 0
      },
      // Update popper on content resize
      handleResize: !1,
      // Enable HTML content in directive
      html: !1,
      // Displayed when tooltip content is loading
      loadingContent: "..."
    },
    dropdown: {
      // Default dropdown placement relative to target element
      placement: "bottom",
      // Default events that trigger the dropdown
      triggers: ["click"],
      // Delay (ms)
      delay: 0,
      // Update popper on content resize
      handleResize: !0,
      // Hide on clock outside
      autoHide: !0
    },
    menu: {
      $extend: "dropdown",
      triggers: ["hover", "focus"],
      popperTriggers: ["hover"],
      delay: {
        show: 0,
        hide: 400
      }
    }
  }
};
function S(e, j) {
  let ke = h.themes[e] || {}, Se;
  do
    Se = ke[j], typeof Se > "u" ? ke.$extend ? ke = h.themes[ke.$extend] || {} : (ke = null, Se = h[j]) : ke = null;
  while (ke);
  return Se;
}
function Ze(e) {
  const j = [e];
  let ke = h.themes[e] || {};
  do
    ke.$extend && !ke.$resetCss ? (j.push(ke.$extend), ke = h.themes[ke.$extend] || {}) : ke = null;
  while (ke);
  return j.map((Se) => `v-popper--theme-${Se}`);
}
function re(e) {
  const j = [e];
  let ke = h.themes[e] || {};
  do
    ke.$extend ? (j.push(ke.$extend), ke = h.themes[ke.$extend] || {}) : ke = null;
  while (ke);
  return j;
}
let $ = !1;
if (typeof window < "u") {
  $ = !1;
  try {
    const e = Object.defineProperty({}, "passive", {
      get() {
        $ = !0;
      }
    });
    window.addEventListener("test", null, e);
  } catch {
  }
}
let _e = !1;
typeof window < "u" && typeof navigator < "u" && (_e = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
const Te = ["auto", "top", "bottom", "left", "right"].reduce((e, j) => e.concat([
  j,
  `${j}-start`,
  `${j}-end`
]), []), pe = {
  hover: "mouseenter",
  focus: "focus",
  click: "click",
  touch: "touchstart",
  pointer: "pointerdown"
}, ae = {
  hover: "mouseleave",
  focus: "blur",
  click: "click",
  touch: "touchend",
  pointer: "pointerup"
};
function de(e, j) {
  const ke = e.indexOf(j);
  ke !== -1 && e.splice(ke, 1);
}
function G() {
  return new Promise((e) => requestAnimationFrame(() => {
    requestAnimationFrame(e);
  }));
}
const d = [];
let g = null;
const le = {};
function he(e) {
  let j = le[e];
  return j || (j = le[e] = []), j;
}
let Y = function() {
};
typeof window < "u" && (Y = window.Element);
function n(e) {
  return function(j) {
    return S(j.theme, e);
  };
}
const q = "__floating-vue__popper", Q = () => defineComponent({
  name: "VPopper",
  provide() {
    return {
      [q]: {
        parentPopper: this
      }
    };
  },
  inject: {
    [q]: { default: null }
  },
  props: {
    theme: {
      type: String,
      required: !0
    },
    targetNodes: {
      type: Function,
      required: !0
    },
    referenceNode: {
      type: Function,
      default: null
    },
    popperNode: {
      type: Function,
      required: !0
    },
    shown: {
      type: Boolean,
      default: !1
    },
    showGroup: {
      type: String,
      default: null
    },
    // eslint-disable-next-line vue/require-prop-types
    ariaId: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: n("disabled")
    },
    positioningDisabled: {
      type: Boolean,
      default: n("positioningDisabled")
    },
    placement: {
      type: String,
      default: n("placement"),
      validator: (e) => Te.includes(e)
    },
    delay: {
      type: [String, Number, Object],
      default: n("delay")
    },
    distance: {
      type: [Number, String],
      default: n("distance")
    },
    skidding: {
      type: [Number, String],
      default: n("skidding")
    },
    triggers: {
      type: Array,
      default: n("triggers")
    },
    showTriggers: {
      type: [Array, Function],
      default: n("showTriggers")
    },
    hideTriggers: {
      type: [Array, Function],
      default: n("hideTriggers")
    },
    popperTriggers: {
      type: Array,
      default: n("popperTriggers")
    },
    popperShowTriggers: {
      type: [Array, Function],
      default: n("popperShowTriggers")
    },
    popperHideTriggers: {
      type: [Array, Function],
      default: n("popperHideTriggers")
    },
    container: {
      type: [String, Object, Y, Boolean],
      default: n("container")
    },
    boundary: {
      type: [String, Y],
      default: n("boundary")
    },
    strategy: {
      type: String,
      validator: (e) => ["absolute", "fixed"].includes(e),
      default: n("strategy")
    },
    autoHide: {
      type: [Boolean, Function],
      default: n("autoHide")
    },
    handleResize: {
      type: Boolean,
      default: n("handleResize")
    },
    instantMove: {
      type: Boolean,
      default: n("instantMove")
    },
    eagerMount: {
      type: Boolean,
      default: n("eagerMount")
    },
    popperClass: {
      type: [String, Array, Object],
      default: n("popperClass")
    },
    computeTransformOrigin: {
      type: Boolean,
      default: n("computeTransformOrigin")
    },
    /**
     * @deprecated
     */
    autoMinSize: {
      type: Boolean,
      default: n("autoMinSize")
    },
    autoSize: {
      type: [Boolean, String],
      default: n("autoSize")
    },
    /**
     * @deprecated
     */
    autoMaxSize: {
      type: Boolean,
      default: n("autoMaxSize")
    },
    autoBoundaryMaxSize: {
      type: Boolean,
      default: n("autoBoundaryMaxSize")
    },
    preventOverflow: {
      type: Boolean,
      default: n("preventOverflow")
    },
    overflowPadding: {
      type: [Number, String],
      default: n("overflowPadding")
    },
    arrowPadding: {
      type: [Number, String],
      default: n("arrowPadding")
    },
    arrowOverflow: {
      type: Boolean,
      default: n("arrowOverflow")
    },
    flip: {
      type: Boolean,
      default: n("flip")
    },
    shift: {
      type: Boolean,
      default: n("shift")
    },
    shiftCrossAxis: {
      type: Boolean,
      default: n("shiftCrossAxis")
    },
    noAutoFocus: {
      type: Boolean,
      default: n("noAutoFocus")
    },
    disposeTimeout: {
      type: Number,
      default: n("disposeTimeout")
    }
  },
  emits: {
    show: () => !0,
    hide: () => !0,
    "update:shown": (e) => !0,
    "apply-show": () => !0,
    "apply-hide": () => !0,
    "close-group": () => !0,
    "close-directive": () => !0,
    "auto-hide": () => !0,
    resize: () => !0
  },
  data() {
    return {
      isShown: !1,
      isMounted: !1,
      skipTransition: !1,
      classes: {
        showFrom: !1,
        showTo: !1,
        hideFrom: !1,
        hideTo: !0
      },
      result: {
        x: 0,
        y: 0,
        placement: "",
        strategy: this.strategy,
        arrow: {
          x: 0,
          y: 0,
          centerOffset: 0
        },
        transformOrigin: null
      },
      randomId: `popper_${[Math.random(), Date.now()].map((e) => e.toString(36).substring(2, 10)).join("_")}`,
      shownChildren: /* @__PURE__ */ new Set(),
      lastAutoHide: !0,
      pendingHide: !1,
      containsGlobalTarget: !1,
      isDisposed: !0,
      mouseDownContains: !1
    };
  },
  computed: {
    popperId() {
      return this.ariaId != null ? this.ariaId : this.randomId;
    },
    shouldMountContent() {
      return this.eagerMount || this.isMounted;
    },
    slotData() {
      return {
        popperId: this.popperId,
        isShown: this.isShown,
        shouldMountContent: this.shouldMountContent,
        skipTransition: this.skipTransition,
        autoHide: typeof this.autoHide == "function" ? this.lastAutoHide : this.autoHide,
        show: this.show,
        hide: this.hide,
        handleResize: this.handleResize,
        onResize: this.onResize,
        classes: {
          ...this.classes,
          popperClass: this.popperClass
        },
        result: this.positioningDisabled ? null : this.result,
        attrs: this.$attrs
      };
    },
    parentPopper() {
      var e;
      return (e = this[q]) == null ? void 0 : e.parentPopper;
    },
    hasPopperShowTriggerHover() {
      var e, j;
      return ((e = this.popperTriggers) == null ? void 0 : e.includes("hover")) || ((j = this.popperShowTriggers) == null ? void 0 : j.includes("hover"));
    }
  },
  watch: {
    shown: "$_autoShowHide",
    disabled(e) {
      e ? this.dispose() : this.init();
    },
    async container() {
      this.isShown && (this.$_ensureTeleport(), await this.$_computePosition());
    },
    triggers: {
      handler: "$_refreshListeners",
      deep: !0
    },
    positioningDisabled: "$_refreshListeners",
    ...[
      "placement",
      "distance",
      "skidding",
      "boundary",
      "strategy",
      "overflowPadding",
      "arrowPadding",
      "preventOverflow",
      "shift",
      "shiftCrossAxis",
      "flip"
    ].reduce((e, j) => (e[j] = "$_computePosition", e), {})
  },
  created() {
    this.autoMinSize && console.warn('[floating-vue] `autoMinSize` option is deprecated. Use `autoSize="min"` instead.'), this.autoMaxSize && console.warn("[floating-vue] `autoMaxSize` option is deprecated. Use `autoBoundaryMaxSize` instead.");
  },
  mounted() {
    this.init(), this.$_detachPopperNode();
  },
  activated() {
    this.$_autoShowHide();
  },
  deactivated() {
    this.hide();
  },
  beforeUnmount() {
    this.dispose();
  },
  methods: {
    show({ event: e = null, skipDelay: j = !1, force: ke = !1 } = {}) {
      var Se, xe;
      (Se = this.parentPopper) != null && Se.lockedChild && this.parentPopper.lockedChild !== this || (this.pendingHide = !1, (ke || !this.disabled) && (((xe = this.parentPopper) == null ? void 0 : xe.lockedChild) === this && (this.parentPopper.lockedChild = null), this.$_scheduleShow(e, j), this.$emit("show"), this.$_showFrameLocked = !0, requestAnimationFrame(() => {
        this.$_showFrameLocked = !1;
      })), this.$emit("update:shown", !0));
    },
    hide({ event: e = null, skipDelay: j = !1 } = {}) {
      var ke;
      if (!this.$_hideInProgress) {
        if (this.shownChildren.size > 0) {
          this.pendingHide = !0;
          return;
        }
        if (this.hasPopperShowTriggerHover && this.$_isAimingPopper()) {
          this.parentPopper && (this.parentPopper.lockedChild = this, clearTimeout(this.parentPopper.lockedChildTimer), this.parentPopper.lockedChildTimer = setTimeout(() => {
            this.parentPopper.lockedChild === this && (this.parentPopper.lockedChild.hide({ skipDelay: j }), this.parentPopper.lockedChild = null);
          }, 1e3));
          return;
        }
        ((ke = this.parentPopper) == null ? void 0 : ke.lockedChild) === this && (this.parentPopper.lockedChild = null), this.pendingHide = !1, this.$_scheduleHide(e, j), this.$emit("hide"), this.$emit("update:shown", !1);
      }
    },
    init() {
      var e;
      this.isDisposed && (this.isDisposed = !1, this.isMounted = !1, this.$_events = [], this.$_preventShow = !1, this.$_referenceNode = ((e = this.referenceNode) == null ? void 0 : e.call(this)) ?? this.$el, this.$_targetNodes = this.targetNodes().filter((j) => j.nodeType === j.ELEMENT_NODE), this.$_popperNode = this.popperNode(), this.$_innerNode = this.$_popperNode.querySelector(".v-popper__inner"), this.$_arrowNode = this.$_popperNode.querySelector(".v-popper__arrow-container"), this.$_swapTargetAttrs("title", "data-original-title"), this.$_detachPopperNode(), this.triggers.length && this.$_addEventListeners(), this.shown && this.show());
    },
    dispose() {
      this.isDisposed || (this.isDisposed = !0, this.$_removeEventListeners(), this.hide({ skipDelay: !0 }), this.$_detachPopperNode(), this.isMounted = !1, this.isShown = !1, this.$_updateParentShownChildren(!1), this.$_swapTargetAttrs("data-original-title", "title"));
    },
    async onResize() {
      this.isShown && (await this.$_computePosition(), this.$emit("resize"));
    },
    async $_computePosition() {
      if (this.isDisposed || this.positioningDisabled)
        return;
      const e = {
        strategy: this.strategy,
        middleware: []
      };
      (this.distance || this.skidding) && e.middleware.push(offset({
        mainAxis: this.distance,
        crossAxis: this.skidding
      }));
      const j = this.placement.startsWith("auto");
      if (j ? e.middleware.push(autoPlacement({
        alignment: this.placement.split("-")[1] ?? ""
      })) : e.placement = this.placement, this.preventOverflow && (this.shift && e.middleware.push(shift({
        padding: this.overflowPadding,
        boundary: this.boundary,
        crossAxis: this.shiftCrossAxis
      })), !j && this.flip && e.middleware.push(flip({
        padding: this.overflowPadding,
        boundary: this.boundary
      }))), e.middleware.push(arrow({
        element: this.$_arrowNode,
        padding: this.arrowPadding
      })), this.arrowOverflow && e.middleware.push({
        name: "arrowOverflow",
        fn: ({ placement: Se, rects: xe, middlewareData: Ie }) => {
          let Me;
          const { centerOffset: Ee } = Ie.arrow;
          return Se.startsWith("top") || Se.startsWith("bottom") ? Me = Math.abs(Ee) > xe.reference.width / 2 : Me = Math.abs(Ee) > xe.reference.height / 2, {
            data: {
              overflow: Me
            }
          };
        }
      }), this.autoMinSize || this.autoSize) {
        const Se = this.autoSize ? this.autoSize : this.autoMinSize ? "min" : null;
        e.middleware.push({
          name: "autoSize",
          fn: ({ rects: xe, placement: Ie, middlewareData: Me }) => {
            var Ee;
            if ((Ee = Me.autoSize) != null && Ee.skip)
              return {};
            let Be, $e;
            return Ie.startsWith("top") || Ie.startsWith("bottom") ? Be = xe.reference.width : $e = xe.reference.height, this.$_innerNode.style[Se === "min" ? "minWidth" : Se === "max" ? "maxWidth" : "width"] = Be != null ? `${Be}px` : null, this.$_innerNode.style[Se === "min" ? "minHeight" : Se === "max" ? "maxHeight" : "height"] = $e != null ? `${$e}px` : null, {
              data: {
                skip: !0
              },
              reset: {
                rects: !0
              }
            };
          }
        });
      }
      (this.autoMaxSize || this.autoBoundaryMaxSize) && (this.$_innerNode.style.maxWidth = null, this.$_innerNode.style.maxHeight = null, e.middleware.push(size({
        boundary: this.boundary,
        padding: this.overflowPadding,
        apply: ({ availableWidth: Se, availableHeight: xe }) => {
          this.$_innerNode.style.maxWidth = Se != null ? `${Se}px` : null, this.$_innerNode.style.maxHeight = xe != null ? `${xe}px` : null;
        }
      })));
      const ke = await B$1(this.$_referenceNode, this.$_popperNode, e);
      Object.assign(this.result, {
        x: ke.x,
        y: ke.y,
        placement: ke.placement,
        strategy: ke.strategy,
        arrow: {
          ...ke.middlewareData.arrow,
          ...ke.middlewareData.arrowOverflow
        }
      });
    },
    $_scheduleShow(e, j = !1) {
      if (this.$_updateParentShownChildren(!0), this.$_hideInProgress = !1, clearTimeout(this.$_scheduleTimer), g && this.instantMove && g.instantMove && g !== this.parentPopper) {
        g.$_applyHide(!0), this.$_applyShow(!0);
        return;
      }
      j ? this.$_applyShow() : this.$_scheduleTimer = setTimeout(this.$_applyShow.bind(this), this.$_computeDelay("show"));
    },
    $_scheduleHide(e, j = !1) {
      if (this.shownChildren.size > 0) {
        this.pendingHide = !0;
        return;
      }
      this.$_updateParentShownChildren(!1), this.$_hideInProgress = !0, clearTimeout(this.$_scheduleTimer), this.isShown && (g = this), j ? this.$_applyHide() : this.$_scheduleTimer = setTimeout(this.$_applyHide.bind(this), this.$_computeDelay("hide"));
    },
    $_computeDelay(e) {
      const j = this.delay;
      return parseInt(j && j[e] || j || 0);
    },
    async $_applyShow(e = !1) {
      clearTimeout(this.$_disposeTimer), clearTimeout(this.$_scheduleTimer), this.skipTransition = e, !this.isShown && (this.$_ensureTeleport(), await G(), await this.$_computePosition(), await this.$_applyShowEffect(), this.positioningDisabled || this.$_registerEventListeners([
        ...D(this.$_referenceNode),
        ...D(this.$_popperNode)
      ], "scroll", () => {
        this.$_computePosition();
      }));
    },
    async $_applyShowEffect() {
      if (this.$_hideInProgress)
        return;
      if (this.computeTransformOrigin) {
        const j = this.$_referenceNode.getBoundingClientRect(), ke = this.$_popperNode.querySelector(".v-popper__wrapper"), Se = ke.parentNode.getBoundingClientRect(), xe = j.x + j.width / 2 - (Se.left + ke.offsetLeft), Ie = j.y + j.height / 2 - (Se.top + ke.offsetTop);
        this.result.transformOrigin = `${xe}px ${Ie}px`;
      }
      this.isShown = !0, this.$_applyAttrsToTarget({
        "aria-describedby": this.popperId,
        "data-popper-shown": ""
      });
      const e = this.showGroup;
      if (e) {
        let j;
        for (let ke = 0; ke < d.length; ke++)
          j = d[ke], j.showGroup !== e && (j.hide(), j.$emit("close-group"));
      }
      d.push(this), document.body.classList.add("v-popper--some-open");
      for (const j of re(this.theme))
        he(j).push(this), document.body.classList.add(`v-popper--some-open--${j}`);
      this.$emit("apply-show"), this.classes.showFrom = !0, this.classes.showTo = !1, this.classes.hideFrom = !1, this.classes.hideTo = !1, await G(), this.classes.showFrom = !1, this.classes.showTo = !0, this.noAutoFocus || this.$_popperNode.focus();
    },
    async $_applyHide(e = !1) {
      if (this.shownChildren.size > 0) {
        this.pendingHide = !0, this.$_hideInProgress = !1;
        return;
      }
      if (clearTimeout(this.$_scheduleTimer), !this.isShown)
        return;
      this.skipTransition = e, de(d, this), d.length === 0 && document.body.classList.remove("v-popper--some-open");
      for (const ke of re(this.theme)) {
        const Se = he(ke);
        de(Se, this), Se.length === 0 && document.body.classList.remove(`v-popper--some-open--${ke}`);
      }
      g === this && (g = null), this.isShown = !1, this.$_applyAttrsToTarget({
        "aria-describedby": void 0,
        "data-popper-shown": void 0
      }), clearTimeout(this.$_disposeTimer);
      const j = this.disposeTimeout;
      j !== null && (this.$_disposeTimer = setTimeout(() => {
        this.$_popperNode && (this.$_detachPopperNode(), this.isMounted = !1);
      }, j)), this.$_removeEventListeners("scroll"), this.$emit("apply-hide"), this.classes.showFrom = !1, this.classes.showTo = !1, this.classes.hideFrom = !0, this.classes.hideTo = !1, await G(), this.classes.hideFrom = !1, this.classes.hideTo = !0;
    },
    $_autoShowHide() {
      this.shown ? this.show() : this.hide();
    },
    $_ensureTeleport() {
      if (this.isDisposed)
        return;
      let e = this.container;
      if (typeof e == "string" ? e = window.document.querySelector(e) : e === !1 && (e = this.$_targetNodes[0].parentNode), !e)
        throw new Error("No container for popover: " + this.container);
      e.appendChild(this.$_popperNode), this.isMounted = !0;
    },
    $_addEventListeners() {
      const e = (ke) => {
        this.isShown && !this.$_hideInProgress || (ke.usedByTooltip = !0, !this.$_preventShow && this.show({ event: ke }));
      };
      this.$_registerTriggerListeners(this.$_targetNodes, pe, this.triggers, this.showTriggers, e), this.$_registerTriggerListeners([this.$_popperNode], pe, this.popperTriggers, this.popperShowTriggers, e);
      const j = (ke) => {
        ke.usedByTooltip || this.hide({ event: ke });
      };
      this.$_registerTriggerListeners(this.$_targetNodes, ae, this.triggers, this.hideTriggers, j), this.$_registerTriggerListeners([this.$_popperNode], ae, this.popperTriggers, this.popperHideTriggers, j);
    },
    $_registerEventListeners(e, j, ke) {
      this.$_events.push({ targetNodes: e, eventType: j, handler: ke }), e.forEach((Se) => Se.addEventListener(j, ke, $ ? {
        passive: !0
      } : void 0));
    },
    $_registerTriggerListeners(e, j, ke, Se, xe) {
      let Ie = ke;
      Se != null && (Ie = typeof Se == "function" ? Se(Ie) : Se), Ie.forEach((Me) => {
        const Ee = j[Me];
        Ee && this.$_registerEventListeners(e, Ee, xe);
      });
    },
    $_removeEventListeners(e) {
      const j = [];
      this.$_events.forEach((ke) => {
        const { targetNodes: Se, eventType: xe, handler: Ie } = ke;
        !e || e === xe ? Se.forEach((Me) => Me.removeEventListener(xe, Ie)) : j.push(ke);
      }), this.$_events = j;
    },
    $_refreshListeners() {
      this.isDisposed || (this.$_removeEventListeners(), this.$_addEventListeners());
    },
    $_handleGlobalClose(e, j = !1) {
      this.$_showFrameLocked || (this.hide({ event: e }), e.closePopover ? this.$emit("close-directive") : this.$emit("auto-hide"), j && (this.$_preventShow = !0, setTimeout(() => {
        this.$_preventShow = !1;
      }, 300)));
    },
    $_detachPopperNode() {
      this.$_popperNode.parentNode && this.$_popperNode.parentNode.removeChild(this.$_popperNode);
    },
    $_swapTargetAttrs(e, j) {
      for (const ke of this.$_targetNodes) {
        const Se = ke.getAttribute(e);
        Se && (ke.removeAttribute(e), ke.setAttribute(j, Se));
      }
    },
    $_applyAttrsToTarget(e) {
      for (const j of this.$_targetNodes)
        for (const ke in e) {
          const Se = e[ke];
          Se == null ? j.removeAttribute(ke) : j.setAttribute(ke, Se);
        }
    },
    $_updateParentShownChildren(e) {
      let j = this.parentPopper;
      for (; j; )
        e ? j.shownChildren.add(this.randomId) : (j.shownChildren.delete(this.randomId), j.pendingHide && j.hide()), j = j.parentPopper;
    },
    $_isAimingPopper() {
      const e = this.$_referenceNode.getBoundingClientRect();
      if (y >= e.left && y <= e.right && _ >= e.top && _ <= e.bottom) {
        const j = this.$_popperNode.getBoundingClientRect(), ke = y - c, Se = _ - m, xe = j.left + j.width / 2 - c + (j.top + j.height / 2) - m + j.width + j.height, Ie = c + ke * xe, Me = m + Se * xe;
        return C(c, m, Ie, Me, j.left, j.top, j.left, j.bottom) || // Left edge
        C(c, m, Ie, Me, j.left, j.top, j.right, j.top) || // Top edge
        C(c, m, Ie, Me, j.right, j.top, j.right, j.bottom) || // Right edge
        C(c, m, Ie, Me, j.left, j.bottom, j.right, j.bottom);
      }
      return !1;
    }
  },
  render() {
    return this.$slots.default(this.slotData);
  }
});
if (typeof document < "u" && typeof window < "u") {
  if (_e) {
    const e = $ ? {
      passive: !0,
      capture: !0
    } : !0;
    document.addEventListener("touchstart", (j) => ue(j), e), document.addEventListener("touchend", (j) => fe(j, !0), e);
  } else
    window.addEventListener("mousedown", (e) => ue(e), !0), window.addEventListener("click", (e) => fe(e, !1), !0);
  window.addEventListener("resize", tt);
}
function ue(e, j) {
  for (let ke = 0; ke < d.length; ke++) {
    const Se = d[ke];
    try {
      Se.mouseDownContains = Se.popperNode().contains(e.target);
    } catch {
    }
  }
}
function fe(e, j) {
  Pe(e, j);
}
function Pe(e, j) {
  const ke = {};
  for (let Se = d.length - 1; Se >= 0; Se--) {
    const xe = d[Se];
    try {
      const Ie = xe.containsGlobalTarget = xe.mouseDownContains || xe.popperNode().contains(e.target);
      xe.pendingHide = !1, requestAnimationFrame(() => {
        if (xe.pendingHide = !1, !ke[xe.randomId] && ce(xe, Ie, e)) {
          if (xe.$_handleGlobalClose(e, j), !e.closeAllPopover && e.closePopover && Ie) {
            let Ee = xe.parentPopper;
            for (; Ee; )
              ke[Ee.randomId] = !0, Ee = Ee.parentPopper;
            return;
          }
          let Me = xe.parentPopper;
          for (; Me && ce(Me, Me.containsGlobalTarget, e); )
            Me.$_handleGlobalClose(e, j), Me = Me.parentPopper;
        }
      });
    } catch {
    }
  }
}
function ce(e, j, ke) {
  return ke.closeAllPopover || ke.closePopover && j || et(e, ke) && !j;
}
function et(e, j) {
  if (typeof e.autoHide == "function") {
    const ke = e.autoHide(j);
    return e.lastAutoHide = ke, ke;
  }
  return e.autoHide;
}
function tt() {
  for (let e = 0; e < d.length; e++)
    d[e].$_computePosition();
}
let c = 0, m = 0, y = 0, _ = 0;
typeof window < "u" && window.addEventListener("mousemove", (e) => {
  c = y, m = _, y = e.clientX, _ = e.clientY;
}, $ ? {
  passive: !0
} : void 0);
function C(e, j, ke, Se, xe, Ie, Me, Ee) {
  const Be = ((Me - xe) * (j - Ie) - (Ee - Ie) * (e - xe)) / ((Ee - Ie) * (ke - e) - (Me - xe) * (Se - j)), $e = ((ke - e) * (j - Ie) - (Se - j) * (e - xe)) / ((Ee - Ie) * (ke - e) - (Me - xe) * (Se - j));
  return Be >= 0 && Be <= 1 && $e >= 0 && $e <= 1;
}
const ot = {
  extends: Q()
}, B = (e, j) => {
  const ke = e.__vccOpts || e;
  for (const [Se, xe] of j)
    ke[Se] = xe;
  return ke;
};
function it(e, j, ke, Se, xe, Ie) {
  return openBlock(), createElementBlock("div", {
    ref: "reference",
    class: normalizeClass(["v-popper", {
      "v-popper--shown": e.slotData.isShown
    }])
  }, [
    renderSlot(e.$slots, "default", normalizeProps(guardReactiveProps(e.slotData)))
  ], 2);
}
const st = /* @__PURE__ */ B(ot, [["render", it]]);
function nt() {
  var e = window.navigator.userAgent, j = e.indexOf("MSIE ");
  if (j > 0)
    return parseInt(e.substring(j + 5, e.indexOf(".", j)), 10);
  var ke = e.indexOf("Trident/");
  if (ke > 0) {
    var Se = e.indexOf("rv:");
    return parseInt(e.substring(Se + 3, e.indexOf(".", Se)), 10);
  }
  var xe = e.indexOf("Edge/");
  return xe > 0 ? parseInt(e.substring(xe + 5, e.indexOf(".", xe)), 10) : -1;
}
let z;
function X() {
  X.init || (X.init = !0, z = nt() !== -1);
}
var E = {
  name: "ResizeObserver",
  props: {
    emitOnMount: {
      type: Boolean,
      default: !1
    },
    ignoreWidth: {
      type: Boolean,
      default: !1
    },
    ignoreHeight: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "notify"
  ],
  mounted() {
    X(), nextTick(() => {
      this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitOnMount && this.emitSize();
    });
    const e = document.createElement("object");
    this._resizeObject = e, e.setAttribute("aria-hidden", "true"), e.setAttribute("tabindex", -1), e.onload = this.addResizeHandlers, e.type = "text/html", z && this.$el.appendChild(e), e.data = "about:blank", z || this.$el.appendChild(e);
  },
  beforeUnmount() {
    this.removeResizeHandlers();
  },
  methods: {
    compareAndNotify() {
      (!this.ignoreWidth && this._w !== this.$el.offsetWidth || !this.ignoreHeight && this._h !== this.$el.offsetHeight) && (this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitSize());
    },
    emitSize() {
      this.$emit("notify", {
        width: this._w,
        height: this._h
      });
    },
    addResizeHandlers() {
      this._resizeObject.contentDocument.defaultView.addEventListener("resize", this.compareAndNotify), this.compareAndNotify();
    },
    removeResizeHandlers() {
      this._resizeObject && this._resizeObject.onload && (!z && this._resizeObject.contentDocument && this._resizeObject.contentDocument.defaultView.removeEventListener("resize", this.compareAndNotify), this.$el.removeChild(this._resizeObject), this._resizeObject.onload = null, this._resizeObject = null);
    }
  }
};
const rt = /* @__PURE__ */ withScopeId("data-v-b329ee4c");
pushScopeId("data-v-b329ee4c");
const pt = {
  class: "resize-observer",
  tabindex: "-1"
};
popScopeId();
const at = /* @__PURE__ */ rt((e, j, ke, Se, xe, Ie) => (openBlock(), createBlock("div", pt)));
E.render = at;
E.__scopeId = "data-v-b329ee4c";
E.__file = "src/components/ResizeObserver.vue";
const Z = (e = "theme") => ({
  computed: {
    themeClass() {
      return Ze(this[e]);
    }
  }
}), dt = defineComponent({
  name: "VPopperContent",
  components: {
    ResizeObserver: E
  },
  mixins: [
    Z()
  ],
  props: {
    popperId: String,
    theme: String,
    shown: Boolean,
    mounted: Boolean,
    skipTransition: Boolean,
    autoHide: Boolean,
    handleResize: Boolean,
    classes: Object,
    result: Object
  },
  emits: [
    "hide",
    "resize"
  ],
  methods: {
    toPx(e) {
      return e != null && !isNaN(e) ? `${e}px` : null;
    }
  }
}), lt = ["id", "aria-hidden", "tabindex", "data-popper-placement"], ht = {
  ref: "inner",
  class: "v-popper__inner"
}, ut = /* @__PURE__ */ createElementVNode("div", { class: "v-popper__arrow-outer" }, null, -1), ft = /* @__PURE__ */ createElementVNode("div", { class: "v-popper__arrow-inner" }, null, -1), ct = [
  ut,
  ft
];
function mt(e, j, ke, Se, xe, Ie) {
  const Me = resolveComponent("ResizeObserver");
  return openBlock(), createElementBlock("div", {
    id: e.popperId,
    ref: "popover",
    class: normalizeClass(["v-popper__popper", [
      e.themeClass,
      e.classes.popperClass,
      {
        "v-popper__popper--shown": e.shown,
        "v-popper__popper--hidden": !e.shown,
        "v-popper__popper--show-from": e.classes.showFrom,
        "v-popper__popper--show-to": e.classes.showTo,
        "v-popper__popper--hide-from": e.classes.hideFrom,
        "v-popper__popper--hide-to": e.classes.hideTo,
        "v-popper__popper--skip-transition": e.skipTransition,
        "v-popper__popper--arrow-overflow": e.result && e.result.arrow.overflow,
        "v-popper__popper--no-positioning": !e.result
      }
    ]]),
    style: normalizeStyle(e.result ? {
      position: e.result.strategy,
      transform: `translate3d(${Math.round(e.result.x)}px,${Math.round(e.result.y)}px,0)`
    } : void 0),
    "aria-hidden": e.shown ? "false" : "true",
    tabindex: e.autoHide ? 0 : void 0,
    "data-popper-placement": e.result ? e.result.placement : void 0,
    onKeyup: j[2] || (j[2] = withKeys((Ee) => e.autoHide && e.$emit("hide"), ["esc"]))
  }, [
    createElementVNode("div", {
      class: "v-popper__backdrop",
      onClick: j[0] || (j[0] = (Ee) => e.autoHide && e.$emit("hide"))
    }),
    createElementVNode("div", {
      class: "v-popper__wrapper",
      style: normalizeStyle(e.result ? {
        transformOrigin: e.result.transformOrigin
      } : void 0)
    }, [
      createElementVNode("div", ht, [
        e.mounted ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createElementVNode("div", null, [
            renderSlot(e.$slots, "default")
          ]),
          e.handleResize ? (openBlock(), createBlock(Me, {
            key: 0,
            onNotify: j[1] || (j[1] = (Ee) => e.$emit("resize", Ee))
          })) : createCommentVNode("", !0)
        ], 64)) : createCommentVNode("", !0)
      ], 512),
      createElementVNode("div", {
        ref: "arrow",
        class: "v-popper__arrow-container",
        style: normalizeStyle(e.result ? {
          left: e.toPx(e.result.arrow.x),
          top: e.toPx(e.result.arrow.y)
        } : void 0)
      }, ct, 4)
    ], 4)
  ], 46, lt);
}
const ee = /* @__PURE__ */ B(dt, [["render", mt]]), te = {
  methods: {
    show(...e) {
      return this.$refs.popper.show(...e);
    },
    hide(...e) {
      return this.$refs.popper.hide(...e);
    },
    dispose(...e) {
      return this.$refs.popper.dispose(...e);
    },
    onResize(...e) {
      return this.$refs.popper.onResize(...e);
    }
  }
};
let K = function() {
};
typeof window < "u" && (K = window.Element);
const gt = defineComponent({
  name: "VPopperWrapper",
  components: {
    Popper: st,
    PopperContent: ee
  },
  mixins: [
    te,
    Z("finalTheme")
  ],
  props: {
    theme: {
      type: String,
      default: null
    },
    referenceNode: {
      type: Function,
      default: null
    },
    shown: {
      type: Boolean,
      default: !1
    },
    showGroup: {
      type: String,
      default: null
    },
    // eslint-disable-next-line vue/require-prop-types
    ariaId: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    positioningDisabled: {
      type: Boolean,
      default: void 0
    },
    placement: {
      type: String,
      default: void 0
    },
    delay: {
      type: [String, Number, Object],
      default: void 0
    },
    distance: {
      type: [Number, String],
      default: void 0
    },
    skidding: {
      type: [Number, String],
      default: void 0
    },
    triggers: {
      type: Array,
      default: void 0
    },
    showTriggers: {
      type: [Array, Function],
      default: void 0
    },
    hideTriggers: {
      type: [Array, Function],
      default: void 0
    },
    popperTriggers: {
      type: Array,
      default: void 0
    },
    popperShowTriggers: {
      type: [Array, Function],
      default: void 0
    },
    popperHideTriggers: {
      type: [Array, Function],
      default: void 0
    },
    container: {
      type: [String, Object, K, Boolean],
      default: void 0
    },
    boundary: {
      type: [String, K],
      default: void 0
    },
    strategy: {
      type: String,
      default: void 0
    },
    autoHide: {
      type: [Boolean, Function],
      default: void 0
    },
    handleResize: {
      type: Boolean,
      default: void 0
    },
    instantMove: {
      type: Boolean,
      default: void 0
    },
    eagerMount: {
      type: Boolean,
      default: void 0
    },
    popperClass: {
      type: [String, Array, Object],
      default: void 0
    },
    computeTransformOrigin: {
      type: Boolean,
      default: void 0
    },
    /**
     * @deprecated
     */
    autoMinSize: {
      type: Boolean,
      default: void 0
    },
    autoSize: {
      type: [Boolean, String],
      default: void 0
    },
    /**
     * @deprecated
     */
    autoMaxSize: {
      type: Boolean,
      default: void 0
    },
    autoBoundaryMaxSize: {
      type: Boolean,
      default: void 0
    },
    preventOverflow: {
      type: Boolean,
      default: void 0
    },
    overflowPadding: {
      type: [Number, String],
      default: void 0
    },
    arrowPadding: {
      type: [Number, String],
      default: void 0
    },
    arrowOverflow: {
      type: Boolean,
      default: void 0
    },
    flip: {
      type: Boolean,
      default: void 0
    },
    shift: {
      type: Boolean,
      default: void 0
    },
    shiftCrossAxis: {
      type: Boolean,
      default: void 0
    },
    noAutoFocus: {
      type: Boolean,
      default: void 0
    },
    disposeTimeout: {
      type: Number,
      default: void 0
    }
  },
  emits: {
    show: () => !0,
    hide: () => !0,
    "update:shown": (e) => !0,
    "apply-show": () => !0,
    "apply-hide": () => !0,
    "close-group": () => !0,
    "close-directive": () => !0,
    "auto-hide": () => !0,
    resize: () => !0
  },
  computed: {
    finalTheme() {
      return this.theme ?? this.$options.vPopperTheme;
    }
  },
  methods: {
    getTargetNodes() {
      return Array.from(this.$el.children).filter((e) => e !== this.$refs.popperContent.$el);
    }
  }
});
function wt(e, j, ke, Se, xe, Ie) {
  const Me = resolveComponent("PopperContent"), Ee = resolveComponent("Popper");
  return openBlock(), createBlock(Ee, mergeProps({ ref: "popper" }, e.$props, {
    theme: e.finalTheme,
    "target-nodes": e.getTargetNodes,
    "popper-node": () => e.$refs.popperContent.$el,
    class: [
      e.themeClass
    ],
    onShow: j[0] || (j[0] = () => e.$emit("show")),
    onHide: j[1] || (j[1] = () => e.$emit("hide")),
    "onUpdate:shown": j[2] || (j[2] = (Be) => e.$emit("update:shown", Be)),
    onApplyShow: j[3] || (j[3] = () => e.$emit("apply-show")),
    onApplyHide: j[4] || (j[4] = () => e.$emit("apply-hide")),
    onCloseGroup: j[5] || (j[5] = () => e.$emit("close-group")),
    onCloseDirective: j[6] || (j[6] = () => e.$emit("close-directive")),
    onAutoHide: j[7] || (j[7] = () => e.$emit("auto-hide")),
    onResize: j[8] || (j[8] = () => e.$emit("resize"))
  }), {
    default: withCtx(({
      popperId: Be,
      isShown: $e,
      shouldMountContent: Le,
      skipTransition: Fe,
      autoHide: Ve,
      show: je,
      hide: Ge,
      handleResize: De,
      onResize: Ue,
      classes: Re,
      result: Ye
    }) => [
      renderSlot(e.$slots, "default", {
        shown: $e,
        show: je,
        hide: Ge
      }),
      createVNode(Me, {
        ref: "popperContent",
        "popper-id": Be,
        theme: e.finalTheme,
        shown: $e,
        mounted: Le,
        "skip-transition": Fe,
        "auto-hide": Ve,
        "handle-resize": De,
        classes: Re,
        result: Ye,
        onHide: Ge,
        onResize: Ue
      }, {
        default: withCtx(() => [
          renderSlot(e.$slots, "popper", {
            shown: $e,
            hide: Ge
          })
        ]),
        _: 2
      }, 1032, ["popper-id", "theme", "shown", "mounted", "skip-transition", "auto-hide", "handle-resize", "classes", "result", "onHide", "onResize"])
    ]),
    _: 3
  }, 16, ["theme", "target-nodes", "popper-node", "class"]);
}
const k = /* @__PURE__ */ B(gt, [["render", wt]]);
({
  ...k
});
({
  ...k
});
({
  ...k
});
const $t = defineComponent({
  name: "VTooltipDirective",
  components: {
    Popper: Q(),
    PopperContent: ee
  },
  mixins: [
    te
  ],
  inheritAttrs: !1,
  props: {
    theme: {
      type: String,
      default: "tooltip"
    },
    html: {
      type: Boolean,
      default: (e) => S(e.theme, "html")
    },
    content: {
      type: [String, Number, Function],
      default: null
    },
    loadingContent: {
      type: String,
      default: (e) => S(e.theme, "loadingContent")
    },
    targetNodes: {
      type: Function,
      required: !0
    }
  },
  data() {
    return {
      asyncContent: null
    };
  },
  computed: {
    isContentAsync() {
      return typeof this.content == "function";
    },
    loading() {
      return this.isContentAsync && this.asyncContent == null;
    },
    finalContent() {
      return this.isContentAsync ? this.loading ? this.loadingContent : this.asyncContent : this.content;
    }
  },
  watch: {
    content: {
      handler() {
        this.fetchContent(!0);
      },
      immediate: !0
    },
    async finalContent() {
      await this.$nextTick(), this.$refs.popper.onResize();
    }
  },
  created() {
    this.$_fetchId = 0;
  },
  methods: {
    fetchContent(e) {
      if (typeof this.content == "function" && this.$_isShown && (e || !this.$_loading && this.asyncContent == null)) {
        this.asyncContent = null, this.$_loading = !0;
        const j = ++this.$_fetchId, ke = this.content(this);
        ke.then ? ke.then((Se) => this.onResult(j, Se)) : this.onResult(j, ke);
      }
    },
    onResult(e, j) {
      e === this.$_fetchId && (this.$_loading = !1, this.asyncContent = j);
    },
    onShow() {
      this.$_isShown = !0, this.fetchContent();
    },
    onHide() {
      this.$_isShown = !1;
    }
  }
}), vt = ["innerHTML"], yt = ["textContent"];
function _t(e, j, ke, Se, xe, Ie) {
  const Me = resolveComponent("PopperContent"), Ee = resolveComponent("Popper");
  return openBlock(), createBlock(Ee, mergeProps({ ref: "popper" }, e.$attrs, {
    theme: e.theme,
    "target-nodes": e.targetNodes,
    "popper-node": () => e.$refs.popperContent.$el,
    onApplyShow: e.onShow,
    onApplyHide: e.onHide
  }), {
    default: withCtx(({
      popperId: Be,
      isShown: $e,
      shouldMountContent: Le,
      skipTransition: Fe,
      autoHide: Ve,
      hide: je,
      handleResize: Ge,
      onResize: De,
      classes: Ue,
      result: Re
    }) => [
      createVNode(Me, {
        ref: "popperContent",
        class: normalizeClass({
          "v-popper--tooltip-loading": e.loading
        }),
        "popper-id": Be,
        theme: e.theme,
        shown: $e,
        mounted: Le,
        "skip-transition": Fe,
        "auto-hide": Ve,
        "handle-resize": Ge,
        classes: Ue,
        result: Re,
        onHide: je,
        onResize: De
      }, {
        default: withCtx(() => [
          e.html ? (openBlock(), createElementBlock("div", {
            key: 0,
            innerHTML: e.finalContent
          }, null, 8, vt)) : (openBlock(), createElementBlock("div", {
            key: 1,
            textContent: toDisplayString(e.finalContent)
          }, null, 8, yt))
        ]),
        _: 2
      }, 1032, ["class", "popper-id", "theme", "shown", "mounted", "skip-transition", "auto-hide", "handle-resize", "classes", "result", "onHide", "onResize"])
    ]),
    _: 1
  }, 16, ["theme", "target-nodes", "popper-node", "onApplyShow", "onApplyHide"]);
}
const ze = /* @__PURE__ */ B($t, [["render", _t]]), Ae = "v-popper--has-tooltip";
function Tt(e, j) {
  let ke = e.placement;
  if (!ke && j)
    for (const Se of Te)
      j[Se] && (ke = Se);
  return ke || (ke = S(e.theme || "tooltip", "placement")), ke;
}
function Ne(e, j, ke) {
  let Se;
  const xe = typeof j;
  return xe === "string" ? Se = { content: j } : j && xe === "object" ? Se = j : Se = { content: !1 }, Se.placement = Tt(Se, ke), Se.targetNodes = () => [e], Se.referenceNode = () => e, Se;
}
let x, b, Pt = 0;
function St() {
  if (x)
    return;
  b = ref([]), x = createApp({
    name: "VTooltipDirectiveApp",
    setup() {
      return {
        directives: b
      };
    },
    render() {
      return this.directives.map((j) => h$2(ze, {
        ...j.options,
        shown: j.shown || j.options.shown,
        key: j.id
      }));
    },
    devtools: {
      hide: !0
    }
  });
  const e = document.createElement("div");
  document.body.appendChild(e), x.mount(e);
}
function bt(e, j, ke) {
  St();
  const Se = ref(Ne(e, j, ke)), xe = ref(!1), Ie = {
    id: Pt++,
    options: Se,
    shown: xe
  };
  return b.value.push(Ie), e.classList && e.classList.add(Ae), e.$_popper = {
    options: Se,
    item: Ie,
    show() {
      xe.value = !0;
    },
    hide() {
      xe.value = !1;
    }
  };
}
function He(e) {
  if (e.$_popper) {
    const j = b.value.indexOf(e.$_popper.item);
    j !== -1 && b.value.splice(j, 1), delete e.$_popper, delete e.$_popperOldShown, delete e.$_popperMountTarget;
  }
  e.classList && e.classList.remove(Ae);
}
function me(e, { value: j, modifiers: ke }) {
  const Se = Ne(e, j, ke);
  if (!Se.content || S(Se.theme || "tooltip", "disabled"))
    He(e);
  else {
    let xe;
    e.$_popper ? (xe = e.$_popper, xe.options.value = Se) : xe = bt(e, j, ke), typeof j.shown < "u" && j.shown !== e.$_popperOldShown && (e.$_popperOldShown = j.shown, j.shown ? xe.show() : xe.hide());
  }
}
const oe = {
  beforeMount: me,
  updated: me,
  beforeUnmount(e) {
    He(e);
  }
}, Mt = oe, _sfc_main$1s = /* @__PURE__ */ defineComponent({
  __name: "SatTooltip",
  props: {
    content: {},
    trigger: {},
    position: {}
  },
  setup(e) {
    const j = bemBuilder("atom-tooltip"), ke = e, Se = computed(() => {
      const xe = {
        content: ke.content,
        distance: 10
      };
      return ke.trigger && (xe.trigger = ke.trigger), ke.position && (xe.position = ke.position), xe;
    });
    return (xe, Ie) => withDirectives((openBlock(), createElementBlock("span", {
      class: normalizeClass(unref(j)())
    }, [
      renderSlot(xe.$slots, "default")
    ], 2)), [
      [unref(Mt), Se.value]
    ]);
  }
}), className$1k = "sat-qr-code-generator", css$1k = bemBuilder(className$1k);
bemBuilder(className$1k, !0);
var browser = {}, canPromise, hasRequiredCanPromise;
function requireCanPromise() {
  return hasRequiredCanPromise || (hasRequiredCanPromise = 1, canPromise = function() {
    return typeof Promise == "function" && Promise.prototype && Promise.prototype.then;
  }), canPromise;
}
var qrcode = {}, utils$1 = {}, hasRequiredUtils$1;
function requireUtils$1() {
  if (hasRequiredUtils$1) return utils$1;
  hasRequiredUtils$1 = 1;
  let e;
  const j = [
    0,
    // Not used
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
  ];
  return utils$1.getSymbolSize = function(Se) {
    if (!Se) throw new Error('"version" cannot be null or undefined');
    if (Se < 1 || Se > 40) throw new Error('"version" should be in range from 1 to 40');
    return Se * 4 + 17;
  }, utils$1.getSymbolTotalCodewords = function(Se) {
    return j[Se];
  }, utils$1.getBCHDigit = function(ke) {
    let Se = 0;
    for (; ke !== 0; )
      Se++, ke >>>= 1;
    return Se;
  }, utils$1.setToSJISFunction = function(Se) {
    if (typeof Se != "function")
      throw new Error('"toSJISFunc" is not a valid function.');
    e = Se;
  }, utils$1.isKanjiModeEnabled = function() {
    return typeof e < "u";
  }, utils$1.toSJIS = function(Se) {
    return e(Se);
  }, utils$1;
}
var errorCorrectionLevel = {}, hasRequiredErrorCorrectionLevel;
function requireErrorCorrectionLevel() {
  return hasRequiredErrorCorrectionLevel || (hasRequiredErrorCorrectionLevel = 1, function(e) {
    e.L = { bit: 1 }, e.M = { bit: 0 }, e.Q = { bit: 3 }, e.H = { bit: 2 };
    function j(ke) {
      if (typeof ke != "string")
        throw new Error("Param is not a string");
      switch (ke.toLowerCase()) {
        case "l":
        case "low":
          return e.L;
        case "m":
        case "medium":
          return e.M;
        case "q":
        case "quartile":
          return e.Q;
        case "h":
        case "high":
          return e.H;
        default:
          throw new Error("Unknown EC Level: " + ke);
      }
    }
    e.isValid = function(Se) {
      return Se && typeof Se.bit < "u" && Se.bit >= 0 && Se.bit < 4;
    }, e.from = function(Se, xe) {
      if (e.isValid(Se))
        return Se;
      try {
        return j(Se);
      } catch {
        return xe;
      }
    };
  }(errorCorrectionLevel)), errorCorrectionLevel;
}
var bitBuffer, hasRequiredBitBuffer;
function requireBitBuffer() {
  if (hasRequiredBitBuffer) return bitBuffer;
  hasRequiredBitBuffer = 1;
  function e() {
    this.buffer = [], this.length = 0;
  }
  return e.prototype = {
    get: function(j) {
      const ke = Math.floor(j / 8);
      return (this.buffer[ke] >>> 7 - j % 8 & 1) === 1;
    },
    put: function(j, ke) {
      for (let Se = 0; Se < ke; Se++)
        this.putBit((j >>> ke - Se - 1 & 1) === 1);
    },
    getLengthInBits: function() {
      return this.length;
    },
    putBit: function(j) {
      const ke = Math.floor(this.length / 8);
      this.buffer.length <= ke && this.buffer.push(0), j && (this.buffer[ke] |= 128 >>> this.length % 8), this.length++;
    }
  }, bitBuffer = e, bitBuffer;
}
var bitMatrix, hasRequiredBitMatrix;
function requireBitMatrix() {
  if (hasRequiredBitMatrix) return bitMatrix;
  hasRequiredBitMatrix = 1;
  function e(j) {
    if (!j || j < 1)
      throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = j, this.data = new Uint8Array(j * j), this.reservedBit = new Uint8Array(j * j);
  }
  return e.prototype.set = function(j, ke, Se, xe) {
    const Ie = j * this.size + ke;
    this.data[Ie] = Se, xe && (this.reservedBit[Ie] = !0);
  }, e.prototype.get = function(j, ke) {
    return this.data[j * this.size + ke];
  }, e.prototype.xor = function(j, ke, Se) {
    this.data[j * this.size + ke] ^= Se;
  }, e.prototype.isReserved = function(j, ke) {
    return this.reservedBit[j * this.size + ke];
  }, bitMatrix = e, bitMatrix;
}
var alignmentPattern = {}, hasRequiredAlignmentPattern;
function requireAlignmentPattern() {
  return hasRequiredAlignmentPattern || (hasRequiredAlignmentPattern = 1, function(e) {
    const j = requireUtils$1().getSymbolSize;
    e.getRowColCoords = function(Se) {
      if (Se === 1) return [];
      const xe = Math.floor(Se / 7) + 2, Ie = j(Se), Me = Ie === 145 ? 26 : Math.ceil((Ie - 13) / (2 * xe - 2)) * 2, Ee = [Ie - 7];
      for (let Be = 1; Be < xe - 1; Be++)
        Ee[Be] = Ee[Be - 1] - Me;
      return Ee.push(6), Ee.reverse();
    }, e.getPositions = function(Se) {
      const xe = [], Ie = e.getRowColCoords(Se), Me = Ie.length;
      for (let Ee = 0; Ee < Me; Ee++)
        for (let Be = 0; Be < Me; Be++)
          Ee === 0 && Be === 0 || // top-left
          Ee === 0 && Be === Me - 1 || // bottom-left
          Ee === Me - 1 && Be === 0 || xe.push([Ie[Ee], Ie[Be]]);
      return xe;
    };
  }(alignmentPattern)), alignmentPattern;
}
var finderPattern = {}, hasRequiredFinderPattern;
function requireFinderPattern() {
  if (hasRequiredFinderPattern) return finderPattern;
  hasRequiredFinderPattern = 1;
  const e = requireUtils$1().getSymbolSize, j = 7;
  return finderPattern.getPositions = function(Se) {
    const xe = e(Se);
    return [
      // top-left
      [0, 0],
      // top-right
      [xe - j, 0],
      // bottom-left
      [0, xe - j]
    ];
  }, finderPattern;
}
var maskPattern = {}, hasRequiredMaskPattern;
function requireMaskPattern() {
  return hasRequiredMaskPattern || (hasRequiredMaskPattern = 1, function(e) {
    e.Patterns = {
      PATTERN000: 0,
      PATTERN001: 1,
      PATTERN010: 2,
      PATTERN011: 3,
      PATTERN100: 4,
      PATTERN101: 5,
      PATTERN110: 6,
      PATTERN111: 7
    };
    const j = {
      N1: 3,
      N2: 3,
      N3: 40,
      N4: 10
    };
    e.isValid = function(xe) {
      return xe != null && xe !== "" && !isNaN(xe) && xe >= 0 && xe <= 7;
    }, e.from = function(xe) {
      return e.isValid(xe) ? parseInt(xe, 10) : void 0;
    }, e.getPenaltyN1 = function(xe) {
      const Ie = xe.size;
      let Me = 0, Ee = 0, Be = 0, $e = null, Le = null;
      for (let Fe = 0; Fe < Ie; Fe++) {
        Ee = Be = 0, $e = Le = null;
        for (let Ve = 0; Ve < Ie; Ve++) {
          let je = xe.get(Fe, Ve);
          je === $e ? Ee++ : (Ee >= 5 && (Me += j.N1 + (Ee - 5)), $e = je, Ee = 1), je = xe.get(Ve, Fe), je === Le ? Be++ : (Be >= 5 && (Me += j.N1 + (Be - 5)), Le = je, Be = 1);
        }
        Ee >= 5 && (Me += j.N1 + (Ee - 5)), Be >= 5 && (Me += j.N1 + (Be - 5));
      }
      return Me;
    }, e.getPenaltyN2 = function(xe) {
      const Ie = xe.size;
      let Me = 0;
      for (let Ee = 0; Ee < Ie - 1; Ee++)
        for (let Be = 0; Be < Ie - 1; Be++) {
          const $e = xe.get(Ee, Be) + xe.get(Ee, Be + 1) + xe.get(Ee + 1, Be) + xe.get(Ee + 1, Be + 1);
          ($e === 4 || $e === 0) && Me++;
        }
      return Me * j.N2;
    }, e.getPenaltyN3 = function(xe) {
      const Ie = xe.size;
      let Me = 0, Ee = 0, Be = 0;
      for (let $e = 0; $e < Ie; $e++) {
        Ee = Be = 0;
        for (let Le = 0; Le < Ie; Le++)
          Ee = Ee << 1 & 2047 | xe.get($e, Le), Le >= 10 && (Ee === 1488 || Ee === 93) && Me++, Be = Be << 1 & 2047 | xe.get(Le, $e), Le >= 10 && (Be === 1488 || Be === 93) && Me++;
      }
      return Me * j.N3;
    }, e.getPenaltyN4 = function(xe) {
      let Ie = 0;
      const Me = xe.data.length;
      for (let Be = 0; Be < Me; Be++) Ie += xe.data[Be];
      return Math.abs(Math.ceil(Ie * 100 / Me / 5) - 10) * j.N4;
    };
    function ke(Se, xe, Ie) {
      switch (Se) {
        case e.Patterns.PATTERN000:
          return (xe + Ie) % 2 === 0;
        case e.Patterns.PATTERN001:
          return xe % 2 === 0;
        case e.Patterns.PATTERN010:
          return Ie % 3 === 0;
        case e.Patterns.PATTERN011:
          return (xe + Ie) % 3 === 0;
        case e.Patterns.PATTERN100:
          return (Math.floor(xe / 2) + Math.floor(Ie / 3)) % 2 === 0;
        case e.Patterns.PATTERN101:
          return xe * Ie % 2 + xe * Ie % 3 === 0;
        case e.Patterns.PATTERN110:
          return (xe * Ie % 2 + xe * Ie % 3) % 2 === 0;
        case e.Patterns.PATTERN111:
          return (xe * Ie % 3 + (xe + Ie) % 2) % 2 === 0;
        default:
          throw new Error("bad maskPattern:" + Se);
      }
    }
    e.applyMask = function(xe, Ie) {
      const Me = Ie.size;
      for (let Ee = 0; Ee < Me; Ee++)
        for (let Be = 0; Be < Me; Be++)
          Ie.isReserved(Be, Ee) || Ie.xor(Be, Ee, ke(xe, Be, Ee));
    }, e.getBestMask = function(xe, Ie) {
      const Me = Object.keys(e.Patterns).length;
      let Ee = 0, Be = 1 / 0;
      for (let $e = 0; $e < Me; $e++) {
        Ie($e), e.applyMask($e, xe);
        const Le = e.getPenaltyN1(xe) + e.getPenaltyN2(xe) + e.getPenaltyN3(xe) + e.getPenaltyN4(xe);
        e.applyMask($e, xe), Le < Be && (Be = Le, Ee = $e);
      }
      return Ee;
    };
  }(maskPattern)), maskPattern;
}
var errorCorrectionCode = {}, hasRequiredErrorCorrectionCode;
function requireErrorCorrectionCode() {
  if (hasRequiredErrorCorrectionCode) return errorCorrectionCode;
  hasRequiredErrorCorrectionCode = 1;
  const e = requireErrorCorrectionLevel(), j = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
  ], ke = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
  ];
  return errorCorrectionCode.getBlocksCount = function(xe, Ie) {
    switch (Ie) {
      case e.L:
        return j[(xe - 1) * 4 + 0];
      case e.M:
        return j[(xe - 1) * 4 + 1];
      case e.Q:
        return j[(xe - 1) * 4 + 2];
      case e.H:
        return j[(xe - 1) * 4 + 3];
      default:
        return;
    }
  }, errorCorrectionCode.getTotalCodewordsCount = function(xe, Ie) {
    switch (Ie) {
      case e.L:
        return ke[(xe - 1) * 4 + 0];
      case e.M:
        return ke[(xe - 1) * 4 + 1];
      case e.Q:
        return ke[(xe - 1) * 4 + 2];
      case e.H:
        return ke[(xe - 1) * 4 + 3];
      default:
        return;
    }
  }, errorCorrectionCode;
}
var polynomial = {}, galoisField = {}, hasRequiredGaloisField;
function requireGaloisField() {
  if (hasRequiredGaloisField) return galoisField;
  hasRequiredGaloisField = 1;
  const e = new Uint8Array(512), j = new Uint8Array(256);
  return function() {
    let Se = 1;
    for (let xe = 0; xe < 255; xe++)
      e[xe] = Se, j[Se] = xe, Se <<= 1, Se & 256 && (Se ^= 285);
    for (let xe = 255; xe < 512; xe++)
      e[xe] = e[xe - 255];
  }(), galoisField.log = function(Se) {
    if (Se < 1) throw new Error("log(" + Se + ")");
    return j[Se];
  }, galoisField.exp = function(Se) {
    return e[Se];
  }, galoisField.mul = function(Se, xe) {
    return Se === 0 || xe === 0 ? 0 : e[j[Se] + j[xe]];
  }, galoisField;
}
var hasRequiredPolynomial;
function requirePolynomial() {
  return hasRequiredPolynomial || (hasRequiredPolynomial = 1, function(e) {
    const j = requireGaloisField();
    e.mul = function(Se, xe) {
      const Ie = new Uint8Array(Se.length + xe.length - 1);
      for (let Me = 0; Me < Se.length; Me++)
        for (let Ee = 0; Ee < xe.length; Ee++)
          Ie[Me + Ee] ^= j.mul(Se[Me], xe[Ee]);
      return Ie;
    }, e.mod = function(Se, xe) {
      let Ie = new Uint8Array(Se);
      for (; Ie.length - xe.length >= 0; ) {
        const Me = Ie[0];
        for (let Be = 0; Be < xe.length; Be++)
          Ie[Be] ^= j.mul(xe[Be], Me);
        let Ee = 0;
        for (; Ee < Ie.length && Ie[Ee] === 0; ) Ee++;
        Ie = Ie.slice(Ee);
      }
      return Ie;
    }, e.generateECPolynomial = function(Se) {
      let xe = new Uint8Array([1]);
      for (let Ie = 0; Ie < Se; Ie++)
        xe = e.mul(xe, new Uint8Array([1, j.exp(Ie)]));
      return xe;
    };
  }(polynomial)), polynomial;
}
var reedSolomonEncoder, hasRequiredReedSolomonEncoder;
function requireReedSolomonEncoder() {
  if (hasRequiredReedSolomonEncoder) return reedSolomonEncoder;
  hasRequiredReedSolomonEncoder = 1;
  const e = requirePolynomial();
  function j(ke) {
    this.genPoly = void 0, this.degree = ke, this.degree && this.initialize(this.degree);
  }
  return j.prototype.initialize = function(Se) {
    this.degree = Se, this.genPoly = e.generateECPolynomial(this.degree);
  }, j.prototype.encode = function(Se) {
    if (!this.genPoly)
      throw new Error("Encoder not initialized");
    const xe = new Uint8Array(Se.length + this.degree);
    xe.set(Se);
    const Ie = e.mod(xe, this.genPoly), Me = this.degree - Ie.length;
    if (Me > 0) {
      const Ee = new Uint8Array(this.degree);
      return Ee.set(Ie, Me), Ee;
    }
    return Ie;
  }, reedSolomonEncoder = j, reedSolomonEncoder;
}
var version = {}, mode = {}, versionCheck = {}, hasRequiredVersionCheck;
function requireVersionCheck() {
  return hasRequiredVersionCheck || (hasRequiredVersionCheck = 1, versionCheck.isValid = function(j) {
    return !isNaN(j) && j >= 1 && j <= 40;
  }), versionCheck;
}
var regex = {}, hasRequiredRegex;
function requireRegex() {
  if (hasRequiredRegex) return regex;
  hasRequiredRegex = 1;
  const e = "[0-9]+", j = "[A-Z $%*+\\-./:]+";
  let ke = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
  ke = ke.replace(/u/g, "\\u");
  const Se = "(?:(?![A-Z0-9 $%*+\\-./:]|" + ke + `)(?:.|[\r
]))+`;
  regex.KANJI = new RegExp(ke, "g"), regex.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g"), regex.BYTE = new RegExp(Se, "g"), regex.NUMERIC = new RegExp(e, "g"), regex.ALPHANUMERIC = new RegExp(j, "g");
  const xe = new RegExp("^" + ke + "$"), Ie = new RegExp("^" + e + "$"), Me = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
  return regex.testKanji = function(Be) {
    return xe.test(Be);
  }, regex.testNumeric = function(Be) {
    return Ie.test(Be);
  }, regex.testAlphanumeric = function(Be) {
    return Me.test(Be);
  }, regex;
}
var hasRequiredMode;
function requireMode() {
  return hasRequiredMode || (hasRequiredMode = 1, function(e) {
    const j = requireVersionCheck(), ke = requireRegex();
    e.NUMERIC = {
      id: "Numeric",
      bit: 1,
      ccBits: [10, 12, 14]
    }, e.ALPHANUMERIC = {
      id: "Alphanumeric",
      bit: 2,
      ccBits: [9, 11, 13]
    }, e.BYTE = {
      id: "Byte",
      bit: 4,
      ccBits: [8, 16, 16]
    }, e.KANJI = {
      id: "Kanji",
      bit: 8,
      ccBits: [8, 10, 12]
    }, e.MIXED = {
      bit: -1
    }, e.getCharCountIndicator = function(Ie, Me) {
      if (!Ie.ccBits) throw new Error("Invalid mode: " + Ie);
      if (!j.isValid(Me))
        throw new Error("Invalid version: " + Me);
      return Me >= 1 && Me < 10 ? Ie.ccBits[0] : Me < 27 ? Ie.ccBits[1] : Ie.ccBits[2];
    }, e.getBestModeForData = function(Ie) {
      return ke.testNumeric(Ie) ? e.NUMERIC : ke.testAlphanumeric(Ie) ? e.ALPHANUMERIC : ke.testKanji(Ie) ? e.KANJI : e.BYTE;
    }, e.toString = function(Ie) {
      if (Ie && Ie.id) return Ie.id;
      throw new Error("Invalid mode");
    }, e.isValid = function(Ie) {
      return Ie && Ie.bit && Ie.ccBits;
    };
    function Se(xe) {
      if (typeof xe != "string")
        throw new Error("Param is not a string");
      switch (xe.toLowerCase()) {
        case "numeric":
          return e.NUMERIC;
        case "alphanumeric":
          return e.ALPHANUMERIC;
        case "kanji":
          return e.KANJI;
        case "byte":
          return e.BYTE;
        default:
          throw new Error("Unknown mode: " + xe);
      }
    }
    e.from = function(Ie, Me) {
      if (e.isValid(Ie))
        return Ie;
      try {
        return Se(Ie);
      } catch {
        return Me;
      }
    };
  }(mode)), mode;
}
var hasRequiredVersion;
function requireVersion() {
  return hasRequiredVersion || (hasRequiredVersion = 1, function(e) {
    const j = requireUtils$1(), ke = requireErrorCorrectionCode(), Se = requireErrorCorrectionLevel(), xe = requireMode(), Ie = requireVersionCheck(), Me = 7973, Ee = j.getBCHDigit(Me);
    function Be(Ve, je, Ge) {
      for (let De = 1; De <= 40; De++)
        if (je <= e.getCapacity(De, Ge, Ve))
          return De;
    }
    function $e(Ve, je) {
      return xe.getCharCountIndicator(Ve, je) + 4;
    }
    function Le(Ve, je) {
      let Ge = 0;
      return Ve.forEach(function(De) {
        const Ue = $e(De.mode, je);
        Ge += Ue + De.getBitsLength();
      }), Ge;
    }
    function Fe(Ve, je) {
      for (let Ge = 1; Ge <= 40; Ge++)
        if (Le(Ve, Ge) <= e.getCapacity(Ge, je, xe.MIXED))
          return Ge;
    }
    e.from = function(je, Ge) {
      return Ie.isValid(je) ? parseInt(je, 10) : Ge;
    }, e.getCapacity = function(je, Ge, De) {
      if (!Ie.isValid(je))
        throw new Error("Invalid QR Code version");
      typeof De > "u" && (De = xe.BYTE);
      const Ue = j.getSymbolTotalCodewords(je), Re = ke.getTotalCodewordsCount(je, Ge), Ye = (Ue - Re) * 8;
      if (De === xe.MIXED) return Ye;
      const We = Ye - $e(De, je);
      switch (De) {
        case xe.NUMERIC:
          return Math.floor(We / 10 * 3);
        case xe.ALPHANUMERIC:
          return Math.floor(We / 11 * 2);
        case xe.KANJI:
          return Math.floor(We / 13);
        case xe.BYTE:
        default:
          return Math.floor(We / 8);
      }
    }, e.getBestVersionForData = function(je, Ge) {
      let De;
      const Ue = Se.from(Ge, Se.M);
      if (Array.isArray(je)) {
        if (je.length > 1)
          return Fe(je, Ue);
        if (je.length === 0)
          return 1;
        De = je[0];
      } else
        De = je;
      return Be(De.mode, De.getLength(), Ue);
    }, e.getEncodedBits = function(je) {
      if (!Ie.isValid(je) || je < 7)
        throw new Error("Invalid QR Code version");
      let Ge = je << 12;
      for (; j.getBCHDigit(Ge) - Ee >= 0; )
        Ge ^= Me << j.getBCHDigit(Ge) - Ee;
      return je << 12 | Ge;
    };
  }(version)), version;
}
var formatInfo = {}, hasRequiredFormatInfo;
function requireFormatInfo() {
  if (hasRequiredFormatInfo) return formatInfo;
  hasRequiredFormatInfo = 1;
  const e = requireUtils$1(), j = 1335, ke = 21522, Se = e.getBCHDigit(j);
  return formatInfo.getEncodedBits = function(Ie, Me) {
    const Ee = Ie.bit << 3 | Me;
    let Be = Ee << 10;
    for (; e.getBCHDigit(Be) - Se >= 0; )
      Be ^= j << e.getBCHDigit(Be) - Se;
    return (Ee << 10 | Be) ^ ke;
  }, formatInfo;
}
var segments = {}, numericData, hasRequiredNumericData;
function requireNumericData() {
  if (hasRequiredNumericData) return numericData;
  hasRequiredNumericData = 1;
  const e = requireMode();
  function j(ke) {
    this.mode = e.NUMERIC, this.data = ke.toString();
  }
  return j.getBitsLength = function(Se) {
    return 10 * Math.floor(Se / 3) + (Se % 3 ? Se % 3 * 3 + 1 : 0);
  }, j.prototype.getLength = function() {
    return this.data.length;
  }, j.prototype.getBitsLength = function() {
    return j.getBitsLength(this.data.length);
  }, j.prototype.write = function(Se) {
    let xe, Ie, Me;
    for (xe = 0; xe + 3 <= this.data.length; xe += 3)
      Ie = this.data.substr(xe, 3), Me = parseInt(Ie, 10), Se.put(Me, 10);
    const Ee = this.data.length - xe;
    Ee > 0 && (Ie = this.data.substr(xe), Me = parseInt(Ie, 10), Se.put(Me, Ee * 3 + 1));
  }, numericData = j, numericData;
}
var alphanumericData, hasRequiredAlphanumericData;
function requireAlphanumericData() {
  if (hasRequiredAlphanumericData) return alphanumericData;
  hasRequiredAlphanumericData = 1;
  const e = requireMode(), j = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
  ];
  function ke(Se) {
    this.mode = e.ALPHANUMERIC, this.data = Se;
  }
  return ke.getBitsLength = function(xe) {
    return 11 * Math.floor(xe / 2) + 6 * (xe % 2);
  }, ke.prototype.getLength = function() {
    return this.data.length;
  }, ke.prototype.getBitsLength = function() {
    return ke.getBitsLength(this.data.length);
  }, ke.prototype.write = function(xe) {
    let Ie;
    for (Ie = 0; Ie + 2 <= this.data.length; Ie += 2) {
      let Me = j.indexOf(this.data[Ie]) * 45;
      Me += j.indexOf(this.data[Ie + 1]), xe.put(Me, 11);
    }
    this.data.length % 2 && xe.put(j.indexOf(this.data[Ie]), 6);
  }, alphanumericData = ke, alphanumericData;
}
var byteData, hasRequiredByteData;
function requireByteData() {
  if (hasRequiredByteData) return byteData;
  hasRequiredByteData = 1;
  const e = requireMode();
  function j(ke) {
    this.mode = e.BYTE, typeof ke == "string" ? this.data = new TextEncoder().encode(ke) : this.data = new Uint8Array(ke);
  }
  return j.getBitsLength = function(Se) {
    return Se * 8;
  }, j.prototype.getLength = function() {
    return this.data.length;
  }, j.prototype.getBitsLength = function() {
    return j.getBitsLength(this.data.length);
  }, j.prototype.write = function(ke) {
    for (let Se = 0, xe = this.data.length; Se < xe; Se++)
      ke.put(this.data[Se], 8);
  }, byteData = j, byteData;
}
var kanjiData, hasRequiredKanjiData;
function requireKanjiData() {
  if (hasRequiredKanjiData) return kanjiData;
  hasRequiredKanjiData = 1;
  const e = requireMode(), j = requireUtils$1();
  function ke(Se) {
    this.mode = e.KANJI, this.data = Se;
  }
  return ke.getBitsLength = function(xe) {
    return xe * 13;
  }, ke.prototype.getLength = function() {
    return this.data.length;
  }, ke.prototype.getBitsLength = function() {
    return ke.getBitsLength(this.data.length);
  }, ke.prototype.write = function(Se) {
    let xe;
    for (xe = 0; xe < this.data.length; xe++) {
      let Ie = j.toSJIS(this.data[xe]);
      if (Ie >= 33088 && Ie <= 40956)
        Ie -= 33088;
      else if (Ie >= 57408 && Ie <= 60351)
        Ie -= 49472;
      else
        throw new Error(
          "Invalid SJIS character: " + this.data[xe] + `
Make sure your charset is UTF-8`
        );
      Ie = (Ie >>> 8 & 255) * 192 + (Ie & 255), Se.put(Ie, 13);
    }
  }, kanjiData = ke, kanjiData;
}
var dijkstra = { exports: {} }, hasRequiredDijkstra;
function requireDijkstra() {
  return hasRequiredDijkstra || (hasRequiredDijkstra = 1, function(e) {
    var j = {
      single_source_shortest_paths: function(ke, Se, xe) {
        var Ie = {}, Me = {};
        Me[Se] = 0;
        var Ee = j.PriorityQueue.make();
        Ee.push(Se, 0);
        for (var Be, $e, Le, Fe, Ve, je, Ge, De, Ue; !Ee.empty(); ) {
          Be = Ee.pop(), $e = Be.value, Fe = Be.cost, Ve = ke[$e] || {};
          for (Le in Ve)
            Ve.hasOwnProperty(Le) && (je = Ve[Le], Ge = Fe + je, De = Me[Le], Ue = typeof Me[Le] > "u", (Ue || De > Ge) && (Me[Le] = Ge, Ee.push(Le, Ge), Ie[Le] = $e));
        }
        if (typeof xe < "u" && typeof Me[xe] > "u") {
          var Re = ["Could not find a path from ", Se, " to ", xe, "."].join("");
          throw new Error(Re);
        }
        return Ie;
      },
      extract_shortest_path_from_predecessor_list: function(ke, Se) {
        for (var xe = [], Ie = Se; Ie; )
          xe.push(Ie), ke[Ie], Ie = ke[Ie];
        return xe.reverse(), xe;
      },
      find_path: function(ke, Se, xe) {
        var Ie = j.single_source_shortest_paths(ke, Se, xe);
        return j.extract_shortest_path_from_predecessor_list(
          Ie,
          xe
        );
      },
      /**
       * A very naive priority queue implementation.
       */
      PriorityQueue: {
        make: function(ke) {
          var Se = j.PriorityQueue, xe = {}, Ie;
          ke = ke || {};
          for (Ie in Se)
            Se.hasOwnProperty(Ie) && (xe[Ie] = Se[Ie]);
          return xe.queue = [], xe.sorter = ke.sorter || Se.default_sorter, xe;
        },
        default_sorter: function(ke, Se) {
          return ke.cost - Se.cost;
        },
        /**
         * Add a new item to the queue and ensure the highest priority element
         * is at the front of the queue.
         */
        push: function(ke, Se) {
          var xe = { value: ke, cost: Se };
          this.queue.push(xe), this.queue.sort(this.sorter);
        },
        /**
         * Return the highest priority element in the queue.
         */
        pop: function() {
          return this.queue.shift();
        },
        empty: function() {
          return this.queue.length === 0;
        }
      }
    };
    e.exports = j;
  }(dijkstra)), dijkstra.exports;
}
var hasRequiredSegments;
function requireSegments() {
  return hasRequiredSegments || (hasRequiredSegments = 1, function(e) {
    const j = requireMode(), ke = requireNumericData(), Se = requireAlphanumericData(), xe = requireByteData(), Ie = requireKanjiData(), Me = requireRegex(), Ee = requireUtils$1(), Be = requireDijkstra();
    function $e(Re) {
      return unescape(encodeURIComponent(Re)).length;
    }
    function Le(Re, Ye, We) {
      const qe = [];
      let Je;
      for (; (Je = Re.exec(We)) !== null; )
        qe.push({
          data: Je[0],
          index: Je.index,
          mode: Ye,
          length: Je[0].length
        });
      return qe;
    }
    function Fe(Re) {
      const Ye = Le(Me.NUMERIC, j.NUMERIC, Re), We = Le(Me.ALPHANUMERIC, j.ALPHANUMERIC, Re);
      let qe, Je;
      return Ee.isKanjiModeEnabled() ? (qe = Le(Me.BYTE, j.BYTE, Re), Je = Le(Me.KANJI, j.KANJI, Re)) : (qe = Le(Me.BYTE_KANJI, j.BYTE, Re), Je = []), Ye.concat(We, qe, Je).sort(function(xt, Ct) {
        return xt.index - Ct.index;
      }).map(function(xt) {
        return {
          data: xt.data,
          mode: xt.mode,
          length: xt.length
        };
      });
    }
    function Ve(Re, Ye) {
      switch (Ye) {
        case j.NUMERIC:
          return ke.getBitsLength(Re);
        case j.ALPHANUMERIC:
          return Se.getBitsLength(Re);
        case j.KANJI:
          return Ie.getBitsLength(Re);
        case j.BYTE:
          return xe.getBitsLength(Re);
      }
    }
    function je(Re) {
      return Re.reduce(function(Ye, We) {
        const qe = Ye.length - 1 >= 0 ? Ye[Ye.length - 1] : null;
        return qe && qe.mode === We.mode ? (Ye[Ye.length - 1].data += We.data, Ye) : (Ye.push(We), Ye);
      }, []);
    }
    function Ge(Re) {
      const Ye = [];
      for (let We = 0; We < Re.length; We++) {
        const qe = Re[We];
        switch (qe.mode) {
          case j.NUMERIC:
            Ye.push([
              qe,
              { data: qe.data, mode: j.ALPHANUMERIC, length: qe.length },
              { data: qe.data, mode: j.BYTE, length: qe.length }
            ]);
            break;
          case j.ALPHANUMERIC:
            Ye.push([
              qe,
              { data: qe.data, mode: j.BYTE, length: qe.length }
            ]);
            break;
          case j.KANJI:
            Ye.push([
              qe,
              { data: qe.data, mode: j.BYTE, length: $e(qe.data) }
            ]);
            break;
          case j.BYTE:
            Ye.push([
              { data: qe.data, mode: j.BYTE, length: $e(qe.data) }
            ]);
        }
      }
      return Ye;
    }
    function De(Re, Ye) {
      const We = {}, qe = { start: {} };
      let Je = ["start"];
      for (let Ke = 0; Ke < Re.length; Ke++) {
        const xt = Re[Ke], Ct = [];
        for (let It = 0; It < xt.length; It++) {
          const Nt = xt[It], Bt = "" + Ke + It;
          Ct.push(Bt), We[Bt] = { node: Nt, lastCount: 0 }, qe[Bt] = {};
          for (let At = 0; At < Je.length; At++) {
            const Ft = Je[At];
            We[Ft] && We[Ft].node.mode === Nt.mode ? (qe[Ft][Bt] = Ve(We[Ft].lastCount + Nt.length, Nt.mode) - Ve(We[Ft].lastCount, Nt.mode), We[Ft].lastCount += Nt.length) : (We[Ft] && (We[Ft].lastCount = Nt.length), qe[Ft][Bt] = Ve(Nt.length, Nt.mode) + 4 + j.getCharCountIndicator(Nt.mode, Ye));
          }
        }
        Je = Ct;
      }
      for (let Ke = 0; Ke < Je.length; Ke++)
        qe[Je[Ke]].end = 0;
      return { map: qe, table: We };
    }
    function Ue(Re, Ye) {
      let We;
      const qe = j.getBestModeForData(Re);
      if (We = j.from(Ye, qe), We !== j.BYTE && We.bit < qe.bit)
        throw new Error('"' + Re + '" cannot be encoded with mode ' + j.toString(We) + `.
 Suggested mode is: ` + j.toString(qe));
      switch (We === j.KANJI && !Ee.isKanjiModeEnabled() && (We = j.BYTE), We) {
        case j.NUMERIC:
          return new ke(Re);
        case j.ALPHANUMERIC:
          return new Se(Re);
        case j.KANJI:
          return new Ie(Re);
        case j.BYTE:
          return new xe(Re);
      }
    }
    e.fromArray = function(Ye) {
      return Ye.reduce(function(We, qe) {
        return typeof qe == "string" ? We.push(Ue(qe, null)) : qe.data && We.push(Ue(qe.data, qe.mode)), We;
      }, []);
    }, e.fromString = function(Ye, We) {
      const qe = Fe(Ye, Ee.isKanjiModeEnabled()), Je = Ge(qe), Ke = De(Je, We), xt = Be.find_path(Ke.map, "start", "end"), Ct = [];
      for (let It = 1; It < xt.length - 1; It++)
        Ct.push(Ke.table[xt[It]].node);
      return e.fromArray(je(Ct));
    }, e.rawSplit = function(Ye) {
      return e.fromArray(
        Fe(Ye, Ee.isKanjiModeEnabled())
      );
    };
  }(segments)), segments;
}
var hasRequiredQrcode;
function requireQrcode() {
  if (hasRequiredQrcode) return qrcode;
  hasRequiredQrcode = 1;
  const e = requireUtils$1(), j = requireErrorCorrectionLevel(), ke = requireBitBuffer(), Se = requireBitMatrix(), xe = requireAlignmentPattern(), Ie = requireFinderPattern(), Me = requireMaskPattern(), Ee = requireErrorCorrectionCode(), Be = requireReedSolomonEncoder(), $e = requireVersion(), Le = requireFormatInfo(), Fe = requireMode(), Ve = requireSegments();
  function je(Ke, xt) {
    const Ct = Ke.size, It = Ie.getPositions(xt);
    for (let Nt = 0; Nt < It.length; Nt++) {
      const Bt = It[Nt][0], At = It[Nt][1];
      for (let Ft = -1; Ft <= 7; Ft++)
        if (!(Bt + Ft <= -1 || Ct <= Bt + Ft))
          for (let Dt = -1; Dt <= 7; Dt++)
            At + Dt <= -1 || Ct <= At + Dt || (Ft >= 0 && Ft <= 6 && (Dt === 0 || Dt === 6) || Dt >= 0 && Dt <= 6 && (Ft === 0 || Ft === 6) || Ft >= 2 && Ft <= 4 && Dt >= 2 && Dt <= 4 ? Ke.set(Bt + Ft, At + Dt, !0, !0) : Ke.set(Bt + Ft, At + Dt, !1, !0));
    }
  }
  function Ge(Ke) {
    const xt = Ke.size;
    for (let Ct = 8; Ct < xt - 8; Ct++) {
      const It = Ct % 2 === 0;
      Ke.set(Ct, 6, It, !0), Ke.set(6, Ct, It, !0);
    }
  }
  function De(Ke, xt) {
    const Ct = xe.getPositions(xt);
    for (let It = 0; It < Ct.length; It++) {
      const Nt = Ct[It][0], Bt = Ct[It][1];
      for (let At = -2; At <= 2; At++)
        for (let Ft = -2; Ft <= 2; Ft++)
          At === -2 || At === 2 || Ft === -2 || Ft === 2 || At === 0 && Ft === 0 ? Ke.set(Nt + At, Bt + Ft, !0, !0) : Ke.set(Nt + At, Bt + Ft, !1, !0);
    }
  }
  function Ue(Ke, xt) {
    const Ct = Ke.size, It = $e.getEncodedBits(xt);
    let Nt, Bt, At;
    for (let Ft = 0; Ft < 18; Ft++)
      Nt = Math.floor(Ft / 3), Bt = Ft % 3 + Ct - 8 - 3, At = (It >> Ft & 1) === 1, Ke.set(Nt, Bt, At, !0), Ke.set(Bt, Nt, At, !0);
  }
  function Re(Ke, xt, Ct) {
    const It = Ke.size, Nt = Le.getEncodedBits(xt, Ct);
    let Bt, At;
    for (Bt = 0; Bt < 15; Bt++)
      At = (Nt >> Bt & 1) === 1, Bt < 6 ? Ke.set(Bt, 8, At, !0) : Bt < 8 ? Ke.set(Bt + 1, 8, At, !0) : Ke.set(It - 15 + Bt, 8, At, !0), Bt < 8 ? Ke.set(8, It - Bt - 1, At, !0) : Bt < 9 ? Ke.set(8, 15 - Bt - 1 + 1, At, !0) : Ke.set(8, 15 - Bt - 1, At, !0);
    Ke.set(It - 8, 8, 1, !0);
  }
  function Ye(Ke, xt) {
    const Ct = Ke.size;
    let It = -1, Nt = Ct - 1, Bt = 7, At = 0;
    for (let Ft = Ct - 1; Ft > 0; Ft -= 2)
      for (Ft === 6 && Ft--; ; ) {
        for (let Dt = 0; Dt < 2; Dt++)
          if (!Ke.isReserved(Nt, Ft - Dt)) {
            let zt = !1;
            At < xt.length && (zt = (xt[At] >>> Bt & 1) === 1), Ke.set(Nt, Ft - Dt, zt), Bt--, Bt === -1 && (At++, Bt = 7);
          }
        if (Nt += It, Nt < 0 || Ct <= Nt) {
          Nt -= It, It = -It;
          break;
        }
      }
  }
  function We(Ke, xt, Ct) {
    const It = new ke();
    Ct.forEach(function(Dt) {
      It.put(Dt.mode.bit, 4), It.put(Dt.getLength(), Fe.getCharCountIndicator(Dt.mode, Ke)), Dt.write(It);
    });
    const Nt = e.getSymbolTotalCodewords(Ke), Bt = Ee.getTotalCodewordsCount(Ke, xt), At = (Nt - Bt) * 8;
    for (It.getLengthInBits() + 4 <= At && It.put(0, 4); It.getLengthInBits() % 8 !== 0; )
      It.putBit(0);
    const Ft = (At - It.getLengthInBits()) / 8;
    for (let Dt = 0; Dt < Ft; Dt++)
      It.put(Dt % 2 ? 17 : 236, 8);
    return qe(It, Ke, xt);
  }
  function qe(Ke, xt, Ct) {
    const It = e.getSymbolTotalCodewords(xt), Nt = Ee.getTotalCodewordsCount(xt, Ct), Bt = It - Nt, At = Ee.getBlocksCount(xt, Ct), Ft = It % At, Dt = At - Ft, zt = Math.floor(It / At), kt = Math.floor(Bt / At), Et = kt + 1, Qe = zt - kt, Xe = new Be(Qe);
    let Vt = 0;
    const Lt = new Array(At), Gt = new Array(At);
    let Wt = 0;
    const Zt = new Uint8Array(Ke.buffer);
    for (let Yt = 0; Yt < At; Yt++) {
      const Ut = Yt < Dt ? kt : Et;
      Lt[Yt] = Zt.slice(Vt, Vt + Ut), Gt[Yt] = Xe.encode(Lt[Yt]), Vt += Ut, Wt = Math.max(Wt, Ut);
    }
    const Ot = new Uint8Array(It);
    let Ht = 0, Rt, jt;
    for (Rt = 0; Rt < Wt; Rt++)
      for (jt = 0; jt < At; jt++)
        Rt < Lt[jt].length && (Ot[Ht++] = Lt[jt][Rt]);
    for (Rt = 0; Rt < Qe; Rt++)
      for (jt = 0; jt < At; jt++)
        Ot[Ht++] = Gt[jt][Rt];
    return Ot;
  }
  function Je(Ke, xt, Ct, It) {
    let Nt;
    if (Array.isArray(Ke))
      Nt = Ve.fromArray(Ke);
    else if (typeof Ke == "string") {
      let zt = xt;
      if (!zt) {
        const kt = Ve.rawSplit(Ke);
        zt = $e.getBestVersionForData(kt, Ct);
      }
      Nt = Ve.fromString(Ke, zt || 40);
    } else
      throw new Error("Invalid data");
    const Bt = $e.getBestVersionForData(Nt, Ct);
    if (!Bt)
      throw new Error("The amount of data is too big to be stored in a QR Code");
    if (!xt)
      xt = Bt;
    else if (xt < Bt)
      throw new Error(
        `
The chosen QR Code version cannot contain this amount of data.
Minimum version required to store current data is: ` + Bt + `.
`
      );
    const At = We(xt, Ct, Nt), Ft = e.getSymbolSize(xt), Dt = new Se(Ft);
    return je(Dt, xt), Ge(Dt), De(Dt, xt), Re(Dt, Ct, 0), xt >= 7 && Ue(Dt, xt), Ye(Dt, At), isNaN(It) && (It = Me.getBestMask(
      Dt,
      Re.bind(null, Dt, Ct)
    )), Me.applyMask(It, Dt), Re(Dt, Ct, It), {
      modules: Dt,
      version: xt,
      errorCorrectionLevel: Ct,
      maskPattern: It,
      segments: Nt
    };
  }
  return qrcode.create = function(xt, Ct) {
    if (typeof xt > "u" || xt === "")
      throw new Error("No input text");
    let It = j.M, Nt, Bt;
    return typeof Ct < "u" && (It = j.from(Ct.errorCorrectionLevel, j.M), Nt = $e.from(Ct.version), Bt = Me.from(Ct.maskPattern), Ct.toSJISFunc && e.setToSJISFunction(Ct.toSJISFunc)), Je(xt, Nt, It, Bt);
  }, qrcode;
}
var canvas = {}, utils = {}, hasRequiredUtils;
function requireUtils() {
  return hasRequiredUtils || (hasRequiredUtils = 1, function(e) {
    function j(ke) {
      if (typeof ke == "number" && (ke = ke.toString()), typeof ke != "string")
        throw new Error("Color should be defined as hex string");
      let Se = ke.slice().replace("#", "").split("");
      if (Se.length < 3 || Se.length === 5 || Se.length > 8)
        throw new Error("Invalid hex color: " + ke);
      (Se.length === 3 || Se.length === 4) && (Se = Array.prototype.concat.apply([], Se.map(function(Ie) {
        return [Ie, Ie];
      }))), Se.length === 6 && Se.push("F", "F");
      const xe = parseInt(Se.join(""), 16);
      return {
        r: xe >> 24 & 255,
        g: xe >> 16 & 255,
        b: xe >> 8 & 255,
        a: xe & 255,
        hex: "#" + Se.slice(0, 6).join("")
      };
    }
    e.getOptions = function(Se) {
      Se || (Se = {}), Se.color || (Se.color = {});
      const xe = typeof Se.margin > "u" || Se.margin === null || Se.margin < 0 ? 4 : Se.margin, Ie = Se.width && Se.width >= 21 ? Se.width : void 0, Me = Se.scale || 4;
      return {
        width: Ie,
        scale: Ie ? 4 : Me,
        margin: xe,
        color: {
          dark: j(Se.color.dark || "#000000ff"),
          light: j(Se.color.light || "#ffffffff")
        },
        type: Se.type,
        rendererOpts: Se.rendererOpts || {}
      };
    }, e.getScale = function(Se, xe) {
      return xe.width && xe.width >= Se + xe.margin * 2 ? xe.width / (Se + xe.margin * 2) : xe.scale;
    }, e.getImageWidth = function(Se, xe) {
      const Ie = e.getScale(Se, xe);
      return Math.floor((Se + xe.margin * 2) * Ie);
    }, e.qrToImageData = function(Se, xe, Ie) {
      const Me = xe.modules.size, Ee = xe.modules.data, Be = e.getScale(Me, Ie), $e = Math.floor((Me + Ie.margin * 2) * Be), Le = Ie.margin * Be, Fe = [Ie.color.light, Ie.color.dark];
      for (let Ve = 0; Ve < $e; Ve++)
        for (let je = 0; je < $e; je++) {
          let Ge = (Ve * $e + je) * 4, De = Ie.color.light;
          if (Ve >= Le && je >= Le && Ve < $e - Le && je < $e - Le) {
            const Ue = Math.floor((Ve - Le) / Be), Re = Math.floor((je - Le) / Be);
            De = Fe[Ee[Ue * Me + Re] ? 1 : 0];
          }
          Se[Ge++] = De.r, Se[Ge++] = De.g, Se[Ge++] = De.b, Se[Ge] = De.a;
        }
    };
  }(utils)), utils;
}
var hasRequiredCanvas;
function requireCanvas() {
  return hasRequiredCanvas || (hasRequiredCanvas = 1, function(e) {
    const j = requireUtils();
    function ke(xe, Ie, Me) {
      xe.clearRect(0, 0, Ie.width, Ie.height), Ie.style || (Ie.style = {}), Ie.height = Me, Ie.width = Me, Ie.style.height = Me + "px", Ie.style.width = Me + "px";
    }
    function Se() {
      try {
        return document.createElement("canvas");
      } catch {
        throw new Error("You need to specify a canvas element");
      }
    }
    e.render = function(Ie, Me, Ee) {
      let Be = Ee, $e = Me;
      typeof Be > "u" && (!Me || !Me.getContext) && (Be = Me, Me = void 0), Me || ($e = Se()), Be = j.getOptions(Be);
      const Le = j.getImageWidth(Ie.modules.size, Be), Fe = $e.getContext("2d"), Ve = Fe.createImageData(Le, Le);
      return j.qrToImageData(Ve.data, Ie, Be), ke(Fe, $e, Le), Fe.putImageData(Ve, 0, 0), $e;
    }, e.renderToDataURL = function(Ie, Me, Ee) {
      let Be = Ee;
      typeof Be > "u" && (!Me || !Me.getContext) && (Be = Me, Me = void 0), Be || (Be = {});
      const $e = e.render(Ie, Me, Be), Le = Be.type || "image/png", Fe = Be.rendererOpts || {};
      return $e.toDataURL(Le, Fe.quality);
    };
  }(canvas)), canvas;
}
var svgTag = {}, hasRequiredSvgTag;
function requireSvgTag() {
  if (hasRequiredSvgTag) return svgTag;
  hasRequiredSvgTag = 1;
  const e = requireUtils();
  function j(xe, Ie) {
    const Me = xe.a / 255, Ee = Ie + '="' + xe.hex + '"';
    return Me < 1 ? Ee + " " + Ie + '-opacity="' + Me.toFixed(2).slice(1) + '"' : Ee;
  }
  function ke(xe, Ie, Me) {
    let Ee = xe + Ie;
    return typeof Me < "u" && (Ee += " " + Me), Ee;
  }
  function Se(xe, Ie, Me) {
    let Ee = "", Be = 0, $e = !1, Le = 0;
    for (let Fe = 0; Fe < xe.length; Fe++) {
      const Ve = Math.floor(Fe % Ie), je = Math.floor(Fe / Ie);
      !Ve && !$e && ($e = !0), xe[Fe] ? (Le++, Fe > 0 && Ve > 0 && xe[Fe - 1] || (Ee += $e ? ke("M", Ve + Me, 0.5 + je + Me) : ke("m", Be, 0), Be = 0, $e = !1), Ve + 1 < Ie && xe[Fe + 1] || (Ee += ke("h", Le), Le = 0)) : Be++;
    }
    return Ee;
  }
  return svgTag.render = function(Ie, Me, Ee) {
    const Be = e.getOptions(Me), $e = Ie.modules.size, Le = Ie.modules.data, Fe = $e + Be.margin * 2, Ve = Be.color.light.a ? "<path " + j(Be.color.light, "fill") + ' d="M0 0h' + Fe + "v" + Fe + 'H0z"/>' : "", je = "<path " + j(Be.color.dark, "stroke") + ' d="' + Se(Le, $e, Be.margin) + '"/>', Ge = 'viewBox="0 0 ' + Fe + " " + Fe + '"', Ue = '<svg xmlns="http://www.w3.org/2000/svg" ' + (Be.width ? 'width="' + Be.width + '" height="' + Be.width + '" ' : "") + Ge + ' shape-rendering="crispEdges">' + Ve + je + `</svg>
`;
    return typeof Ee == "function" && Ee(null, Ue), Ue;
  }, svgTag;
}
var hasRequiredBrowser;
function requireBrowser() {
  if (hasRequiredBrowser) return browser;
  hasRequiredBrowser = 1;
  const e = requireCanPromise(), j = requireQrcode(), ke = requireCanvas(), Se = requireSvgTag();
  function xe(Ie, Me, Ee, Be, $e) {
    const Le = [].slice.call(arguments, 1), Fe = Le.length, Ve = typeof Le[Fe - 1] == "function";
    if (!Ve && !e())
      throw new Error("Callback required as last argument");
    if (Ve) {
      if (Fe < 2)
        throw new Error("Too few arguments provided");
      Fe === 2 ? ($e = Ee, Ee = Me, Me = Be = void 0) : Fe === 3 && (Me.getContext && typeof $e > "u" ? ($e = Be, Be = void 0) : ($e = Be, Be = Ee, Ee = Me, Me = void 0));
    } else {
      if (Fe < 1)
        throw new Error("Too few arguments provided");
      return Fe === 1 ? (Ee = Me, Me = Be = void 0) : Fe === 2 && !Me.getContext && (Be = Ee, Ee = Me, Me = void 0), new Promise(function(je, Ge) {
        try {
          const De = j.create(Ee, Be);
          je(Ie(De, Me, Be));
        } catch (De) {
          Ge(De);
        }
      });
    }
    try {
      const je = j.create(Ee, Be);
      $e(null, Ie(je, Me, Be));
    } catch (je) {
      $e(je);
    }
  }
  return browser.create = j.create, browser.toCanvas = xe.bind(null, ke.render), browser.toDataURL = xe.bind(null, ke.renderToDataURL), browser.toString = xe.bind(null, function(Ie, Me, Ee) {
    return Se.render(Ie, Ee);
  }), browser;
}
var browserExports = requireBrowser();
const QRCode = /* @__PURE__ */ getDefaultExportFromCjs(browserExports), _hoisted_1$s = ["src"], _sfc_main$1r = /* @__PURE__ */ defineComponent({
  __name: "SatQrCodeGenerator",
  props: {
    url: {}
  },
  setup(e) {
    const j = e, ke = ref(""), Se = async () => {
      const xe = await QRCode.toDataURL(j.url, {
        errorCorrectionLevel: "H"
      });
      xe && (ke.value = xe);
    };
    return onMounted(() => {
      Se();
    }), (xe, Ie) => (openBlock(), createElementBlock("img", {
      src: ke.value,
      class: normalizeClass(unref(css$1k)())
    }, null, 10, _hoisted_1$s));
  }
}), SatQrCodeGenerator = /* @__PURE__ */ _export_sfc(_sfc_main$1r, [["__scopeId", "data-v-f1061f57"]]), className$1j = "sat-navigation", css$1j = bemBuilder(className$1j);
bemBuilder(className$1j, !0);
const _sfc_main$1q = /* @__PURE__ */ defineComponent({
  __name: "SatNavigation",
  props: {
    background: { default: "transparent" },
    iconNameLeft: {},
    iconNameRight: {},
    sticky: { type: Boolean, default: !0 }
  },
  emits: ["clickLeftCta", "clickRightCta"],
  setup(e, { emit: j }) {
    const ke = e, Se = j;
    return (xe, Ie) => withDirectives((openBlock(), createElementBlock("div", {
      class: normalizeClass([unref(css$1j)(), unref(css$1j)("", ke.background)])
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$1j)("column"))
      }, [
        ke.iconNameLeft ? (openBlock(), createBlock(unref(SatIconButton), {
          key: 0,
          class: normalizeClass(unref(css$1j)("left-cta")),
          theme: "ghost",
          variant: "primary",
          "icon-name": ke.iconNameLeft,
          onClick: Ie[0] || (Ie[0] = (Me) => Se("clickLeftCta", Me))
        }, null, 8, ["class", "icon-name"])) : createCommentVNode("", !0)
      ], 2),
      createVNode(unref(AtomText), {
        class: normalizeClass(unref(css$1j)("content")),
        type: "subtitle",
        tag: "span"
      }, {
        default: withCtx(() => [
          renderSlot(xe.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["class"]),
      createElementVNode("div", {
        class: normalizeClass(unref(css$1j)("column"))
      }, [
        ke.iconNameRight ? (openBlock(), createBlock(unref(SatIconButton), {
          key: 0,
          class: normalizeClass(unref(css$1j)("right-cta")),
          theme: "ghost",
          variant: "primary",
          "icon-name": ke.iconNameRight,
          onClick: Ie[1] || (Ie[1] = (Me) => Se("clickRightCta", Me))
        }, null, 8, ["class", "icon-name"])) : createCommentVNode("", !0)
      ], 2)
    ], 2)), [
      [unref(N$1), { zIndex: 10, disabled: !ke.sticky }]
    ]);
  }
}), SatNavigation = /* @__PURE__ */ _export_sfc(_sfc_main$1q, [["__scopeId", "data-v-8d376d67"]]), className$1i = "sat-loyalty-program-card", css$1i = bemBuilder(className$1i);
bemBuilder(className$1i, !0);
const className$1h = "atom-badge", css$1h = bemBuilder(className$1h);
bemBuilder(className$1h, !0);
const _sfc_main$1p = /* @__PURE__ */ defineComponent({
  __name: "AtomBadge",
  props: {
    value: {},
    size: { default: "normal" },
    emphasis: { default: "high" },
    state: { default: "neutral" }
  },
  setup(e) {
    const j = e;
    return (ke, Se) => (openBlock(), createElementBlock("span", {
      class: normalizeClass([
        unref(css$1h)(),
        unref(css$1h)("size", j.size),
        unref(css$1h)("emphasis", j.emphasis),
        unref(css$1h)("state", j.state)
      ])
    }, toDisplayString(j.value), 3));
  }
}), AtomBadge = /* @__PURE__ */ _export_sfc(_sfc_main$1p, [["__scopeId", "data-v-7d3ccb47"]]), _sfc_main$1o = /* @__PURE__ */ defineComponent({
  __name: "SatLoyaltyProgramCard",
  props: {
    photo: {},
    title: {},
    cost: {},
    description: {},
    badgeLabel: {},
    badgeType: {}
  },
  setup(e) {
    const j = e;
    return (ke, Se) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$1i)())
    }, [
      createElementVNode("div", null, [
        createElementVNode("div", {
          class: normalizeClass(unref(css$1i)("cover")),
          style: normalizeStyle(j.photo ? `background-image: url(${j.photo})` : "")
        }, [
          j.photo ? createCommentVNode("", !0) : (openBlock(), createBlock(unref(_sfc_main$1Q), {
            key: 0,
            size: "large",
            name: "discount"
          }))
        ], 6)
      ]),
      createElementVNode("div", {
        class: normalizeClass(unref(css$1i)("content"))
      }, [
        j.badgeLabel ? (openBlock(), createBlock(unref(AtomBadge), {
          key: 0,
          emphasis: "low",
          class: normalizeClass(unref(css$1i)("badge")),
          state: j.badgeType,
          value: j.badgeLabel
        }, null, 8, ["class", "state", "value"])) : createCommentVNode("", !0),
        createVNode(unref(AtomText), {
          tag: "div",
          type: "body-bold",
          class: normalizeClass(unref(css$1i)("title")),
          color: "color-text-headline"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(j.title), 1)
          ]),
          _: 1
        }, 8, ["class"]),
        typeof j.cost == "number" && j.cost > 0 ? (openBlock(), createBlock(unref(AtomText), {
          key: 1,
          class: normalizeClass(unref(css$1i)("cost")),
          color: "color-text-body"
        }, {
          default: withCtx(() => [
            createVNode(unref(_sfc_main$1Q), {
              size: "small",
              name: "rating"
            }),
            createTextVNode(" " + toDisplayString(j.cost), 1)
          ]),
          _: 1
        }, 8, ["class"])) : createCommentVNode("", !0),
        j.description ? (openBlock(), createBlock(unref(AtomText), {
          key: 2,
          class: normalizeClass(unref(css$1i)("description")),
          color: "color-text-secondary"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(j.description), 1)
          ]),
          _: 1
        }, 8, ["class"])) : createCommentVNode("", !0)
      ], 2)
    ], 2));
  }
}), SatLoyaltyProgramCard = /* @__PURE__ */ _export_sfc(_sfc_main$1o, [["__scopeId", "data-v-0f6adaf0"]]), className$1g = "sat-loyalty-program-selection", css$1g = bemBuilder(className$1g);
bemBuilder(className$1g, !0);
const className$1f = "atom-loading-spinner", css$1f = bemBuilder(className$1f);
bemBuilder(className$1f, !0);
const _hoisted_1$r = ["width", "height"], _sfc_main$1n = /* @__PURE__ */ defineComponent({
  __name: "AtomLoadingSpinner",
  props: {
    size: { default: 50 }
  },
  setup(e) {
    const j = e;
    return (ke, Se) => (openBlock(), createElementBlock("svg", {
      class: normalizeClass(unref(css$1f)()),
      width: j.size,
      height: j.size,
      viewBox: "0 0 100 100"
    }, [
      createElementVNode("circle", {
        class: normalizeClass(unref(css$1f)("animate")),
        cx: "50",
        cy: "50",
        r: "45"
      }, null, 2)
    ], 10, _hoisted_1$r));
  }
}), AtomLoadingSpinner = /* @__PURE__ */ _export_sfc(_sfc_main$1n, [["__scopeId", "data-v-ec9e852f"]]), _sfc_main$1m = /* @__PURE__ */ defineComponent({
  __name: "SatLoyaltyProgramSelection",
  props: {
    title: {},
    buttonLabel: {},
    items: {},
    emptyMessage: {},
    isLoading: { type: Boolean },
    isButtonLoading: { type: Boolean }
  },
  emits: ["selected"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = ref();
    return (Ie, Me) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$1g)())
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$1g)("header"))
      }, [
        createVNode(unref(AtomText), {
          type: "h3",
          color: "color-text-headline"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.title), 1)
          ]),
          _: 1
        })
      ], 2),
      createElementVNode("div", {
        class: normalizeClass(unref(css$1g)("content"))
      }, [
        renderSlot(Ie.$slots, "default", {}, void 0, !0),
        ke.isLoading ? (openBlock(), createBlock(unref(AtomLoadingSpinner), {
          key: 0,
          size: 30,
          class: normalizeClass(unref(css$1g)("loading"))
        }, null, 8, ["class"])) : (openBlock(), createElementBlock("ul", {
          key: 1,
          class: normalizeClass(unref(css$1g)("list"))
        }, [
          (openBlock(!0), createElementBlock(Fragment, null, renderList(ke.items, (Ee) => (openBlock(), createElementBlock("li", {
            key: Ee.id
          }, [
            createElementVNode("label", {
              class: normalizeClass(unref(css$1g)("item"))
            }, [
              createVNode(unref(SatLoyaltyProgramCard), {
                class: normalizeClass(unref(css$1g)("card")),
                photo: Ee.photo,
                title: Ee.title,
                cost: Ee.cost,
                description: Ee.description,
                "badge-label": Ee.badgeLabel,
                "badge-type": Ee.badgeType
              }, null, 8, ["class", "photo", "title", "cost", "description", "badge-label", "badge-type"]),
              createVNode(unref(AtomRadio), {
                name: "program",
                value: Ee.id,
                checked: xe.value?.id === Ee.id,
                onChange: (Be) => xe.value = Ee
              }, null, 8, ["value", "checked", "onChange"])
            ], 2)
          ]))), 128)),
          ke.items.length ? createCommentVNode("", !0) : (openBlock(), createElementBlock("li", {
            key: 0,
            class: normalizeClass(unref(css$1g)("empty"))
          }, toDisplayString(ke.emptyMessage), 3))
        ], 2))
      ], 2),
      createElementVNode("div", {
        class: normalizeClass(unref(css$1g)("footer"))
      }, [
        createVNode(unref(AtomButton), {
          size: "large",
          wide: "",
          "is-disabled": !xe.value,
          "is-loading": ke.isButtonLoading,
          onClick: Me[0] || (Me[0] = withModifiers((Ee) => xe.value ? Se("selected", xe.value) : {}, ["prevent"]))
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.buttonLabel), 1)
          ]),
          _: 1
        }, 8, ["is-disabled", "is-loading"])
      ], 2)
    ], 2));
  }
}), SatLoyaltyProgramSelection = /* @__PURE__ */ _export_sfc(_sfc_main$1m, [["__scopeId", "data-v-a3901787"]]);
function setScriptSrc(e, j) {
  e.src = j;
}
const bootstrap = (e) => {
  var j, ke, Se, xe = "The Google Maps JavaScript API", Ie = "google", Me = "importLibrary", Ee = "__ib__", Be = document, $e = window, Le = $e[Ie] || ($e[Ie] = {}), Fe = Le.maps || (Le.maps = {}), Ve = /* @__PURE__ */ new Set(), je = new URLSearchParams(), Ge = () => j || (j = new Promise(async (De, Ue) => {
    await (ke = Be.createElement("script")), je.set("libraries", [...Ve] + "");
    for (Se in e)
      je.set(Se.replace(/[A-Z]/g, (Re) => "_" + Re[0].toLowerCase()), e[Se]);
    je.set("callback", Ie + ".maps." + Ee), setScriptSrc(ke, "https://maps.googleapis.com/maps/api/js?" + je), Fe[Ee] = De, ke.onerror = () => j = Ue(Error(xe + " could not load.")), ke.nonce = Be.querySelector("script[nonce]")?.nonce || "", Be.head.append(ke);
  }));
  Fe[Me] ? console.warn(xe + " only loads once. Ignoring:", e) : Fe[Me] = (De, ...Ue) => Ve.add(De) && Ge().then(() => Fe[Me](De, ...Ue));
}, MSG_REPEATED_SET_OPTIONS = (e) => `The setOptions() function should only be called once. The options passed to the additional call (${JSON.stringify(e)}) will be ignored.`, MSG_IMPORT_LIBRARY_EXISTS = (e) => `The google.maps.importLibrary() function is already defined, and @googlemaps/js-api-loader will use the existing function instead of overwriting it. The options passed to setOptions (${JSON.stringify(e)}) will be ignored.`, MSG_SET_OPTIONS_NOT_CALLED = "No options were set before calling importLibrary. Make sure to configure the loader using setOptions().", MSG_SCRIPT_ELEMENT_EXISTS = "There already is a script loading the Google Maps JavaScript API, and no google.maps.importLibrary function is defined. @googlemaps/js-api-loader will proceed to bootstrap the API with the specified options, but the existing script might cause problems using the API. Make sure to remove the script loading the API.", __DEV__$1 = process.env.NODE_ENV !== "production", logDevWarning = __DEV__$1 ? (e) => {
  console.warn(`[@googlemaps/js-api-loader] ${e}`);
} : () => {
}, logDevNotice = __DEV__$1 ? (e) => {
  console.info(`[@googlemaps/js-api-loader] ${e}`);
} : () => {
}, __DEV__ = process.env.NODE_ENV !== "production";
let setOptionsWasCalled_ = !1;
function setOptions(e) {
  if (setOptionsWasCalled_) {
    logDevWarning(MSG_REPEATED_SET_OPTIONS(e));
    return;
  }
  installImportLibrary_(e), setOptionsWasCalled_ = !0;
}
async function importLibrary(e) {
  if (setOptionsWasCalled_ || logDevWarning(MSG_SET_OPTIONS_NOT_CALLED), !window?.google?.maps?.importLibrary)
    throw new Error("google.maps.importLibrary is not installed.");
  return await google.maps.importLibrary(e);
}
function installImportLibrary_(e) {
  const j = !!window.google?.maps?.importLibrary;
  j ? logDevNotice(MSG_IMPORT_LIBRARY_EXISTS(e)) : __DEV__ && document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]') && logDevWarning(MSG_SCRIPT_ELEMENT_EXISTS), j || bootstrap(e);
}
let isConfigured = !1, loadPromise = null;
const isLoading = ref(!1), isLoaded = ref(!1), configureAPI = (e) => {
  isConfigured || (setOptions({
    key: e
  }), isConfigured = !0);
}, loadLibrary = async (e) => {
  if (!isLoaded.value) {
    if (isLoading.value && loadPromise) {
      await loadPromise;
      return;
    }
    configureAPI(e), isLoading.value = !0;
    try {
      loadPromise = Promise.all([
        importLibrary("maps"),
        importLibrary("places"),
        importLibrary("geometry")
      ]).then(() => window.google.maps), await loadPromise, isLoaded.value = !0;
    } catch (j) {
      throw console.error("Failed to load Google Maps:", j), j;
    } finally {
      isLoading.value = !1;
    }
  }
}, getMaps = async (e) => (await loadLibrary(e), window.google.maps), useGoogleMaps = (e) => (e || console.warn("Google Maps API key is required"), {
  loadLibrary: () => loadLibrary(e),
  getMaps: () => getMaps(e),
  isLoading,
  isLoaded
}), className$1e = "sat-place-searcher", css$1e = bemBuilder(className$1e);
bemBuilder(className$1e, !0);
const _hoisted_1$q = ["onClick"], _sfc_main$1l = /* @__PURE__ */ defineComponent({
  __name: "SatPlaceSearcher",
  props: {
    apiKey: {},
    country: {},
    input: {},
    max: {},
    placeholder: {}
  },
  emits: ["select", "clear"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = ref(), Ie = ref(), Me = ref([]), Ee = ref([]), Be = ref(!1), $e = ref(), Le = computed(() => Me.value.length > 0), Fe = () => {
      Me.value = [];
    }, Ve = () => {
      Me.value = Ee.value;
    }, je = () => {
      $e.value = "", Fe(), Se("clear");
    }, Ge = debounce$1((qe) => {
      $e.value = qe;
    }, 500), De = () => {
      setTimeout(() => {
        Ee.value = Me.value, Fe();
      }, 200);
    }, Ue = (qe) => {
      const Je = [
        "locality",
        "administrative_area_level_3",
        "postal_town"
      ];
      let Ke = "";
      for (const xt of Je)
        for (const Ct of qe.address_components)
          if (Ct.types.includes(xt)) {
            Ke = Ct.long_name || Ct.short_name;
            break;
          }
      return Ke;
    }, Re = async (qe) => {
      if (!Ie.value)
        throw new Error("Google Maps: Geocode service is not available.");
      const Ke = (await Ie.value.geocode({ placeId: qe })).results[0];
      if (!Ke)
        throw new Error("Google Maps: Invalid place id.");
      return {
        coordinates: Ke.geometry.location.toJSON(),
        formattedAddress: Ke.formatted_address,
        postalCode: Ke.address_components.find(
          (xt) => xt.types.includes("postal_code")
        )?.long_name,
        mainArea: Ue(Ke)
      };
    }, Ye = async (qe) => {
      $e.value = qe.description, Be.value = !0;
      const Je = await Re(qe.placeId), Ke = {
        ...qe,
        ...Je
      };
      Se("select", Ke), Me.value = [], Ee.value = [];
    }, We = (qe) => {
      const Je = qe.placePrediction;
      return Je ? {
        description: Je.text?.text || "",
        placeId: Je.placeId || "",
        mainText: Je.mainText?.text || "",
        secondaryText: Je.secondaryText?.text || ""
      } : {
        description: "",
        placeId: "",
        mainText: "",
        secondaryText: ""
      };
    };
    return watch($e, async (qe = "") => {
      if (xe.value) {
        if (!qe.trim()) {
          Fe();
          return;
        }
        if (Be.value) {
          Be.value = !1, Fe();
          return;
        }
        try {
          const Je = {
            input: qe,
            includedRegionCodes: [ke.country]
          }, { suggestions: Ke } = await xe.value.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(
            Je
          );
          Me.value = Ke ? Ke.slice(0, ke.max).map(We) : [];
        } catch (Je) {
          console.error("Error fetching autocomplete suggestions:", Je), Fe();
        }
      }
    }), watch(
      () => ke.input,
      () => {
        $e.value = ke.input;
      },
      { immediate: !0 }
    ), onMounted(async () => {
      const { getMaps: qe } = useGoogleMaps(ke.apiKey);
      xe.value = await qe(), xe.value && (Ie.value = new xe.value.Geocoder());
    }), (qe, Je) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$1e)())
    }, [
      createVNode(unref(SatInputSearch), {
        class: normalizeClass(unref(css$1e)("input")),
        placeholder: e.placeholder,
        value: $e.value,
        clearable: "",
        onKeyup: unref(Ge),
        onBlur: De,
        onFocus: Ve,
        onClear: je
      }, null, 8, ["class", "placeholder", "value", "onKeyup"]),
      Le.value ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(unref(css$1e)("predictions"))
      }, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(Me.value, (Ke) => (openBlock(), createElementBlock("a", {
          key: Ke.placeId,
          class: normalizeClass(unref(css$1e)("prediction")),
          "data-test": "prediction",
          href: "#",
          onClick: withModifiers((xt) => Ye(Ke), ["prevent"])
        }, [
          createVNode(unref(AtomText), {
            type: "body-bold",
            "data-test": "prediction-title",
            class: normalizeClass(unref(css$1e)("title"))
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(Ke.mainText), 1)
            ]),
            _: 2
          }, 1032, ["class"]),
          createVNode(unref(AtomText), {
            class: normalizeClass(unref(css$1e)("summary")),
            "data-test": "prediction-summary"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(Ke.secondaryText), 1)
            ]),
            _: 2
          }, 1032, ["class"])
        ], 10, _hoisted_1$q))), 128))
      ], 2)) : createCommentVNode("", !0)
    ], 2));
  }
}), SatPlaceSearcher = /* @__PURE__ */ _export_sfc(_sfc_main$1l, [["__scopeId", "data-v-be00e91d"]]), className$1d = "sat-map", css$1d = bemBuilder(className$1d);
bemBuilder(className$1d, !0);
const satMapGoogleMapsInjectionKey = Symbol("satMapGoogleMapsInjectionKey"), satMapGeocoderInjectionKey = Symbol("satMapGeocoderInjectionKey"), satMapMapInjectionKey = Symbol("satMapMapInjectionKey"), satMapErrorHandlerInjectionKey = Symbol("satMapErrorHandlerInjectionKey"), addMapListener$1 = (e, j, ke, Se = 100) => {
  const xe = debounce$1(j, Se);
  ke.addListener(e, xe);
}, registerMapListeners = (e, j) => {
  addMapListener$1(
    "center_changed",
    () => e("centerChange", j.getCenter()?.toJSON()),
    j,
    100
  ), addMapListener$1(
    "drag",
    () => e("drag", j.getCenter()?.toJSON()),
    j,
    100
  ), addMapListener$1(
    "dragstart",
    () => e("dragStart", j.getCenter()?.toJSON()),
    j,
    0
  ), addMapListener$1(
    "dragend",
    () => e("dragEnd", j.getCenter()?.toJSON()),
    j,
    0
  ), addMapListener$1(
    "tilesloaded",
    () => {
      e("tilesLoaded");
    },
    j,
    0
  ), addMapListener$1(
    "bounds_changed",
    () => e("boundsChange", j.getBounds()?.toJSON()),
    j,
    100
  ), addMapListener$1(
    "zoom_changed",
    () => e("zoomChange", j.getZoom()),
    j,
    100
  );
}, _sfc_main$1k = /* @__PURE__ */ defineComponent({
  __name: "SatMap",
  props: {
    apiKey: {},
    country: {},
    mapBounds: {},
    mapZoom: {},
    panX: {},
    options: {}
  },
  emits: ["drag", "dragStart", "dragEnd", "centerChange", "boundsChange", "zoomChange", "loadFailed", "tilesLoaded"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = ref(), Ie = ref(), Me = ref(), Ee = computed(() => {
      if (!xe.value)
        throw new Error("Google Maps instance not found.");
      return xe.value;
    }), Be = computed(() => {
      if (!Me.value)
        throw new Error("Maps instance not found.");
      return Me.value;
    }), $e = computed(() => {
      if (!Ie.value)
        throw new Error("Google Maps Geocoder instance not found.");
      return Ie.value;
    });
    provide(satMapGoogleMapsInjectionKey, Ee), provide(satMapGeocoderInjectionKey, $e), provide(satMapMapInjectionKey, Be);
    const Le = ref(), Fe = ref(""), Ve = ref(!0), je = (Ct) => {
      Se("loadFailed"), Fe.value = Ct instanceof Error ? Ct.message : "Something went wrong loading the map.";
    };
    provide(satMapErrorHandlerInjectionKey, je);
    const Ge = (Ct) => {
      Be.value.setZoom(Ct);
    }, De = (Ct) => {
      Be.value.fitBounds(Ct), ke.panX && Be.value.panBy(ke.panX, 0);
    }, Ue = async (Ct, It) => {
      if (It === Ee.value.GeocoderStatus.OK && Ct && Ct[0])
        return De(Ct[0].geometry?.viewport), Se("dragEnd", Me.value?.getCenter()?.toJSON()), Ct;
      qe(ke.country);
    }, Re = (Ct) => {
      De(Ct);
    }, Ye = (Ct) => {
      Ie.value && $e.value.geocode(
        {
          placeId: Ct
        },
        Ue
      );
    }, We = (Ct) => {
      Ie.value && $e.value.geocode(
        {
          location: {
            lat: Ct?.lat,
            lng: Ct?.lng
          }
        },
        Ue
      );
    }, qe = (Ct = "") => {
      Ie.value && $e.value.geocode(
        {
          address: Ct,
          componentRestrictions: {
            country: ke.country
          }
        },
        Ue
      );
    }, Je = (Ct) => {
      const { placeId: It, coordinates: Nt, location: Bt, country: At, bounds: Ft } = Ct;
      return Ft ? Re(Ft) : It ? Ye(It) : Nt ? We(Nt) : qe(Bt || At);
    }, Ke = async () => {
      try {
        const { getMaps: Ct } = useGoogleMaps(ke.apiKey);
        if (xe.value = await Ct(), !xe.value)
          throw new Error("Global Google Maps instance not found.");
        if (!Le.value)
          throw new Error("HTML element to mount the map does not exist.");
        const It = {
          zoomControl: !0,
          zoom: ke.mapZoom ?? null,
          zoomControlOptions: {
            position: 7
          },
          disableDefaultUI: !0,
          gestureHandling: "greedy"
        };
        Me.value = new xe.value.Map(
          Le.value,
          ke.options || It
        ), Ie.value = new xe.value.Geocoder(), registerMapListeners(Se, Me.value);
        const Nt = Me.value.addListener("tilesloaded", () => {
          Ve.value = !1, Nt.remove();
        }), Bt = Me.value.addListener("idle", () => {
          Je(ke.mapBounds ?? { country: ke.country }), ke.mapZoom && Ge(ke.mapZoom), Bt.remove();
        });
      } catch (Ct) {
        je(Ct);
      }
    }, xt = () => {
      try {
        Me.value && Ee.value.event.clearInstanceListeners(Me.value);
      } catch (Ct) {
        je(Ct);
      }
    };
    return onMounted(() => Ke()), onUnmounted(() => xt()), watch(
      () => ke.country,
      (Ct, It) => {
        Ct === It || !Ct || Je({ country: Ct });
      }
    ), watch(
      () => ke.mapBounds,
      (Ct, It) => {
        Ct === It || !Ct || Je(Ct);
      }
    ), watchDebounced(
      () => ke.mapZoom,
      (Ct, It) => {
        Ct === It || !Ct || Ge(Ct);
      },
      {
        debounce: 200
      }
    ), watch(
      () => ke.options,
      (Ct) => Be.value.setOptions(Ct || {}),
      { deep: !0 }
    ), (Ct, It) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$1d)())
    }, [
      createVNode(Transition, {
        name: unref(css$1d)("fade")
      }, {
        default: withCtx(() => [
          Fe.value ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(unref(css$1d)("error"))
          }, toDisplayString(Fe.value), 3)) : Ve.value ? (openBlock(), createElementBlock("div", {
            key: 1,
            class: normalizeClass(unref(css$1d)("loading"))
          }, [
            createVNode(unref(AtomLoadingSpinner))
          ], 2)) : createCommentVNode("", !0)
        ]),
        _: 1
      }, 8, ["name"]),
      !Ve.value && !Fe.value && Me.value ? renderSlot(Ct.$slots, "default", { key: 0 }, void 0, !0) : createCommentVNode("", !0),
      createElementVNode("div", {
        ref_key: "mapElement",
        ref: Le,
        class: normalizeClass(unref(css$1d)("map"))
      }, null, 2)
    ], 2));
  }
}), SatMap = /* @__PURE__ */ _export_sfc(_sfc_main$1k, [["__scopeId", "data-v-b9f7a371"]]), MolMap = SatMap, molMapGoogleMapsInjectionKey = satMapGoogleMapsInjectionKey, molMapMapInjectionKey = satMapMapInjectionKey, molMapErrorHandlerInjectionKey = satMapErrorHandlerInjectionKey, addMapListener = (e, j, ke, Se = 100) => {
  const xe = debounce$1(j, Se);
  ke.addListener(e, xe);
}, registerMarkerListeners = (e, j, ke, Se) => {
  addMapListener(
    "drag",
    () => e("drag", ke.getPosition()?.toJSON()),
    ke,
    100
  ), addMapListener(
    "dragstart",
    () => e("dragStart", ke.getPosition()?.toJSON()),
    ke,
    0
  ), addMapListener(
    "dragend",
    () => {
      const xe = ke.getPosition()?.toJSON();
      e("dragEnd", xe), !(!xe || !j.lookupAddress) && Se.geocode({ location: xe }).then((Ie) => {
        if (!Ie?.results[0]) return;
        const Me = Ie.results[0], Ee = [
          "locality",
          "administrative_area_level_3",
          "administrative_area_level_2"
        ];
        let Be = "", $e = !1;
        for (const Le of Ee) {
          if ($e) break;
          for (const Fe of Me.address_components)
            if (Fe.types.includes(Le)) {
              Be = Fe.long_name || Fe.short_name, $e = !0;
              break;
            }
        }
        e("addressLookup", {
          mainArea: Be,
          placeId: Me.place_id,
          formattedAddress: Me.formatted_address,
          coordinates: Me.geometry.location.toJSON(),
          postalCode: Me.address_components.find(
            (Le) => Le.types.includes("postal_code")
          )?.long_name
        });
      });
    },
    ke,
    0
  ), addMapListener("click", () => e("click"), ke, 0), addMapListener("doubleclick", () => e("doubleClick"), ke, 0), addMapListener("mouseover", () => e("mouseOver"), ke, 0), addMapListener("mouseout", () => e("mouseOut"), ke, 0);
}, satMapMarkerInjectionKey = Symbol("satMapMarkerInjectionKey"), _sfc_main$1j = /* @__PURE__ */ defineComponent({
  __name: "SatMapMarker",
  props: {
    position: {},
    draggable: { type: Boolean },
    isVisible: { type: Boolean, default: !0 },
    lookupAddress: { type: Boolean, default: !1 },
    label: {},
    labelColor: {},
    labelFontFamily: {},
    markerColor: {}
  },
  emits: ["drag", "dragStart", "dragEnd", "addressLookup", "click", "doubleClick", "mouseOver", "mouseOut"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, { getRawTokenValue: xe } = useDesignTokens(), Ie = Y$2(satMapMapInjectionKey), Me = Y$2(satMapGoogleMapsInjectionKey), Ee = Y$2(satMapErrorHandlerInjectionKey), Be = ref(!1);
    let $e;
    const Le = {
      path: "M32 16c0 4.26-1.666 8.133-4.381 11-2.916 3.08 0 0-11.619 11.5C4.381 27 7.297 30.08 4.381 27A15.945 15.945 0 0 1 0 16C0 7.163 7.163 0 16 0s16 7.163 16 16Z",
      fillColor: ke.markerColor ?? xe("--color-primary"),
      fillOpacity: 1,
      strokeWeight: 0,
      rotation: 0,
      scale: 1,
      anchor: new google.maps.Point(16, 39),
      labelOrigin: new Me.value.Point(16, 16)
    }, Fe = computed(() => {
      if (!$e)
        throw new Error("Google Maps Marker instance not found.");
      return $e;
    }), Ve = computed(() => {
      const De = ke.label || "⬤", Ue = ke.label ? "18px" : "17px", Re = ke.labelColor ?? xe("--color-on-primary"), Ye = ke.labelFontFamily ?? xe("--text-base-font-family");
      return {
        text: De,
        color: Re,
        fontSize: Ue,
        fontFamily: Ye
      };
    });
    provide(satMapMarkerInjectionKey, Fe);
    const je = () => {
      try {
        $e = new Me.value.Marker({
          position: ke.position,
          draggable: ke.draggable,
          crossOnDrag: !1,
          icon: Le,
          label: Ve.value,
          visible: ke.isVisible
        }), $e.setMap(Ie.value);
        const De = new google.maps.Geocoder();
        registerMarkerListeners(Se, ke, $e, De), Be.value = !0;
      } catch (De) {
        Ee(
          De instanceof Error ? De : new Error("Google Maps Marker: error creating marker instance.")
        );
      }
    }, Ge = () => {
      try {
        if (!$e) return;
        Me.value.event.clearInstanceListeners($e), $e.setMap(null), $e = void 0;
      } catch (De) {
        Ee(
          De instanceof Error ? De : new Error("Google Maps Marker: error removing the marker instance.")
        );
      }
    };
    return onMounted(() => {
      je();
    }), onUnmounted(() => {
      Ge();
    }), watch(
      () => ke.position,
      (De) => {
        Fe.value.setPosition(De);
      },
      { deep: !0 }
    ), watch(
      () => ke.isVisible,
      (De) => {
        Fe.value.setVisible(De);
      }
    ), watch(
      () => ke.draggable,
      (De) => {
        Fe.value.setDraggable(De);
      }
    ), watch(
      () => ke.lookupAddress,
      (De) => {
        Fe.value.set("lookupAddress", De);
      }
    ), watch(
      () => [ke.markerColor, ke.label, ke.labelColor],
      ([De]) => {
        Le.fillColor = De ?? xe("--color-primary"), Fe.value.setIcon(Le), Fe.value.setLabel(Ve.value);
      }
    ), (De, Ue) => (openBlock(), createElementBlock("div", null, [
      Be.value ? renderSlot(De.$slots, "default", { key: 0 }) : createCommentVNode("", !0)
    ]));
  }
}), MolMapMarker = _sfc_main$1j, molMapMarkerInjectionKey = satMapMarkerInjectionKey, className$1c = "sat-map-marker-info", css$1c = bemBuilder(className$1c);
bemBuilder(className$1c, !0);
const className$1b = "sat-map-info-window", css$1b = bemBuilder(className$1b);
bemBuilder(className$1b, !0);
const _sfc_main$1i = /* @__PURE__ */ defineComponent({
  __name: "SatMapInfoWindow",
  props: {
    isOpen: { type: Boolean }
  },
  setup(e) {
    const j = e, ke = Y$2(satMapMapInjectionKey), Se = Y$2(satMapGoogleMapsInjectionKey), xe = Y$2(satMapMarkerInjectionKey), Ie = Y$2(satMapErrorHandlerInjectionKey), Me = ref();
    let Ee;
    const Be = computed(() => {
      if (!Ee)
        throw new Error("Map Info Window instance not found.");
      return Ee;
    }), $e = () => {
      if (!Me.value)
        throw new Error("Map Info Window element not found.");
      try {
        Ee = new Se.value.InfoWindow({
          content: Me.value,
          pixelOffset: new google.maps.Size(0, 18)
        }), j.isOpen && Le();
      } catch (je) {
        Ie(
          je instanceof Error ? je : new Error("Google Maps Marker: error creating marker instance.")
        );
      }
    }, Le = () => {
      Be.value.open({
        anchor: xe.value,
        map: ke.value,
        shouldFocus: !1
      });
    }, Fe = () => {
      Be.value.close();
    }, Ve = () => {
      try {
        if (!Ee) return;
        Ee.close(), Ee.setContent(null), Ee = void 0;
      } catch {
      }
    };
    return onMounted(() => {
      $e();
    }), onUnmounted(() => {
      Ve();
    }), watch(
      () => j.isOpen,
      (je) => {
        je ? Le() : Fe();
      }
    ), (je, Ge) => (openBlock(), createElementBlock("div", {
      ref_key: "mainElement",
      ref: Me,
      class: normalizeClass(unref(css$1b)())
    }, [
      renderSlot(je.$slots, "default")
    ], 2));
  }
}), AtomMapInfoWindow = _sfc_main$1i, _sfc_main$1h = /* @__PURE__ */ defineComponent({
  __name: "SatMapMarkerInfo",
  props: {
    title: {},
    description: {},
    position: {},
    draggable: { type: Boolean, default: !1 },
    isVisible: { type: Boolean, default: !0 },
    label: {},
    labelColor: {},
    markerColor: {},
    isInfoOpen: { type: Boolean, default: !0 },
    isInfoDisabled: { type: Boolean, default: !1 },
    lookupAddress: { type: Boolean, default: !1 },
    showCta: { type: Boolean, default: !0 },
    ctaLabel: { default: "Click here" },
    isCtaLoading: { type: Boolean, default: !1 },
    isCtaDisabled: { type: Boolean, default: !1 }
  },
  emits: ["mouseOver", "mouseOut", "markerClick", "ctaClick", "addressLookup"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = computed(
      () => ke.isInfoDisabled ? "color-text-disabled" : "color-text-body"
    ), Ie = (Ee) => {
      Se("ctaClick", Ee);
    }, Me = (Ee) => {
      Se("addressLookup", Ee);
    };
    return (Ee, Be) => (openBlock(), createBlock(unref(_sfc_main$1j), {
      draggable: ke.draggable,
      position: ke.position,
      "is-visible": ke.isVisible,
      label: ke.label,
      "label-color": ke.labelColor,
      "marker-color": ke.markerColor,
      "lookup-address": ke.lookupAddress,
      onMouseOver: Be[0] || (Be[0] = ($e) => Se("mouseOver")),
      onMouseOut: Be[1] || (Be[1] = ($e) => Se("mouseOut")),
      onClick: Be[2] || (Be[2] = ($e) => Se("markerClick")),
      onAddressLookup: Me
    }, {
      default: withCtx(() => [
        withDirectives(createVNode(unref(_sfc_main$1i), {
          "is-open": ke.isVisible
        }, {
          default: withCtx(() => [
            createElementVNode("div", {
              class: normalizeClass(unref(css$1c)("bubble"))
            }, [
              createVNode(unref(AtomCard), {
                class: normalizeClass(unref(css$1c)("bubble-content")),
                radii: "small",
                elevation: "large"
              }, {
                default: withCtx(() => [
                  createVNode(unref(AtomText), {
                    type: "subtitle",
                    color: xe.value
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(ke.title), 1)
                    ]),
                    _: 1
                  }, 8, ["color"]),
                  createVNode(unref(AtomText), {
                    type: "small",
                    color: xe.value
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(ke.description), 1)
                    ]),
                    _: 1
                  }, 8, ["color"]),
                  renderSlot(Ee.$slots, "default", {}, void 0, !0)
                ]),
                _: 3
              }, 8, ["class"]),
              !ke.isInfoDisabled && ke.showCta ? (openBlock(), createBlock(unref(AtomButton), {
                key: 0,
                "is-loading": ke.isCtaLoading,
                "is-disabled": ke.isCtaDisabled,
                size: "large",
                wide: "",
                onClick: Ie
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(ke.ctaLabel), 1)
                ]),
                _: 1
              }, 8, ["is-loading", "is-disabled"])) : createCommentVNode("", !0)
            ], 2)
          ]),
          _: 3
        }, 8, ["is-open"]), [
          [vShow, ke.isInfoOpen]
        ])
      ]),
      _: 3
    }, 8, ["draggable", "position", "is-visible", "label", "label-color", "marker-color", "lookup-address"]));
  }
}), SatMapMarkerInfo = /* @__PURE__ */ _export_sfc(_sfc_main$1h, [["__scopeId", "data-v-7e3f23c5"]]), className$1a = "sat-button-current-location", css$1a = bemBuilder(className$1a);
bemBuilder(className$1a, !0);
const _sfc_main$1g = /* @__PURE__ */ defineComponent({
  __name: "SatButtonCurrentLocation",
  props: {
    label: {},
    disabled: { type: Boolean, default: !1 },
    isLoading: { type: Boolean, default: !1 },
    wide: { type: Boolean, default: !1 },
    apiKey: {}
  },
  emits: ["success", "error"],
  setup(e, { emit: j }) {
    const ke = j, Se = ref(!1), xe = ref(), Ie = ref(), Me = e, Ee = async (Fe) => {
      const Ve = Fe.coords.latitude, je = Fe.coords.longitude, Ge = await Le({ lat: Ve, lng: je });
      ke("success", Ge), Se.value = !1;
    }, Be = (Fe) => {
      const Ve = Fe.code, je = Fe.message;
      ke("error", { code: Ve, message: je }), Se.value = !1;
    }, $e = () => {
      !Se.value && !Me.disabled && !Me.isLoading && (Se.value = !0, navigator.geolocation.getCurrentPosition(Ee, Be));
    }, Le = async (Fe) => {
      if (!Ie.value)
        throw new Error("Google Maps: Geocode service is not available.");
      const je = (await Ie.value.geocode({
        location: {
          lat: Fe.lat,
          lng: Fe.lng
        }
      })).results[0];
      if (!je)
        throw new Error("Google Maps: Invalid location id.");
      const Ge = [
        "locality",
        "administrative_area_level_3",
        "administrative_area_level_2"
      ];
      let De = "", Ue = !1;
      for (const Re of Ge) {
        if (Ue) break;
        for (const Ye of je.address_components)
          if (Ye.types.includes(Re)) {
            De = Ye.long_name || Ye.short_name, Ue = !0;
            break;
          }
      }
      return {
        coordinates: je.geometry.location.toJSON(),
        formattedAddress: je.formatted_address,
        mainArea: De,
        placeId: je.place_id,
        postalCode: je.address_components.find(
          (Re) => Re.types.includes("postal_code")
        )?.long_name
      };
    };
    return onMounted(async () => {
      const { getMaps: Fe } = useGoogleMaps(Me.apiKey);
      xe.value = await Fe(), xe.value && (Ie.value = new xe.value.Geocoder());
    }), (Fe, Ve) => (openBlock(), createElementBlock("a", {
      href: "",
      class: normalizeClass([
        unref(css$1a)(),
        {
          [unref(css$1a)("", "wide")]: Me.wide,
          [unref(css$1a)("", "disabled")]: Me.disabled || Se.value || e.isLoading
        }
      ]),
      onClick: withModifiers($e, ["prevent"])
    }, [
      Se.value || e.isLoading ? (openBlock(), createBlock(unref(AtomLoadingSpinner), {
        key: 0,
        size: 21
      })) : (openBlock(), createBlock(unref(SatIconButton), {
        key: 1,
        class: normalizeClass(unref(css$1a)("icon")),
        theme: "filled",
        size: "extra-small",
        "icon-name": "location",
        disabled: Me.disabled
      }, null, 8, ["class", "disabled"])),
      Me.label ? (openBlock(), createBlock(unref(AtomText), { key: 2 }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(Me.label), 1)
        ]),
        _: 1
      })) : createCommentVNode("", !0)
    ], 2));
  }
}), SatButtonCurrentLocation = /* @__PURE__ */ _export_sfc(_sfc_main$1g, [["__scopeId", "data-v-e02fa005"]]), className$19 = "sat-menu-selector", css$19 = bemBuilder(className$19);
bemBuilder(className$19, !0);
const _hoisted_1$p = ["href", "onClick"], _sfc_main$1f = /* @__PURE__ */ defineComponent({
  __name: "SatMenuSelector",
  props: {
    menus: {}
  },
  emits: ["select"],
  setup(e, { emit: j }) {
    const ke = e, Se = j;
    return (xe, Ie) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$19)())
    }, [
      createElementVNode("ul", {
        class: normalizeClass(unref(css$19)("list"))
      }, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(ke.menus, (Me) => (openBlock(), createElementBlock("li", {
          key: Me.id,
          class: normalizeClass(unref(css$19)("line"))
        }, [
          createElementVNode("a", {
            href: Me.link,
            class: normalizeClass(unref(css$19)("link")),
            onClick: withModifiers(
              (Ee) => Se("select", { id: Me.id, link: Me.link, event: Ee }),
              ["prevent"]
            )
          }, [
            createElementVNode("div", {
              class: normalizeClass(unref(css$19)("image")),
              style: normalizeStyle(`background-image: url(${Me.icon})`)
            }, null, 6),
            createVNode(unref(AtomText), {
              type: "subtitle",
              color: "color-text-headline"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(Me.title), 1)
              ]),
              _: 2
            }, 1024),
            Me.summary ? (openBlock(), createBlock(unref(AtomText), {
              key: 0,
              "data-test": "summary",
              type: "small",
              tag: "p",
              color: "color-text-secondary"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(Me.summary), 1)
              ]),
              _: 2
            }, 1024)) : createCommentVNode("", !0)
          ], 10, _hoisted_1$p)
        ], 2))), 128))
      ], 2)
    ], 2));
  }
}), SatMenuSelector = /* @__PURE__ */ _export_sfc(_sfc_main$1f, [["__scopeId", "data-v-0429bebd"]]), className$18 = "sat-menu-navigator", css$18 = bemBuilder(className$18);
bemBuilder(className$18, !0);
const className$17 = "atom-pill", css$17 = bemBuilder(className$17);
bemBuilder(className$17, !0);
const _sfc_main$1e = /* @__PURE__ */ defineComponent({
  __name: "AtomPill",
  props: {
    active: { type: Boolean, default: !1 },
    size: { default: "large" }
  },
  emits: ["click"],
  setup(e) {
    const j = e;
    return (ke, Se) => (openBlock(), createElementBlock("button", {
      class: normalizeClass([unref(css$17)(), unref(css$17)("", j.size), { [unref(css$17)("", "active")]: j.active }]),
      onClick: Se[0] || (Se[0] = withModifiers((xe) => ke.$emit("click", xe), ["prevent"]))
    }, [
      renderSlot(ke.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), AtomPill = /* @__PURE__ */ _export_sfc(_sfc_main$1e, [["__scopeId", "data-v-f9d21af2"]]), className$16 = "mol-unordered-list", css$16 = bemBuilder(className$16);
bemBuilder(className$16, !0);
const _hoisted_1$o = ["onClick"], _sfc_main$1d = /* @__PURE__ */ defineComponent({
  __name: "MolUnorderedList",
  props: {
    items: {},
    activeId: {}
  },
  emits: ["itemSelected"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = ref(ke.activeId), Ie = (Ee) => Ee === xe.value, Me = (Ee) => {
      Ie(Ee) || (xe.value = Ee, Se("itemSelected", Ee));
    };
    return (Ee, Be) => (openBlock(), createElementBlock("ul", {
      class: normalizeClass(unref(css$16)())
    }, [
      (openBlock(!0), createElementBlock(Fragment, null, renderList(ke.items, ($e) => (openBlock(), createElementBlock("li", {
        key: $e.id,
        class: normalizeClass([
          unref(css$16)("item"),
          Ie($e.id) ? unref(css$16)("item", "active") : ""
        ])
      }, [
        createElementVNode("a", {
          href: "#",
          class: normalizeClass(unref(css$16)("item-link")),
          onClick: withModifiers((Le) => Me($e.id), ["prevent"])
        }, [
          createElementVNode("div", {
            class: normalizeClass(unref(css$16)("item-link-content"))
          }, [
            createVNode(unref(AtomText), {
              type: Ie($e.id) ? "body-bold" : "body"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString($e.name), 1)
              ]),
              _: 2
            }, 1032, ["type"]),
            createVNode(unref(AtomText), { type: "small-bold" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString($e.count), 1)
              ]),
              _: 2
            }, 1024)
          ], 2)
        ], 10, _hoisted_1$o)
      ], 2))), 128))
    ], 2));
  }
}), MolUnorderedList = /* @__PURE__ */ _export_sfc(_sfc_main$1d, [["__scopeId", "data-v-30003355"]]), _sfc_main$1c = /* @__PURE__ */ defineComponent({
  __name: "SatMenuNavigator",
  props: {
    layout: { default: 1 },
    activeId: {},
    title: {},
    items: {},
    showNavBar: { type: Boolean, default: !0 },
    showImages: { type: Boolean },
    searchable: { type: Boolean },
    searchDebounce: {},
    searchPlaceholder: {}
  },
  emits: ["itemSelected", "search", "searchCancelled"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, {
      enable: xe,
      disable: Ie,
      state: Me
    } = useTogglable(), Ee = ref(), Be = ref(), $e = ref(), Le = ref(!1), Fe = ref(""), Ve = () => {
      Le.value = !1, Fe.value = "", Se("searchCancelled");
    };
    watchDebounced(
      () => Fe.value,
      (We) => {
        Se("search", We);
      },
      {
        debounce: ke.searchDebounce ?? 300
      }
    ), watch(
      () => ke.activeId,
      (We) => {
        We && (Ee.value = We, De(We));
      },
      { immediate: !0 }
    ), watch(
      () => Me.value,
      (We) => {
        We && nextTick(Ue);
      }
    );
    function je(We) {
      Se("itemSelected", We), !Ge(We) && (Ee.value = We, Me.value && Ie(), nextTick(() => {
        De(We);
      }));
    }
    function Ge(We) {
      return We === Ee.value;
    }
    function De(We) {
      const qe = document.getElementById(We);
      if (!qe) return;
      const Je = qe.getBoundingClientRect().left, Ke = Be.value?.getBoundingClientRect()?.left;
      if (!Ke) return;
      const Ct = parseFloat(Be.value.scrollLeft) + Je - Ke - 7;
      Be.value.scrollTo({
        left: Ct,
        behavior: "smooth"
      });
    }
    function Ue() {
      const We = Re($e);
      We && We.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start"
      });
    }
    const Re = (We) => {
      if (!We.value) return;
      const qe = We.value.$el?.children, Je = Ye();
      return qe[Je];
    }, Ye = () => ke.items.findIndex((We) => We.id === Ee.value);
    return (We, qe) => (openBlock(), createElementBlock("div", {
      class: normalizeClass([
        unref(css$18)(),
        {
          [unref(css$18)("", "with-image")]: ke.showImages,
          [unref(css$18)("", "layout-two")]: ke.layout === 2
        }
      ])
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$18)("content"))
      }, [
        ke.showNavBar ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(css$18)("burger-button"))
        }, [
          createVNode(unref(AtomPill), {
            class: normalizeClass([unref(css$18)("pill"), unref(css$18)("pill", "burger")]),
            onClick: unref(xe)
          }, {
            default: withCtx(() => [
              createVNode(unref(_sfc_main$1Q), {
                name: "nav",
                "ignore-color": "",
                size: ke.showImages ? "medium" : "small"
              }, null, 8, ["size"])
            ]),
            _: 1
          }, 8, ["class", "onClick"])
        ], 2)) : createCommentVNode("", !0),
        Le.value ? createCommentVNode("", !0) : (openBlock(), createElementBlock("div", {
          key: 1,
          ref_key: "menuRef",
          ref: Be,
          class: normalizeClass([
            unref(css$18)("menu"),
            { [unref(css$18)("menu", "with-search")]: ke.searchable }
          ])
        }, [
          (openBlock(!0), createElementBlock(Fragment, null, renderList(ke.items, (Je) => (openBlock(), createBlock(unref(AtomPill), {
            id: Je.id,
            key: Je.id,
            class: normalizeClass([
              unref(css$18)("pill"),
              unref(css$18)("pill", "item"),
              { [unref(css$18)("pill", "active")]: Ee.value === Je.id }
            ]),
            active: Ge(Je.id),
            onClick: (Ke) => je(Je.id)
          }, {
            default: withCtx(() => [
              ke.showImages ? (openBlock(), createElementBlock("span", {
                key: 0,
                class: normalizeClass(unref(css$18)("image")),
                style: normalizeStyle(Je.image ? `background-image: url(${Je.image})` : "")
              }, null, 6)) : createCommentVNode("", !0),
              createElementVNode("span", {
                class: normalizeClass(unref(css$18)("name"))
              }, [
                createElementVNode("span", null, toDisplayString(Je.name), 1)
              ], 2)
            ]),
            _: 2
          }, 1032, ["id", "class", "active", "onClick"]))), 128))
        ], 2)),
        ke.searchable ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
          createElementVNode("div", {
            key: "search-input",
            class: normalizeClass([
              unref(css$18)("search-input"),
              { [unref(css$18)("search-input", "visible")]: Le.value }
            ])
          }, [
            createVNode(unref(SatInputSearch), {
              modelValue: Fe.value,
              "onUpdate:modelValue": qe[0] || (qe[0] = (Je) => Fe.value = Je),
              "is-menu-search": "",
              clearable: "",
              "auto-focus": "",
              "keep-clear-visible": "",
              placeholder: ke.searchPlaceholder || unref(t)("menu_navigator.search_placeholder"),
              onClear: Ve
            }, null, 8, ["modelValue", "placeholder"])
          ], 2),
          createElementVNode("div", {
            class: normalizeClass({
              [unref(css$18)("search-button")]: !0,
              [unref(css$18)("search-button", "visible")]: !Le.value
            })
          }, [
            createVNode(unref(AtomPill), {
              class: normalizeClass([unref(css$18)("pill"), unref(css$18)("pill", "search")]),
              onClick: qe[1] || (qe[1] = () => Le.value = !0)
            }, {
              default: withCtx(() => [
                createVNode(unref(_sfc_main$1Q), {
                  name: "search",
                  "ignore-color": "",
                  size: ke.showImages ? "medium" : "small"
                }, null, 8, ["size"])
              ]),
              _: 1
            }, 8, ["class"])
          ], 2)
        ], 64)) : createCommentVNode("", !0)
      ], 2),
      (openBlock(), createBlock(Teleport, { to: "body" }, [
        createVNode(unref(SatDrawer), {
          modelValue: unref(Me),
          "onUpdate:modelValue": [
            qe[3] || (qe[3] = (Je) => isRef(Me) ? Me.value = Je : null),
            unref(Ie)
          ],
          "aria-label": "drawer-category-menu",
          "max-width": 460,
          class: normalizeClass(unref(css$18)("drawer"))
        }, {
          default: withCtx(() => [
            createElementVNode("div", {
              class: normalizeClass(unref(css$18)("drawer-content"))
            }, [
              ke.title ? (openBlock(), createElementBlock("header", {
                key: 0,
                class: normalizeClass(unref(css$18)("list-header"))
              }, [
                createVNode(unref(AtomText), { type: "subtitle" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(ke.title), 1)
                  ]),
                  _: 1
                }),
                createElementVNode("a", {
                  href: "#",
                  onClick: qe[2] || (qe[2] = withModifiers(
                    //@ts-ignore
                    (...Je) => unref(Ie) && unref(Ie)(...Je),
                    ["prevent"]
                  ))
                }, [
                  createVNode(unref(_sfc_main$1Q), {
                    name: "close",
                    color: "color-primary"
                  })
                ])
              ], 2)) : createCommentVNode("", !0),
              createVNode(unref(MolUnorderedList), {
                ref_key: "unorderedListRef",
                ref: $e,
                "active-id": Ee.value,
                class: normalizeClass(unref(css$18)("list-menu")),
                items: ke.items,
                onItemSelected: je
              }, null, 8, ["active-id", "class", "items"])
            ], 2)
          ]),
          _: 1
        }, 8, ["modelValue", "class", "onUpdate:modelValue"])
      ]))
    ], 2));
  }
}), SatMenuNavigator = /* @__PURE__ */ _export_sfc(_sfc_main$1c, [["__scopeId", "data-v-3f3d5a23"]]), className$15 = "sat-item-display", css$15 = bemBuilder(className$15);
bemBuilder(className$15, !0);
const _sfc_main$1b = /* @__PURE__ */ defineComponent({
  __name: "SatItemDisplay",
  props: {
    view: { default: "col" },
    id: {},
    name: {},
    photo: {},
    description: {},
    amount: {},
    originalAmount: {},
    customPriceLabel: {},
    locale: {},
    showPlusSymbolPrice: { type: Boolean },
    isDisabled: { type: Boolean, default: !1 },
    hasAllergenItems: { type: Boolean },
    consumables: {}
  },
  setup(e) {
    const j = e, { optimize: ke } = useImage(), Se = computed(() => {
      if (j.amount) {
        if (typeof j.amount == "number") {
          const Ve = "currency" in j && typeof j?.currency == "string" ? j.currency : "USD";
          return {
            value: j.amount,
            currency: Ve
          };
        }
        return j.amount;
      }
    }), xe = computed(() => {
      if (!(!j.originalAmount || !Se.value || j.originalAmount.value === Se.value.value))
        return j.originalAmount;
    }), Ie = computed(() => j.view === "col"), Me = computed(
      () => j.isDisabled ? "color-text-disabled" : null
    ), Ee = computed(() => Me.value || "color-text-body"), Be = computed(() => Me.value || "color-text-secondary"), $e = computed(() => Me.value || "color-text-body"), Le = computed(() => j.consumables.length), Fe = computed(
      () => j.hasAllergenItems || Le.value > 0
    );
    return (Ve, je) => (openBlock(), createElementBlock("div", {
      class: normalizeClass([unref(css$15)(), unref(css$15)("", j.view)])
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$15)("description"))
      }, [
        createVNode(unref(AtomText), {
          tag: "h2",
          type: Ie.value ? "subtitle" : "body-bold",
          color: Ee.value
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(j.name), 1)
          ]),
          _: 1
        }, 8, ["type", "color"]),
        Ie.value && j.description ? (openBlock(), createBlock(unref(AtomText), {
          key: 0,
          class: normalizeClass(unref(css$15)("desc")),
          color: Be.value
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(j.description), 1)
          ]),
          _: 1
        }, 8, ["class", "color"])) : createCommentVNode("", !0),
        Fe.value ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass([
            unref(css$15)("nutrition"),
            { [unref(css$15)("nutrition", "disabled")]: j.isDisabled }
          ])
        }, [
          j.hasAllergenItems ? (openBlock(), createBlock(unref(AtomBadge), {
            key: 0,
            class: normalizeClass([unref(css$15)("nutrition-tag"), unref(css$15)("nutrition-tag", "allergens")]),
            size: "small",
            emphasis: "low",
            state: "warning",
            value: "Allergens"
          }, null, 8, ["class"])) : createCommentVNode("", !0),
          Le.value > 0 ? (openBlock(), createBlock(unref(AtomBadge), {
            key: 1,
            class: normalizeClass([
              unref(css$15)("nutrition-tag"),
              unref(css$15)("nutrition-tag", "consumable-label")
            ]),
            size: "small",
            emphasis: "low",
            state: "neutral",
            value: j.consumables[0]
          }, null, 8, ["class", "value"])) : createCommentVNode("", !0),
          Le.value > 1 ? (openBlock(), createBlock(unref(AtomBadge), {
            key: 2,
            class: normalizeClass([unref(css$15)("nutrition-tag"), unref(css$15)("nutrition-tag", "amount")]),
            size: "small",
            emphasis: "low",
            state: "neutral",
            value: `+ ${Le.value - 1}`
          }, null, 8, ["class", "value"])) : createCommentVNode("", !0)
        ], 2)) : createCommentVNode("", !0),
        createVNode(unref(AtomText), {
          class: normalizeClass(unref(css$15)("price-area")),
          color: $e.value,
          type: Ie.value ? "body-bold" : "body"
        }, {
          default: withCtx(() => [
            j.customPriceLabel ? (openBlock(), createElementBlock("span", {
              key: 0,
              class: normalizeClass(unref(css$15)("custom-price"))
            }, toDisplayString(j.customPriceLabel), 3)) : Se.value ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              j.showPlusSymbolPrice && j.amount && j.amount?.value > 0 ? (openBlock(), createElementBlock("span", {
                key: 0,
                class: normalizeClass(unref(css$15)("price-icon"))
              }, " + ", 2)) : createCommentVNode("", !0),
              createVNode(unref(_sfc_main$1w), {
                class: normalizeClass(unref(css$15)("price")),
                amount: Se.value.value,
                currency: Se.value.currency,
                locale: j.locale
              }, null, 8, ["class", "amount", "currency", "locale"]),
              xe.value ? (openBlock(), createBlock(unref(AtomText), {
                key: 1,
                striked: "",
                type: "body",
                color: "color-text-secondary",
                class: normalizeClass(unref(css$15)("original-price"))
              }, {
                default: withCtx(() => [
                  createVNode(unref(_sfc_main$1w), {
                    amount: xe.value.value,
                    currency: xe.value.currency,
                    locale: j.locale
                  }, null, 8, ["amount", "currency", "locale"])
                ]),
                _: 1
              }, 8, ["class"])) : createCommentVNode("", !0)
            ], 64)) : createCommentVNode("", !0)
          ]),
          _: 1
        }, 8, ["class", "color", "type"])
      ], 2),
      createElementVNode("div", {
        class: normalizeClass([
          unref(css$15)("image-box"),
          { [unref(css$15)("image-box", "no-image")]: !j.photo },
          { [unref(css$15)("image-box", "disabled")]: j.isDisabled }
        ])
      }, [
        j.photo ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(css$15)("image")),
          style: normalizeStyle(`background-image: url(${unref(ke)(j.photo, {
            w: 800,
            h: 800,
            fit: "crop",
            crop: "center"
          })})`)
        }, null, 6)) : Ie.value ? createCommentVNode("", !0) : (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass([unref(css$15)("placeholder"), unref(css$15)("placeholder", j.view)])
        }, [
          createVNode(unref(_sfc_main$1Q), {
            class: normalizeClass(unref(css$15)("placeholder-icon")),
            name: "food",
            size: "49",
            color: "color-base-50"
          }, null, 8, ["class"])
        ], 2)),
        renderSlot(Ve.$slots, "afterImage", {}, void 0, !0)
      ], 2)
    ], 2));
  }
}), SatItemDisplay = /* @__PURE__ */ _export_sfc(_sfc_main$1b, [["__scopeId", "data-v-674e0438"]]), className$14 = "sat-item-selector", css$14 = bemBuilder(className$14);
bemBuilder(className$14, !0);
const _hoisted_1$n = { key: 1 }, _sfc_main$1a = /* @__PURE__ */ defineComponent({
  __name: "SatItemSelector",
  props: {
    id: {},
    view: { default: "row" },
    type: {},
    name: {},
    count: { default: 0 },
    photo: {},
    description: {},
    amount: {},
    originalAmount: {},
    customPriceLabel: {},
    locale: {},
    isDisabled: { type: Boolean, default: !1 },
    hasAllergenItems: { type: Boolean, default: !1 },
    showPlusSymbolPrice: { type: Boolean, default: !1 },
    consumables: {},
    isSelected: { type: Boolean },
    cardPadding: { default: "medium" },
    buttonSize: { default: "medium" },
    customizeLabel: {}
  },
  emits: ["click", "increase", "decrease", "customize"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = (Me) => {
      ke.isDisabled || Se("click", { itemId: ke.id, event: Me });
    }, Ie = (Me) => {
      Se("customize", { itemId: ke.id, event: Me });
    };
    return (Me, Ee) => (openBlock(), createBlock(unref(AtomCard), {
      class: normalizeClass([unref(css$14)(""), { [unref(css$14)("", "selected")]: ke.isSelected }]),
      padding: ke.cardPadding,
      onClick: xe
    }, {
      default: withCtx(() => [
        createVNode(unref(SatItemDisplay), {
          id: ke.id,
          view: ke.view,
          name: ke.name,
          photo: ke.photo,
          description: ke.description,
          amount: ke.amount,
          "original-amount": ke.originalAmount,
          "custom-price-label": ke.customPriceLabel,
          locale: ke.locale,
          "show-plus-symbol-price": ke.showPlusSymbolPrice,
          "is-disabled": ke.isDisabled,
          "has-allergen-items": ke.hasAllergenItems,
          consumables: ke.consumables || []
        }, createSlots({ _: 2 }, [
          e.type ? {
            name: "afterImage",
            fn: withCtx(() => [
              createElementVNode("div", {
                class: normalizeClass([
                  unref(css$14)("action"),
                  { [unref(css$14)("action", "col")]: ke.view === "col" }
                ])
              }, [
                e.type === "multiple" ? (openBlock(), createBlock(unref(SatQuickAddButton), {
                  key: 0,
                  value: ke.id,
                  count: ke.count,
                  "show-delete": !1,
                  "is-animated": !1,
                  disabled: ke.isDisabled,
                  size: ke.buttonSize,
                  onClick: Ee[0] || (Ee[0] = withModifiers(() => {
                  }, ["stop"])),
                  onIncrease: Ee[1] || (Ee[1] = (Be, $e, Le) => Se("increase", { count: Be, itemId: $e, event: Le })),
                  onDecrease: Ee[2] || (Ee[2] = (Be, $e, Le) => Se("decrease", { count: Be, itemId: $e, event: Le }))
                }, null, 8, ["value", "count", "disabled", "size"])) : (openBlock(), createElementBlock("div", _hoisted_1$n, [
                  withDirectives(createVNode(unref(SatIconButton), {
                    size: ke.buttonSize,
                    "icon-name": "check"
                  }, null, 8, ["size"]), [
                    [vShow, ke.isSelected]
                  ]),
                  withDirectives(createVNode(unref(SatIconButton), {
                    size: ke.buttonSize,
                    "icon-name": "plus"
                  }, null, 8, ["size"]), [
                    [vShow, !ke.isSelected]
                  ])
                ]))
              ], 2)
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["id", "view", "name", "photo", "description", "amount", "original-amount", "custom-price-label", "locale", "show-plus-symbol-price", "is-disabled", "has-allergen-items", "consumables"]),
        ke.customizeLabel ? (openBlock(), createBlock(unref(AtomButton), {
          key: 0,
          class: normalizeClass(unref(css$14)("customize")),
          size: "small",
          theme: "filled",
          variant: "secondary",
          wide: "",
          "is-disabled": ke.isDisabled,
          onClick: withModifiers(Ie, ["stop"])
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.customizeLabel), 1)
          ]),
          _: 1
        }, 8, ["class", "is-disabled"])) : createCommentVNode("", !0)
      ]),
      _: 1
    }, 8, ["class", "padding"]));
  }
}), SatItemSelector = /* @__PURE__ */ _export_sfc(_sfc_main$1a, [["__scopeId", "data-v-f989dea7"]]), className$13 = "sat-nutrition-info", css$13 = bemBuilder(className$13);
bemBuilder(className$13, !0);
const _sfc_main$19 = /* @__PURE__ */ defineComponent({
  __name: "SatNutritionInfo",
  props: {
    tags: {},
    caloriesLabel: {},
    caloriesValue: {},
    allergensLabel: {},
    allergensValue: {}
  },
  setup(e) {
    const j = e;
    return (ke, Se) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$13)())
    }, [
      j.tags?.length ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(unref(css$13)("tags"))
      }, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(j.tags, (xe, Ie) => (openBlock(), createBlock(unref(AtomBadge), {
          key: Ie,
          size: "small",
          emphasis: "low",
          state: "neutral",
          value: xe
        }, null, 8, ["value"]))), 128))
      ], 2)) : createCommentVNode("", !0),
      j.caloriesLabel && j.caloriesValue ? (openBlock(), createElementBlock("div", {
        key: 1,
        class: normalizeClass(unref(css$13)("calories"))
      }, [
        createVNode(unref(AtomText), {
          type: "small-bold",
          color: "color-text-body"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(j.caloriesLabel), 1)
          ]),
          _: 1
        }),
        createVNode(unref(AtomText), {
          type: "small",
          color: "color-text-secondary"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(` ${j.caloriesValue}`), 1)
          ]),
          _: 1
        })
      ], 2)) : createCommentVNode("", !0),
      j.allergensLabel && j.allergensValue ? (openBlock(), createElementBlock("div", {
        key: 2,
        class: normalizeClass(unref(css$13)("allergens"))
      }, [
        createVNode(unref(AtomText), {
          type: "small-bold",
          color: "color-canary"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(j.allergensLabel), 1)
          ]),
          _: 1
        }),
        createVNode(unref(AtomText), {
          type: "small",
          color: "color-text-secondary"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(` ${j.allergensValue}`), 1)
          ]),
          _: 1
        })
      ], 2)) : createCommentVNode("", !0)
    ], 2));
  }
}), SatNutritionInfo = /* @__PURE__ */ _export_sfc(_sfc_main$19, [["__scopeId", "data-v-e9c96afa"]]), className$12 = "sat-item-builder", css$12 = bemBuilder(className$12);
bemBuilder(className$12, !0);
function useItemBuilder(e) {
  const j = useStackedNavigation(), ke = ref(), Se = ref(), xe = ref(), Ie = ref(), Me = () => {
    e.rootItem.type === "variant" ? j.reset({
      type: "variant",
      item: e.rootItem,
      title: e.rootItem.name
    }) : (ke.value = e.rootItem, j.reset({
      type: "item",
      item: e.rootItem,
      title: e.rootItem.name
    }));
  }, Ee = (It) => {
    It.id !== Ie.value?.id && (Ie.value = void 0), ke.value = It, j.navigateTo({
      type: "item",
      item: It,
      title: It.name,
      subTitle: e.rootItem.type === "variant" ? e.rootItem.name : void 0,
      parentItemId: e.rootItem.type === "variant" ? e.rootItem.id : void 0
    });
  }, Be = (It, Nt) => {
    Se.value = It, xe.value = Nt, j.navigateTo({
      type: "modifier",
      item: It,
      title: It.name,
      subTitle: ke.value?.name,
      parentItemId: ke.value?.id,
      modifierListId: Nt
    });
  }, $e = (It, Nt, Bt) => {
    j.navigateTo({
      type: "sub-modifier",
      item: It,
      title: It.name,
      subTitle: Nt.name,
      parentItemId: Nt.id,
      modifierListId: Bt
    });
  }, Le = () => j.goBack(), Fe = computed(() => j.isAtRoot.value), Ve = computed(() => j.currentItem.value?.title || ""), je = computed(() => j.currentItem.value?.subTitle || ""), Ge = computed(() => j.currentItem.value?.type === "variant"), De = computed(() => j.currentItem.value?.type === "item"), Ue = computed(() => j.currentItem.value?.type === "modifier"), Re = computed(() => j.currentItem.value?.type === "sub-modifier");
  Me();
  const Ye = (It) => {
    Ie.value = It;
  }, We = (It, Nt) => {
    if (!Ie.value || !ke.value || !Se.value)
      return;
    const Bt = ke.value.modifierLists?.find(
      (Dt) => Dt.id === Nt
    );
    if (!Bt) return;
    Ie.value.modifierLists || (Ie.value.modifierLists = []);
    let At = Ie.value.modifierLists.find(
      (Dt) => Dt.id === Bt.id
    );
    At || (At = {
      id: Bt.id,
      plu: Bt.plu,
      modifiers: []
    }, Ie.value.modifierLists.push(At)), Bt.selectType === "radio" && (At.modifiers = []);
    const Ft = {
      id: It.id,
      plu: It.plu,
      quantity: It.quantity,
      unitPrice: It.unitPrice,
      modifierLists: It.modifierLists
    };
    At.modifiers.push(Ft), Se.value = void 0, xe.value = void 0, Le();
  }, qe = computed(() => e.discountApplied && e.discountApplied.unit === "percentage" && (e.discountApplied.discountedProducts.length === 0 || e.discountApplied.discountedProducts.includes(
    e.rootItem.plu
  )) ? e.discountApplied.amount : 0), Je = (It) => qe.value > 0 ? {
    value: It.value * (1 - qe.value / 100),
    currency: It.currency
  } : {
    value: It.value,
    currency: It.currency
  }, Ke = computed(() => {
    if (Ie.value) {
      if (e.rootItem.type === "variant") {
        const It = e.rootItem.modifierLists?.find(
          (Nt) => Nt.modifiers.find(
            (Bt) => Bt.id === Ie.value?.id
          )
        );
        return It ? {
          id: e.rootItem.id,
          // root item ID (variant)
          plu: e.rootItem.plu,
          quantity: 1,
          // quantity is fixed at 1 for variant
          unitPrice: Je(e.rootItem.price).value,
          modifierLists: [
            {
              id: It.id,
              plu: It.plu,
              modifiers: [Ie.value]
            }
          ],
          notes: Ie.value.notes
        } : Ie.value;
      }
      return Ie.value;
    }
  }), xt = (It = []) => It.reduce((Nt, Bt) => {
    const At = Bt.modifiers.reduce((Ft, Dt) => {
      const zt = Dt.unitPrice, kt = Dt.modifierLists ? xt(Dt.modifierLists) : 0;
      return Ft + (zt + kt) * Dt.quantity;
    }, 0);
    return Nt + At;
  }, 0), Ct = computed(() => {
    if (!Ke.value)
      return {
        value: 0,
        currency: e.rootItem.price.currency
      };
    const It = Ke.value.unitPrice, Nt = Ke.value.quantity, Bt = xt(
      Ke.value.modifierLists
    );
    return {
      value: (It + Bt) * Nt,
      currency: e.rootItem.price.currency
    };
  });
  return {
    selectedItem: ke,
    selectedModifier: Se,
    modifierListIdFromSelectedModifier: xe,
    basketPayload: Ie,
    finalBasketPayload: Ke,
    finalTotalPrice: Ct,
    isAtRoot: Fe,
    navigation: j,
    navigationTitle: Ve,
    navigationSubTitle: je,
    isVariantView: Ge,
    isItemView: De,
    isModifierView: Ue,
    isSubModifierView: Re,
    discountPercentageAmount: qe,
    setItem: Ye,
    setModifier: We,
    goBack: Le,
    navigateToItem: Ee,
    navigateToModifier: Be,
    navigateToSubModifier: $e
  };
}
const _hoisted_1$m = { class: "sat-item-builder-variant" }, _sfc_main$18 = /* @__PURE__ */ defineComponent({
  __name: "SatItemBuilderVariant",
  props: {
    variant: {},
    itemDisplayView: {},
    discountPercentageAmount: {},
    stacked: { type: Boolean }
  },
  emits: ["select"],
  setup(e, { emit: j }) {
    const ke = e, Se = j;
    return (xe, Ie) => (openBlock(), createElementBlock("div", _hoisted_1$m, [
      createVNode(unref(SatVariantSelection), {
        variant: ke.variant,
        "item-display-view": ke.itemDisplayView,
        "discount-percentage-amount": ke.discountPercentageAmount,
        stacked: ke.stacked,
        onSelect: Ie[0] || (Ie[0] = (Me) => Se("select", Me))
      }, null, 8, ["variant", "item-display-view", "discount-percentage-amount", "stacked"])
    ]));
  }
}), SatItemBuilderVariant = /* @__PURE__ */ _export_sfc(_sfc_main$18, [["__scopeId", "data-v-b5f3d6a3"]]);
function getScrollableParent(e) {
  let j = e.parentElement;
  for (; j; ) {
    const Se = getComputedStyle(j).overflowY;
    if (Se === "auto" || Se === "scroll")
      return j;
    j = j.parentElement;
  }
  return window;
}
function isHTMLElement(e) {
  return e !== window;
}
function scrollToId(e, j = 0) {
  if (!isBrowser()) return !1;
  const ke = document.getElementById(e);
  if (!ke) return !1;
  const Se = getScrollableParent(ke);
  if (Se === window)
    if (j === 0)
      ke.scrollIntoView({ behavior: "smooth", block: "start" });
    else {
      const Ie = ke.getBoundingClientRect().top + window.pageYOffset + j;
      window.scrollTo({
        top: Ie,
        behavior: "smooth"
      });
    }
  else if (isHTMLElement(Se)) {
    const xe = ke.getBoundingClientRect(), Ie = Se.getBoundingClientRect(), Me = xe.top - Ie.top, Ee = Se.scrollTop + Me + j;
    Se.scrollTo({
      top: Ee,
      behavior: "smooth"
    });
  }
  return !0;
}
const MOBILE_HEADER_NAVIGATION_HEIGHT$1 = -63, _sfc_main$17 = /* @__PURE__ */ defineComponent({
  __name: "SatItemBuilderItem",
  props: {
    item: {},
    parentItem: {},
    selected: {},
    discountPercentageAmount: {},
    isCtaLoading: { type: Boolean },
    finalTotalPrice: {},
    stacked: { type: Boolean },
    displayNotes: { type: Boolean },
    displayCounter: { type: Boolean }
  },
  emits: ["change", "customize-modifier", "add-to-basket"],
  setup(e, { emit: j }) {
    const ke = bemBuilder("sat-item-builder-item"), Se = e, xe = j, { optimize: Ie } = useImage(), { isMobile: Me } = useWindowResize(), Ee = ref(""), Be = ref(Se.selected?.quantity || 1), $e = ref(Se.item.price), Le = ref(), Fe = (Ge) => {
      $e.value = Ge.totalPrice, Le.value = Ge.validation, xe("change", Ge.basketPayload);
    }, Ve = (Ge) => {
      const Ue = Se.item.modifierLists.find(
        (Re) => Re.id === Ge.categoryId
      )?.modifiers?.find(
        (Re) => Re.id === Ge.itemId
      );
      Ue && xe("customize-modifier", Ue, Ge.categoryId);
    }, je = (Ge) => {
      if (Se.isCtaLoading) return;
      const De = Le.value?.errors;
      if (De?.length) {
        scrollToId(
          De[0].modifierListId,
          Me.value ? MOBILE_HEADER_NAVIGATION_HEIGHT$1 : 0
        );
        return;
      }
      xe("add-to-basket", Ge);
    };
    return (Ge, De) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(ke)())
    }, [
      createElementVNode("div", {
        class: normalizeClass({
          [unref(ke)("wrapper")]: !0,
          [unref(ke)("wrapper", "stacked")]: Se.stacked
        })
      }, [
        Se.item?.photo ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(ke)("image"))
        }, [
          createElementVNode("div", {
            class: normalizeClass(unref(ke)("photo")),
            style: normalizeStyle(`background-image: url(${unref(Ie)(Se.item.photo, {
              w: 800,
              h: 800,
              fit: "crop",
              crop: "center"
            })})`)
          }, null, 6)
        ], 2)) : createCommentVNode("", !0),
        createElementVNode("div", null, [
          createVNode(unref(SatItemHandler), {
            item: Se.item,
            "parent-item": Se.parentItem,
            "discount-percentage-amount": Se.discountPercentageAmount,
            quantity: Be.value,
            notes: Ee.value,
            selected: Se.selected,
            onChange: Fe,
            onCustomizeModifier: Ve
          }, null, 8, ["item", "parent-item", "discount-percentage-amount", "quantity", "notes", "selected"]),
          Se.displayNotes ? (openBlock(), createBlock(unref(SatFormControl), {
            key: 0,
            class: normalizeClass(unref(ke)("notes")),
            label: unref(t)("item_builder.item.note_label")
          }, {
            default: withCtx(() => [
              createVNode(unref(AtomTextarea), {
                "auto-grow": "",
                rows: 2,
                value: Ee.value,
                placeholder: unref(t)("item_builder.item.note_placeholder"),
                onChange: De[0] || (De[0] = (Ue) => Ee.value = Ue)
              }, null, 8, ["value", "placeholder"])
            ]),
            _: 1
          }, 8, ["class", "label"])) : createCommentVNode("", !0)
        ])
      ], 2),
      createElementVNode("div", {
        class: normalizeClass(unref(ke)("footer"))
      }, [
        Se.displayCounter ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(ke)("footer-counter"))
        }, [
          createVNode(unref(SatCounter), {
            count: Be.value,
            size: "large",
            "min-count": 1,
            "show-delete": !1,
            onChange: De[1] || (De[1] = (Ue) => Be.value = Ue)
          }, null, 8, ["count"])
        ], 2)) : createCommentVNode("", !0),
        createElementVNode("div", {
          class: normalizeClass(unref(ke)("footer-cta"))
        }, [
          createVNode(unref(SatButtonMoney), {
            price: Se.finalTotalPrice,
            "hide-cents": !1,
            size: "large",
            loading: Se.isCtaLoading,
            onClick: withModifiers(je, ["prevent"])
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t)("item_builder.item.cta_label")), 1)
            ]),
            _: 1
          }, 8, ["price", "loading"])
        ], 2)
      ], 2)
    ], 2));
  }
}), SatItemBuilderItem = /* @__PURE__ */ _export_sfc(_sfc_main$17, [["__scopeId", "data-v-72fcdca9"]]), MOBILE_HEADER_NAVIGATION_HEIGHT = -63, _sfc_main$16 = /* @__PURE__ */ defineComponent({
  __name: "SatItemBuilderModifier",
  props: {
    item: {},
    parentItem: {},
    modifierListId: {},
    selected: {},
    discountPercentageAmount: {},
    navigationStack: {}
  },
  emits: ["select", "customizeSubModifier", "goBack"],
  setup(e, { emit: j }) {
    const ke = defineAsyncComponent(
      () => Promise.resolve().then(() => SatItemBuilderModifier$1)
    ), Se = bemBuilder("sat-item-builder-modifier"), xe = e, Ie = j, { isMobile: Me } = useWindowResize(), Ee = computed(() => ({
      id: xe.item.id,
      plu: xe.item.plu,
      name: xe.item.name
    })), Be = ref(xe.selected), $e = ref(xe.item.price), Le = ref(), Fe = ref(), Ve = ref(), je = ref(!1), Ge = computed(() => {
      if (!Be.value || !Fe.value) return;
      const Ct = Be.value.modifierLists.find((It) => It.id === Ve.value)?.modifiers?.find((It) => It.id === Fe.value?.id);
      return Ct ? {
        id: Fe.value.id,
        plu: Ct.plu,
        quantity: 1,
        unitPrice: Ct.unitPrice,
        modifierLists: Ct.modifierLists
      } : void 0;
    }), De = (Ct) => {
      Be.value = Ct.basketPayload, $e.value = Ct.totalPrice, Le.value = Ct.validation;
    }, Ue = (Ct) => {
      const It = xe.item.modifierLists.find((Nt) => Nt.id === Ct.categoryId)?.modifiers?.find((Nt) => Nt.id === Ct.itemId);
      It?.modifierLists?.length && (Fe.value = It, Ve.value = Ct.categoryId, je.value = !0, xt(
        It,
        Ee.value,
        Ct.categoryId
      ));
    }, Re = computed(() => {
      const Ct = xe.item.modifierLists.find(
        (Nt) => Nt.id === Ve.value
      ), It = Ct?.modifiers.find(
        (Nt) => Nt.id === Fe.value?.id
      );
      return { modifierList: Ct, modifier: It };
    }), Ye = (Ct, It) => {
      let Nt = Ct.modifierLists.find(
        (Bt) => Bt.id === It.id
      );
      return Nt || (Nt = {
        id: It.id,
        plu: It.plu,
        modifiers: []
      }, Ct.modifierLists.push(Nt)), Nt;
    }, We = (Ct, It) => {
      let Nt = Ct.modifiers.find(
        (Bt) => Bt.id === It.id
      );
      return Nt || (Nt = {
        id: It.id,
        plu: It.plu,
        quantity: 1,
        unitPrice: qe(It.price.value),
        modifierLists: []
      }, Ct.modifiers.push(Nt)), Nt;
    }, qe = (Ct) => xe.discountPercentageAmount > 0 ? Ct * (1 - xe.discountPercentageAmount / 100) : Ct, Je = (Ct) => {
      if (!Be.value || !Fe.value || !Re.value?.modifierList || !Re.value.modifier)
        return;
      const It = JSON.parse(JSON.stringify(Be.value)), Nt = Ye(
        It,
        Re.value.modifierList
      );
      Re.value?.modifierList?.selectType === "radio" && (Nt.modifiers = []), We(
        Nt,
        Re.value.modifier
      ).modifierLists.push(...Ct.modifierLists), Be.value = It, je.value = !1, Fe.value = void 0, Ve.value = void 0, Ie("goBack");
    }, Ke = () => {
      const Ct = Le.value?.errors;
      if (Ct?.length) {
        scrollToId(
          Ct[0].modifierListId,
          Me.value ? MOBILE_HEADER_NAVIGATION_HEIGHT : 0
        );
        return;
      }
      Be.value && xe.modifierListId && Ie("select", Be.value, xe.modifierListId);
    }, xt = (Ct, It, Nt) => {
      Ie(
        "customizeSubModifier",
        Ct,
        It,
        Nt
      );
    };
    return watch(
      () => xe.navigationStack,
      (Ct) => {
        je.value && Fe.value && (Ct.find(
          (Nt) => Nt.item.id === Fe.value?.id
        ) || (je.value = !1, Fe.value = void 0, Ve.value = void 0));
      },
      { deep: !0 }
    ), (Ct, It) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(Se)())
    }, [
      je.value ? Fe.value ? (openBlock(), createBlock(unref(ke), {
        key: 1,
        class: normalizeClass(unref(Se)("sub-content")),
        item: Fe.value,
        "parent-item": Ee.value,
        "modifier-list-id": Ve.value,
        "discount-percentage-amount": xe.discountPercentageAmount,
        selected: Ge.value,
        "navigation-stack": xe.navigationStack,
        onSelect: Je,
        onCustomizeSubModifier: xt,
        onGoBack: It[0] || (It[0] = (Nt) => Ie("goBack"))
      }, null, 8, ["class", "item", "parent-item", "modifier-list-id", "discount-percentage-amount", "selected", "navigation-stack"])) : createCommentVNode("", !0) : (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(unref(Se)("content"))
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(Se)("wrapper"))
        }, [
          createVNode(unref(SatItemHandler), {
            item: xe.item,
            "parent-item": xe.parentItem,
            "discount-percentage-amount": xe.discountPercentageAmount,
            selected: Be.value,
            onChange: De,
            onCustomizeModifier: Ue
          }, null, 8, ["item", "parent-item", "discount-percentage-amount", "selected"])
        ], 2),
        createElementVNode("div", {
          class: normalizeClass(unref(Se)("footer"))
        }, [
          createVNode(unref(SatButtonMoney), {
            wide: "",
            size: "large",
            price: $e.value,
            "hide-cents": !1,
            onClick: withModifiers(Ke, ["prevent"])
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t)("item_builder.modifier.cta_label")), 1)
            ]),
            _: 1
          }, 8, ["price"])
        ], 2)
      ], 2))
    ], 2));
  }
}), SatItemBuilderModifier = /* @__PURE__ */ _export_sfc(_sfc_main$16, [["__scopeId", "data-v-840ee625"]]), SatItemBuilderModifier$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: SatItemBuilderModifier
}, Symbol.toStringTag, { value: "Module" })), _hoisted_1$l = ["id"], _sfc_main$15 = /* @__PURE__ */ defineComponent({
  __name: "SatItemBuilder",
  props: {
    item: {},
    itemDisplayView: { default: "col" },
    discountApplied: {},
    isCtaLoading: { type: Boolean, default: !1 },
    stacked: { type: Boolean, default: !1 },
    displayNotes: { type: Boolean, default: !0 }
  },
  emits: ["close", "addToBasket"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, {
      goBack: xe,
      isAtRoot: Ie,
      navigationTitle: Me,
      navigationSubTitle: Ee,
      isVariantView: Be,
      isItemView: $e,
      isModifierView: Le,
      isSubModifierView: Fe,
      navigation: Ve,
      navigateToItem: je,
      navigateToModifier: Ge,
      navigateToSubModifier: De,
      selectedItem: Ue,
      selectedModifier: Re,
      modifierListIdFromSelectedModifier: Ye,
      setItem: We,
      setModifier: qe,
      basketPayload: Je,
      finalBasketPayload: Ke,
      finalTotalPrice: xt,
      discountPercentageAmount: Ct
    } = useItemBuilder({
      rootItem: ke.item,
      discountApplied: ke.discountApplied
    }), It = (Qe) => {
      Se("close", Qe);
    }, Nt = (Qe) => {
      xe() || It(Qe);
    }, Bt = computed(() => ke.item.type === "variant"), At = computed(() => Bt.value ? { id: ke.item.id, plu: ke.item.plu, name: ke.item.name } : void 0), Ft = computed(() => Ue.value ? {
      id: Ue.value.id,
      plu: Ue.value.plu,
      name: Ue.value.name
    } : void 0), Dt = computed(() => {
      if (!(!Je.value || !Ue.value || !Re.value))
        return Je.value.modifierLists.find((Qe) => Qe.id === Ye.value)?.modifiers?.find((Qe) => Qe.id === Re.value?.id);
    }), zt = () => {
      Ke.value && Se("addToBasket", Ke.value);
    }, kt = computed(() => !!(Be.value && !ke.item.photo || $e.value && !Ue.value?.photo || Le.value || Fe.value)), Et = useId();
    return watch(
      () => [
        Be.value,
        $e.value,
        Le.value,
        Fe.value
      ],
      () => {
        scrollToId(Et);
      },
      { flush: "post" }
    ), (Qe, Xe) => (openBlock(), createElementBlock("div", {
      id: unref(Et),
      class: normalizeClass([unref(css$12)(""), { [unref(css$12)("", "compact-layout")]: kt.value }])
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$12)("header"))
      }, [
        createVNode(unref(SatNavigation), {
          sticky: !1,
          class: normalizeClass(unref(css$12)("header-mobile")),
          "icon-name-left": unref(Ie) ? void 0 : "arrow-left",
          "icon-name-right": "close",
          onClickLeftCta: Xe[0] || (Xe[0] = (Vt) => Nt(Vt)),
          onClickRightCta: Xe[1] || (Xe[1] = (Vt) => It(Vt))
        }, {
          default: withCtx(() => [
            unref(Ee) ? (openBlock(), createBlock(unref(AtomText), {
              key: 0,
              type: "small-bold",
              class: normalizeClass(unref(css$12)("header-mobile-subtitle"))
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(Ee)), 1)
              ]),
              _: 1
            }, 8, ["class"])) : createCommentVNode("", !0),
            unref(Me) ? (openBlock(), createBlock(unref(AtomText), {
              key: 1,
              type: "subtitle",
              class: normalizeClass(unref(css$12)("header-mobile-title"))
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(Me)), 1)
              ]),
              _: 1
            }, 8, ["class"])) : createCommentVNode("", !0)
          ]),
          _: 1
        }, 8, ["class", "icon-name-left"]),
        unref(Ie) ? createCommentVNode("", !0) : (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(css$12)("header-desktop"))
        }, [
          createVNode(unref(SatButton), {
            size: "large",
            variant: "secondary",
            class: normalizeClass(unref(css$12)("header-desktop-back-button")),
            onClick: withModifiers(Nt, ["prevent"])
          }, {
            default: withCtx(() => [
              createVNode(unref(_sfc_main$1Q), {
                name: "arrow-left",
                "ignore-color": ""
              }),
              createTextVNode(" " + toDisplayString(unref(t)("item_builder.back_cta")), 1)
            ]),
            _: 1
          }, 8, ["class"])
        ], 2))
      ], 2),
      createElementVNode("div", {
        class: normalizeClass(unref(css$12)("content"))
      }, [
        unref(Be) ? (openBlock(), createBlock(SatItemBuilderVariant, {
          key: 0,
          variant: ke.item,
          "item-display-view": ke.itemDisplayView,
          "discount-percentage-amount": unref(Ct),
          stacked: ke.stacked,
          onSelect: unref(je)
        }, null, 8, ["variant", "item-display-view", "discount-percentage-amount", "stacked", "onSelect"])) : unref($e) && unref(Ue) ? (openBlock(), createBlock(SatItemBuilderItem, {
          key: 1,
          item: unref(Ue),
          "parent-item": At.value,
          selected: unref(Je),
          "discount-percentage-amount": unref(Ct),
          "final-total-price": unref(xt),
          "is-cta-loading": ke.isCtaLoading,
          stacked: ke.stacked,
          "display-notes": ke.displayNotes,
          "display-counter": !Bt.value,
          onChange: unref(We),
          onAddToBasket: zt,
          onCustomizeModifier: unref(Ge)
        }, null, 8, ["item", "parent-item", "selected", "discount-percentage-amount", "final-total-price", "is-cta-loading", "stacked", "display-notes", "display-counter", "onChange", "onCustomizeModifier"])) : (unref(Le) || unref(Fe)) && unref(Re) ? (openBlock(), createBlock(SatItemBuilderModifier, {
          key: 2,
          item: unref(Re),
          "parent-item": Ft.value,
          "modifier-list-id": unref(Ye),
          selected: Dt.value,
          "discount-percentage-amount": unref(Ct),
          "navigation-stack": unref(Ve).navigationStack.value,
          onSelect: unref(qe),
          onCustomizeSubModifier: unref(De),
          onGoBack: unref(xe)
        }, null, 8, ["item", "parent-item", "modifier-list-id", "selected", "discount-percentage-amount", "navigation-stack", "onSelect", "onCustomizeSubModifier", "onGoBack"])) : createCommentVNode("", !0)
      ], 2)
    ], 10, _hoisted_1$l));
  }
}), SatItemBuilder = /* @__PURE__ */ _export_sfc(_sfc_main$15, [["__scopeId", "data-v-0bec4d31"]]), className$11 = "sat-item-handler", css$11 = bemBuilder(className$11);
bemBuilder(className$11, !0);
const _hoisted_1$k = {
  key: 0,
  "data-test": "main-content"
}, _hoisted_2$7 = ["id"], _sfc_main$14 = /* @__PURE__ */ defineComponent({
  __name: "SatItemHandler",
  props: {
    item: {},
    selected: {},
    parentItem: {},
    discountPercentageAmount: {},
    quantity: {},
    notes: {}
  },
  emits: ["change", "customizeModifier"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, {
      addModifier: xe,
      removeModifier: Ie,
      toggleModifier: Me,
      setItemQuantity: Ee,
      setItemNotes: Be,
      generateBasketPayload: $e,
      getSelectedModifier: Le,
      getSelectedModifierQuantity: Fe,
      itemQuantity: Ve,
      itemNotes: je,
      currentValidation: Ge,
      canAddToBasket: De,
      totalPrice: Ue
    } = useItemManager({
      rootItem: ke.item,
      initialSelection: ke.selected,
      discountPercentageAmount: ke.discountPercentageAmount
    }), Re = computed(() => ke.item.modifierLists.map((Bt) => ({
      ...Bt,
      items: Bt.modifiers.map((At) => ({
        id: At.id,
        name: At.name,
        price: Ye(At.price),
        quantity: Fe(Bt.id, At.id),
        cta: We(Bt.id, At.id, At?.modifierLists),
        hasSubModifiers: At.modifierLists.length > 0
      }))
    })));
    function Ye(Bt) {
      return ke.discountPercentageAmount > 0 ? {
        value: Bt.value * (1 - ke.discountPercentageAmount / 100),
        currency: Bt.currency
      } : Bt;
    }
    function We(Bt, At, Ft = []) {
      const Dt = Le(Bt, At);
      if (Dt && Dt?.quantity > 0 && Ft.length) {
        let zt = function(Et) {
          return !Dt || !Dt.modifierLists ? 0 : Object.values(
            Dt.modifierLists[Et] || {}
          ).reduce((Qe, Xe) => Qe + Xe.quantity, 0);
        };
        const kt = Ft.reduce(
          (Et, Qe) => (
            // add +1 for each modifier list required not selected
            Qe.minSelection > zt(Qe.id) ? Et + 1 : Et
          ),
          0
        );
        return kt > 0 ? {
          label: t("item_handler.min_selections_required", {
            count: kt
          }),
          hasError: !0
        } : {
          label: t("item_handler.customizable"),
          hasError: !1
        };
      }
    }
    function qe(Bt, At) {
      if (Bt > 0) {
        if (At === Bt && At > 1)
          return t("item_handler.choose_at_least_x", { min: Bt });
        if (At > 1)
          return t("item_handler.choose_at_least_x_up_to_x", {
            max: At,
            min: Bt
          });
        if (At === 1)
          return t("item_handler.choose_1");
      }
      return At > 0 ? t("item_handler.choose_up_to_x", { max: At }) : "";
    }
    const Je = ref(!1), Ke = computed(() => ke.item.bottleDepositPrice?.value <= 0 ? "" : t("item_handler.bottle_deposit", {
      amount: toMoney(
        ke.item.bottleDepositPrice.value,
        ke.item.bottleDepositPrice.currency
      )
    })), xt = computed(() => ke.item.calories > 0 || ke.item.allergens.length || ke.item.consumables.length), Ct = computed(() => typeof ke.item.calories != "number" ? "" : t("item_handler.calories_value", {
      calories: ke.item.calories
    }));
    function It(Bt) {
      const { itemId: At, categoryId: Ft, decrease: Dt, type: zt } = Bt, Et = ke.item.modifierLists.find(
        (Lt) => Lt.id === Ft
      )?.modifiers.find((Lt) => Lt.id === At);
      if (!Et) return;
      const Qe = Le(Ft, At);
      if (Et.modifierLists.length > 0 && (!Dt && !Qe)) {
        Se("customizeModifier", {
          itemId: At,
          categoryId: Ft
        });
        return;
      }
      if (zt === "radio" || zt === "checkbox")
        Me(Ft, At);
      else if (zt === "multiple")
        if (Dt)
          Ie({
            modifierListId: Ft,
            modifierId: At,
            quantity: 1
          });
        else {
          const Lt = Fe(Ft, At);
          xe({
            modifierListId: Ft,
            modifierId: At,
            modifierPlu: Et.plu,
            quantity: Lt + 1,
            unitPrice: Et.price.value
          });
        }
    }
    watchEffect(() => {
      const Bt = $e(), At = De.value, Ft = Ue.value, Dt = Ge.value;
      Se("change", {
        basketPayload: Bt,
        validation: Dt,
        canAddToBasket: At,
        totalPrice: Ft
      });
    }), watch(
      () => ke.quantity,
      (Bt) => {
        typeof Bt == "number" && Bt !== Ve.value && Ee(Bt);
      }
    ), watch(
      () => ke.notes,
      (Bt) => {
        Bt !== je.value && Be(Bt || "");
      }
    );
    function Nt(Bt) {
      Se("customizeModifier", Bt);
    }
    return (Bt, At) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$11)())
    }, [
      Je.value ? (openBlock(), createBlock(unref(SatItemHandlerInfo), {
        key: 1,
        item: ke.item,
        onBack: At[1] || (At[1] = (Ft) => Je.value = !1)
      }, null, 8, ["item"])) : (openBlock(), createElementBlock("div", _hoisted_1$k, [
        createElementVNode("div", {
          class: normalizeClass(unref(css$11)("content"))
        }, [
          createVNode(unref(SatProductInfo), {
            "parent-product-name": ke.parentItem?.name,
            name: ke.item.name,
            description: ke.item.description,
            price: Ye(ke.item.price),
            "original-price": ke.item.price,
            "complementary-price": Ke.value
          }, null, 8, ["parent-product-name", "name", "description", "price", "original-price", "complementary-price"]),
          xt.value ? (openBlock(), createBlock(unref(SatNutritionInfo), {
            key: 0,
            tags: ke.item.consumables,
            "calories-label": unref(t)("item_handler.calories_label"),
            "calories-value": Ct.value,
            "allergens-label": unref(t)("item_handler.allergens_label"),
            "allergens-value": ke.item.allergens?.join(", ")
          }, null, 8, ["tags", "calories-label", "calories-value", "allergens-label", "allergens-value"])) : createCommentVNode("", !0),
          createElementVNode("div", null, [
            createVNode(unref(SatButton), {
              wide: "",
              size: "small",
              variant: "secondary",
              class: normalizeClass(unref(css$11)("button")),
              onClick: At[0] || (At[0] = withModifiers((Ft) => Je.value = !0, ["prevent"]))
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t)("item_handler.product_info_cta_label")) + " ", 1),
                createVNode(unref(_sfc_main$1Q), {
                  name: "arrow-right",
                  "ignore-color": ""
                })
              ]),
              _: 1
            }, 8, ["class"])
          ])
        ], 2),
        Re.value.length ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(css$11)("modifier-list"))
        }, [
          (openBlock(!0), createElementBlock(Fragment, null, renderList(Re.value, (Ft) => (openBlock(), createElementBlock("div", {
            id: Ft.id,
            key: Ft.id,
            class: normalizeClass(unref(css$11)("modifier-list-item"))
          }, [
            createVNode(unref(OrgModifierGroup), {
              "validate-on-mount": "",
              class: normalizeClass(unref(css$11)("modifier-list-box")),
              title: Ft.name,
              "category-id": Ft.id,
              "view-only": ke.item.inStock === !1,
              subtitle: qe(
                Ft.minSelection,
                Ft.maxSelection
              ),
              items: Ft.items,
              type: Ft.selectType,
              "max-selection": Ft.maxSelection,
              "min-selection": Ft.minSelection,
              onChange: It,
              onCustomizeModifier: Nt
            }, null, 8, ["class", "title", "category-id", "view-only", "subtitle", "items", "type", "max-selection", "min-selection"])
          ], 10, _hoisted_2$7))), 128))
        ], 2)) : createCommentVNode("", !0)
      ]))
    ], 2));
  }
}), SatItemHandler = /* @__PURE__ */ _export_sfc(_sfc_main$14, [["__scopeId", "data-v-610c2470"]]), _sfc_main$13 = /* @__PURE__ */ defineComponent({
  __name: "SatItemHandlerInfo",
  props: {
    item: {}
  },
  emits: ["back"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = bemBuilder("sat-item-handler-info"), Ie = computed(() => Be(ke.item)), Me = computed(
      () => ke.item.modifierLists.flatMap(
        (Ge) => Ge.modifiers.map((De) => Be(De))
      )
    ), Ee = (Ge, De) => {
      if (Ge)
        return De ? t("item_handler.info.range_calories_value", {
          calories: Ge,
          highCalories: De
        }) : t("item_handler.info.calories_value", { calories: Ge });
    }, Be = (Ge) => ({
      id: Ge.id,
      name: Ge.name,
      description: Ge.description,
      calories: Ee(Ge.calories, Ge.caloriesRangeHigh),
      allergens: Ge.allergens,
      nutritional: {
        fat: $e(Ge?.nutritional?.fat),
        sugar: $e(Ge?.nutritional?.sugar),
        saturatedFat: $e(Ge?.nutritional?.saturatedFat),
        carbohydrates: $e(Ge?.nutritional?.carbohydrates),
        protein: $e(Ge?.nutritional?.protein),
        salt: $e(Ge?.nutritional?.salt)
      },
      servingSize: Fe(
        "servingSize",
        Ge?.nutritional?.servingSize
      ),
      netQuantity: Fe(
        "netQuantity",
        Ge?.nutritional?.netQuantity
      ),
      beverage: {
        alcohol: Ge?.beverage?.alcohol ? t("item_handler.info.alcohol", { amount: Ge.beverage.alcohol }) : void 0,
        caffeine: Ge?.beverage?.caffeine ? t("item_handler.info.caffeine", {
          amount: Ge.beverage.caffeine
        }) : void 0
      },
      reusable: Le(
        t("item_handler.info.reusable_label_yes"),
        t("item_handler.info.reusable_label_no"),
        Ge?.packaging?.reusable
      ),
      storageInstructions: Ge?.packaging?.storageInstructions,
      legalName: Ge?.supplemental?.legalName,
      instructionsForUse: Ge?.supplemental?.instructionsForUse,
      ingredients: Ge?.supplemental?.ingredients ?? [],
      additives: Ge?.supplemental?.additives ?? [],
      prepackaged: Le(
        t("item_handler.info.prepackaged_label_yes"),
        t("item_handler.info.prepackaged_label_no"),
        Ge?.supplemental?.prepackaged
      ),
      foodBusinessOperator: {
        name: Ge?.supplemental?.foodBusinessOperator?.name,
        address: Ge?.supplemental?.foodBusinessOperator?.address,
        countryOfOrigin: Ge?.supplemental?.foodBusinessOperator?.countryOfOrigin
      }
    }), $e = (Ge) => {
      if (typeof Ge == "number")
        return t("item_handler.info.nutrition_table.grams_label", {
          amount: Ge
        });
    }, Le = (Ge, De, Ue) => {
      if (Ue !== void 0)
        return Ue ? Ge : De;
    }, Fe = (Ge, De) => {
      if (!De) return;
      const Ue = {
        amount: De?.amount ?? "",
        count: De?.countUnitDescription ?? "",
        type: De?.unitType ?? ""
      };
      return t(Ge === "servingSize" ? "item_handler.info.nutrition_table.serving_size" : "item_handler.info.nutrition_table.net_quantity", Ue);
    }, { product: Ve, modifiers: je } = useSatProductDetails({
      product: Ie.value,
      modifiers: Me.value,
      content: {
        caloriesLabel: `${t("item_handler.info.nutrition_label")} `,
        nutritionTitle: t("item_handler.info.nutrition_table.title"),
        emptyMessageLabel: t("item_handler.info.empty_label"),
        allergens: t("item_handler.info.allergens_label"),
        nutritional: {
          fat: t("item_handler.info.nutrition_table.fat"),
          sugar: t("item_handler.info.nutrition_table.sugar"),
          saturatedFat: t("item_handler.info.nutrition_table.saturated_fat"),
          carbohydrates: t("item_handler.info.nutrition_table.carbohydrates"),
          protein: t("item_handler.info.nutrition_table.protein"),
          salt: t("item_handler.info.nutrition_table.salt")
        },
        beverage: t("item_handler.info.beverage_label"),
        reusable: t("item_handler.info.reusable_label"),
        storageInstructions: t("item_handler.info.storage_instructions_label"),
        legalName: t("item_handler.info.legal_name_label"),
        instructionsForUse: t("item_handler.info.instructions_to_use_label"),
        ingredients: t("item_handler.info.ingredients_label"),
        additives: t("item_handler.info.additives_label"),
        prepackaged: t("item_handler.info.prepackaged_label"),
        foodBusinessOperator: t("item_handler.info.business_operator_label")
      }
    });
    return (Ge, De) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(xe)())
    }, [
      createElementVNode("div", null, [
        createVNode(unref(SatButton), {
          size: "small",
          variant: "secondary",
          class: normalizeClass(unref(xe)("button")),
          onClick: De[0] || (De[0] = withModifiers((Ue) => Se("back", Ue), ["prevent"]))
        }, {
          default: withCtx(() => [
            createVNode(unref(_sfc_main$1Q), {
              name: "arrow-left",
              "ignore-color": ""
            }),
            createTextVNode(" " + toDisplayString(unref(t)("item_handler.info.back_cta")), 1)
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      createVNode(unref(SatProductDetails), {
        product: unref(Ve),
        modifiers: unref(je)
      }, null, 8, ["product", "modifiers"])
    ], 2));
  }
}), SatItemHandlerInfo = /* @__PURE__ */ _export_sfc(_sfc_main$13, [["__scopeId", "data-v-9c3bf4ec"]]), className$10 = "sat-product-details", css$10 = bemBuilder(className$10);
bemBuilder(className$10, !0);
const _hoisted_1$j = ["onClick"], _sfc_main$12 = /* @__PURE__ */ defineComponent({
  __name: "SatProductDetails",
  props: {
    product: {},
    modifiers: {}
  },
  setup(e) {
    const j = e, ke = ref([]), Se = (xe) => {
      ke.value.includes(xe) ? ke.value = ke.value.filter(
        (Ie) => Ie !== xe
      ) : ke.value = [...ke.value, xe];
    };
    return (xe, Ie) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$10)())
    }, [
      createVNode(unref(SatProductInfo), {
        class: normalizeClass(unref(css$10)("header")),
        name: j.product.name,
        layout: 2,
        description: j.product.description
      }, null, 8, ["class", "name", "description"]),
      createVNode(unref(SatProductSpecs), {
        "calories-label": j.product.caloriesLabel,
        "calories-value": j.product.caloriesValue,
        "serving-measurements": j.product.servingMeasurements,
        "nutrition-title": j.product.nutritionTitle,
        "nutrition-data": j.product.nutritionData,
        "list-specs": j.product.listSpecs,
        "empty-message-label": j.product.emptyMessageLabel
      }, null, 8, ["calories-label", "calories-value", "serving-measurements", "nutrition-title", "nutrition-data", "list-specs", "empty-message-label"]),
      (openBlock(!0), createElementBlock(Fragment, null, renderList(j.modifiers, (Me) => (openBlock(), createBlock(unref(AtomCard), {
        key: Me.id,
        padding: "none",
        radii: "small",
        class: normalizeClass(unref(css$10)("modifier"))
      }, {
        default: withCtx(() => [
          createElementVNode("a", {
            href: "",
            class: normalizeClass(unref(css$10)("modifier-toggle")),
            onClick: withModifiers((Ee) => Se(Me.id), ["prevent"])
          }, [
            createVNode(unref(AtomText), { type: "body-bold" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(Me.name), 1)
              ]),
              _: 2
            }, 1024),
            createVNode(unref(MolCollapseIndicator), {
              theme: "ghost",
              variant: "primary",
              collapsed: !ke.value.includes(Me.id)
            }, null, 8, ["collapsed"])
          ], 10, _hoisted_1$j),
          ke.value.includes(Me.id) ? (openBlock(), createBlock(unref(SatProductSpecs), {
            key: 0,
            class: normalizeClass(unref(css$10)("modifier-content")),
            "calories-label": Me.caloriesLabel,
            "calories-value": Me.caloriesValue,
            "serving-measurements": Me.servingMeasurements,
            "nutrition-title": Me.nutritionTitle,
            "nutrition-data": Me.nutritionData,
            "list-specs": Me.listSpecs,
            "empty-message-label": Me.emptyMessageLabel
          }, null, 8, ["class", "calories-label", "calories-value", "serving-measurements", "nutrition-title", "nutrition-data", "list-specs", "empty-message-label"])) : createCommentVNode("", !0)
        ]),
        _: 2
      }, 1032, ["class"]))), 128))
    ], 2));
  }
}), SatProductDetails = /* @__PURE__ */ _export_sfc(_sfc_main$12, [["__scopeId", "data-v-04586943"]]), useSatProductDetails = (e) => {
  const j = computed(() => Ee(e.product)), ke = computed(
    () => e.modifiers.map((Be) => Ee(Be))
  ), Se = (Be = []) => Be.join(", "), xe = (Be) => {
    const $e = [];
    return [
      { property: "allergens", value: Be.allergens },
      { property: "ingredients", value: Be?.ingredients },
      { property: "additives", value: Be?.additives },
      { property: "beverage", value: Ie(Be?.beverage) },
      { property: "instructionsForUse", value: Be?.instructionsForUse },
      { property: "storageInstructions", value: Be?.storageInstructions },
      { property: "legalName", value: Be?.legalName },
      {
        property: "foodBusinessOperator",
        value: Ie(Be?.foodBusinessOperator)
      },
      { property: "reusable", value: Be?.reusable },
      { property: "prepackaged", value: Be?.prepackaged }
    ].forEach(({ property: Le, value: Fe }) => {
      const Ve = Array.isArray(Fe) ? Se(Fe) : Fe;
      Ve && $e.push({
        key: Le,
        label: String(
          e.content[Le]
        ),
        value: Ve
      });
    }), $e;
  }, Ie = (Be = {}) => Object.values(Be).filter(Boolean), Me = (Be = {}) => Object.entries(Be).filter(([$e, Le]) => Le).map(([$e, Le]) => ({
    key: $e,
    label: e.content.nutritional[$e],
    value: Le
  })), Ee = (Be) => ({
    id: Be.id,
    name: Be.name,
    description: Be?.description,
    caloriesLabel: e.content.caloriesLabel,
    caloriesValue: Be?.calories ?? "",
    servingMeasurements: Ie({
      servingSize: Be?.servingSize ?? "",
      netQuantity: Be?.netQuantity ?? ""
    }),
    nutritionTitle: e.content.nutritionTitle,
    nutritionData: Me(Be?.nutritional),
    listSpecs: xe(Be),
    emptyMessageLabel: e.content.emptyMessageLabel
  });
  return {
    product: j.value,
    modifiers: ke.value
  };
}, className$$ = "sat-product-info", css$$ = bemBuilder(className$$);
bemBuilder(className$$, !0);
const _sfc_main$11 = /* @__PURE__ */ defineComponent({
  __name: "SatProductInfo",
  props: {
    name: {},
    parentProductName: {},
    description: {},
    price: {},
    originalPrice: {},
    complementaryPrice: {},
    layout: { default: 2 }
  },
  setup(e) {
    const j = e, ke = computed(() => {
      if (!(!j.originalPrice || j.originalPrice.value === j.price?.value))
        return j.originalPrice;
    }), Se = computed(() => j.layout === 1);
    return (xe, Ie) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$$)())
    }, [
      createElementVNode("div", {
        class: normalizeClass({
          [unref(css$$)("content")]: !0,
          [unref(css$$)("display-one")]: Se.value,
          [unref(css$$)("display-two")]: !Se.value
        })
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(css$$)("info"))
        }, [
          createElementVNode("div", {
            class: normalizeClass(unref(css$$)("name-wrapper"))
          }, [
            j.parentProductName ? (openBlock(), createBlock(unref(AtomText), {
              key: 0,
              class: normalizeClass(unref(css$$)("parent-product-name")),
              type: "body-bold",
              color: "color-text-secondary"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(j.parentProductName), 1)
              ]),
              _: 1
            }, 8, ["class"])) : createCommentVNode("", !0),
            createVNode(unref(AtomText), {
              class: normalizeClass(unref(css$$)("name")),
              color: "color-text-headline",
              type: Se.value ? "h1" : "h3"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(j.name), 1)
              ]),
              _: 1
            }, 8, ["class", "type"])
          ], 2),
          j.description ? (openBlock(), createBlock(unref(AtomText), {
            key: 0,
            class: normalizeClass(unref(css$$)("description")),
            type: "body",
            color: "color-text-secondary"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(j.description), 1)
            ]),
            _: 1
          }, 8, ["class"])) : createCommentVNode("", !0)
        ], 2),
        j.price ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(css$$)("price-box"))
        }, [
          createElementVNode("div", {
            class: normalizeClass(unref(css$$)("pricing"))
          }, [
            j.price ? (openBlock(), createBlock(unref(AtomText), {
              key: 0,
              type: Se.value ? "h2" : "body-bold",
              class: normalizeClass(unref(css$$)("price")),
              color: "color-text-body"
            }, {
              default: withCtx(() => [
                createVNode(unref(_sfc_main$1w), {
                  amount: j.price.value,
                  currency: j.price.currency
                }, null, 8, ["amount", "currency"])
              ]),
              _: 1
            }, 8, ["type", "class"])) : createCommentVNode("", !0),
            ke.value ? (openBlock(), createBlock(unref(AtomText), {
              key: 1,
              type: Se.value ? "h3" : "body",
              class: normalizeClass(unref(css$$)("stiked-price")),
              color: "color-text-secondary",
              striked: ""
            }, {
              default: withCtx(() => [
                createVNode(unref(_sfc_main$1w), {
                  amount: ke.value.value,
                  currency: ke.value.currency
                }, null, 8, ["amount", "currency"])
              ]),
              _: 1
            }, 8, ["type", "class"])) : createCommentVNode("", !0)
          ], 2),
          j.complementaryPrice ? (openBlock(), createBlock(unref(AtomText), {
            key: 0,
            type: "small",
            color: "color-text-disabled",
            class: normalizeClass(unref(css$$)("complementary-price"))
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(j.complementaryPrice), 1)
            ]),
            _: 1
          }, 8, ["class"])) : createCommentVNode("", !0)
        ], 2)) : createCommentVNode("", !0)
      ], 2)
    ], 2));
  }
}), SatProductInfo = /* @__PURE__ */ _export_sfc(_sfc_main$11, [["__scopeId", "data-v-b59a30fc"]]), className$_ = "sat-product-specs", css$_ = bemBuilder(className$_);
bemBuilder(className$_, !0);
const _hoisted_1$i = { "data-test": "first-content" }, _hoisted_2$6 = { key: 1 }, _hoisted_3$1 = ["data-test"], _hoisted_4 = ["data-test"], _sfc_main$10 = /* @__PURE__ */ defineComponent({
  __name: "SatProductSpecs",
  props: {
    caloriesLabel: {},
    caloriesValue: {},
    servingMeasurements: {},
    nutritionTitle: {},
    nutritionData: {},
    listSpecs: {},
    emptyMessageLabel: {}
  },
  setup(e) {
    const j = e, ke = computed(
      () => j.caloriesValue || j.nutritionData.length || j.listSpecs?.length
    );
    return (Se, xe) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$_)())
    }, [
      ke.value ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(unref(css$_)("content")),
        "data-test": "content"
      }, [
        j.caloriesValue ? (openBlock(), createBlock(unref(AtomText), {
          key: 0,
          tag: "div",
          type: "small"
        }, {
          default: withCtx(() => [
            createElementVNode("strong", null, toDisplayString(j.caloriesLabel), 1),
            createElementVNode("span", _hoisted_1$i, toDisplayString(j.caloriesValue), 1)
          ]),
          _: 1
        })) : createCommentVNode("", !0),
        j.nutritionData.length ? (openBlock(), createElementBlock("div", _hoisted_2$6, [
          createVNode(unref(AtomText), {
            tag: "div",
            type: "small-bold"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(j.nutritionTitle), 1)
            ]),
            _: 1
          }),
          (openBlock(!0), createElementBlock(Fragment, null, renderList(j.servingMeasurements, (Ie, Me) => (openBlock(), createBlock(unref(AtomText), {
            key: Me,
            tag: "div",
            type: "small",
            "data-test": `list-before-table-${Me}`
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(Ie), 1)
            ]),
            _: 2
          }, 1032, ["data-test"]))), 128)),
          createVNode(unref(AtomText), { type: "small" }, {
            default: withCtx(() => [
              createElementVNode("ul", {
                class: normalizeClass(unref(css$_)("table"))
              }, [
                (openBlock(!0), createElementBlock(Fragment, null, renderList(j.nutritionData, (Ie) => (openBlock(), createElementBlock("li", {
                  key: Ie.key,
                  "data-test": `table-${Ie.key}`
                }, [
                  createElementVNode("span", null, toDisplayString(Ie.label), 1),
                  createElementVNode("span", null, toDisplayString(Ie.value), 1)
                ], 8, _hoisted_3$1))), 128))
              ], 2)
            ]),
            _: 1
          })
        ])) : createCommentVNode("", !0),
        (openBlock(!0), createElementBlock(Fragment, null, renderList(j.listSpecs, (Ie) => (openBlock(), createElementBlock("div", {
          key: Ie.key,
          class: normalizeClass(unref(css$_)("line")),
          "data-test": `list-after-table-${Ie.key}`
        }, [
          createVNode(unref(AtomText), { type: "small-bold" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(Ie.label), 1)
            ]),
            _: 2
          }, 1024),
          createVNode(unref(AtomText), { type: "small" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(Ie.value), 1)
            ]),
            _: 2
          }, 1024)
        ], 10, _hoisted_4))), 128))
      ], 2)) : (openBlock(), createBlock(unref(AtomText), {
        key: 1,
        type: "small",
        "data-test": "empty-message"
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(j.emptyMessageLabel), 1)
        ]),
        _: 1
      }))
    ], 2));
  }
}), SatProductSpecs = /* @__PURE__ */ _export_sfc(_sfc_main$10, [["__scopeId", "data-v-abb4c00d"]]), className$Z = "sat-variant-selection", css$Z = bemBuilder(className$Z);
bemBuilder(className$Z, !0);
const _hoisted_1$h = { key: 0 }, _hoisted_2$5 = ["onClick"], _sfc_main$$ = /* @__PURE__ */ defineComponent({
  __name: "SatVariantSelection",
  props: {
    variant: {},
    itemDisplayView: {},
    discountPercentageAmount: {},
    stacked: { type: Boolean }
  },
  emits: ["select"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, { optimize: xe } = useImage(), Ie = (Me) => ke.discountPercentageAmount > 0 ? {
      value: Me.value * (1 - ke.discountPercentageAmount / 100),
      currency: Me.currency
    } : Me;
    return (Me, Ee) => (openBlock(), createElementBlock("div", {
      class: normalizeClass({
        [unref(css$Z)("")]: !0,
        [unref(css$Z)("", "stacked")]: ke.stacked
      })
    }, [
      ke.variant.photo ? (openBlock(), createElementBlock("div", _hoisted_1$h, [
        createElementVNode("div", {
          class: normalizeClass(unref(css$Z)("photo")),
          style: normalizeStyle(`background-image: url(${unref(xe)(ke.variant.photo, {
            w: 800,
            h: 800,
            fit: "crop",
            crop: "center"
          })})`)
        }, null, 6)
      ])) : createCommentVNode("", !0),
      createElementVNode("div", {
        class: normalizeClass(unref(css$Z)("wrapper"))
      }, [
        createVNode(unref(SatProductInfo), {
          class: normalizeClass(unref(css$Z)("info")),
          name: ke.variant.name,
          description: ke.variant.description,
          price: Ie(ke.variant.price),
          "original-price": ke.variant.price
        }, null, 8, ["class", "name", "description", "price", "original-price"]),
        (openBlock(!0), createElementBlock(Fragment, null, renderList(ke.variant.modifierLists, (Be) => (openBlock(), createElementBlock("div", {
          key: Be.id,
          class: normalizeClass(unref(css$Z)("modifier-list"))
        }, [
          createVNode(unref(AtomText), {
            class: normalizeClass(unref(css$Z)("modifier-list-name")),
            type: "body-bold"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(Be.name), 1)
            ]),
            _: 2
          }, 1032, ["class"]),
          createElementVNode("div", {
            class: normalizeClass([
              unref(css$Z)("item-list"),
              { [unref(css$Z)("item-list", "grid")]: ke.itemDisplayView === "row" }
            ])
          }, [
            (openBlock(!0), createElementBlock(Fragment, null, renderList(Be.modifiers, ($e) => (openBlock(), createElementBlock("a", {
              key: $e.id,
              class: normalizeClass([unref(css$Z)("item"), { [unref(css$Z)("item", "disabled")]: !$e.inStock }]),
              onClick: withModifiers((Le) => $e.inStock && Se("select", $e), ["prevent"])
            }, [
              createVNode(unref(SatItemDisplay), {
                id: $e.id,
                name: $e.name,
                description: $e.description,
                view: ke.itemDisplayView,
                photo: $e.photo ? unref(xe)($e.photo, {
                  w: 300,
                  h: 300,
                  fit: "crop",
                  crop: "center"
                }) : void 0,
                amount: Ie($e.price),
                "original-amount": $e.price,
                "is-disabled": !$e.inStock,
                "has-allergen-items": $e.allergens.length > 0,
                consumables: $e.consumables
              }, null, 8, ["id", "name", "description", "view", "photo", "amount", "original-amount", "is-disabled", "has-allergen-items", "consumables"])
            ], 10, _hoisted_2$5))), 128))
          ], 2)
        ], 2))), 128))
      ], 2)
    ], 2));
  }
}), SatVariantSelection = /* @__PURE__ */ _export_sfc(_sfc_main$$, [["__scopeId", "data-v-444f8c70"]]), className$Y = "sat-price-breakdown", css$Y = bemBuilder(className$Y);
bemBuilder(className$Y, !0);
var AtomTextTypeEnum = /* @__PURE__ */ ((e) => (e.H1 = "h1", e.H2 = "h2", e.H3 = "h3", e.SUBTITLE = "subtitle", e.BODY = "body", e.BODY_BOLD = "body-bold", e.SMALL = "small", e.SMALL_BOLD = "small-bold", e.LINK = "link", e))(AtomTextTypeEnum || {}), ColorEnum = /* @__PURE__ */ ((e) => (e.BASE_0 = "color-base-0", e.BASE_10 = "color-base-10", e.BASE_20 = "color-base-20", e.BASE_30 = "color-base-30", e.BASE_40 = "color-base-40", e.BASE_50 = "color-base-50", e.BASE_60 = "color-base-60", e.BASE_70 = "color-base-70", e.BASE_80 = "color-base-80", e.BASE_90 = "color-base-90", e.BASE_95 = "color-base-95", e.BASE_100 = "color-base-100", e.CORAL = "color-coral", e.SALMON = "color-salmon", e.CANARY = "color-canary", e.LEMON_SORBET = "color-lemon-sorbet", e.MINT = "color-mint", e.PISTACHIO = "color-pistachio", e.ERROR = "color-error", e.PRIMARY = "color-primary", e.ON_PRIMARY = "color-on-primary", e.PRIMARY_HOVER = "color-primary-hover", e.SECONDARY = "color-secondary", e.ON_SECONDARY = "color-on-secondary", e.SECONDARY_HOVER = "color-secondary-hover", e.TEXT_BODY = "color-text-body", e.TEXT_SECONDARY = "color-text-secondary", e.TEXT_DISABLED = "color-text-disabled", e.TEXT_HEADLINE = "color-text-headline", e))(ColorEnum || {});
const _hoisted_1$g = {
  key: 0,
  "data-test": "hint"
}, _sfc_main$_ = /* @__PURE__ */ defineComponent({
  __name: "SatPriceBreakdown",
  props: {
    items: {}
  },
  setup(e) {
    const j = e, ke = ColorEnum.TEXT_SECONDARY, Se = (Ie) => Ie ?? ke, xe = (Ie) => Ie ? AtomTextTypeEnum.BODY_BOLD : AtomTextTypeEnum.BODY;
    return (Ie, Me) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$Y)())
    }, [
      (openBlock(!0), createElementBlock(Fragment, null, renderList(j.items, (Ee, Be) => (openBlock(), createElementBlock("div", { key: Be }, [
        createVNode(unref(AtomText), {
          class: normalizeClass([
            unref(css$Y)("item"),
            {
              [unref(css$Y)("border-top")]: Ee.borderTop
            }
          ]),
          tag: "div",
          "data-test": "item",
          type: xe(Ee.bold ?? Ee.isTotal),
          color: Se(Ee.color)
        }, {
          default: withCtx(() => [
            createElementVNode("span", null, [
              createTextVNode(toDisplayString(Ee.name) + " ", 1),
              Ee.hint ? (openBlock(), createElementBlock("span", _hoisted_1$g, " (" + toDisplayString(Ee.hint) + ") ", 1)) : createCommentVNode("", !0)
            ]),
            createElementVNode("div", {
              class: normalizeClass(unref(css$Y)("amount-wrapper"))
            }, [
              Ee.strikedAmount ? (openBlock(), createBlock(unref(AtomText), {
                key: 0,
                color: "color-coral",
                striked: ""
              }, {
                default: withCtx(() => [
                  createVNode(unref(_sfc_main$1w), {
                    amount: Ee.strikedAmount.value,
                    currency: Ee.strikedAmount.currency
                  }, null, 8, ["amount", "currency"])
                ]),
                _: 2
              }, 1024)) : createCommentVNode("", !0),
              createVNode(unref(_sfc_main$1w), {
                amount: Ee.amount.value,
                currency: Ee.amount.currency
              }, null, 8, ["amount", "currency"])
            ], 2)
          ]),
          _: 2
        }, 1032, ["class", "type", "color"]),
        Ee.subline ? (openBlock(), createBlock(unref(AtomText), {
          key: 0,
          "data-test": "subline",
          color: "color-text-secondary",
          type: "small"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(Ee.subline), 1)
          ]),
          _: 2
        }, 1024)) : createCommentVNode("", !0)
      ]))), 128))
    ], 2));
  }
}), SatPriceBreakdown = /* @__PURE__ */ _export_sfc(_sfc_main$_, [["__scopeId", "data-v-69f240b0"]]), MolChargeEntry = SatPriceBreakdown, className$X = "sat-product-summary", css$X = bemBuilder(className$X);
bemBuilder(className$X, !0);
const _sfc_main$Z = /* @__PURE__ */ defineComponent({
  __name: "ModifierItem",
  props: {
    name: {},
    quantity: {},
    modifiers: {}
  },
  setup(e) {
    const j = bemBuilder("modifier-item"), ke = e;
    return (Se, xe) => {
      const Ie = resolveComponent("ModifierItem", !0);
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(j)())
      }, [
        createVNode(unref(AtomText), null, {
          default: withCtx(() => [
            ke.quantity > 1 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              createTextVNode(toDisplayString(ke.quantity) + " × ", 1)
            ], 64)) : createCommentVNode("", !0),
            createTextVNode(" " + toDisplayString(ke.name) + " ", 1),
            ke.modifiers.length ? (openBlock(!0), createElementBlock(Fragment, { key: 1 }, renderList(ke.modifiers, (Me, Ee) => (openBlock(), createBlock(Ie, {
              key: Ee,
              class: normalizeClass(unref(j)("list")),
              name: Me.name,
              quantity: Me.quantity,
              modifiers: Me.modifiers
            }, null, 8, ["class", "name", "quantity", "modifiers"]))), 128)) : createCommentVNode("", !0)
          ]),
          _: 1
        })
      ], 2);
    };
  }
}), ModifierItem = /* @__PURE__ */ _export_sfc(_sfc_main$Z, [["__scopeId", "data-v-87e4e8fe"]]), _sfc_main$Y = /* @__PURE__ */ defineComponent({
  __name: "SatProductSummary",
  props: {
    id: {},
    quantity: {},
    name: {},
    modifiers: {},
    price: {},
    isLoading: { type: Boolean },
    isViewOnly: { type: Boolean },
    removeItemLabel: {},
    discountedPrice: {},
    notes: {},
    notesLabel: {},
    isCounterDisabled: { type: Boolean },
    counterSize: { default: "small" }
  },
  emits: ["increase", "decrease", "change", "clear"],
  setup(e, { emit: j }) {
    const ke = e, Se = j;
    return (xe, Ie) => (openBlock(), createElementBlock("div", {
      class: normalizeClass([unref(css$X)(), { [unref(css$X)("", "is-loading")]: ke.isLoading }])
    }, [
      ke.isLoading ? (openBlock(), createBlock(unref(AtomLoadingSpinner), {
        key: 0,
        size: 32,
        class: normalizeClass(unref(css$X)("loading"))
      }, null, 8, ["class"])) : createCommentVNode("", !0),
      createElementVNode("div", {
        class: normalizeClass(unref(css$X)("content-positioning"))
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(css$X)("content"))
        }, [
          createVNode(unref(AtomText), {
            tag: "div",
            type: "body-bold",
            class: normalizeClass(unref(css$X)("name")),
            color: "color-text-body"
          }, {
            default: withCtx(() => [
              ke.isViewOnly && ke.quantity > 1 ? (openBlock(), createElementBlock("span", {
                key: 0,
                class: normalizeClass(unref(css$X)("quantity"))
              }, toDisplayString(ke.quantity) + " × ", 3)) : createCommentVNode("", !0),
              createTextVNode(" " + toDisplayString(ke.name), 1)
            ]),
            _: 1
          }, 8, ["class"]),
          (openBlock(!0), createElementBlock(Fragment, null, renderList(ke.modifiers, (Me, Ee) => (openBlock(), createBlock(ModifierItem, {
            key: Ee,
            class: normalizeClass(unref(css$X)("modifier")),
            name: Me.name,
            quantity: Me.quantity,
            modifiers: Me.modifiers
          }, null, 8, ["class", "name", "quantity", "modifiers"]))), 128)),
          ke.notes ? (openBlock(), createBlock(unref(AtomText), {
            key: 0,
            color: "color-text-secondary",
            tag: "div"
          }, {
            default: withCtx(() => [
              createElementVNode("strong", null, toDisplayString(ke.notesLabel ?? "Notes:"), 1),
              createTextVNode(" " + toDisplayString(ke.notes), 1)
            ]),
            _: 1
          })) : createCommentVNode("", !0)
        ], 2),
        createElementVNode("div", {
          class: normalizeClass(unref(css$X)("price"))
        }, [
          ke.discountedPrice ? (openBlock(), createBlock(unref(AtomText), {
            key: 0,
            type: "body-bold",
            color: "color-text-body",
            "data-test": "discounted-price"
          }, {
            default: withCtx(() => [
              createVNode(unref(_sfc_main$1w), {
                amount: ke.discountedPrice.value,
                currency: ke.discountedPrice.currency
              }, null, 8, ["amount", "currency"])
            ]),
            _: 1
          })) : createCommentVNode("", !0),
          createVNode(unref(AtomText), {
            "data-test": "price",
            striked: !!ke.discountedPrice,
            type: ke.discountedPrice ? "body" : "body-bold",
            color: ke.discountedPrice ? "color-text-disabled" : "color-text-body"
          }, {
            default: withCtx(() => [
              createVNode(unref(_sfc_main$1w), {
                amount: ke.price.value,
                currency: ke.price.currency
              }, null, 8, ["amount", "currency"])
            ]),
            _: 1
          }, 8, ["striked", "type", "color"])
        ], 2)
      ], 2),
      ke.isViewOnly ? createCommentVNode("", !0) : (openBlock(), createElementBlock("div", {
        key: 1,
        class: normalizeClass(unref(css$X)("counter-box"))
      }, [
        createVNode(unref(SatCounter), {
          class: normalizeClass(unref(css$X)("counter")),
          value: ke.id,
          "show-delete": !0,
          size: ke.counterSize,
          disabled: ke.isCounterDisabled,
          count: ke.quantity,
          onIncrease: Ie[0] || (Ie[0] = (Me, Ee) => Se("increase", Ee, Me)),
          onDecrease: Ie[1] || (Ie[1] = (Me, Ee) => Se("decrease", Ee, Me)),
          onChange: Ie[2] || (Ie[2] = (Me, Ee) => Se("change", Ee, Me)),
          onCleared: Ie[3] || (Ie[3] = (Me) => Se("clear", Me))
        }, null, 8, ["class", "value", "size", "disabled", "count"]),
        createVNode(SatLink, {
          color: "color-coral",
          underlined: !1,
          onClick: Ie[4] || (Ie[4] = () => Se("clear", ke.id))
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.removeItemLabel || "Remove"), 1)
          ]),
          _: 1
        })
      ], 2))
    ], 2));
  }
}), SatProductSummary = /* @__PURE__ */ _export_sfc(_sfc_main$Y, [["__scopeId", "data-v-473d483d"]]), className$W = "sat-discount", css$W = bemBuilder(className$W);
bemBuilder(className$W, !0);
const _sfc_main$X = /* @__PURE__ */ defineComponent({
  __name: "SatDiscount",
  props: {
    code: {},
    addCodeLabel: {},
    appliedLabel: {},
    applyCtaLabel: {},
    inputPlaceholder: {},
    isLoading: { type: Boolean },
    errorMessage: {}
  },
  emits: ["remove", "apply", "cancel"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = ref("empty"), Ie = () => {
      xe.value = "form";
    }, Me = (Le) => {
      Se("remove", Le);
    }, Ee = (Le) => {
      Se("apply", $e.value.trim(), Le);
    }, Be = () => {
      xe.value = "empty", Se("cancel");
    }, $e = ref("");
    return watch(
      () => ke.code,
      (Le) => {
        $e.value = "", xe.value = Le ? "filled" : "empty";
      },
      { immediate: !0 }
    ), (Le, Fe) => xe.value === "empty" ? (openBlock(), createElementBlock("label", {
      key: 0,
      class: normalizeClass([unref(css$W)(), unref(css$W)("", "empty")]),
      onClick: Ie
    }, [
      createVNode(unref(AtomText), null, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(Le.$props.addCodeLabel), 1)
        ]),
        _: 1
      }),
      createVNode(unref(SatIconButton), {
        variant: "secondary",
        theme: "tailored",
        "icon-name": "plus",
        plain: "",
        size: "extra-small"
      })
    ], 2)) : xe.value === "filled" ? (openBlock(), createElementBlock("div", {
      key: 1,
      class: normalizeClass([unref(css$W)(), unref(css$W)("", "filled")])
    }, [
      createVNode(unref(AtomText), null, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(ke.appliedLabel) + " ", 1),
          createElementVNode("strong", null, toDisplayString(ke.code), 1)
        ]),
        _: 1
      }),
      createVNode(unref(SatIconButton), {
        variant: "danger",
        theme: "ghost",
        "icon-name": "delete",
        size: "extra-small",
        onClick: Me
      })
    ], 2)) : xe.value === "form" ? (openBlock(), createElementBlock("form", {
      key: 2,
      class: normalizeClass([unref(css$W)(), unref(css$W)("", "form")]),
      onSubmit: withModifiers(Ee, ["prevent"])
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$W)("input-group"))
      }, [
        createVNode(unref(AtomInput), {
          class: normalizeClass(unref(css$W)("input")),
          placeholder: ke.inputPlaceholder,
          "has-error": !!ke.errorMessage,
          value: $e.value,
          autofocus: "",
          onChange: Fe[0] || (Fe[0] = (Ve) => $e.value = Ve),
          onKeydown: withKeys(withModifiers(Be, ["exact"]), ["esc"])
        }, null, 8, ["class", "placeholder", "has-error", "value", "onKeydown"]),
        createVNode(unref(AtomButton), {
          variant: "secondary",
          theme: "tailored",
          "is-loading": ke.isLoading,
          onClick: Ee
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(Le.$props.applyCtaLabel), 1)
          ]),
          _: 1
        }, 8, ["is-loading"])
      ], 2),
      ke.errorMessage ? (openBlock(), createBlock(unref(AtomText), {
        key: 0,
        class: normalizeClass(unref(css$W)("error")),
        color: "color-coral",
        type: "small",
        tag: "div"
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(Le.$props.errorMessage), 1)
        ]),
        _: 1
      }, 8, ["class"])) : createCommentVNode("", !0)
    ], 34)) : createCommentVNode("", !0);
  }
}), SatDiscount = /* @__PURE__ */ _export_sfc(_sfc_main$X, [["__scopeId", "data-v-05bb212f"]]), className$V = "atom-apple-pay-button", css$V = bemBuilder(className$V);
bemBuilder(className$V, !0);
const _hoisted_1$f = ["disabled"], _sfc_main$W = /* @__PURE__ */ defineComponent({
  __name: "AtomApplePayButton",
  props: {
    disabled: { type: Boolean, default: !1 },
    isLoading: { type: Boolean, default: !1 },
    loadingText: { default: "Checking for updates..." }
  },
  emits: ["click"],
  setup(e) {
    const j = e, ke = computed(() => defineAsyncComponent(async () => import("./loading-Dt4_aNY7.js")));
    return (Se, xe) => (openBlock(), createElementBlock("button", {
      class: normalizeClass({
        [unref(css$V)()]: !0,
        [unref(css$V)("", "loading")]: j.isLoading
      }),
      disabled: j.disabled || j.isLoading,
      onClick: xe[0] || (xe[0] = (Ie) => Se.$emit("click", Ie))
    }, [
      j.isLoading ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        (openBlock(), createBlock(resolveDynamicComponent(ke.value), {
          class: normalizeClass(unref(css$V)("spinner"))
        }, null, 8, ["class"])),
        j.loadingText ? (openBlock(), createElementBlock("span", {
          key: 0,
          class: normalizeClass(unref(css$V)("loading-text"))
        }, toDisplayString(j.loadingText), 3)) : createCommentVNode("", !0)
      ], 64)) : (openBlock(), createElementBlock("span", {
        key: 1,
        class: normalizeClass(unref(css$V)("title"))
      }, [
        renderSlot(Se.$slots, "default", {}, void 0, !0)
      ], 2))
    ], 10, _hoisted_1$f));
  }
}), AtomApplePayButton = /* @__PURE__ */ _export_sfc(_sfc_main$W, [["__scopeId", "data-v-bbc6943c"]]), className$U = "atom-checkbox", css$U = bemBuilder(className$U);
bemBuilder(className$U, !0);
const _hoisted_1$e = ["value", "checked", "disabled"], _sfc_main$V = /* @__PURE__ */ defineComponent({
  __name: "AtomCheckbox",
  props: {
    checked: { type: Boolean, default: !1 },
    value: { default: "" },
    partial: { type: Boolean, default: !1 },
    rightContent: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["change"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = useSlots(), Ie = computed(() => !!xe.default);
    function Me() {
      ke.disabled || Se("change", !ke.checked, ke.value);
    }
    return (Ee, Be) => (openBlock(), createElementBlock("label", {
      class: normalizeClass([
        unref(css$U)(),
        {
          [unref(css$U)("", "right-content")]: ke.rightContent,
          [unref(css$U)("", "disabled")]: ke.disabled
        }
      ])
    }, [
      createElementVNode("input", {
        type: "checkbox",
        class: normalizeClass(unref(css$U)("input")),
        value: ke.value,
        checked: ke.checked,
        disabled: ke.disabled,
        onChange: Me
      }, null, 42, _hoisted_1$e),
      createElementVNode("span", {
        class: normalizeClass([
          unref(css$U)("checkmark"),
          { [unref(css$U)("checkmark", "partial")]: ke.partial }
        ])
      }, null, 2),
      Ie.value ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(unref(css$U)("content"))
      }, [
        renderSlot(Ee.$slots, "default", {}, void 0, !0)
      ], 2)) : createCommentVNode("", !0)
    ], 2));
  }
}), AtomCheckbox = /* @__PURE__ */ _export_sfc(_sfc_main$V, [["__scopeId", "data-v-69efc8cd"]]), className$T = "atom-graphic", css$T = bemBuilder(className$T);
bemBuilder(className$T, !0);
const _sfc_main$U = /* @__PURE__ */ defineComponent({
  __name: "AtomGraphic",
  props: {
    name: {},
    size: { default: 16 },
    width: {},
    height: {}
  },
  setup(e) {
    const j = e, ke = computed(() => defineAsyncComponent(async () => __variableDynamicImportRuntimeHelper(/* @__PURE__ */ Object.assign({ "./assets/amex.svg": () => import("./amex-L99slikX.js"), "./assets/apple-pay.svg": () => import("./apple-pay-gZBuc9iB.js"), "./assets/chatfood-logo-placeholder.svg": () => import("./chatfood-logo-placeholder-DE8NSiVB.js"), "./assets/chatfood-logo.svg": () => import("./chatfood-logo-B3MAlTVr.js"), "./assets/deliverect-logo-placeholder.svg": () => import("./deliverect-logo-placeholder-Dvdi0TXm.js"), "./assets/deliverect-logo.svg": () => import("./deliverect-logo-Bk43ReT0.js"), "./assets/dine-in.svg": () => import("./dine-in-DxOnRaY1.js"), "./assets/discount.svg": () => import("./discount-C93zdsMi.js"), "./assets/discover.svg": () => import("./discover-D1BWEE-g.js"), "./assets/emoji-heart-eyes.svg": () => import("./emoji-heart-eyes-DVTWVx6k.js"), "./assets/emoji-in-love.svg": () => import("./emoji-in-love-CUjUiTTt.js"), "./assets/emoji-pray.svg": () => import("./emoji-pray-t8l1KXiq.js"), "./assets/emoji-star-eyes.svg": () => import("./emoji-star-eyes-DZRI3zCd.js"), "./assets/emoji-thumbs-up.svg": () => import("./emoji-thumbs-up-CS_abpe-.js"), "./assets/empty-bag.svg": () => import("./empty-bag-DCXjBYPi.js"), "./assets/general-information.svg": () => import("./general-information-DUL0PxFC.js"), "./assets/google.svg": () => import("./google-vG_BIG6p.js"), "./assets/mastercard.svg": () => import("./mastercard-DO3MzWiF.js"), "./assets/pay-at-counter.svg": () => import("./pay-at-counter-CCywDxCm.js"), "./assets/payment-card.svg": () => import("./payment-card-DmYAHaKS.js"), "./assets/payment-cash.svg": () => import("./payment-cash-BKGYrOC7.js"), "./assets/reset-order.svg": () => import("./reset-order-o_jJQ5gn.js"), "./assets/skipcash.svg": () => import("./skipcash-mGMUfDrk.js"), "./assets/takeaway.svg": () => import("./takeaway-Bc3LBPOO.js"), "./assets/todo-checkmark.svg": () => import("./todo-checkmark-BXrlot5v.js"), "./assets/user-typing.svg": () => import("./user-typing-Dd819qEt.js"), "./assets/visa.svg": () => import("./visa-B2Dzsoki.js"), "./assets/whatsapp.svg": () => import("./whatsapp-D3Mf1pqx.js") }), `./assets/${j.name}.svg`, 3))), Se = computed(() => j.width && j.height ? {
      height: `${j.height}px`,
      width: `${j.width}px`
    } : j.height ? {
      maxWidth: j.width ? `${j.width}px` : "auto",
      height: `${j.height}px`
    } : j.width ? {
      maxHeight: j.height ? `${j.height}px` : "auto",
      width: `${j.width}px`
    } : {
      width: `${j.size}px`,
      "max-height": `${j.size}px`
    });
    return (xe, Ie) => (openBlock(), createBlock(resolveDynamicComponent(ke.value), {
      class: normalizeClass(unref(css$T)()),
      style: normalizeStyle(Se.value)
    }, null, 8, ["class", "style"]));
  }
});
var AtomGraphicNameEnum = /* @__PURE__ */ ((e) => (e.AMEX = "amex", e.APPLE_PAY = "apple-pay", e.CHATFOOD_LOGO = "chatfood-logo", e.CHATFOOD_LOGO_PLACEHOLDER = "chatfood-logo-placeholder", e.DELIVERECT_LOGO = "deliverect-logo", e.DELIVERECT_LOGO_PLACEHOLDER = "deliverect-logo-placeholder", e.DINE_IN = "dine-in", e.DISCOUNT = "discount", e.DISCOVER = "discover", e.EMOJI_HEART_EYES = "emoji-heart-eyes", e.EMOJI_IN_LOVE = "emoji-in-love", e.EMOJI_PRAY = "emoji-pray", e.EMOJI_STAR_EYES = "emoji-star-eyes", e.EMOJI_THUMBS_UP = "emoji-thumbs-up", e.EMPTY_BAG = "empty-bag", e.GENERAL_INFORMATION = "general-information", e.GOOGLE = "google", e.MASTERCARD = "mastercard", e.PAY_AT_COUNTER = "pay-at-counter", e.PAYMENT_CARD = "payment-card", e.PAYMENT_CASH = "payment-cash", e.RESET_ORDER = "reset-order", e.SKIPCASH = "skipcash", e.TAKEAWAY = "takeaway", e.TODO_CHECKMARK = "todo-checkmark", e.VISA = "visa", e.WHATSAPP = "whatsapp", e.USER_TYPING = "user-typing", e))(AtomGraphicNameEnum || {});
const useAtomGraphic = () => ({
  preloadAssets: () => {
    Object.values(AtomGraphicNameEnum).forEach((j) => {
      __variableDynamicImportRuntimeHelper(/* @__PURE__ */ Object.assign({ "./assets/amex.svg": () => import("./amex-L99slikX.js"), "./assets/apple-pay.svg": () => import("./apple-pay-gZBuc9iB.js"), "./assets/chatfood-logo-placeholder.svg": () => import("./chatfood-logo-placeholder-DE8NSiVB.js"), "./assets/chatfood-logo.svg": () => import("./chatfood-logo-B3MAlTVr.js"), "./assets/deliverect-logo-placeholder.svg": () => import("./deliverect-logo-placeholder-Dvdi0TXm.js"), "./assets/deliverect-logo.svg": () => import("./deliverect-logo-Bk43ReT0.js"), "./assets/dine-in.svg": () => import("./dine-in-DxOnRaY1.js"), "./assets/discount.svg": () => import("./discount-C93zdsMi.js"), "./assets/discover.svg": () => import("./discover-D1BWEE-g.js"), "./assets/emoji-heart-eyes.svg": () => import("./emoji-heart-eyes-DVTWVx6k.js"), "./assets/emoji-in-love.svg": () => import("./emoji-in-love-CUjUiTTt.js"), "./assets/emoji-pray.svg": () => import("./emoji-pray-t8l1KXiq.js"), "./assets/emoji-star-eyes.svg": () => import("./emoji-star-eyes-DZRI3zCd.js"), "./assets/emoji-thumbs-up.svg": () => import("./emoji-thumbs-up-CS_abpe-.js"), "./assets/empty-bag.svg": () => import("./empty-bag-DCXjBYPi.js"), "./assets/general-information.svg": () => import("./general-information-DUL0PxFC.js"), "./assets/google.svg": () => import("./google-vG_BIG6p.js"), "./assets/mastercard.svg": () => import("./mastercard-DO3MzWiF.js"), "./assets/pay-at-counter.svg": () => import("./pay-at-counter-CCywDxCm.js"), "./assets/payment-card.svg": () => import("./payment-card-DmYAHaKS.js"), "./assets/payment-cash.svg": () => import("./payment-cash-BKGYrOC7.js"), "./assets/reset-order.svg": () => import("./reset-order-o_jJQ5gn.js"), "./assets/skipcash.svg": () => import("./skipcash-mGMUfDrk.js"), "./assets/takeaway.svg": () => import("./takeaway-Bc3LBPOO.js"), "./assets/todo-checkmark.svg": () => import("./todo-checkmark-BXrlot5v.js"), "./assets/user-typing.svg": () => import("./user-typing-Dd819qEt.js"), "./assets/visa.svg": () => import("./visa-B2Dzsoki.js"), "./assets/whatsapp.svg": () => import("./whatsapp-D3Mf1pqx.js") }), `./assets/${j}.svg`, 3);
    });
  }
}), className$S = "atom-image", css$S = bemBuilder(className$S);
bemBuilder(className$S, !0);
const _hoisted_1$d = ["alt", "src"], _sfc_main$T = /* @__PURE__ */ defineComponent({
  __name: "AtomImage",
  props: {
    src: {},
    alt: {},
    width: {},
    height: {},
    size: { default: 68 },
    type: { default: "square" }
  },
  setup(e) {
    const j = e, ke = computed(() => ({
      width: `${j.height ?? j.size}px`,
      "max-height": `${j.height ?? j.size}px`
    }));
    return (Se, xe) => (openBlock(), createElementBlock("img", {
      alt: j.alt,
      class: normalizeClass([unref(css$S)(""), unref(css$S)("", j.type)]),
      style: normalizeStyle(ke.value),
      src: j.src
    }, null, 14, _hoisted_1$d));
  }
}), AtomImage = /* @__PURE__ */ _export_sfc(_sfc_main$T, [["__scopeId", "data-v-e9f72745"]]), className$R = "atom-input-money", css$R = bemBuilder(className$R);
bemBuilder(className$R, !0);
const _hoisted_1$c = ["value", "disabled", "autofocus"], _sfc_main$S = /* @__PURE__ */ defineComponent({
  __name: "AtomInputMoney",
  props: {
    hasError: { type: Boolean },
    disabled: { type: Boolean },
    value: {},
    autoFocus: { type: Boolean }
  },
  emits: ["input"],
  setup(e, { emit: j }) {
    const ke = e, Se = ref(), xe = ref(""), Ie = ref(0);
    watch(
      () => ke.value,
      (Be) => {
        xe.value = toMoney(Be.value, Be.currency), nextTick(() => {
          if (Se.value && Ie.value > 0) {
            const $e = (Ie.value ?? 0) + 1;
            Se.value.setSelectionRange(
              $e,
              $e
            );
          }
        });
      },
      {
        immediate: !0
      }
    );
    const Me = j;
    function Ee(Be) {
      if (ke.disabled) return;
      const $e = Be.target, Le = $e.value;
      let Fe = parseInt(Le.replace(/\D/g, ""), 10);
      Ie.value = $e.selectionStart ?? 0, isNaN(Fe) && (Fe = 0), Me("input", {
        value: Fe,
        currency: ke.value.currency
      });
    }
    return (Be, $e) => (openBlock(), createElementBlock("div", {
      class: normalizeClass([
        unref(css$R)(),
        {
          [unref(css$R)("", "error")]: ke.hasError,
          [unref(css$R)("", "disabled")]: ke.disabled
        }
      ])
    }, [
      createElementVNode("input", {
        ref_key: "inputElement",
        ref: Se,
        class: normalizeClass(unref(css$R)("field")),
        value: xe.value,
        type: "tel",
        disabled: ke.disabled,
        autofocus: ke.autoFocus,
        onInput: Ee
      }, null, 42, _hoisted_1$c)
    ], 2));
  }
}), AtomInputMoney = /* @__PURE__ */ _export_sfc(_sfc_main$S, [["__scopeId", "data-v-9623513e"]]), className$Q = "atom-input-phone-number", css$Q = bemBuilder(className$Q);
bemBuilder(className$Q, !0);
const _hoisted_1$b = ["disabled", "placeholder", "autofocus"], _sfc_main$R = /* @__PURE__ */ defineComponent({
  __name: "AtomInputPhoneNumber",
  props: {
    country: {},
    number: { default: "" },
    disabled: { type: Boolean, default: !1 },
    hasError: { type: Boolean, default: !1 },
    autofocus: { type: Boolean, default: !1 }
  },
  emits: ["input", "blur"],
  setup(e, { emit: j }) {
    useCssVars((xt) => ({
      v7fa5e5bc: Ue.value
    }));
    const ke = (xt, Ct) => getPhoneNumberExample(findCountryByIso(xt).iso2, Ct), Se = (xt, Ct) => xt ? Ct <= 2 ? 14 : 13 : Ct <= 3 ? 10 : 9, xe = e, Ie = j, Me = ref(parseInputNumber(xe.country)), Ee = ref(findCountryByIso(xe.country)), Be = ref(`+${Ee.value.dialCode}`), $e = ref(!1), Le = ref(), Fe = ref(!0), Ve = ref(
      ke(findCountryByIso(xe.country).iso2)
    ), je = ref(
      ke(findCountryByIso(xe.country).iso2, "national")
    ), Ge = window.innerWidth <= 460, De = computed(
      () => Se(Ge, Be.value.length)
    ), Ue = computed(
      () => Fe.value ? `${String(Be.value.length * De.value)}px` : "100%"
    ), Re = computed(() => isValidMobileNumber(Me.value)), Ye = ref(!1), We = computed(
      () => xe.hasError || (!Re.value || !Me.value.countryCode) && Ye.value
    );
    onMounted(() => {
      Le.value?.blur(), xe.number && (Be.value = Be.value.concat(xe.number), Fe.value = Be.value.length <= 4 && !!Ee.value.iso2);
    }), watch(Be, (xt) => {
      hasProperLength(xt, 1, 2) && (Be.value = addPlusToInternationalNumber(xt)), Me.value = parseInputNumber(xt), Ee.value = findCountryByIso(Me.value.regionCode), Re.value && (Be.value = Me.value.number.international, Ye.value = !0), Ie("input", {
        isValid: Re.value,
        countryCode: Me.value.countryCode,
        number: Me.value.number.national
      });
    }), watch(Ee, (xt) => {
      xt.iso2 && (Ve.value = ke(xt.iso2), je.value = ke(xt.iso2, "national"));
    });
    const qe = () => {
      Fe.value = !1, $e.value = !0;
    }, Je = () => {
      $e.value = !1, Be.value.length <= 4 && Ee.value.iso2 && (Fe.value = !0), Ie("blur", {
        isValid: Re.value,
        countryCode: Me.value.countryCode,
        number: Me.value.number.national
      });
    }, Ke = computed(() => Ee.value.iso2 ? Ee.value.flagEmoji : "🤔");
    return (xt, Ct) => (openBlock(), createElementBlock("a", {
      class: normalizeClass([
        unref(css$Q)(),
        {
          [unref(css$Q)("", "error")]: We.value,
          [unref(css$Q)("", "disabled")]: xe.disabled,
          [unref(css$Q)("", "focus")]: $e.value,
          [unref(css$Q)("", "empty")]: !Be.value
        }
      ]),
      onClick: Ct[1] || (Ct[1] = (It) => Le.value?.focus())
    }, [
      createElementVNode("span", {
        class: normalizeClass([
          unref(css$Q)("flag"),
          {
            [unref(css$Q)("flag", "error")]: !Ee.value?.iso2
          }
        ])
      }, toDisplayString(Ke.value), 3),
      withDirectives(createElementVNode("input", {
        ref_key: "fieldTempRed",
        ref: Le,
        "onUpdate:modelValue": Ct[0] || (Ct[0] = (It) => Be.value = It),
        class: normalizeClass(unref(css$Q)("field")),
        disabled: xe.disabled,
        placeholder: Ve.value,
        type: "tel",
        autofocus: xe.autofocus,
        onFocus: qe,
        onBlur: Je
      }, null, 42, _hoisted_1$b), [
        [vModelText, Be.value]
      ]),
      Fe.value ? (openBlock(), createElementBlock("label", {
        key: 0,
        class: normalizeClass(unref(css$Q)("label"))
      }, toDisplayString(je.value), 3)) : createCommentVNode("", !0)
    ], 2));
  }
}), AtomInputPhoneNumber = /* @__PURE__ */ _export_sfc(_sfc_main$R, [["__scopeId", "data-v-0727783f"]]), className$P = "atom-input-pin-code", css$P = bemBuilder(className$P);
bemBuilder(className$P, !0);
const _hoisted_1$a = ["type", "pattern", "value", "disabled", "required", "onFocus", "onInput", "onKeydown"], _sfc_main$Q = /* @__PURE__ */ defineComponent({
  __name: "AtomInputPinCode",
  props: {
    fieldCount: {},
    type: { default: "number" },
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !0 },
    invalid: { type: Boolean, default: !1 }
  },
  emits: ["validate"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = ref(new Array(ke.fieldCount)), Ie = ref([]), Me = computed(() => ke.type === "number"), Ee = computed(() => Me.value ? "tel" : "text"), Be = computed(() => Me.value ? "[0-9]+" : void 0);
    onMounted(() => {
      Ie.value[0]?.focus();
    });
    const $e = (Re) => ({
      current: Ie.value[Re],
      prevEl: Ie.value[Re - 1],
      nextEl: Ie.value[Re + 1]
    }), Le = () => {
      const Re = xe.value.join("");
      Se("validate", {
        pinCode: Re,
        isValid: Re.length >= ke.fieldCount
      });
    }, Fe = (Re) => {
      Ie.value[Re]?.focus();
    }, Ve = (Re) => {
      const { prevEl: Ye } = $e(Re);
      xe.value[Re] = "", xe.value[Re] || Ye?.focus(), xe.value = [...xe.value];
    }, je = (Re) => {
      $e(Re).nextEl?.focus();
    }, Ge = (Re) => {
      $e(Re).prevEl?.focus();
    }, De = (Re) => {
      Re.preventDefault();
    }, Ue = (Re) => {
      const { current: Ye } = $e(Re), We = ke.fieldCount - 1;
      let qe = Re + 1;
      if (Me.value && (Ye.value = Ye.value.replace(/[^\d+]/gi, "")), Ye.value === "" || Me.value && !Ye.validity.valid)
        return;
      const Je = Ye.value;
      if (xe.value[Re] = Je.charAt(0), Je.length > 1) {
        const Ct = Je.substring(1);
        Ct.length && (Ct.split("").forEach((It) => {
          qe <= ke.fieldCount && qe <= We && (xe.value[qe] = It, qe++);
        }), xe.value = [...xe.value]);
      }
      const Ke = qe >= We, xt = Ke ? Ie.value[We] : Ie.value[qe];
      xt.focus(), Ke && xt.setSelectionRange(0, 0, "backward"), Le();
    };
    return (Re, Ye) => (openBlock(), createElementBlock("label", {
      ref: "pinCodeContainer",
      class: normalizeClass([
        unref(css$P)(),
        {
          [unref(css$P)("", "invalid")]: ke.invalid
        }
      ])
    }, [
      (openBlock(!0), createElementBlock(Fragment, null, renderList(xe.value, (We, qe) => (openBlock(), createElementBlock("input", {
        ref_for: !0,
        ref_key: "pinCodeFields",
        ref: Ie,
        key: qe,
        autocomplete: "one-time-code",
        class: normalizeClass(unref(css$P)("input")),
        type: Ee.value,
        pattern: Be.value,
        value: We,
        disabled: ke.disabled,
        required: ke.required,
        onFocus: withModifiers((Je) => Fe(qe), ["stop", "prevent"]),
        onInput: (Je) => Ue(qe),
        onKeydown: [
          withKeys(withModifiers((Je) => Ve(qe), ["stop", "prevent"]), ["delete"]),
          withKeys(withModifiers((Je) => je(qe), ["prevent"]), ["right"]),
          withKeys(withModifiers((Je) => Ge(qe), ["prevent"]), ["left"]),
          withKeys(De, ["up"]),
          withKeys(De, ["down"])
        ]
      }, null, 42, _hoisted_1$a))), 128))
    ], 2));
  }
}), AtomInputPinCode = /* @__PURE__ */ _export_sfc(_sfc_main$Q, [["__scopeId", "data-v-30894732"]]), className$O = "atom-intersection", css$O = bemBuilder(className$O);
bemBuilder(className$O, !0);
const _sfc_main$P = /* @__PURE__ */ defineComponent({
  __name: "AtomIntersection",
  props: {
    offset: { default: 0 },
    scrollElementId: {}
  },
  emits: ["enter", "leave"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = ref(), Ie = ref(!1), Me = ref(window), Ee = (Fe) => {
      const Ve = parseFloat(xe.value.offsetTop), je = parseFloat(xe.value.offsetHeight), De = (Me.value instanceof Window ? Me.value.scrollY : Me.value.scrollTop) + ke.offset;
      De > Ve && De < Ve + je ? Ie.value || (Se("enter", xe.value, Fe), Ie.value = !0) : Ie.value && (Se("leave", xe.value, Fe), Ie.value = !1);
    }, Be = () => {
      Me.value.addEventListener("scroll", Ee, { passive: !0 });
    }, $e = () => {
      Me.value.removeEventListener("scroll", Ee);
    }, Le = () => {
      Me.value = ke.scrollElementId && document.getElementById(ke.scrollElementId) || window;
    };
    return onMounted(() => {
      Le(), Be();
    }), onBeforeUnmount(() => {
      $e();
    }), watch(
      () => ke.scrollElementId,
      () => {
        $e(), Le(), Be();
      }
    ), (Fe, Ve) => (openBlock(), createElementBlock("div", {
      ref_key: "root",
      ref: xe,
      class: normalizeClass(unref(css$O)())
    }, [
      renderSlot(Fe.$slots, "default")
    ], 2));
  }
}), className$N = "atom-link", css$N = bemBuilder(className$N);
bemBuilder(className$N, !0);
const _sfc_main$O = /* @__PURE__ */ defineComponent({
  __name: "AtomLink",
  props: {
    to: {},
    target: { default: "_self" },
    theme: { default: "primary" },
    type: { default: "link" },
    wide: { type: Boolean, default: !1 },
    color: {}
  },
  setup(e) {
    const j = e, ke = computed(
      () => j.target === "_blank" ? "a" : "router-link"
    ), Se = computed(() => j.target === "_blank" ? {
      href: j.to,
      target: j.target,
      rel: "noopener noreferrer"
    } : {
      to: j.to
    });
    return (xe, Ie) => (openBlock(), createBlock(resolveDynamicComponent(ke.value), mergeProps({
      class: [
        unref(css$N)(),
        unref(css$N)("", j.theme),
        unref(css$N)("", j.type),
        j.wide ? unref(css$N)("", "wide") : ""
      ],
      style: j.color ? `color: var(--${j.color})` : void 0
    }, Se.value), {
      default: withCtx(() => [
        renderSlot(xe.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 16, ["class", "style"]));
  }
}), AtomLink = /* @__PURE__ */ _export_sfc(_sfc_main$O, [["__scopeId", "data-v-4ee42d94"]]), className$M = "atom-skeleton-loader", css$M = bemBuilder(className$M);
bemBuilder(className$M, !0);
const _sfc_main$N = /* @__PURE__ */ defineComponent({
  __name: "AtomSkeletonLoader",
  props: {
    type: { default: "square" },
    loading: { type: Boolean, default: !0 },
    size: {},
    lines: { default: 3 },
    width: {},
    height: {},
    aspectRatio: {},
    equalLines: { type: Boolean, default: !0 },
    borderRadius: { default: "small" }
  },
  setup(e) {
    const j = e, ke = computed(
      () => [...Array(j.lines)].map((xe, Ie) => css$M(`line-item-${Ie + 1}`))
    ), Se = computed(() => ({
      ...j.aspectRatio ? { aspectRatio: j.aspectRatio } : {},
      width: `${j.width ?? j.size}px`,
      height: `${j.height ?? j.size}px`
    }));
    return (xe, Ie) => (openBlock(), createElementBlock("div", {
      class: normalizeClass({
        [unref(css$M)()]: !0,
        [unref(css$M)("", `radius-${j.borderRadius}`)]: !0,
        [unref(css$M)("", `${j.type}`)]: !0,
        [unref(css$M)("", "loading")]: j.loading
      })
    }, [
      (openBlock(!0), createElementBlock(Fragment, null, renderList(ke.value, (Me, Ee) => (openBlock(), createElementBlock("div", {
        key: Ee,
        style: normalizeStyle(Se.value),
        class: normalizeClass({
          [unref(css$M)("line")]: !0,
          [Me]: !0,
          [unref(css$M)("line", "equal")]: j.equalLines
        })
      }, null, 6))), 128))
    ], 2));
  }
}), AtomSkeletonLoader = /* @__PURE__ */ _export_sfc(_sfc_main$N, [["__scopeId", "data-v-15f3e9a9"]]), className$L = "atom-switcher", css$L = bemBuilder(className$L);
bemBuilder(className$L, !0);
const _sfc_main$M = /* @__PURE__ */ defineComponent({
  __name: "AtomSwitcher",
  props: {
    checked: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    size: { default: "regular" }
  },
  emits: ["change"],
  setup(e) {
    const j = e;
    return (ke, Se) => (openBlock(), createElementBlock("label", {
      class: normalizeClass([unref(css$L)(), { [unref(css$L)("", "disabled")]: j.disabled }]),
      onClick: Se[0] || (Se[0] = (xe) => !j.disabled && ke.$emit("change", xe))
    }, [
      createElementVNode("span", {
        class: normalizeClass([
          unref(css$L)("mark"),
          {
            [unref(css$L)("mark", "unchecked")]: !j.checked,
            [unref(css$L)("mark", "mini")]: j.size === "small"
          }
        ])
      }, null, 2)
    ], 2));
  }
}), AtomSwitcher = /* @__PURE__ */ _export_sfc(_sfc_main$M, [["__scopeId", "data-v-27a7f0ba"]]), className$K = "atom-textarea", css$K = bemBuilder(className$K);
bemBuilder(className$K, !0);
const _hoisted_1$9 = ["placeholder", "value", "disabled", "rows"], _sfc_main$L = /* @__PURE__ */ defineComponent({
  __name: "AtomTextarea",
  props: {
    placeholder: {},
    hasError: { type: Boolean },
    value: { default: "" },
    disabled: { type: Boolean },
    autoGrow: { type: Boolean, default: !0 },
    rows: { default: 2 }
  },
  emits: ["keyup", "change"],
  setup(e, { emit: j }) {
    const ke = e, Se = ref(), xe = computed(() => Math.max(ke.rows, 2));
    nextTick(() => {
      ke.autoGrow && $e();
    });
    const Ie = j, Me = () => {
      ke.disabled || Ie("change", Se.value?.value);
    }, Ee = () => {
      ke.disabled || Ie("keyup", Se.value?.value);
    }, Be = () => {
      ke.autoGrow && $e();
    };
    onMounted(() => {
      ke.autoGrow && $e();
    });
    function $e() {
      {
        const Le = Se.value;
        if (!Le) return;
        const {
          borderTopWidth: Fe,
          borderBottomWidth: Ve,
          paddingTop: je,
          paddingBottom: Ge,
          lineHeight: De
        } = window.getComputedStyle(Le);
        Le.style.height = "auto";
        const Ue = parseFloat(Fe) + parseFloat(Ve), Re = parseFloat(je) + parseFloat(Ge), Ye = Number(Le.scrollHeight), We = parseFloat(De), qe = Ue + Re, Je = We * xe.value + qe, Ke = Math.max((Ye - Re) / We, 2), xt = Math.max(Ke, xe.value), Ct = Math.max(
          Math.ceil(xt * We + qe),
          Je
        );
        Le.style.height = `${Ct}px`;
      }
    }
    return (Le, Fe) => (openBlock(), createElementBlock("div", {
      class: normalizeClass([
        unref(css$K)(),
        {
          [unref(css$K)("", "error")]: ke.hasError,
          [unref(css$K)("", "disabled")]: ke.disabled
        }
      ])
    }, [
      createElementVNode("textarea", {
        ref_key: "textarea",
        ref: Se,
        class: normalizeClass({
          [unref(css$K)("field")]: !0,
          [unref(css$K)("field", "auto-grow")]: ke.autoGrow
        }),
        placeholder: ke.placeholder,
        value: ke.value,
        disabled: ke.disabled,
        rows: xe.value,
        onChange: Me,
        onKeyup: Ee,
        onInput: Be
      }, null, 42, _hoisted_1$9)
    ], 2));
  }
}), AtomTextarea = /* @__PURE__ */ _export_sfc(_sfc_main$L, [["__scopeId", "data-v-477b7f42"]]), className$J = "atom-wrapper", css$J = bemBuilder(className$J);
bemBuilder(className$J, !0);
const _sfc_main$K = /* @__PURE__ */ defineComponent({
  __name: "AtomWrapper",
  props: {
    centered: { type: Boolean, default: !0 },
    spacedBetween: { type: Boolean, default: !1 },
    backgroundType: {}
  },
  setup(e) {
    const j = e;
    return (ke, Se) => (openBlock(), createElementBlock("div", {
      class: normalizeClass([unref(css$J)(), { [unref(css$J)("", j.backgroundType)]: j.backgroundType }])
    }, [
      createElementVNode("div", {
        class: normalizeClass([
          unref(css$J)("container"),
          {
            [unref(css$J)("container", "centered")]: j.centered,
            [unref(css$J)("container", "spaced-between")]: j.spacedBetween
          }
        ])
      }, [
        renderSlot(ke.$slots, "default", {}, void 0, !0)
      ], 2)
    ], 2));
  }
}), AtomWrapper = /* @__PURE__ */ _export_sfc(_sfc_main$K, [["__scopeId", "data-v-b2dfc73e"]]), className$I = "atom-toast", css$I = bemBuilder(className$I);
bemBuilder(className$I, !0);
const iconMap = {
  success: "data:image/svg+xml;base64,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",
  error: "data:image/svg+xml;base64,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"
};
class AtomToast {
  options;
  constructor(j) {
    this.options = {
      position: j?.position || "bottom",
      timeout: j?.timeout || 5e3,
      type: j?.type || "success",
      title: j?.title || "",
      text: j?.text || "",
      closeButton: j?.closeButton,
      fixed: j?.fixed,
      icon: j?.icon
    };
  }
  create(j) {
    const ke = { ...this.options, ...j }, Se = document.querySelector("body");
    if (!document.getElementById("toast")) {
      const Ve = document.createElement("div");
      Ve.id = "toast", Ve.classList.add(
        css$I("container"),
        css$I("container", ke.position)
      ), Se?.appendChild(Ve);
    }
    const Ie = document.createElement("div");
    Ie.classList.add(css$I("item"));
    const Me = document.createElement("div");
    Me.classList.add(css$I("icon"));
    const Ee = ke.icon || iconMap[ke.type];
    Me.style.backgroundImage = `url(${Ee})`, Ie.appendChild(Me), Ie.classList.add(css$I("", ke.type));
    const Be = document.createElement("div");
    Be.classList.add(css$I("content")), Ie.appendChild(Be);
    const $e = document.createElement("h4");
    if ($e.classList.add(css$I("title")), $e.innerHTML = ke.title || "", Be.appendChild($e), ke.text) {
      const Ve = document.createElement("p");
      Ve.classList.add(css$I("text")), Ve.innerHTML = ke.text, Be.appendChild(Ve);
    }
    const Le = () => {
      document.getElementById("toast")?.removeChild(Ie);
    }, Fe = () => {
      Ie.classList.add(css$I("", "hide")), Ie.addEventListener("animationend", Le, !1);
    };
    if (ke.closeButton) {
      const Ve = document.createElement("span");
      Ve.classList.add(css$I("close")), Ve.addEventListener("click", Fe), Ie.appendChild(Ve);
    }
    ke.closeButton || Ie.addEventListener("click", Fe), ke.fixed || setTimeout(Fe, ke.timeout), document.getElementById("toast")?.appendChild(Ie);
  }
}
const className$H = "atom-checkout-dot-com-card-form", css$H = bemBuilder(className$H);
bemBuilder(className$H, !0);
const _sfc_main$J = /* @__PURE__ */ defineComponent({
  __name: "AtomCheckoutDotComCardForm",
  props: {
    publicKey: {}
  },
  emits: ["error", "status", "cardSelected"],
  setup(e, { expose: j, emit: ke }) {
    const Se = e, xe = ke;
    j({ submitCard: Ie });
    async function Ie() {
      try {
        xe("status", "PROCESSING"), await window.Frames.submitCard();
      } catch (je) {
        xe("error", {
          code: je === "Card form invalid" ? "INVALID_FORM" : "UNEXPECTED_ERROR",
          actual: je
        });
      } finally {
        xe("status", "ACTIVE");
      }
    }
    const Me = ref(""), Ee = ref(""), Be = ref("");
    onMounted(async () => {
      xe("status", "LOADING"), await $e(), Fe();
    });
    function $e() {
      if (typeof window > "u" || !document) return;
      const je = getComputedStyle(document.documentElement);
      je && (Me.value = je.getPropertyValue("--color-text-body")?.trim(), Ee.value = je.getPropertyValue("--color-text-secondary")?.trim(), Be.value = je.getPropertyValue("--color-error")?.trim());
    }
    onBeforeUnmount(() => {
      window.Frames.removeAllEventHandlers("frameActivated"), window.Frames.removeAllEventHandlers("cardTokenized"), window.Frames.removeAllEventHandlers("cardTokenizationFailed");
    });
    function Le() {
      return window.Frames ? Promise.resolve() : new Promise((je, Ge) => {
        const De = document.createElement("script");
        De.async = !0, De.src = "https://cdn.checkout.com/js/framesv2.min.js", document.head.appendChild(De), De.onload = je, De.onerror = Ge;
      });
    }
    async function Fe() {
      try {
        await Le();
      } catch (je) {
        xe("error", {
          code: "UNAVAILABLE",
          actual: je
        });
        return;
      }
      if (window.Frames) {
        try {
          Ve();
        } catch (je) {
          xe("error", { code: "UNAVAILABLE", actual: je });
        }
        return;
      }
      xe("error", {
        code: "UNAVAILABLE",
        actual: new Error("Could not load frame")
      });
    }
    function Ve() {
      window.Frames.init({
        publicKey: Se.publicKey,
        style: {
          base: {
            color: Me.value || "dimgray",
            fontSize: "14px",
            fontWeight: 400,
            letterSpacing: "0.5px",
            fontFamily: "Inter, sans-serif"
          },
          focus: {
            color: Me.value || "black",
            borderColor: "black"
          },
          invalid: {
            color: Be.value || "red",
            borderColor: "red"
          },
          placeholder: {
            base: {
              color: Ee.value || "gray",
              letterSpacing: "0.2px"
            }
          }
        },
        frameActivated: () => {
          xe("status", "ACTIVE");
        },
        cardTokenized: (je) => {
          const Ge = {
            bin: je.bin,
            cardCategory: je.card_category,
            cardType: je.card_type,
            expiresOn: new Date(je.expires_on),
            expiryMonth: je.expiry_month,
            expiryYear: je.expiry_year,
            issuer: je.issuer,
            issuerCountry: je.issuer_country,
            last4: je.last4,
            preferredScheme: je.preferred_scheme,
            productType: je.product_type,
            productId: je.product_id,
            scheme: je.scheme,
            token: je.token,
            type: je.type
          };
          xe("cardSelected", Ge);
        },
        cardTokenizationFailed: () => {
          xe("error", {
            code: "UNEXPECTED_ERROR",
            actual: new Error("Tokenization failure")
          });
        }
      });
    }
    return (je, Ge) => (openBlock(), createElementBlock("div", {
      id: "payment-form",
      class: normalizeClass(unref(css$H)())
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$H)("content"))
      }, [...Ge[0] || (Ge[0] = [
        createElementVNode("div", { class: "card-frame" }, null, -1)
      ])], 2)
    ], 2));
  }
}), AtomCheckoutDotComCardForm = /* @__PURE__ */ _export_sfc(_sfc_main$J, [["__scopeId", "data-v-482aea0b"]]);
var AtomCheckoutDotComFormErrorEnum = /* @__PURE__ */ ((e) => (e.UNAVAILABLE = "UNAVAILABLE", e.UNEXPECTED_ERROR = "UNEXPECTED_ERROR", e.INVALID_FORM = "INVALID_FORM", e))(AtomCheckoutDotComFormErrorEnum || {}), AtomCheckoutDotComFormStatusEnum = /* @__PURE__ */ ((e) => (e.LOADING = "LOADING", e.ACTIVE = "ACTIVE", e.PROCESSING = "PROCESSING", e))(AtomCheckoutDotComFormStatusEnum || {});
const className$G = "mol-button-badge", css$G = bemBuilder(className$G);
bemBuilder(className$G, !0);
const _sfc_main$I = /* @__PURE__ */ defineComponent({
  __name: "MolButtonBadge",
  props: {
    variant: { default: "primary" },
    size: { default: "large" },
    value: {}
  },
  emits: ["click"],
  setup(e) {
    const j = e, ke = computed(
      () => j.variant === "primary" ? "low" : "high"
    );
    return (Se, xe) => (openBlock(), createBlock(unref(AtomButton), {
      wide: "",
      class: normalizeClass(unref(css$G)()),
      size: j.size,
      variant: j.variant,
      onClick: xe[0] || (xe[0] = (Ie) => Se.$emit("click", Ie))
    }, {
      default: withCtx(() => [
        createVNode(unref(AtomBadge), {
          class: normalizeClass(unref(css$G)("badge")),
          state: "branded",
          value: j.value,
          emphasis: ke.value,
          size: j.size === "large" ? "normal" : "small"
        }, null, 8, ["class", "value", "emphasis", "size"]),
        createElementVNode("span", {
          class: normalizeClass(unref(css$G)("label"))
        }, [
          renderSlot(Se.$slots, "default", {}, void 0, !0)
        ], 2)
      ]),
      _: 3
    }, 8, ["class", "size", "variant"]));
  }
}), MolButtonBadge = /* @__PURE__ */ _export_sfc(_sfc_main$I, [["__scopeId", "data-v-4af0dad2"]]), className$F = "mol-button-round", css$F = bemBuilder(className$F);
bemBuilder(className$F, !0);
const _sfc_main$H = /* @__PURE__ */ defineComponent({
  __name: "MolButtonRound",
  props: {
    iconName: {},
    label: {},
    to: {},
    target: { default: "_self" },
    shadow: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  setup(e) {
    const j = e, ke = computed(() => !j.iconName && j.label);
    return (Se, xe) => (openBlock(), createBlock(unref(AtomLink), {
      class: normalizeClass([
        unref(css$F)(),
        {
          [unref(css$F)("", "shadow")]: j.shadow,
          [unref(css$F)("", "with-label")]: j.label,
          [unref(css$F)("", "only-label")]: ke.value,
          [unref(css$F)("", "disabled")]: j.disabled
        }
      ]),
      to: j.to,
      target: j.target
    }, {
      default: withCtx(() => [
        j.iconName ? (openBlock(), createBlock(unref(_sfc_main$1Q), {
          key: 0,
          class: normalizeClass(unref(css$F)("icon")),
          name: j.iconName,
          "ignore-color": ""
        }, null, 8, ["class", "name"])) : createCommentVNode("", !0),
        j.label ? (openBlock(), createBlock(unref(AtomText), {
          key: 1,
          type: "body-bold",
          class: normalizeClass(unref(css$F)("label"))
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(j.label), 1)
          ]),
          _: 1
        }, 8, ["class"])) : createCommentVNode("", !0)
      ]),
      _: 1
    }, 8, ["class", "to", "target"]));
  }
}), MolButtonRound = /* @__PURE__ */ _export_sfc(_sfc_main$H, [["__scopeId", "data-v-219d1d58"]]), className$E = "mol-card-header", css$E = bemBuilder(className$E);
bemBuilder(className$E, !0);
const _sfc_main$G = /* @__PURE__ */ defineComponent({
  __name: "MolCardHeader",
  props: {
    title: {},
    subtitle: {},
    isRequired: { type: Boolean, default: !1 },
    hasError: { type: Boolean, default: !1 },
    hasBorder: { type: Boolean, default: !0 },
    requiredLabel: { default: "required" }
  },
  setup(e) {
    const j = e, ke = computed(() => j.hasError ? "color-coral" : "color-base-40");
    return (Se, xe) => (openBlock(), createElementBlock("div", {
      class: normalizeClass({
        [unref(css$E)()]: !0,
        [unref(css$E)("", "has-border")]: j.hasBorder
      })
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$E)("title"))
      }, [
        createVNode(unref(AtomText), {
          tag: "p",
          type: "body-bold"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(j.title), 1)
          ]),
          _: 1
        }),
        j.isRequired ? (openBlock(), createBlock(unref(AtomText), {
          key: 0,
          type: "small",
          color: ke.value,
          class: normalizeClass(unref(css$E)("required"))
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(j.requiredLabel), 1)
          ]),
          _: 1
        }, 8, ["color", "class"])) : createCommentVNode("", !0)
      ], 2),
      j.subtitle ? (openBlock(), createBlock(unref(AtomText), {
        key: 0,
        color: ke.value,
        class: normalizeClass(unref(css$E)("subtitle")),
        type: j.hasError ? "small-bold" : "small"
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(j.subtitle), 1)
        ]),
        _: 1
      }, 8, ["color", "class", "type"])) : createCommentVNode("", !0)
    ], 2));
  }
}), MolCardHeader = /* @__PURE__ */ _export_sfc(_sfc_main$G, [["__scopeId", "data-v-39459c8c"]]), className$D = "mol-channel-selector", css$D = bemBuilder(className$D);
bemBuilder(className$D, !0);
const _sfc_main$F = /* @__PURE__ */ defineComponent({
  __name: "MolChannelSelector",
  props: {
    channel: {},
    title: {},
    headline: {},
    cta: {},
    isLoading: { type: Boolean },
    showCloseButton: { type: Boolean, default: !0 }
  },
  emits: ["select", "close"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = ref(ke.channel), Ie = [
      {
        id: "whatsapp",
        icon: "whatsapp",
        label: "WhatsApp"
      },
      {
        id: "sms",
        icon: "sms",
        label: "SMS"
      }
    ], Me = ($e) => {
      Se("close", $e);
    }, Ee = () => {
      Se("select", xe.value);
    }, Be = ($e) => {
      if ($e === "sms") {
        xe.value = "sms";
        return;
      }
      xe.value = "whatsapp";
    };
    return ($e, Le) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$D)())
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$D)("header"))
      }, [
        createVNode(unref(AtomText), {
          type: "subtitle",
          tag: "div"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.title), 1)
          ]),
          _: 1
        }),
        e.showCloseButton ? (openBlock(), createElementBlock("button", {
          key: 0,
          type: "button",
          class: normalizeClass(unref(css$D)("close")),
          onClick: Me
        }, [
          createVNode(unref(_sfc_main$1Q), { name: "close" })
        ], 2)) : createCommentVNode("", !0)
      ], 2),
      ke.headline ? (openBlock(), createBlock(unref(AtomText), {
        key: 0,
        class: normalizeClass(unref(css$D)("headline")),
        tag: "div"
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(ke.headline), 1)
        ]),
        _: 1
      }, 8, ["class"])) : createCommentVNode("", !0),
      createElementVNode("div", {
        class: normalizeClass(unref(css$D)("options"))
      }, [
        (openBlock(), createElementBlock(Fragment, null, renderList(Ie, (Fe) => createVNode(unref(AtomRadio), {
          key: Fe.id,
          name: "channel",
          "right-content": !0,
          class: normalizeClass(unref(css$D)("option")),
          value: Fe.id,
          "space-between": !0,
          checked: xe.value === Fe.id,
          onChange: Be
        }, {
          default: withCtx(() => [
            createVNode(unref(_sfc_main$1Q), {
              name: Fe.icon,
              color: "color-primary"
            }, null, 8, ["name"]),
            createVNode(unref(AtomText), null, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(Fe.label), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["class", "value", "checked"])), 64))
      ], 2),
      createVNode(unref(AtomButton), {
        size: "large",
        wide: "",
        class: normalizeClass(unref(css$D)("cta")),
        "is-loading": ke.isLoading,
        onClick: Ee
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(ke.cta), 1)
        ]),
        _: 1
      }, 8, ["class", "is-loading"])
    ], 2));
  }
}), MolChannelSelector = /* @__PURE__ */ _export_sfc(_sfc_main$F, [["__scopeId", "data-v-afa89a00"]]), className$C = "mol-collapse-indicator", css$C = bemBuilder(className$C);
bemBuilder(className$C, !0);
const _sfc_main$E = /* @__PURE__ */ defineComponent({
  __name: "MolCollapseIndicator",
  props: {
    collapsed: { type: Boolean, default: !1 },
    theme: {},
    variant: {},
    borderLess: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e) {
    const j = e;
    return (ke, Se) => (openBlock(), createElementBlock("a", {
      class: normalizeClass([
        unref(css$C)(),
        unref(css$C)("", j.collapsed ? "collapsed" : "uncollapsed"),
        unref(css$C)("", j.borderLess ? "border-none" : ""),
        unref(css$C)(j.variant),
        unref(css$C)(j.variant, j.theme)
      ]),
      "data-test": "mol-collapse-indicator",
      onClick: Se[0] || (Se[0] = withModifiers((xe) => ke.$emit("click", xe), ["prevent"]))
    }, [
      createVNode(unref(_sfc_main$1Q), {
        class: normalizeClass(unref(css$C)("icon")),
        name: "caret-right-alt",
        size: "small",
        "ignore-color": ""
      }, null, 8, ["class"])
    ], 2));
  }
}), MolCollapseIndicator = /* @__PURE__ */ _export_sfc(_sfc_main$E, [["__scopeId", "data-v-5106b8f7"]]), className$B = "mol-collectable-loyalty-points", css$B = bemBuilder(className$B);
bemBuilder(className$B, !0);
const _sfc_main$D = /* @__PURE__ */ defineComponent({
  __name: "MolCollectableLoyaltyPoints",
  setup(e) {
    return (j, ke) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$B)())
    }, [
      createVNode(unref(_sfc_main$1Q), {
        color: "color-primary",
        name: "diamond"
      }),
      createVNode(unref(AtomText), null, {
        default: withCtx(() => [
          renderSlot(j.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      })
    ], 2));
  }
}), MolCollectableLoyaltyPoints = /* @__PURE__ */ _export_sfc(_sfc_main$D, [["__scopeId", "data-v-b7e70547"]]), className$A = "mol-logo-loading", css$A = bemBuilder(className$A);
bemBuilder(className$A, !0);
const _sfc_main$C = /* @__PURE__ */ defineComponent({
  __name: "MolLogoLoading",
  props: {
    message: {},
    absolute: { type: Boolean, default: !1 },
    brand: { default: "chatfood" }
  },
  setup(e) {
    const j = e, ke = computed(
      () => j.brand === "chatfood" ? "chatfood-logo" : "deliverect-logo"
    );
    return (Se, xe) => (openBlock(), createElementBlock("span", {
      class: normalizeClass({
        [unref(css$A)()]: !0,
        [unref(css$A)("", "absolute")]: j.absolute
      })
    }, [
      createElementVNode("span", null, [
        createElementVNode("span", {
          class: normalizeClass(unref(css$A)("location_indicator"))
        }, [
          (openBlock(), createBlock(unref(_sfc_main$U), {
            key: ke.value,
            name: ke.value,
            size: 45,
            class: normalizeClass(unref(css$A)("icon"))
          }, null, 8, ["name", "class"]))
        ], 2),
        j.message ? (openBlock(), createBlock(unref(AtomText), {
          key: 0,
          color: "color-base-50",
          class: normalizeClass(unref(css$A)("title"))
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(j.message), 1)
          ]),
          _: 1
        }, 8, ["class"])) : createCommentVNode("", !0)
      ])
    ], 2));
  }
}), MolLogoLoading = /* @__PURE__ */ _export_sfc(_sfc_main$C, [["__scopeId", "data-v-338dd847"]]), className$z = "mol-loyalty-detail", css$z = bemBuilder(className$z);
bemBuilder(className$z, !0);
const _sfc_main$B = /* @__PURE__ */ defineComponent({
  __name: "MolLoyaltyDetail",
  props: {
    title: {},
    subtitle: {},
    iconName: { default: "diamond" },
    balance: {},
    titleRules: {},
    lineRules: {}
  },
  emits: ["onClose"],
  setup(e) {
    const j = e;
    return (ke, Se) => (openBlock(), createBlock(unref(AtomCard), {
      class: normalizeClass(unref(css$z)()),
      padding: "none"
    }, {
      default: withCtx(() => [
        createVNode(unref(_sfc_main$1Q), {
          name: "close",
          class: normalizeClass(unref(css$z)("close")),
          color: "color-on-primary",
          onClick: Se[0] || (Se[0] = (xe) => ke.$emit("onClose", xe))
        }, null, 8, ["class"]),
        createElementVNode("div", {
          class: normalizeClass(unref(css$z)("header"))
        }, [
          createElementVNode("div", {
            class: normalizeClass(unref(css$z)("icon"))
          }, [
            createVNode(unref(_sfc_main$1Q), {
              class: normalizeClass(unref(css$z)("icon-svg")),
              name: j.iconName,
              color: "color-primary"
            }, null, 8, ["class", "name"])
          ], 2),
          createElementVNode("div", {
            class: normalizeClass(unref(css$z)("header-content"))
          }, [
            createVNode(unref(AtomText), {
              type: "small-bold",
              color: "color-on-primary"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(j.title), 1)
              ]),
              _: 1
            }),
            createVNode(unref(AtomText), {
              type: "h3",
              color: "color-on-primary"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(j.balance), 1)
              ]),
              _: 1
            }),
            createVNode(unref(AtomText), {
              type: "small",
              color: "color-on-primary"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(j.subtitle), 1)
              ]),
              _: 1
            })
          ], 2)
        ], 2),
        createElementVNode("div", {
          class: normalizeClass(unref(css$z)("content"))
        }, [
          createVNode(unref(AtomText), { type: "body-bold" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(j.titleRules), 1)
            ]),
            _: 1
          }),
          createVNode(unref(AtomText), {
            type: "small",
            color: "color-base-40"
          }, {
            default: withCtx(() => [
              createElementVNode("ul", {
                class: normalizeClass(unref(css$z)("list"))
              }, [
                (openBlock(!0), createElementBlock(Fragment, null, renderList(j.lineRules, (xe, Ie) => (openBlock(), createElementBlock("li", { key: Ie }, toDisplayString(xe), 1))), 128))
              ], 2)
            ]),
            _: 1
          })
        ], 2)
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), MolLoyaltyDetail = /* @__PURE__ */ _export_sfc(_sfc_main$B, [["__scopeId", "data-v-a5651a1a"]]), className$y = "loyalty-banner", css$y = bemBuilder(className$y);
bemBuilder(className$y, !0);
const _sfc_main$A = /* @__PURE__ */ defineComponent({
  __name: "MolLoyaltyBanner",
  props: {
    title: {},
    subtitle: {},
    ctaLabel: {}
  },
  emits: ["ctaClick"],
  setup(e, { emit: j }) {
    const ke = e, Se = j;
    return (xe, Ie) => (openBlock(), createBlock(unref(AtomCard), {
      class: normalizeClass(unref(css$y)()),
      padding: "none"
    }, {
      default: withCtx(() => [
        createElementVNode("div", {
          class: normalizeClass(unref(css$y)("icon"))
        }, [
          createVNode(unref(_sfc_main$1Q), {
            name: "diamond",
            size: "49",
            color: "color-base-100"
          })
        ], 2),
        createElementVNode("div", {
          class: normalizeClass(unref(css$y)("content"))
        }, [
          createElementVNode("div", {
            class: normalizeClass(unref(css$y)("info"))
          }, [
            createVNode(unref(AtomText), { type: "body-bold" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(ke.title), 1)
              ]),
              _: 1
            }),
            ke.subtitle ? (openBlock(), createBlock(unref(AtomText), {
              key: 0,
              class: normalizeClass(unref(css$y)("subtitle")),
              type: "small",
              color: "color-base-40"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(ke.subtitle), 1)
              ]),
              _: 1
            }, 8, ["class"])) : createCommentVNode("", !0)
          ], 2),
          ke.ctaLabel ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(unref(css$y)("action"))
          }, [
            createVNode(unref(AtomButton), {
              class: normalizeClass(unref(css$y)("cta")),
              variant: "secondary",
              size: "small",
              onClick: Ie[0] || (Ie[0] = (Me) => Se("ctaClick", Me))
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(ke.ctaLabel), 1)
              ]),
              _: 1
            }, 8, ["class"])
          ], 2)) : createCommentVNode("", !0)
        ], 2)
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), MolLoyaltyBanner = /* @__PURE__ */ _export_sfc(_sfc_main$A, [["__scopeId", "data-v-6f18a559"]]), className$x = "mol-loyalty-switch", css$x = bemBuilder(className$x);
bemBuilder(className$x, !0);
const _sfc_main$z = /* @__PURE__ */ defineComponent({
  __name: "MolLoyaltySwitch",
  props: {
    label: { default: "Use loyalty points" },
    loyaltyValue: {},
    checked: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["change"],
  setup(e) {
    const j = e;
    return (ke, Se) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$x)())
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$x)("label-container"))
      }, [
        createVNode(unref(AtomText), null, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(j.label) + " ", 1),
            createElementVNode("strong", null, [
              createVNode(unref(_sfc_main$1w), {
                amount: j.loyaltyValue.value,
                currency: j.loyaltyValue.currency
              }, null, 8, ["amount", "currency"])
            ])
          ]),
          _: 1
        })
      ], 2),
      createVNode(unref(AtomSwitcher), {
        size: "small",
        checked: j.checked,
        disabled: j.disabled,
        onChange: Se[0] || (Se[0] = (xe) => ke.$emit("change", xe))
      }, null, 8, ["checked", "disabled"])
    ], 2));
  }
}), MolLoyaltySwitch = /* @__PURE__ */ _export_sfc(_sfc_main$z, [["__scopeId", "data-v-1ba23be2"]]), className$w = "mol-payment-method", css$w = bemBuilder(className$w);
bemBuilder(className$w, !0);
const _sfc_main$y = /* @__PURE__ */ defineComponent({
  __name: "MolPaymentMethod",
  props: {
    name: {},
    text: { default: () => ({
      cardMachine: "Card machine",
      cash: "Cash",
      addToTab: "Add to tab",
      invoice: "Invoice"
    }) },
    last4: {},
    selected: { type: Boolean },
    showChangeCTA: { type: Boolean },
    changeCTALabel: {}
  },
  emits: ["click"],
  setup(e) {
    const j = e, ke = {
      "apple-pay": {
        type: "graphic",
        symbol: "apple-pay",
        label: "Apple Pay",
        showLast4: !1
      },
      mastercard: {
        type: "graphic",
        symbol: "mastercard",
        label: "Mastercard",
        showLast4: !0
      },
      visa: {
        type: "graphic",
        symbol: "visa",
        label: "Visa",
        showLast4: !0
      },
      amex: {
        type: "graphic",
        symbol: "amex",
        label: "Amex",
        showLast4: !0
      },
      discover: {
        type: "graphic",
        symbol: "discover",
        label: "Discover",
        showLast4: !0
      },
      skipcash: {
        type: "graphic",
        symbol: "skipcash",
        label: "SkipCash",
        showLast4: !1
      },
      cash: {
        type: "icon",
        symbol: "dollar-sign",
        label: j.text.cash,
        showLast4: !1
      },
      invoice: {
        type: "icon",
        symbol: "dollar-sign",
        label: j.text.invoice,
        showLast4: !1
      },
      "card-machine": {
        type: "icon",
        symbol: "card",
        label: j.text.cardMachine,
        showLast4: !1
      },
      "add-to-tab": {
        label: j.text.addToTab,
        type: "icon",
        symbol: "people",
        showLast4: !1
      }
    }, Se = computed(() => {
      const xe = ke[j.name];
      return xe || {
        type: "icon",
        symbol: "card",
        label: textBeautifier(j.name),
        showLast4: !!j.last4?.length
      };
    });
    return (xe, Ie) => (openBlock(), createElementBlock("a", {
      class: normalizeClass(unref(css$w)()),
      href: "#",
      onClick: Ie[0] || (Ie[0] = withModifiers((Me) => xe.$emit("click", Me), ["prevent"]))
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$w)("payment-info-wrapper"))
      }, [
        Se.value.type === "graphic" ? (openBlock(), createBlock(unref(_sfc_main$U), {
          key: 0,
          class: normalizeClass(unref(css$w)("method-logo")),
          name: Se.value.symbol,
          size: 21
        }, null, 8, ["class", "name"])) : Se.value.type === "icon" ? (openBlock(), createBlock(unref(_sfc_main$1Q), {
          key: 1,
          class: normalizeClass(unref(css$w)("method-logo")),
          name: Se.value.symbol,
          size: "medium"
        }, null, 8, ["class", "name"])) : createCommentVNode("", !0),
        Se.value.label ? (openBlock(), createBlock(unref(AtomText), {
          key: 2,
          class: normalizeClass(unref(css$w)("method-name")),
          type: "body-bold"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(Se.value.label), 1)
          ]),
          _: 1
        }, 8, ["class"])) : createCommentVNode("", !0),
        Se.value?.showLast4 ?? j.last4?.length ? (openBlock(), createBlock(unref(AtomText), {
          key: 3,
          "data-test": "last-4"
        }, {
          default: withCtx(() => [
            createTextVNode(" (•••• " + toDisplayString(j.last4) + ") ", 1)
          ]),
          _: 1
        })) : createCommentVNode("", !0)
      ], 2),
      j.showChangeCTA ? (openBlock(), createBlock(unref(AtomText), {
        key: 0,
        "data-test": "change-button",
        color: "color-primary",
        type: "small-bold"
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(j.changeCTALabel), 1)
        ]),
        _: 1
      })) : j.selected ? (openBlock(), createBlock(unref(_sfc_main$1Q), {
        key: 1,
        "data-test": "checkmark",
        name: "checkmark",
        size: "small",
        color: "color-primary"
      })) : createCommentVNode("", !0)
    ], 2));
  }
}), MolPaymentMethod = /* @__PURE__ */ _export_sfc(_sfc_main$y, [["__scopeId", "data-v-de41e7e6"]]), className$v = "mol-powered-by-chatfood", css$v = bemBuilder(className$v);
bemBuilder(className$v, !0);
const _sfc_main$x = /* @__PURE__ */ defineComponent({
  __name: "MolPoweredByChatFood",
  setup(e) {
    return (j, ke) => (openBlock(), createElementBlock("a", {
      href: "https://www.chatfood.io",
      rel: "noopener noreferrer",
      target: "_blank",
      class: normalizeClass(unref(css$v)())
    }, [
      createVNode(unref(_sfc_main$U), {
        class: normalizeClass(unref(css$v)("icon")),
        name: "chatfood-logo",
        size: 21
      }, null, 8, ["class"]),
      createVNode(unref(AtomText), {
        class: normalizeClass(unref(css$v)("text")),
        color: "color-base-50",
        type: "small"
      }, {
        default: withCtx(() => [
          renderSlot(j.$slots, "default", {}, () => [
            ke[0] || (ke[0] = createTextVNode(" Powered by ChatFood ", -1))
          ], !0)
        ]),
        _: 3
      }, 8, ["class"])
    ], 2));
  }
}), MolPoweredByChatFood = /* @__PURE__ */ _export_sfc(_sfc_main$x, [["__scopeId", "data-v-490907c0"]]), className$u = "mol-powered-by-deliverect", css$u = bemBuilder(className$u);
bemBuilder(className$u, !0);
const _sfc_main$w = /* @__PURE__ */ defineComponent({
  __name: "MolPoweredByDeliverect",
  setup(e) {
    return (j, ke) => (openBlock(), createElementBlock("a", {
      href: "https://www.deliverect.com",
      rel: "noopener noreferrer",
      target: "_blank",
      class: normalizeClass(unref(css$u)())
    }, [
      createVNode(unref(_sfc_main$U), {
        class: normalizeClass(unref(css$u)("icon")),
        name: "deliverect-logo",
        size: 21
      }, null, 8, ["class"]),
      createVNode(unref(AtomText), {
        class: normalizeClass(unref(css$u)("text")),
        color: "color-base-50",
        type: "small"
      }, {
        default: withCtx(() => [
          renderSlot(j.$slots, "default", {}, () => [
            ke[0] || (ke[0] = createTextVNode(" Powered by Deliverect ", -1))
          ], !0)
        ]),
        _: 3
      }, 8, ["class"])
    ], 2));
  }
}), MolPoweredByDeliverect = /* @__PURE__ */ _export_sfc(_sfc_main$w, [["__scopeId", "data-v-d90902ca"]]), className$t = "mol-rating-with-stars", css$t = bemBuilder(className$t);
bemBuilder(className$t, !0);
const _hoisted_1$8 = ["for"], _hoisted_2$4 = ["id", "value", "disabled", "checked", "onChange"], _sfc_main$v = /* @__PURE__ */ defineComponent({
  __name: "MolRatingWithStars",
  props: {
    title: {},
    messages: {},
    selected: {},
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["select"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = computed(
      () => [...Array(ke.messages.length).keys()].reduce(
        (Ee, Be) => [Be + 1, ...Ee],
        []
      )
    ), Ie = computed(() => ke.selected ? ke.messages[ke.selected - 1] : ""), Me = (Ee) => {
      ke.disabled || Se("select", Ee);
    };
    return (Ee, Be) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$t)())
    }, [
      ke.title ? (openBlock(), createBlock(unref(AtomText), {
        key: 0,
        class: normalizeClass(unref(css$t)("title")),
        type: "subtitle"
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(ke.title), 1)
        ]),
        _: 1
      }, 8, ["class"])) : createCommentVNode("", !0),
      createElementVNode("div", {
        class: normalizeClass(unref(css$t)("rating"))
      }, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(xe.value, ($e) => (openBlock(), createElementBlock("label", {
          key: $e,
          for: `rate-${$e}`,
          style: normalizeStyle(`--data-counter: ${$e}s`),
          class: normalizeClass([
            unref(css$t)("label"),
            { [unref(css$t)("label", "disabled")]: ke.disabled },
            { [unref(css$t)("label", "checked")]: ke.selected === $e }
          ])
        }, [
          createElementVNode("input", {
            id: `rate-${$e}`,
            type: "radio",
            name: "rate",
            value: $e,
            disabled: ke.disabled,
            checked: ke.selected === $e,
            class: normalizeClass(unref(css$t)("input")),
            onChange: () => Me($e)
          }, null, 42, _hoisted_2$4),
          createVNode(unref(_sfc_main$1Q), {
            name: "rating",
            color: "color-base-90",
            size: "large"
          })
        ], 14, _hoisted_1$8))), 128))
      ], 2),
      createVNode(unref(AtomText), {
        type: "small-bold",
        color: "color-canary",
        class: normalizeClass(unref(css$t)("message"))
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(Ie.value), 1)
        ]),
        _: 1
      }, 8, ["class"])
    ], 2));
  }
}), MolRatingWithStars = /* @__PURE__ */ _export_sfc(_sfc_main$v, [["__scopeId", "data-v-0f832929"]]), className$s = "mol-item-display-skeleton", css$s = bemBuilder(className$s);
bemBuilder(className$s, !0);
const _sfc_main$u = /* @__PURE__ */ defineComponent({
  __name: "MolItemDisplaySkeleton",
  props: {
    view: { default: "col" }
  },
  setup(e) {
    const j = e, ke = computed(() => j.view === "col");
    return (Se, xe) => (openBlock(), createElementBlock("div", {
      class: normalizeClass([unref(css$s)(), unref(css$s)("", j.view)])
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$s)("", "full"))
      }, [
        createVNode(unref(AtomSkeletonLoader), {
          class: normalizeClass(unref(css$s)("title")),
          loading: "",
          lines: 1,
          width: 150,
          height: 12,
          type: "square",
          "border-radius": "medium"
        }, null, 8, ["class"]),
        ke.value ? (openBlock(), createBlock(unref(AtomSkeletonLoader), {
          key: 0,
          class: normalizeClass(unref(css$s)("desc")),
          loading: "",
          lines: 3,
          type: "square",
          "equal-lines": !1,
          "border-radius": "medium"
        }, null, 8, ["class"])) : createCommentVNode("", !0),
        createVNode(unref(AtomSkeletonLoader), {
          class: normalizeClass(unref(css$s)("price")),
          loading: "",
          lines: 1,
          width: 50,
          height: 8,
          type: "square",
          "border-radius": "medium"
        }, null, 8, ["class"])
      ], 2),
      createVNode(unref(AtomSkeletonLoader), {
        class: normalizeClass([unref(css$s)("image"), unref(css$s)("image", j.view)]),
        size: ke.value ? 126 : 500,
        loading: "",
        lines: 1,
        type: "square",
        "border-radius": "medium"
      }, null, 8, ["class", "size"])
    ], 2));
  }
}), MolItemDisplaySkeleton = /* @__PURE__ */ _export_sfc(_sfc_main$u, [["__scopeId", "data-v-a48e3527"]]), className$r = "mol-modifier-group-skeleton", css$r = bemBuilder(className$r);
bemBuilder(className$r, !0);
const _sfc_main$t = /* @__PURE__ */ defineComponent({
  __name: "MolModifierGroupSkeleton",
  props: {
    items: { default: 4 }
  },
  setup(e) {
    const j = e, ke = computed(() => Array(j.items));
    return (Se, xe) => (openBlock(), createBlock(unref(AtomCard), {
      class: normalizeClass(unref(css$r)()),
      radii: "none"
    }, {
      default: withCtx(() => [
        createElementVNode("div", {
          class: normalizeClass(unref(css$r)("header"))
        }, [
          createElementVNode("div", {
            class: normalizeClass(unref(css$r)("header", "left"))
          }, [
            createVNode(unref(AtomSkeletonLoader), {
              "border-radius": "large",
              lines: 1,
              height: 14,
              width: 120
            }),
            createVNode(unref(AtomSkeletonLoader), {
              "border-radius": "large",
              lines: 1,
              height: 7,
              width: 50
            })
          ], 2),
          createElementVNode("div", {
            class: normalizeClass(unref(css$r)("header", "right"))
          }, [
            createVNode(unref(AtomSkeletonLoader), {
              lines: 1,
              width: 42
            })
          ], 2)
        ], 2),
        (openBlock(!0), createElementBlock(Fragment, null, renderList(ke.value, (Ie) => (openBlock(), createElementBlock("div", {
          key: Ie,
          class: normalizeClass(unref(css$r)("item"))
        }, [
          createVNode(unref(AtomSkeletonLoader), {
            "equal-lines": !1,
            class: normalizeClass(unref(css$r)("item", "left")),
            lines: 2
          }, null, 8, ["class"]),
          createVNode(unref(AtomSkeletonLoader), {
            class: normalizeClass(unref(css$r)("item", "right")),
            lines: 1,
            size: 21,
            type: "rounded"
          }, null, 8, ["class"])
        ], 2))), 128))
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), MolModifierGroupSkeleton = /* @__PURE__ */ _export_sfc(_sfc_main$t, [["__scopeId", "data-v-e2404a94"]]), className$q = "mol-basket-line", css$q = bemBuilder(className$q);
bemBuilder(className$q, !0);
const _sfc_main$s = /* @__PURE__ */ defineComponent({
  __name: "MolBasketLine",
  props: {
    lineId: {},
    quantity: {},
    name: {},
    note: {},
    total: {},
    enableAddedBy: { type: Boolean },
    noteLabel: {},
    isVoided: { type: Boolean, default: !1 },
    modifiers: {}
  },
  emits: ["view-added-by"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = () => {
      ke.enableAddedBy && Se("view-added-by", ke.lineId);
    };
    return (Ie, Me) => (openBlock(), createElementBlock("div", {
      class: normalizeClass([unref(css$q)(""), { [unref(css$q)("", "voided")]: ke.isVoided }])
    }, [
      createVNode(unref(AtomText), {
        color: ke.isVoided ? "color-base-50" : "color-base-20",
        type: "body-bold",
        tag: "div",
        class: normalizeClass(unref(css$q)("name"))
      }, {
        default: withCtx(() => [
          ke.quantity > 1 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createTextVNode(toDisplayString(ke.quantity) + " ×", 1)
          ], 64)) : createCommentVNode("", !0),
          createTextVNode(" " + toDisplayString(ke.name) + " ", 1),
          createElementVNode("div", null, [
            createVNode(unref(_sfc_main$1w), {
              class: normalizeClass({
                [unref(css$q)("price")]: !0,
                [unref(css$q)("price", "added-by")]: ke.enableAddedBy
              }),
              amount: ke.total.value,
              currency: ke.total.currency,
              onClick: xe
            }, null, 8, ["class", "amount", "currency"]),
            ke.isVoided ? (openBlock(), createBlock(unref(_sfc_main$1w), {
              key: 0,
              class: normalizeClass(unref(css$q)("price-voided")),
              "hide-cents": !0,
              amount: 0,
              currency: ke.total.currency
            }, null, 8, ["class", "currency"])) : createCommentVNode("", !0)
          ])
        ]),
        _: 1
      }, 8, ["color", "class"]),
      (openBlock(!0), createElementBlock(Fragment, null, renderList(ke.modifiers, (Ee, Be) => (openBlock(), createBlock(unref(AtomText), {
        key: Be,
        color: ke.isVoided ? "color-base-50" : "color-base-40",
        tag: "div"
      }, {
        default: withCtx(() => [
          Ee.quantity > 1 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createTextVNode(toDisplayString(Ee.quantity) + " ×", 1)
          ], 64)) : createCommentVNode("", !0),
          createTextVNode(" " + toDisplayString(Ee.name), 1)
        ]),
        _: 2
      }, 1032, ["color"]))), 128)),
      ke.note ? (openBlock(), createBlock(unref(AtomText), {
        key: 0,
        color: ke.isVoided ? "color-base-50" : "color-base-40",
        tag: "div"
      }, {
        default: withCtx(() => [
          createElementVNode("strong", null, toDisplayString(ke.noteLabel), 1),
          createTextVNode(" " + toDisplayString(ke.note), 1)
        ]),
        _: 1
      }, 8, ["color"])) : createCommentVNode("", !0)
    ], 2));
  }
}), MolBasketLine = /* @__PURE__ */ _export_sfc(_sfc_main$s, [["__scopeId", "data-v-187de46b"]]), className$p = "org-add-to-basket-display", css$p = bemBuilder(className$p);
bemBuilder(className$p, !0);
const className$o = "org-spin-button", css$o = bemBuilder(className$o);
bemBuilder(className$o, !0);
const _sfc_main$r = /* @__PURE__ */ defineComponent({
  __name: "OrgSpinButton",
  props: {
    count: { default: 0 },
    type: { default: "animated" },
    value: { default: "" }
  },
  emits: ["change", "increase", "decrease", "cleared"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = useSlots(), Ie = {
      animated: {
        theme: "filled",
        variant: "primary",
        size: "medium",
        type: "rounded"
      },
      fixed: {
        theme: "filled",
        variant: "secondary",
        size: "medium",
        type: "rounded"
      },
      square: {
        theme: "ghost",
        variant: "primary",
        size: "extra-small",
        type: "square"
      }
    }, Me = computed(() => ke.type === "animated"), Ee = computed(
      () => ke.type === "square" ? "body" : "subtitle"
    ), Be = computed(() => ke.count === 0), $e = computed(() => ke.count === 1), Le = computed(() => ke.count > 0), Fe = computed(() => !!xe.default), Ve = computed(() => Ie[ke.type]), je = computed(
      () => Me.value && (Be.value || $e.value) ? "delete" : "minus"
    );
    function Ge() {
      if (Be.value) return;
      const Ue = ke.count - 1;
      Se("change", Ue, ke.value), Se("decrease", Ue, ke.value), Ue === 0 && Se("cleared", ke.value);
    }
    function De() {
      const Ue = ke.count + 1;
      Se("change", Ue, ke.value), Se("increase", Ue, ke.value);
    }
    return (Ue, Re) => (openBlock(), createElementBlock("div", {
      class: normalizeClass([
        unref(css$o)(),
        unref(css$o)("", ke.type),
        { [unref(css$o)("", "has-counts")]: Le.value }
      ])
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$o)("input"))
      }, [
        (openBlock(), createBlock(unref(SatIconButton), mergeProps({
          key: je.value,
          class: [unref(css$o)("icon-button"), unref(css$o)("count", "decrease")],
          "icon-name": je.value
        }, Ve.value, { onClick: Ge }), null, 16, ["class", "icon-name"])),
        createVNode(unref(AtomText), {
          type: Ee.value,
          class: normalizeClass(unref(css$o)("amount"))
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.count), 1)
          ]),
          _: 1
        }, 8, ["type", "class"]),
        createVNode(unref(SatIconButton), mergeProps({
          class: [unref(css$o)("icon-button"), unref(css$o)("count", "increase")],
          "icon-name": "plus"
        }, Ve.value, { onClick: De }), null, 16, ["class"])
      ], 2),
      Fe.value ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(unref(css$o)("content"))
      }, [
        renderSlot(Ue.$slots, "default", {}, void 0, !0)
      ], 2)) : createCommentVNode("", !0)
    ], 2));
  }
}), OrgSpinButton = /* @__PURE__ */ _export_sfc(_sfc_main$r, [["__scopeId", "data-v-08131f31"]]), _sfc_main$q = /* @__PURE__ */ defineComponent({
  __name: "OrgAddToBasketDisplay",
  props: {
    count: {},
    ctaDisabled: { type: Boolean, default: !1 },
    price: {},
    minCount: { default: 1 },
    type: {},
    locale: {},
    hideCents: { type: Boolean, default: !0 }
  },
  emits: ["update", "buttonClick"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = computed(
      () => ke.minCount > ke.count ? ke.minCount : ke.count
    ), Ie = computed(() => ({
      value: xe.value * ke.price.value,
      currency: ke.price.currency
    }));
    function Me(Be) {
      Se("update", Be);
    }
    function Ee(Be) {
      ke.minCount > Be || Se("update", Be);
    }
    return (Be, $e) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$p)())
    }, [
      createVNode(OrgSpinButton, {
        class: normalizeClass(unref(css$p)("spin-button")),
        type: "fixed",
        count: xe.value,
        onIncrease: Me,
        onDecrease: Ee
      }, null, 8, ["class", "count"]),
      createVNode(unref(SatButtonMoney), {
        class: normalizeClass(unref(css$p)("button-money")),
        disabled: ke.ctaDisabled,
        price: Ie.value,
        locale: ke.locale,
        "hide-cents": ke.hideCents,
        size: "large",
        onClick: $e[0] || ($e[0] = (Le) => Be.$emit("buttonClick", Le))
      }, {
        default: withCtx(() => [
          renderSlot(Be.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["class", "disabled", "price", "locale", "hide-cents"])
    ], 2));
  }
}), OrgAddToBasketDisplay = /* @__PURE__ */ _export_sfc(_sfc_main$q, [["__scopeId", "data-v-e9322871"]]), className$n = "org-icon-modal", css$n = bemBuilder(className$n);
bemBuilder(className$n, !0);
const _sfc_main$p = /* @__PURE__ */ defineComponent({
  __name: "OrgIconModal",
  props: {
    modelValue: { type: Boolean, default: !1 },
    primaryText: {},
    secondaryText: {},
    iconName: {},
    iconColor: { default: "color-base-20" }
  },
  emits: ["close", "update:modelValue"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = useSlots(), Ie = computed(() => !!xe.default);
    return (Me, Ee) => (openBlock(), createBlock(unref(MolModal), {
      "model-value": e.modelValue,
      class: normalizeClass(unref(css$n)()),
      "onUpdate:modelValue": Ee[0] || (Ee[0] = (Be) => Se("update:modelValue", Be)),
      onClose: Ee[1] || (Ee[1] = (Be) => Se("close", Be))
    }, {
      default: withCtx(() => [
        createVNode(unref(_sfc_main$1Q), {
          size: "70",
          name: ke.iconName,
          color: ke.iconColor,
          class: normalizeClass(unref(css$n)("icon"))
        }, null, 8, ["name", "color", "class"]),
        createVNode(unref(AtomText), {
          type: "h3",
          class: normalizeClass(unref(css$n)("primary-text"))
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.primaryText), 1)
          ]),
          _: 1
        }, 8, ["class"]),
        ke.secondaryText ? (openBlock(), createBlock(unref(AtomText), {
          key: 0,
          color: "color-base-50",
          tag: "div",
          class: normalizeClass(unref(css$n)("secondary-text"))
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.secondaryText), 1)
          ]),
          _: 1
        }, 8, ["class"])) : createCommentVNode("", !0),
        Ie.value ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(unref(css$n)("open-slot"))
        }, [
          renderSlot(Me.$slots, "default", {}, void 0, !0)
        ], 2)) : createCommentVNode("", !0)
      ]),
      _: 3
    }, 8, ["model-value", "class"]));
  }
}), OrgIconModal = /* @__PURE__ */ _export_sfc(_sfc_main$p, [["__scopeId", "data-v-e23701aa"]]), className$m = "org-modifier-group", css$m = bemBuilder(className$m);
bemBuilder(className$m, !0);
const _hoisted_1$7 = ["id"], _hoisted_2$3 = ["onClick"], _sfc_main$o = /* @__PURE__ */ defineComponent({
  __name: "OrgModifierGroup",
  props: {
    title: {},
    items: {},
    maxSelection: { default: 0 },
    minSelection: { default: 0 },
    type: {},
    subtitle: {},
    validateOnMount: { type: Boolean, default: !1 },
    categoryId: {},
    viewOnly: { type: Boolean, default: !1 }
  },
  emits: ["change", "validate", "customizeModifier"],
  setup(e, { emit: j }) {
    const ke = e, Se = j;
    onMounted(() => {
      ke.validateOnMount && Ge();
    }), watch(
      () => ke.items,
      () => Ge(),
      { deep: !0 }
    );
    const xe = computed(() => !!ke.minSelection);
    function Ie(Ue) {
      return {
        radio: { checked: !!Ue },
        checkbox: { checked: !!Ue },
        multiple: { count: Ue }
      }[ke.type];
    }
    const Me = computed(() => ({
      radio: {
        component: AtomRadio,
        className: "radio",
        events: {
          change: (Ue) => je(Ue)
        },
        defaultProps: {
          rightContent: !0,
          name: ke.categoryId
        }
      },
      checkbox: {
        component: AtomCheckbox,
        className: "checkbox",
        events: {
          change: (Ue, Re) => je(Re)
        },
        defaultProps: {
          rightContent: !0
        }
      },
      multiple: {
        component: OrgSpinButton,
        className: "spin-button",
        events: {
          increase: (Ue, Re) => {
            $e.value || je(Re);
          },
          decrease: (Ue, Re) => je(Re, !0)
        },
        defaultProps: {
          type: "square"
        }
      }
    })), Ee = computed(() => Me.value[ke.type]);
    function Be(Ue) {
      return ke.items.find((Re) => Re.id === Ue);
    }
    const $e = computed(() => ke.maxSelection <= Fe.value), Le = computed(() => !(ke.minSelection > Fe.value)), Fe = computed(
      () => ke.items.reduce((Ue, Re) => Ue + Re.quantity, 0)
    );
    function Ve(Ue) {
      const Re = Be(Ue);
      return Re && Re.quantity > 0 || ke.type === "radio" ? !1 : $e.value;
    }
    function je(Ue, Re = !1) {
      Se("change", {
        itemId: Ue,
        decrease: Re,
        categoryId: ke.categoryId,
        type: ke.type
      });
    }
    function Ge() {
      Se("validate", { valid: Le.value, categoryId: ke.categoryId });
    }
    function De(Ue) {
      Ve(Ue) || Se("customizeModifier", { itemId: Ue, categoryId: ke.categoryId });
    }
    return (Ue, Re) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$m)())
    }, [
      createVNode(unref(MolCardHeader), {
        subtitle: ke.subtitle,
        title: ke.title,
        "is-required": ke.viewOnly ? !1 : xe.value,
        "has-error": ke.viewOnly ? !1 : !Le.value,
        class: normalizeClass(unref(css$m)("header"))
      }, null, 8, ["subtitle", "title", "is-required", "has-error", "class"]),
      createElementVNode("div", {
        class: normalizeClass(unref(css$m)("content"))
      }, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(ke.items, (Ye) => (openBlock(), createElementBlock("div", {
          id: `${ke.categoryId}-${Ye.id}`,
          key: Ye.id,
          class: normalizeClass([
            unref(css$m)("item-box"),
            { [unref(css$m)("item", "disabled")]: Ve(Ye.id) }
          ])
        }, [
          createElementVNode("div", {
            class: normalizeClass(unref(css$m)("item-content"))
          }, [
            (openBlock(), createBlock(resolveDynamicComponent(ke.viewOnly ? "div" : Ee.value.component), mergeProps({ ref_for: !0 }, {
              ...Ee.value.defaultProps,
              count: Ye.quantity,
              value: Ye.id,
              disabled: Ve(Ye.id),
              ...Ie(Ye.quantity)
            }, {
              class: [unref(css$m)("item"), unref(css$m)("item", Ee.value.className)]
            }, toHandlers(Ee.value.events)), {
              default: withCtx(() => [
                createElementVNode("div", null, [
                  createVNode(unref(AtomText), {
                    tag: "div",
                    color: Ve(Ye.id) ? "color-text-disabled" : "color-text-body"
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(Ye.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["color"]),
                  Ye.price.value > 0 ? (openBlock(), createBlock(unref(AtomText), {
                    key: 0,
                    type: "small",
                    color: Ve(Ye.id) ? "color-text-disabled" : "color-base-40"
                  }, {
                    default: withCtx(() => [
                      Re[0] || (Re[0] = createTextVNode(" + ", -1)),
                      createVNode(unref(_sfc_main$1w), {
                        currency: Ye.price.currency,
                        amount: Ye.price.value
                      }, null, 8, ["currency", "amount"])
                    ]),
                    _: 2
                  }, 1032, ["color"])) : createCommentVNode("", !0)
                ])
              ]),
              _: 2
            }, 1040, ["class"])),
            Ye.hasSubModifiers ? (openBlock(), createElementBlock("a", {
              key: 0,
              href: "",
              class: normalizeClass(unref(css$m)("item-icon-modifiers")),
              onClick: withModifiers((We) => De(Ye.id), ["prevent"])
            }, [
              createVNode(unref(_sfc_main$1Q), {
                "ignore-color": "",
                name: "caret-right-alt"
              })
            ], 10, _hoisted_2$3)) : createCommentVNode("", !0)
          ], 2),
          Ye.cta ? (openBlock(), createBlock(unref(LegacyAtomButton), {
            key: 0,
            wide: "",
            size: "small",
            theme: "simple",
            class: normalizeClass([
              unref(css$m)("cta"),
              { [unref(css$m)("cta", "disabled")]: Ve(Ye.id) },
              { [unref(css$m)("cta", "has-error")]: Ye.cta.hasError }
            ]),
            onClick: withModifiers((We) => De(Ye.id), ["prevent"])
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(Ye.cta.label), 1)
            ]),
            _: 2
          }, 1032, ["class", "onClick"])) : createCommentVNode("", !0)
        ], 10, _hoisted_1$7))), 128))
      ], 2)
    ], 2));
  }
}), OrgModifierGroup = /* @__PURE__ */ _export_sfc(_sfc_main$o, [["__scopeId", "data-v-8fc32cef"]]);
function useOrgModifierGroup() {
  function e(j) {
    return j.items.map((ke) => {
      let Se = ke.quantity;
      return j.type === "radio" && (Se = ke.id === j.itemId ? 1 : 0), j.type === "checkbox" && ke.id === j.itemId && (Se = ke.quantity === 0 ? 1 : 0), j.type === "multiple" && ke.id === j.itemId && (Se = j.decrease ? Se === 0 ? 0 : Se - 1 : Se + 1), {
        ...ke,
        quantity: Se
      };
    });
  }
  return {
    updateItems: e
  };
}
const className$l = "org-navigation", css$l = bemBuilder(className$l);
bemBuilder(className$l, !0);
const _sfc_main$n = /* @__PURE__ */ defineComponent({
  __name: "OrgNavigation",
  props: {
    background: { default: "transparent" },
    cta: {},
    sticky: { type: Boolean, default: !0 }
  },
  emits: ["clickCta"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = computed(() => ke.cta === "back"), Ie = computed(() => ke.cta === "close");
    return (Me, Ee) => withDirectives((openBlock(), createElementBlock("div", {
      class: normalizeClass([unref(css$l)(), unref(css$l)("", ke.background)])
    }, [
      xe.value ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass([unref(css$l)("column")])
      }, [
        createVNode(unref(SatIconButton), {
          "icon-name": "back",
          theme: "ghost",
          variant: "primary",
          onClick: Ee[0] || (Ee[0] = (Be) => Se("clickCta", Be))
        })
      ], 2)) : createCommentVNode("", !0),
      createVNode(unref(AtomText), {
        class: normalizeClass({
          [unref(css$l)("center")]: !0,
          [unref(css$l)("center", "text-left")]: !xe.value,
          [unref(css$l)("center", "right-offset")]: xe.value && !Ie.value
        }),
        type: "subtitle",
        tag: "span"
      }, {
        default: withCtx(() => [
          renderSlot(Me.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["class"]),
      Ie.value ? (openBlock(), createElementBlock("div", {
        key: 1,
        class: normalizeClass([unref(css$l)("column")])
      }, [
        createVNode(unref(SatIconButton), {
          "icon-name": "close",
          theme: "ghost",
          variant: "primary",
          onClick: Ee[1] || (Ee[1] = (Be) => Me.$emit("clickCta", Be))
        })
      ], 2)) : createCommentVNode("", !0)
    ], 2)), [
      [unref(N$1), { zIndex: 10, disabled: !ke.sticky }]
    ]);
  }
}), OrgNavigation = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["__scopeId", "data-v-1ba7b4f0"]]), className$k = "org-loading-modal", css$k = bemBuilder(className$k);
bemBuilder(className$k, !0);
const _sfc_main$m = /* @__PURE__ */ defineComponent({
  __name: "OrgLoadingModal",
  props: {
    primaryText: {},
    secondaryText: {},
    modelValue: { type: Boolean, default: !1 }
  },
  emits: ["close", "update:modelValue"],
  setup(e, { emit: j }) {
    const ke = e, Se = j;
    return (xe, Ie) => (openBlock(), createBlock(unref(MolModal), {
      "model-value": e.modelValue,
      class: normalizeClass(unref(css$k)()),
      "onUpdate:modelValue": Ie[0] || (Ie[0] = (Me) => Se("update:modelValue", Me)),
      onClose: Ie[1] || (Ie[1] = (Me) => Se("close", Me))
    }, {
      default: withCtx(() => [
        createElementVNode("div", {
          class: normalizeClass(unref(css$k)("modal-content"))
        }, [
          createVNode(unref(AtomLoadingSpinner), {
            class: normalizeClass(unref(css$k)("spinner"))
          }, null, 8, ["class"]),
          createVNode(unref(AtomText), {
            type: "h3",
            class: normalizeClass(unref(css$k)("primary-text"))
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(ke.primaryText), 1)
            ]),
            _: 1
          }, 8, ["class"]),
          ke.secondaryText ? (openBlock(), createBlock(unref(AtomText), {
            key: 0,
            type: "body",
            color: "color-base-50",
            class: normalizeClass(unref(css$k)("secondary-text"))
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(ke.secondaryText), 1)
            ]),
            _: 1
          }, 8, ["class"])) : createCommentVNode("", !0)
        ], 2)
      ]),
      _: 1
    }, 8, ["model-value", "class"]));
  }
}), OrgLoadingModal = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["__scopeId", "data-v-59798f52"]]), className$j = "org-message-modal", css$j = bemBuilder(className$j);
bemBuilder(className$j, !0);
const _sfc_main$l = /* @__PURE__ */ defineComponent({
  __name: "OrgMessageModal",
  props: {
    primaryText: {},
    secondaryText: {},
    modelValue: { type: Boolean, default: !1 }
  },
  emits: ["close", "update:modelValue"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = useSlots(), Ie = computed(() => !!xe.default);
    return (Me, Ee) => (openBlock(), createBlock(unref(MolModal), {
      "model-value": e.modelValue,
      class: normalizeClass(unref(css$j)()),
      "onUpdate:modelValue": Ee[0] || (Ee[0] = (Be) => Se("update:modelValue", Be)),
      onClose: Ee[1] || (Ee[1] = (Be) => Se("close", Be))
    }, {
      default: withCtx(() => [
        createVNode(unref(AtomText), {
          type: "h3",
          class: normalizeClass(unref(css$j)("primary-text"))
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.primaryText), 1)
          ]),
          _: 1
        }, 8, ["class"]),
        ke.secondaryText ? (openBlock(), createBlock(unref(AtomText), {
          key: 0,
          color: "color-base-50",
          tag: "div",
          class: normalizeClass(unref(css$j)("secondary-text"))
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.secondaryText), 1)
          ]),
          _: 1
        }, 8, ["class"])) : createCommentVNode("", !0),
        Ie.value ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(unref(css$j)("open-slot"))
        }, [
          renderSlot(Me.$slots, "default", {}, void 0, !0)
        ], 2)) : createCommentVNode("", !0)
      ]),
      _: 3
    }, 8, ["model-value", "class"]));
  }
}), OrgMessageModal = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["__scopeId", "data-v-d806ebae"]]), className$i = "org-tip-picker", css$i = bemBuilder(className$i);
bemBuilder(className$i, !0);
const _hoisted_1$6 = ["onClick"], _sfc_main$k = /* @__PURE__ */ defineComponent({
  __name: "OrgTipPicker",
  props: {
    title: {},
    subtitle: {},
    noTipButtonLabel: {},
    hasError: { type: Boolean, default: !1 },
    billAmount: {},
    selectedAmount: {},
    tipPercentages: { default: () => [0, 5, 10, 15] },
    allowCustom: { type: Boolean },
    customAmountLabel: { default: "Custom amount" }
  },
  emits: ["change"],
  setup(e, { emit: j }) {
    const ke = e, Se = ref(), xe = (je) => {
      Se.value = je;
    }, Ie = ref(!1), Me = ref(ke.billAmount.currency), Ee = j, Be = computed(() => ke.tipPercentages.filter((je) => je > 0).map((je) => ({
      percentage: je,
      amount: {
        value: Math.ceil(ke.billAmount.value * (je / 100)),
        currency: Me.value
      }
    })));
    onBeforeMount(() => {
      if (ke.tipPercentages.some(
        (je) => je < 0 || je > 100
      ))
        throw new Error("OrgTipPicker: Invalid percentage provided");
    });
    const $e = computed(() => ke.hasError ? "color-coral" : null);
    function Le(je) {
      Ie.value = !1, xe(je.value), Ee("change", je);
    }
    function Fe(je) {
      xe(je.value), Ee("change", je);
    }
    function Ve() {
      Fe({ value: 0, currency: Me.value }), Ie.value = !0;
    }
    return (je, Ge) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$i)())
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$i)("header-wrapper"))
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(css$i)("header"))
        }, [
          ke.title ? (openBlock(), createBlock(unref(AtomText), {
            key: 0,
            "data-test": "main-header",
            type: "subtitle",
            color: $e.value || "color-base-20"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(ke.title), 1)
            ]),
            _: 1
          }, 8, ["color"])) : createCommentVNode("", !0),
          createVNode(unref(AtomText), { color: "color-base-50" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(ke.subtitle), 1)
            ]),
            _: 1
          })
        ], 2)
      ], 2),
      createElementVNode("div", {
        class: normalizeClass(unref(css$i)("tip-options"))
      }, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(Be.value, (De) => (openBlock(), createElementBlock("div", {
          key: De.percentage,
          class: normalizeClass([
            unref(css$i)("tip-option-item"),
            {
              [unref(css$i)("tip-option-item", "selected")]: De.amount.value === ke.selectedAmount
            }
          ]),
          onClick: (Ue) => Le(De.amount)
        }, [
          createVNode(unref(AtomText), {
            color: ke.selectedAmount === De.amount.value ? "color-on-primary" : "color-base-20",
            type: "body-bold"
          }, {
            default: withCtx(() => [
              createVNode(unref(_sfc_main$1w), {
                amount: De.amount.value,
                currency: De.amount.currency
              }, null, 8, ["amount", "currency"])
            ]),
            _: 2
          }, 1032, ["color"]),
          createVNode(unref(AtomText), {
            color: ke.selectedAmount === De.amount.value ? "color-on-primary" : "color-base-50",
            type: "small"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(De.percentage) + "%", 1)
            ]),
            _: 2
          }, 1032, ["color"])
        ], 10, _hoisted_1$6))), 128))
      ], 2),
      createElementVNode("div", {
        class: normalizeClass(unref(css$i)("tip-options-bottom"))
      }, [
        ke.tipPercentages.includes(0) ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass([
            unref(css$i)("tip-option-item"),
            unref(css$i)("tip-option-item", "wide"),
            {
              [unref(css$i)("tip-option-item", "selected")]: ke.selectedAmount === 0 && !Ie.value
            }
          ]),
          onClick: Ge[0] || (Ge[0] = (De) => Le({ value: 0, currency: Me.value }))
        }, [
          createVNode(unref(AtomText), {
            color: ke.selectedAmount === 0 && !Ie.value ? "color-on-primary" : "color-base-20",
            type: "body-bold"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(ke.noTipButtonLabel), 1)
            ]),
            _: 1
          }, 8, ["color"])
        ], 2)) : createCommentVNode("", !0),
        ke.allowCustom ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          Ie.value ? (openBlock(), createBlock(unref(AtomInputMoney), {
            key: 0,
            value: {
              value: Se.value ?? 0,
              currency: Me.value
            },
            disabled: !1,
            "has-error": !1,
            "auto-focus": !0,
            onInput: Fe
          }, null, 8, ["value"])) : (openBlock(), createBlock(unref(AtomText), {
            key: 1,
            class: normalizeClass([unref(css$i)("tip-option-item"), unref(css$i)("tip-option-item", "custom")]),
            type: "body-bold",
            tag: "div",
            onClick: Ve
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(ke.customAmountLabel), 1)
            ]),
            _: 1
          }, 8, ["class"]))
        ], 64)) : createCommentVNode("", !0)
      ], 2)
    ], 2));
  }
}), OrgTipPicker = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["__scopeId", "data-v-96daf77f"]]), className$h = "org-rating-form", css$h = bemBuilder(className$h);
bemBuilder(className$h, !0);
const commentLimit = 250, _sfc_main$j = /* @__PURE__ */ defineComponent({
  __name: "OrgRatingForm",
  props: {
    title: {},
    subheader: {},
    hintMessage: {},
    selectOptions: {},
    selectOptionPlaceholder: {},
    ratingMessages: {},
    isLoading: { type: Boolean, default: !1 },
    ctaLabel: {}
  },
  emits: ["selectedRating", "save"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = ref(0), Ie = ref(""), Me = ref(""), Ee = computed(() => Ie.value.trim().length), Be = computed(() => Ee.value > commentLimit), $e = computed(() => commentLimit - Ee.value), Le = (je) => {
      Se("selectedRating", je), xe.value = je;
    }, Fe = (je) => {
      Ie.value = je;
    }, Ve = () => {
      Se("save", {
        rating: xe.value,
        comment: Ie.value,
        option: Me.value
      });
    };
    return (je, Ge) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$h)(""))
    }, [
      createVNode(unref(MolRatingWithStars), {
        title: ke.title,
        selected: xe.value,
        messages: ke.ratingMessages,
        disabled: ke.isLoading,
        onSelect: Le
      }, null, 8, ["title", "selected", "messages", "disabled"]),
      xe.value ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(unref(css$h)("container"))
      }, [
        ke.selectOptions?.length ? (openBlock(), createBlock(unref(SatSelect), {
          key: 0,
          "has-errors": !1,
          "append-to-body": !0,
          disabled: ke.isLoading,
          options: ke.selectOptions,
          placeholder: ke.selectOptionPlaceholder,
          onSelect: Ge[0] || (Ge[0] = (De) => Me.value = De.id)
        }, null, 8, ["disabled", "options", "placeholder"])) : createCommentVNode("", !0),
        createElementVNode("div", null, [
          createVNode(unref(SatFormControl), {
            label: ke.subheader
          }, {
            default: withCtx(() => [
              createVNode(unref(AtomTextarea), {
                rows: 3,
                value: Ie.value,
                "has-error": Be.value,
                disabled: ke.isLoading,
                onKeyup: Fe
              }, null, 8, ["value", "has-error", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          createVNode(unref(AtomText), {
            type: "small",
            class: normalizeClass(unref(css$h)("hint")),
            color: Be.value ? "color-coral" : "color-base-40"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString($e.value) + " " + toDisplayString(ke.hintMessage), 1)
            ]),
            _: 1
          }, 8, ["class", "color"])
        ]),
        createVNode(unref(AtomButton), {
          wide: "",
          size: "large",
          "is-disabled": Be.value,
          "is-loading": ke.isLoading,
          onClick: Ve
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.ctaLabel), 1)
          ]),
          _: 1
        }, 8, ["is-disabled", "is-loading"])
      ], 2)) : createCommentVNode("", !0)
    ], 2));
  }
}), OrgRatingForm = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["__scopeId", "data-v-6ec9608d"]]), className$g = "org-collapsable-order", css$g = bemBuilder(className$g);
bemBuilder(className$g, !0);
const _sfc_main$i = /* @__PURE__ */ defineComponent({
  __name: "OrgCollapsableOrder",
  props: {
    isLoading: { type: Boolean, default: !1 },
    isCollapsed: { type: Boolean, default: !1 },
    text: {},
    orderNumber: {},
    spotName: {},
    createdAt: {},
    status: {},
    details: {}
  },
  emits: ["toggleCollapse"],
  setup(e) {
    const j = e, ke = {
      IN_PROGRESS: "warning",
      REJECTED: "danger",
      OTHER: void 0
    }, Se = computed(() => ke[j.status]), xe = computed(() => j.details ? j.details.items.reduce((Ee, Be) => (Ee += Be.quantity, Be.modifiers?.length && (Ee += Be.modifiers.reduce(($e, Le) => (Le.modifiers?.length && ($e += Le.modifiers.reduce(
      (Fe, Ve) => Fe += Ve.quantity,
      0
    )), $e += Le.quantity), 0)), Ee), 0) * 18 : 0), Ie = computed(() => {
      const Me = j.details?.paymentMethod;
      return Me ? ["apple-pay", "cash", "card-machine", "invoice"].includes(
        Me.type
      ) ? Me.type : Me.type === "card-online" && Me?.cardDetails ? Me?.cardDetails.brand : "paid-online" : "";
    });
    return (Me, Ee) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$g)())
    }, [
      createVNode(unref(AtomCard), null, {
        default: withCtx(() => [
          createElementVNode("div", {
            class: normalizeClass(unref(css$g)("two-column"))
          }, [
            createElementVNode("div", {
              class: normalizeClass(unref(css$g)("stack"))
            }, [
              createVNode(unref(AtomText), { type: "body-bold" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(j.text.order) + " #" + toDisplayString(j.orderNumber), 1)
                ]),
                _: 1
              }),
              createVNode(unref(AtomText), {
                type: "small",
                class: normalizeClass(unref(css$g)("table-name")),
                color: "color-base-40"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(j.spotName) + " • " + toDisplayString(j.createdAt), 1)
                ]),
                _: 1
              }, 8, ["class"]),
              Se.value ? (openBlock(), createBlock(unref(AtomBadge), {
                key: 0,
                class: normalizeClass(unref(css$g)("status-badge")),
                size: "small",
                state: Se.value,
                value: j.text.status
              }, null, 8, ["class", "state", "value"])) : createCommentVNode("", !0)
            ], 2),
            createVNode(unref(MolCollapseIndicator), {
              collapsed: e.isCollapsed,
              onClick: Ee[0] || (Ee[0] = (Be) => Me.$emit("toggleCollapse", j.orderNumber))
            }, null, 8, ["collapsed"])
          ], 2),
          createElementVNode("div", {
            class: normalizeClass(unref(css$g)("collapsable")),
            style: normalizeStyle(
              e.isCollapsed ? { maxHeight: "0px" } : {
                maxHeight: `${j.isLoading ? 65 : 320 + xe.value}px`
              }
            )
          }, [
            j.isLoading ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(unref(css$g)("loader"))
            }, [
              createVNode(unref(AtomLoadingSpinner))
            ], 2)) : createCommentVNode("", !0),
            j.details ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              j.details.items ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass([unref(css$g)("section"), unref(css$g)("section", "gap-14")])
              }, [
                (openBlock(!0), createElementBlock(Fragment, null, renderList(j.details.items, (Be, $e) => (openBlock(), createElementBlock("div", {
                  key: $e,
                  class: normalizeClass(unref(css$g)("two-column"))
                }, [
                  createElementVNode("div", {
                    class: normalizeClass(unref(css$g)("stack"))
                  }, [
                    createVNode(unref(AtomText), { type: "body-bold" }, {
                      default: withCtx(() => [
                        Be.quantity > 1 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                          createTextVNode(toDisplayString(Be.quantity) + " × ", 1)
                        ], 64)) : createCommentVNode("", !0),
                        createTextVNode(" " + toDisplayString(Be.name), 1)
                      ]),
                      _: 2
                    }, 1024),
                    (openBlock(!0), createElementBlock(Fragment, null, renderList(Be.modifiers, (Le, Fe) => (openBlock(), createBlock(unref(AtomText), {
                      key: Fe,
                      color: "color-base-40"
                    }, {
                      default: withCtx(() => [
                        Le.quantity > 1 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                          createTextVNode(toDisplayString(Le.quantity) + " × ", 1)
                        ], 64)) : createCommentVNode("", !0),
                        createTextVNode(" " + toDisplayString(Le.name) + " ", 1),
                        (openBlock(!0), createElementBlock(Fragment, null, renderList(Le.modifiers, (Ve, je) => (openBlock(), createElementBlock("div", {
                          key: je,
                          class: normalizeClass(unref(css$g)("space-left"))
                        }, [
                          Ve.quantity > 1 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                            createTextVNode(toDisplayString(Ve.quantity) + " × ", 1)
                          ], 64)) : createCommentVNode("", !0),
                          createTextVNode(" " + toDisplayString(Ve.name), 1)
                        ], 2))), 128))
                      ]),
                      _: 2
                    }, 1024))), 128))
                  ], 2),
                  createElementVNode("div", null, [
                    createVNode(unref(AtomText), { type: "body-bold" }, {
                      default: withCtx(() => [
                        createVNode(unref(_sfc_main$1w), {
                          amount: Be.totalPrice.value,
                          currency: Be.totalPrice.currency
                        }, null, 8, ["amount", "currency"])
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ], 2))), 128))
              ], 2)) : createCommentVNode("", !0),
              createElementVNode("div", {
                class: normalizeClass([unref(css$g)("section"), unref(css$g)("section", "gap-7")])
              }, [
                createVNode(unref(SatPriceBreakdown), {
                  items: j.details.chargeEntry
                }, null, 8, ["items"])
              ], 2),
              j.details.paymentMethod ? (openBlock(), createElementBlock("div", {
                key: 1,
                class: normalizeClass(unref(css$g)("section"))
              }, [
                createElementVNode("div", {
                  class: normalizeClass(unref(css$g)("two-column"))
                }, [
                  createVNode(unref(AtomText), null, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(j.text.paidWith), 1)
                    ]),
                    _: 1
                  }),
                  createVNode(unref(MolPaymentMethod), {
                    name: Ie.value,
                    last4: j.details.paymentMethod?.cardDetails?.last4
                  }, null, 8, ["name", "last4"])
                ], 2)
              ], 2)) : createCommentVNode("", !0),
              j.text.loyaltyPointsEarned ? (openBlock(), createElementBlock("div", {
                key: 2,
                class: normalizeClass(unref(css$g)("section"))
              }, [
                createElementVNode("div", {
                  class: normalizeClass(unref(css$g)("loyalty-info-wrapper"))
                }, [
                  createVNode(unref(_sfc_main$1Q), {
                    class: normalizeClass(unref(css$g)("loyalty-icon")),
                    color: "color-primary",
                    name: "diamond",
                    size: "medium"
                  }, null, 8, ["class"]),
                  createVNode(unref(AtomText), null, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(j.text.loyaltyPointsEarned), 1)
                    ]),
                    _: 1
                  })
                ], 2)
              ], 2)) : createCommentVNode("", !0)
            ], 64)) : createCommentVNode("", !0)
          ], 6)
        ]),
        _: 1
      })
    ], 2));
  }
}), OrgCollapsableOrder = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["__scopeId", "data-v-a8a4602b"]]), className$f = "org-discount-card", css$f = bemBuilder(className$f);
bemBuilder(className$f, !0);
const _sfc_main$h = /* @__PURE__ */ defineComponent({
  __name: "OrgDiscountCard",
  props: {
    code: {},
    notAppliedLabel: {},
    appliedLabel: {},
    applyCtaLabel: {},
    applyTrayTitle: {},
    applyTrayInputPlaceholder: {},
    isCheckingCode: { type: Boolean },
    errorMessage: {},
    teleportTo: {}
  },
  emits: ["removeCode", "applyDiscount"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, {
      state: xe,
      enable: Ie,
      disable: Me
    } = useTogglable(), Ee = () => {
      ke.code || Ie();
    }, Be = (Fe) => {
      Se("removeCode", Fe);
    }, $e = (Fe) => {
      Se("applyDiscount", Le.value.trim(), Fe);
    };
    watch(
      () => ke.code,
      (Fe, Ve) => {
        !Ve && Fe && (Me(), Le.value = "");
      }
    );
    const Le = ref("");
    return (Fe, Ve) => (openBlock(), createElementBlock("div", {
      class: normalizeClass({
        [unref(css$f)()]: !0,
        [unref(css$f)("", "applied")]: !!ke.code
      }),
      padding: "large",
      onClick: withModifiers(Ee, ["self"])
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$f)("code")),
        onClick: Ee
      }, [
        createVNode(unref(_sfc_main$1Q), {
          name: "discount",
          size: "medium",
          color: "color-primary"
        }),
        ke.code ? (openBlock(), createBlock(unref(AtomText), { key: 0 }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.appliedLabel) + " ", 1),
            createElementVNode("strong", null, toDisplayString(ke.code), 1)
          ]),
          _: 1
        })) : (openBlock(), createBlock(unref(AtomText), { key: 1 }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.notAppliedLabel), 1)
          ]),
          _: 1
        }))
      ], 2),
      ke.code ? (openBlock(), createElementBlock("button", {
        key: 0,
        type: "button",
        class: normalizeClass(unref(css$f)("remove-discount")),
        onClick: Be
      }, [
        createVNode(unref(_sfc_main$1Q), {
          name: "delete",
          color: "color-base-40",
          size: "medium"
        })
      ], 2)) : (openBlock(), createBlock(unref(SatIconButton), {
        key: 1,
        class: normalizeClass(unref(css$f)("expander-icon")),
        "icon-name": "caret-right-alt",
        theme: "ghost",
        variant: "primary",
        size: "extra-small"
      }, null, 8, ["class"])),
      (openBlock(), createBlock(Teleport, {
        to: ke.teleportTo ?? "body"
      }, [
        createVNode(unref(SatDrawer), {
          modelValue: unref(xe),
          "onUpdate:modelValue": Ve[2] || (Ve[2] = (je) => isRef(xe) ? xe.value = je : null),
          "aria-label": "select-discount-drawer",
          "max-width": 460
        }, {
          default: withCtx(() => [
            createElementVNode("div", {
              class: normalizeClass(unref(css$f)("add-discount"))
            }, [
              createElementVNode("div", {
                class: normalizeClass(unref(css$f)("tray-header"))
              }, [
                createVNode(unref(AtomText), { type: "subtitle" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(ke.applyTrayTitle), 1)
                  ]),
                  _: 1
                }),
                createElementVNode("button", {
                  type: "button",
                  class: normalizeClass(unref(css$f)("close-tray")),
                  onClick: Ve[0] || (Ve[0] = //@ts-ignore
                  (...je) => unref(Me) && unref(Me)(...je))
                }, [
                  createVNode(unref(_sfc_main$1Q), {
                    name: "close",
                    color: "color-primary"
                  })
                ], 2)
              ], 2),
              createElementVNode("form", null, [
                createVNode(unref(AtomInput), {
                  placeholder: ke.applyTrayInputPlaceholder,
                  "has-error": !!ke.errorMessage,
                  value: Le.value,
                  onChange: Ve[1] || (Ve[1] = (je) => Le.value = je)
                }, null, 8, ["placeholder", "has-error", "value"]),
                ke.errorMessage ? (openBlock(), createBlock(unref(AtomText), {
                  key: 0,
                  color: "color-coral",
                  class: normalizeClass(unref(css$f)("error-message"))
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(ke.errorMessage), 1)
                  ]),
                  _: 1
                }, 8, ["class"])) : createCommentVNode("", !0),
                createVNode(unref(AtomButton), {
                  class: normalizeClass(unref(css$f)("apply-button")),
                  wide: "",
                  size: "large",
                  type: "submit",
                  "is-loading": ke.isCheckingCode,
                  onClick: withModifiers($e, ["prevent"])
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(ke.applyCtaLabel), 1)
                  ]),
                  _: 1
                }, 8, ["class", "is-loading"])
              ])
            ], 2)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 8, ["to"]))
    ], 2));
  }
}), OrgDiscountCard = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["__scopeId", "data-v-4c46d4ad"]]), className$e = "org-start-tab", css$e = bemBuilder(className$e);
bemBuilder(className$e, !0);
const _sfc_main$g = /* @__PURE__ */ defineComponent({
  __name: "OrgStartTab",
  props: {
    showCloseButton: { type: Boolean, default: !0 },
    customerNamePlaceholder: {},
    customerNameLabel: {},
    customerName: {},
    customerNameError: {},
    isCardRequired: { type: Boolean },
    cardLabel: {},
    cardMessage: {},
    cardError: {},
    checkoutPublicKey: {},
    headline: {},
    title: {},
    cta: {},
    isLoading: { type: Boolean }
  },
  emits: ["start", "close", "card-error"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = ref(ke.customerName), Ie = ref(), Me = ref(!1), Ee = ref(), Be = (je) => {
      Se("close", je);
    }, $e = () => {
      Ee.value ? Ee.value.submitCard() : Se("start", { name: xe.value, card: Ie.value });
    }, Le = (je) => {
      Ie.value = je, Me.value = !1, Se("start", {
        name: xe.value,
        card: Ie.value
      });
    }, Fe = (je) => {
      Se("card-error", je);
    }, Ve = (je) => {
      Me.value = je === "PROCESSING";
    };
    return (je, Ge) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$e)())
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$e)("header"))
      }, [
        createVNode(unref(AtomText), {
          type: "subtitle",
          tag: "div"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.title), 1)
          ]),
          _: 1
        }),
        ke.showCloseButton ? (openBlock(), createElementBlock("button", {
          key: 0,
          type: "button",
          class: normalizeClass(unref(css$e)("close")),
          onClick: Be
        }, [
          createVNode(unref(_sfc_main$1Q), { name: "close" })
        ], 2)) : createCommentVNode("", !0)
      ], 2),
      createVNode(unref(AtomText), {
        class: normalizeClass(unref(css$e)("headline")),
        tag: "div"
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(ke.headline), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      createVNode(unref(SatFormControl), {
        class: normalizeClass(unref(css$e)("name-control")),
        label: ke.customerNameLabel,
        "error-message": ke.customerNameError
      }, {
        default: withCtx(() => [
          createVNode(unref(AtomInput), {
            placeholder: ke.customerNamePlaceholder,
            value: xe.value,
            onChange: Ge[0] || (Ge[0] = (De) => xe.value = De)
          }, null, 8, ["placeholder", "value"])
        ]),
        _: 1
      }, 8, ["class", "label", "error-message"]),
      ke.isCardRequired && ke.checkoutPublicKey ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        createVNode(unref(SatFormControl), {
          class: normalizeClass(unref(css$e)("card-control")),
          label: ke.cardLabel,
          "error-message": ke.cardError
        }, {
          default: withCtx(() => [
            Ie.value ? (openBlock(), createBlock(unref(MolPaymentMethod), {
              key: 1,
              last4: Ie.value.last4,
              class: normalizeClass(unref(css$e)("selected-card")),
              name: Ie.value.scheme.toLowerCase(),
              "change-c-t-a-label": "change",
              "show-change-c-t-a": !0,
              onClick: Ge[1] || (Ge[1] = () => Ie.value = void 0)
            }, null, 8, ["last4", "class", "name"])) : (openBlock(), createBlock(unref(AtomCheckoutDotComCardForm), {
              key: 0,
              ref_key: "checkoutFormEl",
              ref: Ee,
              "public-key": ke.checkoutPublicKey,
              onCardSelected: Le,
              onError: Fe,
              onStatus: Ve
            }, null, 8, ["public-key"]))
          ]),
          _: 1
        }, 8, ["class", "label", "error-message"]),
        createVNode(unref(AtomText), {
          tag: "div",
          color: "color-base-40"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.cardMessage), 1)
          ]),
          _: 1
        })
      ], 64)) : createCommentVNode("", !0),
      createVNode(unref(AtomButton), {
        size: "large",
        class: normalizeClass(unref(css$e)("cta")),
        wide: "",
        "is-loading": ke.isLoading || Me.value,
        onClick: $e
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(ke.cta), 1)
        ]),
        _: 1
      }, 8, ["class", "is-loading"])
    ], 2));
  }
}), OrgStartTab = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["__scopeId", "data-v-730ea3e1"]]), className$d = "org-validate-otp", css$d = bemBuilder(className$d);
bemBuilder(className$d, !0);
const className$c = "atom-button", css$c = bemBuilder(className$c);
bemBuilder(className$c, !0);
const _hoisted_1$5 = ["type", "disabled"], _sfc_main$f = /* @__PURE__ */ defineComponent({
  __name: "AtomButton",
  props: {
    type: { default: "button" },
    size: { default: "medium" },
    theme: { default: "primary" },
    disabled: { type: Boolean, default: !1 },
    isLoading: { type: Boolean, default: !1 },
    wide: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e) {
    const j = e, ke = computed(() => j.type === "link" ? "button" : j.type), Se = computed(() => j.type === "link"), xe = computed(() => defineAsyncComponent(async () => import("./loading-ChaR-xSv.js")));
    return (Ie, Me) => (openBlock(), createElementBlock("button", {
      type: ke.value,
      disabled: j.disabled || j.isLoading,
      class: normalizeClass([
        unref(css$c)(),
        unref(css$c)("", j.theme),
        Se.value ? "" : unref(css$c)("", j.size),
        j.wide ? unref(css$c)("", "wide") : "",
        Se.value ? unref(css$c)("", "link") : ""
      ]),
      onClick: Me[0] || (Me[0] = withModifiers((Ee) => Ie.$emit("click", Ee), ["prevent"]))
    }, [
      j.isLoading ? (openBlock(), createElementBlock("span", {
        key: 0,
        class: normalizeClass(unref(css$c)("loading"))
      }, [
        (openBlock(), createBlock(resolveDynamicComponent(xe.value)))
      ], 2)) : renderSlot(Ie.$slots, "default", { key: 1 }, void 0, !0)
    ], 10, _hoisted_1$5));
  }
}), LegacyAtomButton = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["__scopeId", "data-v-a0d00302"]]), _hoisted_1$4 = { key: 0 }, _hoisted_2$2 = { key: 0 }, _hoisted_3 = { key: 1 }, intervalId = null, _sfc_main$e = /* @__PURE__ */ defineComponent({
  __name: "OrgValidateOtp",
  props: {
    title: {},
    headline: {},
    phoneNumber: {},
    resendMessage: {},
    resendThrottleSec: {},
    isLoading: { type: Boolean },
    errorMessage: {},
    otpLength: {},
    cta: {},
    showCloseButton: { type: Boolean, default: !0 },
    optionsSubtitle: {},
    resendOptions: {},
    resendCta: {}
  },
  emits: ["input", "validate", "resendTrough", "resend", "close"],
  setup(e, { emit: j }) {
    const ke = e, Se = ref(ke.resendThrottleSec), xe = computed(() => ke.resendOptions && ke.resendOptions.length > 0), Ie = j, Me = computed(() => ke.headline.split("##")), Ee = computed(() => ke.headline.includes("##")), Be = ref(""), $e = ref({
      pinCode: "",
      isValid: !1
    }), Le = ref(!1), Fe = (We) => {
      Ie("close", We);
    }, Ve = (We) => {
      Re.value && (xe.value ? Le.value = !0 : Ie("resend", We));
    }, je = () => {
      Ie("resendTrough", Be.value), Le.value = !1, Se.value = ke.resendThrottleSec, Ye(intervalId, Se);
    }, Ge = (We) => {
      Be.value = We;
    }, De = (We) => {
      $e.value = We, Ie("input", $e.value);
    }, Ue = () => {
      Ie("validate", $e.value);
    }, Re = computed(() => Se.value === 0), Ye = (We, qe) => {
      We = setInterval(() => {
        qe.value > 0 && qe.value--, qe.value === 0 && We && clearInterval(We);
      }, 1e3);
    };
    return onMounted(() => {
      Ye(intervalId, Se);
    }), onUnmounted(() => {
    }), (We, qe) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$d)())
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$d)("header"))
      }, [
        createVNode(unref(AtomText), {
          type: "subtitle",
          tag: "div"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.title), 1)
          ]),
          _: 1
        }),
        ke.showCloseButton ? (openBlock(), createElementBlock("button", {
          key: 0,
          type: "button",
          class: normalizeClass(unref(css$d)("close")),
          onClick: Fe
        }, [
          createVNode(unref(_sfc_main$1Q), { name: "close" })
        ], 2)) : createCommentVNode("", !0)
      ], 2),
      createVNode(unref(AtomText), {
        class: normalizeClass(unref(css$d)("headline")),
        tag: "div"
      }, {
        default: withCtx(() => [
          Ee.value ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            createElementVNode("span", null, toDisplayString(Me.value[0]), 1),
            createElementVNode("strong", null, toDisplayString(ke.phoneNumber), 1),
            createElementVNode("span", null, toDisplayString(Me.value[1]), 1)
          ], 64)) : (openBlock(), createElementBlock("span", _hoisted_1$4, toDisplayString(ke.headline), 1))
        ]),
        _: 1
      }, 8, ["class"]),
      createVNode(unref(SatFormControl), {
        "error-message": ke.errorMessage,
        class: normalizeClass(unref(css$d)("input-control"))
      }, {
        default: withCtx(() => [
          createVNode(unref(AtomInputPinCode), {
            "field-count": ke.otpLength,
            invalid: !!ke.errorMessage,
            disabled: !1,
            class: normalizeClass(unref(css$d)("input")),
            onValidate: De,
            onKeydown: withKeys(Ue, ["enter"])
          }, null, 8, ["field-count", "invalid", "class"])
        ]),
        _: 1
      }, 8, ["error-message", "class"]),
      Le.value ? createCommentVNode("", !0) : (openBlock(), createBlock(unref(LegacyAtomButton), {
        key: 0,
        type: "link",
        class: normalizeClass(unref(css$d)("resend-link")),
        wide: "",
        disabled: !Re.value,
        onClick: withModifiers(Ve, ["prevent"])
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(ke.resendMessage) + " ", 1),
          Re.value ? createCommentVNode("", !0) : (openBlock(), createElementBlock("span", _hoisted_2$2, "•")),
          Re.value ? createCommentVNode("", !0) : (openBlock(), createElementBlock("span", _hoisted_3, toDisplayString(Se.value), 1))
        ]),
        _: 1
      }, 8, ["class", "disabled"])),
      Le.value ? (openBlock(), createElementBlock("div", {
        key: 1,
        class: normalizeClass(unref(css$d)("resend-box"))
      }, [
        ke.optionsSubtitle ? (openBlock(), createBlock(unref(AtomText), {
          key: 0,
          type: "subtitle",
          color: "color-base-20"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.optionsSubtitle), 1)
          ]),
          _: 1
        })) : createCommentVNode("", !0),
        (openBlock(!0), createElementBlock(Fragment, null, renderList(ke.resendOptions, (Je) => (openBlock(), createElementBlock("div", {
          key: Je.key,
          class: normalizeClass(unref(css$d)("resend-otp-item"))
        }, [
          createElementVNode("label", {
            name: "resend-otp",
            class: normalizeClass(unref(css$d)("resend-otp-label"))
          }, [
            createVNode(unref(AtomRadio), {
              name: "resend-otp",
              value: Je.key,
              checked: Be.value === Je.key,
              onChange: Ge
            }, {
              default: withCtx(() => [
                createVNode(unref(AtomText), {
                  type: "body",
                  color: "color-base-20"
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(Je.text), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["value", "checked"]),
            createVNode(unref(AtomText), {
              color: "color-base-40",
              type: "small"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(Je.subText), 1)
              ]),
              _: 2
            }, 1024)
          ], 2)
        ], 2))), 128))
      ], 2)) : createCommentVNode("", !0),
      Le.value ? (openBlock(), createBlock(unref(AtomButton), {
        key: 2,
        size: "large",
        wide: "",
        "data-test": "resend-otp",
        "is-loading": ke.isLoading,
        onClick: je
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(ke.resendCta), 1)
        ]),
        _: 1
      }, 8, ["is-loading"])) : (openBlock(), createBlock(unref(AtomButton), {
        key: 3,
        size: "large",
        wide: "",
        "data-test": "validate-cta",
        "is-loading": ke.isLoading,
        "is-disabled": !$e.value.isValid,
        onClick: Ue
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(ke.cta), 1)
        ]),
        _: 1
      }, 8, ["is-loading", "is-disabled"]))
    ], 2));
  }
}), OrgValidateOtp = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["__scopeId", "data-v-62d73287"]]), className$b = "org-join-tab", css$b = bemBuilder(className$b);
bemBuilder(className$b, !0);
const _sfc_main$d = /* @__PURE__ */ defineComponent({
  __name: "OrgJoinTab",
  props: {
    customerName: {},
    showCloseButton: { type: Boolean, default: !0 },
    customerNamePlaceholder: {},
    customerNameLabel: {},
    customerNameError: {},
    headline: {},
    title: {},
    cta: {},
    isLoading: { type: Boolean }
  },
  emits: ["close", "join"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = ref(ke.customerName), Ie = (Ee) => {
      Se("close", Ee);
    }, Me = () => {
      Se("join", xe.value);
    };
    return (Ee, Be) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$b)())
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$b)("header"))
      }, [
        createVNode(unref(AtomText), {
          type: "subtitle",
          tag: "div"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.title), 1)
          ]),
          _: 1
        }),
        ke.showCloseButton ? (openBlock(), createElementBlock("button", {
          key: 0,
          type: "button",
          class: normalizeClass(unref(css$b)("close")),
          onClick: Ie
        }, [
          createVNode(unref(_sfc_main$1Q), { name: "close" })
        ], 2)) : createCommentVNode("", !0)
      ], 2),
      createVNode(unref(AtomText), {
        class: normalizeClass(unref(css$b)("headline")),
        tag: "div"
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(ke.headline), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      createVNode(unref(SatFormControl), {
        class: normalizeClass(unref(css$b)("name-control")),
        label: ke.customerNameLabel,
        "error-message": ke.customerNameError
      }, {
        default: withCtx(() => [
          createVNode(unref(AtomInput), {
            placeholder: ke.customerNamePlaceholder,
            value: xe.value,
            onChange: Be[0] || (Be[0] = ($e) => xe.value = $e)
          }, null, 8, ["placeholder", "value"])
        ]),
        _: 1
      }, 8, ["class", "label", "error-message"]),
      createVNode(unref(AtomButton), {
        size: "large",
        class: normalizeClass(unref(css$b)("cta")),
        wide: "",
        "is-loading": ke.isLoading,
        onClick: Me
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(ke.cta), 1)
        ]),
        _: 1
      }, 8, ["class", "is-loading"])
    ], 2));
  }
}), OrgJoinTab = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["__scopeId", "data-v-e84c70e8"]]), className$a = "org-request-otp", css$a = bemBuilder(className$a);
bemBuilder(className$a, !0);
const _sfc_main$c = /* @__PURE__ */ defineComponent({
  __name: "OrgRequestOtp",
  props: {
    country: {},
    title: {},
    headline: {},
    cta: {},
    isLoading: { type: Boolean },
    errorMessage: {},
    showCloseButton: { type: Boolean, default: !0 },
    defaultPhoneNumber: { default: "" }
  },
  emits: ["request", "close"],
  setup(e, { emit: j }) {
    const ke = e, Se = ref({
      countryCode: 0,
      isValid: !1,
      number: ke.defaultPhoneNumber
    }), xe = j, Ie = (Ee) => {
      xe("close", Ee);
    }, Me = () => {
      xe("request", Se.value);
    };
    return (Ee, Be) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$a)())
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$a)("header"))
      }, [
        createVNode(unref(AtomText), {
          type: "subtitle",
          tag: "div"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.title), 1)
          ]),
          _: 1
        }),
        ke.showCloseButton ? (openBlock(), createElementBlock("button", {
          key: 0,
          type: "button",
          class: normalizeClass(unref(css$a)("close")),
          onClick: Ie
        }, [
          createVNode(unref(_sfc_main$1Q), { name: "close" })
        ], 2)) : createCommentVNode("", !0)
      ], 2),
      createVNode(unref(AtomText), { tag: "div" }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(ke.headline), 1)
        ]),
        _: 1
      }),
      createVNode(unref(SatFormControl), {
        "error-message": ke.errorMessage,
        class: normalizeClass(unref(css$a)("input-control"))
      }, {
        default: withCtx(() => [
          createVNode(unref(AtomInputPhoneNumber), {
            country: ke.country,
            number: Se.value.number,
            onInput: Be[0] || (Be[0] = ($e) => Se.value = $e),
            onKeypress: withKeys(Me, ["enter"])
          }, null, 8, ["country", "number"])
        ]),
        _: 1
      }, 8, ["error-message", "class"]),
      createVNode(unref(AtomButton), {
        size: "large",
        wide: "",
        "is-loading": ke.isLoading,
        onClick: Me
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(ke.cta), 1)
        ]),
        _: 1
      }, 8, ["is-loading"])
    ], 2));
  }
}), OrgRequestOtp = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["__scopeId", "data-v-491a3418"]]), className$9 = "org-signup-form", css$9 = bemBuilder(className$9);
bemBuilder(className$9, !0);
const _sfc_main$b = /* @__PURE__ */ defineComponent({
  __name: "OrgSignupForm",
  props: /* @__PURE__ */ mergeModels({
    country: {},
    title: {},
    headline: {},
    cta: {},
    isLoading: { type: Boolean },
    nameFieldLabel: {},
    phoneFieldLabel: {},
    acceptsTermsConditionsLabel: {},
    acceptsMarketingCommunicationsLabel: {},
    errors: {},
    showCloseButton: { type: Boolean, default: !0 }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ mergeModels(["submit", "close"], ["update:modelValue"]),
  setup(e, { emit: j }) {
    const ke = e, Se = useModel(e, "modelValue"), xe = useSlots(), Ie = computed(() => !!xe.tcs), Me = (Le) => {
      Se.value.phoneNumber = {
        isValid: Le.isValid,
        countryCode: Le.countryCode,
        number: Le.number ? +Le.number.replace(/\D+/g, "") : void 0
      };
    }, Ee = j, Be = (Le) => {
      Ee("close", Le);
    }, $e = () => {
      Ee("submit", Se.value);
    };
    return (Le, Fe) => (openBlock(), createElementBlock("form", {
      class: normalizeClass(unref(css$9)()),
      onSubmit: withModifiers($e, ["prevent"])
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$9)("header"))
      }, [
        createVNode(unref(AtomText), {
          type: "subtitle",
          tag: "div"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.title), 1)
          ]),
          _: 1
        }),
        ke.showCloseButton ? (openBlock(), createElementBlock("button", {
          key: 0,
          type: "button",
          class: normalizeClass(unref(css$9)("close")),
          onClick: Be
        }, [
          createVNode(unref(_sfc_main$1Q), { name: "close" })
        ], 2)) : createCommentVNode("", !0)
      ], 2),
      createVNode(unref(AtomText), { tag: "div" }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(ke.headline), 1)
        ]),
        _: 1
      }),
      createVNode(unref(SatFormControl), {
        "error-message": ke.errors.name,
        class: normalizeClass(unref(css$9)("input-control")),
        label: ke.nameFieldLabel
      }, {
        default: withCtx(() => [
          createVNode(unref(AtomInput), {
            "has-error": !!ke.errors.name,
            value: Se.value.name,
            onChange: Fe[0] || (Fe[0] = (Ve) => Se.value.name = Ve)
          }, null, 8, ["has-error", "value"])
        ]),
        _: 1
      }, 8, ["error-message", "class", "label"]),
      createVNode(unref(SatFormControl), {
        "error-message": ke.errors.phoneNumber,
        class: normalizeClass(unref(css$9)("input-control")),
        label: ke.phoneFieldLabel
      }, {
        default: withCtx(() => [
          createVNode(unref(AtomInputPhoneNumber), {
            country: ke.country,
            number: Se.value.phoneNumber.number?.toString() ?? "",
            "has-error": !!ke.errors.phoneNumber,
            onInput: Me,
            onKeypress: withKeys($e, ["enter"])
          }, null, 8, ["country", "number", "has-error"])
        ]),
        _: 1
      }, 8, ["error-message", "class", "label"]),
      createElementVNode("div", {
        class: normalizeClass(unref(css$9)("terms-box"))
      }, [
        createVNode(unref(SatFormControl), {
          "error-message": ke.errors.acceptsTermsConditions
        }, {
          default: withCtx(() => [
            createVNode(unref(AtomCheckbox), {
              class: normalizeClass(unref(css$9)("terms-condition")),
              checked: Se.value.acceptsTermsConditions,
              onChange: Fe[1] || (Fe[1] = (Ve) => Se.value.acceptsTermsConditions = Ve)
            }, {
              default: withCtx(() => [
                Ie.value ? (openBlock(), createBlock(resolveDynamicComponent(unref(xe).tcs), { key: 0 })) : (openBlock(), createBlock(unref(AtomText), {
                  key: 1,
                  type: "body",
                  color: "color-base-40"
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(ke.acceptsTermsConditionsLabel), 1)
                  ]),
                  _: 1
                }))
              ]),
              _: 1
            }, 8, ["class", "checked"])
          ]),
          _: 1
        }, 8, ["error-message"]),
        createVNode(unref(SatFormControl), {
          "error-message": ke.errors.acceptsMarketingCommunications
        }, {
          default: withCtx(() => [
            createVNode(unref(AtomCheckbox), {
              class: normalizeClass(unref(css$9)("marketing-preferences")),
              checked: Se.value.acceptsMarketingCommunications,
              onChange: Fe[2] || (Fe[2] = (Ve) => Se.value.acceptsMarketingCommunications = Ve)
            }, {
              default: withCtx(() => [
                createVNode(unref(AtomText), {
                  type: "body",
                  color: "color-base-40"
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(ke.acceptsMarketingCommunicationsLabel), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["class", "checked"])
          ]),
          _: 1
        }, 8, ["error-message"])
      ], 2),
      createVNode(unref(AtomButton), {
        size: "large",
        wide: "",
        "is-loading": ke.isLoading,
        type: "submit",
        onClick: $e
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(ke.cta), 1)
        ]),
        _: 1
      }, 8, ["is-loading"])
    ], 34));
  }
}), OrgSignupForm = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["__scopeId", "data-v-bd3cafd5"]]), className$8 = "tpt-checkout-basket", css$8 = bemBuilder(className$8);
bemBuilder(className$8, !0);
const _sfc_main$a = /* @__PURE__ */ defineComponent({
  __name: "TptCheckoutBasket",
  props: {
    title: {},
    items: {},
    totals: {},
    noteLabel: { default: "note" }
  },
  emits: ["increaseItem", "decreaseItem", "clearItem", "basketEmptied"],
  setup(e, { emit: j }) {
    const ke = e, Se = j;
    function xe(Ie) {
      Se("clearItem", Ie), ke.items.reduce(
        (Ee, Be) => Be.quantity + Ee,
        0
      ) <= 1 && ke.items.length <= 2 && Se("basketEmptied");
    }
    return (Ie, Me) => (openBlock(), createBlock(unref(AtomCard), {
      padding: "large",
      class: normalizeClass(unref(css$8)())
    }, {
      default: withCtx(() => [
        createVNode(unref(AtomText), {
          tag: "h2",
          type: "subtitle",
          class: normalizeClass(unref(css$8)("name"))
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.title), 1)
          ]),
          _: 1
        }, 8, ["class"]),
        createElementVNode("ul", {
          class: normalizeClass(unref(css$8)("list"))
        }, [
          (openBlock(!0), createElementBlock(Fragment, null, renderList(ke.items, (Ee) => (openBlock(), createElementBlock("li", {
            key: Ee.id,
            class: normalizeClass(unref(css$8)("list-item"))
          }, [
            createElementVNode("div", null, [
              createVNode(unref(AtomText), {
                type: "body-bold",
                tag: "div",
                class: normalizeClass(unref(css$8)("list-name"))
              }, {
                default: withCtx(() => [
                  Ee.quantity > 1 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                    createTextVNode(toDisplayString(Ee.quantity) + " × ", 1)
                  ], 64)) : createCommentVNode("", !0),
                  createTextVNode(" " + toDisplayString(Ee.name), 1)
                ]),
                _: 2
              }, 1032, ["class"]),
              (openBlock(!0), createElementBlock(Fragment, null, renderList(Ee.modifiers, (Be) => (openBlock(), createBlock(unref(AtomText), {
                key: Be.id,
                class: normalizeClass(unref(css$8)("modifier-name")),
                color: "color-base-40",
                tag: "div"
              }, {
                default: withCtx(() => [
                  createElementVNode("div", null, [
                    Be.quantity > 1 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                      createTextVNode(toDisplayString(Be.quantity) + " × ", 1)
                    ], 64)) : createCommentVNode("", !0),
                    createTextVNode(" " + toDisplayString(Be.name) + " ", 1),
                    (openBlock(!0), createElementBlock(Fragment, null, renderList(Be.modifiers, ($e) => (openBlock(), createElementBlock("div", {
                      key: $e.id,
                      class: normalizeClass(unref(css$8)("modifier-combo"))
                    }, [
                      $e.quantity > 1 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                        createTextVNode(toDisplayString($e.quantity) + " × ", 1)
                      ], 64)) : createCommentVNode("", !0),
                      createTextVNode(" " + toDisplayString($e.name), 1)
                    ], 2))), 128))
                  ])
                ]),
                _: 2
              }, 1032, ["class"]))), 128)),
              Ee.note ? (openBlock(), createBlock(unref(AtomText), {
                key: 0,
                class: normalizeClass(unref(css$8)("note")),
                color: "color-base-40",
                tag: "div"
              }, {
                default: withCtx(() => [
                  createElementVNode("strong", null, toDisplayString(ke.noteLabel) + ":", 1),
                  createTextVNode(" " + toDisplayString(Ee.note), 1)
                ]),
                _: 2
              }, 1032, ["class"])) : createCommentVNode("", !0),
              createVNode(unref(AtomText), {
                class: normalizeClass(unref(css$8)("list-price")),
                tag: "div",
                color: "color-base-20"
              }, {
                default: withCtx(() => [
                  createVNode(unref(_sfc_main$1w), {
                    amount: Ee.price.value,
                    currency: Ee.price.currency
                  }, null, 8, ["amount", "currency"])
                ]),
                _: 2
              }, 1032, ["class"])
            ]),
            createVNode(unref(OrgSpinButton), {
              type: "square",
              value: Ee.id,
              class: normalizeClass(unref(css$8)("spin-button")),
              count: Ee.quantity,
              onIncrease: (Be) => Se("increaseItem", Ee.id),
              onDecrease: (Be) => Se("decreaseItem", Ee.id),
              onCleared: (Be) => xe(Ee.id)
            }, null, 8, ["value", "class", "count", "onIncrease", "onDecrease", "onCleared"])
          ], 2))), 128))
        ], 2),
        ke.totals.length ? (openBlock(), createBlock(unref(SatPriceBreakdown), {
          key: 0,
          class: normalizeClass(unref(css$8)("totals")),
          items: ke.totals
        }, null, 8, ["class", "items"])) : createCommentVNode("", !0)
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), TptCheckoutBasket = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["__scopeId", "data-v-581ce152"]]), className$7 = "tpt-menu-category", css$7 = bemBuilder(className$7);
bemBuilder(className$7, !0);
const _hoisted_1$3 = ["href", "onClick"], _sfc_main$9 = /* @__PURE__ */ defineComponent({
  __name: "TptMenuCategory",
  props: {
    name: {},
    description: {},
    items: {},
    isGridLayout: { type: Boolean },
    viewOnly: { type: Boolean, default: !1 },
    viewType: { default: "chiclets" },
    isDisabled: { type: Boolean }
  },
  emits: ["increaseItem", "decreaseItem", "clearItem", "clickItem"],
  setup(e, { emit: j }) {
    const ke = e, Se = (Me) => Me && !ke.viewOnly, xe = j, Ie = (Me, Ee, Be) => {
      Be && xe("clickItem", Ee, Me);
    };
    return (Me, Ee) => (openBlock(), createElementBlock("div", {
      class: normalizeClass([
        unref(css$7)(),
        unref(css$7)("", ke.viewType),
        unref(css$7)("", ke.isGridLayout ? "grid" : "row")
      ])
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$7)("header"))
      }, [
        createVNode(unref(AtomText), {
          type: "h2",
          color: "color-text-headline"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.name), 1)
          ]),
          _: 1
        }),
        ke.description ? (openBlock(), createBlock(unref(AtomText), {
          key: 0,
          color: "color-text-secondary"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.description), 1)
          ]),
          _: 1
        })) : createCommentVNode("", !0)
      ], 2),
      createElementVNode("ul", {
        class: normalizeClass(unref(css$7)("list"))
      }, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(ke.items, (Be) => (openBlock(), createElementBlock("li", {
          key: Be.id,
          class: normalizeClass(unref(css$7)("list-item"))
        }, [
          createElementVNode("a", {
            href: Be.link,
            class: normalizeClass([unref(css$7)("link"), { [unref(css$7)("link", "disabled")]: !Be.inStock }]),
            onClick: withModifiers(
              ($e) => Ie($e, Be.id, Be.inStock),
              ["prevent"]
            )
          }, [
            createVNode(unref(SatItemDisplay), {
              id: Be.id,
              class: normalizeClass(unref(css$7)("item")),
              name: Be.name,
              description: Be.description,
              amount: Be.price,
              "original-amount": Be.originalPrice,
              photo: Be.photo,
              "custom-price-label": Be.customPriceLabel,
              "is-disabled": !Be.inStock,
              view: ke.isGridLayout ? "row" : "col",
              "has-allergen-items": Be.hasAllergenItems,
              consumables: Be.consumables
            }, {
              afterImage: withCtx(() => [
                Se(Be.inStock) ? (openBlock(), createBlock(unref(SatQuickAddButton), {
                  key: 0,
                  value: Be.id,
                  disabled: ke.isDisabled,
                  class: normalizeClass([
                    unref(css$7)("spin-button"),
                    !Be.photo && !ke.isGridLayout ? unref(css$7)("spin-button", "no-img") : ""
                  ]),
                  count: Be.amount,
                  onClick: Ee[0] || (Ee[0] = withModifiers(() => {
                  }, ["stop"])),
                  onIncrease: ($e) => xe("increaseItem", Be.id),
                  onDecrease: ($e) => xe("decreaseItem", Be.id),
                  onCleared: ($e) => xe("clearItem", Be.id)
                }, null, 8, ["value", "disabled", "class", "count", "onIncrease", "onDecrease", "onCleared"])) : createCommentVNode("", !0)
              ]),
              _: 2
            }, 1032, ["id", "class", "name", "description", "amount", "original-amount", "photo", "custom-price-label", "is-disabled", "view", "has-allergen-items", "consumables"])
          ], 10, _hoisted_1$3)
        ], 2))), 128))
      ], 2)
    ], 2));
  }
}), TptMenuCategory = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["__scopeId", "data-v-9899b520"]]), className$6 = "tpt-payment-tray", css$6 = bemBuilder(className$6);
bemBuilder(className$6, !0);
const useCash = (e) => {
  const j = {
    type: "cash",
    name: "cash"
  };
  return {
    isCashSelected: computed(() => e.value?.type === "cash"),
    onSelectCash: () => {
      e.value = j;
    }
  };
}, useInvoice = (e) => {
  const j = {
    type: "invoice",
    name: "invoice"
  };
  return {
    isInvoiceSelected: computed(
      () => e.value?.type === "invoice"
    ),
    onSelectInvoice: () => {
      e.value = j;
    }
  };
}, useApplePay = (e) => {
  const j = {
    type: "apple_pay",
    name: "apple-pay"
  };
  return {
    isApplePaySelected: computed(
      () => e.value?.type === "apple_pay"
    ),
    onSelectApplePay: () => {
      e.value = j;
    }
  };
}, useCardMachine = (e) => {
  const j = {
    type: "card_machine",
    name: "card-machine"
  };
  return {
    isCardMachineSelected: computed(
      () => e.value?.type === "card_machine"
    ),
    onSelectCardMachine: () => {
      e.value = j;
    }
  };
}, useAddToTab = (e) => {
  const j = {
    type: "add_to_tab",
    name: "add-to-tab"
  };
  return {
    isAddToTabSelected: computed(
      () => e.value?.type === "add_to_tab"
    ),
    onSelectAddToTab: () => {
      e.value = j;
    }
  };
}, useCardOnline = (e, j) => {
  const ke = ref([]), Se = computed(() => j ? j.map(($e) => ({
    type: "existing",
    id: $e.id,
    name: $e.name,
    last4: $e.last4
  })) : []), xe = computed(() => [...Se.value, ...ke.value]), Ie = ($e) => e.value ? $e.type === "existing" && "id" in e.value ? e.value.id === $e.id : $e.type === "new" && "token" in e.value ? e.value.token === $e.token : !1 : !1, Me = ($e) => {
    e.value = $e;
  };
  return {
    isCardSelected: Ie,
    allCards: xe,
    onSelectMostRecentCard: ($e) => {
      if ($e.length === 0)
        throw new Error(
          "Can't find recent card due to an empty cards list given."
        );
      const Fe = $e.sort(
        (Ve, je) => Number(je.lastUsedAt) - Number(Ve.lastUsedAt)
      )[0];
      Me({
        type: "existing",
        ...Fe
      });
    },
    onSelectCard: Me,
    onSelectNewCard: ($e) => {
      const Le = {
        type: "new",
        name: $e.scheme.toLocaleLowerCase(),
        expiryMonth: $e.expiryMonth.toString(),
        expiryYear: $e.expiryYear.toString(),
        last4: $e.last4,
        token: $e.token
      };
      ke.value.push(Le), e.value = Le;
    }
  };
}, useSkipCash = (e) => {
  const j = {
    type: "skipcash",
    name: "skipcash"
  };
  return {
    isSkipCashSelected: computed(
      () => e.value?.type === "skipcash"
    ),
    onSelectSkipCash: () => {
      e.value = j;
    }
  };
}, useDeliverectPay = (e, j) => {
  const ke = computed(
    () => j ? j.map((Ie) => ({
      type: "deliverect_pay",
      ...Ie
    })) : []
  );
  return {
    onSelectDeliverectPay: (Ie) => {
      e.value = Ie;
    },
    isDeliverectPaySelected: (Ie) => e.value && Ie.type === "deliverect_pay" && "id" in e.value ? e.value.id === Ie.id : !1,
    allDeliverectPayMethods: ke
  };
}, _hoisted_1$2 = {
  key: 2,
  "data-test": "methods-list"
}, _hoisted_2$1 = {
  key: 3,
  "data-test": "new-card"
}, _sfc_main$8 = /* @__PURE__ */ defineComponent({
  __name: "TptPaymentTray",
  props: {
    total: {},
    acceptApplePay: { type: Boolean },
    acceptTab: { type: Boolean },
    acceptCash: { type: Boolean },
    acceptCardMachine: { type: Boolean },
    acceptInvoice: { type: Boolean },
    acceptCardOnline: { type: Boolean },
    acceptSkipCash: { type: Boolean },
    acceptDeliverectPay: { type: Boolean },
    deliverectPayMethods: {},
    keepScrollBottom: { type: Boolean, default: !1 },
    keepFocusOnSelected: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    gatewayKey: {},
    userCards: {},
    cardMachineLabel: {},
    cashLabel: {},
    addToTab: {},
    invoice: {},
    invoiceLabel: {},
    invalidCardMessage: {},
    overflowOptionsIn: { default: 4 },
    title: {},
    changeMethodLabel: {},
    addCardLabel: {},
    totalLabel: {},
    applePayPrefix: {},
    payLabel: {},
    addToTabLabel: {}
  },
  emits: ["pay", "error", "select"],
  setup(e, { emit: j }) {
    useCssVars((Rt) => ({
      v9430ab7e: zt.value
    }));
    const ke = e, Se = j, xe = ref("new-card"), Ie = ref(!1), Me = ref(), Ee = {
      cardMachine: ke.cardMachineLabel ?? "Card machine",
      cash: ke.cashLabel ?? "Cash",
      addToTab: ke.addToTab ?? "Add to tab",
      invoice: ke.invoice ?? "Invoice",
      skipcash: "SkipCash"
    }, { isCashSelected: Be, onSelectCash: $e } = useCash(Me), { isInvoiceSelected: Le, onSelectInvoice: Fe } = useInvoice(Me), { isApplePaySelected: Ve, onSelectApplePay: je } = useApplePay(Me), { isCardMachineSelected: Ge, onSelectCardMachine: De } = useCardMachine(Me), { isAddToTabSelected: Ue, onSelectAddToTab: Re } = useAddToTab(Me), { isSkipCashSelected: Ye, onSelectSkipCash: We } = useSkipCash(Me), {
      isCardSelected: qe,
      allCards: Je,
      onSelectCard: Ke,
      onSelectMostRecentCard: xt,
      onSelectNewCard: Ct
    } = useCardOnline(Me, ke.userCards), {
      isDeliverectPaySelected: It,
      allDeliverectPayMethods: Nt,
      onSelectDeliverectPay: Bt
    } = useDeliverectPay(Me, ke.deliverectPayMethods);
    watch(
      () => ke.userCards,
      (Rt) => {
        if (!Me.value) {
          if (ke.acceptTab) {
            Re(), xe.value = "selected-method";
            return;
          }
          if (ke.acceptApplePay) {
            je(), xe.value = "selected-method";
            return;
          }
          if (!ke.acceptCardOnline) {
            ke.acceptSkipCash ? (We(), xe.value = "selected-method") : ke.acceptCardMachine ? (De(), xe.value = "selected-method") : ke.acceptCash ? ($e(), xe.value = "selected-method") : xe.value = "methods-list";
            return;
          }
          if (!Rt || Rt.length === 0) {
            xe.value = "new-card";
            return;
          }
          try {
            xt(Rt), xe.value = "selected-method";
          } catch (jt) {
            throw xe.value = "new-card", jt;
          }
        }
      },
      { immediate: !0 }
    ), watch(
      () => Me.value,
      (Rt) => {
        Rt && Se("select", Rt);
      },
      {
        immediate: !0
      }
    );
    const At = (Rt) => {
      xe.value = Rt, Wt.value = "", ke.keepScrollBottom && nextTick(() => {
        window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
      });
    }, Ft = computed(() => Ue.value ? ke.addToTabLabel : ke.payLabel), Dt = computed(() => {
      let Rt = ke.userCards?.length ?? 0;
      const jt = 49;
      ke.acceptCardOnline || (Rt = 0), ke.acceptApplePay && Rt++, ke.acceptCardMachine && Rt++, ke.acceptCash && Rt++, ke.acceptTab && Rt++, ke.acceptSkipCash && Rt++, ke.acceptDeliverectPay && ke.deliverectPayMethods?.length && (Rt = Rt + ke.deliverectPayMethods.length);
      const Yt = ke.overflowOptionsIn && Rt > ke.overflowOptionsIn, Ut = Yt ? ke.overflowOptionsIn : Rt;
      let Qt = 0;
      return Yt && (Qt = jt / 2), Ut * jt + Qt;
    }), zt = computed(() => {
      let jt = Dt.value;
      return ke.acceptCardOnline && (jt += 56), jt > 0 ? `${jt}px` : "auto";
    }), kt = computed(() => !ke.acceptApplePay && !ke.acceptCardMachine && !ke.acceptCardOnline && !ke.acceptCash && !ke.acceptSkipCash && !ke.acceptTab && !ke.acceptDeliverectPay), Et = () => {
      At("new-card");
    }, Qe = (Rt) => {
      Ct(Rt), At("selected-method"), Gt(), Ie.value = !1;
    }, Xe = () => {
      if (!ke.userCards && ke.acceptCardOnline && !ke.acceptApplePay && !ke.acceptCardMachine && !ke.acceptCash && !ke.acceptSkipCash && !ke.acceptInvoice && !ke.acceptTab) {
        At("new-card");
        return;
      }
      At("methods-list");
    }, Vt = () => {
      if (Me.value) {
        At("selected-method");
        return;
      }
      At("methods-list");
    }, Lt = () => {
      At("selected-method");
    }, Gt = () => {
      if (xe.value === "new-card") {
        Ie.value = !0, Wt.value = "", Ot.value.submitCard();
        return;
      }
      Me.value && Se("pay", Me.value);
    }, Wt = ref(""), Zt = (Rt) => {
      Ie.value = !1, Rt.code === "INVALID_FORM" && (Se("error", "invalid_new_card"), Wt.value = ke.invalidCardMessage ?? "The card is not valid.");
    }, Ot = ref(), Ht = (Rt, jt) => {
      jt ? Rt(jt) : Rt(), At("selected-method");
    };
    return onMounted(() => {
      ke.acceptCardOnline && !ke.gatewayKey && Se("error", "gateway_key_required");
    }), (Rt, jt) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$6)())
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$6)("header"))
      }, [
        createVNode(unref(AtomText), {
          type: "subtitle",
          tag: "div"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.title), 1)
          ]),
          _: 1
        }),
        xe.value === "new-card" && (unref(Je).length || ke.acceptCardMachine || ke.acceptCash || ke.acceptTab || ke.acceptInvoice || ke.acceptSkipCash) ? (openBlock(), createBlock(unref(_sfc_main$1Q), {
          key: 0,
          name: "close",
          class: normalizeClass(unref(css$6)("close-cta")),
          onClick: Vt
        }, null, 8, ["class"])) : createCommentVNode("", !0),
        xe.value === "methods-list" && !kt.value && Me.value ? (openBlock(), createBlock(unref(_sfc_main$1Q), {
          key: 1,
          name: "close",
          class: normalizeClass(unref(css$6)("close-cta")),
          onClick: Lt
        }, null, 8, ["class"])) : createCommentVNode("", !0)
      ], 2),
      createElementVNode("div", {
        class: normalizeClass([unref(css$6)("content"), unref(css$6)("content", xe.value)])
      }, [
        createVNode(Transition, { name: "tpt-payment-tray-fade" }, {
          default: withCtx(() => [
            kt.value ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass([unref(css$6)("selected-method"), unref(css$6)("selected-method", "empty")])
            }, " No payment method available ", 2)) : xe.value === "selected-method" && Me.value ? (openBlock(), createElementBlock("a", {
              key: 1,
              href: "#",
              class: normalizeClass(unref(css$6)("selected-method")),
              "data-test": "selected-method",
              onClick: withModifiers(Xe, ["prevent"])
            }, [
              Me.value.type === "new" || Me.value.type === "existing" ? (openBlock(), createBlock(unref(MolPaymentMethod), {
                key: 0,
                name: Me.value.name,
                last4: Me.value.last4,
                "change-c-t-a-label": ke.changeMethodLabel,
                "show-change-c-t-a": "",
                text: Ee
              }, null, 8, ["name", "last4", "change-c-t-a-label"])) : (openBlock(), createBlock(unref(MolPaymentMethod), {
                key: 1,
                name: Me.value.name,
                "change-c-t-a-label": ke.changeMethodLabel,
                "show-change-c-t-a": "",
                text: Ee
              }, null, 8, ["name", "change-c-t-a-label"]))
            ], 2)) : xe.value === "methods-list" ? (openBlock(), createElementBlock("div", _hoisted_1$2, [
              createElementVNode("div", {
                class: normalizeClass(unref(css$6)("options")),
                style: normalizeStyle(`max-height: ${Dt.value}px`)
              }, [
                ke.acceptDeliverectPay ? (openBlock(!0), createElementBlock(Fragment, { key: 0 }, renderList(unref(Nt), (Yt, Ut) => (openBlock(), createBlock(unref(MolPaymentMethod), {
                  key: `${Yt.name}-${Ut}`,
                  class: normalizeClass(unref(css$6)("method-item")),
                  name: Yt.name,
                  selected: unref(It)(Yt),
                  "data-test": "select-deliverect-pay-method",
                  onClick: (Qt) => Ht(unref(Bt), Yt)
                }, null, 8, ["class", "name", "selected", "onClick"]))), 128)) : createCommentVNode("", !0),
                ke.acceptCardOnline ? (openBlock(!0), createElementBlock(Fragment, { key: 1 }, renderList(unref(Je), (Yt, Ut) => (openBlock(), createBlock(unref(MolPaymentMethod), {
                  key: `${Yt.name}-${Ut}`,
                  class: normalizeClass(unref(css$6)("method-item")),
                  name: Yt.name,
                  last4: Yt.last4,
                  selected: unref(qe)(Yt),
                  "data-test": "select-card",
                  onClick: (Qt) => Ht(unref(Ke), Yt)
                }, null, 8, ["class", "name", "last4", "selected", "onClick"]))), 128)) : createCommentVNode("", !0),
                ke.acceptApplePay ? (openBlock(), createBlock(unref(MolPaymentMethod), {
                  key: 2,
                  class: normalizeClass(unref(css$6)("method-item")),
                  name: "apple-pay",
                  selected: unref(Ve),
                  text: Ee,
                  "data-test": "select-apple-pay",
                  onClick: jt[0] || (jt[0] = (Yt) => Ht(unref(je)))
                }, null, 8, ["class", "selected"])) : createCommentVNode("", !0),
                ke.acceptSkipCash ? (openBlock(), createBlock(unref(MolPaymentMethod), {
                  key: 3,
                  class: normalizeClass(unref(css$6)("method-item")),
                  name: "skipcash",
                  selected: unref(Ye),
                  text: Ee,
                  "data-test": "select-skipcash",
                  onClick: jt[1] || (jt[1] = (Yt) => Ht(unref(We)))
                }, null, 8, ["class", "selected"])) : createCommentVNode("", !0),
                ke.acceptCash ? (openBlock(), createBlock(unref(MolPaymentMethod), {
                  key: 4,
                  class: normalizeClass(unref(css$6)("method-item")),
                  name: "cash",
                  selected: unref(Be),
                  text: Ee,
                  "data-test": "select-cash",
                  onClick: jt[2] || (jt[2] = (Yt) => Ht(unref($e)))
                }, null, 8, ["class", "selected"])) : createCommentVNode("", !0),
                ke.acceptInvoice ? (openBlock(), createBlock(unref(MolPaymentMethod), {
                  key: 5,
                  class: normalizeClass(unref(css$6)("method-item")),
                  name: "invoice",
                  selected: unref(Le),
                  text: Ee,
                  onClick: jt[3] || (jt[3] = (Yt) => Ht(unref(Fe)))
                }, null, 8, ["class", "selected"])) : createCommentVNode("", !0),
                ke.acceptCardMachine ? (openBlock(), createBlock(unref(MolPaymentMethod), {
                  key: 6,
                  class: normalizeClass(unref(css$6)("method-item")),
                  name: "card-machine",
                  text: Ee,
                  selected: unref(Ge),
                  "data-test": "select-card-machine",
                  onClick: jt[4] || (jt[4] = (Yt) => Ht(unref(De)))
                }, null, 8, ["class", "selected"])) : createCommentVNode("", !0),
                ke.acceptTab ? (openBlock(), createBlock(unref(MolPaymentMethod), {
                  key: 7,
                  class: normalizeClass(unref(css$6)("method-item")),
                  name: "add-to-tab",
                  selected: unref(Ue),
                  text: Ee,
                  "data-test": "select-tab",
                  onClick: jt[5] || (jt[5] = (Yt) => Ht(unref(Re)))
                }, null, 8, ["class", "selected"])) : createCommentVNode("", !0)
              ], 6),
              ke.acceptCardOnline ? (openBlock(), createBlock(unref(AtomButton), {
                key: 0,
                class: normalizeClass(unref(css$6)("add-card-cta")),
                "data-test": "add-card-btn",
                size: "small",
                variant: "secondary",
                onClick: Et
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(ke.addCardLabel), 1)
                ]),
                _: 1
              }, 8, ["class"])) : createCommentVNode("", !0)
            ])) : xe.value === "new-card" && ke.acceptCardOnline && ke.gatewayKey ? (openBlock(), createElementBlock("div", _hoisted_2$1, [
              createVNode(unref(AtomCheckoutDotComCardForm), {
                ref_key: "checkoutCardFormRef",
                ref: Ot,
                "public-key": ke.gatewayKey,
                onError: Zt,
                onCardSelected: Qe
              }, null, 8, ["public-key"]),
              Wt.value ? (openBlock(), createBlock(unref(AtomText), {
                key: 0,
                color: "color-coral",
                class: normalizeClass(unref(css$6)("new-card-error")),
                tag: "div"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(Wt.value), 1)
                ]),
                _: 1
              }, 8, ["class"])) : createCommentVNode("", !0)
            ])) : createCommentVNode("", !0)
          ]),
          _: 1
        })
      ], 2),
      createVNode(unref(AtomText), {
        type: "subtitle",
        tag: "div",
        class: normalizeClass(unref(css$6)("total"))
      }, {
        default: withCtx(() => [
          createElementVNode("span", null, toDisplayString(ke.totalLabel), 1),
          createVNode(unref(_sfc_main$1w), {
            amount: ke.total.value,
            currency: ke.total.currency
          }, null, 8, ["amount", "currency"])
        ]),
        _: 1
      }, 8, ["class"]),
      kt.value ? createCommentVNode("", !0) : (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        unref(Ve) && xe.value !== "new-card" ? (openBlock(), createBlock(unref(AtomApplePayButton), {
          key: 0,
          "is-loading": ke.loading || Ie.value,
          class: normalizeClass(unref(css$6)("cta")),
          "data-test": "pay-cta",
          onClick: Gt
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.applePayPrefix), 1)
          ]),
          _: 1
        }, 8, ["is-loading", "class"])) : (openBlock(), createBlock(unref(AtomButton), {
          key: 1,
          "is-loading": ke.loading || Ie.value,
          size: "large",
          wide: "",
          class: normalizeClass(unref(css$6)("cta")),
          "data-test": "pay-cta",
          onClick: Gt
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(Ft.value), 1)
          ]),
          _: 1
        }, 8, ["is-loading", "class"]))
      ], 64))
    ], 2));
  }
}), TptPaymentTray = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["__scopeId", "data-v-0d402035"]]), className$5 = "tpt-bill-splitter", css$5 = bemBuilder(className$5);
bemBuilder(className$5, !0);
const _sfc_main$7 = /* @__PURE__ */ defineComponent({
  __name: "TptBillSplitter",
  props: {
    totalAmount: {},
    remainingAmount: {},
    participants: {},
    paymentDone: { type: Boolean },
    payAgainLabel: {},
    splitLabel: {},
    yourShareButtonLabel: {},
    changeYourShareLabel: {},
    tabEvenlyLabel: {},
    tabCustomLabel: {},
    orderTotalLabel: {},
    remainingAmountLabel: {},
    customInputLabel: {},
    customInputErrorOverLimit: {},
    evenlyPeopleAmountTitle: {},
    evenlyPeopleAmountResult: {},
    evenlyPayingForTitle: {},
    evenlyPayingForResult: {},
    calculatorConfirmCta: {},
    teleportTo: {}
  },
  emits: ["input", "pay-again"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, {
      disable: xe,
      enable: Ie,
      state: Me
    } = useTogglable(), Ee = ref(ke.remainingAmount.currency), Be = ref("custom"), $e = computed(() => Be.value === "custom"), Le = (Nt) => Be.value = Nt, Fe = ref(ke.participants), Ve = ref(1), je = ref({
      value: 0,
      currency: Ee.value
    }), Ge = ref(""), De = ref(), Ue = (Nt) => {
      Ge.value = Nt.value > ke.remainingAmount.value ? ke.customInputErrorOverLimit : "", je.value = Nt;
    }, Re = computed(() => Math.ceil(ke.totalAmount.value / Fe.value)), Ye = computed(() => {
      const Nt = Math.ceil(Re.value * Ve.value);
      return Nt > ke.remainingAmount.value ? ke.remainingAmount.value : Nt;
    }), We = (Nt) => {
      Fe.value = Nt;
    }, qe = (Nt) => {
      Nt < 1 || (Fe.value = Nt, Fe.value < Ve.value && (Ve.value = Nt));
    }, Je = (Nt) => {
      Nt < 1 || Nt > Fe.value || (Ve.value = Nt);
    }, Ke = (Nt) => {
      Nt < 1 || (Ve.value = Nt);
    }, xt = computed(
      () => $e.value ? je.value.value : Ye.value
    ), Ct = () => {
      xt.value > ke.remainingAmount.value || (De.value = {
        value: xt.value,
        currency: Ee.value
      }, xe(), Se("input", De.value));
    }, It = (Nt) => {
      Se("pay-again", Nt), De.value = void 0, Ie();
    };
    return (Nt, Bt) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$5)())
    }, [
      e.paymentDone ? (openBlock(), createElementBlock("button", {
        key: 0,
        class: normalizeClass(unref(css$5)("main-cta")),
        onClick: It
      }, [
        createVNode(unref(AtomText), {
          color: "color-primary",
          type: "body-bold"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.payAgainLabel), 1)
          ]),
          _: 1
        })
      ], 2)) : De.value ? De.value ? (openBlock(), createElementBlock("button", {
        key: 2,
        class: normalizeClass([unref(css$5)("main-cta"), unref(css$5)("main-cta", "spaced")]),
        onClick: Bt[1] || (Bt[1] = //@ts-ignore
        (...At) => unref(Ie) && unref(Ie)(...At))
      }, [
        createVNode(unref(AtomText), null, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.yourShareButtonLabel) + " ", 1),
            createElementVNode("strong", null, [
              createVNode(unref(_sfc_main$1w), {
                amount: De.value.value,
                currency: De.value.currency
              }, null, 8, ["amount", "currency"])
            ])
          ]),
          _: 1
        }),
        createVNode(unref(AtomText), {
          color: "color-primary",
          type: "small-bold"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.changeYourShareLabel), 1)
          ]),
          _: 1
        })
      ], 2)) : createCommentVNode("", !0) : (openBlock(), createElementBlock("button", {
        key: 1,
        class: normalizeClass(unref(css$5)("main-cta")),
        onClick: Bt[0] || (Bt[0] = //@ts-ignore
        (...At) => unref(Ie) && unref(Ie)(...At))
      }, [
        createVNode(unref(AtomText), {
          color: "color-primary",
          type: "body-bold"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.splitLabel), 1)
          ]),
          _: 1
        })
      ], 2)),
      (openBlock(), createBlock(Teleport, {
        to: ke.teleportTo ?? "body"
      }, [
        createVNode(unref(SatDrawer), {
          modelValue: unref(Me),
          "onUpdate:modelValue": Bt[5] || (Bt[5] = (At) => isRef(Me) ? Me.value = At : null),
          "max-width": 460
        }, {
          default: withCtx(() => [
            createElementVNode("div", {
              class: normalizeClass(unref(css$5)("calculator"))
            }, [
              createElementVNode("div", {
                class: normalizeClass(unref(css$5)("calculator-header"))
              }, [
                createVNode(unref(AtomText), {
                  type: "subtitle",
                  tag: "div"
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(ke.splitLabel), 1)
                  ]),
                  _: 1
                }),
                createElementVNode("button", {
                  type: "button",
                  class: normalizeClass(unref(css$5)("close")),
                  onClick: Bt[2] || (Bt[2] = //@ts-ignore
                  (...At) => unref(xe) && unref(xe)(...At))
                }, [
                  createVNode(unref(_sfc_main$1Q), { name: "close" })
                ], 2)
              ], 2),
              createElementVNode("div", {
                class: normalizeClass(unref(css$5)("switcher"))
              }, [
                createVNode(unref(AtomText), {
                  class: normalizeClass({
                    [unref(css$5)("option")]: !0,
                    [unref(css$5)("option", "active")]: !$e.value
                  }),
                  onClick: Bt[3] || (Bt[3] = (At) => Le("evenly"))
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(ke.tabEvenlyLabel), 1)
                  ]),
                  _: 1
                }, 8, ["class"]),
                createVNode(unref(AtomText), {
                  class: normalizeClass({
                    [unref(css$5)("option")]: !0,
                    [unref(css$5)("option", "active")]: $e.value
                  }),
                  onClick: Bt[4] || (Bt[4] = (At) => Le("custom"))
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(ke.tabCustomLabel), 1)
                  ]),
                  _: 1
                }, 8, ["class"])
              ], 2),
              createVNode(unref(AtomText), {
                tag: "div",
                class: normalizeClass(unref(css$5)("bill-values")),
                color: "color-base-40"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(ke.orderTotalLabel) + " ", 1),
                  createVNode(unref(_sfc_main$1w), {
                    amount: ke.totalAmount.value,
                    currency: ke.totalAmount.currency
                  }, null, 8, ["amount", "currency"])
                ]),
                _: 1
              }, 8, ["class"]),
              createVNode(unref(AtomText), {
                tag: "div",
                class: normalizeClass(unref(css$5)("bill-values")),
                color: "color-base-40"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(ke.remainingAmountLabel) + " ", 1),
                  createVNode(unref(_sfc_main$1w), {
                    amount: ke.remainingAmount.value,
                    currency: ke.remainingAmount.currency
                  }, null, 8, ["amount", "currency"])
                ]),
                _: 1
              }, 8, ["class"]),
              $e.value ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass(unref(css$5)("custom-share"))
              }, [
                createVNode(unref(SatFormControl), {
                  label: ke.customInputLabel,
                  "error-message": Ge.value
                }, {
                  default: withCtx(() => [
                    createVNode(unref(AtomInputMoney), {
                      value: je.value,
                      disabled: !1,
                      "has-error": !!Ge.value,
                      onInput: Ue
                    }, null, 8, ["value", "has-error"])
                  ]),
                  _: 1
                }, 8, ["label", "error-message"])
              ], 2)) : (openBlock(), createElementBlock("div", {
                key: 1,
                class: normalizeClass(unref(css$5)("evenly-share"))
              }, [
                createVNode(unref(AtomText), {
                  tag: "div",
                  type: "subtitle"
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(ke.evenlyPeopleAmountTitle), 1)
                  ]),
                  _: 1
                }),
                createVNode(unref(OrgSpinButton), {
                  type: "fixed",
                  count: Fe.value,
                  onIncrease: We,
                  onDecrease: qe
                }, {
                  default: withCtx(() => [
                    createVNode(unref(AtomText), {
                      type: "body-bold",
                      color: "color-base-40"
                    }, {
                      default: withCtx(() => [
                        createVNode(unref(_sfc_main$1w), {
                          amount: Re.value,
                          currency: Ee.value
                        }, null, 8, ["amount", "currency"]),
                        createTextVNode(" " + toDisplayString(ke.evenlyPeopleAmountResult), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["count"]),
                createVNode(unref(AtomText), {
                  tag: "div",
                  type: "subtitle"
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(ke.evenlyPayingForTitle), 1)
                  ]),
                  _: 1
                }),
                createVNode(unref(OrgSpinButton), {
                  type: "fixed",
                  count: Ve.value,
                  onIncrease: Je,
                  onDecrease: Ke
                }, {
                  default: withCtx(() => [
                    createVNode(unref(AtomText), {
                      type: "body-bold",
                      color: "color-base-40"
                    }, {
                      default: withCtx(() => [
                        createVNode(unref(_sfc_main$1w), {
                          amount: Ye.value,
                          currency: Ee.value
                        }, null, 8, ["amount", "currency"]),
                        createTextVNode(" " + toDisplayString(ke.evenlyPayingForResult), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["count"])
              ], 2)),
              createElementVNode("div", {
                class: normalizeClass(unref(css$5)("ctas"))
              }, [
                createVNode(unref(SatButtonMoney), {
                  wide: "",
                  size: "large",
                  price: {
                    value: xt.value,
                    currency: Ee.value
                  },
                  "hide-cents": !1,
                  onClick: Ct
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(ke.calculatorConfirmCta), 1)
                  ]),
                  _: 1
                }, 8, ["price"])
              ], 2)
            ], 2)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 8, ["to"]))
    ], 2));
  }
}), TptBillSplitter = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["__scopeId", "data-v-0936b9bc"]]), className$4 = "wo-header", css$4 = bemBuilder(className$4);
bemBuilder(className$4, !0);
const _hoisted_1$1 = ["href"], _hoisted_2 = ["src", "alt"], _sfc_main$6 = /* @__PURE__ */ defineComponent({
  __name: "WoHeader",
  props: {
    logoUrl: {},
    businessName: {},
    userName: {},
    isLoggedIn: { type: Boolean },
    showAuthBtn: { type: Boolean },
    isLogoWide: { type: Boolean, default: !1 },
    authBtnLabel: {},
    logoLink: {}
  },
  emits: ["userClick", "authClick", "logoClick"],
  setup(e, { emit: j }) {
    const ke = e, Se = j;
    return (xe, Ie) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$4)())
    }, [
      createElementVNode("a", {
        href: ke.logoLink,
        class: normalizeClass(unref(css$4)("business-brand")),
        onClick: Ie[0] || (Ie[0] = withModifiers((Me) => Se("logoClick", Me), ["prevent"]))
      }, [
        ke.isLogoWide ? (openBlock(), createElementBlock("img", {
          key: 1,
          class: normalizeClass(unref(css$4)("logo-wide")),
          src: ke.logoUrl,
          alt: ke.businessName
        }, null, 10, _hoisted_2)) : (openBlock(), createBlock(unref(AtomImage), {
          key: 0,
          class: normalizeClass(unref(css$4)("business-logo")),
          alt: ke.businessName,
          src: ke.logoUrl,
          size: 49,
          type: ke.isLogoWide ? "square" : "circle"
        }, null, 8, ["class", "alt", "src", "type"])),
        ke.isLogoWide ? createCommentVNode("", !0) : (openBlock(), createBlock(unref(AtomText), {
          key: 2,
          class: normalizeClass(unref(css$4)("business-name")),
          type: "h3",
          color: "color-text-headline"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.businessName), 1)
          ]),
          _: 1
        }, 8, ["class"]))
      ], 10, _hoisted_1$1),
      createElementVNode("div", {
        class: normalizeClass(unref(css$4)("controls"))
      }, [
        renderSlot(xe.$slots, "default", {}, void 0, !0),
        ke.isLoggedIn ? (openBlock(), createBlock(unref(AtomButton), {
          key: 0,
          variant: "secondary",
          theme: "tailored",
          class: normalizeClass(unref(css$4)("user")),
          "data-test": "userClick",
          onClick: Ie[1] || (Ie[1] = (Me) => Se("userClick", Me))
        }, {
          default: withCtx(() => [
            createVNode(unref(_sfc_main$1Q), {
              "ignore-color": "",
              name: "user"
            }),
            createTextVNode(" " + toDisplayString(ke.userName), 1)
          ]),
          _: 1
        }, 8, ["class"])) : createCommentVNode("", !0),
        ke.showAuthBtn ? (openBlock(), createBlock(unref(AtomButton), {
          key: 1,
          "data-test": "authClick",
          onClick: Ie[2] || (Ie[2] = (Me) => Se("authClick", Me))
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.authBtnLabel), 1)
          ]),
          _: 1
        })) : createCommentVNode("", !0)
      ], 2)
    ], 2));
  }
}), WoHeader = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["__scopeId", "data-v-d7c2009b"]]), className$3 = "wo-location", css$3 = bemBuilder(className$3);
bemBuilder(className$3, !0);
const _sfc_main$5 = /* @__PURE__ */ defineComponent({
  __name: "WoLocation",
  props: {
    name: {},
    address: {},
    addressPrefix: {},
    image: {},
    badgeValue: {},
    state: {},
    stateLabel: {},
    stateDescription: {},
    isActive: { type: Boolean },
    hasInfoIcon: { type: Boolean, default: !1 }
  },
  emits: ["mouseHover", "mouseOut", "info", "click"],
  setup(e, { emit: j }) {
    const ke = e, Se = j, xe = {
      open: "color-mint",
      close: "color-text-disabled",
      soon: "color-text-body"
    }, Ie = computed(() => xe[ke.state]), Me = ref(!1);
    function Ee() {
      Me.value || (Me.value = !0, Se("mouseHover"));
    }
    function Be() {
      Me.value = !1, Se("mouseOut");
    }
    const $e = computed(() => Me.value || ke.isActive ? {
      emphasis: "high",
      state: "branded"
    } : {
      emphasis: "low",
      state: "neutral"
    });
    return (Le, Fe) => (openBlock(), createElementBlock("a", {
      href: "",
      class: normalizeClass([unref(css$3)(), { [unref(css$3)("", "is-active")]: ke.isActive }]),
      onMouseover: Ee,
      onMouseleave: Be,
      onClick: Fe[1] || (Fe[1] = withModifiers((Ve) => Le.$emit("click", Ve), ["prevent"]))
    }, [
      createElementVNode("div", {
        class: normalizeClass(unref(css$3)("content"))
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(css$3)("description"))
        }, [
          createElementVNode("div", {
            class: normalizeClass(unref(css$3)("name"))
          }, [
            e.badgeValue ? (openBlock(), createBlock(unref(AtomBadge), mergeProps({
              key: 0,
              size: "small",
              value: e.badgeValue
            }, $e.value, {
              class: unref(css$3)("badge")
            }), null, 16, ["value", "class"])) : createCommentVNode("", !0),
            createVNode(unref(AtomText), { type: "body-bold" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(ke.name), 1)
              ]),
              _: 1
            }),
            ke.hasInfoIcon ? (openBlock(), createBlock(unref(SatIconButton), {
              key: 1,
              "icon-name": "info",
              size: "extra-small",
              class: normalizeClass(unref(css$3)("info-icon")),
              onClick: Fe[0] || (Fe[0] = withModifiers((Ve) => Se("info"), ["stop", "prevent"]))
            }, null, 8, ["class"])) : createCommentVNode("", !0)
          ], 2),
          createVNode(unref(AtomText), {
            type: "small",
            class: normalizeClass(unref(css$3)("address")),
            color: "color-text-secondary"
          }, {
            default: withCtx(() => [
              e.addressPrefix ? (openBlock(), createElementBlock("strong", {
                key: 0,
                class: normalizeClass(unref(css$3)("prefix"))
              }, toDisplayString(ke.addressPrefix), 3)) : createCommentVNode("", !0),
              createTextVNode(" " + toDisplayString(ke.address), 1)
            ]),
            _: 1
          }, 8, ["class"]),
          createElementVNode("div", {
            class: normalizeClass(unref(css$3)("state"))
          }, [
            createVNode(unref(AtomText), {
              type: "small-bold",
              color: Ie.value,
              class: normalizeClass(unref(css$3)("state-label"))
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(ke.stateLabel), 1)
              ]),
              _: 1
            }, 8, ["color", "class"]),
            ke.stateDescription ? (openBlock(), createBlock(unref(AtomText), {
              key: 0,
              color: "color-text-secondary",
              type: "small",
              class: normalizeClass(unref(css$3)("state-description"))
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(ke.stateDescription), 1)
              ]),
              _: 1
            }, 8, ["class"])) : createCommentVNode("", !0)
          ], 2)
        ], 2),
        ke.image ? (openBlock(), createBlock(unref(AtomImage), {
          key: 0,
          class: normalizeClass(unref(css$3)("img")),
          size: 71,
          src: ke.image,
          alt: ke.name,
          type: "rounded"
        }, null, 8, ["class", "src", "alt"])) : createCommentVNode("", !0)
      ], 2),
      renderSlot(Le.$slots, "default", {}, void 0, !0)
    ], 34));
  }
}), WoLocation = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["__scopeId", "data-v-311c796a"]]), className$2 = "page-menu", css$2 = bemBuilder(className$2);
bemBuilder(className$2, !0);
const _hoisted_1 = { key: 1 }, _sfc_main$4 = /* @__PURE__ */ defineComponent({
  __name: "PageMenu",
  props: {
    headerType: {},
    businessCover: {},
    businessLogo: {},
    businessName: {},
    userLoyaltyBalance: {},
    loyaltyProgram: {},
    loginLabel: {},
    loginLink: {},
    isLoggedIn: { type: Boolean },
    profileLink: {},
    menuName: {},
    userLoyaltyPoints: {},
    menuCover: {},
    viewOnly: { type: Boolean, default: !1 },
    logoLink: {},
    isGridLayout: { type: Boolean },
    pillsWithImage: { type: Boolean },
    categories: {}
  },
  emits: ["clickBack", "viewedLoyaltyProgram", "increaseItem", "decreaseItem", "clearItem", "clickItem", "logoClick", "loginClick", "profileClick"],
  setup(e, { emit: j }) {
    useCssVars((Ye) => ({
      ba510982: Le.value
    }));
    const ke = e, Se = ref(), xe = ref(), Ie = ref(), Me = ref(!1), Ee = {
      menu: 49,
      business: 63
    }, Be = computed(
      () => ke.categories.map((Ye) => ({
        name: Ye.name,
        id: Ye.id,
        count: Ye.items.length,
        image: Ye.image
      }))
    ), $e = computed(() => Ee[ke.headerType]), Le = computed(() => `${Ee[ke.headerType]}px`), Fe = j, Ve = (Ye) => {
      Me.value || (Se.value = Ye.id);
    }, je = (Ye) => Be.value.findIndex((We) => We.id === Ye), Ge = (Ye) => {
      const We = je(Ye);
      Me.value = !0;
      const qe = xe.value[We].$el, Je = parseFloat(qe.getBoundingClientRect().top);
      let Ke = $e.value;
      Ie.value && (Ke += Ie.value.$el.scrollHeight), nextTick(() => {
        window.scrollTo({
          top: Je + window.scrollY - Ke,
          behavior: "smooth"
        });
      }), setTimeout(() => {
        Me.value = !1;
      }, 1e3);
    }, De = computed(
      () => {
        if (ke.loyaltyProgram)
          return {
            iconName: "diamond",
            ...ke.loyaltyProgram
          };
      }
    ), Ue = useSlots(), Re = computed(() => !!Ue.default);
    return (Ye, We) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$2)())
    }, [
      ke.headerType === "business" ? (openBlock(), createBlock(unref(SatBusinessHeader), {
        key: 0,
        class: normalizeClass(unref(css$2)("header")),
        "cover-image": ke.businessCover,
        "is-logged-in": ke.isLoggedIn,
        "login-label": ke.loginLabel,
        "login-link": ke.loginLink,
        "loyalty-program": De.value,
        "profile-link": ke.profileLink,
        "user-loyalty-points": ke.userLoyaltyPoints,
        "logo-url": ke.businessLogo,
        "logo-link": ke.logoLink,
        "logo-alt": ke.businessName,
        "user-loyalty-balance": ke.userLoyaltyBalance,
        "hide-nav": !1,
        onLogoClick: We[0] || (We[0] = (qe) => Fe("logoClick", qe)),
        onLoginClick: We[1] || (We[1] = (qe) => Fe("loginClick", qe)),
        onProfileClick: We[2] || (We[2] = (qe) => Fe("profileClick", qe)),
        onViewedLoyaltyProgram: We[3] || (We[3] = (qe) => Fe("viewedLoyaltyProgram", qe))
      }, {
        actions: withCtx(() => [
          renderSlot(Ye.$slots, "actions", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["class", "cover-image", "is-logged-in", "login-label", "login-link", "loyalty-program", "profile-link", "user-loyalty-points", "logo-url", "logo-link", "logo-alt", "user-loyalty-balance"])) : createCommentVNode("", !0),
      ke.headerType === "menu" ? (openBlock(), createElementBlock("div", _hoisted_1, [
        createVNode(unref(OrgNavigation), {
          background: "white",
          cta: "back",
          onClickCta: We[4] || (We[4] = (qe) => Fe("clickBack", qe))
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.menuName), 1)
          ]),
          _: 1
        }),
        ke.menuCover ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass([unref(css$2)("menu-cover")]),
          style: normalizeStyle(`background-image: url(${ke.menuCover})`)
        }, null, 6)) : createCommentVNode("", !0)
      ])) : createCommentVNode("", !0),
      Re.value ? (openBlock(), createElementBlock("div", {
        key: 2,
        class: normalizeClass(unref(css$2)("slot"))
      }, [
        renderSlot(Ye.$slots, "default", {}, void 0, !0)
      ], 2)) : createCommentVNode("", !0),
      Be.value ? (openBlock(), createElementBlock("div", {
        key: 3,
        class: normalizeClass(unref(css$2)("pills"))
      }, [
        createVNode(unref(SatMenuNavigator), {
          ref_key: "pillMenuRef",
          ref: Ie,
          "show-images": ke.pillsWithImage,
          items: Be.value,
          title: ke.menuName,
          "active-id": Se.value,
          onItemSelected: Ge
        }, null, 8, ["show-images", "items", "title", "active-id"])
      ], 2)) : createCommentVNode("", !0),
      createElementVNode("div", {
        class: normalizeClass(unref(css$2)("wrapper"))
      }, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(ke.categories, (qe, Je) => (openBlock(), createBlock(unref(_sfc_main$P), {
          id: qe.id,
          ref_for: !0,
          ref_key: "intersectionRef",
          ref: xe,
          key: Je + qe.name,
          offset: 118,
          onEnter: Ve
        }, {
          default: withCtx(() => [
            (openBlock(), createBlock(unref(TptMenuCategory), {
              key: Je + qe.name,
              class: normalizeClass(unref(css$2)("menu-category")),
              "is-grid-layout": ke.isGridLayout,
              "view-only": ke.viewOnly,
              "view-type": "block",
              name: qe.name,
              items: qe.items,
              onIncreaseItem: We[5] || (We[5] = (Ke) => Fe("increaseItem", Ke)),
              onDecreaseItem: We[6] || (We[6] = (Ke) => Fe("decreaseItem", Ke)),
              onClearItem: We[7] || (We[7] = (Ke) => Fe("clearItem", Ke)),
              onClickItem: We[8] || (We[8] = (Ke, xt) => Fe("clickItem", Ke, xt))
            }, null, 8, ["class", "is-grid-layout", "view-only", "name", "items"]))
          ]),
          _: 2
        }, 1032, ["id"]))), 128))
      ], 2)
    ], 2));
  }
}), PageMenu = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["__scopeId", "data-v-43798910"]]), _sfc_main$3 = /* @__PURE__ */ defineComponent({
  __name: "PageMenuSkeleton",
  props: {
    isGridLayout: { type: Boolean }
  },
  setup(e) {
    const j = e;
    return (ke, Se) => (openBlock(), createElementBlock("div", {
      class: normalizeClass([
        unref(css$2)("", "skeleton"),
        unref(css$2)("", j.isGridLayout ? "grid" : "line")
      ])
    }, [
      createVNode(unref(AtomSkeletonLoader), {
        class: normalizeClass(unref(css$2)("header")),
        loading: "",
        lines: 1,
        "aspect-ratio": "16 / 9",
        "border-radius": "none"
      }, null, 8, ["class"]),
      (openBlock(), createElementBlock(Fragment, null, renderList(3, (xe) => createElementVNode("div", {
        key: xe,
        class: normalizeClass(unref(css$2)("card"))
      }, [
        createVNode(unref(AtomSkeletonLoader), {
          loading: "",
          lines: 1,
          width: 200,
          height: 16,
          type: "square",
          class: normalizeClass(unref(css$2)("title")),
          "border-radius": "medium"
        }, null, 8, ["class"]),
        createElementVNode("div", {
          class: normalizeClass(unref(css$2)("list"))
        }, [
          (openBlock(), createElementBlock(Fragment, null, renderList(4, (Ie) => createVNode(unref(MolItemDisplaySkeleton), {
            key: Ie,
            class: normalizeClass(unref(css$2)("list-item")),
            view: j.isGridLayout ? "row" : "col"
          }, null, 8, ["class", "view"])), 64))
        ], 2)
      ], 2)), 64))
    ], 2));
  }
}), PageMenuSkeleton = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["__scopeId", "data-v-9cf322d3"]]), className$1 = "page-menus", css$1 = bemBuilder(className$1);
bemBuilder(className$1, !0);
const brand = ref("chatfood"), brandSetter = (e) => {
  brand.value = e;
}, _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "PageMenus",
  props: {
    satBusinessHeader: {},
    title: {},
    poweredBy: {},
    menus: {}
  },
  emits: ["viewMenu", "logoClick", "loginClick", "profileClick", "viewedLoyaltyProgram"],
  setup(e, { emit: j }) {
    const ke = e, Se = j;
    function xe(Ie) {
      Se("viewMenu", Ie);
    }
    return (Ie, Me) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css$1)())
    }, [
      createVNode(unref(SatBusinessHeader), mergeProps(ke.satBusinessHeader, {
        onLogoClick: Me[0] || (Me[0] = (Ee) => Se("logoClick", Ee)),
        onLoginClick: Me[1] || (Me[1] = (Ee) => Se("loginClick", Ee)),
        onProfileClick: Me[2] || (Me[2] = (Ee) => Se("profileClick", Ee)),
        onViewedLoyaltyProgram: Me[3] || (Me[3] = (Ee) => Se("viewedLoyaltyProgram", Ee))
      }), {
        actions: withCtx(() => [
          renderSlot(Ie.$slots, "actions", {}, void 0, !0)
        ]),
        _: 3
      }, 16),
      createElementVNode("div", {
        class: normalizeClass(unref(css$1)("wrapper"))
      }, [
        createVNode(unref(AtomText), {
          class: normalizeClass(unref(css$1)("title")),
          type: "h2",
          color: "color-base-20"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.title), 1)
          ]),
          _: 1
        }, 8, ["class"]),
        createVNode(unref(SatMenuSelector), {
          menus: e.menus,
          onSelect: xe
        }, null, 8, ["menus"])
      ], 2),
      createElementVNode("div", {
        class: normalizeClass(unref(css$1)("footer"))
      }, [
        unref(brand) === "deliverect" ? (openBlock(), createBlock(unref(MolPoweredByDeliverect), { key: 0 }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.poweredBy), 1)
          ]),
          _: 1
        })) : createCommentVNode("", !0),
        unref(brand) === "chatfood" ? (openBlock(), createBlock(unref(MolPoweredByChatFood), { key: 1 }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(ke.poweredBy), 1)
          ]),
          _: 1
        })) : createCommentVNode("", !0)
      ], 2)
    ], 2));
  }
}), PageMenus = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["__scopeId", "data-v-885d5a83"]]), mapper = {
  primary: "--color-primary",
  onPrimary: "--color-on-primary",
  primaryHover: "--color-primary-hover",
  secondary: "--color-secondary",
  onSecondary: "--color-on-secondary",
  secondaryHover: "--color-secondary-hover"
}, colorSetter = (e, j) => {
  document.documentElement.style.setProperty(mapper[e], j);
}, _sfc_main$1 = {};
function _sfc_render(e, j) {
  return openBlock(), createElementBlock("span");
}
const BaseStyleSheet = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render]]), className = "mol-powered-by", css = bemBuilder(className);
bemBuilder(className, !0);
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MolPoweredBy",
  setup(e) {
    return (j, ke) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(css)())
    }, [
      createVNode(unref(_sfc_main$U), {
        class: normalizeClass(unref(css)("icon")),
        name: "chatfood-logo",
        size: 21
      }, null, 8, ["class"]),
      createVNode(unref(AtomText), {
        class: normalizeClass(unref(css)("text")),
        color: "color-base-50",
        type: "small"
      }, {
        default: withCtx(() => [
          renderSlot(j.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["class"])
    ], 2));
  }
}), MolPoweredBy = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-490360a0"]]);
export {
  AtomApplePayButton,
  AtomBadge,
  AtomButton,
  AtomCard,
  AtomCheckbox,
  AtomCheckoutDotComCardForm,
  AtomCheckoutDotComFormErrorEnum,
  AtomCheckoutDotComFormStatusEnum,
  AtomDrawer,
  _sfc_main$U as AtomGraphic,
  _sfc_main$1Q as AtomIcon,
  AtomImage,
  AtomInput,
  AtomInputMoney,
  AtomInputPhoneNumber,
  AtomInputPinCode,
  _sfc_main$P as AtomIntersection,
  AtomLink,
  AtomLoadingSpinner,
  AtomMapInfoWindow,
  _sfc_main$1w as AtomMoney,
  AtomOverlay,
  AtomPill,
  AtomRadio,
  AtomSkeletonLoader,
  AtomSwitcher,
  AtomText,
  AtomTextarea,
  AtomToast,
  AtomWrapper,
  BaseStyleSheet,
  LegacyAtomButton,
  MolBasketLine,
  MolButtonBadge,
  MolButtonMoney,
  MolButtonRound,
  MolCardHeader,
  MolChannelSelector,
  MolChargeEntry,
  MolCollapseIndicator,
  MolCollectableLoyaltyPoints,
  MolFormControl,
  MolIconButton,
  MolItemDisplaySkeleton,
  MolLogoLoading,
  MolLoyaltyBanner,
  MolLoyaltyDetail,
  MolLoyaltySwitch,
  MolMap,
  MolMapMarker,
  MolModal,
  MolModifierGroupSkeleton,
  MolPaymentMethod,
  MolPoweredBy,
  MolPoweredByChatFood,
  MolPoweredByDeliverect,
  MolRatingWithStars,
  MolUnorderedList,
  OrgAddToBasketDisplay,
  AtomCheckoutDotComCardForm as OrgCheckoutDotComCardForm,
  AtomCheckoutDotComFormErrorEnum as OrgCheckoutDotComFormErrorEnum,
  AtomCheckoutDotComFormStatusEnum as OrgCheckoutDotComFormStatusEnum,
  OrgCollapsableOrder,
  OrgDiscountCard,
  OrgIconModal,
  OrgJoinTab,
  OrgLoadingModal,
  OrgMessageModal,
  OrgModifierGroup,
  OrgNavigation,
  OrgRatingForm,
  OrgRequestOtp,
  OrgSignupForm,
  OrgSpinButton,
  OrgStartTab,
  OrgTipPicker,
  OrgValidateOtp,
  PageMenu,
  PageMenuSkeleton,
  PageMenus,
  SAT_SETUP_ID_SELECTOR,
  SatBusinessHeader,
  SatButton,
  SatButtonCurrentLocation,
  SatButtonMoney,
  SatCounter,
  SatDiscount,
  SatDrawer,
  _sfc_main$1K as SatElasticPanel,
  SatFormControl,
  SatIconButton,
  SatInputSearch,
  SatItemBuilder,
  SatItemDisplay,
  SatItemHandler,
  SatItemHandlerInfo,
  SatItemSelector,
  SatLanguageSwitcher,
  SatLink,
  SatLottieJson,
  SatLoyaltyProgramCard,
  SatLoyaltyProgramSelection,
  SatMap,
  _sfc_main$1i as SatMapInfoWindow,
  _sfc_main$1j as SatMapMarker,
  SatMapMarkerInfo,
  SatMenuNavigator,
  SatMenuSelector,
  SatNavigation,
  SatNutritionInfo,
  SatOtpMethodSelector,
  SatPlaceSearcher,
  SatPriceBreakdown,
  SatProductDetails,
  SatProductInfo,
  SatProductSpecs,
  SatProductSummary,
  SatProgressBar,
  SatProgressTracker,
  SatQrCodeGenerator,
  SatQuickAddButton,
  SatSelect,
  SatSetup,
  SatTabNavigation,
  _sfc_main$1s as SatTooltip,
  SatVariantSelection,
  SatVirtualKeyboard,
  SatSetup as SatelliteSetup,
  TptBillSplitter,
  TptCheckoutBasket,
  TptMenuCategory,
  TptPaymentTray,
  WoHeader,
  WoLocation,
  brandSetter,
  colorSetter,
  molMapErrorHandlerInjectionKey,
  molMapGoogleMapsInjectionKey,
  molMapMapInjectionKey,
  molMapMarkerInjectionKey,
  satMapErrorHandlerInjectionKey,
  satMapGoogleMapsInjectionKey,
  satMapMapInjectionKey,
  satMapMarkerInjectionKey,
  useAtomDrawer,
  useAtomGraphic,
  useAtomIcon,
  useDate,
  useDesignTokens,
  useImage,
  useItemManager,
  useLocalStorage,
  useMolModal,
  useOrgModifierGroup,
  useSatLottieJson,
  useSatProductDetails,
  useStackedNavigation,
  useToast,
  useTogglable,
  useWindowResize,
  watchDebounced
};
